
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire776e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire776e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2Qwp0", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $2129928c0bdc1efe$export$ffb0004e005737fa; }, function (v) { return $2129928c0bdc1efe$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $2129928c0bdc1efe$export$34b9dba7ce09269b; }, function (v) { return $2129928c0bdc1efe$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $2129928c0bdc1efe$export$25062201e9e25d76; }, function (v) { return $2129928c0bdc1efe$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2129928c0bdc1efe$export$ffb0004e005737fa;
var $2129928c0bdc1efe$export$34b9dba7ce09269b;
var $2129928c0bdc1efe$export$25062201e9e25d76;
'use strict';
parcelRequire("2WFPq");

var $gIfym = parcelRequire("gIfym");
var $2129928c0bdc1efe$var$g = 60103;
$2129928c0bdc1efe$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $2129928c0bdc1efe$var$h = Symbol.for;
    $2129928c0bdc1efe$var$g = $2129928c0bdc1efe$var$h("react.element");
    $2129928c0bdc1efe$export$ffb0004e005737fa = $2129928c0bdc1efe$var$h("react.fragment");
}
var $2129928c0bdc1efe$var$m = $gIfym.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $2129928c0bdc1efe$var$n = Object.prototype.hasOwnProperty, $2129928c0bdc1efe$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $2129928c0bdc1efe$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$2129928c0bdc1efe$var$n.call(a, b) && !$2129928c0bdc1efe$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $2129928c0bdc1efe$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $2129928c0bdc1efe$var$m.current
    };
}
$2129928c0bdc1efe$export$34b9dba7ce09269b = $2129928c0bdc1efe$var$q;
$2129928c0bdc1efe$export$25062201e9e25d76 = $2129928c0bdc1efe$var$q;

});
parcelRegister("2WFPq", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $225171d2ce221288$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $225171d2ce221288$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $225171d2ce221288$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $225171d2ce221288$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $225171d2ce221288$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $225171d2ce221288$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $225171d2ce221288$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($225171d2ce221288$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($225171d2ce221288$var$getOwnPropertySymbols) {
            symbols = $225171d2ce221288$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($225171d2ce221288$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("gIfym", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ga9lV"));

});
parcelRegister("ga9lV", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $bc44d5c582efa5c9$export$ffb0004e005737fa; }, function (v) { return $bc44d5c582efa5c9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bc44d5c582efa5c9$export$5f8d39834fd61797; }, function (v) { return $bc44d5c582efa5c9$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $bc44d5c582efa5c9$export$e2c29f18771995cb; }, function (v) { return $bc44d5c582efa5c9$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $bc44d5c582efa5c9$export$74bf444e3cd11ea5; }, function (v) { return $bc44d5c582efa5c9$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $bc44d5c582efa5c9$export$dca3b0875bd9a954; }, function (v) { return $bc44d5c582efa5c9$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $bc44d5c582efa5c9$export$16fa2f45be04daa8; }, function (v) { return $bc44d5c582efa5c9$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $bc44d5c582efa5c9$export$221d75b3f55bb0bd; }, function (v) { return $bc44d5c582efa5c9$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $bc44d5c582efa5c9$export$ae55be85d98224ed; }, function (v) { return $bc44d5c582efa5c9$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $bc44d5c582efa5c9$export$e530037191fcd5d7; }, function (v) { return $bc44d5c582efa5c9$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $bc44d5c582efa5c9$export$fd42f52fd3ae1109; }, function (v) { return $bc44d5c582efa5c9$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $bc44d5c582efa5c9$export$c8a8987d4410bf2d; }, function (v) { return $bc44d5c582efa5c9$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $bc44d5c582efa5c9$export$d38cd72104c1f0e9; }, function (v) { return $bc44d5c582efa5c9$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $bc44d5c582efa5c9$export$7d1e3a5e95ceca43; }, function (v) { return $bc44d5c582efa5c9$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $bc44d5c582efa5c9$export$257a8862b851cb5b; }, function (v) { return $bc44d5c582efa5c9$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $bc44d5c582efa5c9$export$a8257692ac88316c; }, function (v) { return $bc44d5c582efa5c9$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $bc44d5c582efa5c9$export$488013bae63b21da; }, function (v) { return $bc44d5c582efa5c9$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $bc44d5c582efa5c9$export$7c73462e0d25e514; }, function (v) { return $bc44d5c582efa5c9$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $bc44d5c582efa5c9$export$35808ee640e87ca7; }, function (v) { return $bc44d5c582efa5c9$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $bc44d5c582efa5c9$export$fae74005e78b1a27; }, function (v) { return $bc44d5c582efa5c9$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $bc44d5c582efa5c9$export$dc8fbce3eb94dc1e; }, function (v) { return $bc44d5c582efa5c9$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $bc44d5c582efa5c9$export$6d9c69b0de29b591; }, function (v) { return $bc44d5c582efa5c9$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $bc44d5c582efa5c9$export$d5a552a76deda3c2; }, function (v) { return $bc44d5c582efa5c9$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $bc44d5c582efa5c9$export$e5c5a5f917a5871c; }, function (v) { return $bc44d5c582efa5c9$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $bc44d5c582efa5c9$export$1538c33de8887b59; }, function (v) { return $bc44d5c582efa5c9$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $bc44d5c582efa5c9$export$13e3392192263954; }, function (v) { return $bc44d5c582efa5c9$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $bc44d5c582efa5c9$export$b8f5890fc79d6aca; }, function (v) { return $bc44d5c582efa5c9$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $bc44d5c582efa5c9$export$60241385465d0a34; }, function (v) { return $bc44d5c582efa5c9$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $bc44d5c582efa5c9$export$83d89fbfd8236492; }, function (v) { return $bc44d5c582efa5c9$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bc44d5c582efa5c9$export$ffb0004e005737fa;
var $bc44d5c582efa5c9$export$5f8d39834fd61797;
var $bc44d5c582efa5c9$export$e2c29f18771995cb;
var $bc44d5c582efa5c9$export$74bf444e3cd11ea5;
var $bc44d5c582efa5c9$export$dca3b0875bd9a954;
var $bc44d5c582efa5c9$export$16fa2f45be04daa8;
var $bc44d5c582efa5c9$export$221d75b3f55bb0bd;
var $bc44d5c582efa5c9$export$ae55be85d98224ed;
var $bc44d5c582efa5c9$export$e530037191fcd5d7;
var $bc44d5c582efa5c9$export$fd42f52fd3ae1109;
var $bc44d5c582efa5c9$export$c8a8987d4410bf2d;
var $bc44d5c582efa5c9$export$d38cd72104c1f0e9;
var $bc44d5c582efa5c9$export$7d1e3a5e95ceca43;
var $bc44d5c582efa5c9$export$257a8862b851cb5b;
var $bc44d5c582efa5c9$export$a8257692ac88316c;
var $bc44d5c582efa5c9$export$488013bae63b21da;
var $bc44d5c582efa5c9$export$7c73462e0d25e514;
var $bc44d5c582efa5c9$export$35808ee640e87ca7;
var $bc44d5c582efa5c9$export$fae74005e78b1a27;
var $bc44d5c582efa5c9$export$dc8fbce3eb94dc1e;
var $bc44d5c582efa5c9$export$6d9c69b0de29b591;
var $bc44d5c582efa5c9$export$d5a552a76deda3c2;
var $bc44d5c582efa5c9$export$e5c5a5f917a5871c;
var $bc44d5c582efa5c9$export$1538c33de8887b59;
var $bc44d5c582efa5c9$export$13e3392192263954;
var $bc44d5c582efa5c9$export$b8f5890fc79d6aca;
var $bc44d5c582efa5c9$export$60241385465d0a34;
var $bc44d5c582efa5c9$export$83d89fbfd8236492;
'use strict';

var $2WFPq = parcelRequire("2WFPq");
var $bc44d5c582efa5c9$var$n = 60103, $bc44d5c582efa5c9$var$p = 60106;
$bc44d5c582efa5c9$export$ffb0004e005737fa = 60107;
$bc44d5c582efa5c9$export$5f8d39834fd61797 = 60108;
$bc44d5c582efa5c9$export$e2c29f18771995cb = 60114;
var $bc44d5c582efa5c9$var$q = 60109, $bc44d5c582efa5c9$var$r = 60110, $bc44d5c582efa5c9$var$t = 60112;
$bc44d5c582efa5c9$export$74bf444e3cd11ea5 = 60113;
var $bc44d5c582efa5c9$var$u = 60115, $bc44d5c582efa5c9$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $bc44d5c582efa5c9$var$w = Symbol.for;
    $bc44d5c582efa5c9$var$n = $bc44d5c582efa5c9$var$w("react.element");
    $bc44d5c582efa5c9$var$p = $bc44d5c582efa5c9$var$w("react.portal");
    $bc44d5c582efa5c9$export$ffb0004e005737fa = $bc44d5c582efa5c9$var$w("react.fragment");
    $bc44d5c582efa5c9$export$5f8d39834fd61797 = $bc44d5c582efa5c9$var$w("react.strict_mode");
    $bc44d5c582efa5c9$export$e2c29f18771995cb = $bc44d5c582efa5c9$var$w("react.profiler");
    $bc44d5c582efa5c9$var$q = $bc44d5c582efa5c9$var$w("react.provider");
    $bc44d5c582efa5c9$var$r = $bc44d5c582efa5c9$var$w("react.context");
    $bc44d5c582efa5c9$var$t = $bc44d5c582efa5c9$var$w("react.forward_ref");
    $bc44d5c582efa5c9$export$74bf444e3cd11ea5 = $bc44d5c582efa5c9$var$w("react.suspense");
    $bc44d5c582efa5c9$var$u = $bc44d5c582efa5c9$var$w("react.memo");
    $bc44d5c582efa5c9$var$v = $bc44d5c582efa5c9$var$w("react.lazy");
}
var $bc44d5c582efa5c9$var$x = "function" === typeof Symbol && Symbol.iterator;
function $bc44d5c582efa5c9$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $bc44d5c582efa5c9$var$x && a[$bc44d5c582efa5c9$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $bc44d5c582efa5c9$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $bc44d5c582efa5c9$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $bc44d5c582efa5c9$var$B = {};
function $bc44d5c582efa5c9$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $bc44d5c582efa5c9$var$B;
    this.updater = c || $bc44d5c582efa5c9$var$A;
}
$bc44d5c582efa5c9$var$C.prototype.isReactComponent = {};
$bc44d5c582efa5c9$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($bc44d5c582efa5c9$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$bc44d5c582efa5c9$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $bc44d5c582efa5c9$var$D() {}
$bc44d5c582efa5c9$var$D.prototype = $bc44d5c582efa5c9$var$C.prototype;
function $bc44d5c582efa5c9$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $bc44d5c582efa5c9$var$B;
    this.updater = c || $bc44d5c582efa5c9$var$A;
}
var $bc44d5c582efa5c9$var$F = $bc44d5c582efa5c9$var$E.prototype = new $bc44d5c582efa5c9$var$D;
$bc44d5c582efa5c9$var$F.constructor = $bc44d5c582efa5c9$var$E;
$2WFPq($bc44d5c582efa5c9$var$F, $bc44d5c582efa5c9$var$C.prototype);
$bc44d5c582efa5c9$var$F.isPureReactComponent = !0;
var $bc44d5c582efa5c9$var$G = {
    current: null
}, $bc44d5c582efa5c9$var$H = Object.prototype.hasOwnProperty, $bc44d5c582efa5c9$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bc44d5c582efa5c9$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$bc44d5c582efa5c9$var$H.call(b, e) && !$bc44d5c582efa5c9$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $bc44d5c582efa5c9$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $bc44d5c582efa5c9$var$G.current
    };
}
function $bc44d5c582efa5c9$var$K(a, b) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $bc44d5c582efa5c9$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bc44d5c582efa5c9$var$n;
}
function $bc44d5c582efa5c9$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $bc44d5c582efa5c9$var$M = /\/+/g;
function $bc44d5c582efa5c9$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $bc44d5c582efa5c9$var$escape("" + a.key) : b.toString(36);
}
function $bc44d5c582efa5c9$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $bc44d5c582efa5c9$var$n:
                case $bc44d5c582efa5c9$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $bc44d5c582efa5c9$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($bc44d5c582efa5c9$var$M, "$&/") + "/"), $bc44d5c582efa5c9$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($bc44d5c582efa5c9$var$L(d) && (d = $bc44d5c582efa5c9$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($bc44d5c582efa5c9$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $bc44d5c582efa5c9$var$N(k, g);
        h += $bc44d5c582efa5c9$var$O(k, b, c, f, d);
    }
    else if (f = $bc44d5c582efa5c9$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $bc44d5c582efa5c9$var$N(k, g++), h += $bc44d5c582efa5c9$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($bc44d5c582efa5c9$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $bc44d5c582efa5c9$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $bc44d5c582efa5c9$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $bc44d5c582efa5c9$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $bc44d5c582efa5c9$var$R = {
    current: null
};
function $bc44d5c582efa5c9$var$S() {
    var a = $bc44d5c582efa5c9$var$R.current;
    if (null === a) throw Error($bc44d5c582efa5c9$var$z(321));
    return a;
}
var $bc44d5c582efa5c9$var$T = {
    ReactCurrentDispatcher: $bc44d5c582efa5c9$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $bc44d5c582efa5c9$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $2WFPq
};
$bc44d5c582efa5c9$export$dca3b0875bd9a954 = {
    map: $bc44d5c582efa5c9$var$P,
    forEach: function(a, b, c) {
        $bc44d5c582efa5c9$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $bc44d5c582efa5c9$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $bc44d5c582efa5c9$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$bc44d5c582efa5c9$var$L(a)) throw Error($bc44d5c582efa5c9$var$z(143));
        return a;
    }
};
$bc44d5c582efa5c9$export$16fa2f45be04daa8 = $bc44d5c582efa5c9$var$C;
$bc44d5c582efa5c9$export$221d75b3f55bb0bd = $bc44d5c582efa5c9$var$E;
$bc44d5c582efa5c9$export$ae55be85d98224ed = $bc44d5c582efa5c9$var$T;
$bc44d5c582efa5c9$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($bc44d5c582efa5c9$var$z(267, a));
    var e = $2WFPq({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $bc44d5c582efa5c9$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$bc44d5c582efa5c9$var$H.call(b, f) && !$bc44d5c582efa5c9$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $bc44d5c582efa5c9$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$bc44d5c582efa5c9$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $bc44d5c582efa5c9$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $bc44d5c582efa5c9$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$bc44d5c582efa5c9$export$c8a8987d4410bf2d = $bc44d5c582efa5c9$var$J;
$bc44d5c582efa5c9$export$d38cd72104c1f0e9 = function(a) {
    var b = $bc44d5c582efa5c9$var$J.bind(null, a);
    b.type = a;
    return b;
};
$bc44d5c582efa5c9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$bc44d5c582efa5c9$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$t,
        render: a
    };
};
$bc44d5c582efa5c9$export$a8257692ac88316c = $bc44d5c582efa5c9$var$L;
$bc44d5c582efa5c9$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $bc44d5c582efa5c9$var$Q
    };
};
$bc44d5c582efa5c9$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$bc44d5c582efa5c9$export$35808ee640e87ca7 = function(a, b) {
    return $bc44d5c582efa5c9$var$S().useCallback(a, b);
};
$bc44d5c582efa5c9$export$fae74005e78b1a27 = function(a, b) {
    return $bc44d5c582efa5c9$var$S().useContext(a, b);
};
$bc44d5c582efa5c9$export$dc8fbce3eb94dc1e = function() {};
$bc44d5c582efa5c9$export$6d9c69b0de29b591 = function(a, b) {
    return $bc44d5c582efa5c9$var$S().useEffect(a, b);
};
$bc44d5c582efa5c9$export$d5a552a76deda3c2 = function(a, b, c) {
    return $bc44d5c582efa5c9$var$S().useImperativeHandle(a, b, c);
};
$bc44d5c582efa5c9$export$e5c5a5f917a5871c = function(a, b) {
    return $bc44d5c582efa5c9$var$S().useLayoutEffect(a, b);
};
$bc44d5c582efa5c9$export$1538c33de8887b59 = function(a, b) {
    return $bc44d5c582efa5c9$var$S().useMemo(a, b);
};
$bc44d5c582efa5c9$export$13e3392192263954 = function(a, b, c) {
    return $bc44d5c582efa5c9$var$S().useReducer(a, b, c);
};
$bc44d5c582efa5c9$export$b8f5890fc79d6aca = function(a) {
    return $bc44d5c582efa5c9$var$S().useRef(a);
};
$bc44d5c582efa5c9$export$60241385465d0a34 = function(a) {
    return $bc44d5c582efa5c9$var$S().useState(a);
};
$bc44d5c582efa5c9$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("eN6q3", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $gIfym = parcelRequire("gIfym");

var $2WFPq = parcelRequire("2WFPq");

var $Qw0kg = parcelRequire("Qw0kg");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$gIfym) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $gIfym.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $2WFPq({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $gIfym.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $2WFPq({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $2WFPq({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $2WFPq({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $Qw0kg.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $Qw0kg.unstable_scheduleCallback($Qw0kg.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $Qw0kg.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $Qw0kg.unstable_UserBlockingPriority, ed = $Qw0kg.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $2WFPq(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $2WFPq({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $2WFPq({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $2WFPq({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $2WFPq({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $2WFPq({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $2WFPq({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $2WFPq({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $2WFPq({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $2WFPq({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $2WFPq({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $2WFPq({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $2WFPq({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $2WFPq({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $Qw0kg.unstable_runWithPriority, Of = $Qw0kg.unstable_scheduleCallback, Pf = $Qw0kg.unstable_cancelCallback, Qf = $Qw0kg.unstable_shouldYield, Rf = $Qw0kg.unstable_requestPaint, Sf = $Qw0kg.unstable_now, Tf = $Qw0kg.unstable_getCurrentPriorityLevel, Uf = $Qw0kg.unstable_ImmediatePriority, Vf = $Qw0kg.unstable_UserBlockingPriority, Wf = $Qw0kg.unstable_NormalPriority, Xf = $Qw0kg.unstable_LowPriority, Yf = $Qw0kg.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $2WFPq({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $2WFPq({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $gIfym.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $2WFPq({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $2WFPq({}, e, {
                    value: void 0
                });
                d = $2WFPq({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $2WFPq({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("Qw0kg", function(module, exports) {
'use strict';

module.exports = (parcelRequire("29Llp"));

});
parcelRegister("29Llp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $192125a6b5623347$export$c4744153514ff05d; }, function (v) { return $192125a6b5623347$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $192125a6b5623347$export$b5836b71941fa3ed; }, function (v) { return $192125a6b5623347$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $192125a6b5623347$export$d66a1c1c77bd778b; }, function (v) { return $192125a6b5623347$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $192125a6b5623347$export$3e506c1ccc9cc1a7; }, function (v) { return $192125a6b5623347$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $192125a6b5623347$export$e26fe2ed2fa76875; }, function (v) { return $192125a6b5623347$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $192125a6b5623347$export$502329bbf4b505b1; }, function (v) { return $192125a6b5623347$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $192125a6b5623347$export$6e3807111c4874c4; }, function (v) { return $192125a6b5623347$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $192125a6b5623347$export$c27134553091fb3a; }, function (v) { return $192125a6b5623347$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $192125a6b5623347$export$33ee1acdc04fd2a2; }, function (v) { return $192125a6b5623347$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $192125a6b5623347$export$b00a404bbd5edef2; }, function (v) { return $192125a6b5623347$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $192125a6b5623347$export$8352ce38b91d0c62; }, function (v) { return $192125a6b5623347$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $192125a6b5623347$export$d3dfb8e4810cb555; }, function (v) { return $192125a6b5623347$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $192125a6b5623347$export$839f9183b0465a69; }, function (v) { return $192125a6b5623347$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $192125a6b5623347$export$72fdf0e06517287b; }, function (v) { return $192125a6b5623347$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $192125a6b5623347$export$4b844e58a3e414b4; }, function (v) { return $192125a6b5623347$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $192125a6b5623347$export$816d2913ae6b83b1; }, function (v) { return $192125a6b5623347$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $192125a6b5623347$export$61bcfe829111a1d0; }, function (v) { return $192125a6b5623347$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $192125a6b5623347$export$7ee8c9beb337bc3f; }, function (v) { return $192125a6b5623347$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $192125a6b5623347$export$cf845f2c119da08a; }, function (v) { return $192125a6b5623347$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $192125a6b5623347$export$c4744153514ff05d;
var $192125a6b5623347$export$b5836b71941fa3ed;
var $192125a6b5623347$export$d66a1c1c77bd778b;
var $192125a6b5623347$export$3e506c1ccc9cc1a7;
var $192125a6b5623347$export$e26fe2ed2fa76875;
var $192125a6b5623347$export$502329bbf4b505b1;
var $192125a6b5623347$export$6e3807111c4874c4;
var $192125a6b5623347$export$c27134553091fb3a;
var $192125a6b5623347$export$33ee1acdc04fd2a2;
var $192125a6b5623347$export$b00a404bbd5edef2;
var $192125a6b5623347$export$8352ce38b91d0c62;
var $192125a6b5623347$export$d3dfb8e4810cb555;
var $192125a6b5623347$export$839f9183b0465a69;
var $192125a6b5623347$export$72fdf0e06517287b;
var $192125a6b5623347$export$4b844e58a3e414b4;
var $192125a6b5623347$export$816d2913ae6b83b1;
var $192125a6b5623347$export$61bcfe829111a1d0;
var $192125a6b5623347$export$7ee8c9beb337bc3f;
var $192125a6b5623347$export$cf845f2c119da08a;
'use strict';
var $192125a6b5623347$var$f, $192125a6b5623347$var$g, $192125a6b5623347$var$h, $192125a6b5623347$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $192125a6b5623347$var$l = performance;
    $192125a6b5623347$export$c4744153514ff05d = function() {
        return $192125a6b5623347$var$l.now();
    };
} else {
    var $192125a6b5623347$var$p = Date, $192125a6b5623347$var$q = $192125a6b5623347$var$p.now();
    $192125a6b5623347$export$c4744153514ff05d = function() {
        return $192125a6b5623347$var$p.now() - $192125a6b5623347$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $192125a6b5623347$var$t = null, $192125a6b5623347$var$u = null, $192125a6b5623347$var$w = function() {
        if (null !== $192125a6b5623347$var$t) try {
            var a = $192125a6b5623347$export$c4744153514ff05d();
            $192125a6b5623347$var$t(!0, a);
            $192125a6b5623347$var$t = null;
        } catch (b) {
            throw setTimeout($192125a6b5623347$var$w, 0), b;
        }
    };
    $192125a6b5623347$var$f = function(a) {
        null !== $192125a6b5623347$var$t ? setTimeout($192125a6b5623347$var$f, 0, a) : ($192125a6b5623347$var$t = a, setTimeout($192125a6b5623347$var$w, 0));
    };
    $192125a6b5623347$var$g = function(a, b) {
        $192125a6b5623347$var$u = setTimeout(a, b);
    };
    $192125a6b5623347$var$h = function() {
        clearTimeout($192125a6b5623347$var$u);
    };
    $192125a6b5623347$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $192125a6b5623347$var$k = $192125a6b5623347$export$d66a1c1c77bd778b = function() {};
} else {
    var $192125a6b5623347$var$x = window.setTimeout, $192125a6b5623347$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $192125a6b5623347$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $192125a6b5623347$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $192125a6b5623347$var$A = !1, $192125a6b5623347$var$B = null, $192125a6b5623347$var$C = -1, $192125a6b5623347$var$D = 5, $192125a6b5623347$var$E = 0;
    $192125a6b5623347$export$b5836b71941fa3ed = function() {
        return $192125a6b5623347$export$c4744153514ff05d() >= $192125a6b5623347$var$E;
    };
    $192125a6b5623347$var$k = function() {};
    $192125a6b5623347$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $192125a6b5623347$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $192125a6b5623347$var$F = new MessageChannel, $192125a6b5623347$var$G = $192125a6b5623347$var$F.port2;
    $192125a6b5623347$var$F.port1.onmessage = function() {
        if (null !== $192125a6b5623347$var$B) {
            var a = $192125a6b5623347$export$c4744153514ff05d();
            $192125a6b5623347$var$E = a + $192125a6b5623347$var$D;
            try {
                $192125a6b5623347$var$B(!0, a) ? $192125a6b5623347$var$G.postMessage(null) : ($192125a6b5623347$var$A = !1, $192125a6b5623347$var$B = null);
            } catch (b) {
                throw $192125a6b5623347$var$G.postMessage(null), b;
            }
        } else $192125a6b5623347$var$A = !1;
    };
    $192125a6b5623347$var$f = function(a) {
        $192125a6b5623347$var$B = a;
        $192125a6b5623347$var$A || ($192125a6b5623347$var$A = !0, $192125a6b5623347$var$G.postMessage(null));
    };
    $192125a6b5623347$var$g = function(a, b) {
        $192125a6b5623347$var$C = $192125a6b5623347$var$x(function() {
            a($192125a6b5623347$export$c4744153514ff05d());
        }, b);
    };
    $192125a6b5623347$var$h = function() {
        $192125a6b5623347$var$y($192125a6b5623347$var$C);
        $192125a6b5623347$var$C = -1;
    };
}
function $192125a6b5623347$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $192125a6b5623347$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $192125a6b5623347$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $192125a6b5623347$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $192125a6b5623347$var$I(n, c)) void 0 !== r && 0 > $192125a6b5623347$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $192125a6b5623347$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $192125a6b5623347$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $192125a6b5623347$var$L = [], $192125a6b5623347$var$M = [], $192125a6b5623347$var$N = 1, $192125a6b5623347$var$O = null, $192125a6b5623347$var$P = 3, $192125a6b5623347$var$Q = !1, $192125a6b5623347$var$R = !1, $192125a6b5623347$var$S = !1;
function $192125a6b5623347$var$T(a) {
    for(var b = $192125a6b5623347$var$J($192125a6b5623347$var$M); null !== b;){
        if (null === b.callback) $192125a6b5623347$var$K($192125a6b5623347$var$M);
        else if (b.startTime <= a) $192125a6b5623347$var$K($192125a6b5623347$var$M), b.sortIndex = b.expirationTime, $192125a6b5623347$var$H($192125a6b5623347$var$L, b);
        else break;
        b = $192125a6b5623347$var$J($192125a6b5623347$var$M);
    }
}
function $192125a6b5623347$var$U(a) {
    $192125a6b5623347$var$S = !1;
    $192125a6b5623347$var$T(a);
    if (!$192125a6b5623347$var$R) {
        if (null !== $192125a6b5623347$var$J($192125a6b5623347$var$L)) $192125a6b5623347$var$R = !0, $192125a6b5623347$var$f($192125a6b5623347$var$V);
        else {
            var b = $192125a6b5623347$var$J($192125a6b5623347$var$M);
            null !== b && $192125a6b5623347$var$g($192125a6b5623347$var$U, b.startTime - a);
        }
    }
}
function $192125a6b5623347$var$V(a, b) {
    $192125a6b5623347$var$R = !1;
    $192125a6b5623347$var$S && ($192125a6b5623347$var$S = !1, $192125a6b5623347$var$h());
    $192125a6b5623347$var$Q = !0;
    var c = $192125a6b5623347$var$P;
    try {
        $192125a6b5623347$var$T(b);
        for($192125a6b5623347$var$O = $192125a6b5623347$var$J($192125a6b5623347$var$L); null !== $192125a6b5623347$var$O && (!($192125a6b5623347$var$O.expirationTime > b) || a && !$192125a6b5623347$export$b5836b71941fa3ed());){
            var d = $192125a6b5623347$var$O.callback;
            if ("function" === typeof d) {
                $192125a6b5623347$var$O.callback = null;
                $192125a6b5623347$var$P = $192125a6b5623347$var$O.priorityLevel;
                var e = d($192125a6b5623347$var$O.expirationTime <= b);
                b = $192125a6b5623347$export$c4744153514ff05d();
                "function" === typeof e ? $192125a6b5623347$var$O.callback = e : $192125a6b5623347$var$O === $192125a6b5623347$var$J($192125a6b5623347$var$L) && $192125a6b5623347$var$K($192125a6b5623347$var$L);
                $192125a6b5623347$var$T(b);
            } else $192125a6b5623347$var$K($192125a6b5623347$var$L);
            $192125a6b5623347$var$O = $192125a6b5623347$var$J($192125a6b5623347$var$L);
        }
        if (null !== $192125a6b5623347$var$O) var m = !0;
        else {
            var n = $192125a6b5623347$var$J($192125a6b5623347$var$M);
            null !== n && $192125a6b5623347$var$g($192125a6b5623347$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $192125a6b5623347$var$O = null, $192125a6b5623347$var$P = c, $192125a6b5623347$var$Q = !1;
    }
}
var $192125a6b5623347$var$W = $192125a6b5623347$var$k;
$192125a6b5623347$export$3e506c1ccc9cc1a7 = 5;
$192125a6b5623347$export$e26fe2ed2fa76875 = 1;
$192125a6b5623347$export$502329bbf4b505b1 = 4;
$192125a6b5623347$export$6e3807111c4874c4 = 3;
$192125a6b5623347$export$c27134553091fb3a = null;
$192125a6b5623347$export$33ee1acdc04fd2a2 = 2;
$192125a6b5623347$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$192125a6b5623347$export$8352ce38b91d0c62 = function() {
    $192125a6b5623347$var$R || $192125a6b5623347$var$Q || ($192125a6b5623347$var$R = !0, $192125a6b5623347$var$f($192125a6b5623347$var$V));
};
$192125a6b5623347$export$d3dfb8e4810cb555 = function() {
    return $192125a6b5623347$var$P;
};
$192125a6b5623347$export$839f9183b0465a69 = function() {
    return $192125a6b5623347$var$J($192125a6b5623347$var$L);
};
$192125a6b5623347$export$72fdf0e06517287b = function(a) {
    switch($192125a6b5623347$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $192125a6b5623347$var$P;
    }
    var c = $192125a6b5623347$var$P;
    $192125a6b5623347$var$P = b;
    try {
        return a();
    } finally{
        $192125a6b5623347$var$P = c;
    }
};
$192125a6b5623347$export$4b844e58a3e414b4 = function() {};
$192125a6b5623347$export$816d2913ae6b83b1 = $192125a6b5623347$var$W;
$192125a6b5623347$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $192125a6b5623347$var$P;
    $192125a6b5623347$var$P = a;
    try {
        return b();
    } finally{
        $192125a6b5623347$var$P = c;
    }
};
$192125a6b5623347$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $192125a6b5623347$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $192125a6b5623347$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $192125a6b5623347$var$H($192125a6b5623347$var$M, a), null === $192125a6b5623347$var$J($192125a6b5623347$var$L) && a === $192125a6b5623347$var$J($192125a6b5623347$var$M) && ($192125a6b5623347$var$S ? $192125a6b5623347$var$h() : $192125a6b5623347$var$S = !0, $192125a6b5623347$var$g($192125a6b5623347$var$U, c - d))) : (a.sortIndex = e, $192125a6b5623347$var$H($192125a6b5623347$var$L, a), $192125a6b5623347$var$R || $192125a6b5623347$var$Q || ($192125a6b5623347$var$R = !0, $192125a6b5623347$var$f($192125a6b5623347$var$V)));
    return a;
};
$192125a6b5623347$export$cf845f2c119da08a = function(a) {
    var b = $192125a6b5623347$var$P;
    return function() {
        var c = $192125a6b5623347$var$P;
        $192125a6b5623347$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $192125a6b5623347$var$P = c;
        }
    };
};

});



parcelRegister("kh2Rv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $4H3Nt = parcelRequire("4H3Nt");
function $ec279d803f66d50f$var$emptyFunction() {}
function $ec279d803f66d50f$var$emptyFunctionWithReset() {}
$ec279d803f66d50f$var$emptyFunctionWithReset.resetWarningCache = $ec279d803f66d50f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $4H3Nt) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $ec279d803f66d50f$var$emptyFunctionWithReset,
        resetWarningCache: $ec279d803f66d50f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("4H3Nt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $36ae1f94766f6c68$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $36ae1f94766f6c68$var$ReactPropTypesSecret;

});


parcelRegister("hBYHu", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $cd24fa3138346a41$export$2b8d127b894957b9; }, function (v) { return $cd24fa3138346a41$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $cd24fa3138346a41$export$cea3a54a6425200c; }, function (v) { return $cd24fa3138346a41$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $cd24fa3138346a41$export$a7c73072b1a182ae; }, function (v) { return $cd24fa3138346a41$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $cd24fa3138346a41$export$9f27bc3417b4524d; }, function (v) { return $cd24fa3138346a41$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $cd24fa3138346a41$export$db77ccec0bb4ccac; }, function (v) { return $cd24fa3138346a41$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $cd24fa3138346a41$export$8392c0c9d3dcbd35; }, function (v) { return $cd24fa3138346a41$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cd24fa3138346a41$export$ffb0004e005737fa; }, function (v) { return $cd24fa3138346a41$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $cd24fa3138346a41$export$b624eff549462981; }, function (v) { return $cd24fa3138346a41$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $cd24fa3138346a41$export$7897aa7841a5380c; }, function (v) { return $cd24fa3138346a41$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $cd24fa3138346a41$export$602eac185826482c; }, function (v) { return $cd24fa3138346a41$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $cd24fa3138346a41$export$e2c29f18771995cb; }, function (v) { return $cd24fa3138346a41$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cd24fa3138346a41$export$5f8d39834fd61797; }, function (v) { return $cd24fa3138346a41$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cd24fa3138346a41$export$74bf444e3cd11ea5; }, function (v) { return $cd24fa3138346a41$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $cd24fa3138346a41$export$92387174baf9b227; }, function (v) { return $cd24fa3138346a41$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $cd24fa3138346a41$export$ec112efeb987d9c6; }, function (v) { return $cd24fa3138346a41$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $cd24fa3138346a41$export$b706b080d889d2c9; }, function (v) { return $cd24fa3138346a41$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $cd24fa3138346a41$export$5be5a87408f70ddc; }, function (v) { return $cd24fa3138346a41$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $cd24fa3138346a41$export$45a5e7f76e0caa8d; }, function (v) { return $cd24fa3138346a41$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $cd24fa3138346a41$export$455c2e768291efa6; }, function (v) { return $cd24fa3138346a41$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $cd24fa3138346a41$export$9522e17588c12572; }, function (v) { return $cd24fa3138346a41$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $cd24fa3138346a41$export$2110ac352bb060b9; }, function (v) { return $cd24fa3138346a41$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $cd24fa3138346a41$export$56885ab8b9c456ab; }, function (v) { return $cd24fa3138346a41$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $cd24fa3138346a41$export$d927fcb6adf8f9de; }, function (v) { return $cd24fa3138346a41$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $cd24fa3138346a41$export$b82d16f27459e05a; }, function (v) { return $cd24fa3138346a41$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $cd24fa3138346a41$export$522c17b4f5e123e8; }, function (v) { return $cd24fa3138346a41$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $cd24fa3138346a41$export$1aabd8a0274ecfd6; }, function (v) { return $cd24fa3138346a41$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $cd24fa3138346a41$export$9b621391a187a31a; }, function (v) { return $cd24fa3138346a41$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $cd24fa3138346a41$export$f5bbd400c2f4426f; }, function (v) { return $cd24fa3138346a41$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cd24fa3138346a41$export$2b8d127b894957b9;
var $cd24fa3138346a41$export$cea3a54a6425200c;
var $cd24fa3138346a41$export$a7c73072b1a182ae;
var $cd24fa3138346a41$export$9f27bc3417b4524d;
var $cd24fa3138346a41$export$db77ccec0bb4ccac;
var $cd24fa3138346a41$export$8392c0c9d3dcbd35;
var $cd24fa3138346a41$export$ffb0004e005737fa;
var $cd24fa3138346a41$export$b624eff549462981;
var $cd24fa3138346a41$export$7897aa7841a5380c;
var $cd24fa3138346a41$export$602eac185826482c;
var $cd24fa3138346a41$export$e2c29f18771995cb;
var $cd24fa3138346a41$export$5f8d39834fd61797;
var $cd24fa3138346a41$export$74bf444e3cd11ea5;
var $cd24fa3138346a41$export$92387174baf9b227;
var $cd24fa3138346a41$export$ec112efeb987d9c6;
var $cd24fa3138346a41$export$b706b080d889d2c9;
var $cd24fa3138346a41$export$5be5a87408f70ddc;
var $cd24fa3138346a41$export$45a5e7f76e0caa8d;
var $cd24fa3138346a41$export$455c2e768291efa6;
var $cd24fa3138346a41$export$9522e17588c12572;
var $cd24fa3138346a41$export$2110ac352bb060b9;
var $cd24fa3138346a41$export$56885ab8b9c456ab;
var $cd24fa3138346a41$export$d927fcb6adf8f9de;
var $cd24fa3138346a41$export$b82d16f27459e05a;
var $cd24fa3138346a41$export$522c17b4f5e123e8;
var $cd24fa3138346a41$export$1aabd8a0274ecfd6;
var $cd24fa3138346a41$export$9b621391a187a31a;
var $cd24fa3138346a41$export$f5bbd400c2f4426f;
'use strict';
var $cd24fa3138346a41$var$b = "function" === typeof Symbol && Symbol.for, $cd24fa3138346a41$var$c = $cd24fa3138346a41$var$b ? Symbol.for("react.element") : 60103, $cd24fa3138346a41$var$d = $cd24fa3138346a41$var$b ? Symbol.for("react.portal") : 60106, $cd24fa3138346a41$var$e = $cd24fa3138346a41$var$b ? Symbol.for("react.fragment") : 60107, $cd24fa3138346a41$var$f = $cd24fa3138346a41$var$b ? Symbol.for("react.strict_mode") : 60108, $cd24fa3138346a41$var$g = $cd24fa3138346a41$var$b ? Symbol.for("react.profiler") : 60114, $cd24fa3138346a41$var$h = $cd24fa3138346a41$var$b ? Symbol.for("react.provider") : 60109, $cd24fa3138346a41$var$k = $cd24fa3138346a41$var$b ? Symbol.for("react.context") : 60110, $cd24fa3138346a41$var$l = $cd24fa3138346a41$var$b ? Symbol.for("react.async_mode") : 60111, $cd24fa3138346a41$var$m = $cd24fa3138346a41$var$b ? Symbol.for("react.concurrent_mode") : 60111, $cd24fa3138346a41$var$n = $cd24fa3138346a41$var$b ? Symbol.for("react.forward_ref") : 60112, $cd24fa3138346a41$var$p = $cd24fa3138346a41$var$b ? Symbol.for("react.suspense") : 60113, $cd24fa3138346a41$var$q = $cd24fa3138346a41$var$b ? Symbol.for("react.suspense_list") : 60120, $cd24fa3138346a41$var$r = $cd24fa3138346a41$var$b ? Symbol.for("react.memo") : 60115, $cd24fa3138346a41$var$t = $cd24fa3138346a41$var$b ? Symbol.for("react.lazy") : 60116, $cd24fa3138346a41$var$v = $cd24fa3138346a41$var$b ? Symbol.for("react.block") : 60121, $cd24fa3138346a41$var$w = $cd24fa3138346a41$var$b ? Symbol.for("react.fundamental") : 60117, $cd24fa3138346a41$var$x = $cd24fa3138346a41$var$b ? Symbol.for("react.responder") : 60118, $cd24fa3138346a41$var$y = $cd24fa3138346a41$var$b ? Symbol.for("react.scope") : 60119;
function $cd24fa3138346a41$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $cd24fa3138346a41$var$c:
                switch(a = a.type, a){
                    case $cd24fa3138346a41$var$l:
                    case $cd24fa3138346a41$var$m:
                    case $cd24fa3138346a41$var$e:
                    case $cd24fa3138346a41$var$g:
                    case $cd24fa3138346a41$var$f:
                    case $cd24fa3138346a41$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $cd24fa3138346a41$var$k:
                            case $cd24fa3138346a41$var$n:
                            case $cd24fa3138346a41$var$t:
                            case $cd24fa3138346a41$var$r:
                            case $cd24fa3138346a41$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $cd24fa3138346a41$var$d:
                return u;
        }
    }
}
function $cd24fa3138346a41$var$A(a) {
    return $cd24fa3138346a41$var$z(a) === $cd24fa3138346a41$var$m;
}
$cd24fa3138346a41$export$2b8d127b894957b9 = $cd24fa3138346a41$var$l;
$cd24fa3138346a41$export$cea3a54a6425200c = $cd24fa3138346a41$var$m;
$cd24fa3138346a41$export$a7c73072b1a182ae = $cd24fa3138346a41$var$k;
$cd24fa3138346a41$export$9f27bc3417b4524d = $cd24fa3138346a41$var$h;
$cd24fa3138346a41$export$db77ccec0bb4ccac = $cd24fa3138346a41$var$c;
$cd24fa3138346a41$export$8392c0c9d3dcbd35 = $cd24fa3138346a41$var$n;
$cd24fa3138346a41$export$ffb0004e005737fa = $cd24fa3138346a41$var$e;
$cd24fa3138346a41$export$b624eff549462981 = $cd24fa3138346a41$var$t;
$cd24fa3138346a41$export$7897aa7841a5380c = $cd24fa3138346a41$var$r;
$cd24fa3138346a41$export$602eac185826482c = $cd24fa3138346a41$var$d;
$cd24fa3138346a41$export$e2c29f18771995cb = $cd24fa3138346a41$var$g;
$cd24fa3138346a41$export$5f8d39834fd61797 = $cd24fa3138346a41$var$f;
$cd24fa3138346a41$export$74bf444e3cd11ea5 = $cd24fa3138346a41$var$p;
$cd24fa3138346a41$export$92387174baf9b227 = function(a) {
    return $cd24fa3138346a41$var$A(a) || $cd24fa3138346a41$var$z(a) === $cd24fa3138346a41$var$l;
};
$cd24fa3138346a41$export$ec112efeb987d9c6 = $cd24fa3138346a41$var$A;
$cd24fa3138346a41$export$b706b080d889d2c9 = function(a) {
    return $cd24fa3138346a41$var$z(a) === $cd24fa3138346a41$var$k;
};
$cd24fa3138346a41$export$5be5a87408f70ddc = function(a) {
    return $cd24fa3138346a41$var$z(a) === $cd24fa3138346a41$var$h;
};
$cd24fa3138346a41$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cd24fa3138346a41$var$c;
};
$cd24fa3138346a41$export$455c2e768291efa6 = function(a) {
    return $cd24fa3138346a41$var$z(a) === $cd24fa3138346a41$var$n;
};
$cd24fa3138346a41$export$9522e17588c12572 = function(a) {
    return $cd24fa3138346a41$var$z(a) === $cd24fa3138346a41$var$e;
};
$cd24fa3138346a41$export$2110ac352bb060b9 = function(a) {
    return $cd24fa3138346a41$var$z(a) === $cd24fa3138346a41$var$t;
};
$cd24fa3138346a41$export$56885ab8b9c456ab = function(a) {
    return $cd24fa3138346a41$var$z(a) === $cd24fa3138346a41$var$r;
};
$cd24fa3138346a41$export$d927fcb6adf8f9de = function(a) {
    return $cd24fa3138346a41$var$z(a) === $cd24fa3138346a41$var$d;
};
$cd24fa3138346a41$export$b82d16f27459e05a = function(a) {
    return $cd24fa3138346a41$var$z(a) === $cd24fa3138346a41$var$g;
};
$cd24fa3138346a41$export$522c17b4f5e123e8 = function(a) {
    return $cd24fa3138346a41$var$z(a) === $cd24fa3138346a41$var$f;
};
$cd24fa3138346a41$export$1aabd8a0274ecfd6 = function(a) {
    return $cd24fa3138346a41$var$z(a) === $cd24fa3138346a41$var$p;
};
$cd24fa3138346a41$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $cd24fa3138346a41$var$e || a === $cd24fa3138346a41$var$m || a === $cd24fa3138346a41$var$g || a === $cd24fa3138346a41$var$f || a === $cd24fa3138346a41$var$p || a === $cd24fa3138346a41$var$q || "object" === typeof a && null !== a && (a.$$typeof === $cd24fa3138346a41$var$t || a.$$typeof === $cd24fa3138346a41$var$r || a.$$typeof === $cd24fa3138346a41$var$h || a.$$typeof === $cd24fa3138346a41$var$k || a.$$typeof === $cd24fa3138346a41$var$n || a.$$typeof === $cd24fa3138346a41$var$w || a.$$typeof === $cd24fa3138346a41$var$x || a.$$typeof === $cd24fa3138346a41$var$y || a.$$typeof === $cd24fa3138346a41$var$v);
};
$cd24fa3138346a41$export$f5bbd400c2f4426f = $cd24fa3138346a41$var$z;

});

parcelRegister("4sGuq", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $33fabc84eaff793d$export$2b8d127b894957b9; }, function (v) { return $33fabc84eaff793d$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $33fabc84eaff793d$export$cea3a54a6425200c; }, function (v) { return $33fabc84eaff793d$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $33fabc84eaff793d$export$a7c73072b1a182ae; }, function (v) { return $33fabc84eaff793d$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $33fabc84eaff793d$export$9f27bc3417b4524d; }, function (v) { return $33fabc84eaff793d$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $33fabc84eaff793d$export$db77ccec0bb4ccac; }, function (v) { return $33fabc84eaff793d$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $33fabc84eaff793d$export$8392c0c9d3dcbd35; }, function (v) { return $33fabc84eaff793d$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $33fabc84eaff793d$export$ffb0004e005737fa; }, function (v) { return $33fabc84eaff793d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $33fabc84eaff793d$export$b624eff549462981; }, function (v) { return $33fabc84eaff793d$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $33fabc84eaff793d$export$7897aa7841a5380c; }, function (v) { return $33fabc84eaff793d$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $33fabc84eaff793d$export$602eac185826482c; }, function (v) { return $33fabc84eaff793d$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $33fabc84eaff793d$export$e2c29f18771995cb; }, function (v) { return $33fabc84eaff793d$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $33fabc84eaff793d$export$5f8d39834fd61797; }, function (v) { return $33fabc84eaff793d$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $33fabc84eaff793d$export$74bf444e3cd11ea5; }, function (v) { return $33fabc84eaff793d$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $33fabc84eaff793d$export$92387174baf9b227; }, function (v) { return $33fabc84eaff793d$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $33fabc84eaff793d$export$ec112efeb987d9c6; }, function (v) { return $33fabc84eaff793d$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $33fabc84eaff793d$export$b706b080d889d2c9; }, function (v) { return $33fabc84eaff793d$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $33fabc84eaff793d$export$5be5a87408f70ddc; }, function (v) { return $33fabc84eaff793d$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $33fabc84eaff793d$export$45a5e7f76e0caa8d; }, function (v) { return $33fabc84eaff793d$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $33fabc84eaff793d$export$455c2e768291efa6; }, function (v) { return $33fabc84eaff793d$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $33fabc84eaff793d$export$9522e17588c12572; }, function (v) { return $33fabc84eaff793d$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $33fabc84eaff793d$export$2110ac352bb060b9; }, function (v) { return $33fabc84eaff793d$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $33fabc84eaff793d$export$56885ab8b9c456ab; }, function (v) { return $33fabc84eaff793d$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $33fabc84eaff793d$export$d927fcb6adf8f9de; }, function (v) { return $33fabc84eaff793d$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $33fabc84eaff793d$export$b82d16f27459e05a; }, function (v) { return $33fabc84eaff793d$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $33fabc84eaff793d$export$522c17b4f5e123e8; }, function (v) { return $33fabc84eaff793d$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $33fabc84eaff793d$export$1aabd8a0274ecfd6; }, function (v) { return $33fabc84eaff793d$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $33fabc84eaff793d$export$9b621391a187a31a; }, function (v) { return $33fabc84eaff793d$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $33fabc84eaff793d$export$f5bbd400c2f4426f; }, function (v) { return $33fabc84eaff793d$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $33fabc84eaff793d$export$2b8d127b894957b9;
var $33fabc84eaff793d$export$cea3a54a6425200c;
var $33fabc84eaff793d$export$a7c73072b1a182ae;
var $33fabc84eaff793d$export$9f27bc3417b4524d;
var $33fabc84eaff793d$export$db77ccec0bb4ccac;
var $33fabc84eaff793d$export$8392c0c9d3dcbd35;
var $33fabc84eaff793d$export$ffb0004e005737fa;
var $33fabc84eaff793d$export$b624eff549462981;
var $33fabc84eaff793d$export$7897aa7841a5380c;
var $33fabc84eaff793d$export$602eac185826482c;
var $33fabc84eaff793d$export$e2c29f18771995cb;
var $33fabc84eaff793d$export$5f8d39834fd61797;
var $33fabc84eaff793d$export$74bf444e3cd11ea5;
var $33fabc84eaff793d$export$92387174baf9b227;
var $33fabc84eaff793d$export$ec112efeb987d9c6;
var $33fabc84eaff793d$export$b706b080d889d2c9;
var $33fabc84eaff793d$export$5be5a87408f70ddc;
var $33fabc84eaff793d$export$45a5e7f76e0caa8d;
var $33fabc84eaff793d$export$455c2e768291efa6;
var $33fabc84eaff793d$export$9522e17588c12572;
var $33fabc84eaff793d$export$2110ac352bb060b9;
var $33fabc84eaff793d$export$56885ab8b9c456ab;
var $33fabc84eaff793d$export$d927fcb6adf8f9de;
var $33fabc84eaff793d$export$b82d16f27459e05a;
var $33fabc84eaff793d$export$522c17b4f5e123e8;
var $33fabc84eaff793d$export$1aabd8a0274ecfd6;
var $33fabc84eaff793d$export$9b621391a187a31a;
var $33fabc84eaff793d$export$f5bbd400c2f4426f;
'use strict';
var $33fabc84eaff793d$var$b = "function" === typeof Symbol && Symbol.for, $33fabc84eaff793d$var$c = $33fabc84eaff793d$var$b ? Symbol.for("react.element") : 60103, $33fabc84eaff793d$var$d = $33fabc84eaff793d$var$b ? Symbol.for("react.portal") : 60106, $33fabc84eaff793d$var$e = $33fabc84eaff793d$var$b ? Symbol.for("react.fragment") : 60107, $33fabc84eaff793d$var$f = $33fabc84eaff793d$var$b ? Symbol.for("react.strict_mode") : 60108, $33fabc84eaff793d$var$g = $33fabc84eaff793d$var$b ? Symbol.for("react.profiler") : 60114, $33fabc84eaff793d$var$h = $33fabc84eaff793d$var$b ? Symbol.for("react.provider") : 60109, $33fabc84eaff793d$var$k = $33fabc84eaff793d$var$b ? Symbol.for("react.context") : 60110, $33fabc84eaff793d$var$l = $33fabc84eaff793d$var$b ? Symbol.for("react.async_mode") : 60111, $33fabc84eaff793d$var$m = $33fabc84eaff793d$var$b ? Symbol.for("react.concurrent_mode") : 60111, $33fabc84eaff793d$var$n = $33fabc84eaff793d$var$b ? Symbol.for("react.forward_ref") : 60112, $33fabc84eaff793d$var$p = $33fabc84eaff793d$var$b ? Symbol.for("react.suspense") : 60113, $33fabc84eaff793d$var$q = $33fabc84eaff793d$var$b ? Symbol.for("react.suspense_list") : 60120, $33fabc84eaff793d$var$r = $33fabc84eaff793d$var$b ? Symbol.for("react.memo") : 60115, $33fabc84eaff793d$var$t = $33fabc84eaff793d$var$b ? Symbol.for("react.lazy") : 60116, $33fabc84eaff793d$var$v = $33fabc84eaff793d$var$b ? Symbol.for("react.block") : 60121, $33fabc84eaff793d$var$w = $33fabc84eaff793d$var$b ? Symbol.for("react.fundamental") : 60117, $33fabc84eaff793d$var$x = $33fabc84eaff793d$var$b ? Symbol.for("react.responder") : 60118, $33fabc84eaff793d$var$y = $33fabc84eaff793d$var$b ? Symbol.for("react.scope") : 60119;
function $33fabc84eaff793d$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $33fabc84eaff793d$var$c:
                switch(a = a.type, a){
                    case $33fabc84eaff793d$var$l:
                    case $33fabc84eaff793d$var$m:
                    case $33fabc84eaff793d$var$e:
                    case $33fabc84eaff793d$var$g:
                    case $33fabc84eaff793d$var$f:
                    case $33fabc84eaff793d$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $33fabc84eaff793d$var$k:
                            case $33fabc84eaff793d$var$n:
                            case $33fabc84eaff793d$var$t:
                            case $33fabc84eaff793d$var$r:
                            case $33fabc84eaff793d$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $33fabc84eaff793d$var$d:
                return u;
        }
    }
}
function $33fabc84eaff793d$var$A(a) {
    return $33fabc84eaff793d$var$z(a) === $33fabc84eaff793d$var$m;
}
$33fabc84eaff793d$export$2b8d127b894957b9 = $33fabc84eaff793d$var$l;
$33fabc84eaff793d$export$cea3a54a6425200c = $33fabc84eaff793d$var$m;
$33fabc84eaff793d$export$a7c73072b1a182ae = $33fabc84eaff793d$var$k;
$33fabc84eaff793d$export$9f27bc3417b4524d = $33fabc84eaff793d$var$h;
$33fabc84eaff793d$export$db77ccec0bb4ccac = $33fabc84eaff793d$var$c;
$33fabc84eaff793d$export$8392c0c9d3dcbd35 = $33fabc84eaff793d$var$n;
$33fabc84eaff793d$export$ffb0004e005737fa = $33fabc84eaff793d$var$e;
$33fabc84eaff793d$export$b624eff549462981 = $33fabc84eaff793d$var$t;
$33fabc84eaff793d$export$7897aa7841a5380c = $33fabc84eaff793d$var$r;
$33fabc84eaff793d$export$602eac185826482c = $33fabc84eaff793d$var$d;
$33fabc84eaff793d$export$e2c29f18771995cb = $33fabc84eaff793d$var$g;
$33fabc84eaff793d$export$5f8d39834fd61797 = $33fabc84eaff793d$var$f;
$33fabc84eaff793d$export$74bf444e3cd11ea5 = $33fabc84eaff793d$var$p;
$33fabc84eaff793d$export$92387174baf9b227 = function(a) {
    return $33fabc84eaff793d$var$A(a) || $33fabc84eaff793d$var$z(a) === $33fabc84eaff793d$var$l;
};
$33fabc84eaff793d$export$ec112efeb987d9c6 = $33fabc84eaff793d$var$A;
$33fabc84eaff793d$export$b706b080d889d2c9 = function(a) {
    return $33fabc84eaff793d$var$z(a) === $33fabc84eaff793d$var$k;
};
$33fabc84eaff793d$export$5be5a87408f70ddc = function(a) {
    return $33fabc84eaff793d$var$z(a) === $33fabc84eaff793d$var$h;
};
$33fabc84eaff793d$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $33fabc84eaff793d$var$c;
};
$33fabc84eaff793d$export$455c2e768291efa6 = function(a) {
    return $33fabc84eaff793d$var$z(a) === $33fabc84eaff793d$var$n;
};
$33fabc84eaff793d$export$9522e17588c12572 = function(a) {
    return $33fabc84eaff793d$var$z(a) === $33fabc84eaff793d$var$e;
};
$33fabc84eaff793d$export$2110ac352bb060b9 = function(a) {
    return $33fabc84eaff793d$var$z(a) === $33fabc84eaff793d$var$t;
};
$33fabc84eaff793d$export$56885ab8b9c456ab = function(a) {
    return $33fabc84eaff793d$var$z(a) === $33fabc84eaff793d$var$r;
};
$33fabc84eaff793d$export$d927fcb6adf8f9de = function(a) {
    return $33fabc84eaff793d$var$z(a) === $33fabc84eaff793d$var$d;
};
$33fabc84eaff793d$export$b82d16f27459e05a = function(a) {
    return $33fabc84eaff793d$var$z(a) === $33fabc84eaff793d$var$g;
};
$33fabc84eaff793d$export$522c17b4f5e123e8 = function(a) {
    return $33fabc84eaff793d$var$z(a) === $33fabc84eaff793d$var$f;
};
$33fabc84eaff793d$export$1aabd8a0274ecfd6 = function(a) {
    return $33fabc84eaff793d$var$z(a) === $33fabc84eaff793d$var$p;
};
$33fabc84eaff793d$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $33fabc84eaff793d$var$e || a === $33fabc84eaff793d$var$m || a === $33fabc84eaff793d$var$g || a === $33fabc84eaff793d$var$f || a === $33fabc84eaff793d$var$p || a === $33fabc84eaff793d$var$q || "object" === typeof a && null !== a && (a.$$typeof === $33fabc84eaff793d$var$t || a.$$typeof === $33fabc84eaff793d$var$r || a.$$typeof === $33fabc84eaff793d$var$h || a.$$typeof === $33fabc84eaff793d$var$k || a.$$typeof === $33fabc84eaff793d$var$n || a.$$typeof === $33fabc84eaff793d$var$w || a.$$typeof === $33fabc84eaff793d$var$x || a.$$typeof === $33fabc84eaff793d$var$y || a.$$typeof === $33fabc84eaff793d$var$v);
};
$33fabc84eaff793d$export$f5bbd400c2f4426f = $33fabc84eaff793d$var$z;

});

parcelRegister("k4hZ0", function(module, exports) {

$parcel$export(module.exports, "createRule", function () { return createRule; });
$parcel$export(module.exports, "toCssValue", function () { return toCssValue; });
$parcel$export(module.exports, "RuleList", function () { return RuleList; });
$parcel$export(module.exports, "create", function () { return createJss; });
$parcel$export(module.exports, "hasCSSTOMSupport", function () { return hasCSSTOMSupport; });
$parcel$export(module.exports, "getDynamicStyles", function () { return getDynamicStyles; });

var $k2R8s = parcelRequire("k2R8s");

var $b9Diu = parcelRequire("b9Diu");

var $l1ZSk = parcelRequire("l1ZSk");

var $lU1Um = parcelRequire("lU1Um");

var $Ku8r1 = parcelRequire("Ku8r1");

var $6o8oQ = parcelRequire("6o8oQ");

var $8hGk9 = parcelRequire("8hGk9");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== 'object') return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = 'unnamed';
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = '';
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === '!important') break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === '!important') break;
        if (cssValue) cssValue += ', ';
        cssValue += join(value[i], ' ');
    }
    else cssValue = join(value, ', '); // Add !important, because it was ignored.
    if (value[value.length - 1] === '!important') cssValue += ' !important';
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: '',
        space: ''
    };
    return {
        linebreak: '\n',
        space: ' '
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = '';
    for(var index = 0; index < indent; index++)result += '  ';
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = '';
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== 'fallbacks') {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = 'style';
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $Ku8r1.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $6o8oQ.default)((0, $6o8oQ.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== 'object') json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $k2R8s.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $lU1Um.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = 'conditional';
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $k2R8s.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = 'keyframes';
        this.at = '@keyframes';
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = 'noname';
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $k2R8s.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $k2R8s.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === 'string') return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style' || !sheet) return style;
        if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
        if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case 'animation':
                return findReferencedKeyframe(val, sheet.keyframes);
            case 'animation-name':
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $Ku8r1.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $k2R8s.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === 'keyframes') return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = 'font-face';
        this.at = '@font-face';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = '';
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = 'viewport';
        this.at = '@viewport';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = 'simple';
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = '';
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += '\n';
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    '@charset': true,
    '@import': true,
    '@namespace': true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $k2R8s.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $k2R8s.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = '';
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $k2R8s.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === 'object' ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: 'external'
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $8hGk9.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = '';
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $lU1Um.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = '';
        var prefix = '';
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return '';
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === 'string') {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute('content') : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ('insertRule' in container) container.insertRule(rule, index);
        else if ('appendRule' in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = '\n';
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute('data-jss', '');
        if (media) this.element.setAttribute('media', media);
        if (meta) this.element.setAttribute('data-meta', meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute('nonce', nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = '\n';
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === 'conditional' || rule.type === 'keyframes') {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $b9Diu.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: 'internal'
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $k2R8s.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ('Renderer' in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== 'number') index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $k2R8s.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === 'object') return this.createRule(undefined, name, style);
        var ruleOptions = (0, $k2R8s.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $l1ZSk.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $l1ZSk.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $lU1Um.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === 'function') {
            if (!to) to = {};
            to[key] = value;
        } else if (type === 'object' && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $e9c2216eeee1340a$export$2e2bcd8739ae039 = index;

});
parcelRegister("k2R8s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e97d362134fa57b8$export$2e2bcd8739ae039; });
function $e97d362134fa57b8$export$2e2bcd8739ae039() {
    return $e97d362134fa57b8$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e97d362134fa57b8$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("b9Diu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81ef048fe13f9728$export$2e2bcd8739ae039; });
var $81ef048fe13f9728$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $81ef048fe13f9728$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $81ef048fe13f9728$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $81ef048fe13f9728$var$_typeof(document)) === 'object' && document.nodeType === 9;
var $81ef048fe13f9728$export$2e2bcd8739ae039 = $81ef048fe13f9728$export$4e09c449d6c407f7;

});

parcelRegister("l1ZSk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4f9b01701245dfa$export$2e2bcd8739ae039; });
var $f4f9b01701245dfa$var$isProduction = true;
function $f4f9b01701245dfa$var$warning(condition, message) {
    if (!$f4f9b01701245dfa$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $f4f9b01701245dfa$export$2e2bcd8739ae039 = $f4f9b01701245dfa$var$warning;

});

parcelRegister("lU1Um", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff204ed3b2150eb1$export$2e2bcd8739ae039; });

var $3mYeD = parcelRequire("3mYeD");
function $ff204ed3b2150eb1$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $3mYeD.default)(o.key), o);
    }
}
function $ff204ed3b2150eb1$export$2e2bcd8739ae039(e, r, t) {
    return r && $ff204ed3b2150eb1$var$_defineProperties(e.prototype, r), t && $ff204ed3b2150eb1$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("3mYeD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $274226961e1566b9$export$2e2bcd8739ae039; });

var $8ZNRc = parcelRequire("8ZNRc");

var $fdh06 = parcelRequire("fdh06");
function $274226961e1566b9$export$2e2bcd8739ae039(t) {
    var i = (0, $fdh06.default)(t, "string");
    return "symbol" == (0, $8ZNRc.default)(i) ? i : i + "";
}

});
parcelRegister("8ZNRc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68cab1d0bf278cf6$export$2e2bcd8739ae039; });
function $68cab1d0bf278cf6$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $68cab1d0bf278cf6$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $68cab1d0bf278cf6$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fdh06", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b13541e5a88ec4dd$export$2e2bcd8739ae039; });

var $8ZNRc = parcelRequire("8ZNRc");
function $b13541e5a88ec4dd$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8ZNRc.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8ZNRc.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("Ku8r1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08bbac2f6708d378$export$2e2bcd8739ae039; });

var $dtYFN = parcelRequire("dtYFN");
function $08bbac2f6708d378$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $dtYFN.default)(t, o);
}

});
parcelRegister("dtYFN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d0d0c37df867b82$export$2e2bcd8739ae039; });
function $9d0d0c37df867b82$export$2e2bcd8739ae039(t, e) {
    return $9d0d0c37df867b82$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $9d0d0c37df867b82$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("6o8oQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a6b7ffb37dfa0f8$export$2e2bcd8739ae039; });
function $4a6b7ffb37dfa0f8$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("8hGk9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6080bdebdcd55ee7$export$2e2bcd8739ae039; });
function $6080bdebdcd55ee7$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("kKaK5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $ljC17.default;
    }
});

var $ljC17 = parcelRequire("ljC17");

});
parcelRegister("ljC17", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f848dcbd928553b6$export$2e2bcd8739ae039; });

var $k2R8s = parcelRequire("k2R8s");

var $gIfym = parcelRequire("gIfym");

var $8QfUv = parcelRequire("8QfUv");
function $f848dcbd928553b6$export$2e2bcd8739ae039(path, displayName) {
    var Component = function Component(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $8QfUv.default), (0, $k2R8s.default)({
            ref: ref
        }, props), path);
    };
    Component.muiName = (0, $8QfUv.default).muiName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).forwardRef(Component));
}

});
parcelRegister("8QfUv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01a94858db9e70ae$export$2e2bcd8739ae039; });

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");


var $82OGZ = parcelRequire("82OGZ");

var $kfLRg = parcelRequire("kfLRg");
var $01a94858db9e70ae$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: 'none',
            width: '1em',
            height: '1em',
            display: 'inline-block',
            fill: 'currentColor',
            flexShrink: 0,
            fontSize: theme.typography.pxToRem(24),
            transition: theme.transitions.create('fill', {
                duration: theme.transitions.duration.shorter
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: 'inherit'
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(35)
        }
    };
};
var $01a94858db9e70ae$var$SvgIcon = /*#__PURE__*/ $gIfym.forwardRef(function SvgIcon(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'inherit' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'svg' : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox, other = (0, $f6Qba.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "titleAccess",
        "viewBox"
    ]);
    return /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, $kfLRg.default)(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat((0, $kfLRg.default)(fontSize))]),
        focusable: "false",
        viewBox: viewBox,
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, other), children, titleAccess ? /*#__PURE__*/ $gIfym.createElement("title", null, titleAccess) : null);
});
$01a94858db9e70ae$var$SvgIcon.muiName = 'SvgIcon';
var $01a94858db9e70ae$export$2e2bcd8739ae039 = (0, $82OGZ.default)($01a94858db9e70ae$export$9dd6ff9ea0189349, {
    name: 'MuiSvgIcon'
})($01a94858db9e70ae$var$SvgIcon);

});
parcelRegister("f6Qba", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afffe439ef75a7d9$export$2e2bcd8739ae039; });

var $8hGk9 = parcelRequire("8hGk9");
function $afffe439ef75a7d9$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $8hGk9.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("ba4yE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $820429fdb0776530$export$2e2bcd8739ae039; });
function $820429fdb0776530$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $820429fdb0776530$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $820429fdb0776530$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $820429fdb0776530$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $820429fdb0776530$export$2e2bcd8739ae039 = $820429fdb0776530$export$4f5d2d50c9deca37;

});

parcelRegister("82OGZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5db5d5198336196e$export$2e2bcd8739ae039; });

var $k2R8s = parcelRequire("k2R8s");

var $fyPRy = parcelRequire("fyPRy");

var $7nQ0B = parcelRequire("7nQ0B");
function $5db5d5198336196e$var$withStyles(stylesOrCreator, options) {
    return (0, $fyPRy.default)(stylesOrCreator, (0, $k2R8s.default)({
        defaultTheme: (0, $7nQ0B.default)
    }, options));
}
var $5db5d5198336196e$export$2e2bcd8739ae039 = $5db5d5198336196e$var$withStyles;

});
parcelRegister("fyPRy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b54242d60be9f384$export$2e2bcd8739ae039; });

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $6vbYm = parcelRequire("6vbYm");


var $hQJVM = parcelRequire("hQJVM");

var $f1Esc = parcelRequire("f1Esc");

var $6VBRO = parcelRequire("6VBRO");
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $b54242d60be9f384$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $f6Qba.default)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var useStyles = (0, $hQJVM.default)(stylesOrCreator, (0, $k2R8s.default)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $f6Qba.default)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $k2R8s.default)({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === 'string' || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $6VBRO.default)() || defaultTheme;
                if (name) more = (0, $f1Esc.default)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(Component, (0, $k2R8s.default)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6vbYm)))(WithStyles, Component);
        return WithStyles;
    };
};
var $b54242d60be9f384$export$2e2bcd8739ae039 = $b54242d60be9f384$var$withStyles;

});
parcelRegister("6vbYm", function(module, exports) {
'use strict';

var $da4M9 = parcelRequire("da4M9");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $4bbeecd90a0b158c$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $4bbeecd90a0b158c$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $4bbeecd90a0b158c$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $4bbeecd90a0b158c$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $4bbeecd90a0b158c$var$TYPE_STATICS = {};
$4bbeecd90a0b158c$var$TYPE_STATICS[$da4M9.ForwardRef] = $4bbeecd90a0b158c$var$FORWARD_REF_STATICS;
$4bbeecd90a0b158c$var$TYPE_STATICS[$da4M9.Memo] = $4bbeecd90a0b158c$var$MEMO_STATICS;
function $4bbeecd90a0b158c$var$getStatics(component) {
    // React v16.11 and below
    if ($da4M9.isMemo(component)) return $4bbeecd90a0b158c$var$MEMO_STATICS;
     // React v16.12 and above
    return $4bbeecd90a0b158c$var$TYPE_STATICS[component['$$typeof']] || $4bbeecd90a0b158c$var$REACT_STATICS;
}
var $4bbeecd90a0b158c$var$defineProperty = Object.defineProperty;
var $4bbeecd90a0b158c$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $4bbeecd90a0b158c$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $4bbeecd90a0b158c$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $4bbeecd90a0b158c$var$getPrototypeOf = Object.getPrototypeOf;
var $4bbeecd90a0b158c$var$objectPrototype = Object.prototype;
function $4bbeecd90a0b158c$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($4bbeecd90a0b158c$var$objectPrototype) {
            var inheritedComponent = $4bbeecd90a0b158c$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $4bbeecd90a0b158c$var$objectPrototype) $4bbeecd90a0b158c$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $4bbeecd90a0b158c$var$getOwnPropertyNames(sourceComponent);
        if ($4bbeecd90a0b158c$var$getOwnPropertySymbols) keys = keys.concat($4bbeecd90a0b158c$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $4bbeecd90a0b158c$var$getStatics(targetComponent);
        var sourceStatics = $4bbeecd90a0b158c$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$4bbeecd90a0b158c$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $4bbeecd90a0b158c$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $4bbeecd90a0b158c$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $4bbeecd90a0b158c$var$hoistNonReactStatics;

});
parcelRegister("da4M9", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4sGuq"));

});


parcelRegister("hQJVM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfeaebf195fbaaff$export$2e2bcd8739ae039; });

var $f6Qba = parcelRequire("f6Qba");

var $k2R8s = parcelRequire("k2R8s");

var $gIfym = parcelRequire("gIfym");

var $k4hZ0 = parcelRequire("k4hZ0");

var $698pq = parcelRequire("698pq");

var $hZPI2 = parcelRequire("hZPI2");

var $6VBRO = parcelRequire("6VBRO");

var $63HoO = parcelRequire("63HoO");

var $lSDFw = parcelRequire("lSDFw");

var $bhvFL = parcelRequire("bhvFL");

var $7e26m = parcelRequire("7e26m");
function $cfeaebf195fbaaff$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $698pq.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $cfeaebf195fbaaff$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $hZPI2.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $hZPI2.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $k2R8s.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $hZPI2.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $k2R8s.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $hZPI2.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $k4hZ0.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $k2R8s.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $698pq.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $cfeaebf195fbaaff$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $cfeaebf195fbaaff$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $hZPI2.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $hZPI2.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $cfeaebf195fbaaff$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $cfeaebf195fbaaff$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $7e26m.default) : _options$defaultTheme, stylesOptions2 = (0, $f6Qba.default)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $bhvFL.default)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
    stylesCreator.options = {
        index: (0, $lSDFw.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $6VBRO.default)() || defaultTheme;
        var stylesOptions = (0, $k2R8s.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useContext((0, $63HoO.StylesContext)), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useRef();
        $cfeaebf195fbaaff$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $cfeaebf195fbaaff$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $cfeaebf195fbaaff$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useEffect(function() {
            if (shouldUpdate.current) $cfeaebf195fbaaff$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $cfeaebf195fbaaff$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

});
parcelRegister("698pq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $479a1b35dc0650b1$export$2e2bcd8739ae039; });

var $k2R8s = parcelRequire("k2R8s");

function $479a1b35dc0650b1$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $k2R8s.default)({}, baseClasses);
    Object.keys(newClasses).forEach(function(key) {
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}

});

parcelRegister("hZPI2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1a03e8dac5ff9af$export$2e2bcd8739ae039; });
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $d1a03e8dac5ff9af$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $d1a03e8dac5ff9af$export$2e2bcd8739ae039 = $d1a03e8dac5ff9af$var$multiKeyStore;

});

parcelRegister("6VBRO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50b570888aee275b$export$2e2bcd8739ae039; });

var $gIfym = parcelRequire("gIfym");

var $8htcl = parcelRequire("8htcl");
function $50b570888aee275b$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useContext((0, $8htcl.default));
    return theme;
}

});
parcelRegister("8htcl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60768f626470321f$export$2e2bcd8739ae039; });

var $gIfym = parcelRequire("gIfym");
var $60768f626470321f$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createContext(null);
var $60768f626470321f$export$2e2bcd8739ae039 = $60768f626470321f$var$ThemeContext;

});


parcelRegister("63HoO", function(module, exports) {

$parcel$export(module.exports, "StylesContext", function () { return $4694b01513704dde$export$f4de434b269fe487; });

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");



var $hSGsQ = parcelRequire("hSGsQ");

var $k4hZ0 = parcelRequire("k4hZ0");

var $lhNds = parcelRequire("lhNds");
var $4694b01513704dde$var$jss = (0, $k4hZ0.create)((0, $lhNds.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $4694b01513704dde$var$generateClassName = (0, $hSGsQ.default)(); // Exported for test purposes
var $4694b01513704dde$export$70a8aea9ff58d1cd = new Map();
var $4694b01513704dde$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $4694b01513704dde$var$generateClassName,
    jss: $4694b01513704dde$var$jss,
    sheetsCache: null,
    sheetsManager: $4694b01513704dde$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $4694b01513704dde$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createContext($4694b01513704dde$var$defaultOptions);
var $4694b01513704dde$var$injectFirstNode;
function $4694b01513704dde$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $f6Qba.default)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useContext($4694b01513704dde$export$f4de434b269fe487);
    var context = (0, $k2R8s.default)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
        if (!$4694b01513704dde$var$injectFirstNode) {
            var head = document.head;
            $4694b01513704dde$var$injectFirstNode = document.createComment('mui-inject-first');
            head.insertBefore($4694b01513704dde$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $k4hZ0.create)({
            plugins: (0, $lhNds.default)().plugins,
            insertionPoint: $4694b01513704dde$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($4694b01513704dde$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}

});
parcelRegister("hSGsQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0486b596e413e40$export$2e2bcd8739ae039; });

var $hpRbo = parcelRequire("hpRbo");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $d0486b596e413e40$var$pseudoClasses = [
    'checked',
    'disabled',
    'error',
    'focused',
    'focusVisible',
    'required',
    'expanded',
    'selected'
]; // Returns a function which generates unique class names based on counters.
function $d0486b596e413e40$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? '' : _options$seed;
    var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($d0486b596e413e40$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $hpRbo.default] || seed !== '') return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix;
        return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    };
}

});
parcelRegister("hpRbo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cade067380adfbaf$export$2e2bcd8739ae039; });
var $cade067380adfbaf$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $cade067380adfbaf$export$2e2bcd8739ae039 = $cade067380adfbaf$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("lhNds", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7f15cc7e198aba9$export$2e2bcd8739ae039; });

var $83PQB = parcelRequire("83PQB");

var $1Wbh8 = parcelRequire("1Wbh8");

var $8ydlK = parcelRequire("8ydlK");

var $9s8m8 = parcelRequire("9s8m8");

var $fk364 = parcelRequire("fk364");

var $jLHiW = parcelRequire("jLHiW");

var $2SN53 = parcelRequire("2SN53");
function $f7f15cc7e198aba9$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $83PQB.default)(),
            (0, $1Wbh8.default)(),
            (0, $8ydlK.default)(),
            (0, $9s8m8.default)(),
            (0, $fk364.default)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === 'undefined' ? null : (0, $jLHiW.default)(),
            (0, $2SN53.default)()
        ]
    };
}

});
parcelRegister("83PQB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5de6d25f449e0c66$export$2e2bcd8739ae039; });


var $k4hZ0 = parcelRequire("k4hZ0");
var $5de6d25f449e0c66$var$now = Date.now();
var $5de6d25f449e0c66$var$fnValuesNs = "fnValues" + $5de6d25f449e0c66$var$now;
var $5de6d25f449e0c66$var$fnRuleNs = "fnStyle" + ++$5de6d25f449e0c66$var$now;
var $5de6d25f449e0c66$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== 'function') return null;
            var rule = (0, $k4hZ0.createRule)(name, {}, options);
            rule[$5de6d25f449e0c66$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($5de6d25f449e0c66$var$fnValuesNs in rule || $5de6d25f449e0c66$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== 'function') continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$5de6d25f449e0c66$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$5de6d25f449e0c66$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$5de6d25f449e0c66$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $5de6d25f449e0c66$export$2e2bcd8739ae039 = $5de6d25f449e0c66$var$functionPlugin;

});

parcelRegister("1Wbh8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1693f44c25ca250d$export$2e2bcd8739ae039; });

var $k2R8s = parcelRequire("k2R8s");

var $k4hZ0 = parcelRequire("k4hZ0");
var $1693f44c25ca250d$var$at = '@global';
var $1693f44c25ca250d$var$atPrefix = '@global ';
var $1693f44c25ca250d$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = 'global';
        this.at = $1693f44c25ca250d$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $k4hZ0.RuleList)((0, $k2R8s.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $1693f44c25ca250d$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = 'global';
        this.at = $1693f44c25ca250d$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($1693f44c25ca250d$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $k2R8s.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : '';
    };
    return GlobalPrefixedRule;
}();
var $1693f44c25ca250d$var$separatorRegExp = /\s*,\s*/g;
function $1693f44c25ca250d$var$addScope(selector, scope) {
    var parts = selector.split($1693f44c25ca250d$var$separatorRegExp);
    var scoped = '';
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ', ';
    }
    return scoped;
}
function $1693f44c25ca250d$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$1693f44c25ca250d$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $k2R8s.default)({}, options, {
        selector: $1693f44c25ca250d$var$addScope(name, rule.selector)
    }));
    delete style[$1693f44c25ca250d$var$at];
}
function $1693f44c25ca250d$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== '@' || prop.substr(0, $1693f44c25ca250d$var$at.length) !== $1693f44c25ca250d$var$at) continue;
        var selector = $1693f44c25ca250d$var$addScope(prop.substr($1693f44c25ca250d$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $k2R8s.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $1693f44c25ca250d$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $1693f44c25ca250d$var$at) return new $1693f44c25ca250d$var$GlobalContainerRule(name, styles, options);
        if (name[0] === '@' && name.substr(0, $1693f44c25ca250d$var$atPrefix.length) === $1693f44c25ca250d$var$atPrefix) return new $1693f44c25ca250d$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== 'style' || !sheet) return;
        $1693f44c25ca250d$var$handleNestedGlobalContainerRule(rule, sheet);
        $1693f44c25ca250d$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $1693f44c25ca250d$export$2e2bcd8739ae039 = $1693f44c25ca250d$var$jssGlobal;

});

parcelRegister("8ydlK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $639bdaab645c217f$export$2e2bcd8739ae039; });

var $k2R8s = parcelRequire("k2R8s");

var $639bdaab645c217f$var$separatorRegExp = /\s*,\s*/g;
var $639bdaab645c217f$var$parentRegExp = /&/g;
var $639bdaab645c217f$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $639bdaab645c217f$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($639bdaab645c217f$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($639bdaab645c217f$var$separatorRegExp);
        var result = '';
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf('&') !== -1 ? nested.replace($639bdaab645c217f$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $k2R8s.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $k2R8s.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style') return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf('&') !== -1;
            var isNestedConditional = prop[0] === '@';
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($639bdaab645c217f$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ('replaceRule' in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $k2R8s.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $k2R8s.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $639bdaab645c217f$export$2e2bcd8739ae039 = $639bdaab645c217f$var$jssNested;

});

parcelRegister("9s8m8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e1d35e8da4e8f0a$export$2e2bcd8739ae039; });

var $imGat = parcelRequire("imGat");
/**
 * Convert camel cased property names to dash separated.
 */ function $6e1d35e8da4e8f0a$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf('--') === 0 ? prop : (0, $imGat.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($6e1d35e8da4e8f0a$var$convertCase);
        else converted.fallbacks = $6e1d35e8da4e8f0a$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $6e1d35e8da4e8f0a$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $6e1d35e8da4e8f0a$var$convertCase(style[index]);
            return style;
        }
        return $6e1d35e8da4e8f0a$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf('--') === 0) return value;
        var hyphenatedProp = (0, $imGat.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $6e1d35e8da4e8f0a$export$2e2bcd8739ae039 = $6e1d35e8da4e8f0a$var$camelCase;

});
parcelRegister("imGat", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5eafdbdafab7e38$export$2e2bcd8739ae039; });
/* eslint-disable no-var, prefer-template */ var $d5eafdbdafab7e38$var$uppercasePattern = /[A-Z]/g;
var $d5eafdbdafab7e38$var$msPattern = /^ms-/;
var $d5eafdbdafab7e38$var$cache = {};
function $d5eafdbdafab7e38$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $d5eafdbdafab7e38$var$hyphenateStyleName(name) {
    if ($d5eafdbdafab7e38$var$cache.hasOwnProperty(name)) return $d5eafdbdafab7e38$var$cache[name];
    var hName = name.replace($d5eafdbdafab7e38$var$uppercasePattern, $d5eafdbdafab7e38$var$toHyphenLower);
    return $d5eafdbdafab7e38$var$cache[name] = $d5eafdbdafab7e38$var$msPattern.test(hName) ? '-' + hName : hName;
}
var $d5eafdbdafab7e38$export$2e2bcd8739ae039 = $d5eafdbdafab7e38$var$hyphenateStyleName;

});


parcelRegister("fk364", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b27b2046e86670eb$export$2e2bcd8739ae039; });

var $k4hZ0 = parcelRequire("k4hZ0");
var $b27b2046e86670eb$var$px = (0, $k4hZ0.hasCSSTOMSupport) && CSS ? CSS.px : 'px';
var $b27b2046e86670eb$var$ms = (0, $k4hZ0.hasCSSTOMSupport) && CSS ? CSS.ms : 'ms';
var $b27b2046e86670eb$var$percent = (0, $k4hZ0.hasCSSTOMSupport) && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $b27b2046e86670eb$var$defaultUnits = {
    // Animation properties
    'animation-delay': $b27b2046e86670eb$var$ms,
    'animation-duration': $b27b2046e86670eb$var$ms,
    // Background properties
    'background-position': $b27b2046e86670eb$var$px,
    'background-position-x': $b27b2046e86670eb$var$px,
    'background-position-y': $b27b2046e86670eb$var$px,
    'background-size': $b27b2046e86670eb$var$px,
    // Border Properties
    border: $b27b2046e86670eb$var$px,
    'border-bottom': $b27b2046e86670eb$var$px,
    'border-bottom-left-radius': $b27b2046e86670eb$var$px,
    'border-bottom-right-radius': $b27b2046e86670eb$var$px,
    'border-bottom-width': $b27b2046e86670eb$var$px,
    'border-left': $b27b2046e86670eb$var$px,
    'border-left-width': $b27b2046e86670eb$var$px,
    'border-radius': $b27b2046e86670eb$var$px,
    'border-right': $b27b2046e86670eb$var$px,
    'border-right-width': $b27b2046e86670eb$var$px,
    'border-top': $b27b2046e86670eb$var$px,
    'border-top-left-radius': $b27b2046e86670eb$var$px,
    'border-top-right-radius': $b27b2046e86670eb$var$px,
    'border-top-width': $b27b2046e86670eb$var$px,
    'border-width': $b27b2046e86670eb$var$px,
    'border-block': $b27b2046e86670eb$var$px,
    'border-block-end': $b27b2046e86670eb$var$px,
    'border-block-end-width': $b27b2046e86670eb$var$px,
    'border-block-start': $b27b2046e86670eb$var$px,
    'border-block-start-width': $b27b2046e86670eb$var$px,
    'border-block-width': $b27b2046e86670eb$var$px,
    'border-inline': $b27b2046e86670eb$var$px,
    'border-inline-end': $b27b2046e86670eb$var$px,
    'border-inline-end-width': $b27b2046e86670eb$var$px,
    'border-inline-start': $b27b2046e86670eb$var$px,
    'border-inline-start-width': $b27b2046e86670eb$var$px,
    'border-inline-width': $b27b2046e86670eb$var$px,
    'border-start-start-radius': $b27b2046e86670eb$var$px,
    'border-start-end-radius': $b27b2046e86670eb$var$px,
    'border-end-start-radius': $b27b2046e86670eb$var$px,
    'border-end-end-radius': $b27b2046e86670eb$var$px,
    // Margin properties
    margin: $b27b2046e86670eb$var$px,
    'margin-bottom': $b27b2046e86670eb$var$px,
    'margin-left': $b27b2046e86670eb$var$px,
    'margin-right': $b27b2046e86670eb$var$px,
    'margin-top': $b27b2046e86670eb$var$px,
    'margin-block': $b27b2046e86670eb$var$px,
    'margin-block-end': $b27b2046e86670eb$var$px,
    'margin-block-start': $b27b2046e86670eb$var$px,
    'margin-inline': $b27b2046e86670eb$var$px,
    'margin-inline-end': $b27b2046e86670eb$var$px,
    'margin-inline-start': $b27b2046e86670eb$var$px,
    // Padding properties
    padding: $b27b2046e86670eb$var$px,
    'padding-bottom': $b27b2046e86670eb$var$px,
    'padding-left': $b27b2046e86670eb$var$px,
    'padding-right': $b27b2046e86670eb$var$px,
    'padding-top': $b27b2046e86670eb$var$px,
    'padding-block': $b27b2046e86670eb$var$px,
    'padding-block-end': $b27b2046e86670eb$var$px,
    'padding-block-start': $b27b2046e86670eb$var$px,
    'padding-inline': $b27b2046e86670eb$var$px,
    'padding-inline-end': $b27b2046e86670eb$var$px,
    'padding-inline-start': $b27b2046e86670eb$var$px,
    // Mask properties
    'mask-position-x': $b27b2046e86670eb$var$px,
    'mask-position-y': $b27b2046e86670eb$var$px,
    'mask-size': $b27b2046e86670eb$var$px,
    // Width and height properties
    height: $b27b2046e86670eb$var$px,
    width: $b27b2046e86670eb$var$px,
    'min-height': $b27b2046e86670eb$var$px,
    'max-height': $b27b2046e86670eb$var$px,
    'min-width': $b27b2046e86670eb$var$px,
    'max-width': $b27b2046e86670eb$var$px,
    // Position properties
    bottom: $b27b2046e86670eb$var$px,
    left: $b27b2046e86670eb$var$px,
    top: $b27b2046e86670eb$var$px,
    right: $b27b2046e86670eb$var$px,
    inset: $b27b2046e86670eb$var$px,
    'inset-block': $b27b2046e86670eb$var$px,
    'inset-block-end': $b27b2046e86670eb$var$px,
    'inset-block-start': $b27b2046e86670eb$var$px,
    'inset-inline': $b27b2046e86670eb$var$px,
    'inset-inline-end': $b27b2046e86670eb$var$px,
    'inset-inline-start': $b27b2046e86670eb$var$px,
    // Shadow properties
    'box-shadow': $b27b2046e86670eb$var$px,
    'text-shadow': $b27b2046e86670eb$var$px,
    // Column properties
    'column-gap': $b27b2046e86670eb$var$px,
    'column-rule': $b27b2046e86670eb$var$px,
    'column-rule-width': $b27b2046e86670eb$var$px,
    'column-width': $b27b2046e86670eb$var$px,
    // Font and text properties
    'font-size': $b27b2046e86670eb$var$px,
    'font-size-delta': $b27b2046e86670eb$var$px,
    'letter-spacing': $b27b2046e86670eb$var$px,
    'text-decoration-thickness': $b27b2046e86670eb$var$px,
    'text-indent': $b27b2046e86670eb$var$px,
    'text-stroke': $b27b2046e86670eb$var$px,
    'text-stroke-width': $b27b2046e86670eb$var$px,
    'word-spacing': $b27b2046e86670eb$var$px,
    // Motion properties
    motion: $b27b2046e86670eb$var$px,
    'motion-offset': $b27b2046e86670eb$var$px,
    // Outline properties
    outline: $b27b2046e86670eb$var$px,
    'outline-offset': $b27b2046e86670eb$var$px,
    'outline-width': $b27b2046e86670eb$var$px,
    // Perspective properties
    perspective: $b27b2046e86670eb$var$px,
    'perspective-origin-x': $b27b2046e86670eb$var$percent,
    'perspective-origin-y': $b27b2046e86670eb$var$percent,
    // Transform properties
    'transform-origin': $b27b2046e86670eb$var$percent,
    'transform-origin-x': $b27b2046e86670eb$var$percent,
    'transform-origin-y': $b27b2046e86670eb$var$percent,
    'transform-origin-z': $b27b2046e86670eb$var$percent,
    // Transition properties
    'transition-delay': $b27b2046e86670eb$var$ms,
    'transition-duration': $b27b2046e86670eb$var$ms,
    // Alignment properties
    'vertical-align': $b27b2046e86670eb$var$px,
    'flex-basis': $b27b2046e86670eb$var$px,
    // Some random properties
    'shape-margin': $b27b2046e86670eb$var$px,
    size: $b27b2046e86670eb$var$px,
    gap: $b27b2046e86670eb$var$px,
    // Grid properties
    grid: $b27b2046e86670eb$var$px,
    'grid-gap': $b27b2046e86670eb$var$px,
    'row-gap': $b27b2046e86670eb$var$px,
    'grid-row-gap': $b27b2046e86670eb$var$px,
    'grid-column-gap': $b27b2046e86670eb$var$px,
    'grid-template-rows': $b27b2046e86670eb$var$px,
    'grid-template-columns': $b27b2046e86670eb$var$px,
    'grid-auto-rows': $b27b2046e86670eb$var$px,
    'grid-auto-columns': $b27b2046e86670eb$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    'box-shadow-x': $b27b2046e86670eb$var$px,
    'box-shadow-y': $b27b2046e86670eb$var$px,
    'box-shadow-blur': $b27b2046e86670eb$var$px,
    'box-shadow-spread': $b27b2046e86670eb$var$px,
    'font-line-height': $b27b2046e86670eb$var$px,
    'text-shadow-x': $b27b2046e86670eb$var$px,
    'text-shadow-y': $b27b2046e86670eb$var$px,
    'text-shadow-blur': $b27b2046e86670eb$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $b27b2046e86670eb$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $b27b2046e86670eb$var$units = $b27b2046e86670eb$var$addCamelCasedVersion($b27b2046e86670eb$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $b27b2046e86670eb$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $b27b2046e86670eb$var$iterate(prop, value[i], options);
    else if (typeof value === 'object') {
        if (prop === 'fallbacks') for(var innerProp in value)value[innerProp] = $b27b2046e86670eb$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $b27b2046e86670eb$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === 'number' && isNaN(value) === false) {
        var unit = options[prop] || $b27b2046e86670eb$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $b27b2046e86670eb$var$px)) return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $b27b2046e86670eb$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $b27b2046e86670eb$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        for(var prop in style)style[prop] = $b27b2046e86670eb$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $b27b2046e86670eb$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $b27b2046e86670eb$export$2e2bcd8739ae039 = $b27b2046e86670eb$var$defaultUnit;

});

parcelRegister("jLHiW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e643ff77c666e54d$export$2e2bcd8739ae039; });

var $lotoM = parcelRequire("lotoM");

var $k4hZ0 = parcelRequire("k4hZ0");
/**
 * Add vendor prefix to a property name when needed.
 */ function $e643ff77c666e54d$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === 'keyframes') {
            var atRule = rule;
            atRule.at = (0, $lotoM.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === 'fallbacks' && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $lotoM.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $lotoM.supportedValue)(supportedProp, (0, $k4hZ0.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $lotoM.supportedValue)(prop, (0, $k4hZ0.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $e643ff77c666e54d$export$2e2bcd8739ae039 = $e643ff77c666e54d$var$jssVendorPrefixer;

});
parcelRegister("lotoM", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", function () { return $f932a4d5c81d5a03$export$b6aa0648d950180a; });
$parcel$export(module.exports, "supportedProperty", function () { return $f932a4d5c81d5a03$export$ce097f82c2e4551a; });
$parcel$export(module.exports, "supportedValue", function () { return $f932a4d5c81d5a03$export$511766124059c277; });

var $b9Diu = parcelRequire("b9Diu");

var $9unC2 = parcelRequire("9unC2");
// Export javascript style and css style vendor prefixes.
var $f932a4d5c81d5a03$var$js = '';
var $f932a4d5c81d5a03$var$css = '';
var $f932a4d5c81d5a03$var$vendor = '';
var $f932a4d5c81d5a03$var$browser = '';
var $f932a4d5c81d5a03$var$isTouch = (0, $b9Diu.default) && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
if (0, $b9Diu.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $f932a4d5c81d5a03$var$jsCssMap = {
        Moz: '-moz-',
        ms: '-ms-',
        O: '-o-',
        Webkit: '-webkit-'
    };
    var $f932a4d5c81d5a03$var$_document$createEleme = document.createElement('p'), $f932a4d5c81d5a03$var$style = $f932a4d5c81d5a03$var$_document$createEleme.style;
    var $f932a4d5c81d5a03$var$testProp = 'Transform';
    for(var $f932a4d5c81d5a03$var$key in $f932a4d5c81d5a03$var$jsCssMap)if ($f932a4d5c81d5a03$var$key + $f932a4d5c81d5a03$var$testProp in $f932a4d5c81d5a03$var$style) {
        $f932a4d5c81d5a03$var$js = $f932a4d5c81d5a03$var$key;
        $f932a4d5c81d5a03$var$css = $f932a4d5c81d5a03$var$jsCssMap[$f932a4d5c81d5a03$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($f932a4d5c81d5a03$var$js === 'Webkit' && 'msHyphens' in $f932a4d5c81d5a03$var$style) {
        $f932a4d5c81d5a03$var$js = 'ms';
        $f932a4d5c81d5a03$var$css = $f932a4d5c81d5a03$var$jsCssMap.ms;
        $f932a4d5c81d5a03$var$browser = 'edge';
    } // Correctly detect the Safari browser.
    if ($f932a4d5c81d5a03$var$js === 'Webkit' && '-apple-trailing-word' in $f932a4d5c81d5a03$var$style) $f932a4d5c81d5a03$var$vendor = 'apple';
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $f932a4d5c81d5a03$export$82e9f45cca5ba907 = {
    js: $f932a4d5c81d5a03$var$js,
    css: $f932a4d5c81d5a03$var$css,
    vendor: $f932a4d5c81d5a03$var$vendor,
    browser: $f932a4d5c81d5a03$var$browser,
    isTouch: $f932a4d5c81d5a03$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $f932a4d5c81d5a03$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($f932a4d5c81d5a03$export$82e9f45cca5ba907.js === 'ms') return key;
    return "@" + $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $f932a4d5c81d5a03$var$appearence = {
    noPrefill: [
        'appearance'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'appearance') return false;
        if ($f932a4d5c81d5a03$export$82e9f45cca5ba907.js === 'ms') return "-webkit-" + prop;
        return $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $f932a4d5c81d5a03$var$colorAdjust = {
    noPrefill: [
        'color-adjust'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'color-adjust') return false;
        if ($f932a4d5c81d5a03$export$82e9f45cca5ba907.js === 'Webkit') return $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $f932a4d5c81d5a03$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $f932a4d5c81d5a03$var$toUpper(match, c) {
    return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $f932a4d5c81d5a03$var$camelize(str) {
    return str.replace($f932a4d5c81d5a03$var$regExp, $f932a4d5c81d5a03$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $f932a4d5c81d5a03$var$pascalize(str) {
    return $f932a4d5c81d5a03$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $f932a4d5c81d5a03$var$mask = {
    noPrefill: [
        'mask'
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($f932a4d5c81d5a03$export$82e9f45cca5ba907.js === 'Webkit') {
            var longhand = 'mask-image';
            if ($f932a4d5c81d5a03$var$camelize(longhand) in style) return prop;
            if ($f932a4d5c81d5a03$export$82e9f45cca5ba907.js + $f932a4d5c81d5a03$var$pascalize(longhand) in style) return $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $f932a4d5c81d5a03$var$textOrientation = {
    noPrefill: [
        'text-orientation'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'text-orientation') return false;
        if ($f932a4d5c81d5a03$export$82e9f45cca5ba907.vendor === 'apple' && !$f932a4d5c81d5a03$export$82e9f45cca5ba907.isTouch) return $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $f932a4d5c81d5a03$var$transform = {
    noPrefill: [
        'transform'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transform') return false;
        if (options.transform) return prop;
        return $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $f932a4d5c81d5a03$var$transition = {
    noPrefill: [
        'transition'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transition') return false;
        if (options.transition) return prop;
        return $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $f932a4d5c81d5a03$var$writingMode = {
    noPrefill: [
        'writing-mode'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'writing-mode') return false;
        if ($f932a4d5c81d5a03$export$82e9f45cca5ba907.js === 'Webkit' || $f932a4d5c81d5a03$export$82e9f45cca5ba907.js === 'ms' && $f932a4d5c81d5a03$export$82e9f45cca5ba907.browser !== 'edge') return $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $f932a4d5c81d5a03$var$userSelect = {
    noPrefill: [
        'user-select'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'user-select') return false;
        if ($f932a4d5c81d5a03$export$82e9f45cca5ba907.js === 'Moz' || $f932a4d5c81d5a03$export$82e9f45cca5ba907.js === 'ms' || $f932a4d5c81d5a03$export$82e9f45cca5ba907.vendor === 'apple') return $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $f932a4d5c81d5a03$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($f932a4d5c81d5a03$export$82e9f45cca5ba907.js === 'Webkit') {
            var jsProp = "WebkitColumn" + $f932a4d5c81d5a03$var$pascalize(prop);
            return jsProp in style ? $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($f932a4d5c81d5a03$export$82e9f45cca5ba907.js === 'Moz') {
            var _jsProp = "page" + $f932a4d5c81d5a03$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $f932a4d5c81d5a03$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($f932a4d5c81d5a03$export$82e9f45cca5ba907.js === 'Moz') return prop;
        var newProp = prop.replace('-inline', '');
        return $f932a4d5c81d5a03$export$82e9f45cca5ba907.js + $f932a4d5c81d5a03$var$pascalize(newProp) in style ? $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $f932a4d5c81d5a03$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $f932a4d5c81d5a03$var$camelize(prop) in style ? prop : false;
    }
};
var $f932a4d5c81d5a03$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $f932a4d5c81d5a03$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
        if (prop[0] === '-' && prop[1] === '-') return prop;
        if ($f932a4d5c81d5a03$export$82e9f45cca5ba907.js + pascalized in style) return $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($f932a4d5c81d5a03$export$82e9f45cca5ba907.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $f932a4d5c81d5a03$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== 'scroll-snap') return false;
        if ($f932a4d5c81d5a03$export$82e9f45cca5ba907.js === 'ms') return "" + $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $f932a4d5c81d5a03$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'overscroll-behavior') return false;
        if ($f932a4d5c81d5a03$export$82e9f45cca5ba907.js === 'ms') return $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $f932a4d5c81d5a03$var$propMap = {
    'flex-grow': 'flex-positive',
    'flex-shrink': 'flex-negative',
    'flex-basis': 'flex-preferred-size',
    'justify-content': 'flex-pack',
    order: 'flex-order',
    'align-items': 'flex-align',
    'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $f932a4d5c81d5a03$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $f932a4d5c81d5a03$var$propMap[prop];
        if (!newProp) return false;
        return $f932a4d5c81d5a03$export$82e9f45cca5ba907.js + $f932a4d5c81d5a03$var$pascalize(newProp) in style ? $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $f932a4d5c81d5a03$var$propMap$1 = {
    flex: 'box-flex',
    'flex-grow': 'box-flex',
    'flex-direction': [
        'box-orient',
        'box-direction'
    ],
    order: 'box-ordinal-group',
    'align-items': 'box-align',
    'flex-flow': [
        'box-orient',
        'box-direction'
    ],
    'justify-content': 'box-pack'
};
var $f932a4d5c81d5a03$var$propKeys = Object.keys($f932a4d5c81d5a03$var$propMap$1);
var $f932a4d5c81d5a03$var$prefixCss = function prefixCss(p) {
    return $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $f932a4d5c81d5a03$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($f932a4d5c81d5a03$var$propKeys.indexOf(prop) > -1) {
            var newProp = $f932a4d5c81d5a03$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $f932a4d5c81d5a03$export$82e9f45cca5ba907.js + $f932a4d5c81d5a03$var$pascalize(newProp) in style ? $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($f932a4d5c81d5a03$export$82e9f45cca5ba907.js + $f932a4d5c81d5a03$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($f932a4d5c81d5a03$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $f932a4d5c81d5a03$var$plugins = [
    $f932a4d5c81d5a03$var$appearence,
    $f932a4d5c81d5a03$var$colorAdjust,
    $f932a4d5c81d5a03$var$mask,
    $f932a4d5c81d5a03$var$textOrientation,
    $f932a4d5c81d5a03$var$transform,
    $f932a4d5c81d5a03$var$transition,
    $f932a4d5c81d5a03$var$writingMode,
    $f932a4d5c81d5a03$var$userSelect,
    $f932a4d5c81d5a03$var$breakPropsOld,
    $f932a4d5c81d5a03$var$inlineLogicalOld,
    $f932a4d5c81d5a03$var$unprefixed,
    $f932a4d5c81d5a03$var$prefixed,
    $f932a4d5c81d5a03$var$scrollSnap,
    $f932a4d5c81d5a03$var$overscrollBehavior,
    $f932a4d5c81d5a03$var$flex2012,
    $f932a4d5c81d5a03$var$flex2009
];
var $f932a4d5c81d5a03$var$propertyDetectors = $f932a4d5c81d5a03$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $f932a4d5c81d5a03$var$noPrefill = $f932a4d5c81d5a03$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $9unC2.default)(p.noPrefill));
    return a;
}, []);
var $f932a4d5c81d5a03$var$el;
var $f932a4d5c81d5a03$var$cache = {};
if (0, $b9Diu.default) {
    $f932a4d5c81d5a03$var$el = document.createElement('p'); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $f932a4d5c81d5a03$var$computed = window.getComputedStyle(document.documentElement, '');
    for(var $f932a4d5c81d5a03$var$key$1 in $f932a4d5c81d5a03$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($f932a4d5c81d5a03$var$key$1)) $f932a4d5c81d5a03$var$cache[$f932a4d5c81d5a03$var$computed[$f932a4d5c81d5a03$var$key$1]] = $f932a4d5c81d5a03$var$computed[$f932a4d5c81d5a03$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $f932a4d5c81d5a03$var$noPrefill.forEach(function(x) {
        return delete $f932a4d5c81d5a03$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $f932a4d5c81d5a03$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$f932a4d5c81d5a03$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($f932a4d5c81d5a03$var$cache[prop] != null) return $f932a4d5c81d5a03$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === 'transition' || prop === 'transform') options[prop] = prop in $f932a4d5c81d5a03$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $f932a4d5c81d5a03$var$propertyDetectors.length; i++){
        $f932a4d5c81d5a03$var$cache[prop] = $f932a4d5c81d5a03$var$propertyDetectors[i](prop, $f932a4d5c81d5a03$var$el.style, options); // Break loop, if value found.
        if ($f932a4d5c81d5a03$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $f932a4d5c81d5a03$var$el.style[prop] = '';
    } catch (err) {
        return false;
    }
    return $f932a4d5c81d5a03$var$cache[prop];
}
var $f932a4d5c81d5a03$var$cache$1 = {};
var $f932a4d5c81d5a03$var$transitionProperties = {
    transition: 1,
    'transition-property': 1,
    '-webkit-transition': 1,
    '-webkit-transition-property': 1
};
var $f932a4d5c81d5a03$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $f932a4d5c81d5a03$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $f932a4d5c81d5a03$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === 'var') return 'var';
    if (p1 === 'all') return 'all';
    if (p2 === 'all') return ', all';
    var prefixedValue = p1 ? $f932a4d5c81d5a03$export$ce097f82c2e4551a(p1) : ", " + $f932a4d5c81d5a03$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $b9Diu.default) $f932a4d5c81d5a03$var$el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $f932a4d5c81d5a03$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$f932a4d5c81d5a03$var$el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($f932a4d5c81d5a03$var$cache$1[cacheKey] != null) return $f932a4d5c81d5a03$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $f932a4d5c81d5a03$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $f932a4d5c81d5a03$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($f932a4d5c81d5a03$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($f932a4d5c81d5a03$var$transPropsRegExp, $f932a4d5c81d5a03$var$prefixTransitionCallback);
    else if ($f932a4d5c81d5a03$var$el$1.style[property] === '') {
        // Value with a vendor prefix.
        prefixedValue = $f932a4d5c81d5a03$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === '-ms-flex') $f932a4d5c81d5a03$var$el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
        $f932a4d5c81d5a03$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($f932a4d5c81d5a03$var$el$1.style[property] === '') {
            $f932a4d5c81d5a03$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $f932a4d5c81d5a03$var$el$1.style[property] = ''; // Write current value to cache.
    $f932a4d5c81d5a03$var$cache$1[cacheKey] = prefixedValue;
    return $f932a4d5c81d5a03$var$cache$1[cacheKey];
}

});
parcelRegister("9unC2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e893b60175ac257$export$2e2bcd8739ae039; });

var $eFrWP = parcelRequire("eFrWP");

var $9Vqi3 = parcelRequire("9Vqi3");

var $biFy3 = parcelRequire("biFy3");

var $6WB5e = parcelRequire("6WB5e");
function $6e893b60175ac257$export$2e2bcd8739ae039(r) {
    return (0, $eFrWP.default)(r) || (0, $9Vqi3.default)(r) || (0, $biFy3.default)(r) || (0, $6WB5e.default)();
}

});
parcelRegister("eFrWP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aada92ddabbc5f6f$export$2e2bcd8739ae039; });

var $4rfJf = parcelRequire("4rfJf");
function $aada92ddabbc5f6f$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $4rfJf.default)(r);
}

});
parcelRegister("4rfJf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33b5e26e8768d07a$export$2e2bcd8739ae039; });
function $33b5e26e8768d07a$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("9Vqi3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $739dd4a0018a6e6b$export$2e2bcd8739ae039; });
function $739dd4a0018a6e6b$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("biFy3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83a19ac171244ba6$export$2e2bcd8739ae039; });

var $4rfJf = parcelRequire("4rfJf");
function $83a19ac171244ba6$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $4rfJf.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $4rfJf.default)(r, a) : void 0;
    }
}

});

parcelRegister("6WB5e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50e4ecdc3989e5dd$export$2e2bcd8739ae039; });
function $50e4ecdc3989e5dd$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("2SN53", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2196b248a4f56fc4$export$2e2bcd8739ae039; });
/**
 * Sort props by length.
 */ function $2196b248a4f56fc4$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $2196b248a4f56fc4$export$2e2bcd8739ae039 = $2196b248a4f56fc4$var$jssPropsSort;

});



parcelRegister("lSDFw", function(module, exports) {

$parcel$export(module.exports, "increment", function () { return $fedd697d8c340a43$export$a2647aa13413c947; });
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $fedd697d8c340a43$var$indexCounter = -1000000000;
function $fedd697d8c340a43$export$a2647aa13413c947() {
    $fedd697d8c340a43$var$indexCounter += 1;
    return $fedd697d8c340a43$var$indexCounter;
}

});

parcelRegister("bhvFL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8369d9c6bdb18d23$export$2e2bcd8739ae039; });

var $k2R8s = parcelRequire("k2R8s");
parcelRequire("8ZNRc");

var $14Uvj = parcelRequire("14Uvj");

function $8369d9c6bdb18d23$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === 'function';
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $k2R8s.default)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                stylesWithOverrides[key] = (0, $14Uvj.default)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRegister("14Uvj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c91feb3fe5d4a9d$export$2e2bcd8739ae039; });

var $k2R8s = parcelRequire("k2R8s");

var $8ZNRc = parcelRequire("8ZNRc");
function $0c91feb3fe5d4a9d$export$53b83ca8eaab0383(item) {
    return item && (0, $8ZNRc.default)(item) === 'object' && item.constructor === Object;
}
function $0c91feb3fe5d4a9d$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $k2R8s.default)({}, target) : target;
    if ($0c91feb3fe5d4a9d$export$53b83ca8eaab0383(target) && $0c91feb3fe5d4a9d$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === '__proto__') return;
        if ($0c91feb3fe5d4a9d$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $0c91feb3fe5d4a9d$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});


parcelRegister("7e26m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $542b7890062497ae$export$2e2bcd8739ae039; });
// We use the same empty object to ref count the styles that don't need a theme object.
var $542b7890062497ae$var$noopTheme = {};
var $542b7890062497ae$export$2e2bcd8739ae039 = $542b7890062497ae$var$noopTheme;

});


parcelRegister("f1Esc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af06544ee8f97f85$export$2e2bcd8739ae039; });
/* eslint-disable no-restricted-syntax */ function $af06544ee8f97f85$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}

});


parcelRegister("7nQ0B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5603063f173bf6d9$export$2e2bcd8739ae039; });

var $aWYXl = parcelRequire("aWYXl");
var $5603063f173bf6d9$var$defaultTheme = (0, $aWYXl.default)();
var $5603063f173bf6d9$export$2e2bcd8739ae039 = $5603063f173bf6d9$var$defaultTheme;

});
parcelRegister("aWYXl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f8e9ac4a85cd880$export$2e2bcd8739ae039; });
parcelRequire("8k2Uc");

var $f6Qba = parcelRequire("f6Qba");

var $14Uvj = parcelRequire("14Uvj");

var $gvzGU = parcelRequire("gvzGU");

var $b4OZi = parcelRequire("b4OZi");

var $2LhJH = parcelRequire("2LhJH");

var $dFFjy = parcelRequire("dFFjy");

var $kpJi8 = parcelRequire("kpJi8");

var $irC6C = parcelRequire("irC6C");

var $bghsb = parcelRequire("bghsb");

var $dJPr8 = parcelRequire("dJPr8");

var $3hBRr = parcelRequire("3hBRr");
function $7f8e9ac4a85cd880$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $f6Qba.default)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $2LhJH.default)(paletteInput);
    var breakpoints = (0, $gvzGU.default)(breakpointsInput);
    var spacing = (0, $bghsb.default)(spacingInput);
    var muiTheme = (0, $14Uvj.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        mixins: (0, $b4OZi.default)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $kpJi8.default),
        typography: (0, $dFFjy.default)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $irC6C.default),
        transitions: (0, $dJPr8.default),
        zIndex: (0, $3hBRr.default)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $14Uvj.default)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $7f8e9ac4a85cd880$var$warnedOnce = false;
function $7f8e9ac4a85cd880$export$c469355549431d9b() {
    return $7f8e9ac4a85cd880$var$createTheme.apply(void 0, arguments);
}
var $7f8e9ac4a85cd880$export$2e2bcd8739ae039 = $7f8e9ac4a85cd880$var$createTheme;

});
parcelRegister("8k2Uc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60f271ecc98b033c$export$2e2bcd8739ae039; });

var $3mYeD = parcelRequire("3mYeD");
function $60f271ecc98b033c$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3mYeD.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("gvzGU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c04b3a1c00cfd6f4$export$2e2bcd8739ae039; });

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");
var $c04b3a1c00cfd6f4$export$ed97f33186d4b816 = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
]; // Keep in mind that @media is inclusive by the CSS specification.
function $c04b3a1c00cfd6f4$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $f6Qba.default)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === 'number' ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $c04b3a1c00cfd6f4$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$c04b3a1c00cfd6f4$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $c04b3a1c00cfd6f4$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up('xs');
        var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $c04b3a1c00cfd6f4$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $c04b3a1c00cfd6f4$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$c04b3a1c00cfd6f4$export$ed97f33186d4b816[endIndex + 1]] === 'number' ? values[$c04b3a1c00cfd6f4$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        return values[key];
    }
    return (0, $k2R8s.default)({
        keys: $c04b3a1c00cfd6f4$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}

});

parcelRegister("b4OZi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81079e8061dae629$export$2e2bcd8739ae039; });

var $8k2Uc = parcelRequire("8k2Uc");

var $k2R8s = parcelRequire("k2R8s");
function $81079e8061dae629$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $k2R8s.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                'Material-UI: theme.mixins.gutters() is deprecated.',
                'You can use the source of the mixin directly:',
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join('\n'));
            return (0, $k2R8s.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $8k2Uc.default)({}, breakpoints.up('sm'), (0, $k2R8s.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up('sm')])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $8k2Uc.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $8k2Uc.default)(_toolbar, breakpoints.up('sm'), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}

});

parcelRegister("2LhJH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $202dba8d55d34095$export$2e2bcd8739ae039; });

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $14Uvj = parcelRequire("14Uvj");
var $gzSPO = parcelRequire("gzSPO");

var $6qzaL = parcelRequire("6qzaL");

var $81RUX = parcelRequire("81RUX");

var $7RRhm = parcelRequire("7RRhm");

var $80D7b = parcelRequire("80D7b");

var $eIqoH = parcelRequire("eIqoH");

var $7RALO = parcelRequire("7RALO");

var $7fPrT = parcelRequire("7fPrT");

var $98bES = parcelRequire("98bES");

var $aUprr = parcelRequire("aUprr");
var $202dba8d55d34095$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.54)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)',
        // Text hints.
        hint: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $6qzaL.default).white,
        default: (0, $81RUX.default)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $202dba8d55d34095$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $6qzaL.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        hint: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: (0, $81RUX.default)[800],
        default: '#303030'
    },
    action: {
        active: (0, $6qzaL.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $202dba8d55d34095$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $aUprr.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $aUprr.darken)(intent.main, tonalOffsetDark);
    }
}
function $202dba8d55d34095$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $7RRhm.default)[300],
        main: (0, $7RRhm.default)[500],
        dark: (0, $7RRhm.default)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $80D7b.default).A200,
        main: (0, $80D7b.default).A400,
        dark: (0, $80D7b.default).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $eIqoH.default)[300],
        main: (0, $eIqoH.default)[500],
        dark: (0, $eIqoH.default)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $7RALO.default)[300],
        main: (0, $7RALO.default)[500],
        dark: (0, $7RALO.default)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $7fPrT.default)[300],
        main: (0, $7fPrT.default)[500],
        dark: (0, $7fPrT.default)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $98bES.default)[300],
        main: (0, $98bES.default)[500],
        dark: (0, $98bES.default)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? 'light' : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $f6Qba.default)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $aUprr.getContrastRatio)(background, $202dba8d55d34095$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $202dba8d55d34095$export$55ce6f3a06c59543.text.primary : $202dba8d55d34095$export$a43af521ac8c3202.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $k2R8s.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $gzSPO.default)(4, mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $gzSPO.default)(5, JSON.stringify(color.main)));
        $202dba8d55d34095$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $202dba8d55d34095$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $202dba8d55d34095$export$55ce6f3a06c59543,
        light: $202dba8d55d34095$export$a43af521ac8c3202
    };
    var paletteOutput = (0, $14Uvj.default)((0, $k2R8s.default)({
        // A collection of common colors.
        common: (0, $6qzaL.default),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $81RUX.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}

});
parcelRegister("gzSPO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c11a73428f1ab16e$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $c11a73428f1ab16e$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ var url = 'https://mui.com/production-error/?code=' + code;
    for(var i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});

parcelRegister("6qzaL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ae07454c331ec7f$export$2e2bcd8739ae039; });
var $4ae07454c331ec7f$var$common = {
    black: '#000',
    white: '#fff'
};
var $4ae07454c331ec7f$export$2e2bcd8739ae039 = $4ae07454c331ec7f$var$common;

});

parcelRegister("81RUX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d883da8905a2214$export$2e2bcd8739ae039; });
var $5d883da8905a2214$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161'
};
var $5d883da8905a2214$export$2e2bcd8739ae039 = $5d883da8905a2214$var$grey;

});

parcelRegister("7RRhm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ba6cfb8782fdf2c$export$2e2bcd8739ae039; });
var $5ba6cfb8782fdf2c$var$indigo = {
    50: '#e8eaf6',
    100: '#c5cae9',
    200: '#9fa8da',
    300: '#7986cb',
    400: '#5c6bc0',
    500: '#3f51b5',
    600: '#3949ab',
    700: '#303f9f',
    800: '#283593',
    900: '#1a237e',
    A100: '#8c9eff',
    A200: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe'
};
var $5ba6cfb8782fdf2c$export$2e2bcd8739ae039 = $5ba6cfb8782fdf2c$var$indigo;

});

parcelRegister("80D7b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d4caa321ec246d6$export$2e2bcd8739ae039; });
var $5d4caa321ec246d6$var$pink = {
    50: '#fce4ec',
    100: '#f8bbd0',
    200: '#f48fb1',
    300: '#f06292',
    400: '#ec407a',
    500: '#e91e63',
    600: '#d81b60',
    700: '#c2185b',
    800: '#ad1457',
    900: '#880e4f',
    A100: '#ff80ab',
    A200: '#ff4081',
    A400: '#f50057',
    A700: '#c51162'
};
var $5d4caa321ec246d6$export$2e2bcd8739ae039 = $5d4caa321ec246d6$var$pink;

});

parcelRegister("eIqoH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab69a6bd6f497754$export$2e2bcd8739ae039; });
var $ab69a6bd6f497754$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $ab69a6bd6f497754$export$2e2bcd8739ae039 = $ab69a6bd6f497754$var$red;

});

parcelRegister("7RALO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b9a017093962f59$export$2e2bcd8739ae039; });
var $5b9a017093962f59$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $5b9a017093962f59$export$2e2bcd8739ae039 = $5b9a017093962f59$var$orange;

});

parcelRegister("7fPrT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5481d7cfd80b06bd$export$2e2bcd8739ae039; });
var $5481d7cfd80b06bd$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $5481d7cfd80b06bd$export$2e2bcd8739ae039 = $5481d7cfd80b06bd$var$blue;

});

parcelRegister("98bES", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a5de77fc88a233d$export$2e2bcd8739ae039; });
var $6a5de77fc88a233d$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $6a5de77fc88a233d$export$2e2bcd8739ae039 = $6a5de77fc88a233d$var$green;

});

parcelRegister("aUprr", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $7f12de80e7a2d343$export$d061e26956a60b0a; });
$parcel$export(module.exports, "emphasize", function () { return $7f12de80e7a2d343$export$e665714f76e581fd; });
$parcel$export(module.exports, "darken", function () { return $7f12de80e7a2d343$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $7f12de80e7a2d343$export$c0816ed86df316af; });
$parcel$export(module.exports, "fade", function () { return $7f12de80e7a2d343$export$cbea29d068a2e18f; });
$parcel$export(module.exports, "alpha", function () { return $7f12de80e7a2d343$export$58f0f39f63f3cf42; });

var $gzSPO = parcelRequire("gzSPO");
/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $7f12de80e7a2d343$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
function $7f12de80e7a2d343$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', '), ")") : '';
}
function $7f12de80e7a2d343$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $7f12de80e7a2d343$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    var _decomposeColor = $7f12de80e7a2d343$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $7f12de80e7a2d343$var$intToHex(n);
    }).join(''));
}
function $7f12de80e7a2d343$export$29fb7152bd3f781a(color) {
    color = $7f12de80e7a2d343$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = 'rgb';
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $7f12de80e7a2d343$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $7f12de80e7a2d343$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $7f12de80e7a2d343$export$677b39864803984e($7f12de80e7a2d343$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf('(');
    var type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla'
    ].indexOf(type) === -1) throw new Error((0, $gzSPO.default)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(',');
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $7f12de80e7a2d343$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf('hsl') !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(', '), ")");
}
function $7f12de80e7a2d343$export$d061e26956a60b0a(foreground, background) {
    var lumA = $7f12de80e7a2d343$export$c852d90bf7403b62(foreground);
    var lumB = $7f12de80e7a2d343$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $7f12de80e7a2d343$export$c852d90bf7403b62(color) {
    color = $7f12de80e7a2d343$export$677b39864803984e(color);
    var rgb = color.type === 'hsl' ? $7f12de80e7a2d343$export$677b39864803984e($7f12de80e7a2d343$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $7f12de80e7a2d343$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $7f12de80e7a2d343$export$c852d90bf7403b62(color) > 0.5 ? $7f12de80e7a2d343$export$4b073707ff63303(color, coefficient) : $7f12de80e7a2d343$export$c0816ed86df316af(color, coefficient);
}
var $7f12de80e7a2d343$var$warnedOnce = false;
function $7f12de80e7a2d343$export$cbea29d068a2e18f(color, value) {
    return $7f12de80e7a2d343$export$58f0f39f63f3cf42(color, value);
}
function $7f12de80e7a2d343$export$58f0f39f63f3cf42(color, value) {
    color = $7f12de80e7a2d343$export$677b39864803984e(color);
    value = $7f12de80e7a2d343$var$clamp(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    color.values[3] = value;
    return $7f12de80e7a2d343$export$211a73f2b8c10ce4(color);
}
function $7f12de80e7a2d343$export$4b073707ff63303(color, coefficient) {
    color = $7f12de80e7a2d343$export$677b39864803984e(color);
    coefficient = $7f12de80e7a2d343$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $7f12de80e7a2d343$export$211a73f2b8c10ce4(color);
}
function $7f12de80e7a2d343$export$c0816ed86df316af(color, coefficient) {
    color = $7f12de80e7a2d343$export$677b39864803984e(color);
    coefficient = $7f12de80e7a2d343$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $7f12de80e7a2d343$export$211a73f2b8c10ce4(color);
}

});


parcelRegister("dFFjy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f3f26e1ca2ad948$export$2e2bcd8739ae039; });

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $14Uvj = parcelRequire("14Uvj");
function $9f3f26e1ca2ad948$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $9f3f26e1ca2ad948$var$warnedOnce = false;
function $9f3f26e1ca2ad948$var$roundWithDeprecationWarning(value) {
    return $9f3f26e1ca2ad948$var$round(value);
}
var $9f3f26e1ca2ad948$var$caseAllCaps = {
    textTransform: 'uppercase'
};
var $9f3f26e1ca2ad948$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $9f3f26e1ca2ad948$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === 'function' ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $9f3f26e1ca2ad948$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $f6Qba.default)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $k2R8s.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $9f3f26e1ca2ad948$var$defaultFontFamily ? {
            letterSpacing: "".concat($9f3f26e1ca2ad948$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $9f3f26e1ca2ad948$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $9f3f26e1ca2ad948$var$caseAllCaps)
    };
    return (0, $14Uvj.default)((0, $k2R8s.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $9f3f26e1ca2ad948$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("kpJi8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edc94667307b4bee$export$2e2bcd8739ae039; });
var $edc94667307b4bee$var$shadowKeyUmbraOpacity = 0.2;
var $edc94667307b4bee$var$shadowKeyPenumbraOpacity = 0.14;
var $edc94667307b4bee$var$shadowAmbientShadowOpacity = 0.12;
function $edc94667307b4bee$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($edc94667307b4bee$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($edc94667307b4bee$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($edc94667307b4bee$var$shadowAmbientShadowOpacity, ")")
    ].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $edc94667307b4bee$var$shadows = [
    'none',
    $edc94667307b4bee$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $edc94667307b4bee$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $edc94667307b4bee$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $edc94667307b4bee$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $edc94667307b4bee$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $edc94667307b4bee$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $edc94667307b4bee$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $edc94667307b4bee$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $edc94667307b4bee$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $edc94667307b4bee$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $edc94667307b4bee$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $edc94667307b4bee$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $edc94667307b4bee$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $edc94667307b4bee$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $edc94667307b4bee$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $edc94667307b4bee$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $edc94667307b4bee$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $edc94667307b4bee$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $edc94667307b4bee$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $edc94667307b4bee$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $edc94667307b4bee$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $edc94667307b4bee$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $edc94667307b4bee$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $edc94667307b4bee$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $edc94667307b4bee$export$2e2bcd8739ae039 = $edc94667307b4bee$var$shadows;

});

parcelRegister("irC6C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6d84ea2d2ccf8f4$export$2e2bcd8739ae039; });
var $d6d84ea2d2ccf8f4$var$shape = {
    borderRadius: 4
};
var $d6d84ea2d2ccf8f4$export$2e2bcd8739ae039 = $d6d84ea2d2ccf8f4$var$shape;

});

parcelRegister("bghsb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $832eba3eb157d800$export$2e2bcd8739ae039; });

var $4HVMb = parcelRequire("4HVMb");
var $832eba3eb157d800$var$warnOnce;
function $832eba3eb157d800$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $4HVMb.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === 'string') return argument;
            var output = transform(argument);
            return typeof output === 'number' ? "".concat(output, "px") : output;
        }).join(' ');
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, 'unit', {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("4HVMb", function(module, exports) {

$parcel$export(module.exports, "createUnarySpacing", function () { return $36d7feb59a42793a$export$1def6f833384e3d1; });

var $3KNdx = parcelRequire("3KNdx");


var $9Onlh = parcelRequire("9Onlh");

var $lnusT = parcelRequire("lnusT");

var $d72rL = parcelRequire("d72rL");
var $36d7feb59a42793a$var$properties = {
    m: 'margin',
    p: 'padding'
};
var $36d7feb59a42793a$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
var $36d7feb59a42793a$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $36d7feb59a42793a$var$getCssProperties = (0, $d72rL.default)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($36d7feb59a42793a$var$aliases[prop]) prop = $36d7feb59a42793a$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(''), _prop$split2 = (0, $3KNdx.default)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $36d7feb59a42793a$var$properties[a];
    var direction = $36d7feb59a42793a$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $36d7feb59a42793a$var$spacingKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY'
];
function $36d7feb59a42793a$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === 'number') return function(abs) {
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return function() {
        return undefined;
    };
}
function $36d7feb59a42793a$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return "-".concat(transformed);
}
function $36d7feb59a42793a$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $36d7feb59a42793a$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $36d7feb59a42793a$var$spacing(props) {
    var theme = props.theme;
    var transformer = $36d7feb59a42793a$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($36d7feb59a42793a$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $36d7feb59a42793a$var$getCssProperties(prop);
        var styleFromPropValue = $36d7feb59a42793a$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $9Onlh.handleBreakpoints)(props, propValue, styleFromPropValue);
    }).reduce((0, $lnusT.default), {});
}
$36d7feb59a42793a$var$spacing.propTypes = {};
$36d7feb59a42793a$var$spacing.filterProps = $36d7feb59a42793a$var$spacingKeys;
var $36d7feb59a42793a$export$2e2bcd8739ae039 = $36d7feb59a42793a$var$spacing;

});
parcelRegister("3KNdx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bbbd885e1fef371$export$2e2bcd8739ae039; });

var $c9QmJ = parcelRequire("c9QmJ");

var $cWZB1 = parcelRequire("cWZB1");

var $biFy3 = parcelRequire("biFy3");

var $6MgCo = parcelRequire("6MgCo");
function $2bbbd885e1fef371$export$2e2bcd8739ae039(r, e) {
    return (0, $c9QmJ.default)(r) || (0, $cWZB1.default)(r, e) || (0, $biFy3.default)(r, e) || (0, $6MgCo.default)();
}

});
parcelRegister("c9QmJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d9ef205826c89ae$export$2e2bcd8739ae039; });
function $8d9ef205826c89ae$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("cWZB1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96daae81604445fb$export$2e2bcd8739ae039; });
function $96daae81604445fb$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("6MgCo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ef41dca29d02c66$export$2e2bcd8739ae039; });
function $4ef41dca29d02c66$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("9Onlh", function(module, exports) {

$parcel$export(module.exports, "handleBreakpoints", function () { return $724ae3dc8009f910$export$88347efdb2e19abd; });

var $9unC2 = parcelRequire("9unC2");

var $k2R8s = parcelRequire("k2R8s");

var $8ZNRc = parcelRequire("8ZNRc");


var $lnusT = parcelRequire("lnusT");
// For instance with the first breakpoint xs: [xs, sm[.
var $724ae3dc8009f910$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $724ae3dc8009f910$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: function up(key) {
        return "@media (min-width:".concat($724ae3dc8009f910$var$values[key], "px)");
    }
};
function $724ae3dc8009f910$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $724ae3dc8009f910$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $8ZNRc.default)(propValue) === 'object') {
        var _themeBreakpoints = props.theme.breakpoints || $724ae3dc8009f910$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $724ae3dc8009f910$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $724ae3dc8009f910$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $k2R8s.default)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $lnusT.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ].concat((0, $9unC2.default)(styleFunction.filterProps));
    return newStyleFunction;
}
var $724ae3dc8009f910$export$2e2bcd8739ae039 = $724ae3dc8009f910$var$breakpoints;

});
parcelRegister("lnusT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f90360aeba172076$export$2e2bcd8739ae039; });

var $14Uvj = parcelRequire("14Uvj");
function $f90360aeba172076$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $14Uvj.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $f90360aeba172076$export$2e2bcd8739ae039 = $f90360aeba172076$var$merge;

});


parcelRegister("d72rL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98bdd3b14d15a7b9$export$2e2bcd8739ae039; });
function $98bdd3b14d15a7b9$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("dJPr8", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $a007609a14655dcd$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $a007609a14655dcd$export$2e2bcd8739ae039; });

var $f6Qba = parcelRequire("f6Qba");
var $a007609a14655dcd$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $a007609a14655dcd$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $a007609a14655dcd$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $a007609a14655dcd$export$2e2bcd8739ae039 = {
    easing: $a007609a14655dcd$export$24c5ac7c37452e7d,
    duration: $a007609a14655dcd$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            'all'
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $a007609a14655dcd$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $a007609a14655dcd$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $f6Qba.default)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : $a007609a14655dcd$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : $a007609a14655dcd$var$formatMs(delay));
        }).join(',');
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};

});

parcelRegister("3hBRr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26405407c81a9bba$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $26405407c81a9bba$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $26405407c81a9bba$export$2e2bcd8739ae039 = $26405407c81a9bba$var$zIndex;

});




parcelRegister("kfLRg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebea54f960d16ef6$export$2e2bcd8739ae039; });

var $gzSPO = parcelRequire("gzSPO");
function $ebea54f960d16ef6$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $gzSPO.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});




parcelRegister("6IRuR", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("95oGi", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $69d7b9e0f9338877$export$a7c73072b1a182ae; }, function (v) { return $69d7b9e0f9338877$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $69d7b9e0f9338877$export$9f27bc3417b4524d; }, function (v) { return $69d7b9e0f9338877$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $69d7b9e0f9338877$export$db77ccec0bb4ccac; }, function (v) { return $69d7b9e0f9338877$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $69d7b9e0f9338877$export$8392c0c9d3dcbd35; }, function (v) { return $69d7b9e0f9338877$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $69d7b9e0f9338877$export$ffb0004e005737fa; }, function (v) { return $69d7b9e0f9338877$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $69d7b9e0f9338877$export$b624eff549462981; }, function (v) { return $69d7b9e0f9338877$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $69d7b9e0f9338877$export$7897aa7841a5380c; }, function (v) { return $69d7b9e0f9338877$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $69d7b9e0f9338877$export$602eac185826482c; }, function (v) { return $69d7b9e0f9338877$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $69d7b9e0f9338877$export$e2c29f18771995cb; }, function (v) { return $69d7b9e0f9338877$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $69d7b9e0f9338877$export$5f8d39834fd61797; }, function (v) { return $69d7b9e0f9338877$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $69d7b9e0f9338877$export$74bf444e3cd11ea5; }, function (v) { return $69d7b9e0f9338877$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $69d7b9e0f9338877$export$92387174baf9b227; }, function (v) { return $69d7b9e0f9338877$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $69d7b9e0f9338877$export$ec112efeb987d9c6; }, function (v) { return $69d7b9e0f9338877$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $69d7b9e0f9338877$export$b706b080d889d2c9; }, function (v) { return $69d7b9e0f9338877$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $69d7b9e0f9338877$export$5be5a87408f70ddc; }, function (v) { return $69d7b9e0f9338877$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $69d7b9e0f9338877$export$45a5e7f76e0caa8d; }, function (v) { return $69d7b9e0f9338877$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $69d7b9e0f9338877$export$455c2e768291efa6; }, function (v) { return $69d7b9e0f9338877$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $69d7b9e0f9338877$export$9522e17588c12572; }, function (v) { return $69d7b9e0f9338877$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $69d7b9e0f9338877$export$2110ac352bb060b9; }, function (v) { return $69d7b9e0f9338877$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $69d7b9e0f9338877$export$56885ab8b9c456ab; }, function (v) { return $69d7b9e0f9338877$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $69d7b9e0f9338877$export$d927fcb6adf8f9de; }, function (v) { return $69d7b9e0f9338877$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $69d7b9e0f9338877$export$b82d16f27459e05a; }, function (v) { return $69d7b9e0f9338877$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $69d7b9e0f9338877$export$522c17b4f5e123e8; }, function (v) { return $69d7b9e0f9338877$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $69d7b9e0f9338877$export$1aabd8a0274ecfd6; }, function (v) { return $69d7b9e0f9338877$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $69d7b9e0f9338877$export$9b621391a187a31a; }, function (v) { return $69d7b9e0f9338877$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $69d7b9e0f9338877$export$f5bbd400c2f4426f; }, function (v) { return $69d7b9e0f9338877$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $69d7b9e0f9338877$export$a7c73072b1a182ae;
var $69d7b9e0f9338877$export$9f27bc3417b4524d;
var $69d7b9e0f9338877$export$db77ccec0bb4ccac;
var $69d7b9e0f9338877$export$8392c0c9d3dcbd35;
var $69d7b9e0f9338877$export$ffb0004e005737fa;
var $69d7b9e0f9338877$export$b624eff549462981;
var $69d7b9e0f9338877$export$7897aa7841a5380c;
var $69d7b9e0f9338877$export$602eac185826482c;
var $69d7b9e0f9338877$export$e2c29f18771995cb;
var $69d7b9e0f9338877$export$5f8d39834fd61797;
var $69d7b9e0f9338877$export$74bf444e3cd11ea5;
var $69d7b9e0f9338877$export$92387174baf9b227;
var $69d7b9e0f9338877$export$ec112efeb987d9c6;
var $69d7b9e0f9338877$export$b706b080d889d2c9;
var $69d7b9e0f9338877$export$5be5a87408f70ddc;
var $69d7b9e0f9338877$export$45a5e7f76e0caa8d;
var $69d7b9e0f9338877$export$455c2e768291efa6;
var $69d7b9e0f9338877$export$9522e17588c12572;
var $69d7b9e0f9338877$export$2110ac352bb060b9;
var $69d7b9e0f9338877$export$56885ab8b9c456ab;
var $69d7b9e0f9338877$export$d927fcb6adf8f9de;
var $69d7b9e0f9338877$export$b82d16f27459e05a;
var $69d7b9e0f9338877$export$522c17b4f5e123e8;
var $69d7b9e0f9338877$export$1aabd8a0274ecfd6;
var $69d7b9e0f9338877$export$9b621391a187a31a;
var $69d7b9e0f9338877$export$f5bbd400c2f4426f;
'use strict';
var $69d7b9e0f9338877$var$b = 60103, $69d7b9e0f9338877$var$c = 60106, $69d7b9e0f9338877$var$d = 60107, $69d7b9e0f9338877$var$e = 60108, $69d7b9e0f9338877$var$f = 60114, $69d7b9e0f9338877$var$g = 60109, $69d7b9e0f9338877$var$h = 60110, $69d7b9e0f9338877$var$k = 60112, $69d7b9e0f9338877$var$l = 60113, $69d7b9e0f9338877$var$m = 60120, $69d7b9e0f9338877$var$n = 60115, $69d7b9e0f9338877$var$p = 60116, $69d7b9e0f9338877$var$q = 60121, $69d7b9e0f9338877$var$r = 60122, $69d7b9e0f9338877$var$u = 60117, $69d7b9e0f9338877$var$v = 60129, $69d7b9e0f9338877$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $69d7b9e0f9338877$var$x = Symbol.for;
    $69d7b9e0f9338877$var$b = $69d7b9e0f9338877$var$x("react.element");
    $69d7b9e0f9338877$var$c = $69d7b9e0f9338877$var$x("react.portal");
    $69d7b9e0f9338877$var$d = $69d7b9e0f9338877$var$x("react.fragment");
    $69d7b9e0f9338877$var$e = $69d7b9e0f9338877$var$x("react.strict_mode");
    $69d7b9e0f9338877$var$f = $69d7b9e0f9338877$var$x("react.profiler");
    $69d7b9e0f9338877$var$g = $69d7b9e0f9338877$var$x("react.provider");
    $69d7b9e0f9338877$var$h = $69d7b9e0f9338877$var$x("react.context");
    $69d7b9e0f9338877$var$k = $69d7b9e0f9338877$var$x("react.forward_ref");
    $69d7b9e0f9338877$var$l = $69d7b9e0f9338877$var$x("react.suspense");
    $69d7b9e0f9338877$var$m = $69d7b9e0f9338877$var$x("react.suspense_list");
    $69d7b9e0f9338877$var$n = $69d7b9e0f9338877$var$x("react.memo");
    $69d7b9e0f9338877$var$p = $69d7b9e0f9338877$var$x("react.lazy");
    $69d7b9e0f9338877$var$q = $69d7b9e0f9338877$var$x("react.block");
    $69d7b9e0f9338877$var$r = $69d7b9e0f9338877$var$x("react.server.block");
    $69d7b9e0f9338877$var$u = $69d7b9e0f9338877$var$x("react.fundamental");
    $69d7b9e0f9338877$var$v = $69d7b9e0f9338877$var$x("react.debug_trace_mode");
    $69d7b9e0f9338877$var$w = $69d7b9e0f9338877$var$x("react.legacy_hidden");
}
function $69d7b9e0f9338877$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $69d7b9e0f9338877$var$b:
                switch(a = a.type, a){
                    case $69d7b9e0f9338877$var$d:
                    case $69d7b9e0f9338877$var$f:
                    case $69d7b9e0f9338877$var$e:
                    case $69d7b9e0f9338877$var$l:
                    case $69d7b9e0f9338877$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $69d7b9e0f9338877$var$h:
                            case $69d7b9e0f9338877$var$k:
                            case $69d7b9e0f9338877$var$p:
                            case $69d7b9e0f9338877$var$n:
                            case $69d7b9e0f9338877$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $69d7b9e0f9338877$var$c:
                return t;
        }
    }
}
var $69d7b9e0f9338877$var$z = $69d7b9e0f9338877$var$g, $69d7b9e0f9338877$var$A = $69d7b9e0f9338877$var$b, $69d7b9e0f9338877$var$B = $69d7b9e0f9338877$var$k, $69d7b9e0f9338877$var$C = $69d7b9e0f9338877$var$d, $69d7b9e0f9338877$var$D = $69d7b9e0f9338877$var$p, $69d7b9e0f9338877$var$E = $69d7b9e0f9338877$var$n, $69d7b9e0f9338877$var$F = $69d7b9e0f9338877$var$c, $69d7b9e0f9338877$var$G = $69d7b9e0f9338877$var$f, $69d7b9e0f9338877$var$H = $69d7b9e0f9338877$var$e, $69d7b9e0f9338877$var$I = $69d7b9e0f9338877$var$l;
$69d7b9e0f9338877$export$a7c73072b1a182ae = $69d7b9e0f9338877$var$h;
$69d7b9e0f9338877$export$9f27bc3417b4524d = $69d7b9e0f9338877$var$z;
$69d7b9e0f9338877$export$db77ccec0bb4ccac = $69d7b9e0f9338877$var$A;
$69d7b9e0f9338877$export$8392c0c9d3dcbd35 = $69d7b9e0f9338877$var$B;
$69d7b9e0f9338877$export$ffb0004e005737fa = $69d7b9e0f9338877$var$C;
$69d7b9e0f9338877$export$b624eff549462981 = $69d7b9e0f9338877$var$D;
$69d7b9e0f9338877$export$7897aa7841a5380c = $69d7b9e0f9338877$var$E;
$69d7b9e0f9338877$export$602eac185826482c = $69d7b9e0f9338877$var$F;
$69d7b9e0f9338877$export$e2c29f18771995cb = $69d7b9e0f9338877$var$G;
$69d7b9e0f9338877$export$5f8d39834fd61797 = $69d7b9e0f9338877$var$H;
$69d7b9e0f9338877$export$74bf444e3cd11ea5 = $69d7b9e0f9338877$var$I;
$69d7b9e0f9338877$export$92387174baf9b227 = function() {
    return !1;
};
$69d7b9e0f9338877$export$ec112efeb987d9c6 = function() {
    return !1;
};
$69d7b9e0f9338877$export$b706b080d889d2c9 = function(a) {
    return $69d7b9e0f9338877$var$y(a) === $69d7b9e0f9338877$var$h;
};
$69d7b9e0f9338877$export$5be5a87408f70ddc = function(a) {
    return $69d7b9e0f9338877$var$y(a) === $69d7b9e0f9338877$var$g;
};
$69d7b9e0f9338877$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $69d7b9e0f9338877$var$b;
};
$69d7b9e0f9338877$export$455c2e768291efa6 = function(a) {
    return $69d7b9e0f9338877$var$y(a) === $69d7b9e0f9338877$var$k;
};
$69d7b9e0f9338877$export$9522e17588c12572 = function(a) {
    return $69d7b9e0f9338877$var$y(a) === $69d7b9e0f9338877$var$d;
};
$69d7b9e0f9338877$export$2110ac352bb060b9 = function(a) {
    return $69d7b9e0f9338877$var$y(a) === $69d7b9e0f9338877$var$p;
};
$69d7b9e0f9338877$export$56885ab8b9c456ab = function(a) {
    return $69d7b9e0f9338877$var$y(a) === $69d7b9e0f9338877$var$n;
};
$69d7b9e0f9338877$export$d927fcb6adf8f9de = function(a) {
    return $69d7b9e0f9338877$var$y(a) === $69d7b9e0f9338877$var$c;
};
$69d7b9e0f9338877$export$b82d16f27459e05a = function(a) {
    return $69d7b9e0f9338877$var$y(a) === $69d7b9e0f9338877$var$f;
};
$69d7b9e0f9338877$export$522c17b4f5e123e8 = function(a) {
    return $69d7b9e0f9338877$var$y(a) === $69d7b9e0f9338877$var$e;
};
$69d7b9e0f9338877$export$1aabd8a0274ecfd6 = function(a) {
    return $69d7b9e0f9338877$var$y(a) === $69d7b9e0f9338877$var$l;
};
$69d7b9e0f9338877$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $69d7b9e0f9338877$var$d || a === $69d7b9e0f9338877$var$f || a === $69d7b9e0f9338877$var$v || a === $69d7b9e0f9338877$var$e || a === $69d7b9e0f9338877$var$l || a === $69d7b9e0f9338877$var$m || a === $69d7b9e0f9338877$var$w || "object" === typeof a && null !== a && (a.$$typeof === $69d7b9e0f9338877$var$p || a.$$typeof === $69d7b9e0f9338877$var$n || a.$$typeof === $69d7b9e0f9338877$var$g || a.$$typeof === $69d7b9e0f9338877$var$h || a.$$typeof === $69d7b9e0f9338877$var$k || a.$$typeof === $69d7b9e0f9338877$var$u || a.$$typeof === $69d7b9e0f9338877$var$q || a[0] === $69d7b9e0f9338877$var$r) ? !0 : !1;
};
$69d7b9e0f9338877$export$f5bbd400c2f4426f = $69d7b9e0f9338877$var$y;

});

parcelRegister("gi6Ym", function(module, exports) {

var $g1Rml = parcelRequire("g1Rml");

var $6Em7J = parcelRequire("6Em7J");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $g1Rml.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $6Em7J;
module.exports = isBuffer;

});
parcelRegister("g1Rml", function(module, exports) {

var $5vbhA = parcelRequire("5vbhA");
/** Detect free variable `self`. */ var $bab62169631f940b$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $bab62169631f940b$var$root = $5vbhA || $bab62169631f940b$var$freeSelf || Function('return this')();
module.exports = $bab62169631f940b$var$root;

});
parcelRegister("5vbhA", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $4018998036dd84ac$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $4018998036dd84ac$var$freeGlobal;

});


parcelRegister("6Em7J", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $4d77a3cdd4ed665f$var$stubFalse() {
    return false;
}
module.exports = $4d77a3cdd4ed665f$var$stubFalse;

});


parcelRegister("igBAz", function(module, exports) {

var $5vbhA = parcelRequire("5vbhA");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $5vbhA.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("krok7", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $ee19326d0ef1c11f$export$a7c73072b1a182ae; }, function (v) { return $ee19326d0ef1c11f$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $ee19326d0ef1c11f$export$9f27bc3417b4524d; }, function (v) { return $ee19326d0ef1c11f$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $ee19326d0ef1c11f$export$db77ccec0bb4ccac; }, function (v) { return $ee19326d0ef1c11f$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $ee19326d0ef1c11f$export$8392c0c9d3dcbd35; }, function (v) { return $ee19326d0ef1c11f$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ee19326d0ef1c11f$export$ffb0004e005737fa; }, function (v) { return $ee19326d0ef1c11f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $ee19326d0ef1c11f$export$b624eff549462981; }, function (v) { return $ee19326d0ef1c11f$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $ee19326d0ef1c11f$export$7897aa7841a5380c; }, function (v) { return $ee19326d0ef1c11f$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $ee19326d0ef1c11f$export$602eac185826482c; }, function (v) { return $ee19326d0ef1c11f$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $ee19326d0ef1c11f$export$e2c29f18771995cb; }, function (v) { return $ee19326d0ef1c11f$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ee19326d0ef1c11f$export$5f8d39834fd61797; }, function (v) { return $ee19326d0ef1c11f$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ee19326d0ef1c11f$export$74bf444e3cd11ea5; }, function (v) { return $ee19326d0ef1c11f$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $ee19326d0ef1c11f$export$998bcd577473dd93; }, function (v) { return $ee19326d0ef1c11f$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $ee19326d0ef1c11f$export$92387174baf9b227; }, function (v) { return $ee19326d0ef1c11f$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $ee19326d0ef1c11f$export$ec112efeb987d9c6; }, function (v) { return $ee19326d0ef1c11f$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $ee19326d0ef1c11f$export$b706b080d889d2c9; }, function (v) { return $ee19326d0ef1c11f$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $ee19326d0ef1c11f$export$5be5a87408f70ddc; }, function (v) { return $ee19326d0ef1c11f$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $ee19326d0ef1c11f$export$45a5e7f76e0caa8d; }, function (v) { return $ee19326d0ef1c11f$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $ee19326d0ef1c11f$export$455c2e768291efa6; }, function (v) { return $ee19326d0ef1c11f$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $ee19326d0ef1c11f$export$9522e17588c12572; }, function (v) { return $ee19326d0ef1c11f$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $ee19326d0ef1c11f$export$2110ac352bb060b9; }, function (v) { return $ee19326d0ef1c11f$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $ee19326d0ef1c11f$export$56885ab8b9c456ab; }, function (v) { return $ee19326d0ef1c11f$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $ee19326d0ef1c11f$export$d927fcb6adf8f9de; }, function (v) { return $ee19326d0ef1c11f$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $ee19326d0ef1c11f$export$b82d16f27459e05a; }, function (v) { return $ee19326d0ef1c11f$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $ee19326d0ef1c11f$export$522c17b4f5e123e8; }, function (v) { return $ee19326d0ef1c11f$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $ee19326d0ef1c11f$export$1aabd8a0274ecfd6; }, function (v) { return $ee19326d0ef1c11f$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $ee19326d0ef1c11f$export$3d6c20d97e46b957; }, function (v) { return $ee19326d0ef1c11f$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $ee19326d0ef1c11f$export$9b621391a187a31a; }, function (v) { return $ee19326d0ef1c11f$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $ee19326d0ef1c11f$export$f5bbd400c2f4426f; }, function (v) { return $ee19326d0ef1c11f$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ee19326d0ef1c11f$export$a7c73072b1a182ae;
var $ee19326d0ef1c11f$export$9f27bc3417b4524d;
var $ee19326d0ef1c11f$export$db77ccec0bb4ccac;
var $ee19326d0ef1c11f$export$8392c0c9d3dcbd35;
var $ee19326d0ef1c11f$export$ffb0004e005737fa;
var $ee19326d0ef1c11f$export$b624eff549462981;
var $ee19326d0ef1c11f$export$7897aa7841a5380c;
var $ee19326d0ef1c11f$export$602eac185826482c;
var $ee19326d0ef1c11f$export$e2c29f18771995cb;
var $ee19326d0ef1c11f$export$5f8d39834fd61797;
var $ee19326d0ef1c11f$export$74bf444e3cd11ea5;
var $ee19326d0ef1c11f$export$998bcd577473dd93;
var $ee19326d0ef1c11f$export$92387174baf9b227;
var $ee19326d0ef1c11f$export$ec112efeb987d9c6;
var $ee19326d0ef1c11f$export$b706b080d889d2c9;
var $ee19326d0ef1c11f$export$5be5a87408f70ddc;
var $ee19326d0ef1c11f$export$45a5e7f76e0caa8d;
var $ee19326d0ef1c11f$export$455c2e768291efa6;
var $ee19326d0ef1c11f$export$9522e17588c12572;
var $ee19326d0ef1c11f$export$2110ac352bb060b9;
var $ee19326d0ef1c11f$export$56885ab8b9c456ab;
var $ee19326d0ef1c11f$export$d927fcb6adf8f9de;
var $ee19326d0ef1c11f$export$b82d16f27459e05a;
var $ee19326d0ef1c11f$export$522c17b4f5e123e8;
var $ee19326d0ef1c11f$export$1aabd8a0274ecfd6;
var $ee19326d0ef1c11f$export$3d6c20d97e46b957;
var $ee19326d0ef1c11f$export$9b621391a187a31a;
var $ee19326d0ef1c11f$export$f5bbd400c2f4426f;
'use strict';
var $ee19326d0ef1c11f$var$b = Symbol.for("react.element"), $ee19326d0ef1c11f$var$c = Symbol.for("react.portal"), $ee19326d0ef1c11f$var$d = Symbol.for("react.fragment"), $ee19326d0ef1c11f$var$e = Symbol.for("react.strict_mode"), $ee19326d0ef1c11f$var$f = Symbol.for("react.profiler"), $ee19326d0ef1c11f$var$g = Symbol.for("react.provider"), $ee19326d0ef1c11f$var$h = Symbol.for("react.context"), $ee19326d0ef1c11f$var$k = Symbol.for("react.server_context"), $ee19326d0ef1c11f$var$l = Symbol.for("react.forward_ref"), $ee19326d0ef1c11f$var$m = Symbol.for("react.suspense"), $ee19326d0ef1c11f$var$n = Symbol.for("react.suspense_list"), $ee19326d0ef1c11f$var$p = Symbol.for("react.memo"), $ee19326d0ef1c11f$var$q = Symbol.for("react.lazy"), $ee19326d0ef1c11f$var$t = Symbol.for("react.offscreen"), $ee19326d0ef1c11f$var$u;
$ee19326d0ef1c11f$var$u = Symbol.for("react.module.reference");
function $ee19326d0ef1c11f$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $ee19326d0ef1c11f$var$b:
                switch(a = a.type, a){
                    case $ee19326d0ef1c11f$var$d:
                    case $ee19326d0ef1c11f$var$f:
                    case $ee19326d0ef1c11f$var$e:
                    case $ee19326d0ef1c11f$var$m:
                    case $ee19326d0ef1c11f$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ee19326d0ef1c11f$var$k:
                            case $ee19326d0ef1c11f$var$h:
                            case $ee19326d0ef1c11f$var$l:
                            case $ee19326d0ef1c11f$var$q:
                            case $ee19326d0ef1c11f$var$p:
                            case $ee19326d0ef1c11f$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $ee19326d0ef1c11f$var$c:
                return r;
        }
    }
}
$ee19326d0ef1c11f$export$a7c73072b1a182ae = $ee19326d0ef1c11f$var$h;
$ee19326d0ef1c11f$export$9f27bc3417b4524d = $ee19326d0ef1c11f$var$g;
$ee19326d0ef1c11f$export$db77ccec0bb4ccac = $ee19326d0ef1c11f$var$b;
$ee19326d0ef1c11f$export$8392c0c9d3dcbd35 = $ee19326d0ef1c11f$var$l;
$ee19326d0ef1c11f$export$ffb0004e005737fa = $ee19326d0ef1c11f$var$d;
$ee19326d0ef1c11f$export$b624eff549462981 = $ee19326d0ef1c11f$var$q;
$ee19326d0ef1c11f$export$7897aa7841a5380c = $ee19326d0ef1c11f$var$p;
$ee19326d0ef1c11f$export$602eac185826482c = $ee19326d0ef1c11f$var$c;
$ee19326d0ef1c11f$export$e2c29f18771995cb = $ee19326d0ef1c11f$var$f;
$ee19326d0ef1c11f$export$5f8d39834fd61797 = $ee19326d0ef1c11f$var$e;
$ee19326d0ef1c11f$export$74bf444e3cd11ea5 = $ee19326d0ef1c11f$var$m;
$ee19326d0ef1c11f$export$998bcd577473dd93 = $ee19326d0ef1c11f$var$n;
$ee19326d0ef1c11f$export$92387174baf9b227 = function() {
    return !1;
};
$ee19326d0ef1c11f$export$ec112efeb987d9c6 = function() {
    return !1;
};
$ee19326d0ef1c11f$export$b706b080d889d2c9 = function(a) {
    return $ee19326d0ef1c11f$var$v(a) === $ee19326d0ef1c11f$var$h;
};
$ee19326d0ef1c11f$export$5be5a87408f70ddc = function(a) {
    return $ee19326d0ef1c11f$var$v(a) === $ee19326d0ef1c11f$var$g;
};
$ee19326d0ef1c11f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ee19326d0ef1c11f$var$b;
};
$ee19326d0ef1c11f$export$455c2e768291efa6 = function(a) {
    return $ee19326d0ef1c11f$var$v(a) === $ee19326d0ef1c11f$var$l;
};
$ee19326d0ef1c11f$export$9522e17588c12572 = function(a) {
    return $ee19326d0ef1c11f$var$v(a) === $ee19326d0ef1c11f$var$d;
};
$ee19326d0ef1c11f$export$2110ac352bb060b9 = function(a) {
    return $ee19326d0ef1c11f$var$v(a) === $ee19326d0ef1c11f$var$q;
};
$ee19326d0ef1c11f$export$56885ab8b9c456ab = function(a) {
    return $ee19326d0ef1c11f$var$v(a) === $ee19326d0ef1c11f$var$p;
};
$ee19326d0ef1c11f$export$d927fcb6adf8f9de = function(a) {
    return $ee19326d0ef1c11f$var$v(a) === $ee19326d0ef1c11f$var$c;
};
$ee19326d0ef1c11f$export$b82d16f27459e05a = function(a) {
    return $ee19326d0ef1c11f$var$v(a) === $ee19326d0ef1c11f$var$f;
};
$ee19326d0ef1c11f$export$522c17b4f5e123e8 = function(a) {
    return $ee19326d0ef1c11f$var$v(a) === $ee19326d0ef1c11f$var$e;
};
$ee19326d0ef1c11f$export$1aabd8a0274ecfd6 = function(a) {
    return $ee19326d0ef1c11f$var$v(a) === $ee19326d0ef1c11f$var$m;
};
$ee19326d0ef1c11f$export$3d6c20d97e46b957 = function(a) {
    return $ee19326d0ef1c11f$var$v(a) === $ee19326d0ef1c11f$var$n;
};
$ee19326d0ef1c11f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ee19326d0ef1c11f$var$d || a === $ee19326d0ef1c11f$var$f || a === $ee19326d0ef1c11f$var$e || a === $ee19326d0ef1c11f$var$m || a === $ee19326d0ef1c11f$var$n || a === $ee19326d0ef1c11f$var$t || "object" === typeof a && null !== a && (a.$$typeof === $ee19326d0ef1c11f$var$q || a.$$typeof === $ee19326d0ef1c11f$var$p || a.$$typeof === $ee19326d0ef1c11f$var$g || a.$$typeof === $ee19326d0ef1c11f$var$h || a.$$typeof === $ee19326d0ef1c11f$var$l || a.$$typeof === $ee19326d0ef1c11f$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$ee19326d0ef1c11f$export$f5bbd400c2f4426f = $ee19326d0ef1c11f$var$v;

});

parcelRegister("7GsXL", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("gnUKv"));

});
parcelRegister("gnUKv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $bedad07d1f6abaa3$var$_tickFormat.default;
    }
});

var $bedad07d1f6abaa3$var$_band = $bedad07d1f6abaa3$var$_interopRequireWildcard((parcelRequire("cIZFh")));

var $bedad07d1f6abaa3$var$_identity = $bedad07d1f6abaa3$var$_interopRequireDefault((parcelRequire("2wYci")));

var $bedad07d1f6abaa3$var$_linear = $bedad07d1f6abaa3$var$_interopRequireDefault((parcelRequire("4rEkf")));

var $bedad07d1f6abaa3$var$_log = $bedad07d1f6abaa3$var$_interopRequireDefault((parcelRequire("kLejA")));

var $bedad07d1f6abaa3$var$_symlog = $bedad07d1f6abaa3$var$_interopRequireDefault((parcelRequire("27X7D")));

var $bedad07d1f6abaa3$var$_ordinal = $bedad07d1f6abaa3$var$_interopRequireWildcard((parcelRequire("cPFRk")));

var $bedad07d1f6abaa3$var$_pow = $bedad07d1f6abaa3$var$_interopRequireWildcard((parcelRequire("haUTr")));

var $bedad07d1f6abaa3$var$_radial = $bedad07d1f6abaa3$var$_interopRequireDefault((parcelRequire("l58Nc")));

var $bedad07d1f6abaa3$var$_quantile = $bedad07d1f6abaa3$var$_interopRequireDefault((parcelRequire("8pEqf")));

var $bedad07d1f6abaa3$var$_quantize = $bedad07d1f6abaa3$var$_interopRequireDefault((parcelRequire("fiDb6")));

var $bedad07d1f6abaa3$var$_threshold = $bedad07d1f6abaa3$var$_interopRequireDefault((parcelRequire("kjyGY")));

var $bedad07d1f6abaa3$var$_time = $bedad07d1f6abaa3$var$_interopRequireDefault((parcelRequire("hm640")));

var $bedad07d1f6abaa3$var$_utcTime = $bedad07d1f6abaa3$var$_interopRequireDefault((parcelRequire("e0xFg")));

var $bedad07d1f6abaa3$var$_sequential = $bedad07d1f6abaa3$var$_interopRequireWildcard((parcelRequire("k9Gpj")));

var $bedad07d1f6abaa3$var$_sequentialQuantile = $bedad07d1f6abaa3$var$_interopRequireDefault((parcelRequire("dJf4W")));

var $bedad07d1f6abaa3$var$_diverging = $bedad07d1f6abaa3$var$_interopRequireWildcard((parcelRequire("czpqZ")));

var $bedad07d1f6abaa3$var$_tickFormat = $bedad07d1f6abaa3$var$_interopRequireDefault((parcelRequire("3pGSJ")));
function $bedad07d1f6abaa3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bedad07d1f6abaa3$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($bedad07d1f6abaa3$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $bedad07d1f6abaa3$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bedad07d1f6abaa3$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("cIZFh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $94396d6b3426802e$var$band;
module.exports.point = $94396d6b3426802e$var$point;

var $e3Byi = parcelRequire("e3Byi");

var $beTth = parcelRequire("beTth");

var $94396d6b3426802e$var$_ordinal = $94396d6b3426802e$var$_interopRequireDefault((parcelRequire("cPFRk")));
function $94396d6b3426802e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $94396d6b3426802e$var$band() {
    var scale = (0, $94396d6b3426802e$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $e3Byi.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $94396d6b3426802e$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $beTth.initRange.apply(rescale(), arguments);
}
function $94396d6b3426802e$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $94396d6b3426802e$var$pointish(copy());
    };
    return scale;
}
function $94396d6b3426802e$var$point() {
    return $94396d6b3426802e$var$pointish($94396d6b3426802e$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("e3Byi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $7oKSv.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $2cuqZ.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $2cuqZ.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $7oKSv.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $7oKSv.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $a3be799525508a2b$var$_zip.default;
    }
});

var $a3be799525508a2b$var$_bisect = $a3be799525508a2b$var$_interopRequireWildcard((parcelRequire("jJqVC")));

var $a3be799525508a2b$var$_ascending = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("91TVA")));

var $a3be799525508a2b$var$_bisector = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("1eQyf")));

var $a3be799525508a2b$var$_count = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("9efkv")));

var $a3be799525508a2b$var$_cross = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("9auGQ")));

var $a3be799525508a2b$var$_cumsum = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("2vwJN")));

var $a3be799525508a2b$var$_descending = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("0kfXt")));

var $a3be799525508a2b$var$_deviation = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("sp6gp")));

var $a3be799525508a2b$var$_extent = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("eH0wl")));

var $7oKSv = parcelRequire("7oKSv");

var $a3be799525508a2b$var$_group = $a3be799525508a2b$var$_interopRequireWildcard((parcelRequire("5NGIB")));

var $a3be799525508a2b$var$_groupSort = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("4dUSN")));

var $a3be799525508a2b$var$_bin = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("3uDa0")));

var $a3be799525508a2b$var$_freedmanDiaconis = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("5QEXO")));

var $a3be799525508a2b$var$_scott = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("fhlzT")));

var $a3be799525508a2b$var$_sturges = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("7FVbW")));

var $a3be799525508a2b$var$_max = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("d80JQ")));

var $a3be799525508a2b$var$_maxIndex = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("aNW09")));

var $a3be799525508a2b$var$_mean = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("julZn")));

var $a3be799525508a2b$var$_median = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("9ScMN")));

var $a3be799525508a2b$var$_merge = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("iXEPJ")));

var $a3be799525508a2b$var$_min = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("cBxyK")));

var $a3be799525508a2b$var$_minIndex = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("dWfPM")));

var $a3be799525508a2b$var$_mode = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("gL4hx")));

var $a3be799525508a2b$var$_nice = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("dabfk")));

var $a3be799525508a2b$var$_pairs = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("5FQ0p")));

var $a3be799525508a2b$var$_permute = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("eVtmr")));

var $a3be799525508a2b$var$_quantile = $a3be799525508a2b$var$_interopRequireWildcard((parcelRequire("hC26C")));

var $a3be799525508a2b$var$_quickselect = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("4sZvs")));

var $a3be799525508a2b$var$_range = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("ks8up")));

var $a3be799525508a2b$var$_rank = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("fE6wx")));

var $a3be799525508a2b$var$_least = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("aCVi9")));

var $a3be799525508a2b$var$_leastIndex = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("9RV6m")));

var $a3be799525508a2b$var$_greatest = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("6dn7d")));

var $a3be799525508a2b$var$_greatestIndex = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("eUEph")));

var $a3be799525508a2b$var$_scan = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("kwDkv")));

var $a3be799525508a2b$var$_shuffle = $a3be799525508a2b$var$_interopRequireWildcard((parcelRequire("80rQz")));

var $a3be799525508a2b$var$_sum = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("jztKV")));

var $a3be799525508a2b$var$_ticks = $a3be799525508a2b$var$_interopRequireWildcard((parcelRequire("h0sG3")));

var $a3be799525508a2b$var$_transpose = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("7UtqA")));

var $a3be799525508a2b$var$_variance = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("iPfCL")));

var $a3be799525508a2b$var$_zip = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("liFYF")));

var $a3be799525508a2b$var$_every = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("kG3uY")));

var $a3be799525508a2b$var$_some = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("2AzDG")));

var $a3be799525508a2b$var$_filter = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("du5hp")));

var $a3be799525508a2b$var$_map = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("iEQsJ")));

var $a3be799525508a2b$var$_reduce = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("gW5zZ")));

var $a3be799525508a2b$var$_reverse = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("5iYl5")));

var $a3be799525508a2b$var$_sort = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("cGOeo")));

var $a3be799525508a2b$var$_difference = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("geif6")));

var $a3be799525508a2b$var$_disjoint = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("j1hsm")));

var $a3be799525508a2b$var$_intersection = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("8afoJ")));

var $a3be799525508a2b$var$_subset = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("lDcPp")));

var $a3be799525508a2b$var$_superset = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("53SJi")));

var $a3be799525508a2b$var$_union = $a3be799525508a2b$var$_interopRequireDefault((parcelRequire("5yoRS")));

var $2cuqZ = parcelRequire("2cuqZ");
function $a3be799525508a2b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a3be799525508a2b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a3be799525508a2b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a3be799525508a2b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a3be799525508a2b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("jJqVC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $e5d71bb1c1ef13f4$var$_ascending = $e5d71bb1c1ef13f4$var$_interopRequireDefault((parcelRequire("91TVA")));

var $e5d71bb1c1ef13f4$var$_bisector = $e5d71bb1c1ef13f4$var$_interopRequireDefault((parcelRequire("1eQyf")));

var $e5d71bb1c1ef13f4$var$_number = $e5d71bb1c1ef13f4$var$_interopRequireDefault((parcelRequire("dDbKt")));
function $e5d71bb1c1ef13f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e5d71bb1c1ef13f4$var$ascendingBisect = (0, $e5d71bb1c1ef13f4$var$_bisector.default)($e5d71bb1c1ef13f4$var$_ascending.default);
const $e5d71bb1c1ef13f4$var$bisectRight = $e5d71bb1c1ef13f4$var$ascendingBisect.right;
module.exports.bisectRight = $e5d71bb1c1ef13f4$var$bisectRight;
const $e5d71bb1c1ef13f4$var$bisectLeft = $e5d71bb1c1ef13f4$var$ascendingBisect.left;
module.exports.bisectLeft = $e5d71bb1c1ef13f4$var$bisectLeft;
const $e5d71bb1c1ef13f4$var$bisectCenter = (0, $e5d71bb1c1ef13f4$var$_bisector.default)($e5d71bb1c1ef13f4$var$_number.default).center;
module.exports.bisectCenter = $e5d71bb1c1ef13f4$var$bisectCenter;
var $e5d71bb1c1ef13f4$var$_default = $e5d71bb1c1ef13f4$var$bisectRight;
module.exports.default = $e5d71bb1c1ef13f4$var$_default;

});
parcelRegister("91TVA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $692f972250d7c9c9$var$ascending;
function $692f972250d7c9c9$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("1eQyf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e6fdcdefea694bf$var$bisector;

var $0e6fdcdefea694bf$var$_ascending = $0e6fdcdefea694bf$var$_interopRequireDefault((parcelRequire("91TVA")));

var $0e6fdcdefea694bf$var$_descending = $0e6fdcdefea694bf$var$_interopRequireDefault((parcelRequire("0kfXt")));
function $0e6fdcdefea694bf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0e6fdcdefea694bf$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $0e6fdcdefea694bf$var$_ascending.default;
        compare2 = (d, x)=>(0, $0e6fdcdefea694bf$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $0e6fdcdefea694bf$var$_ascending.default || f === $0e6fdcdefea694bf$var$_descending.default ? f : $0e6fdcdefea694bf$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $0e6fdcdefea694bf$var$zero() {
    return 0;
}

});
parcelRegister("0kfXt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $000fb6b2fedfe25f$var$descending;
function $000fb6b2fedfe25f$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("dDbKt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9ec807e0c504a21f$var$number;
module.exports.numbers = $9ec807e0c504a21f$var$numbers;
function $9ec807e0c504a21f$var$number(x) {
    return x === null ? NaN : +x;
}
function* $9ec807e0c504a21f$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("9efkv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b81500cfdd0592f$var$count;
function $6b81500cfdd0592f$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("9auGQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6accdaa5ea7d2fc7$var$cross;
function $6accdaa5ea7d2fc7$var$length(array) {
    return array.length | 0;
}
function $6accdaa5ea7d2fc7$var$empty(length) {
    return !(length > 0);
}
function $6accdaa5ea7d2fc7$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $6accdaa5ea7d2fc7$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $6accdaa5ea7d2fc7$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $6accdaa5ea7d2fc7$var$reducer(values.pop());
    values = values.map($6accdaa5ea7d2fc7$var$arrayify);
    const lengths = values.map($6accdaa5ea7d2fc7$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($6accdaa5ea7d2fc7$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("2vwJN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1d37df0ae839eca0$var$cumsum;
function $1d37df0ae839eca0$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("sp6gp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $055615fb74636fca$var$deviation;

var $055615fb74636fca$var$_variance = $055615fb74636fca$var$_interopRequireDefault((parcelRequire("iPfCL")));
function $055615fb74636fca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $055615fb74636fca$var$deviation(values, valueof) {
    const v = (0, $055615fb74636fca$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("iPfCL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $db491c09e43ab89f$var$variance;
function $db491c09e43ab89f$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("eH0wl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ab257c3d0701b855$var$extent;
function $ab257c3d0701b855$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("7oKSv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $562f2351eccc2efc$var$fcumsum;
module.exports.fsum = $562f2351eccc2efc$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $562f2351eccc2efc$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $562f2351eccc2efc$var$Adder;
function $562f2351eccc2efc$var$fsum(values, valueof) {
    const adder = new $562f2351eccc2efc$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $562f2351eccc2efc$var$fcumsum(values, valueof) {
    const adder = new $562f2351eccc2efc$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("5NGIB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4392aa52a4ade78f$var$group;
module.exports.flatGroup = $4392aa52a4ade78f$var$flatGroup;
module.exports.flatRollup = $4392aa52a4ade78f$var$flatRollup;
module.exports.groups = $4392aa52a4ade78f$var$groups;
module.exports.index = $4392aa52a4ade78f$var$index;
module.exports.indexes = $4392aa52a4ade78f$var$indexes;
module.exports.rollup = $4392aa52a4ade78f$var$rollup;
module.exports.rollups = $4392aa52a4ade78f$var$rollups;

var $2cuqZ = parcelRequire("2cuqZ");

var $4392aa52a4ade78f$var$_identity = $4392aa52a4ade78f$var$_interopRequireDefault((parcelRequire("eKoba")));
function $4392aa52a4ade78f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4392aa52a4ade78f$var$group(values, ...keys) {
    return $4392aa52a4ade78f$var$nest(values, $4392aa52a4ade78f$var$_identity.default, $4392aa52a4ade78f$var$_identity.default, keys);
}
function $4392aa52a4ade78f$var$groups(values, ...keys) {
    return $4392aa52a4ade78f$var$nest(values, Array.from, $4392aa52a4ade78f$var$_identity.default, keys);
}
function $4392aa52a4ade78f$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $4392aa52a4ade78f$var$flatGroup(values, ...keys) {
    return $4392aa52a4ade78f$var$flatten($4392aa52a4ade78f$var$groups(values, ...keys), keys);
}
function $4392aa52a4ade78f$var$flatRollup(values, reduce, ...keys) {
    return $4392aa52a4ade78f$var$flatten($4392aa52a4ade78f$var$rollups(values, reduce, ...keys), keys);
}
function $4392aa52a4ade78f$var$rollup(values, reduce, ...keys) {
    return $4392aa52a4ade78f$var$nest(values, $4392aa52a4ade78f$var$_identity.default, reduce, keys);
}
function $4392aa52a4ade78f$var$rollups(values, reduce, ...keys) {
    return $4392aa52a4ade78f$var$nest(values, Array.from, reduce, keys);
}
function $4392aa52a4ade78f$var$index(values, ...keys) {
    return $4392aa52a4ade78f$var$nest(values, $4392aa52a4ade78f$var$_identity.default, $4392aa52a4ade78f$var$unique, keys);
}
function $4392aa52a4ade78f$var$indexes(values, ...keys) {
    return $4392aa52a4ade78f$var$nest(values, Array.from, $4392aa52a4ade78f$var$unique, keys);
}
function $4392aa52a4ade78f$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $4392aa52a4ade78f$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $2cuqZ.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("2cuqZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $19a44f62fee8ade5$var$InternMap extends Map {
    constructor(entries, key = $19a44f62fee8ade5$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($19a44f62fee8ade5$var$intern_get(this, key));
    }
    has(key) {
        return super.has($19a44f62fee8ade5$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($19a44f62fee8ade5$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($19a44f62fee8ade5$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $19a44f62fee8ade5$var$InternMap;
class $19a44f62fee8ade5$var$InternSet extends Set {
    constructor(values, key = $19a44f62fee8ade5$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($19a44f62fee8ade5$var$intern_get(this, value));
    }
    add(value) {
        return super.add($19a44f62fee8ade5$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($19a44f62fee8ade5$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $19a44f62fee8ade5$var$InternSet;
function $19a44f62fee8ade5$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $19a44f62fee8ade5$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $19a44f62fee8ade5$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $19a44f62fee8ade5$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("eKoba", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $abc81e0c322e3def$var$identity;
function $abc81e0c322e3def$var$identity(x) {
    return x;
}

});


parcelRegister("4dUSN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $313480111e8dbd9a$var$groupSort;

var $313480111e8dbd9a$var$_ascending = $313480111e8dbd9a$var$_interopRequireDefault((parcelRequire("91TVA")));

var $313480111e8dbd9a$var$_group = $313480111e8dbd9a$var$_interopRequireWildcard((parcelRequire("5NGIB")));

var $313480111e8dbd9a$var$_sort = $313480111e8dbd9a$var$_interopRequireDefault((parcelRequire("cGOeo")));
function $313480111e8dbd9a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($313480111e8dbd9a$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $313480111e8dbd9a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $313480111e8dbd9a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $313480111e8dbd9a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $313480111e8dbd9a$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $313480111e8dbd9a$var$_sort.default)((0, $313480111e8dbd9a$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $313480111e8dbd9a$var$_ascending.default)(av, bv) || (0, $313480111e8dbd9a$var$_ascending.default)(ak, bk)) : (0, $313480111e8dbd9a$var$_sort.default)((0, $313480111e8dbd9a$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $313480111e8dbd9a$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("cGOeo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $93d05f23b607862f$var$ascendingDefined;
module.exports.compareDefined = $93d05f23b607862f$var$compareDefined;
module.exports.default = $93d05f23b607862f$var$sort;

var $93d05f23b607862f$var$_ascending = $93d05f23b607862f$var$_interopRequireDefault((parcelRequire("91TVA")));

var $93d05f23b607862f$var$_permute = $93d05f23b607862f$var$_interopRequireDefault((parcelRequire("eVtmr")));
function $93d05f23b607862f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $93d05f23b607862f$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $93d05f23b607862f$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$93d05f23b607862f$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $93d05f23b607862f$var$_permute.default)(values, index);
    }
    return values.sort($93d05f23b607862f$var$compareDefined(f));
}
function $93d05f23b607862f$var$compareDefined(compare = $93d05f23b607862f$var$_ascending.default) {
    if (compare === $93d05f23b607862f$var$_ascending.default) return $93d05f23b607862f$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $93d05f23b607862f$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("eVtmr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $addd2a0659ac1823$var$permute;
function $addd2a0659ac1823$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("3uDa0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $28b28cde6c0b4fd6$var$bin;

var $1empY = parcelRequire("1empY");

var $28b28cde6c0b4fd6$var$_bisect = $28b28cde6c0b4fd6$var$_interopRequireDefault((parcelRequire("jJqVC")));

var $28b28cde6c0b4fd6$var$_constant = $28b28cde6c0b4fd6$var$_interopRequireDefault((parcelRequire("dqrtT")));

var $28b28cde6c0b4fd6$var$_extent = $28b28cde6c0b4fd6$var$_interopRequireDefault((parcelRequire("eH0wl")));

var $28b28cde6c0b4fd6$var$_identity = $28b28cde6c0b4fd6$var$_interopRequireDefault((parcelRequire("eKoba")));

var $28b28cde6c0b4fd6$var$_nice = $28b28cde6c0b4fd6$var$_interopRequireDefault((parcelRequire("dabfk")));

var $28b28cde6c0b4fd6$var$_ticks = $28b28cde6c0b4fd6$var$_interopRequireWildcard((parcelRequire("h0sG3")));

var $28b28cde6c0b4fd6$var$_sturges = $28b28cde6c0b4fd6$var$_interopRequireDefault((parcelRequire("7FVbW")));
function $28b28cde6c0b4fd6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($28b28cde6c0b4fd6$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $28b28cde6c0b4fd6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $28b28cde6c0b4fd6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $28b28cde6c0b4fd6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $28b28cde6c0b4fd6$var$bin() {
    var value = $28b28cde6c0b4fd6$var$_identity.default, domain = $28b28cde6c0b4fd6$var$_extent.default, threshold = $28b28cde6c0b4fd6$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $28b28cde6c0b4fd6$var$_extent.default) [x0, x1] = (0, $28b28cde6c0b4fd6$var$_nice.default)(x0, x1, tn);
            tz = (0, $28b28cde6c0b4fd6$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $28b28cde6c0b4fd6$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $28b28cde6c0b4fd6$var$_extent.default) {
                    const step = (0, $28b28cde6c0b4fd6$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $28b28cde6c0b4fd6$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $28b28cde6c0b4fd6$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $28b28cde6c0b4fd6$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $28b28cde6c0b4fd6$var$_constant.default)($1empY.slice.call(_)) : (0, $28b28cde6c0b4fd6$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("1empY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $0e587cfd78d67caa$var$array = Array.prototype;
var $0e587cfd78d67caa$var$slice = $0e587cfd78d67caa$var$array.slice;
module.exports.slice = $0e587cfd78d67caa$var$slice;
var $0e587cfd78d67caa$var$map = $0e587cfd78d67caa$var$array.map;
module.exports.map = $0e587cfd78d67caa$var$map;

});

parcelRegister("dqrtT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9c6305416c9da059$var$constant;
function $9c6305416c9da059$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("dabfk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9954eecbae18e430$var$nice;

var $h0sG3 = parcelRequire("h0sG3");
function $9954eecbae18e430$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $h0sG3.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("h0sG3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c618ae72ed0a3bb9$var$ticks;
module.exports.tickIncrement = $c618ae72ed0a3bb9$var$tickIncrement;
module.exports.tickStep = $c618ae72ed0a3bb9$var$tickStep;
var $c618ae72ed0a3bb9$var$e10 = Math.sqrt(50), $c618ae72ed0a3bb9$var$e5 = Math.sqrt(10), $c618ae72ed0a3bb9$var$e2 = Math.sqrt(2);
function $c618ae72ed0a3bb9$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $c618ae72ed0a3bb9$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $c618ae72ed0a3bb9$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $c618ae72ed0a3bb9$var$e10 ? 10 : error >= $c618ae72ed0a3bb9$var$e5 ? 5 : error >= $c618ae72ed0a3bb9$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $c618ae72ed0a3bb9$var$e10 ? 10 : error >= $c618ae72ed0a3bb9$var$e5 ? 5 : error >= $c618ae72ed0a3bb9$var$e2 ? 2 : 1);
}
function $c618ae72ed0a3bb9$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $c618ae72ed0a3bb9$var$e10) step1 *= 10;
    else if (error >= $c618ae72ed0a3bb9$var$e5) step1 *= 5;
    else if (error >= $c618ae72ed0a3bb9$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("7FVbW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5968b9cf31930c01$var$thresholdSturges;

var $5968b9cf31930c01$var$_count = $5968b9cf31930c01$var$_interopRequireDefault((parcelRequire("9efkv")));
function $5968b9cf31930c01$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5968b9cf31930c01$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $5968b9cf31930c01$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("5QEXO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $442195a4b0ad868e$var$thresholdFreedmanDiaconis;

var $442195a4b0ad868e$var$_count = $442195a4b0ad868e$var$_interopRequireDefault((parcelRequire("9efkv")));

var $442195a4b0ad868e$var$_quantile = $442195a4b0ad868e$var$_interopRequireDefault((parcelRequire("hC26C")));
function $442195a4b0ad868e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $442195a4b0ad868e$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $442195a4b0ad868e$var$_quantile.default)(values, 0.75) - (0, $442195a4b0ad868e$var$_quantile.default)(values, 0.25)) * Math.pow((0, $442195a4b0ad868e$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("hC26C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cd279e713248da5c$var$quantile;
module.exports.quantileSorted = $cd279e713248da5c$var$quantileSorted;

var $cd279e713248da5c$var$_max = $cd279e713248da5c$var$_interopRequireDefault((parcelRequire("d80JQ")));

var $cd279e713248da5c$var$_min = $cd279e713248da5c$var$_interopRequireDefault((parcelRequire("cBxyK")));

var $cd279e713248da5c$var$_quickselect = $cd279e713248da5c$var$_interopRequireDefault((parcelRequire("4sZvs")));

var $cd279e713248da5c$var$_number = $cd279e713248da5c$var$_interopRequireWildcard((parcelRequire("dDbKt")));
function $cd279e713248da5c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cd279e713248da5c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cd279e713248da5c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cd279e713248da5c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $cd279e713248da5c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cd279e713248da5c$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $cd279e713248da5c$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $cd279e713248da5c$var$_min.default)(values);
    if (p >= 1) return (0, $cd279e713248da5c$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $cd279e713248da5c$var$_max.default)((0, $cd279e713248da5c$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $cd279e713248da5c$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $cd279e713248da5c$var$quantileSorted(values, p, valueof = $cd279e713248da5c$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("d80JQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $98ec985fbba317ac$var$max;
function $98ec985fbba317ac$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("cBxyK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $92d2f8f83fb7597c$var$min;
function $92d2f8f83fb7597c$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("4sZvs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $34097cda6ae17a4a$var$quickselect;

var $cGOeo = parcelRequire("cGOeo");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $34097cda6ae17a4a$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $cGOeo.ascendingDefined : (0, $cGOeo.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $34097cda6ae17a4a$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $34097cda6ae17a4a$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $34097cda6ae17a4a$var$swap(array, left, right);
        while(i < j){
            $34097cda6ae17a4a$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $34097cda6ae17a4a$var$swap(array, left, j);
        else ++j, $34097cda6ae17a4a$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $34097cda6ae17a4a$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("fhlzT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1f92e72f2061436$var$thresholdScott;

var $b1f92e72f2061436$var$_count = $b1f92e72f2061436$var$_interopRequireDefault((parcelRequire("9efkv")));

var $b1f92e72f2061436$var$_deviation = $b1f92e72f2061436$var$_interopRequireDefault((parcelRequire("sp6gp")));
function $b1f92e72f2061436$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b1f92e72f2061436$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $b1f92e72f2061436$var$_count.default)(values)) / (3.49 * (0, $b1f92e72f2061436$var$_deviation.default)(values)));
}

});

parcelRegister("aNW09", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ddb78df758878c3$var$maxIndex;
function $7ddb78df758878c3$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("julZn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e301e036ef3ed8c4$var$mean;
function $e301e036ef3ed8c4$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("9ScMN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7303133a8bff4086$var$median;

var $7303133a8bff4086$var$_quantile = $7303133a8bff4086$var$_interopRequireDefault((parcelRequire("hC26C")));
function $7303133a8bff4086$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7303133a8bff4086$var$median(values, valueof) {
    return (0, $7303133a8bff4086$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("iXEPJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dcdd695b2ca85775$var$merge;
function* $dcdd695b2ca85775$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $dcdd695b2ca85775$var$merge(arrays) {
    return Array.from($dcdd695b2ca85775$var$flatten(arrays));
}

});

parcelRegister("dWfPM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a25cf97e556e3b2c$var$minIndex;
function $a25cf97e556e3b2c$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("gL4hx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c3345b6b9d3aa49c$var$mode;

var $2cuqZ = parcelRequire("2cuqZ");
function $c3345b6b9d3aa49c$var$mode(values, valueof) {
    const counts = new $2cuqZ.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("5FQ0p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $42191f4e9b1b61f9$var$pairs;
module.exports.pair = $42191f4e9b1b61f9$var$pair;
function $42191f4e9b1b61f9$var$pairs(values, pairof = $42191f4e9b1b61f9$var$pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $42191f4e9b1b61f9$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("ks8up", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ee3d01fecc079c7f$var$range;
function $ee3d01fecc079c7f$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("fE6wx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $02f082b16256015f$var$rank;

var $02f082b16256015f$var$_ascending = $02f082b16256015f$var$_interopRequireDefault((parcelRequire("91TVA")));

var $cGOeo = parcelRequire("cGOeo");
function $02f082b16256015f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $02f082b16256015f$var$rank(values, valueof = $02f082b16256015f$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $02f082b16256015f$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $02f082b16256015f$var$_ascending.default ? (i, j)=>(0, $cGOeo.ascendingDefined)(V[i], V[j]) : (0, $cGOeo.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("aCVi9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7bc9e4f6f8c0593a$var$least;

var $7bc9e4f6f8c0593a$var$_ascending = $7bc9e4f6f8c0593a$var$_interopRequireDefault((parcelRequire("91TVA")));
function $7bc9e4f6f8c0593a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7bc9e4f6f8c0593a$var$least(values, compare = $7bc9e4f6f8c0593a$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $7bc9e4f6f8c0593a$var$_ascending.default)(value, minValue) < 0 : (0, $7bc9e4f6f8c0593a$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("9RV6m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $01daaac3f5b8cf0e$var$leastIndex;

var $01daaac3f5b8cf0e$var$_ascending = $01daaac3f5b8cf0e$var$_interopRequireDefault((parcelRequire("91TVA")));

var $01daaac3f5b8cf0e$var$_minIndex = $01daaac3f5b8cf0e$var$_interopRequireDefault((parcelRequire("dWfPM")));
function $01daaac3f5b8cf0e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $01daaac3f5b8cf0e$var$leastIndex(values, compare = $01daaac3f5b8cf0e$var$_ascending.default) {
    if (compare.length === 1) return (0, $01daaac3f5b8cf0e$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("6dn7d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4865e331b80d5538$var$greatest;

var $4865e331b80d5538$var$_ascending = $4865e331b80d5538$var$_interopRequireDefault((parcelRequire("91TVA")));
function $4865e331b80d5538$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4865e331b80d5538$var$greatest(values, compare = $4865e331b80d5538$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $4865e331b80d5538$var$_ascending.default)(value, maxValue) > 0 : (0, $4865e331b80d5538$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("eUEph", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adb5a398bc8d5e1f$var$greatestIndex;

var $adb5a398bc8d5e1f$var$_ascending = $adb5a398bc8d5e1f$var$_interopRequireDefault((parcelRequire("91TVA")));

var $adb5a398bc8d5e1f$var$_maxIndex = $adb5a398bc8d5e1f$var$_interopRequireDefault((parcelRequire("aNW09")));
function $adb5a398bc8d5e1f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $adb5a398bc8d5e1f$var$greatestIndex(values, compare = $adb5a398bc8d5e1f$var$_ascending.default) {
    if (compare.length === 1) return (0, $adb5a398bc8d5e1f$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("kwDkv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ef154dd994e355b4$var$scan;

var $ef154dd994e355b4$var$_leastIndex = $ef154dd994e355b4$var$_interopRequireDefault((parcelRequire("9RV6m")));
function $ef154dd994e355b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ef154dd994e355b4$var$scan(values, compare) {
    const index = (0, $ef154dd994e355b4$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("80rQz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $5d43eca629783c0e$var$shuffler;
var $5d43eca629783c0e$var$_default = $5d43eca629783c0e$var$shuffler(Math.random);
module.exports.default = $5d43eca629783c0e$var$_default;
function $5d43eca629783c0e$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("jztKV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e3f85e16cb7146ee$var$sum;
function $e3f85e16cb7146ee$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("7UtqA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5c24971f7e7dd914$var$transpose;

var $5c24971f7e7dd914$var$_min = $5c24971f7e7dd914$var$_interopRequireDefault((parcelRequire("cBxyK")));
function $5c24971f7e7dd914$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5c24971f7e7dd914$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $5c24971f7e7dd914$var$_min.default)(matrix, $5c24971f7e7dd914$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $5c24971f7e7dd914$var$length(d) {
    return d.length;
}

});

parcelRegister("liFYF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f81bd74223827e4a$var$zip;

var $f81bd74223827e4a$var$_transpose = $f81bd74223827e4a$var$_interopRequireDefault((parcelRequire("7UtqA")));
function $f81bd74223827e4a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f81bd74223827e4a$var$zip() {
    return (0, $f81bd74223827e4a$var$_transpose.default)(arguments);
}

});

parcelRegister("kG3uY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f0da71a144f87552$var$every;
function $f0da71a144f87552$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("2AzDG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1e2a96be0461813d$var$some;
function $1e2a96be0461813d$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("du5hp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9d122c2f4f3768a3$var$filter;
function $9d122c2f4f3768a3$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("iEQsJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d954a85bc72de3af$var$map;
function $d954a85bc72de3af$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("gW5zZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c546641407b9b0e2$var$reduce;
function $c546641407b9b0e2$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("5iYl5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3dcd7049a2d5e18e$var$reverse;
function $3dcd7049a2d5e18e$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("geif6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bd0c1ac1581e74d9$var$difference;

var $2cuqZ = parcelRequire("2cuqZ");
function $bd0c1ac1581e74d9$var$difference(values, ...others) {
    values = new $2cuqZ.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("j1hsm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0392c4c1425fd725$var$disjoint;

var $2cuqZ = parcelRequire("2cuqZ");
function $0392c4c1425fd725$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $2cuqZ.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("8afoJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f1b33979f7beeb7$var$intersection;

var $2cuqZ = parcelRequire("2cuqZ");
function $5f1b33979f7beeb7$var$intersection(values, ...others) {
    values = new $2cuqZ.InternSet(values);
    others = others.map($5f1b33979f7beeb7$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $5f1b33979f7beeb7$var$set(values) {
    return values instanceof $2cuqZ.InternSet ? values : new $2cuqZ.InternSet(values);
}

});

parcelRegister("lDcPp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fbf730e82a70d3d3$var$subset;

var $fbf730e82a70d3d3$var$_superset = $fbf730e82a70d3d3$var$_interopRequireDefault((parcelRequire("53SJi")));
function $fbf730e82a70d3d3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fbf730e82a70d3d3$var$subset(values, other) {
    return (0, $fbf730e82a70d3d3$var$_superset.default)(other, values);
}

});
parcelRegister("53SJi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3af7afb19d90cbd7$var$superset;
function $3af7afb19d90cbd7$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $3af7afb19d90cbd7$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $3af7afb19d90cbd7$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $3af7afb19d90cbd7$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("5yoRS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $40b36aff0de16871$var$union;

var $2cuqZ = parcelRequire("2cuqZ");
function $40b36aff0de16871$var$union(...others) {
    const set = new $2cuqZ.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("beTth", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $82ec07ef908c1a06$var$initInterpolator;
module.exports.initRange = $82ec07ef908c1a06$var$initRange;
function $82ec07ef908c1a06$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $82ec07ef908c1a06$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("cPFRk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $957ab7c9fbd84f22$var$ordinal;
module.exports.implicit = void 0;

var $e3Byi = parcelRequire("e3Byi");

var $beTth = parcelRequire("beTth");
const $957ab7c9fbd84f22$var$implicit = Symbol("implicit");
module.exports.implicit = $957ab7c9fbd84f22$var$implicit;
function $957ab7c9fbd84f22$var$ordinal() {
    var index = new $e3Byi.InternMap(), domain = [], range = [], unknown = $957ab7c9fbd84f22$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $957ab7c9fbd84f22$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $e3Byi.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $957ab7c9fbd84f22$var$ordinal(domain, range).unknown(unknown);
    };
    $beTth.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("2wYci", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1d7d43da8b104a02$var$identity;

var $4rEkf = parcelRequire("4rEkf");

var $1d7d43da8b104a02$var$_number = $1d7d43da8b104a02$var$_interopRequireDefault((parcelRequire("3Kkqc")));
function $1d7d43da8b104a02$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1d7d43da8b104a02$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $1d7d43da8b104a02$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $1d7d43da8b104a02$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $1d7d43da8b104a02$var$_number.default) : [
        0,
        1
    ];
    return (0, $4rEkf.linearish)(scale);
}

});
parcelRegister("4rEkf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $33c8f6ddfa8b2760$var$linear;
module.exports.linearish = $33c8f6ddfa8b2760$var$linearish;

var $e3Byi = parcelRequire("e3Byi");

var $33c8f6ddfa8b2760$var$_continuous = $33c8f6ddfa8b2760$var$_interopRequireWildcard((parcelRequire("9VEML")));

var $beTth = parcelRequire("beTth");

var $33c8f6ddfa8b2760$var$_tickFormat = $33c8f6ddfa8b2760$var$_interopRequireDefault((parcelRequire("3pGSJ")));
function $33c8f6ddfa8b2760$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $33c8f6ddfa8b2760$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($33c8f6ddfa8b2760$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $33c8f6ddfa8b2760$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $33c8f6ddfa8b2760$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $33c8f6ddfa8b2760$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $e3Byi.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $33c8f6ddfa8b2760$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $e3Byi.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $33c8f6ddfa8b2760$var$linear() {
    var scale = (0, $33c8f6ddfa8b2760$var$_continuous.default)();
    scale.copy = function() {
        return (0, $33c8f6ddfa8b2760$var$_continuous.copy)(scale, $33c8f6ddfa8b2760$var$linear());
    };
    $beTth.initRange.apply(scale, arguments);
    return $33c8f6ddfa8b2760$var$linearish(scale);
}

});
parcelRegister("9VEML", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $73a91319e5f6550d$var$copy;
module.exports.default = $73a91319e5f6550d$var$continuous;
module.exports.identity = $73a91319e5f6550d$var$identity;
module.exports.transformer = $73a91319e5f6550d$var$transformer;

var $e3Byi = parcelRequire("e3Byi");

var $67YIC = parcelRequire("67YIC");

var $73a91319e5f6550d$var$_constant = $73a91319e5f6550d$var$_interopRequireDefault((parcelRequire("aTzkN")));

var $73a91319e5f6550d$var$_number = $73a91319e5f6550d$var$_interopRequireDefault((parcelRequire("3Kkqc")));
function $73a91319e5f6550d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $73a91319e5f6550d$var$unit = [
    0,
    1
];
function $73a91319e5f6550d$var$identity(x) {
    return x;
}
function $73a91319e5f6550d$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $73a91319e5f6550d$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $73a91319e5f6550d$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $73a91319e5f6550d$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $73a91319e5f6550d$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $73a91319e5f6550d$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $73a91319e5f6550d$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $73a91319e5f6550d$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $e3Byi.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $73a91319e5f6550d$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $73a91319e5f6550d$var$transformer() {
    var domain = $73a91319e5f6550d$var$unit, range = $73a91319e5f6550d$var$unit, interpolate = $67YIC.interpolate, transform, untransform, unknown, clamp = $73a91319e5f6550d$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $73a91319e5f6550d$var$identity) clamp = $73a91319e5f6550d$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $73a91319e5f6550d$var$polymap : $73a91319e5f6550d$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $67YIC.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $73a91319e5f6550d$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $67YIC.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $73a91319e5f6550d$var$identity, rescale()) : clamp !== $73a91319e5f6550d$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $73a91319e5f6550d$var$continuous() {
    return $73a91319e5f6550d$var$transformer()($73a91319e5f6550d$var$identity, $73a91319e5f6550d$var$identity);
}

});
parcelRegister("67YIC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $eC4UI.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $eC4UI.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $47627ef7a5fe0b40$var$_quantize.default;
    }
});

var $47627ef7a5fe0b40$var$_value = $47627ef7a5fe0b40$var$_interopRequireDefault((parcelRequire("c2CcN")));

var $47627ef7a5fe0b40$var$_array = $47627ef7a5fe0b40$var$_interopRequireDefault((parcelRequire("9l0Pr")));

var $47627ef7a5fe0b40$var$_basis = $47627ef7a5fe0b40$var$_interopRequireDefault((parcelRequire("1ewbm")));

var $47627ef7a5fe0b40$var$_basisClosed = $47627ef7a5fe0b40$var$_interopRequireDefault((parcelRequire("lgmKA")));

var $47627ef7a5fe0b40$var$_date = $47627ef7a5fe0b40$var$_interopRequireDefault((parcelRequire("eTYfZ")));

var $47627ef7a5fe0b40$var$_discrete = $47627ef7a5fe0b40$var$_interopRequireDefault((parcelRequire("fMhQw")));

var $47627ef7a5fe0b40$var$_hue = $47627ef7a5fe0b40$var$_interopRequireDefault((parcelRequire("kDXjh")));

var $47627ef7a5fe0b40$var$_number = $47627ef7a5fe0b40$var$_interopRequireDefault((parcelRequire("9I5q6")));

var $47627ef7a5fe0b40$var$_numberArray = $47627ef7a5fe0b40$var$_interopRequireDefault((parcelRequire("h1h5y")));

var $47627ef7a5fe0b40$var$_object = $47627ef7a5fe0b40$var$_interopRequireDefault((parcelRequire("1OWLb")));

var $47627ef7a5fe0b40$var$_round = $47627ef7a5fe0b40$var$_interopRequireDefault((parcelRequire("eWXz4")));

var $47627ef7a5fe0b40$var$_string = $47627ef7a5fe0b40$var$_interopRequireDefault((parcelRequire("a3RV3")));

var $eC4UI = parcelRequire("eC4UI");

var $47627ef7a5fe0b40$var$_zoom = $47627ef7a5fe0b40$var$_interopRequireDefault((parcelRequire("lSxSQ")));

var $47627ef7a5fe0b40$var$_rgb = $47627ef7a5fe0b40$var$_interopRequireWildcard((parcelRequire("kDsb3")));

var $47627ef7a5fe0b40$var$_hsl = $47627ef7a5fe0b40$var$_interopRequireWildcard((parcelRequire("dhJad")));

var $47627ef7a5fe0b40$var$_lab = $47627ef7a5fe0b40$var$_interopRequireDefault((parcelRequire("hJ9K8")));

var $47627ef7a5fe0b40$var$_hcl = $47627ef7a5fe0b40$var$_interopRequireWildcard((parcelRequire("l8Tov")));

var $47627ef7a5fe0b40$var$_cubehelix = $47627ef7a5fe0b40$var$_interopRequireWildcard((parcelRequire("6FZ20")));

var $47627ef7a5fe0b40$var$_piecewise = $47627ef7a5fe0b40$var$_interopRequireDefault((parcelRequire("dVfAt")));

var $47627ef7a5fe0b40$var$_quantize = $47627ef7a5fe0b40$var$_interopRequireDefault((parcelRequire("g5hwz")));
function $47627ef7a5fe0b40$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($47627ef7a5fe0b40$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $47627ef7a5fe0b40$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $47627ef7a5fe0b40$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $47627ef7a5fe0b40$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("c2CcN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c434ec06dd8f9f2$var$_default;

var $x0scs = parcelRequire("x0scs");

var $8c434ec06dd8f9f2$var$_rgb = $8c434ec06dd8f9f2$var$_interopRequireDefault((parcelRequire("kDsb3")));

var $9l0Pr = parcelRequire("9l0Pr");

var $8c434ec06dd8f9f2$var$_date = $8c434ec06dd8f9f2$var$_interopRequireDefault((parcelRequire("eTYfZ")));

var $8c434ec06dd8f9f2$var$_number = $8c434ec06dd8f9f2$var$_interopRequireDefault((parcelRequire("9I5q6")));

var $8c434ec06dd8f9f2$var$_object = $8c434ec06dd8f9f2$var$_interopRequireDefault((parcelRequire("1OWLb")));

var $8c434ec06dd8f9f2$var$_string = $8c434ec06dd8f9f2$var$_interopRequireDefault((parcelRequire("a3RV3")));

var $8c434ec06dd8f9f2$var$_constant = $8c434ec06dd8f9f2$var$_interopRequireDefault((parcelRequire("ibKvj")));

var $8c434ec06dd8f9f2$var$_numberArray = $8c434ec06dd8f9f2$var$_interopRequireWildcard((parcelRequire("h1h5y")));
function $8c434ec06dd8f9f2$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8c434ec06dd8f9f2$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8c434ec06dd8f9f2$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8c434ec06dd8f9f2$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8c434ec06dd8f9f2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8c434ec06dd8f9f2$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $8c434ec06dd8f9f2$var$_constant.default)(b) : (t === "number" ? $8c434ec06dd8f9f2$var$_number.default : t === "string" ? (c = (0, $x0scs.color)(b)) ? (b = c, $8c434ec06dd8f9f2$var$_rgb.default) : $8c434ec06dd8f9f2$var$_string.default : b instanceof $x0scs.color ? $8c434ec06dd8f9f2$var$_rgb.default : b instanceof Date ? $8c434ec06dd8f9f2$var$_date.default : (0, $8c434ec06dd8f9f2$var$_numberArray.isNumberArray)(b) ? $8c434ec06dd8f9f2$var$_numberArray.default : Array.isArray(b) ? $9l0Pr.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $8c434ec06dd8f9f2$var$_object.default : $8c434ec06dd8f9f2$var$_number.default)(a, b);
}

});
parcelRegister("x0scs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $06336f4e00c20f4c$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $06336f4e00c20f4c$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $06336f4e00c20f4c$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $06336f4e00c20f4c$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $06336f4e00c20f4c$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $06336f4e00c20f4c$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $06336f4e00c20f4c$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $06336f4e00c20f4c$var$_color.rgb;
    }
});

var $06336f4e00c20f4c$var$_color = $06336f4e00c20f4c$var$_interopRequireWildcard((parcelRequire("fGluG")));

var $06336f4e00c20f4c$var$_lab = $06336f4e00c20f4c$var$_interopRequireWildcard((parcelRequire("2XnFj")));

var $06336f4e00c20f4c$var$_cubehelix = $06336f4e00c20f4c$var$_interopRequireDefault((parcelRequire("hLSsZ")));
function $06336f4e00c20f4c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $06336f4e00c20f4c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($06336f4e00c20f4c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $06336f4e00c20f4c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $06336f4e00c20f4c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("fGluG", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("2FGko")));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("2FGko", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1f203e88a19640c3$var$_default;
module.exports.extend = $1f203e88a19640c3$var$extend;
function $1f203e88a19640c3$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $1f203e88a19640c3$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("2XnFj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $227372eb4189011c$var$Hcl;
module.exports.Lab = $227372eb4189011c$var$Lab;
module.exports.default = $227372eb4189011c$var$lab;
module.exports.gray = $227372eb4189011c$var$gray;
module.exports.hcl = $227372eb4189011c$var$hcl;
module.exports.lch = $227372eb4189011c$var$lch;

var $227372eb4189011c$var$_define = $227372eb4189011c$var$_interopRequireWildcard((parcelRequire("2FGko")));

var $fGluG = parcelRequire("fGluG");

var $7v0AW = parcelRequire("7v0AW");
function $227372eb4189011c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($227372eb4189011c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $227372eb4189011c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $227372eb4189011c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $227372eb4189011c$var$K = 18, $227372eb4189011c$var$Xn = 0.96422, $227372eb4189011c$var$Yn = 1, $227372eb4189011c$var$Zn = 0.82521, $227372eb4189011c$var$t0 = 4 / 29, $227372eb4189011c$var$t1 = 6 / 29, $227372eb4189011c$var$t2 = 3 * $227372eb4189011c$var$t1 * $227372eb4189011c$var$t1, $227372eb4189011c$var$t3 = $227372eb4189011c$var$t1 * $227372eb4189011c$var$t1 * $227372eb4189011c$var$t1;
function $227372eb4189011c$var$labConvert(o) {
    if (o instanceof $227372eb4189011c$var$Lab) return new $227372eb4189011c$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $227372eb4189011c$var$Hcl) return $227372eb4189011c$var$hcl2lab(o);
    if (!(o instanceof $fGluG.Rgb)) o = (0, $fGluG.rgbConvert)(o);
    var r = $227372eb4189011c$var$rgb2lrgb(o.r), g = $227372eb4189011c$var$rgb2lrgb(o.g), b = $227372eb4189011c$var$rgb2lrgb(o.b), y = $227372eb4189011c$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $227372eb4189011c$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $227372eb4189011c$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $227372eb4189011c$var$Xn);
        z = $227372eb4189011c$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $227372eb4189011c$var$Zn);
    }
    return new $227372eb4189011c$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $227372eb4189011c$var$gray(l, opacity) {
    return new $227372eb4189011c$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $227372eb4189011c$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $227372eb4189011c$var$labConvert(l) : new $227372eb4189011c$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $227372eb4189011c$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $227372eb4189011c$var$_define.default)($227372eb4189011c$var$Lab, $227372eb4189011c$var$lab, (0, $227372eb4189011c$var$_define.extend)($fGluG.Color, {
    brighter (k) {
        return new $227372eb4189011c$var$Lab(this.l + $227372eb4189011c$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $227372eb4189011c$var$Lab(this.l - $227372eb4189011c$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $227372eb4189011c$var$Xn * $227372eb4189011c$var$lab2xyz(x);
        y = $227372eb4189011c$var$Yn * $227372eb4189011c$var$lab2xyz(y);
        z = $227372eb4189011c$var$Zn * $227372eb4189011c$var$lab2xyz(z);
        return new $fGluG.Rgb($227372eb4189011c$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $227372eb4189011c$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $227372eb4189011c$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $227372eb4189011c$var$xyz2lab(t) {
    return t > $227372eb4189011c$var$t3 ? Math.pow(t, 1 / 3) : t / $227372eb4189011c$var$t2 + $227372eb4189011c$var$t0;
}
function $227372eb4189011c$var$lab2xyz(t) {
    return t > $227372eb4189011c$var$t1 ? t * t * t : $227372eb4189011c$var$t2 * (t - $227372eb4189011c$var$t0);
}
function $227372eb4189011c$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $227372eb4189011c$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $227372eb4189011c$var$hclConvert(o) {
    if (o instanceof $227372eb4189011c$var$Hcl) return new $227372eb4189011c$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $227372eb4189011c$var$Lab)) o = $227372eb4189011c$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $227372eb4189011c$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $7v0AW.degrees;
    return new $227372eb4189011c$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $227372eb4189011c$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $227372eb4189011c$var$hclConvert(l) : new $227372eb4189011c$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $227372eb4189011c$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $227372eb4189011c$var$hclConvert(h) : new $227372eb4189011c$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $227372eb4189011c$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $227372eb4189011c$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $227372eb4189011c$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $7v0AW.radians;
    return new $227372eb4189011c$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $227372eb4189011c$var$_define.default)($227372eb4189011c$var$Hcl, $227372eb4189011c$var$hcl, (0, $227372eb4189011c$var$_define.extend)($fGluG.Color, {
    brighter (k) {
        return new $227372eb4189011c$var$Hcl(this.h, this.c, this.l + $227372eb4189011c$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $227372eb4189011c$var$Hcl(this.h, this.c, this.l - $227372eb4189011c$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $227372eb4189011c$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("7v0AW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $575be3c02bd817c1$var$radians = Math.PI / 180;
module.exports.radians = $575be3c02bd817c1$var$radians;
const $575be3c02bd817c1$var$degrees = 180 / Math.PI;
module.exports.degrees = $575be3c02bd817c1$var$degrees;

});


parcelRegister("hLSsZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $cf01135c9af19027$var$Cubehelix;
module.exports.default = $cf01135c9af19027$var$cubehelix;

var $cf01135c9af19027$var$_define = $cf01135c9af19027$var$_interopRequireWildcard((parcelRequire("2FGko")));

var $fGluG = parcelRequire("fGluG");

var $7v0AW = parcelRequire("7v0AW");
function $cf01135c9af19027$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cf01135c9af19027$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cf01135c9af19027$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cf01135c9af19027$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $cf01135c9af19027$var$A = -0.14861, $cf01135c9af19027$var$B = 1.78277, $cf01135c9af19027$var$C = -0.29227, $cf01135c9af19027$var$D = -0.90649, $cf01135c9af19027$var$E = 1.97294, $cf01135c9af19027$var$ED = $cf01135c9af19027$var$E * $cf01135c9af19027$var$D, $cf01135c9af19027$var$EB = $cf01135c9af19027$var$E * $cf01135c9af19027$var$B, $cf01135c9af19027$var$BC_DA = $cf01135c9af19027$var$B * $cf01135c9af19027$var$C - $cf01135c9af19027$var$D * $cf01135c9af19027$var$A;
function $cf01135c9af19027$var$cubehelixConvert(o) {
    if (o instanceof $cf01135c9af19027$var$Cubehelix) return new $cf01135c9af19027$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $fGluG.Rgb)) o = (0, $fGluG.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($cf01135c9af19027$var$BC_DA * b + $cf01135c9af19027$var$ED * r - $cf01135c9af19027$var$EB * g) / ($cf01135c9af19027$var$BC_DA + $cf01135c9af19027$var$ED - $cf01135c9af19027$var$EB), bl = b - l, k = ($cf01135c9af19027$var$E * (g - l) - $cf01135c9af19027$var$C * bl) / $cf01135c9af19027$var$D, s = Math.sqrt(k * k + bl * bl) / ($cf01135c9af19027$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $7v0AW.degrees - 120 : NaN;
    return new $cf01135c9af19027$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $cf01135c9af19027$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $cf01135c9af19027$var$cubehelixConvert(h) : new $cf01135c9af19027$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $cf01135c9af19027$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $cf01135c9af19027$var$_define.default)($cf01135c9af19027$var$Cubehelix, $cf01135c9af19027$var$cubehelix, (0, $cf01135c9af19027$var$_define.extend)($fGluG.Color, {
    brighter (k) {
        k = k == null ? $fGluG.brighter : Math.pow($fGluG.brighter, k);
        return new $cf01135c9af19027$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $fGluG.darker : Math.pow($fGluG.darker, k);
        return new $cf01135c9af19027$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $7v0AW.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $fGluG.Rgb(255 * (l + a * ($cf01135c9af19027$var$A * cosh + $cf01135c9af19027$var$B * sinh)), 255 * (l + a * ($cf01135c9af19027$var$C * cosh + $cf01135c9af19027$var$D * sinh)), 255 * (l + a * ($cf01135c9af19027$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("kDsb3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $x0scs = parcelRequire("x0scs");

var $f05d4e9adf7e3349$var$_basis = $f05d4e9adf7e3349$var$_interopRequireDefault((parcelRequire("1ewbm")));

var $f05d4e9adf7e3349$var$_basisClosed = $f05d4e9adf7e3349$var$_interopRequireDefault((parcelRequire("lgmKA")));

var $f05d4e9adf7e3349$var$_color = $f05d4e9adf7e3349$var$_interopRequireWildcard((parcelRequire("62fLb")));
function $f05d4e9adf7e3349$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f05d4e9adf7e3349$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f05d4e9adf7e3349$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f05d4e9adf7e3349$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f05d4e9adf7e3349$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f05d4e9adf7e3349$var$_default = function rgbGamma(y) {
    var color = (0, $f05d4e9adf7e3349$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $x0scs.rgb)(start)).r, (end = (0, $x0scs.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $f05d4e9adf7e3349$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $f05d4e9adf7e3349$var$_default;
function $f05d4e9adf7e3349$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $x0scs.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $f05d4e9adf7e3349$var$rgbBasis = $f05d4e9adf7e3349$var$rgbSpline($f05d4e9adf7e3349$var$_basis.default);
module.exports.rgbBasis = $f05d4e9adf7e3349$var$rgbBasis;
var $f05d4e9adf7e3349$var$rgbBasisClosed = $f05d4e9adf7e3349$var$rgbSpline($f05d4e9adf7e3349$var$_basisClosed.default);
module.exports.rgbBasisClosed = $f05d4e9adf7e3349$var$rgbBasisClosed;

});
parcelRegister("1ewbm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $0e600ff6a7587e7f$var$basis;
module.exports.default = $0e600ff6a7587e7f$var$_default;
function $0e600ff6a7587e7f$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $0e600ff6a7587e7f$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $0e600ff6a7587e7f$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("lgmKA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f7acbd595a7a4609$var$_default;

var $1ewbm = parcelRequire("1ewbm");
function $f7acbd595a7a4609$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $1ewbm.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("62fLb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $464f27945905ab1e$var$nogamma;
module.exports.gamma = $464f27945905ab1e$var$gamma;
module.exports.hue = $464f27945905ab1e$var$hue;

var $464f27945905ab1e$var$_constant = $464f27945905ab1e$var$_interopRequireDefault((parcelRequire("ibKvj")));
function $464f27945905ab1e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $464f27945905ab1e$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $464f27945905ab1e$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $464f27945905ab1e$var$hue(a, b) {
    var d = b - a;
    return d ? $464f27945905ab1e$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $464f27945905ab1e$var$_constant.default)(isNaN(a) ? b : a);
}
function $464f27945905ab1e$var$gamma(y) {
    return (y = +y) === 1 ? $464f27945905ab1e$var$nogamma : function(a, b) {
        return b - a ? $464f27945905ab1e$var$exponential(a, b, y) : (0, $464f27945905ab1e$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $464f27945905ab1e$var$nogamma(a, b) {
    var d = b - a;
    return d ? $464f27945905ab1e$var$linear(a, d) : (0, $464f27945905ab1e$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("ibKvj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $d3dd53cce96e45b5$var$_default = (x)=>()=>x;
module.exports.default = $d3dd53cce96e45b5$var$_default;

});



parcelRegister("9l0Pr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6cc6b7cc94907012$var$_default;
module.exports.genericArray = $6cc6b7cc94907012$var$genericArray;

var $6cc6b7cc94907012$var$_value = $6cc6b7cc94907012$var$_interopRequireDefault((parcelRequire("c2CcN")));

var $6cc6b7cc94907012$var$_numberArray = $6cc6b7cc94907012$var$_interopRequireWildcard((parcelRequire("h1h5y")));
function $6cc6b7cc94907012$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6cc6b7cc94907012$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6cc6b7cc94907012$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6cc6b7cc94907012$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $6cc6b7cc94907012$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6cc6b7cc94907012$var$_default(a, b) {
    return ((0, $6cc6b7cc94907012$var$_numberArray.isNumberArray)(b) ? $6cc6b7cc94907012$var$_numberArray.default : $6cc6b7cc94907012$var$genericArray)(a, b);
}
function $6cc6b7cc94907012$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $6cc6b7cc94907012$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("h1h5y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c63fc91830916c6b$var$_default;
module.exports.isNumberArray = $c63fc91830916c6b$var$isNumberArray;
function $c63fc91830916c6b$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $c63fc91830916c6b$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("eTYfZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ad94f1802348c6ce$var$_default;
function $ad94f1802348c6ce$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("9I5q6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $711c6d69e637111d$var$_default;
function $711c6d69e637111d$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("1OWLb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $15380a7ef275511b$var$_default;

var $15380a7ef275511b$var$_value = $15380a7ef275511b$var$_interopRequireDefault((parcelRequire("c2CcN")));
function $15380a7ef275511b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $15380a7ef275511b$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $15380a7ef275511b$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("a3RV3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $75340274f6b5f07a$var$_default;

var $75340274f6b5f07a$var$_number = $75340274f6b5f07a$var$_interopRequireDefault((parcelRequire("9I5q6")));
function $75340274f6b5f07a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $75340274f6b5f07a$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $75340274f6b5f07a$var$reB = new RegExp($75340274f6b5f07a$var$reA.source, "g");
function $75340274f6b5f07a$var$zero(b) {
    return function() {
        return b;
    };
}
function $75340274f6b5f07a$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $75340274f6b5f07a$var$_default(a, b) {
    var bi = $75340274f6b5f07a$var$reA.lastIndex = $75340274f6b5f07a$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $75340274f6b5f07a$var$reA.exec(a)) && (bm = $75340274f6b5f07a$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $75340274f6b5f07a$var$_number.default)(am, bm)
            });
        }
        bi = $75340274f6b5f07a$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $75340274f6b5f07a$var$one(q[0].x) : $75340274f6b5f07a$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("fMhQw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7c92e91d6ed05d6$var$_default;
function $b7c92e91d6ed05d6$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("kDXjh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f07574e5242b068d$var$_default;

var $62fLb = parcelRequire("62fLb");
function $f07574e5242b068d$var$_default(a, b) {
    var i = (0, $62fLb.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("eWXz4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae24afc7c7bba8bb$var$_default;
function $ae24afc7c7bba8bb$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("eC4UI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $aa386d10b75de84e$var$_number = $aa386d10b75de84e$var$_interopRequireDefault((parcelRequire("9I5q6")));

var $kFX0a = parcelRequire("kFX0a");
function $aa386d10b75de84e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aa386d10b75de84e$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $aa386d10b75de84e$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $aa386d10b75de84e$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $aa386d10b75de84e$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $aa386d10b75de84e$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $aa386d10b75de84e$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $aa386d10b75de84e$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $aa386d10b75de84e$var$interpolateTransformCss = $aa386d10b75de84e$var$interpolateTransform($kFX0a.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $aa386d10b75de84e$var$interpolateTransformCss;
var $aa386d10b75de84e$var$interpolateTransformSvg = $aa386d10b75de84e$var$interpolateTransform($kFX0a.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $aa386d10b75de84e$var$interpolateTransformSvg;

});
parcelRegister("kFX0a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $f0d5677e3441656c$var$parseCss;
module.exports.parseSvg = $f0d5677e3441656c$var$parseSvg;

var $f0d5677e3441656c$var$_decompose = $f0d5677e3441656c$var$_interopRequireWildcard((parcelRequire("jC9YA")));
function $f0d5677e3441656c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f0d5677e3441656c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f0d5677e3441656c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f0d5677e3441656c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $f0d5677e3441656c$var$svgNode;
/* eslint-disable no-undef */ function $f0d5677e3441656c$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $f0d5677e3441656c$var$_decompose.identity : (0, $f0d5677e3441656c$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $f0d5677e3441656c$var$parseSvg(value) {
    if (value == null) return $f0d5677e3441656c$var$_decompose.identity;
    if (!$f0d5677e3441656c$var$svgNode) $f0d5677e3441656c$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $f0d5677e3441656c$var$svgNode.setAttribute("transform", value);
    if (!(value = $f0d5677e3441656c$var$svgNode.transform.baseVal.consolidate())) return $f0d5677e3441656c$var$_decompose.identity;
    value = value.matrix;
    return (0, $f0d5677e3441656c$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("jC9YA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e4794dfff42a52ef$var$_default;
module.exports.identity = void 0;
var $e4794dfff42a52ef$var$degrees = 180 / Math.PI;
var $e4794dfff42a52ef$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $e4794dfff42a52ef$var$identity;
function $e4794dfff42a52ef$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $e4794dfff42a52ef$var$degrees,
        skewX: Math.atan(skewX) * $e4794dfff42a52ef$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("lSxSQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $fed8ecabddf0ccde$var$epsilon2 = 1e-12;
function $fed8ecabddf0ccde$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $fed8ecabddf0ccde$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $fed8ecabddf0ccde$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $fed8ecabddf0ccde$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $fed8ecabddf0ccde$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $fed8ecabddf0ccde$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $fed8ecabddf0ccde$var$tanh(rho * s + r0) - $fed8ecabddf0ccde$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $fed8ecabddf0ccde$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $fed8ecabddf0ccde$var$_default;

});

parcelRegister("dhJad", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $x0scs = parcelRequire("x0scs");

var $9abfe57cb4a28288$var$_color = $9abfe57cb4a28288$var$_interopRequireWildcard((parcelRequire("62fLb")));
function $9abfe57cb4a28288$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9abfe57cb4a28288$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9abfe57cb4a28288$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9abfe57cb4a28288$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9abfe57cb4a28288$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $x0scs.hsl)(start)).h, (end = (0, $x0scs.hsl)(end)).h), s = (0, $9abfe57cb4a28288$var$_color.default)(start.s, end.s), l = (0, $9abfe57cb4a28288$var$_color.default)(start.l, end.l), opacity = (0, $9abfe57cb4a28288$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $9abfe57cb4a28288$var$_default = $9abfe57cb4a28288$var$hsl($9abfe57cb4a28288$var$_color.hue);
module.exports.default = $9abfe57cb4a28288$var$_default;
var $9abfe57cb4a28288$var$hslLong = $9abfe57cb4a28288$var$hsl($9abfe57cb4a28288$var$_color.default);
module.exports.hslLong = $9abfe57cb4a28288$var$hslLong;

});

parcelRegister("hJ9K8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ce7e32657202775a$var$lab;

var $x0scs = parcelRequire("x0scs");

var $ce7e32657202775a$var$_color = $ce7e32657202775a$var$_interopRequireDefault((parcelRequire("62fLb")));
function $ce7e32657202775a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ce7e32657202775a$var$lab(start, end) {
    var l = (0, $ce7e32657202775a$var$_color.default)((start = (0, $x0scs.lab)(start)).l, (end = (0, $x0scs.lab)(end)).l), a = (0, $ce7e32657202775a$var$_color.default)(start.a, end.a), b = (0, $ce7e32657202775a$var$_color.default)(start.b, end.b), opacity = (0, $ce7e32657202775a$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("l8Tov", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $x0scs = parcelRequire("x0scs");

var $f645507ddeeb1c6c$var$_color = $f645507ddeeb1c6c$var$_interopRequireWildcard((parcelRequire("62fLb")));
function $f645507ddeeb1c6c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f645507ddeeb1c6c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f645507ddeeb1c6c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f645507ddeeb1c6c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f645507ddeeb1c6c$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $x0scs.hcl)(start)).h, (end = (0, $x0scs.hcl)(end)).h), c = (0, $f645507ddeeb1c6c$var$_color.default)(start.c, end.c), l = (0, $f645507ddeeb1c6c$var$_color.default)(start.l, end.l), opacity = (0, $f645507ddeeb1c6c$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $f645507ddeeb1c6c$var$_default = $f645507ddeeb1c6c$var$hcl($f645507ddeeb1c6c$var$_color.hue);
module.exports.default = $f645507ddeeb1c6c$var$_default;
var $f645507ddeeb1c6c$var$hclLong = $f645507ddeeb1c6c$var$hcl($f645507ddeeb1c6c$var$_color.default);
module.exports.hclLong = $f645507ddeeb1c6c$var$hclLong;

});

parcelRegister("6FZ20", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $x0scs = parcelRequire("x0scs");

var $4dc5e9f8cd4bbcfc$var$_color = $4dc5e9f8cd4bbcfc$var$_interopRequireWildcard((parcelRequire("62fLb")));
function $4dc5e9f8cd4bbcfc$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4dc5e9f8cd4bbcfc$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4dc5e9f8cd4bbcfc$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4dc5e9f8cd4bbcfc$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4dc5e9f8cd4bbcfc$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $x0scs.cubehelix)(start)).h, (end = (0, $x0scs.cubehelix)(end)).h), s = (0, $4dc5e9f8cd4bbcfc$var$_color.default)(start.s, end.s), l = (0, $4dc5e9f8cd4bbcfc$var$_color.default)(start.l, end.l), opacity = (0, $4dc5e9f8cd4bbcfc$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $4dc5e9f8cd4bbcfc$var$_default = $4dc5e9f8cd4bbcfc$var$cubehelix($4dc5e9f8cd4bbcfc$var$_color.hue);
module.exports.default = $4dc5e9f8cd4bbcfc$var$_default;
var $4dc5e9f8cd4bbcfc$var$cubehelixLong = $4dc5e9f8cd4bbcfc$var$cubehelix($4dc5e9f8cd4bbcfc$var$_color.default);
module.exports.cubehelixLong = $4dc5e9f8cd4bbcfc$var$cubehelixLong;

});

parcelRegister("dVfAt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a22cb08f99df6602$var$piecewise;

var $a22cb08f99df6602$var$_value = $a22cb08f99df6602$var$_interopRequireDefault((parcelRequire("c2CcN")));
function $a22cb08f99df6602$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a22cb08f99df6602$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $a22cb08f99df6602$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("g5hwz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bb5ab4ed0dc9f403$var$_default;
function $bb5ab4ed0dc9f403$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("aTzkN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7eea7323a5408ddc$var$constants;
function $7eea7323a5408ddc$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("3Kkqc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ba5824c091b9799$var$number;
function $2ba5824c091b9799$var$number(x) {
    return +x;
}

});


parcelRegister("3pGSJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $27c4f857e1cfdd96$var$tickFormat;

var $e3Byi = parcelRequire("e3Byi");

var $5VFv5 = parcelRequire("5VFv5");
function $27c4f857e1cfdd96$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $e3Byi.tickStep)(start, stop, count), precision;
    specifier = (0, $5VFv5.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $5VFv5.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $5VFv5.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $5VFv5.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $5VFv5.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $5VFv5.format)(specifier);
}

});
parcelRegister("5VFv5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $451277b640afc622$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $451277b640afc622$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $451277b640afc622$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $451277b640afc622$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $451277b640afc622$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $451277b640afc622$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $451277b640afc622$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $451277b640afc622$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $451277b640afc622$var$_precisionRound.default;
    }
});

var $451277b640afc622$var$_defaultLocale = $451277b640afc622$var$_interopRequireWildcard((parcelRequire("gGmf9")));

var $451277b640afc622$var$_locale = $451277b640afc622$var$_interopRequireDefault((parcelRequire("afnfY")));

var $451277b640afc622$var$_formatSpecifier = $451277b640afc622$var$_interopRequireWildcard((parcelRequire("2Tdbw")));

var $451277b640afc622$var$_precisionFixed = $451277b640afc622$var$_interopRequireDefault((parcelRequire("adWCf")));

var $451277b640afc622$var$_precisionPrefix = $451277b640afc622$var$_interopRequireDefault((parcelRequire("jjNDq")));

var $451277b640afc622$var$_precisionRound = $451277b640afc622$var$_interopRequireDefault((parcelRequire("bZZe2")));
function $451277b640afc622$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $451277b640afc622$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($451277b640afc622$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $451277b640afc622$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $451277b640afc622$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("gGmf9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c251d2a4d0f953ae$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $c251d2a4d0f953ae$var$_locale = $c251d2a4d0f953ae$var$_interopRequireDefault((parcelRequire("afnfY")));
function $c251d2a4d0f953ae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c251d2a4d0f953ae$var$locale;
var $c251d2a4d0f953ae$var$format;
module.exports.format = $c251d2a4d0f953ae$var$format;
var $c251d2a4d0f953ae$var$formatPrefix;
module.exports.formatPrefix = $c251d2a4d0f953ae$var$formatPrefix;
$c251d2a4d0f953ae$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $c251d2a4d0f953ae$var$defaultLocale(definition) {
    $c251d2a4d0f953ae$var$locale = (0, $c251d2a4d0f953ae$var$_locale.default)(definition);
    module.exports.format = $c251d2a4d0f953ae$var$format = $c251d2a4d0f953ae$var$locale.format;
    module.exports.formatPrefix = $c251d2a4d0f953ae$var$formatPrefix = $c251d2a4d0f953ae$var$locale.formatPrefix;
    return $c251d2a4d0f953ae$var$locale;
}

});
parcelRegister("afnfY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $775d5860a05f925b$var$_default;

var $775d5860a05f925b$var$_exponent = $775d5860a05f925b$var$_interopRequireDefault((parcelRequire("hoJFF")));

var $775d5860a05f925b$var$_formatGroup = $775d5860a05f925b$var$_interopRequireDefault((parcelRequire("18hif")));

var $775d5860a05f925b$var$_formatNumerals = $775d5860a05f925b$var$_interopRequireDefault((parcelRequire("i333S")));

var $775d5860a05f925b$var$_formatSpecifier = $775d5860a05f925b$var$_interopRequireDefault((parcelRequire("2Tdbw")));

var $775d5860a05f925b$var$_formatTrim = $775d5860a05f925b$var$_interopRequireDefault((parcelRequire("g5VMJ")));

var $775d5860a05f925b$var$_formatTypes = $775d5860a05f925b$var$_interopRequireDefault((parcelRequire("cT55U")));

var $38LKp = parcelRequire("38LKp");

var $775d5860a05f925b$var$_identity = $775d5860a05f925b$var$_interopRequireDefault((parcelRequire("gApMF")));
function $775d5860a05f925b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $775d5860a05f925b$var$map = Array.prototype.map, $775d5860a05f925b$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $775d5860a05f925b$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $775d5860a05f925b$var$_identity.default : (0, $775d5860a05f925b$var$_formatGroup.default)($775d5860a05f925b$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $775d5860a05f925b$var$_identity.default : (0, $775d5860a05f925b$var$_formatNumerals.default)($775d5860a05f925b$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $775d5860a05f925b$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$775d5860a05f925b$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $775d5860a05f925b$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $775d5860a05f925b$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $775d5860a05f925b$var$prefixes[8 + $38LKp.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $775d5860a05f925b$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $775d5860a05f925b$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $775d5860a05f925b$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("hoJFF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $caa81ae50e7bf6ba$var$_default;

var $j0Mp5 = parcelRequire("j0Mp5");
function $caa81ae50e7bf6ba$var$_default(x) {
    return x = (0, $j0Mp5.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("j0Mp5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd73905895c181bc$var$_default;
module.exports.formatDecimalParts = $dd73905895c181bc$var$formatDecimalParts;
function $dd73905895c181bc$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $dd73905895c181bc$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("18hif", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0d33f3e7ce48b2ba$var$_default;
function $0d33f3e7ce48b2ba$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("i333S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d23ae1bededde12c$var$_default;
function $d23ae1bededde12c$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("2Tdbw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $21aaf20fa9075986$var$FormatSpecifier;
module.exports.default = $21aaf20fa9075986$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $21aaf20fa9075986$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $21aaf20fa9075986$var$formatSpecifier(specifier) {
    if (!(match = $21aaf20fa9075986$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $21aaf20fa9075986$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$21aaf20fa9075986$var$formatSpecifier.prototype = $21aaf20fa9075986$var$FormatSpecifier.prototype; // instanceof
function $21aaf20fa9075986$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$21aaf20fa9075986$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("g5VMJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bb79efda01cc68d6$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $bb79efda01cc68d6$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("cT55U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $961e92b2782df5dd$var$_formatDecimal = $961e92b2782df5dd$var$_interopRequireDefault((parcelRequire("j0Mp5")));

var $961e92b2782df5dd$var$_formatPrefixAuto = $961e92b2782df5dd$var$_interopRequireDefault((parcelRequire("38LKp")));

var $961e92b2782df5dd$var$_formatRounded = $961e92b2782df5dd$var$_interopRequireDefault((parcelRequire("cT3lV")));
function $961e92b2782df5dd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $961e92b2782df5dd$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $961e92b2782df5dd$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $961e92b2782df5dd$var$_formatRounded.default)(x * 100, p),
    "r": $961e92b2782df5dd$var$_formatRounded.default,
    "s": $961e92b2782df5dd$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $961e92b2782df5dd$var$_default;

});
parcelRegister("38LKp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2497281daf617870$var$_default;
module.exports.prefixExponent = void 0;

var $j0Mp5 = parcelRequire("j0Mp5");
var $2497281daf617870$var$prefixExponent;
module.exports.prefixExponent = $2497281daf617870$var$prefixExponent;
function $2497281daf617870$var$_default(x, p) {
    var d = (0, $j0Mp5.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $2497281daf617870$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $j0Mp5.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("cT3lV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $961d38dbbb47e831$var$_default;

var $j0Mp5 = parcelRequire("j0Mp5");
function $961d38dbbb47e831$var$_default(x, p) {
    var d = (0, $j0Mp5.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("gApMF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c134024489917fe6$var$_default;
function $c134024489917fe6$var$_default(x) {
    return x;
}

});



parcelRegister("adWCf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $77189632ba8aa85d$var$_default;

var $77189632ba8aa85d$var$_exponent = $77189632ba8aa85d$var$_interopRequireDefault((parcelRequire("hoJFF")));
function $77189632ba8aa85d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $77189632ba8aa85d$var$_default(step) {
    return Math.max(0, -(0, $77189632ba8aa85d$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("jjNDq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e1064b1ccd299fdd$var$_default;

var $e1064b1ccd299fdd$var$_exponent = $e1064b1ccd299fdd$var$_interopRequireDefault((parcelRequire("hoJFF")));
function $e1064b1ccd299fdd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e1064b1ccd299fdd$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $e1064b1ccd299fdd$var$_exponent.default)(value) / 3))) * 3 - (0, $e1064b1ccd299fdd$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("bZZe2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8bc4e24d98a471d3$var$_default;

var $8bc4e24d98a471d3$var$_exponent = $8bc4e24d98a471d3$var$_interopRequireDefault((parcelRequire("hoJFF")));
function $8bc4e24d98a471d3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8bc4e24d98a471d3$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $8bc4e24d98a471d3$var$_exponent.default)(max) - (0, $8bc4e24d98a471d3$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("kLejA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1d34d0e9cf5af42$var$log;
module.exports.loggish = $f1d34d0e9cf5af42$var$loggish;

var $e3Byi = parcelRequire("e3Byi");

var $5VFv5 = parcelRequire("5VFv5");

var $f1d34d0e9cf5af42$var$_nice = $f1d34d0e9cf5af42$var$_interopRequireDefault((parcelRequire("cDzZO")));

var $9VEML = parcelRequire("9VEML");

var $beTth = parcelRequire("beTth");
function $f1d34d0e9cf5af42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f1d34d0e9cf5af42$var$transformLog(x) {
    return Math.log(x);
}
function $f1d34d0e9cf5af42$var$transformExp(x) {
    return Math.exp(x);
}
function $f1d34d0e9cf5af42$var$transformLogn(x) {
    return -Math.log(-x);
}
function $f1d34d0e9cf5af42$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $f1d34d0e9cf5af42$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $f1d34d0e9cf5af42$var$powp(base) {
    return base === 10 ? $f1d34d0e9cf5af42$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $f1d34d0e9cf5af42$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $f1d34d0e9cf5af42$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $f1d34d0e9cf5af42$var$loggish(transform) {
    const scale = transform($f1d34d0e9cf5af42$var$transformLog, $f1d34d0e9cf5af42$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $f1d34d0e9cf5af42$var$logp(base), pows = $f1d34d0e9cf5af42$var$powp(base);
        if (domain()[0] < 0) {
            logs = $f1d34d0e9cf5af42$var$reflect(logs), pows = $f1d34d0e9cf5af42$var$reflect(pows);
            transform($f1d34d0e9cf5af42$var$transformLogn, $f1d34d0e9cf5af42$var$transformExpn);
        } else transform($f1d34d0e9cf5af42$var$transformLog, $f1d34d0e9cf5af42$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $e3Byi.ticks)(u, v, n);
        } else z = (0, $e3Byi.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $5VFv5.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $5VFv5.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $f1d34d0e9cf5af42$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $f1d34d0e9cf5af42$var$log() {
    const scale = $f1d34d0e9cf5af42$var$loggish((0, $9VEML.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $9VEML.copy)(scale, $f1d34d0e9cf5af42$var$log()).base(scale.base());
    $beTth.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("cDzZO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $93350c94a1646865$var$nice;
function $93350c94a1646865$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("27X7D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $18ca18a5d94c7260$var$symlog;
module.exports.symlogish = $18ca18a5d94c7260$var$symlogish;

var $4rEkf = parcelRequire("4rEkf");

var $9VEML = parcelRequire("9VEML");

var $beTth = parcelRequire("beTth");
function $18ca18a5d94c7260$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $18ca18a5d94c7260$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $18ca18a5d94c7260$var$symlogish(transform) {
    var c = 1, scale = transform($18ca18a5d94c7260$var$transformSymlog(c), $18ca18a5d94c7260$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($18ca18a5d94c7260$var$transformSymlog(c = +_), $18ca18a5d94c7260$var$transformSymexp(c)) : c;
    };
    return (0, $4rEkf.linearish)(scale);
}
function $18ca18a5d94c7260$var$symlog() {
    var scale = $18ca18a5d94c7260$var$symlogish((0, $9VEML.transformer)());
    scale.copy = function() {
        return (0, $9VEML.copy)(scale, $18ca18a5d94c7260$var$symlog()).constant(scale.constant());
    };
    return $beTth.initRange.apply(scale, arguments);
}

});

parcelRegister("haUTr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c80f80a90902139f$var$pow;
module.exports.powish = $c80f80a90902139f$var$powish;
module.exports.sqrt = $c80f80a90902139f$var$sqrt;

var $4rEkf = parcelRequire("4rEkf");

var $9VEML = parcelRequire("9VEML");

var $beTth = parcelRequire("beTth");
function $c80f80a90902139f$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $c80f80a90902139f$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $c80f80a90902139f$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $c80f80a90902139f$var$powish(transform) {
    var scale = transform($9VEML.identity, $9VEML.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($9VEML.identity, $9VEML.identity) : exponent === 0.5 ? transform($c80f80a90902139f$var$transformSqrt, $c80f80a90902139f$var$transformSquare) : transform($c80f80a90902139f$var$transformPow(exponent), $c80f80a90902139f$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $4rEkf.linearish)(scale);
}
function $c80f80a90902139f$var$pow() {
    var scale = $c80f80a90902139f$var$powish((0, $9VEML.transformer)());
    scale.copy = function() {
        return (0, $9VEML.copy)(scale, $c80f80a90902139f$var$pow()).exponent(scale.exponent());
    };
    $beTth.initRange.apply(scale, arguments);
    return scale;
}
function $c80f80a90902139f$var$sqrt() {
    return $c80f80a90902139f$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("l58Nc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f590e2a47218742a$var$radial;

var $f590e2a47218742a$var$_continuous = $f590e2a47218742a$var$_interopRequireDefault((parcelRequire("9VEML")));

var $beTth = parcelRequire("beTth");

var $4rEkf = parcelRequire("4rEkf");

var $f590e2a47218742a$var$_number = $f590e2a47218742a$var$_interopRequireDefault((parcelRequire("3Kkqc")));
function $f590e2a47218742a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f590e2a47218742a$var$square(x) {
    return Math.sign(x) * x * x;
}
function $f590e2a47218742a$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $f590e2a47218742a$var$radial() {
    var squared = (0, $f590e2a47218742a$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $f590e2a47218742a$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($f590e2a47218742a$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $f590e2a47218742a$var$_number.default)).map($f590e2a47218742a$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $f590e2a47218742a$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $beTth.initRange.apply(scale, arguments);
    return (0, $4rEkf.linearish)(scale);
}

});

parcelRegister("8pEqf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6200038ba41c114d$var$quantile;

var $e3Byi = parcelRequire("e3Byi");

var $beTth = parcelRequire("beTth");
function $6200038ba41c114d$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $e3Byi.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $e3Byi.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($e3Byi.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $6200038ba41c114d$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $beTth.initRange.apply(scale, arguments);
}

});

parcelRegister("fiDb6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b236ed6922427357$var$quantize;

var $e3Byi = parcelRequire("e3Byi");

var $4rEkf = parcelRequire("4rEkf");

var $beTth = parcelRequire("beTth");
function $b236ed6922427357$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $e3Byi.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $b236ed6922427357$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $beTth.initRange.apply((0, $4rEkf.linearish)(scale), arguments);
}

});

parcelRegister("kjyGY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eca07e2284c9633b$var$threshold;

var $e3Byi = parcelRequire("e3Byi");

var $beTth = parcelRequire("beTth");
function $eca07e2284c9633b$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $e3Byi.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $eca07e2284c9633b$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $beTth.initRange.apply(scale, arguments);
}

});

parcelRegister("hm640", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $ca2931dfc40c3ff8$var$calendar;
module.exports.default = $ca2931dfc40c3ff8$var$time;

var $4rLcl = parcelRequire("4rLcl");

var $aoZP1 = parcelRequire("aoZP1");

var $ca2931dfc40c3ff8$var$_continuous = $ca2931dfc40c3ff8$var$_interopRequireWildcard((parcelRequire("9VEML")));

var $beTth = parcelRequire("beTth");

var $ca2931dfc40c3ff8$var$_nice = $ca2931dfc40c3ff8$var$_interopRequireDefault((parcelRequire("cDzZO")));
function $ca2931dfc40c3ff8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ca2931dfc40c3ff8$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ca2931dfc40c3ff8$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ca2931dfc40c3ff8$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ca2931dfc40c3ff8$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ca2931dfc40c3ff8$var$date(t) {
    return new Date(t);
}
function $ca2931dfc40c3ff8$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $ca2931dfc40c3ff8$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $ca2931dfc40c3ff8$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $ca2931dfc40c3ff8$var$number)) : domain().map($ca2931dfc40c3ff8$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $ca2931dfc40c3ff8$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $ca2931dfc40c3ff8$var$_continuous.copy)(scale, $ca2931dfc40c3ff8$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $ca2931dfc40c3ff8$var$time() {
    return $beTth.initRange.apply($ca2931dfc40c3ff8$var$calendar($4rLcl.timeTicks, $4rLcl.timeTickInterval, $4rLcl.timeYear, $4rLcl.timeMonth, $4rLcl.timeWeek, $4rLcl.timeDay, $4rLcl.timeHour, $4rLcl.timeMinute, $4rLcl.timeSecond, $aoZP1.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("4rLcl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $5QWzq.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $5QWzq.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $5QWzq.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $5QWzq.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $5QWzq.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $5QWzq.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $5QWzq.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $5QWzq.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $5QWzq.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $5QWzq.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $cvV5m.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $cvV5m.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $5QWzq.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $5QWzq.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $5QWzq.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $5QWzq.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $5QWzq.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $5QWzq.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $iImXN.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $iImXN.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $iImXN.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $iImXN.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $iImXN.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $iImXN.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $iImXN.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $iImXN.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $iImXN.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $iImXN.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $cvV5m.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $cvV5m.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $iImXN.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $iImXN.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $iImXN.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $iImXN.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $iImXN.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $iImXN.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $33ce4b9401d4568b$var$_utcYear.utcYears;
    }
});

var $33ce4b9401d4568b$var$_interval = $33ce4b9401d4568b$var$_interopRequireDefault((parcelRequire("hPc6R")));

var $33ce4b9401d4568b$var$_millisecond = $33ce4b9401d4568b$var$_interopRequireWildcard((parcelRequire("bOKKB")));

var $33ce4b9401d4568b$var$_second = $33ce4b9401d4568b$var$_interopRequireWildcard((parcelRequire("E16BE")));

var $33ce4b9401d4568b$var$_minute = $33ce4b9401d4568b$var$_interopRequireWildcard((parcelRequire("5c7Y7")));

var $33ce4b9401d4568b$var$_hour = $33ce4b9401d4568b$var$_interopRequireWildcard((parcelRequire("9OKpC")));

var $33ce4b9401d4568b$var$_day = $33ce4b9401d4568b$var$_interopRequireWildcard((parcelRequire("6oyD2")));

var $5QWzq = parcelRequire("5QWzq");

var $33ce4b9401d4568b$var$_month = $33ce4b9401d4568b$var$_interopRequireWildcard((parcelRequire("cibUq")));

var $33ce4b9401d4568b$var$_year = $33ce4b9401d4568b$var$_interopRequireWildcard((parcelRequire("aLMsj")));

var $33ce4b9401d4568b$var$_utcMinute = $33ce4b9401d4568b$var$_interopRequireWildcard((parcelRequire("fRQQe")));

var $33ce4b9401d4568b$var$_utcHour = $33ce4b9401d4568b$var$_interopRequireWildcard((parcelRequire("gpFhc")));

var $33ce4b9401d4568b$var$_utcDay = $33ce4b9401d4568b$var$_interopRequireWildcard((parcelRequire("c4SMy")));

var $iImXN = parcelRequire("iImXN");

var $33ce4b9401d4568b$var$_utcMonth = $33ce4b9401d4568b$var$_interopRequireWildcard((parcelRequire("j4EGY")));

var $33ce4b9401d4568b$var$_utcYear = $33ce4b9401d4568b$var$_interopRequireWildcard((parcelRequire("60MXK")));

var $cvV5m = parcelRequire("cvV5m");
function $33ce4b9401d4568b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($33ce4b9401d4568b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $33ce4b9401d4568b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $33ce4b9401d4568b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $33ce4b9401d4568b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("hPc6R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cfa097cdbb802e7b$var$newInterval;
var $cfa097cdbb802e7b$var$t0 = new Date(), $cfa097cdbb802e7b$var$t1 = new Date();
function $cfa097cdbb802e7b$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $cfa097cdbb802e7b$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $cfa097cdbb802e7b$var$t0.setTime(+start), $cfa097cdbb802e7b$var$t1.setTime(+end);
            floori($cfa097cdbb802e7b$var$t0), floori($cfa097cdbb802e7b$var$t1);
            return Math.floor(count($cfa097cdbb802e7b$var$t0, $cfa097cdbb802e7b$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("bOKKB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $89a8a0e8d1f0a918$var$_interval = $89a8a0e8d1f0a918$var$_interopRequireDefault((parcelRequire("hPc6R")));
function $89a8a0e8d1f0a918$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $89a8a0e8d1f0a918$var$millisecond = (0, $89a8a0e8d1f0a918$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$89a8a0e8d1f0a918$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $89a8a0e8d1f0a918$var$millisecond;
    return (0, $89a8a0e8d1f0a918$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $89a8a0e8d1f0a918$var$_default = $89a8a0e8d1f0a918$var$millisecond;
module.exports.default = $89a8a0e8d1f0a918$var$_default;
var $89a8a0e8d1f0a918$var$milliseconds = $89a8a0e8d1f0a918$var$millisecond.range;
module.exports.milliseconds = $89a8a0e8d1f0a918$var$milliseconds;

});

parcelRegister("E16BE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $07849814c005bd05$var$_interval = $07849814c005bd05$var$_interopRequireDefault((parcelRequire("hPc6R")));

var $4BeTs = parcelRequire("4BeTs");
function $07849814c005bd05$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $07849814c005bd05$var$second = (0, $07849814c005bd05$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $4BeTs.durationSecond);
}, function(start, end) {
    return (end - start) / $4BeTs.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $07849814c005bd05$var$_default = $07849814c005bd05$var$second;
module.exports.default = $07849814c005bd05$var$_default;
var $07849814c005bd05$var$seconds = $07849814c005bd05$var$second.range;
module.exports.seconds = $07849814c005bd05$var$seconds;

});
parcelRegister("4BeTs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $35962ba58edc21fb$var$durationSecond = 1000;
module.exports.durationSecond = $35962ba58edc21fb$var$durationSecond;
const $35962ba58edc21fb$var$durationMinute = $35962ba58edc21fb$var$durationSecond * 60;
module.exports.durationMinute = $35962ba58edc21fb$var$durationMinute;
const $35962ba58edc21fb$var$durationHour = $35962ba58edc21fb$var$durationMinute * 60;
module.exports.durationHour = $35962ba58edc21fb$var$durationHour;
const $35962ba58edc21fb$var$durationDay = $35962ba58edc21fb$var$durationHour * 24;
module.exports.durationDay = $35962ba58edc21fb$var$durationDay;
const $35962ba58edc21fb$var$durationWeek = $35962ba58edc21fb$var$durationDay * 7;
module.exports.durationWeek = $35962ba58edc21fb$var$durationWeek;
const $35962ba58edc21fb$var$durationMonth = $35962ba58edc21fb$var$durationDay * 30;
module.exports.durationMonth = $35962ba58edc21fb$var$durationMonth;
const $35962ba58edc21fb$var$durationYear = $35962ba58edc21fb$var$durationDay * 365;
module.exports.durationYear = $35962ba58edc21fb$var$durationYear;

});


parcelRegister("5c7Y7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $3c844126b37a7d53$var$_interval = $3c844126b37a7d53$var$_interopRequireDefault((parcelRequire("hPc6R")));

var $4BeTs = parcelRequire("4BeTs");
function $3c844126b37a7d53$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3c844126b37a7d53$var$minute = (0, $3c844126b37a7d53$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $4BeTs.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $4BeTs.durationMinute);
}, function(start, end) {
    return (end - start) / $4BeTs.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $3c844126b37a7d53$var$_default = $3c844126b37a7d53$var$minute;
module.exports.default = $3c844126b37a7d53$var$_default;
var $3c844126b37a7d53$var$minutes = $3c844126b37a7d53$var$minute.range;
module.exports.minutes = $3c844126b37a7d53$var$minutes;

});

parcelRegister("9OKpC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $725cc90ed9e62278$var$_interval = $725cc90ed9e62278$var$_interopRequireDefault((parcelRequire("hPc6R")));

var $4BeTs = parcelRequire("4BeTs");
function $725cc90ed9e62278$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $725cc90ed9e62278$var$hour = (0, $725cc90ed9e62278$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $4BeTs.durationSecond - date.getMinutes() * $4BeTs.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $4BeTs.durationHour);
}, function(start, end) {
    return (end - start) / $4BeTs.durationHour;
}, function(date) {
    return date.getHours();
});
var $725cc90ed9e62278$var$_default = $725cc90ed9e62278$var$hour;
module.exports.default = $725cc90ed9e62278$var$_default;
var $725cc90ed9e62278$var$hours = $725cc90ed9e62278$var$hour.range;
module.exports.hours = $725cc90ed9e62278$var$hours;

});

parcelRegister("6oyD2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $4a7fd8806eab04e7$var$_interval = $4a7fd8806eab04e7$var$_interopRequireDefault((parcelRequire("hPc6R")));

var $4BeTs = parcelRequire("4BeTs");
function $4a7fd8806eab04e7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4a7fd8806eab04e7$var$day = (0, $4a7fd8806eab04e7$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $4BeTs.durationMinute) / $4BeTs.durationDay, (date)=>date.getDate() - 1);
var $4a7fd8806eab04e7$var$_default = $4a7fd8806eab04e7$var$day;
module.exports.default = $4a7fd8806eab04e7$var$_default;
var $4a7fd8806eab04e7$var$days = $4a7fd8806eab04e7$var$day.range;
module.exports.days = $4a7fd8806eab04e7$var$days;

});

parcelRegister("5QWzq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $442f3dea611706a6$var$_interval = $442f3dea611706a6$var$_interopRequireDefault((parcelRequire("hPc6R")));

var $4BeTs = parcelRequire("4BeTs");
function $442f3dea611706a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $442f3dea611706a6$var$weekday(i) {
    return (0, $442f3dea611706a6$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $4BeTs.durationMinute) / $4BeTs.durationWeek;
    });
}
var $442f3dea611706a6$var$sunday = $442f3dea611706a6$var$weekday(0);
module.exports.sunday = $442f3dea611706a6$var$sunday;
var $442f3dea611706a6$var$monday = $442f3dea611706a6$var$weekday(1);
module.exports.monday = $442f3dea611706a6$var$monday;
var $442f3dea611706a6$var$tuesday = $442f3dea611706a6$var$weekday(2);
module.exports.tuesday = $442f3dea611706a6$var$tuesday;
var $442f3dea611706a6$var$wednesday = $442f3dea611706a6$var$weekday(3);
module.exports.wednesday = $442f3dea611706a6$var$wednesday;
var $442f3dea611706a6$var$thursday = $442f3dea611706a6$var$weekday(4);
module.exports.thursday = $442f3dea611706a6$var$thursday;
var $442f3dea611706a6$var$friday = $442f3dea611706a6$var$weekday(5);
module.exports.friday = $442f3dea611706a6$var$friday;
var $442f3dea611706a6$var$saturday = $442f3dea611706a6$var$weekday(6);
module.exports.saturday = $442f3dea611706a6$var$saturday;
var $442f3dea611706a6$var$sundays = $442f3dea611706a6$var$sunday.range;
module.exports.sundays = $442f3dea611706a6$var$sundays;
var $442f3dea611706a6$var$mondays = $442f3dea611706a6$var$monday.range;
module.exports.mondays = $442f3dea611706a6$var$mondays;
var $442f3dea611706a6$var$tuesdays = $442f3dea611706a6$var$tuesday.range;
module.exports.tuesdays = $442f3dea611706a6$var$tuesdays;
var $442f3dea611706a6$var$wednesdays = $442f3dea611706a6$var$wednesday.range;
module.exports.wednesdays = $442f3dea611706a6$var$wednesdays;
var $442f3dea611706a6$var$thursdays = $442f3dea611706a6$var$thursday.range;
module.exports.thursdays = $442f3dea611706a6$var$thursdays;
var $442f3dea611706a6$var$fridays = $442f3dea611706a6$var$friday.range;
module.exports.fridays = $442f3dea611706a6$var$fridays;
var $442f3dea611706a6$var$saturdays = $442f3dea611706a6$var$saturday.range;
module.exports.saturdays = $442f3dea611706a6$var$saturdays;

});

parcelRegister("cibUq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $8f30675eacb6eb3a$var$_interval = $8f30675eacb6eb3a$var$_interopRequireDefault((parcelRequire("hPc6R")));
function $8f30675eacb6eb3a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8f30675eacb6eb3a$var$month = (0, $8f30675eacb6eb3a$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $8f30675eacb6eb3a$var$_default = $8f30675eacb6eb3a$var$month;
module.exports.default = $8f30675eacb6eb3a$var$_default;
var $8f30675eacb6eb3a$var$months = $8f30675eacb6eb3a$var$month.range;
module.exports.months = $8f30675eacb6eb3a$var$months;

});

parcelRegister("aLMsj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $7d73e1750be7ce89$var$_interval = $7d73e1750be7ce89$var$_interopRequireDefault((parcelRequire("hPc6R")));
function $7d73e1750be7ce89$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7d73e1750be7ce89$var$year = (0, $7d73e1750be7ce89$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$7d73e1750be7ce89$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $7d73e1750be7ce89$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $7d73e1750be7ce89$var$_default = $7d73e1750be7ce89$var$year;
module.exports.default = $7d73e1750be7ce89$var$_default;
var $7d73e1750be7ce89$var$years = $7d73e1750be7ce89$var$year.range;
module.exports.years = $7d73e1750be7ce89$var$years;

});

parcelRegister("fRQQe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $b8d4cb7bd5fdcc92$var$_interval = $b8d4cb7bd5fdcc92$var$_interopRequireDefault((parcelRequire("hPc6R")));

var $4BeTs = parcelRequire("4BeTs");
function $b8d4cb7bd5fdcc92$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b8d4cb7bd5fdcc92$var$utcMinute = (0, $b8d4cb7bd5fdcc92$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $4BeTs.durationMinute);
}, function(start, end) {
    return (end - start) / $4BeTs.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $b8d4cb7bd5fdcc92$var$_default = $b8d4cb7bd5fdcc92$var$utcMinute;
module.exports.default = $b8d4cb7bd5fdcc92$var$_default;
var $b8d4cb7bd5fdcc92$var$utcMinutes = $b8d4cb7bd5fdcc92$var$utcMinute.range;
module.exports.utcMinutes = $b8d4cb7bd5fdcc92$var$utcMinutes;

});

parcelRegister("gpFhc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $bf2effcce8a11f12$var$_interval = $bf2effcce8a11f12$var$_interopRequireDefault((parcelRequire("hPc6R")));

var $4BeTs = parcelRequire("4BeTs");
function $bf2effcce8a11f12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bf2effcce8a11f12$var$utcHour = (0, $bf2effcce8a11f12$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $4BeTs.durationHour);
}, function(start, end) {
    return (end - start) / $4BeTs.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $bf2effcce8a11f12$var$_default = $bf2effcce8a11f12$var$utcHour;
module.exports.default = $bf2effcce8a11f12$var$_default;
var $bf2effcce8a11f12$var$utcHours = $bf2effcce8a11f12$var$utcHour.range;
module.exports.utcHours = $bf2effcce8a11f12$var$utcHours;

});

parcelRegister("c4SMy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $8cb05a5d79b30b68$var$_interval = $8cb05a5d79b30b68$var$_interopRequireDefault((parcelRequire("hPc6R")));

var $4BeTs = parcelRequire("4BeTs");
function $8cb05a5d79b30b68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8cb05a5d79b30b68$var$utcDay = (0, $8cb05a5d79b30b68$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $4BeTs.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $8cb05a5d79b30b68$var$_default = $8cb05a5d79b30b68$var$utcDay;
module.exports.default = $8cb05a5d79b30b68$var$_default;
var $8cb05a5d79b30b68$var$utcDays = $8cb05a5d79b30b68$var$utcDay.range;
module.exports.utcDays = $8cb05a5d79b30b68$var$utcDays;

});

parcelRegister("iImXN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $d9fe261f8a40e716$var$_interval = $d9fe261f8a40e716$var$_interopRequireDefault((parcelRequire("hPc6R")));

var $4BeTs = parcelRequire("4BeTs");
function $d9fe261f8a40e716$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d9fe261f8a40e716$var$utcWeekday(i) {
    return (0, $d9fe261f8a40e716$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $4BeTs.durationWeek;
    });
}
var $d9fe261f8a40e716$var$utcSunday = $d9fe261f8a40e716$var$utcWeekday(0);
module.exports.utcSunday = $d9fe261f8a40e716$var$utcSunday;
var $d9fe261f8a40e716$var$utcMonday = $d9fe261f8a40e716$var$utcWeekday(1);
module.exports.utcMonday = $d9fe261f8a40e716$var$utcMonday;
var $d9fe261f8a40e716$var$utcTuesday = $d9fe261f8a40e716$var$utcWeekday(2);
module.exports.utcTuesday = $d9fe261f8a40e716$var$utcTuesday;
var $d9fe261f8a40e716$var$utcWednesday = $d9fe261f8a40e716$var$utcWeekday(3);
module.exports.utcWednesday = $d9fe261f8a40e716$var$utcWednesday;
var $d9fe261f8a40e716$var$utcThursday = $d9fe261f8a40e716$var$utcWeekday(4);
module.exports.utcThursday = $d9fe261f8a40e716$var$utcThursday;
var $d9fe261f8a40e716$var$utcFriday = $d9fe261f8a40e716$var$utcWeekday(5);
module.exports.utcFriday = $d9fe261f8a40e716$var$utcFriday;
var $d9fe261f8a40e716$var$utcSaturday = $d9fe261f8a40e716$var$utcWeekday(6);
module.exports.utcSaturday = $d9fe261f8a40e716$var$utcSaturday;
var $d9fe261f8a40e716$var$utcSundays = $d9fe261f8a40e716$var$utcSunday.range;
module.exports.utcSundays = $d9fe261f8a40e716$var$utcSundays;
var $d9fe261f8a40e716$var$utcMondays = $d9fe261f8a40e716$var$utcMonday.range;
module.exports.utcMondays = $d9fe261f8a40e716$var$utcMondays;
var $d9fe261f8a40e716$var$utcTuesdays = $d9fe261f8a40e716$var$utcTuesday.range;
module.exports.utcTuesdays = $d9fe261f8a40e716$var$utcTuesdays;
var $d9fe261f8a40e716$var$utcWednesdays = $d9fe261f8a40e716$var$utcWednesday.range;
module.exports.utcWednesdays = $d9fe261f8a40e716$var$utcWednesdays;
var $d9fe261f8a40e716$var$utcThursdays = $d9fe261f8a40e716$var$utcThursday.range;
module.exports.utcThursdays = $d9fe261f8a40e716$var$utcThursdays;
var $d9fe261f8a40e716$var$utcFridays = $d9fe261f8a40e716$var$utcFriday.range;
module.exports.utcFridays = $d9fe261f8a40e716$var$utcFridays;
var $d9fe261f8a40e716$var$utcSaturdays = $d9fe261f8a40e716$var$utcSaturday.range;
module.exports.utcSaturdays = $d9fe261f8a40e716$var$utcSaturdays;

});

parcelRegister("j4EGY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $de2df4a255100e10$var$_interval = $de2df4a255100e10$var$_interopRequireDefault((parcelRequire("hPc6R")));
function $de2df4a255100e10$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $de2df4a255100e10$var$utcMonth = (0, $de2df4a255100e10$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $de2df4a255100e10$var$_default = $de2df4a255100e10$var$utcMonth;
module.exports.default = $de2df4a255100e10$var$_default;
var $de2df4a255100e10$var$utcMonths = $de2df4a255100e10$var$utcMonth.range;
module.exports.utcMonths = $de2df4a255100e10$var$utcMonths;

});

parcelRegister("60MXK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $4608b91c6a09ef2b$var$_interval = $4608b91c6a09ef2b$var$_interopRequireDefault((parcelRequire("hPc6R")));
function $4608b91c6a09ef2b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4608b91c6a09ef2b$var$utcYear = (0, $4608b91c6a09ef2b$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$4608b91c6a09ef2b$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $4608b91c6a09ef2b$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $4608b91c6a09ef2b$var$_default = $4608b91c6a09ef2b$var$utcYear;
module.exports.default = $4608b91c6a09ef2b$var$_default;
var $4608b91c6a09ef2b$var$utcYears = $4608b91c6a09ef2b$var$utcYear.range;
module.exports.utcYears = $4608b91c6a09ef2b$var$utcYears;

});

parcelRegister("cvV5m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $e3Byi = parcelRequire("e3Byi");

var $4BeTs = parcelRequire("4BeTs");

var $91c4a944a65f038e$var$_millisecond = $91c4a944a65f038e$var$_interopRequireDefault((parcelRequire("bOKKB")));

var $91c4a944a65f038e$var$_second = $91c4a944a65f038e$var$_interopRequireDefault((parcelRequire("E16BE")));

var $91c4a944a65f038e$var$_minute = $91c4a944a65f038e$var$_interopRequireDefault((parcelRequire("5c7Y7")));

var $91c4a944a65f038e$var$_hour = $91c4a944a65f038e$var$_interopRequireDefault((parcelRequire("9OKpC")));

var $91c4a944a65f038e$var$_day = $91c4a944a65f038e$var$_interopRequireDefault((parcelRequire("6oyD2")));

var $5QWzq = parcelRequire("5QWzq");

var $91c4a944a65f038e$var$_month = $91c4a944a65f038e$var$_interopRequireDefault((parcelRequire("cibUq")));

var $91c4a944a65f038e$var$_year = $91c4a944a65f038e$var$_interopRequireDefault((parcelRequire("aLMsj")));

var $91c4a944a65f038e$var$_utcMinute = $91c4a944a65f038e$var$_interopRequireDefault((parcelRequire("fRQQe")));

var $91c4a944a65f038e$var$_utcHour = $91c4a944a65f038e$var$_interopRequireDefault((parcelRequire("gpFhc")));

var $91c4a944a65f038e$var$_utcDay = $91c4a944a65f038e$var$_interopRequireDefault((parcelRequire("c4SMy")));

var $iImXN = parcelRequire("iImXN");

var $91c4a944a65f038e$var$_utcMonth = $91c4a944a65f038e$var$_interopRequireDefault((parcelRequire("j4EGY")));

var $91c4a944a65f038e$var$_utcYear = $91c4a944a65f038e$var$_interopRequireDefault((parcelRequire("60MXK")));
function $91c4a944a65f038e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $91c4a944a65f038e$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $91c4a944a65f038e$var$_second.default,
            1,
            $4BeTs.durationSecond
        ],
        [
            $91c4a944a65f038e$var$_second.default,
            5,
            5 * $4BeTs.durationSecond
        ],
        [
            $91c4a944a65f038e$var$_second.default,
            15,
            15 * $4BeTs.durationSecond
        ],
        [
            $91c4a944a65f038e$var$_second.default,
            30,
            30 * $4BeTs.durationSecond
        ],
        [
            minute,
            1,
            $4BeTs.durationMinute
        ],
        [
            minute,
            5,
            5 * $4BeTs.durationMinute
        ],
        [
            minute,
            15,
            15 * $4BeTs.durationMinute
        ],
        [
            minute,
            30,
            30 * $4BeTs.durationMinute
        ],
        [
            hour,
            1,
            $4BeTs.durationHour
        ],
        [
            hour,
            3,
            3 * $4BeTs.durationHour
        ],
        [
            hour,
            6,
            6 * $4BeTs.durationHour
        ],
        [
            hour,
            12,
            12 * $4BeTs.durationHour
        ],
        [
            day,
            1,
            $4BeTs.durationDay
        ],
        [
            day,
            2,
            2 * $4BeTs.durationDay
        ],
        [
            week,
            1,
            $4BeTs.durationWeek
        ],
        [
            month,
            1,
            $4BeTs.durationMonth
        ],
        [
            month,
            3,
            3 * $4BeTs.durationMonth
        ],
        [
            year,
            1,
            $4BeTs.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $e3Byi.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $e3Byi.tickStep)(start / $4BeTs.durationYear, stop / $4BeTs.durationYear, count));
        if (i === 0) return $91c4a944a65f038e$var$_millisecond.default.every(Math.max((0, $e3Byi.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$91c4a944a65f038e$var$utcTicks, $91c4a944a65f038e$var$utcTickInterval] = $91c4a944a65f038e$var$ticker($91c4a944a65f038e$var$_utcYear.default, $91c4a944a65f038e$var$_utcMonth.default, $iImXN.utcSunday, $91c4a944a65f038e$var$_utcDay.default, $91c4a944a65f038e$var$_utcHour.default, $91c4a944a65f038e$var$_utcMinute.default);
module.exports.utcTickInterval = $91c4a944a65f038e$var$utcTickInterval;
module.exports.utcTicks = $91c4a944a65f038e$var$utcTicks;
const [$91c4a944a65f038e$var$timeTicks, $91c4a944a65f038e$var$timeTickInterval] = $91c4a944a65f038e$var$ticker($91c4a944a65f038e$var$_year.default, $91c4a944a65f038e$var$_month.default, $5QWzq.sunday, $91c4a944a65f038e$var$_day.default, $91c4a944a65f038e$var$_hour.default, $91c4a944a65f038e$var$_minute.default);
module.exports.timeTickInterval = $91c4a944a65f038e$var$timeTickInterval;
module.exports.timeTicks = $91c4a944a65f038e$var$timeTicks;

});


parcelRegister("aoZP1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $792c19d4af23ac7d$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $792c19d4af23ac7d$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $792c19d4af23ac7d$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $792c19d4af23ac7d$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $792c19d4af23ac7d$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $792c19d4af23ac7d$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $792c19d4af23ac7d$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $792c19d4af23ac7d$var$_defaultLocale.utcParse;
    }
});

var $792c19d4af23ac7d$var$_defaultLocale = $792c19d4af23ac7d$var$_interopRequireWildcard((parcelRequire("9Qa0e")));

var $792c19d4af23ac7d$var$_locale = $792c19d4af23ac7d$var$_interopRequireDefault((parcelRequire("7yeDx")));

var $792c19d4af23ac7d$var$_isoFormat = $792c19d4af23ac7d$var$_interopRequireDefault((parcelRequire("eE3Vt")));

var $792c19d4af23ac7d$var$_isoParse = $792c19d4af23ac7d$var$_interopRequireDefault((parcelRequire("5EEn1")));
function $792c19d4af23ac7d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $792c19d4af23ac7d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($792c19d4af23ac7d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $792c19d4af23ac7d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $792c19d4af23ac7d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("9Qa0e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $72a0babc2fbc06c6$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $72a0babc2fbc06c6$var$_locale = $72a0babc2fbc06c6$var$_interopRequireDefault((parcelRequire("7yeDx")));
function $72a0babc2fbc06c6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $72a0babc2fbc06c6$var$locale;
var $72a0babc2fbc06c6$var$timeFormat;
module.exports.timeFormat = $72a0babc2fbc06c6$var$timeFormat;
var $72a0babc2fbc06c6$var$timeParse;
module.exports.timeParse = $72a0babc2fbc06c6$var$timeParse;
var $72a0babc2fbc06c6$var$utcFormat;
module.exports.utcFormat = $72a0babc2fbc06c6$var$utcFormat;
var $72a0babc2fbc06c6$var$utcParse;
module.exports.utcParse = $72a0babc2fbc06c6$var$utcParse;
$72a0babc2fbc06c6$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $72a0babc2fbc06c6$var$defaultLocale(definition) {
    $72a0babc2fbc06c6$var$locale = (0, $72a0babc2fbc06c6$var$_locale.default)(definition);
    module.exports.timeFormat = $72a0babc2fbc06c6$var$timeFormat = $72a0babc2fbc06c6$var$locale.format;
    module.exports.timeParse = $72a0babc2fbc06c6$var$timeParse = $72a0babc2fbc06c6$var$locale.parse;
    module.exports.utcFormat = $72a0babc2fbc06c6$var$utcFormat = $72a0babc2fbc06c6$var$locale.utcFormat;
    module.exports.utcParse = $72a0babc2fbc06c6$var$utcParse = $72a0babc2fbc06c6$var$locale.utcParse;
    return $72a0babc2fbc06c6$var$locale;
}

});
parcelRegister("7yeDx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $57f70feb44dbb727$var$formatLocale;

var $4rLcl = parcelRequire("4rLcl");
function $57f70feb44dbb727$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $57f70feb44dbb727$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $57f70feb44dbb727$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $57f70feb44dbb727$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $57f70feb44dbb727$var$formatRe(locale_periods), periodLookup = $57f70feb44dbb727$var$formatLookup(locale_periods), weekdayRe = $57f70feb44dbb727$var$formatRe(locale_weekdays), weekdayLookup = $57f70feb44dbb727$var$formatLookup(locale_weekdays), shortWeekdayRe = $57f70feb44dbb727$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $57f70feb44dbb727$var$formatLookup(locale_shortWeekdays), monthRe = $57f70feb44dbb727$var$formatRe(locale_months), monthLookup = $57f70feb44dbb727$var$formatLookup(locale_months), shortMonthRe = $57f70feb44dbb727$var$formatRe(locale_shortMonths), shortMonthLookup = $57f70feb44dbb727$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $57f70feb44dbb727$var$formatDayOfMonth,
        "e": $57f70feb44dbb727$var$formatDayOfMonth,
        "f": $57f70feb44dbb727$var$formatMicroseconds,
        "g": $57f70feb44dbb727$var$formatYearISO,
        "G": $57f70feb44dbb727$var$formatFullYearISO,
        "H": $57f70feb44dbb727$var$formatHour24,
        "I": $57f70feb44dbb727$var$formatHour12,
        "j": $57f70feb44dbb727$var$formatDayOfYear,
        "L": $57f70feb44dbb727$var$formatMilliseconds,
        "m": $57f70feb44dbb727$var$formatMonthNumber,
        "M": $57f70feb44dbb727$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $57f70feb44dbb727$var$formatUnixTimestamp,
        "s": $57f70feb44dbb727$var$formatUnixTimestampSeconds,
        "S": $57f70feb44dbb727$var$formatSeconds,
        "u": $57f70feb44dbb727$var$formatWeekdayNumberMonday,
        "U": $57f70feb44dbb727$var$formatWeekNumberSunday,
        "V": $57f70feb44dbb727$var$formatWeekNumberISO,
        "w": $57f70feb44dbb727$var$formatWeekdayNumberSunday,
        "W": $57f70feb44dbb727$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $57f70feb44dbb727$var$formatYear,
        "Y": $57f70feb44dbb727$var$formatFullYear,
        "Z": $57f70feb44dbb727$var$formatZone,
        "%": $57f70feb44dbb727$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $57f70feb44dbb727$var$formatUTCDayOfMonth,
        "e": $57f70feb44dbb727$var$formatUTCDayOfMonth,
        "f": $57f70feb44dbb727$var$formatUTCMicroseconds,
        "g": $57f70feb44dbb727$var$formatUTCYearISO,
        "G": $57f70feb44dbb727$var$formatUTCFullYearISO,
        "H": $57f70feb44dbb727$var$formatUTCHour24,
        "I": $57f70feb44dbb727$var$formatUTCHour12,
        "j": $57f70feb44dbb727$var$formatUTCDayOfYear,
        "L": $57f70feb44dbb727$var$formatUTCMilliseconds,
        "m": $57f70feb44dbb727$var$formatUTCMonthNumber,
        "M": $57f70feb44dbb727$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $57f70feb44dbb727$var$formatUnixTimestamp,
        "s": $57f70feb44dbb727$var$formatUnixTimestampSeconds,
        "S": $57f70feb44dbb727$var$formatUTCSeconds,
        "u": $57f70feb44dbb727$var$formatUTCWeekdayNumberMonday,
        "U": $57f70feb44dbb727$var$formatUTCWeekNumberSunday,
        "V": $57f70feb44dbb727$var$formatUTCWeekNumberISO,
        "w": $57f70feb44dbb727$var$formatUTCWeekdayNumberSunday,
        "W": $57f70feb44dbb727$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $57f70feb44dbb727$var$formatUTCYear,
        "Y": $57f70feb44dbb727$var$formatUTCFullYear,
        "Z": $57f70feb44dbb727$var$formatUTCZone,
        "%": $57f70feb44dbb727$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $57f70feb44dbb727$var$parseDayOfMonth,
        "e": $57f70feb44dbb727$var$parseDayOfMonth,
        "f": $57f70feb44dbb727$var$parseMicroseconds,
        "g": $57f70feb44dbb727$var$parseYear,
        "G": $57f70feb44dbb727$var$parseFullYear,
        "H": $57f70feb44dbb727$var$parseHour24,
        "I": $57f70feb44dbb727$var$parseHour24,
        "j": $57f70feb44dbb727$var$parseDayOfYear,
        "L": $57f70feb44dbb727$var$parseMilliseconds,
        "m": $57f70feb44dbb727$var$parseMonthNumber,
        "M": $57f70feb44dbb727$var$parseMinutes,
        "p": parsePeriod,
        "q": $57f70feb44dbb727$var$parseQuarter,
        "Q": $57f70feb44dbb727$var$parseUnixTimestamp,
        "s": $57f70feb44dbb727$var$parseUnixTimestampSeconds,
        "S": $57f70feb44dbb727$var$parseSeconds,
        "u": $57f70feb44dbb727$var$parseWeekdayNumberMonday,
        "U": $57f70feb44dbb727$var$parseWeekNumberSunday,
        "V": $57f70feb44dbb727$var$parseWeekNumberISO,
        "w": $57f70feb44dbb727$var$parseWeekdayNumberSunday,
        "W": $57f70feb44dbb727$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $57f70feb44dbb727$var$parseYear,
        "Y": $57f70feb44dbb727$var$parseFullYear,
        "Z": $57f70feb44dbb727$var$parseZone,
        "%": $57f70feb44dbb727$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $57f70feb44dbb727$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $57f70feb44dbb727$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $57f70feb44dbb727$var$utcDate($57f70feb44dbb727$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $4rLcl.utcMonday.ceil(week) : (0, $4rLcl.utcMonday)(week);
                    week = $4rLcl.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $57f70feb44dbb727$var$localDate($57f70feb44dbb727$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $4rLcl.timeMonday.ceil(week) : (0, $4rLcl.timeMonday)(week);
                    week = $4rLcl.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $57f70feb44dbb727$var$utcDate($57f70feb44dbb727$var$newDate(d.y, 0, 1)).getUTCDay() : $57f70feb44dbb727$var$localDate($57f70feb44dbb727$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $57f70feb44dbb727$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $57f70feb44dbb727$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $57f70feb44dbb727$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $57f70feb44dbb727$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $57f70feb44dbb727$var$numberRe = /^\s*\d+/, // note: ignores next directive
$57f70feb44dbb727$var$percentRe = /^%/, $57f70feb44dbb727$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $57f70feb44dbb727$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $57f70feb44dbb727$var$requote(s) {
    return s.replace($57f70feb44dbb727$var$requoteRe, "\\$&");
}
function $57f70feb44dbb727$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($57f70feb44dbb727$var$requote).join("|") + ")", "i");
}
function $57f70feb44dbb727$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $57f70feb44dbb727$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseWeekNumberSunday(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseWeekNumberISO(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseWeekNumberMonday(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseFullYear(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseYear(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseQuarter(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseMonthNumber(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseDayOfMonth(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseDayOfYear(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseHour24(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseMinutes(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseSeconds(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseMilliseconds(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseMicroseconds(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseLiteralPercent(d, string, i) {
    var n = $57f70feb44dbb727$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $57f70feb44dbb727$var$parseUnixTimestamp(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $57f70feb44dbb727$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $57f70feb44dbb727$var$formatDayOfMonth(d, p) {
    return $57f70feb44dbb727$var$pad(d.getDate(), p, 2);
}
function $57f70feb44dbb727$var$formatHour24(d, p) {
    return $57f70feb44dbb727$var$pad(d.getHours(), p, 2);
}
function $57f70feb44dbb727$var$formatHour12(d, p) {
    return $57f70feb44dbb727$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $57f70feb44dbb727$var$formatDayOfYear(d, p) {
    return $57f70feb44dbb727$var$pad(1 + $4rLcl.timeDay.count((0, $4rLcl.timeYear)(d), d), p, 3);
}
function $57f70feb44dbb727$var$formatMilliseconds(d, p) {
    return $57f70feb44dbb727$var$pad(d.getMilliseconds(), p, 3);
}
function $57f70feb44dbb727$var$formatMicroseconds(d, p) {
    return $57f70feb44dbb727$var$formatMilliseconds(d, p) + "000";
}
function $57f70feb44dbb727$var$formatMonthNumber(d, p) {
    return $57f70feb44dbb727$var$pad(d.getMonth() + 1, p, 2);
}
function $57f70feb44dbb727$var$formatMinutes(d, p) {
    return $57f70feb44dbb727$var$pad(d.getMinutes(), p, 2);
}
function $57f70feb44dbb727$var$formatSeconds(d, p) {
    return $57f70feb44dbb727$var$pad(d.getSeconds(), p, 2);
}
function $57f70feb44dbb727$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $57f70feb44dbb727$var$formatWeekNumberSunday(d, p) {
    return $57f70feb44dbb727$var$pad($4rLcl.timeSunday.count((0, $4rLcl.timeYear)(d) - 1, d), p, 2);
}
function $57f70feb44dbb727$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $4rLcl.timeThursday)(d) : $4rLcl.timeThursday.ceil(d);
}
function $57f70feb44dbb727$var$formatWeekNumberISO(d, p) {
    d = $57f70feb44dbb727$var$dISO(d);
    return $57f70feb44dbb727$var$pad($4rLcl.timeThursday.count((0, $4rLcl.timeYear)(d), d) + ((0, $4rLcl.timeYear)(d).getDay() === 4), p, 2);
}
function $57f70feb44dbb727$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $57f70feb44dbb727$var$formatWeekNumberMonday(d, p) {
    return $57f70feb44dbb727$var$pad($4rLcl.timeMonday.count((0, $4rLcl.timeYear)(d) - 1, d), p, 2);
}
function $57f70feb44dbb727$var$formatYear(d, p) {
    return $57f70feb44dbb727$var$pad(d.getFullYear() % 100, p, 2);
}
function $57f70feb44dbb727$var$formatYearISO(d, p) {
    d = $57f70feb44dbb727$var$dISO(d);
    return $57f70feb44dbb727$var$pad(d.getFullYear() % 100, p, 2);
}
function $57f70feb44dbb727$var$formatFullYear(d, p) {
    return $57f70feb44dbb727$var$pad(d.getFullYear() % 10000, p, 4);
}
function $57f70feb44dbb727$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $4rLcl.timeThursday)(d) : $4rLcl.timeThursday.ceil(d);
    return $57f70feb44dbb727$var$pad(d.getFullYear() % 10000, p, 4);
}
function $57f70feb44dbb727$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $57f70feb44dbb727$var$pad(z / 60 | 0, "0", 2) + $57f70feb44dbb727$var$pad(z % 60, "0", 2);
}
function $57f70feb44dbb727$var$formatUTCDayOfMonth(d, p) {
    return $57f70feb44dbb727$var$pad(d.getUTCDate(), p, 2);
}
function $57f70feb44dbb727$var$formatUTCHour24(d, p) {
    return $57f70feb44dbb727$var$pad(d.getUTCHours(), p, 2);
}
function $57f70feb44dbb727$var$formatUTCHour12(d, p) {
    return $57f70feb44dbb727$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $57f70feb44dbb727$var$formatUTCDayOfYear(d, p) {
    return $57f70feb44dbb727$var$pad(1 + $4rLcl.utcDay.count((0, $4rLcl.utcYear)(d), d), p, 3);
}
function $57f70feb44dbb727$var$formatUTCMilliseconds(d, p) {
    return $57f70feb44dbb727$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $57f70feb44dbb727$var$formatUTCMicroseconds(d, p) {
    return $57f70feb44dbb727$var$formatUTCMilliseconds(d, p) + "000";
}
function $57f70feb44dbb727$var$formatUTCMonthNumber(d, p) {
    return $57f70feb44dbb727$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $57f70feb44dbb727$var$formatUTCMinutes(d, p) {
    return $57f70feb44dbb727$var$pad(d.getUTCMinutes(), p, 2);
}
function $57f70feb44dbb727$var$formatUTCSeconds(d, p) {
    return $57f70feb44dbb727$var$pad(d.getUTCSeconds(), p, 2);
}
function $57f70feb44dbb727$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $57f70feb44dbb727$var$formatUTCWeekNumberSunday(d, p) {
    return $57f70feb44dbb727$var$pad($4rLcl.utcSunday.count((0, $4rLcl.utcYear)(d) - 1, d), p, 2);
}
function $57f70feb44dbb727$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $4rLcl.utcThursday)(d) : $4rLcl.utcThursday.ceil(d);
}
function $57f70feb44dbb727$var$formatUTCWeekNumberISO(d, p) {
    d = $57f70feb44dbb727$var$UTCdISO(d);
    return $57f70feb44dbb727$var$pad($4rLcl.utcThursday.count((0, $4rLcl.utcYear)(d), d) + ((0, $4rLcl.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $57f70feb44dbb727$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $57f70feb44dbb727$var$formatUTCWeekNumberMonday(d, p) {
    return $57f70feb44dbb727$var$pad($4rLcl.utcMonday.count((0, $4rLcl.utcYear)(d) - 1, d), p, 2);
}
function $57f70feb44dbb727$var$formatUTCYear(d, p) {
    return $57f70feb44dbb727$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $57f70feb44dbb727$var$formatUTCYearISO(d, p) {
    d = $57f70feb44dbb727$var$UTCdISO(d);
    return $57f70feb44dbb727$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $57f70feb44dbb727$var$formatUTCFullYear(d, p) {
    return $57f70feb44dbb727$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $57f70feb44dbb727$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $4rLcl.utcThursday)(d) : $4rLcl.utcThursday.ceil(d);
    return $57f70feb44dbb727$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $57f70feb44dbb727$var$formatUTCZone() {
    return "+0000";
}
function $57f70feb44dbb727$var$formatLiteralPercent() {
    return "%";
}
function $57f70feb44dbb727$var$formatUnixTimestamp(d) {
    return +d;
}
function $57f70feb44dbb727$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("eE3Vt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $9Qa0e = parcelRequire("9Qa0e");
var $aa97d8c2395c9b41$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $aa97d8c2395c9b41$var$isoSpecifier;
function $aa97d8c2395c9b41$var$formatIsoNative(date) {
    return date.toISOString();
}
var $aa97d8c2395c9b41$var$formatIso = Date.prototype.toISOString ? $aa97d8c2395c9b41$var$formatIsoNative : (0, $9Qa0e.utcFormat)($aa97d8c2395c9b41$var$isoSpecifier);
var $aa97d8c2395c9b41$var$_default = $aa97d8c2395c9b41$var$formatIso;
module.exports.default = $aa97d8c2395c9b41$var$_default;

});

parcelRegister("5EEn1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eE3Vt = parcelRequire("eE3Vt");

var $9Qa0e = parcelRequire("9Qa0e");
function $41e000de0376d41c$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $41e000de0376d41c$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $41e000de0376d41c$var$parseIsoNative : (0, $9Qa0e.utcParse)($eE3Vt.isoSpecifier);
var $41e000de0376d41c$var$_default = $41e000de0376d41c$var$parseIso;
module.exports.default = $41e000de0376d41c$var$_default;

});



parcelRegister("e0xFg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a32b2dd9dde19c82$var$utcTime;

var $4rLcl = parcelRequire("4rLcl");

var $aoZP1 = parcelRequire("aoZP1");

var $hm640 = parcelRequire("hm640");

var $beTth = parcelRequire("beTth");
function $a32b2dd9dde19c82$var$utcTime() {
    return $beTth.initRange.apply((0, $hm640.calendar)($4rLcl.utcTicks, $4rLcl.utcTickInterval, $4rLcl.utcYear, $4rLcl.utcMonth, $4rLcl.utcWeek, $4rLcl.utcDay, $4rLcl.utcHour, $4rLcl.utcMinute, $4rLcl.utcSecond, $aoZP1.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("k9Gpj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $eac58b2193b21ddc$var$copy;
module.exports.default = $eac58b2193b21ddc$var$sequential;
module.exports.sequentialLog = $eac58b2193b21ddc$var$sequentialLog;
module.exports.sequentialPow = $eac58b2193b21ddc$var$sequentialPow;
module.exports.sequentialSqrt = $eac58b2193b21ddc$var$sequentialSqrt;
module.exports.sequentialSymlog = $eac58b2193b21ddc$var$sequentialSymlog;

var $67YIC = parcelRequire("67YIC");

var $9VEML = parcelRequire("9VEML");

var $beTth = parcelRequire("beTth");

var $4rEkf = parcelRequire("4rEkf");

var $kLejA = parcelRequire("kLejA");

var $27X7D = parcelRequire("27X7D");

var $haUTr = parcelRequire("haUTr");
function $eac58b2193b21ddc$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $9VEML.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($67YIC.interpolate);
    scale.rangeRound = range($67YIC.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $eac58b2193b21ddc$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $eac58b2193b21ddc$var$sequential() {
    var scale = (0, $4rEkf.linearish)($eac58b2193b21ddc$var$transformer()($9VEML.identity));
    scale.copy = function() {
        return $eac58b2193b21ddc$var$copy(scale, $eac58b2193b21ddc$var$sequential());
    };
    return $beTth.initInterpolator.apply(scale, arguments);
}
function $eac58b2193b21ddc$var$sequentialLog() {
    var scale = (0, $kLejA.loggish)($eac58b2193b21ddc$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $eac58b2193b21ddc$var$copy(scale, $eac58b2193b21ddc$var$sequentialLog()).base(scale.base());
    };
    return $beTth.initInterpolator.apply(scale, arguments);
}
function $eac58b2193b21ddc$var$sequentialSymlog() {
    var scale = (0, $27X7D.symlogish)($eac58b2193b21ddc$var$transformer());
    scale.copy = function() {
        return $eac58b2193b21ddc$var$copy(scale, $eac58b2193b21ddc$var$sequentialSymlog()).constant(scale.constant());
    };
    return $beTth.initInterpolator.apply(scale, arguments);
}
function $eac58b2193b21ddc$var$sequentialPow() {
    var scale = (0, $haUTr.powish)($eac58b2193b21ddc$var$transformer());
    scale.copy = function() {
        return $eac58b2193b21ddc$var$copy(scale, $eac58b2193b21ddc$var$sequentialPow()).exponent(scale.exponent());
    };
    return $beTth.initInterpolator.apply(scale, arguments);
}
function $eac58b2193b21ddc$var$sequentialSqrt() {
    return $eac58b2193b21ddc$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("dJf4W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9feb2ca1c330dfdd$var$sequentialQuantile;

var $e3Byi = parcelRequire("e3Byi");

var $9VEML = parcelRequire("9VEML");

var $beTth = parcelRequire("beTth");
function $9feb2ca1c330dfdd$var$sequentialQuantile() {
    var domain = [], interpolator = $9VEML.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $e3Byi.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($e3Byi.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $e3Byi.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $9feb2ca1c330dfdd$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $beTth.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("czpqZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $926c7baad2b14779$var$diverging;
module.exports.divergingLog = $926c7baad2b14779$var$divergingLog;
module.exports.divergingPow = $926c7baad2b14779$var$divergingPow;
module.exports.divergingSqrt = $926c7baad2b14779$var$divergingSqrt;
module.exports.divergingSymlog = $926c7baad2b14779$var$divergingSymlog;

var $67YIC = parcelRequire("67YIC");

var $9VEML = parcelRequire("9VEML");

var $beTth = parcelRequire("beTth");

var $4rEkf = parcelRequire("4rEkf");

var $kLejA = parcelRequire("kLejA");

var $k9Gpj = parcelRequire("k9Gpj");

var $27X7D = parcelRequire("27X7D");

var $haUTr = parcelRequire("haUTr");
function $926c7baad2b14779$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $9VEML.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $67YIC.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($67YIC.interpolate);
    scale.rangeRound = range($67YIC.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $926c7baad2b14779$var$diverging() {
    var scale = (0, $4rEkf.linearish)($926c7baad2b14779$var$transformer()($9VEML.identity));
    scale.copy = function() {
        return (0, $k9Gpj.copy)(scale, $926c7baad2b14779$var$diverging());
    };
    return $beTth.initInterpolator.apply(scale, arguments);
}
function $926c7baad2b14779$var$divergingLog() {
    var scale = (0, $kLejA.loggish)($926c7baad2b14779$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $k9Gpj.copy)(scale, $926c7baad2b14779$var$divergingLog()).base(scale.base());
    };
    return $beTth.initInterpolator.apply(scale, arguments);
}
function $926c7baad2b14779$var$divergingSymlog() {
    var scale = (0, $27X7D.symlogish)($926c7baad2b14779$var$transformer());
    scale.copy = function() {
        return (0, $k9Gpj.copy)(scale, $926c7baad2b14779$var$divergingSymlog()).constant(scale.constant());
    };
    return $beTth.initInterpolator.apply(scale, arguments);
}
function $926c7baad2b14779$var$divergingPow() {
    var scale = (0, $haUTr.powish)($926c7baad2b14779$var$transformer());
    scale.copy = function() {
        return (0, $k9Gpj.copy)(scale, $926c7baad2b14779$var$divergingPow()).exponent(scale.exponent());
    };
    return $beTth.initInterpolator.apply(scale, arguments);
}
function $926c7baad2b14779$var$divergingSqrt() {
    return $926c7baad2b14779$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("3H57O", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("h5iof"));

});
parcelRegister("h5iof", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $bwfsM.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $bwfsM.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $aTMUl.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $aTMUl.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $axSd3.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $axSd3.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $axSd3.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $axSd3.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $c7012b2cdad71234$var$_symbol.symbolsStroke;
    }
});

var $c7012b2cdad71234$var$_arc = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("7oqDq")));

var $c7012b2cdad71234$var$_area = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("fORS2")));

var $c7012b2cdad71234$var$_line = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("3Z6pp")));

var $c7012b2cdad71234$var$_pie = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("2ARrm")));

var $c7012b2cdad71234$var$_areaRadial = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("cMhUt")));

var $c7012b2cdad71234$var$_lineRadial = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("lqHMc")));

var $c7012b2cdad71234$var$_pointRadial = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("5ynMq")));

var $axSd3 = parcelRequire("axSd3");

var $c7012b2cdad71234$var$_symbol = $c7012b2cdad71234$var$_interopRequireWildcard((parcelRequire("3MbKM")));

var $c7012b2cdad71234$var$_asterisk = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("hAhsc")));

var $c7012b2cdad71234$var$_circle = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("8964m")));

var $c7012b2cdad71234$var$_cross = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("6PZy1")));

var $c7012b2cdad71234$var$_diamond = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("dUGfS")));

var $c7012b2cdad71234$var$_diamond2 = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("7vFGb")));

var $c7012b2cdad71234$var$_plus = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("fB0aC")));

var $c7012b2cdad71234$var$_square = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("6pKm6")));

var $c7012b2cdad71234$var$_square2 = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("2waOu")));

var $c7012b2cdad71234$var$_star = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("e8oVg")));

var $c7012b2cdad71234$var$_triangle = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("i2vdw")));

var $c7012b2cdad71234$var$_triangle2 = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("ckkUc")));

var $c7012b2cdad71234$var$_wye = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("fPANN")));

var $c7012b2cdad71234$var$_x = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("gemeI")));

var $c7012b2cdad71234$var$_basisClosed = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("8lWvL")));

var $c7012b2cdad71234$var$_basisOpen = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("j3GfS")));

var $c7012b2cdad71234$var$_basis = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("3glKE")));

var $bwfsM = parcelRequire("bwfsM");

var $c7012b2cdad71234$var$_bundle = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("9a8vh")));

var $c7012b2cdad71234$var$_cardinalClosed = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("39O9K")));

var $c7012b2cdad71234$var$_cardinalOpen = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("i7o7h")));

var $c7012b2cdad71234$var$_cardinal = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("7Vf95")));

var $c7012b2cdad71234$var$_catmullRomClosed = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("hXMXy")));

var $c7012b2cdad71234$var$_catmullRomOpen = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("fVNfD")));

var $c7012b2cdad71234$var$_catmullRom = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("2ezV1")));

var $c7012b2cdad71234$var$_linearClosed = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("b4NOh")));

var $c7012b2cdad71234$var$_linear = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("fSfhT")));

var $aTMUl = parcelRequire("aTMUl");

var $c7012b2cdad71234$var$_natural = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("4hhdb")));

var $c7012b2cdad71234$var$_step = $c7012b2cdad71234$var$_interopRequireWildcard((parcelRequire("64LSD")));

var $c7012b2cdad71234$var$_stack = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("aE5qa")));

var $c7012b2cdad71234$var$_expand = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("8MNuf")));

var $c7012b2cdad71234$var$_diverging = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("luZSo")));

var $c7012b2cdad71234$var$_none = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("9aRTz")));

var $c7012b2cdad71234$var$_silhouette = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("1vVnA")));

var $c7012b2cdad71234$var$_wiggle = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("6wWyB")));

var $c7012b2cdad71234$var$_appearance = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("91fxO")));

var $c7012b2cdad71234$var$_ascending = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("kdWqf")));

var $c7012b2cdad71234$var$_descending = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("6zI5r")));

var $c7012b2cdad71234$var$_insideOut = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("lkCCH")));

var $c7012b2cdad71234$var$_none2 = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("gpNFQ")));

var $c7012b2cdad71234$var$_reverse = $c7012b2cdad71234$var$_interopRequireDefault((parcelRequire("aZXc7")));
function $c7012b2cdad71234$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c7012b2cdad71234$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c7012b2cdad71234$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c7012b2cdad71234$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c7012b2cdad71234$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("7oqDq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $561f6f6a309399d0$var$_default;

var $JwOmB = parcelRequire("JwOmB");

var $561f6f6a309399d0$var$_constant = $561f6f6a309399d0$var$_interopRequireDefault((parcelRequire("7lFE7")));

var $kk4FQ = parcelRequire("kk4FQ");
function $561f6f6a309399d0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $561f6f6a309399d0$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $561f6f6a309399d0$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $561f6f6a309399d0$var$arcStartAngle(d) {
    return d.startAngle;
}
function $561f6f6a309399d0$var$arcEndAngle(d) {
    return d.endAngle;
}
function $561f6f6a309399d0$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $561f6f6a309399d0$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $kk4FQ.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $561f6f6a309399d0$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $kk4FQ.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $kk4FQ.sqrt)((0, $kk4FQ.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $561f6f6a309399d0$var$_default() {
    var innerRadius = $561f6f6a309399d0$var$arcInnerRadius, outerRadius = $561f6f6a309399d0$var$arcOuterRadius, cornerRadius = (0, $561f6f6a309399d0$var$_constant.default)(0), padRadius = null, startAngle = $561f6f6a309399d0$var$arcStartAngle, endAngle = $561f6f6a309399d0$var$arcEndAngle, padAngle = $561f6f6a309399d0$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $kk4FQ.halfPi, a1 = endAngle.apply(this, arguments) - $kk4FQ.halfPi, da = (0, $kk4FQ.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $JwOmB.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $kk4FQ.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $kk4FQ.tau - $kk4FQ.epsilon) {
            context.moveTo(r1 * (0, $kk4FQ.cos)(a0), r1 * (0, $kk4FQ.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $kk4FQ.epsilon) {
                context.moveTo(r0 * (0, $kk4FQ.cos)(a1), r0 * (0, $kk4FQ.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $kk4FQ.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $kk4FQ.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $kk4FQ.min)((0, $kk4FQ.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $kk4FQ.epsilon) {
                var p0 = (0, $kk4FQ.asin)(rp / r0 * (0, $kk4FQ.sin)(ap)), p1 = (0, $kk4FQ.asin)(rp / r1 * (0, $kk4FQ.sin)(ap));
                if ((da0 -= p0 * 2) > $kk4FQ.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $kk4FQ.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $kk4FQ.cos)(a01), y01 = r1 * (0, $kk4FQ.sin)(a01), x10 = r0 * (0, $kk4FQ.cos)(a10), y10 = r0 * (0, $kk4FQ.sin)(a10); // Apply rounded corners?
            if (rc > $kk4FQ.epsilon) {
                var x11 = r1 * (0, $kk4FQ.cos)(a11), y11 = r1 * (0, $kk4FQ.sin)(a11), x00 = r0 * (0, $kk4FQ.cos)(a00), y00 = r0 * (0, $kk4FQ.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $kk4FQ.pi && (oc = $561f6f6a309399d0$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $kk4FQ.sin)((0, $kk4FQ.acos)((ax * bx + ay * by) / ((0, $kk4FQ.sqrt)(ax * ax + ay * ay) * (0, $kk4FQ.sqrt)(bx * bx + by * by))) / 2), lc = (0, $kk4FQ.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $kk4FQ.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $kk4FQ.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $kk4FQ.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $kk4FQ.epsilon) {
                t0 = $561f6f6a309399d0$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $561f6f6a309399d0$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $kk4FQ.atan2)(t0.y01, t0.x01), (0, $kk4FQ.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $kk4FQ.atan2)(t0.y01, t0.x01), (0, $kk4FQ.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $kk4FQ.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $kk4FQ.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $kk4FQ.atan2)(t1.y11, t1.x11), (0, $kk4FQ.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $kk4FQ.epsilon) || !(da0 > $kk4FQ.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $kk4FQ.epsilon) {
                t0 = $561f6f6a309399d0$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $561f6f6a309399d0$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $kk4FQ.atan2)(t0.y01, t0.x01), (0, $kk4FQ.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $kk4FQ.atan2)(t0.y01, t0.x01), (0, $kk4FQ.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $kk4FQ.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $kk4FQ.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $kk4FQ.atan2)(t1.y11, t1.x11), (0, $kk4FQ.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $kk4FQ.pi / 2;
        return [
            (0, $kk4FQ.cos)(a) * r,
            (0, $kk4FQ.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $561f6f6a309399d0$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $561f6f6a309399d0$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $561f6f6a309399d0$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $561f6f6a309399d0$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $561f6f6a309399d0$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $561f6f6a309399d0$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $561f6f6a309399d0$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("JwOmB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $088da7ba49b1b087$var$_path.default;
    }
});

var $088da7ba49b1b087$var$_path = $088da7ba49b1b087$var$_interopRequireDefault((parcelRequire("fSXMf")));
function $088da7ba49b1b087$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("fSXMf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $b90a44b10c1ebf33$var$pi = Math.PI, $b90a44b10c1ebf33$var$tau = 2 * $b90a44b10c1ebf33$var$pi, $b90a44b10c1ebf33$var$epsilon = 1e-6, $b90a44b10c1ebf33$var$tauEpsilon = $b90a44b10c1ebf33$var$tau - $b90a44b10c1ebf33$var$epsilon;
function $b90a44b10c1ebf33$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $b90a44b10c1ebf33$var$path() {
    return new $b90a44b10c1ebf33$var$Path();
}
$b90a44b10c1ebf33$var$Path.prototype = $b90a44b10c1ebf33$var$path.prototype = {
    constructor: $b90a44b10c1ebf33$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $b90a44b10c1ebf33$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $b90a44b10c1ebf33$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($b90a44b10c1ebf33$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $b90a44b10c1ebf33$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $b90a44b10c1ebf33$var$epsilon || Math.abs(this._y1 - y0) > $b90a44b10c1ebf33$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $b90a44b10c1ebf33$var$tau + $b90a44b10c1ebf33$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $b90a44b10c1ebf33$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $b90a44b10c1ebf33$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $b90a44b10c1ebf33$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $b90a44b10c1ebf33$var$_default = $b90a44b10c1ebf33$var$path;
module.exports.default = $b90a44b10c1ebf33$var$_default;

});


parcelRegister("7lFE7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $559acc9b8af7375d$var$_default;
function $559acc9b8af7375d$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("kk4FQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $ecb94d0e6d6c6e4e$var$acos;
module.exports.asin = $ecb94d0e6d6c6e4e$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $ecb94d0e6d6c6e4e$var$abs = Math.abs;
module.exports.abs = $ecb94d0e6d6c6e4e$var$abs;
const $ecb94d0e6d6c6e4e$var$atan2 = Math.atan2;
module.exports.atan2 = $ecb94d0e6d6c6e4e$var$atan2;
const $ecb94d0e6d6c6e4e$var$cos = Math.cos;
module.exports.cos = $ecb94d0e6d6c6e4e$var$cos;
const $ecb94d0e6d6c6e4e$var$max = Math.max;
module.exports.max = $ecb94d0e6d6c6e4e$var$max;
const $ecb94d0e6d6c6e4e$var$min = Math.min;
module.exports.min = $ecb94d0e6d6c6e4e$var$min;
const $ecb94d0e6d6c6e4e$var$sin = Math.sin;
module.exports.sin = $ecb94d0e6d6c6e4e$var$sin;
const $ecb94d0e6d6c6e4e$var$sqrt = Math.sqrt;
module.exports.sqrt = $ecb94d0e6d6c6e4e$var$sqrt;
const $ecb94d0e6d6c6e4e$var$epsilon = 1e-12;
module.exports.epsilon = $ecb94d0e6d6c6e4e$var$epsilon;
const $ecb94d0e6d6c6e4e$var$pi = Math.PI;
module.exports.pi = $ecb94d0e6d6c6e4e$var$pi;
const $ecb94d0e6d6c6e4e$var$halfPi = $ecb94d0e6d6c6e4e$var$pi / 2;
module.exports.halfPi = $ecb94d0e6d6c6e4e$var$halfPi;
const $ecb94d0e6d6c6e4e$var$tau = 2 * $ecb94d0e6d6c6e4e$var$pi;
module.exports.tau = $ecb94d0e6d6c6e4e$var$tau;
function $ecb94d0e6d6c6e4e$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $ecb94d0e6d6c6e4e$var$pi : Math.acos(x);
}
function $ecb94d0e6d6c6e4e$var$asin(x) {
    return x >= 1 ? $ecb94d0e6d6c6e4e$var$halfPi : x <= -1 ? -$ecb94d0e6d6c6e4e$var$halfPi : Math.asin(x);
}

});


parcelRegister("fORS2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b845501704f74cc0$var$_default;

var $JwOmB = parcelRequire("JwOmB");

var $b845501704f74cc0$var$_array = $b845501704f74cc0$var$_interopRequireDefault((parcelRequire("hC7DE")));

var $b845501704f74cc0$var$_constant = $b845501704f74cc0$var$_interopRequireDefault((parcelRequire("7lFE7")));

var $b845501704f74cc0$var$_linear = $b845501704f74cc0$var$_interopRequireDefault((parcelRequire("fSfhT")));

var $b845501704f74cc0$var$_line = $b845501704f74cc0$var$_interopRequireDefault((parcelRequire("3Z6pp")));

var $hQdVo = parcelRequire("hQdVo");
function $b845501704f74cc0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b845501704f74cc0$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $b845501704f74cc0$var$_constant.default)(true), context = null, curve = $b845501704f74cc0$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $hQdVo.x : (0, $b845501704f74cc0$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $b845501704f74cc0$var$_constant.default)(0) : (0, $b845501704f74cc0$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $hQdVo.y : (0, $b845501704f74cc0$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $b845501704f74cc0$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $JwOmB.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $b845501704f74cc0$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $b845501704f74cc0$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $b845501704f74cc0$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $b845501704f74cc0$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $b845501704f74cc0$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $b845501704f74cc0$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $b845501704f74cc0$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $b845501704f74cc0$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("hC7DE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cd2be9241efbbd83$var$_default;
module.exports.slice = void 0;
var $cd2be9241efbbd83$var$slice = Array.prototype.slice;
module.exports.slice = $cd2be9241efbbd83$var$slice;
function $cd2be9241efbbd83$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("fSfhT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b8e7c1fb79331115$var$_default;
function $b8e7c1fb79331115$var$Linear(context) {
    this._context = context;
}
$b8e7c1fb79331115$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $b8e7c1fb79331115$var$_default(context) {
    return new $b8e7c1fb79331115$var$Linear(context);
}

});

parcelRegister("3Z6pp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2e6c0a48fc0c2bb4$var$_default;

var $JwOmB = parcelRequire("JwOmB");

var $2e6c0a48fc0c2bb4$var$_array = $2e6c0a48fc0c2bb4$var$_interopRequireDefault((parcelRequire("hC7DE")));

var $2e6c0a48fc0c2bb4$var$_constant = $2e6c0a48fc0c2bb4$var$_interopRequireDefault((parcelRequire("7lFE7")));

var $2e6c0a48fc0c2bb4$var$_linear = $2e6c0a48fc0c2bb4$var$_interopRequireDefault((parcelRequire("fSfhT")));

var $hQdVo = parcelRequire("hQdVo");
function $2e6c0a48fc0c2bb4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2e6c0a48fc0c2bb4$var$_default(x, y) {
    var defined = (0, $2e6c0a48fc0c2bb4$var$_constant.default)(true), context = null, curve = $2e6c0a48fc0c2bb4$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $hQdVo.x : (0, $2e6c0a48fc0c2bb4$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $hQdVo.y : (0, $2e6c0a48fc0c2bb4$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $2e6c0a48fc0c2bb4$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $JwOmB.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $2e6c0a48fc0c2bb4$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $2e6c0a48fc0c2bb4$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $2e6c0a48fc0c2bb4$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("hQdVo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $cfd218204643ba3d$var$x;
module.exports.y = $cfd218204643ba3d$var$y;
function $cfd218204643ba3d$var$x(p) {
    return p[0];
}
function $cfd218204643ba3d$var$y(p) {
    return p[1];
}

});



parcelRegister("2ARrm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1e3865b43345ec40$var$_default;

var $1e3865b43345ec40$var$_array = $1e3865b43345ec40$var$_interopRequireDefault((parcelRequire("hC7DE")));

var $1e3865b43345ec40$var$_constant = $1e3865b43345ec40$var$_interopRequireDefault((parcelRequire("7lFE7")));

var $1e3865b43345ec40$var$_descending = $1e3865b43345ec40$var$_interopRequireDefault((parcelRequire("8gmG7")));

var $1e3865b43345ec40$var$_identity = $1e3865b43345ec40$var$_interopRequireDefault((parcelRequire("glyuh")));

var $kk4FQ = parcelRequire("kk4FQ");
function $1e3865b43345ec40$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1e3865b43345ec40$var$_default() {
    var value = $1e3865b43345ec40$var$_identity.default, sortValues = $1e3865b43345ec40$var$_descending.default, sort = null, startAngle = (0, $1e3865b43345ec40$var$_constant.default)(0), endAngle = (0, $1e3865b43345ec40$var$_constant.default)($kk4FQ.tau), padAngle = (0, $1e3865b43345ec40$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $1e3865b43345ec40$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($kk4FQ.tau, Math.max(-$kk4FQ.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $1e3865b43345ec40$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $1e3865b43345ec40$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $1e3865b43345ec40$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $1e3865b43345ec40$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("8gmG7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $604168cadd350098$var$_default;
function $604168cadd350098$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("glyuh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be695bfff82bab12$var$_default;
function $be695bfff82bab12$var$_default(d) {
    return d;
}

});


parcelRegister("cMhUt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $94d7dc473885f831$var$_default;

var $94d7dc473885f831$var$_radial = $94d7dc473885f831$var$_interopRequireWildcard((parcelRequire("huCeK")));

var $94d7dc473885f831$var$_area = $94d7dc473885f831$var$_interopRequireDefault((parcelRequire("fORS2")));

var $lqHMc = parcelRequire("lqHMc");
function $94d7dc473885f831$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $94d7dc473885f831$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($94d7dc473885f831$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $94d7dc473885f831$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $94d7dc473885f831$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $94d7dc473885f831$var$_default() {
    var a = (0, $94d7dc473885f831$var$_area.default)().curve($94d7dc473885f831$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $lqHMc.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $lqHMc.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $lqHMc.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $lqHMc.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $94d7dc473885f831$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("huCeK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $cbc2e6146303e7a9$var$curveRadial;

var $cbc2e6146303e7a9$var$_linear = $cbc2e6146303e7a9$var$_interopRequireDefault((parcelRequire("fSfhT")));
function $cbc2e6146303e7a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cbc2e6146303e7a9$var$curveRadialLinear = $cbc2e6146303e7a9$var$curveRadial($cbc2e6146303e7a9$var$_linear.default);
module.exports.curveRadialLinear = $cbc2e6146303e7a9$var$curveRadialLinear;
function $cbc2e6146303e7a9$var$Radial(curve) {
    this._curve = curve;
}
$cbc2e6146303e7a9$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $cbc2e6146303e7a9$var$curveRadial(curve) {
    function radial(context) {
        return new $cbc2e6146303e7a9$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("lqHMc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f99dfbc291c9a34b$var$_default;
module.exports.lineRadial = $f99dfbc291c9a34b$var$lineRadial;

var $f99dfbc291c9a34b$var$_radial = $f99dfbc291c9a34b$var$_interopRequireWildcard((parcelRequire("huCeK")));

var $f99dfbc291c9a34b$var$_line = $f99dfbc291c9a34b$var$_interopRequireDefault((parcelRequire("3Z6pp")));
function $f99dfbc291c9a34b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f99dfbc291c9a34b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f99dfbc291c9a34b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f99dfbc291c9a34b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f99dfbc291c9a34b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f99dfbc291c9a34b$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $f99dfbc291c9a34b$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $f99dfbc291c9a34b$var$_default() {
    return $f99dfbc291c9a34b$var$lineRadial((0, $f99dfbc291c9a34b$var$_line.default)().curve($f99dfbc291c9a34b$var$_radial.curveRadialLinear));
}

});


parcelRegister("5ynMq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $40b292f62c34ce4d$var$_default;
function $40b292f62c34ce4d$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("axSd3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $7ad7095475116296$var$link;
module.exports.linkHorizontal = $7ad7095475116296$var$linkHorizontal;
module.exports.linkRadial = $7ad7095475116296$var$linkRadial;
module.exports.linkVertical = $7ad7095475116296$var$linkVertical;

var $JwOmB = parcelRequire("JwOmB");

var $hC7DE = parcelRequire("hC7DE");

var $7ad7095475116296$var$_constant = $7ad7095475116296$var$_interopRequireDefault((parcelRequire("7lFE7")));

var $bwfsM = parcelRequire("bwfsM");

var $hQdVo = parcelRequire("hQdVo");
function $7ad7095475116296$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7ad7095475116296$var$linkSource(d) {
    return d.source;
}
function $7ad7095475116296$var$linkTarget(d) {
    return d.target;
}
function $7ad7095475116296$var$link(curve) {
    let source = $7ad7095475116296$var$linkSource;
    let target = $7ad7095475116296$var$linkTarget;
    let x = $hQdVo.x;
    let y = $hQdVo.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $hC7DE.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $JwOmB.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $7ad7095475116296$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $7ad7095475116296$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $7ad7095475116296$var$linkHorizontal() {
    return $7ad7095475116296$var$link($bwfsM.bumpX);
}
function $7ad7095475116296$var$linkVertical() {
    return $7ad7095475116296$var$link($bwfsM.bumpY);
}
function $7ad7095475116296$var$linkRadial() {
    const l = $7ad7095475116296$var$link($bwfsM.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("bwfsM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $862ead8747e546f7$var$bumpRadial;
module.exports.bumpX = $862ead8747e546f7$var$bumpX;
module.exports.bumpY = $862ead8747e546f7$var$bumpY;

var $862ead8747e546f7$var$_pointRadial = $862ead8747e546f7$var$_interopRequireDefault((parcelRequire("5ynMq")));
function $862ead8747e546f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $862ead8747e546f7$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $862ead8747e546f7$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $862ead8747e546f7$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $862ead8747e546f7$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $862ead8747e546f7$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $862ead8747e546f7$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $862ead8747e546f7$var$bumpX(context) {
    return new $862ead8747e546f7$var$Bump(context, true);
}
function $862ead8747e546f7$var$bumpY(context) {
    return new $862ead8747e546f7$var$Bump(context, false);
}
function $862ead8747e546f7$var$bumpRadial(context) {
    return new $862ead8747e546f7$var$BumpRadial(context);
}

});


parcelRegister("3MbKM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2bfef8c670029adb$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $JwOmB = parcelRequire("JwOmB");

var $2bfef8c670029adb$var$_constant = $2bfef8c670029adb$var$_interopRequireDefault((parcelRequire("7lFE7")));

var $2bfef8c670029adb$var$_asterisk = $2bfef8c670029adb$var$_interopRequireDefault((parcelRequire("hAhsc")));

var $2bfef8c670029adb$var$_circle = $2bfef8c670029adb$var$_interopRequireDefault((parcelRequire("8964m")));

var $2bfef8c670029adb$var$_cross = $2bfef8c670029adb$var$_interopRequireDefault((parcelRequire("6PZy1")));

var $2bfef8c670029adb$var$_diamond = $2bfef8c670029adb$var$_interopRequireDefault((parcelRequire("dUGfS")));

var $2bfef8c670029adb$var$_diamond2 = $2bfef8c670029adb$var$_interopRequireDefault((parcelRequire("7vFGb")));

var $2bfef8c670029adb$var$_plus = $2bfef8c670029adb$var$_interopRequireDefault((parcelRequire("fB0aC")));

var $2bfef8c670029adb$var$_square = $2bfef8c670029adb$var$_interopRequireDefault((parcelRequire("6pKm6")));

var $2bfef8c670029adb$var$_square2 = $2bfef8c670029adb$var$_interopRequireDefault((parcelRequire("2waOu")));

var $2bfef8c670029adb$var$_star = $2bfef8c670029adb$var$_interopRequireDefault((parcelRequire("e8oVg")));

var $2bfef8c670029adb$var$_triangle = $2bfef8c670029adb$var$_interopRequireDefault((parcelRequire("i2vdw")));

var $2bfef8c670029adb$var$_triangle2 = $2bfef8c670029adb$var$_interopRequireDefault((parcelRequire("ckkUc")));

var $2bfef8c670029adb$var$_wye = $2bfef8c670029adb$var$_interopRequireDefault((parcelRequire("fPANN")));

var $2bfef8c670029adb$var$_x = $2bfef8c670029adb$var$_interopRequireDefault((parcelRequire("gemeI")));
function $2bfef8c670029adb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $2bfef8c670029adb$var$symbolsFill = [
    $2bfef8c670029adb$var$_circle.default,
    $2bfef8c670029adb$var$_cross.default,
    $2bfef8c670029adb$var$_diamond.default,
    $2bfef8c670029adb$var$_square.default,
    $2bfef8c670029adb$var$_star.default,
    $2bfef8c670029adb$var$_triangle.default,
    $2bfef8c670029adb$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $2bfef8c670029adb$var$symbolsFill;
const $2bfef8c670029adb$var$symbolsStroke = [
    $2bfef8c670029adb$var$_circle.default,
    $2bfef8c670029adb$var$_plus.default,
    $2bfef8c670029adb$var$_x.default,
    $2bfef8c670029adb$var$_triangle2.default,
    $2bfef8c670029adb$var$_asterisk.default,
    $2bfef8c670029adb$var$_square2.default,
    $2bfef8c670029adb$var$_diamond2.default
];
module.exports.symbolsStroke = $2bfef8c670029adb$var$symbolsStroke;
function $2bfef8c670029adb$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $2bfef8c670029adb$var$_constant.default)(type || $2bfef8c670029adb$var$_circle.default);
    size = typeof size === "function" ? size : (0, $2bfef8c670029adb$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $JwOmB.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $2bfef8c670029adb$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $2bfef8c670029adb$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("hAhsc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kk4FQ = parcelRequire("kk4FQ");
const $ccd3566fea2b5045$var$sqrt3 = (0, $kk4FQ.sqrt)(3);
var $ccd3566fea2b5045$var$_default = {
    draw (context, size) {
        const r = (0, $kk4FQ.sqrt)(size + (0, $kk4FQ.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $ccd3566fea2b5045$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $ccd3566fea2b5045$var$_default;

});

parcelRegister("8964m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kk4FQ = parcelRequire("kk4FQ");
var $5ee3df40431aa82e$var$_default = {
    draw (context, size) {
        const r = (0, $kk4FQ.sqrt)(size / $kk4FQ.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $kk4FQ.tau);
    }
};
module.exports.default = $5ee3df40431aa82e$var$_default;

});

parcelRegister("6PZy1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kk4FQ = parcelRequire("kk4FQ");
var $4fa73f994907aa9d$var$_default = {
    draw (context, size) {
        const r = (0, $kk4FQ.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $4fa73f994907aa9d$var$_default;

});

parcelRegister("dUGfS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kk4FQ = parcelRequire("kk4FQ");
const $a2114852436786ee$var$tan30 = (0, $kk4FQ.sqrt)(1 / 3);
const $a2114852436786ee$var$tan30_2 = $a2114852436786ee$var$tan30 * 2;
var $a2114852436786ee$var$_default = {
    draw (context, size) {
        const y = (0, $kk4FQ.sqrt)(size / $a2114852436786ee$var$tan30_2);
        const x = y * $a2114852436786ee$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $a2114852436786ee$var$_default;

});

parcelRegister("7vFGb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kk4FQ = parcelRequire("kk4FQ");
var $577bc24d3ac47215$var$_default = {
    draw (context, size) {
        const r = (0, $kk4FQ.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $577bc24d3ac47215$var$_default;

});

parcelRegister("fB0aC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kk4FQ = parcelRequire("kk4FQ");
var $b5aa7187328b199f$var$_default = {
    draw (context, size) {
        const r = (0, $kk4FQ.sqrt)(size - (0, $kk4FQ.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $b5aa7187328b199f$var$_default;

});

parcelRegister("6pKm6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kk4FQ = parcelRequire("kk4FQ");
var $4ab90921f7fe6812$var$_default = {
    draw (context, size) {
        const w = (0, $kk4FQ.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $4ab90921f7fe6812$var$_default;

});

parcelRegister("2waOu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kk4FQ = parcelRequire("kk4FQ");
var $1d56f53aa7806ed6$var$_default = {
    draw (context, size) {
        const r = (0, $kk4FQ.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $1d56f53aa7806ed6$var$_default;

});

parcelRegister("e8oVg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kk4FQ = parcelRequire("kk4FQ");
const $a4a525218c98f7b9$var$ka = 0.89081309152928522810;
const $a4a525218c98f7b9$var$kr = (0, $kk4FQ.sin)($kk4FQ.pi / 10) / (0, $kk4FQ.sin)(7 * $kk4FQ.pi / 10);
const $a4a525218c98f7b9$var$kx = (0, $kk4FQ.sin)($kk4FQ.tau / 10) * $a4a525218c98f7b9$var$kr;
const $a4a525218c98f7b9$var$ky = -(0, $kk4FQ.cos)($kk4FQ.tau / 10) * $a4a525218c98f7b9$var$kr;
var $a4a525218c98f7b9$var$_default = {
    draw (context, size) {
        const r = (0, $kk4FQ.sqrt)(size * $a4a525218c98f7b9$var$ka);
        const x = $a4a525218c98f7b9$var$kx * r;
        const y = $a4a525218c98f7b9$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $kk4FQ.tau * i / 5;
            const c = (0, $kk4FQ.cos)(a);
            const s = (0, $kk4FQ.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $a4a525218c98f7b9$var$_default;

});

parcelRegister("i2vdw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kk4FQ = parcelRequire("kk4FQ");
const $d220a0f61f0ac2d2$var$sqrt3 = (0, $kk4FQ.sqrt)(3);
var $d220a0f61f0ac2d2$var$_default = {
    draw (context, size) {
        const y = -(0, $kk4FQ.sqrt)(size / ($d220a0f61f0ac2d2$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$d220a0f61f0ac2d2$var$sqrt3 * y, -y);
        context.lineTo($d220a0f61f0ac2d2$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $d220a0f61f0ac2d2$var$_default;

});

parcelRegister("ckkUc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kk4FQ = parcelRequire("kk4FQ");
const $8f9791b26bc695aa$var$sqrt3 = (0, $kk4FQ.sqrt)(3);
var $8f9791b26bc695aa$var$_default = {
    draw (context, size) {
        const s = (0, $kk4FQ.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $8f9791b26bc695aa$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $8f9791b26bc695aa$var$_default;

});

parcelRegister("fPANN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kk4FQ = parcelRequire("kk4FQ");
const $b8682a92141af1b8$var$c = -0.5;
const $b8682a92141af1b8$var$s = (0, $kk4FQ.sqrt)(3) / 2;
const $b8682a92141af1b8$var$k = 1 / (0, $kk4FQ.sqrt)(12);
const $b8682a92141af1b8$var$a = ($b8682a92141af1b8$var$k / 2 + 1) * 3;
var $b8682a92141af1b8$var$_default = {
    draw (context, size) {
        const r = (0, $kk4FQ.sqrt)(size / $b8682a92141af1b8$var$a);
        const x0 = r / 2, y0 = r * $b8682a92141af1b8$var$k;
        const x1 = x0, y1 = r * $b8682a92141af1b8$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($b8682a92141af1b8$var$c * x0 - $b8682a92141af1b8$var$s * y0, $b8682a92141af1b8$var$s * x0 + $b8682a92141af1b8$var$c * y0);
        context.lineTo($b8682a92141af1b8$var$c * x1 - $b8682a92141af1b8$var$s * y1, $b8682a92141af1b8$var$s * x1 + $b8682a92141af1b8$var$c * y1);
        context.lineTo($b8682a92141af1b8$var$c * x2 - $b8682a92141af1b8$var$s * y2, $b8682a92141af1b8$var$s * x2 + $b8682a92141af1b8$var$c * y2);
        context.lineTo($b8682a92141af1b8$var$c * x0 + $b8682a92141af1b8$var$s * y0, $b8682a92141af1b8$var$c * y0 - $b8682a92141af1b8$var$s * x0);
        context.lineTo($b8682a92141af1b8$var$c * x1 + $b8682a92141af1b8$var$s * y1, $b8682a92141af1b8$var$c * y1 - $b8682a92141af1b8$var$s * x1);
        context.lineTo($b8682a92141af1b8$var$c * x2 + $b8682a92141af1b8$var$s * y2, $b8682a92141af1b8$var$c * y2 - $b8682a92141af1b8$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $b8682a92141af1b8$var$_default;

});

parcelRegister("gemeI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kk4FQ = parcelRequire("kk4FQ");
var $bd0f33d94bc24422$var$_default = {
    draw (context, size) {
        const r = (0, $kk4FQ.sqrt)(size - (0, $kk4FQ.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $bd0f33d94bc24422$var$_default;

});


parcelRegister("8lWvL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $614dac0b1f031a6d$var$_default;

var $614dac0b1f031a6d$var$_noop = $614dac0b1f031a6d$var$_interopRequireDefault((parcelRequire("fssAa")));

var $3glKE = parcelRequire("3glKE");
function $614dac0b1f031a6d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $614dac0b1f031a6d$var$BasisClosed(context) {
    this._context = context;
}
$614dac0b1f031a6d$var$BasisClosed.prototype = {
    areaStart: $614dac0b1f031a6d$var$_noop.default,
    areaEnd: $614dac0b1f031a6d$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $3glKE.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $614dac0b1f031a6d$var$_default(context) {
    return new $614dac0b1f031a6d$var$BasisClosed(context);
}

});
parcelRegister("fssAa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b40fa45f95fd1fa4$var$_default;
function $b40fa45f95fd1fa4$var$_default() {}

});

parcelRegister("3glKE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $2603bd18cf0f3d67$var$Basis;
module.exports.default = $2603bd18cf0f3d67$var$_default;
module.exports.point = $2603bd18cf0f3d67$var$point;
function $2603bd18cf0f3d67$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $2603bd18cf0f3d67$var$Basis(context) {
    this._context = context;
}
$2603bd18cf0f3d67$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $2603bd18cf0f3d67$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $2603bd18cf0f3d67$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $2603bd18cf0f3d67$var$_default(context) {
    return new $2603bd18cf0f3d67$var$Basis(context);
}

});


parcelRegister("j3GfS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ddff131a3e96dda1$var$_default;

var $3glKE = parcelRequire("3glKE");
function $ddff131a3e96dda1$var$BasisOpen(context) {
    this._context = context;
}
$ddff131a3e96dda1$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $3glKE.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $ddff131a3e96dda1$var$_default(context) {
    return new $ddff131a3e96dda1$var$BasisOpen(context);
}

});

parcelRegister("9a8vh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3glKE = parcelRequire("3glKE");
function $6abba4dba84179d2$var$Bundle(context, beta) {
    this._basis = new $3glKE.Basis(context);
    this._beta = beta;
}
$6abba4dba84179d2$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $6abba4dba84179d2$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $3glKE.Basis(context) : new $6abba4dba84179d2$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $6abba4dba84179d2$var$_default;

});

parcelRegister("39O9K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $24c91e5828129cc8$var$CardinalClosed;
module.exports.default = void 0;

var $24c91e5828129cc8$var$_noop = $24c91e5828129cc8$var$_interopRequireDefault((parcelRequire("fssAa")));

var $7Vf95 = parcelRequire("7Vf95");
function $24c91e5828129cc8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $24c91e5828129cc8$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$24c91e5828129cc8$var$CardinalClosed.prototype = {
    areaStart: $24c91e5828129cc8$var$_noop.default,
    areaEnd: $24c91e5828129cc8$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $7Vf95.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $24c91e5828129cc8$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $24c91e5828129cc8$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $24c91e5828129cc8$var$_default;

});
parcelRegister("7Vf95", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $5c499adda2b60f2f$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $5c499adda2b60f2f$var$point;
function $5c499adda2b60f2f$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $5c499adda2b60f2f$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$5c499adda2b60f2f$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $5c499adda2b60f2f$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $5c499adda2b60f2f$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $5c499adda2b60f2f$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $5c499adda2b60f2f$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $5c499adda2b60f2f$var$_default;

});


parcelRegister("i7o7h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $d30b96798dd4c3f0$var$CardinalOpen;
module.exports.default = void 0;

var $7Vf95 = parcelRequire("7Vf95");
function $d30b96798dd4c3f0$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$d30b96798dd4c3f0$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $7Vf95.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $d30b96798dd4c3f0$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $d30b96798dd4c3f0$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $d30b96798dd4c3f0$var$_default;

});

parcelRegister("hXMXy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $39O9K = parcelRequire("39O9K");

var $d13decb61bbcac8a$var$_noop = $d13decb61bbcac8a$var$_interopRequireDefault((parcelRequire("fssAa")));

var $2ezV1 = parcelRequire("2ezV1");
function $d13decb61bbcac8a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d13decb61bbcac8a$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$d13decb61bbcac8a$var$CatmullRomClosed.prototype = {
    areaStart: $d13decb61bbcac8a$var$_noop.default,
    areaEnd: $d13decb61bbcac8a$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $2ezV1.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $d13decb61bbcac8a$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $d13decb61bbcac8a$var$CatmullRomClosed(context, alpha) : new $39O9K.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $d13decb61bbcac8a$var$_default;

});
parcelRegister("2ezV1", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $kk4FQ = parcelRequire("kk4FQ");

var $7Vf95 = parcelRequire("7Vf95");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $kk4FQ.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $kk4FQ.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $7Vf95.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

});


parcelRegister("fVNfD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $i7o7h = parcelRequire("i7o7h");

var $2ezV1 = parcelRequire("2ezV1");
function $b99262257fb56814$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$b99262257fb56814$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $2ezV1.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $b99262257fb56814$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $b99262257fb56814$var$CatmullRomOpen(context, alpha) : new $i7o7h.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $b99262257fb56814$var$_default;

});

parcelRegister("b4NOh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8106b4a1837937d5$var$_default;

var $8106b4a1837937d5$var$_noop = $8106b4a1837937d5$var$_interopRequireDefault((parcelRequire("fssAa")));
function $8106b4a1837937d5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8106b4a1837937d5$var$LinearClosed(context) {
    this._context = context;
}
$8106b4a1837937d5$var$LinearClosed.prototype = {
    areaStart: $8106b4a1837937d5$var$_noop.default,
    areaEnd: $8106b4a1837937d5$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $8106b4a1837937d5$var$_default(context) {
    return new $8106b4a1837937d5$var$LinearClosed(context);
}

});

parcelRegister("aTMUl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $7ef4fa87ab6442c5$var$monotoneX;
module.exports.monotoneY = $7ef4fa87ab6442c5$var$monotoneY;
function $7ef4fa87ab6442c5$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $7ef4fa87ab6442c5$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($7ef4fa87ab6442c5$var$sign(s0) + $7ef4fa87ab6442c5$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $7ef4fa87ab6442c5$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $7ef4fa87ab6442c5$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $7ef4fa87ab6442c5$var$MonotoneX(context) {
    this._context = context;
}
$7ef4fa87ab6442c5$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $7ef4fa87ab6442c5$var$point(this, this._t0, $7ef4fa87ab6442c5$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $7ef4fa87ab6442c5$var$point(this, $7ef4fa87ab6442c5$var$slope2(this, t1 = $7ef4fa87ab6442c5$var$slope3(this, x, y)), t1);
                break;
            default:
                $7ef4fa87ab6442c5$var$point(this, this._t0, t1 = $7ef4fa87ab6442c5$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $7ef4fa87ab6442c5$var$MonotoneY(context) {
    this._context = new $7ef4fa87ab6442c5$var$ReflectContext(context);
}
($7ef4fa87ab6442c5$var$MonotoneY.prototype = Object.create($7ef4fa87ab6442c5$var$MonotoneX.prototype)).point = function(x, y) {
    $7ef4fa87ab6442c5$var$MonotoneX.prototype.point.call(this, y, x);
};
function $7ef4fa87ab6442c5$var$ReflectContext(context) {
    this._context = context;
}
$7ef4fa87ab6442c5$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $7ef4fa87ab6442c5$var$monotoneX(context) {
    return new $7ef4fa87ab6442c5$var$MonotoneX(context);
}
function $7ef4fa87ab6442c5$var$monotoneY(context) {
    return new $7ef4fa87ab6442c5$var$MonotoneY(context);
}

});

parcelRegister("4hhdb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $31d619d904c4a7f9$var$_default;
function $31d619d904c4a7f9$var$Natural(context) {
    this._context = context;
}
$31d619d904c4a7f9$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $31d619d904c4a7f9$var$controlPoints(x), py = $31d619d904c4a7f9$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $31d619d904c4a7f9$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $31d619d904c4a7f9$var$_default(context) {
    return new $31d619d904c4a7f9$var$Natural(context);
}

});

parcelRegister("64LSD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $46c841ca87826937$var$_default;
module.exports.stepAfter = $46c841ca87826937$var$stepAfter;
module.exports.stepBefore = $46c841ca87826937$var$stepBefore;
function $46c841ca87826937$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$46c841ca87826937$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $46c841ca87826937$var$_default(context) {
    return new $46c841ca87826937$var$Step(context, 0.5);
}
function $46c841ca87826937$var$stepBefore(context) {
    return new $46c841ca87826937$var$Step(context, 0);
}
function $46c841ca87826937$var$stepAfter(context) {
    return new $46c841ca87826937$var$Step(context, 1);
}

});

parcelRegister("aE5qa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c01d850ef4b2a7e$var$_default;

var $7c01d850ef4b2a7e$var$_array = $7c01d850ef4b2a7e$var$_interopRequireDefault((parcelRequire("hC7DE")));

var $7c01d850ef4b2a7e$var$_constant = $7c01d850ef4b2a7e$var$_interopRequireDefault((parcelRequire("7lFE7")));

var $7c01d850ef4b2a7e$var$_none = $7c01d850ef4b2a7e$var$_interopRequireDefault((parcelRequire("9aRTz")));

var $7c01d850ef4b2a7e$var$_none2 = $7c01d850ef4b2a7e$var$_interopRequireDefault((parcelRequire("gpNFQ")));
function $7c01d850ef4b2a7e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7c01d850ef4b2a7e$var$stackValue(d, key) {
    return d[key];
}
function $7c01d850ef4b2a7e$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $7c01d850ef4b2a7e$var$_default() {
    var keys = (0, $7c01d850ef4b2a7e$var$_constant.default)([]), order = $7c01d850ef4b2a7e$var$_none2.default, offset = $7c01d850ef4b2a7e$var$_none.default, value = $7c01d850ef4b2a7e$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $7c01d850ef4b2a7e$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $7c01d850ef4b2a7e$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $7c01d850ef4b2a7e$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $7c01d850ef4b2a7e$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $7c01d850ef4b2a7e$var$_none2.default : typeof _ === "function" ? _ : (0, $7c01d850ef4b2a7e$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $7c01d850ef4b2a7e$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("9aRTz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6adedabc3e5e4b07$var$_default;
function $6adedabc3e5e4b07$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("gpNFQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf3583522cbb6ede$var$_default;
function $bf3583522cbb6ede$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("8MNuf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6659317bc93d7441$var$_default;

var $6659317bc93d7441$var$_none = $6659317bc93d7441$var$_interopRequireDefault((parcelRequire("9aRTz")));
function $6659317bc93d7441$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6659317bc93d7441$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $6659317bc93d7441$var$_none.default)(series, order);
}

});

parcelRegister("luZSo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fa6c65a5c8bef1b1$var$_default;
function $fa6c65a5c8bef1b1$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("1vVnA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $11a5320aed101764$var$_default;

var $11a5320aed101764$var$_none = $11a5320aed101764$var$_interopRequireDefault((parcelRequire("9aRTz")));
function $11a5320aed101764$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $11a5320aed101764$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $11a5320aed101764$var$_none.default)(series, order);
}

});

parcelRegister("6wWyB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4c132774b7a6325e$var$_default;

var $4c132774b7a6325e$var$_none = $4c132774b7a6325e$var$_interopRequireDefault((parcelRequire("9aRTz")));
function $4c132774b7a6325e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4c132774b7a6325e$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $4c132774b7a6325e$var$_none.default)(series, order);
}

});

parcelRegister("91fxO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $691043d2488325e2$var$_default;

var $691043d2488325e2$var$_none = $691043d2488325e2$var$_interopRequireDefault((parcelRequire("gpNFQ")));
function $691043d2488325e2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $691043d2488325e2$var$_default(series) {
    var peaks = series.map($691043d2488325e2$var$peak);
    return (0, $691043d2488325e2$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $691043d2488325e2$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("kdWqf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eb9256fe60d10c65$var$_default;
module.exports.sum = $eb9256fe60d10c65$var$sum;

var $eb9256fe60d10c65$var$_none = $eb9256fe60d10c65$var$_interopRequireDefault((parcelRequire("gpNFQ")));
function $eb9256fe60d10c65$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $eb9256fe60d10c65$var$_default(series) {
    var sums = series.map($eb9256fe60d10c65$var$sum);
    return (0, $eb9256fe60d10c65$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $eb9256fe60d10c65$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("6zI5r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4c9835a8c37983a6$var$_default;

var $4c9835a8c37983a6$var$_ascending = $4c9835a8c37983a6$var$_interopRequireDefault((parcelRequire("kdWqf")));
function $4c9835a8c37983a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4c9835a8c37983a6$var$_default(series) {
    return (0, $4c9835a8c37983a6$var$_ascending.default)(series).reverse();
}

});

parcelRegister("lkCCH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8796cfb76097da5$var$_default;

var $f8796cfb76097da5$var$_appearance = $f8796cfb76097da5$var$_interopRequireDefault((parcelRequire("91fxO")));

var $kdWqf = parcelRequire("kdWqf");
function $f8796cfb76097da5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f8796cfb76097da5$var$_default(series) {
    var n = series.length, i, j, sums = series.map($kdWqf.sum), order = (0, $f8796cfb76097da5$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("aZXc7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $801d84b0c76d552c$var$_default;

var $801d84b0c76d552c$var$_none = $801d84b0c76d552c$var$_interopRequireDefault((parcelRequire("gpNFQ")));
function $801d84b0c76d552c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $801d84b0c76d552c$var$_default(series) {
    return (0, $801d84b0c76d552c$var$_none.default)(series).reverse();
}

});



parcelRegister("4ckAm", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("apPRO", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("jCFru", function(module, exports) {
"use strict";
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $e491b685df4b6d6b$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.replaceCodePoint = module.exports.fromCodePoint = void 0;
var $e491b685df4b6d6b$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */ module.exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($e491b685df4b6d6b$var$_a = String.fromCodePoint) !== null && $e491b685df4b6d6b$var$_a !== void 0 ? $e491b685df4b6d6b$var$_a : function(codePoint) {
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */ function $e491b685df4b6d6b$var$replaceCodePoint(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $e491b685df4b6d6b$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
module.exports.replaceCodePoint = $e491b685df4b6d6b$var$replaceCodePoint;
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */ function $e491b685df4b6d6b$var$decodeCodePoint(codePoint) {
    return (0, module.exports.fromCodePoint)($e491b685df4b6d6b$var$replaceCodePoint(codePoint));
}
module.exports.default = $e491b685df4b6d6b$var$decodeCodePoint;

});

parcelRegister("h1Rs9", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c65bfe520546a474$var$ReactIs, $c65bfe520546a474$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("kh2Rv"))();

});

var $53f04c69be85011a$exports = {};
$parcel$extendImportMap({
    "1lrMa": "logo.e0718019.png"
});

var $14fc2f3a09df08ae$exports = {};
'use strict';

$14fc2f3a09df08ae$exports = (parcelRequire("2Qwp0"));


parcelRequire("gIfym");
var $c4a08725a78d51bf$exports = {};
'use strict';
function $c4a08725a78d51bf$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($c4a08725a78d51bf$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$c4a08725a78d51bf$var$checkDCE();

$c4a08725a78d51bf$exports = (parcelRequire("eN6q3"));



parcelRequire("gIfym");

var $Ku8r1 = parcelRequire("Ku8r1");

var $gIfym = parcelRequire("gIfym");

var $h1Rs9 = parcelRequire("h1Rs9");

var $k2R8s = parcelRequire("k2R8s");
function $311de12acff63357$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $311de12acff63357$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $311de12acff63357$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $311de12acff63357$var$isAbsolute(to);
    var isFromAbs = from && $311de12acff63357$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $311de12acff63357$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $311de12acff63357$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $311de12acff63357$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $311de12acff63357$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$311de12acff63357$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $311de12acff63357$export$2e2bcd8739ae039 = $311de12acff63357$var$resolvePathname;


function $d55b595ca7b534d5$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $d55b595ca7b534d5$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $d55b595ca7b534d5$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $d55b595ca7b534d5$var$valueOf(a);
        var bValue = $d55b595ca7b534d5$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $d55b595ca7b534d5$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $d55b595ca7b534d5$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $d55b595ca7b534d5$export$2e2bcd8739ae039 = $d55b595ca7b534d5$var$valueEqual;



var $51137fdf63eaf269$var$isProduction = true;
var $51137fdf63eaf269$var$prefix = 'Invariant failed';
function $51137fdf63eaf269$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($51137fdf63eaf269$var$isProduction) throw new Error($51137fdf63eaf269$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($51137fdf63eaf269$var$prefix, ": ").concat(provided) : $51137fdf63eaf269$var$prefix;
    throw new Error(value);
}


function $c0e5765fb75ef8ef$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $c0e5765fb75ef8ef$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $c0e5765fb75ef8ef$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $c0e5765fb75ef8ef$var$stripBasename(path, prefix) {
    return $c0e5765fb75ef8ef$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $c0e5765fb75ef8ef$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $c0e5765fb75ef8ef$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $c0e5765fb75ef8ef$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $c0e5765fb75ef8ef$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $c0e5765fb75ef8ef$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $k2R8s.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $311de12acff63357$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $c0e5765fb75ef8ef$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $d55b595ca7b534d5$export$2e2bcd8739ae039)(a.state, b.state);
}
function $c0e5765fb75ef8ef$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $c0e5765fb75ef8ef$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $c0e5765fb75ef8ef$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $c0e5765fb75ef8ef$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $c0e5765fb75ef8ef$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $c0e5765fb75ef8ef$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $c0e5765fb75ef8ef$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $c0e5765fb75ef8ef$var$PopStateEvent = 'popstate';
var $c0e5765fb75ef8ef$var$HashChangeEvent = 'hashchange';
function $c0e5765fb75ef8ef$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $c0e5765fb75ef8ef$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$c0e5765fb75ef8ef$var$canUseDOM && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $c0e5765fb75ef8ef$var$supportsHistory();
    var needsHashChangeListener = !$c0e5765fb75ef8ef$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $c0e5765fb75ef8ef$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $c0e5765fb75ef8ef$var$stripTrailingSlash($c0e5765fb75ef8ef$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $c0e5765fb75ef8ef$var$stripBasename(path, basename);
        return $c0e5765fb75ef8ef$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $c0e5765fb75ef8ef$var$createTransitionManager();
    function setState(nextState) {
        (0, $k2R8s.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($c0e5765fb75ef8ef$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($c0e5765fb75ef8ef$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($c0e5765fb75ef8ef$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $c0e5765fb75ef8ef$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $c0e5765fb75ef8ef$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $c0e5765fb75ef8ef$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($c0e5765fb75ef8ef$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($c0e5765fb75ef8ef$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($c0e5765fb75ef8ef$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($c0e5765fb75ef8ef$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $c0e5765fb75ef8ef$var$HashChangeEvent$1 = 'hashchange';
var $c0e5765fb75ef8ef$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $c0e5765fb75ef8ef$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $c0e5765fb75ef8ef$var$stripLeadingSlash,
        decodePath: $c0e5765fb75ef8ef$var$addLeadingSlash
    },
    slash: {
        encodePath: $c0e5765fb75ef8ef$var$addLeadingSlash,
        decodePath: $c0e5765fb75ef8ef$var$addLeadingSlash
    }
};
function $c0e5765fb75ef8ef$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $c0e5765fb75ef8ef$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $c0e5765fb75ef8ef$var$pushHashPath(path) {
    window.location.hash = path;
}
function $c0e5765fb75ef8ef$var$replaceHashPath(path) {
    window.location.replace($c0e5765fb75ef8ef$var$stripHash(window.location.href) + '#' + path);
}
function $c0e5765fb75ef8ef$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$c0e5765fb75ef8ef$var$canUseDOM && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $c0e5765fb75ef8ef$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $c0e5765fb75ef8ef$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $c0e5765fb75ef8ef$var$stripTrailingSlash($c0e5765fb75ef8ef$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $c0e5765fb75ef8ef$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($c0e5765fb75ef8ef$var$getHashPath());
        if (basename) path = $c0e5765fb75ef8ef$var$stripBasename(path, basename);
        return $c0e5765fb75ef8ef$export$90c043f1c57770b8(path);
    }
    var transitionManager = $c0e5765fb75ef8ef$var$createTransitionManager();
    function setState(nextState) {
        (0, $k2R8s.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $c0e5765fb75ef8ef$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $c0e5765fb75ef8ef$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $c0e5765fb75ef8ef$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($c0e5765fb75ef8ef$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($c0e5765fb75ef8ef$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $c0e5765fb75ef8ef$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $c0e5765fb75ef8ef$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $c0e5765fb75ef8ef$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $c0e5765fb75ef8ef$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $c0e5765fb75ef8ef$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $c0e5765fb75ef8ef$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $c0e5765fb75ef8ef$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $c0e5765fb75ef8ef$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $c0e5765fb75ef8ef$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($c0e5765fb75ef8ef$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $c0e5765fb75ef8ef$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $c0e5765fb75ef8ef$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $c0e5765fb75ef8ef$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $c0e5765fb75ef8ef$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($c0e5765fb75ef8ef$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($c0e5765fb75ef8ef$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($c0e5765fb75ef8ef$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $c0e5765fb75ef8ef$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $c0e5765fb75ef8ef$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $c0e5765fb75ef8ef$var$createTransitionManager();
    function setState(nextState) {
        (0, $k2R8s.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $c0e5765fb75ef8ef$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $c0e5765fb75ef8ef$export$90c043f1c57770b8(entry, undefined, createKey()) : $c0e5765fb75ef8ef$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $c0e5765fb75ef8ef$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $c0e5765fb75ef8ef$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $c0e5765fb75ef8ef$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $c0e5765fb75ef8ef$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $k2R8s = parcelRequire("k2R8s");
var $e6cfae72bb80dad0$exports = {};
var $209070c8b0ec7001$exports = {};
$209070c8b0ec7001$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $e6cfae72bb80dad0$exports = $e6cfae72bb80dad0$var$pathToRegexp;
$e6cfae72bb80dad0$exports.parse = $e6cfae72bb80dad0$var$parse;
$e6cfae72bb80dad0$exports.compile = $e6cfae72bb80dad0$var$compile;
$e6cfae72bb80dad0$exports.tokensToFunction = $e6cfae72bb80dad0$var$tokensToFunction;
$e6cfae72bb80dad0$exports.tokensToRegExp = $e6cfae72bb80dad0$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $e6cfae72bb80dad0$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $e6cfae72bb80dad0$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $e6cfae72bb80dad0$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $e6cfae72bb80dad0$var$escapeGroup(pattern) : asterisk ? '.*' : $e6cfae72bb80dad0$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $e6cfae72bb80dad0$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $e6cfae72bb80dad0$var$escapeString(delimiter) + ']+?';
    return $e6cfae72bb80dad0$var$escapeString(prevText) + '|(?:(?!' + $e6cfae72bb80dad0$var$escapeString(prevText) + ')[^' + $e6cfae72bb80dad0$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $e6cfae72bb80dad0$var$compile(str, options) {
    return $e6cfae72bb80dad0$var$tokensToFunction($e6cfae72bb80dad0$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $e6cfae72bb80dad0$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $e6cfae72bb80dad0$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $e6cfae72bb80dad0$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $e6cfae72bb80dad0$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $e6cfae72bb80dad0$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($209070c8b0ec7001$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $e6cfae72bb80dad0$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $e6cfae72bb80dad0$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $e6cfae72bb80dad0$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $e6cfae72bb80dad0$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $e6cfae72bb80dad0$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $e6cfae72bb80dad0$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $e6cfae72bb80dad0$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $e6cfae72bb80dad0$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($e6cfae72bb80dad0$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $e6cfae72bb80dad0$var$flags(options));
    return $e6cfae72bb80dad0$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $e6cfae72bb80dad0$var$stringToRegexp(path, keys, options) {
    return $e6cfae72bb80dad0$var$tokensToRegExp($e6cfae72bb80dad0$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $e6cfae72bb80dad0$var$tokensToRegExp(tokens, keys, options) {
    if (!$209070c8b0ec7001$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $e6cfae72bb80dad0$var$escapeString(token);
        else {
            var prefix = $e6cfae72bb80dad0$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $e6cfae72bb80dad0$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $e6cfae72bb80dad0$var$attachKeys(new RegExp('^' + route, $e6cfae72bb80dad0$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $e6cfae72bb80dad0$var$pathToRegexp(path, keys, options) {
    if (!$209070c8b0ec7001$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $e6cfae72bb80dad0$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($209070c8b0ec7001$exports(path)) return $e6cfae72bb80dad0$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $e6cfae72bb80dad0$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $0b2bb1ea50fd1c12$exports = {};
'use strict';

$0b2bb1ea50fd1c12$exports = (parcelRequire("hBYHu"));



var $8hGk9 = parcelRequire("8hGk9");

var $6vbYm = parcelRequire("6vbYm");
var $b585d439d92e032d$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $b585d439d92e032d$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $b585d439d92e032d$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $b585d439d92e032d$var$commonjsGlobal[key] = ($b585d439d92e032d$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $b585d439d92e032d$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $b585d439d92e032d$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $b585d439d92e032d$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $b585d439d92e032d$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $b585d439d92e032d$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $Ku8r1.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $b585d439d92e032d$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($b585d439d92e032d$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $b585d439d92e032d$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $Ku8r1.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $b585d439d92e032d$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $b585d439d92e032d$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $b585d439d92e032d$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $b585d439d92e032d$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createContext || $b585d439d92e032d$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $b585d439d92e032d$var$createNamedContext = function createNamedContext(name) {
    var context = $b585d439d92e032d$var$createContext();
    context.displayName = name;
    return context;
};
var $b585d439d92e032d$export$c213558b66925821 = /*#__PURE__*/ $b585d439d92e032d$var$createNamedContext("Router-History");
var $b585d439d92e032d$export$63baa8ccbe60bb07 = /*#__PURE__*/ $b585d439d92e032d$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $b585d439d92e032d$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $Ku8r1.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($b585d439d92e032d$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($b585d439d92e032d$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $b585d439d92e032d$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $Ku8r1.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $c0e5765fb75ef8ef$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($b585d439d92e032d$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
var $b585d439d92e032d$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $Ku8r1.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $b585d439d92e032d$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($b585d439d92e032d$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($b585d439d92e032d$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $b585d439d92e032d$var$messageType;
var $b585d439d92e032d$var$cache = {};
var $b585d439d92e032d$var$cacheLimit = 10000;
var $b585d439d92e032d$var$cacheCount = 0;
function $b585d439d92e032d$var$compilePath(path) {
    if ($b585d439d92e032d$var$cache[path]) return $b585d439d92e032d$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($e6cfae72bb80dad0$exports))).compile(path);
    if ($b585d439d92e032d$var$cacheCount < $b585d439d92e032d$var$cacheLimit) {
        $b585d439d92e032d$var$cache[path] = generator;
        $b585d439d92e032d$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $b585d439d92e032d$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $b585d439d92e032d$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $b585d439d92e032d$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($b585d439d92e032d$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $c0e5765fb75ef8ef$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $b585d439d92e032d$export$82476f982757e71e(to, computedMatch.params) : (0, $k2R8s.default)({}, to, {
            pathname: $b585d439d92e032d$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($b585d439d92e032d$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $c0e5765fb75ef8ef$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $c0e5765fb75ef8ef$export$c3e8bb440bd55b18)(prevLocation, (0, $k2R8s.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $b585d439d92e032d$var$cache$1 = {};
var $b585d439d92e032d$var$cacheLimit$1 = 10000;
var $b585d439d92e032d$var$cacheCount$1 = 0;
function $b585d439d92e032d$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $b585d439d92e032d$var$cache$1[cacheKey] || ($b585d439d92e032d$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($e6cfae72bb80dad0$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($b585d439d92e032d$var$cacheCount$1 < $b585d439d92e032d$var$cacheLimit$1) {
        pathCache[path] = result;
        $b585d439d92e032d$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $b585d439d92e032d$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $b585d439d92e032d$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $b585d439d92e032d$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Children.count(children) === 0;
}
function $b585d439d92e032d$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $b585d439d92e032d$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $Ku8r1.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($b585d439d92e032d$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $b585d439d92e032d$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $k2R8s.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $b585d439d92e032d$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($b585d439d92e032d$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
function $b585d439d92e032d$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $b585d439d92e032d$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $k2R8s.default)({}, location, {
        pathname: $b585d439d92e032d$var$addLeadingSlash(basename) + location.pathname
    });
}
function $b585d439d92e032d$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $b585d439d92e032d$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $k2R8s.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $b585d439d92e032d$var$createURL(location) {
    return typeof location === "string" ? location : (0, $c0e5765fb75ef8ef$export$fe53371bee54353d)(location);
}
function $b585d439d92e032d$var$staticHandler(methodName) {
    return function() {
        (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
    };
}
function $b585d439d92e032d$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $b585d439d92e032d$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $Ku8r1.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $b585d439d92e032d$var$noop;
        };
        _this.handleBlock = function() {
            return $b585d439d92e032d$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $b585d439d92e032d$var$addBasename(basename, (0, $c0e5765fb75ef8ef$export$90c043f1c57770b8)(location));
        context.url = $b585d439d92e032d$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $8hGk9.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $b585d439d92e032d$var$addLeadingSlash(basename + $b585d439d92e032d$var$createURL(path));
            },
            action: "POP",
            location: $b585d439d92e032d$var$stripBasename(basename, (0, $c0e5765fb75ef8ef$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $b585d439d92e032d$var$staticHandler("go"),
            goBack: $b585d439d92e032d$var$staticHandler("goBack"),
            goForward: $b585d439d92e032d$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($b585d439d92e032d$export$55185c17a0fcbe46, (0, $k2R8s.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $b585d439d92e032d$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $Ku8r1.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($b585d439d92e032d$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $b585d439d92e032d$export$81336c211d5ff295(location.pathname, (0, $k2R8s.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $b585d439d92e032d$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $8hGk9.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($b585d439d92e032d$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(Component, (0, $k2R8s.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6vbYm)))(C, Component);
}
var $b585d439d92e032d$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useContext;
function $b585d439d92e032d$export$3420e1dc2c4a518c() {
    return $b585d439d92e032d$var$useContext($b585d439d92e032d$export$c213558b66925821);
}
function $b585d439d92e032d$export$45d76561a5302f2b() {
    return $b585d439d92e032d$var$useContext($b585d439d92e032d$export$63baa8ccbe60bb07).location;
}
function $b585d439d92e032d$export$99eaa27ddbbb95ef() {
    var match = $b585d439d92e032d$var$useContext($b585d439d92e032d$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $b585d439d92e032d$export$632be4bb944c1bc7(path) {
    var location = $b585d439d92e032d$export$45d76561a5302f2b();
    var match = $b585d439d92e032d$var$useContext($b585d439d92e032d$export$63baa8ccbe60bb07).match;
    return path ? $b585d439d92e032d$export$81336c211d5ff295(location.pathname, path) : match;
}
var $b585d439d92e032d$var$global$1, $b585d439d92e032d$var$key, $b585d439d92e032d$var$buildNames, $b585d439d92e032d$var$initialBuildName, $b585d439d92e032d$var$secondaryBuildName;



var $Ku8r1 = parcelRequire("Ku8r1");

var $gIfym = parcelRequire("gIfym");




var $k2R8s = parcelRequire("k2R8s");

var $8hGk9 = parcelRequire("8hGk9");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $5f667dc1ae602d9e$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $Ku8r1.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $c0e5765fb75ef8ef$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $b585d439d92e032d$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $5f667dc1ae602d9e$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $Ku8r1.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $c0e5765fb75ef8ef$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $b585d439d92e032d$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
var $5f667dc1ae602d9e$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $5f667dc1ae602d9e$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $c0e5765fb75ef8ef$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $5f667dc1ae602d9e$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $5f667dc1ae602d9e$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).forwardRef;
if (typeof $5f667dc1ae602d9e$var$forwardRef === "undefined") $5f667dc1ae602d9e$var$forwardRef = $5f667dc1ae602d9e$var$forwardRefShim;
function $5f667dc1ae602d9e$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $5f667dc1ae602d9e$var$LinkAnchor = $5f667dc1ae602d9e$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $8hGk9.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $k2R8s.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$5f667dc1ae602d9e$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($5f667dc1ae602d9e$var$forwardRefShim !== $5f667dc1ae602d9e$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $5f667dc1ae602d9e$export$a6c7ac8248d6e38a = $5f667dc1ae602d9e$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $5f667dc1ae602d9e$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $8hGk9.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $b585d439d92e032d$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $5f667dc1ae602d9e$var$normalizeToLocation($5f667dc1ae602d9e$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $k2R8s.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $5f667dc1ae602d9e$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $c0e5765fb75ef8ef$export$fe53371bee54353d)(context.location) === (0, $c0e5765fb75ef8ef$export$fe53371bee54353d)($5f667dc1ae602d9e$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($5f667dc1ae602d9e$var$forwardRefShim !== $5f667dc1ae602d9e$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(component, props);
    });
});
var $5f667dc1ae602d9e$var$toType, $5f667dc1ae602d9e$var$refType;
var $5f667dc1ae602d9e$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $5f667dc1ae602d9e$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).forwardRef;
if (typeof $5f667dc1ae602d9e$var$forwardRef$1 === "undefined") $5f667dc1ae602d9e$var$forwardRef$1 = $5f667dc1ae602d9e$var$forwardRefShim$1;
function $5f667dc1ae602d9e$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $5f667dc1ae602d9e$export$b0d92dbee9b5b60d = $5f667dc1ae602d9e$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $8hGk9.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $b585d439d92e032d$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $5f667dc1ae602d9e$var$normalizeToLocation($5f667dc1ae602d9e$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $b585d439d92e032d$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $5f667dc1ae602d9e$var$joinClassnames(className, activeClassName);
            style = (0, $k2R8s.default)({}, style, activeStyle);
        }
        var props = (0, $k2R8s.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($5f667dc1ae602d9e$var$forwardRefShim$1 !== $5f667dc1ae602d9e$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($5f667dc1ae602d9e$export$a6c7ac8248d6e38a, props);
    });
});
var $5f667dc1ae602d9e$var$ariaCurrentType;




var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");


var $82OGZ = parcelRequire("82OGZ");

var $kfLRg = parcelRequire("kfLRg");
var $ff3a7ab0b65b1eb6$var$SIZE = 44;
var $ff3a7ab0b65b1eb6$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'inline-block'
        },
        /* Styles applied to the root element if `variant="static"`. */ static: {
            transition: theme.transitions.create('transform')
        },
        /* Styles applied to the root element if `variant="indeterminate"`. */ indeterminate: {
            animation: '$circular-rotate 1.4s linear infinite'
        },
        /* Styles applied to the root element if `variant="determinate"`. */ determinate: {
            transition: theme.transitions.create('transform')
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the `svg` element. */ svg: {
            display: 'block' // Keeps the progress centered
        },
        /* Styles applied to the `circle` svg path. */ circle: {
            stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
        },
        /* Styles applied to the `circle` svg path if `variant="static"`. */ circleStatic: {
            transition: theme.transitions.create('stroke-dashoffset')
        },
        /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */ circleIndeterminate: {
            animation: '$circular-dash 1.4s ease-in-out infinite',
            // Some default value that looks fine waiting for the animation to kicks in.
            strokeDasharray: '80px, 200px',
            strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
        },
        /* Styles applied to the `circle` svg path if `variant="determinate"`. */ circleDeterminate: {
            transition: theme.transitions.create('stroke-dashoffset')
        },
        '@keyframes circular-rotate': {
            '0%': {
                // Fix IE 11 wobbly
                transformOrigin: '50% 50%'
            },
            '100%': {
                transform: 'rotate(360deg)'
            }
        },
        '@keyframes circular-dash': {
            '0%': {
                strokeDasharray: '1px, 200px',
                strokeDashoffset: '0px'
            },
            '50%': {
                strokeDasharray: '100px, 200px',
                strokeDashoffset: '-15px'
            },
            '100%': {
                strokeDasharray: '100px, 200px',
                strokeDashoffset: '-125px'
            }
        },
        /* Styles applied to the `circle` svg path if `disableShrink={true}`. */ circleDisableShrink: {
            animation: 'none'
        }
    };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ var $ff3a7ab0b65b1eb6$var$CircularProgress = /*#__PURE__*/ $gIfym.forwardRef(function CircularProgress(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$disableShrink = props.disableShrink, disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink, _props$size = props.size, size = _props$size === void 0 ? 40 : _props$size, style = props.style, _props$thickness = props.thickness, thickness = _props$thickness === void 0 ? 3.6 : _props$thickness, _props$value = props.value, value = _props$value === void 0 ? 0 : _props$value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'indeterminate' : _props$variant, other = (0, $f6Qba.default)(props, [
        "classes",
        "className",
        "color",
        "disableShrink",
        "size",
        "style",
        "thickness",
        "value",
        "variant"
    ]);
    var circleStyle = {};
    var rootStyle = {};
    var rootProps = {};
    if (variant === 'determinate' || variant === 'static') {
        var circumference = 2 * Math.PI * (($ff3a7ab0b65b1eb6$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ $gIfym.createElement("div", (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, $kfLRg.default)(color))], {
            'determinate': classes.determinate,
            'indeterminate': classes.indeterminate,
            'static': classes.static
        }[variant]),
        style: (0, $k2R8s.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ref: ref,
        role: "progressbar"
    }, rootProps, other), /*#__PURE__*/ $gIfym.createElement("svg", {
        className: classes.svg,
        viewBox: "".concat($ff3a7ab0b65b1eb6$var$SIZE / 2, " ").concat($ff3a7ab0b65b1eb6$var$SIZE / 2, " ").concat($ff3a7ab0b65b1eb6$var$SIZE, " ").concat($ff3a7ab0b65b1eb6$var$SIZE)
    }, /*#__PURE__*/ $gIfym.createElement("circle", {
        className: (0, $ba4yE.default)(classes.circle, disableShrink && classes.circleDisableShrink, {
            'determinate': classes.circleDeterminate,
            'indeterminate': classes.circleIndeterminate,
            'static': classes.circleStatic
        }[variant]),
        style: circleStyle,
        cx: $ff3a7ab0b65b1eb6$var$SIZE,
        cy: $ff3a7ab0b65b1eb6$var$SIZE,
        r: ($ff3a7ab0b65b1eb6$var$SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
    })));
});
var $ff3a7ab0b65b1eb6$export$2e2bcd8739ae039 = (0, $82OGZ.default)($ff3a7ab0b65b1eb6$export$9dd6ff9ea0189349, {
    name: 'MuiCircularProgress',
    flip: false
})($ff3a7ab0b65b1eb6$var$CircularProgress);



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");


var $82OGZ = parcelRequire("82OGZ");

var $aUprr = parcelRequire("aUprr");

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");



var $ba4yE = parcelRequire("ba4yE");


var $gIfym = parcelRequire("gIfym");
// TODO v5: consider to make it private
function $9c4434890668410f$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


function $9ef4fc3532ca03c1$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $gIfym.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $9c4434890668410f$export$2e2bcd8739ae039)(refA, refValue);
            (0, $9c4434890668410f$export$2e2bcd8739ae039)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}



var $gIfym = parcelRequire("gIfym");
var $fa3e36e8e29920e7$var$useEnhancedEffect = typeof window !== 'undefined' ? $gIfym.useLayoutEffect : $gIfym.useEffect;
function $fa3e36e8e29920e7$export$2e2bcd8739ae039(fn) {
    var ref = $gIfym.useRef(fn);
    $fa3e36e8e29920e7$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $gIfym.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}




var $82OGZ = parcelRequire("82OGZ");
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $gIfym = parcelRequire("gIfym");

var $c26c53624e49625a$var$hadKeyboardEvent = true;
var $c26c53624e49625a$var$hadFocusVisibleRecently = false;
var $c26c53624e49625a$var$hadFocusVisibleRecentlyTimeout = null;
var $c26c53624e49625a$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */ function $c26c53624e49625a$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === 'INPUT' && $c26c53624e49625a$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $c26c53624e49625a$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $c26c53624e49625a$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $c26c53624e49625a$var$handlePointerDown() {
    $c26c53624e49625a$var$hadKeyboardEvent = false;
}
function $c26c53624e49625a$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($c26c53624e49625a$var$hadFocusVisibleRecently) $c26c53624e49625a$var$hadKeyboardEvent = true;
    }
}
function $c26c53624e49625a$var$prepare(doc) {
    doc.addEventListener('keydown', $c26c53624e49625a$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $c26c53624e49625a$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $c26c53624e49625a$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $c26c53624e49625a$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $c26c53624e49625a$var$handleVisibilityChange, true);
}
function $c26c53624e49625a$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $c26c53624e49625a$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $c26c53624e49625a$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $c26c53624e49625a$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $c26c53624e49625a$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $c26c53624e49625a$var$handleVisibilityChange, true);
}
function $c26c53624e49625a$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(':focus-visible');
    } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    // no need for validFocusTarget check. the user does that by attaching it to
    // focusable events only
    return $c26c53624e49625a$var$hadKeyboardEvent || $c26c53624e49625a$var$focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */ function $c26c53624e49625a$var$handleBlurVisible() {
    // To detect a tab/window switch, we look for a blur event followed
    // rapidly by a visibility change.
    // If we don't see a visibility change within 100ms, it's probably a
    // regular focus change.
    $c26c53624e49625a$var$hadFocusVisibleRecently = true;
    window.clearTimeout($c26c53624e49625a$var$hadFocusVisibleRecentlyTimeout);
    $c26c53624e49625a$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        $c26c53624e49625a$var$hadFocusVisibleRecently = false;
    }, 100);
}
function $c26c53624e49625a$export$2e2bcd8739ae039() {
    var ref = $gIfym.useCallback(function(instance) {
        var node = $c4a08725a78d51bf$exports.findDOMNode(instance);
        if (node != null) $c26c53624e49625a$var$prepare(node.ownerDocument);
    }, []);
    return {
        isFocusVisible: $c26c53624e49625a$var$isFocusVisible,
        onBlurVisible: $c26c53624e49625a$var$handleBlurVisible,
        ref: ref
    };
}



var $k2R8s = parcelRequire("k2R8s");

var $9unC2 = parcelRequire("9unC2");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $8hGk9 = parcelRequire("8hGk9");

var $k2R8s = parcelRequire("k2R8s");

var $6o8oQ = parcelRequire("6o8oQ");

var $Ku8r1 = parcelRequire("Ku8r1");


var $gIfym = parcelRequire("gIfym");

var $gIfym = parcelRequire("gIfym");
var $62aabe3b0546d049$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createContext(null);



var $gIfym = parcelRequire("gIfym");
function $27ac1cb9d99d0488$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $gIfym.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $gIfym.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $27ac1cb9d99d0488$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $27ac1cb9d99d0488$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $27ac1cb9d99d0488$export$fa71e2345c31d7a2(props, onExited) {
    return $27ac1cb9d99d0488$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $gIfym.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $27ac1cb9d99d0488$var$getProp(child, 'appear', props),
            enter: $27ac1cb9d99d0488$var$getProp(child, 'enter', props),
            exit: $27ac1cb9d99d0488$var$getProp(child, 'exit', props)
        });
    });
}
function $27ac1cb9d99d0488$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $27ac1cb9d99d0488$export$bbc8a025727ea824(nextProps.children);
    var children = $27ac1cb9d99d0488$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $gIfym.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $gIfym.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $gIfym.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $27ac1cb9d99d0488$var$getProp(child, 'exit', nextProps),
            enter: $27ac1cb9d99d0488$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $gIfym.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $gIfym.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $gIfym.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $27ac1cb9d99d0488$var$getProp(child, 'exit', nextProps),
            enter: $27ac1cb9d99d0488$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $c8a94535b2e16cf8$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $c8a94535b2e16cf8$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $c8a94535b2e16cf8$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $Ku8r1.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $6o8oQ.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $27ac1cb9d99d0488$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $27ac1cb9d99d0488$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $27ac1cb9d99d0488$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $k2R8s.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $8hGk9.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $c8a94535b2e16cf8$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $62aabe3b0546d049$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $62aabe3b0546d049$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$c8a94535b2e16cf8$var$TransitionGroup.propTypes = {};
$c8a94535b2e16cf8$var$TransitionGroup.defaultProps = $c8a94535b2e16cf8$var$defaultProps;
var $c8a94535b2e16cf8$export$2e2bcd8739ae039 = $c8a94535b2e16cf8$var$TransitionGroup;



var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $460612fffcd4830c$var$useEnhancedEffect = typeof window === 'undefined' ? $gIfym.useEffect : $gIfym.useLayoutEffect;
/**
 * @ignore - internal component.
 */ function $460612fffcd4830c$var$Ripple(props) {
    var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props.in, _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function() {} : _props$onExited, timeout = props.timeout;
    var _React$useState = $gIfym.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
    var rippleClassName = (0, $ba4yE.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $ba4yE.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    var handleExited = (0, $fa3e36e8e29920e7$export$2e2bcd8739ae039)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
    $460612fffcd4830c$var$useEnhancedEffect(function() {
        if (!inProp) {
            // react-transition-group#onExit
            setLeaving(true); // react-transition-group#onExited
            var timeoutId = setTimeout(handleExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        handleExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ $gIfym.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
    }, /*#__PURE__*/ $gIfym.createElement("span", {
        className: childClassName
    }));
}
var $460612fffcd4830c$export$2e2bcd8739ae039 = $460612fffcd4830c$var$Ripple;


var $c8c70106cb43d6c5$var$DURATION = 550;
var $c8c70106cb43d6c5$export$95d0c9356b2231a3 = 80;
var $c8c70106cb43d6c5$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: 'hidden',
            pointerEvents: 'none',
            position: 'absolute',
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: 'inherit'
        },
        /* Styles applied to the internal `Ripple` components `ripple` class. */ ripple: {
            opacity: 0,
            position: 'absolute'
        },
        /* Styles applied to the internal `Ripple` components `rippleVisible` class. */ rippleVisible: {
            opacity: 0.3,
            transform: 'scale(1)',
            animation: "$enter ".concat($c8c70106cb43d6c5$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */ ripplePulsate: {
            animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
        },
        /* Styles applied to the internal `Ripple` components `child` class. */ child: {
            opacity: 1,
            display: 'block',
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            backgroundColor: 'currentColor'
        },
        /* Styles applied to the internal `Ripple` components `childLeaving` class. */ childLeaving: {
            opacity: 0,
            animation: "$exit ".concat($c8c70106cb43d6c5$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `childPulsate` class. */ childPulsate: {
            position: 'absolute',
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
        },
        '@keyframes enter': {
            '0%': {
                transform: 'scale(0)',
                opacity: 0.1
            },
            '100%': {
                transform: 'scale(1)',
                opacity: 0.3
            }
        },
        '@keyframes exit': {
            '0%': {
                opacity: 1
            },
            '100%': {
                opacity: 0
            }
        },
        '@keyframes pulsate': {
            '0%': {
                transform: 'scale(1)'
            },
            '50%': {
                transform: 'scale(0.92)'
            },
            '100%': {
                transform: 'scale(1)'
            }
        }
    };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $c8c70106cb43d6c5$var$TouchRipple = /*#__PURE__*/ $gIfym.forwardRef(function TouchRipple(props, ref) {
    var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0, $f6Qba.default)(props, [
        "center",
        "classes",
        "className"
    ]);
    var _React$useState = $gIfym.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
    var nextKey = $gIfym.useRef(0);
    var rippleCallback = $gIfym.useRef(null);
    $gIfym.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $gIfym.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $gIfym.useRef(null); // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $gIfym.useRef(null);
    var container = $gIfym.useRef(null);
    $gIfym.useEffect(function() {
        return function() {
            clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $gIfym.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return [].concat((0, $9unC2.default)(oldRipples), [
                /*#__PURE__*/ $gIfym.createElement((0, $460612fffcd4830c$export$2e2bcd8739ae039), {
                    key: nextKey.current,
                    classes: classes,
                    timeout: $c8c70106cb43d6c5$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                })
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $gIfym.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments.length > 2 ? arguments[2] : undefined;
        var _options$pulsate = options.pulsate, pulsate = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
        if (event.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === 'touchstart') ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $c8c70106cb43d6c5$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $gIfym.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $gIfym.useCallback(function(event, cb) {
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === 'touchend' && startTimerCommit.current) {
            event.persist();
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $gIfym.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ $gIfym.createElement("span", (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className),
        ref: container
    }, other), /*#__PURE__*/ $gIfym.createElement((0, $c8a94535b2e16cf8$export$2e2bcd8739ae039), {
        component: null,
        exit: true
    }, ripples));
});
var $c8c70106cb43d6c5$export$2e2bcd8739ae039 = (0, $82OGZ.default)($c8c70106cb43d6c5$export$9dd6ff9ea0189349, {
    flip: false,
    name: 'MuiTouchRipple'
})(/*#__PURE__*/ $gIfym.memo($c8c70106cb43d6c5$var$TouchRipple));


var $c3be49ff5d39de33$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        '-moz-appearance': 'none',
        // Reset
        '-webkit-appearance': 'none',
        // Reset
        textDecoration: 'none',
        // So we take precedent over the style of a native <a /> element.
        color: 'inherit',
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        '&$disabled': {
            pointerEvents: 'none',
            // Disable link interactions
            cursor: 'default'
        },
        '@media print': {
            colorAdjust: 'exact'
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
    /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $c3be49ff5d39de33$var$ButtonBase = /*#__PURE__*/ $gIfym.forwardRef(function ButtonBase(props, ref) {
    var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? 'button' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? 'button' : _props$type, other = (0, $f6Qba.default)(props, [
        "action",
        "buttonRef",
        "centerRipple",
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "onBlur",
        "onClick",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "onDragLeave",
        "tabIndex",
        "TouchRippleProps",
        "type"
    ]);
    var buttonRef = $gIfym.useRef(null);
    function getButtonNode() {
        // #StrictMode ready
        return $c4a08725a78d51bf$exports.findDOMNode(buttonRef.current);
    }
    var rippleRef = $gIfym.useRef(null);
    var _React$useState = $gIfym.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    var _useIsFocusVisible = (0, $c26c53624e49625a$export$2e2bcd8739ae039)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    $gIfym.useImperativeHandle(action, function() {
        return {
            focusVisible: function focusVisible() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    $gIfym.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
        return (0, $fa3e36e8e29920e7$export$2e2bcd8739ae039)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    var handleMouseDown = useRippleHandler('start', onMouseDown);
    var handleDragLeave = useRippleHandler('stop', onDragLeave);
    var handleMouseUp = useRippleHandler('stop', onMouseUp);
    var handleMouseLeave = useRippleHandler('stop', function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler('start', onTouchStart);
    var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    var handleTouchMove = useRippleHandler('stop', onTouchMove);
    var handleBlur = useRippleHandler('stop', function(event) {
        if (focusVisible) {
            onBlurVisible(event);
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $fa3e36e8e29920e7$export$2e2bcd8739ae039)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (isFocusVisible(event)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function isNonNativeButton() {
        var button = getButtonNode();
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $gIfym.useRef(false);
    var handleKeyDown = (0, $fa3e36e8e29920e7$export$2e2bcd8739ae039)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $fa3e36e8e29920e7$export$2e2bcd8739ae039)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === 'button' && other.href) ComponentProp = 'a';
    var buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (ComponentProp !== 'a' || !other.href) buttonProps.role = 'button';
        buttonProps['aria-disabled'] = disabled;
    }
    var handleUserRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(buttonRefProp, ref);
    var handleOwnRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(focusVisibleRef, buttonRef);
    var handleRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(handleUserRef, handleOwnRef);
    var _React$useState2 = $gIfym.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    $gIfym.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    return /*#__PURE__*/ $gIfym.createElement(ComponentProp, (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className, focusVisible && [
            classes.focusVisible,
            focusVisibleClassName
        ], disabled && classes.disabled),
        onBlur: handleBlur,
        onClick: onClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex
    }, buttonProps, other), children, enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ $gIfym.createElement((0, $c8c70106cb43d6c5$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        ref: rippleRef,
        center: centerRipple
    }, TouchRippleProps)) : null);
});
var $c3be49ff5d39de33$export$2e2bcd8739ae039 = (0, $82OGZ.default)($c3be49ff5d39de33$export$9dd6ff9ea0189349, {
    name: 'MuiButtonBase'
})($c3be49ff5d39de33$var$ButtonBase);



var $kfLRg = parcelRequire("kfLRg");
var $2ae0a89ca37bbdde$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            textAlign: 'center',
            flex: '0 0 auto',
            fontSize: theme.typography.pxToRem(24),
            padding: 12,
            borderRadius: '50%',
            overflow: 'visible',
            // Explicitly set the default value to solve a bug on IE 11.
            color: theme.palette.action.active,
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.shortest
            }),
            '&:hover': {
                backgroundColor: (0, $aUprr.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                backgroundColor: 'transparent',
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -12,
            '$sizeSmall&': {
                marginLeft: -3
            }
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -12,
            '$sizeSmall&': {
                marginRight: -3
            }
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: (0, $aUprr.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: (0, $aUprr.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: 3,
            fontSize: theme.typography.pxToRem(18)
        },
        /* Styles applied to the children container element. */ label: {
            width: '100%',
            display: 'flex',
            alignItems: 'inherit',
            justifyContent: 'inherit'
        }
    };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */ var $2ae0a89ca37bbdde$var$IconButton = /*#__PURE__*/ $gIfym.forwardRef(function IconButton(props, ref) {
    var _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, other = (0, $f6Qba.default)(props, [
        "edge",
        "children",
        "classes",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size"
    ]);
    return /*#__PURE__*/ $gIfym.createElement((0, $c3be49ff5d39de33$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className, color !== 'default' && classes["color".concat((0, $kfLRg.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, $kfLRg.default)(size))], {
            'start': classes.edgeStart,
            'end': classes.edgeEnd
        }[edge]),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other), /*#__PURE__*/ $gIfym.createElement("span", {
        className: classes.label
    }, children));
});
var $2ae0a89ca37bbdde$export$2e2bcd8739ae039 = (0, $82OGZ.default)($2ae0a89ca37bbdde$export$9dd6ff9ea0189349, {
    name: 'MuiIconButton'
})($2ae0a89ca37bbdde$var$IconButton);



var $f6Qba = parcelRequire("f6Qba");

var $k2R8s = parcelRequire("k2R8s");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");


var $82OGZ = parcelRequire("82OGZ");
var $ee13f6b8f50f92d0$export$9dd6ff9ea0189349 = function styles(theme) {
    var elevations = {};
    theme.shadows.forEach(function(shadow, index) {
        elevations["elevation".concat(index)] = {
            boxShadow: shadow
        };
    });
    return (0, $k2R8s.default)({
        /* Styles applied to the root element. */ root: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            transition: theme.transitions.create('box-shadow')
        },
        /* Styles applied to the root element if `square={false}`. */ rounded: {
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            border: "1px solid ".concat(theme.palette.divider)
        }
    }, elevations);
};
var $ee13f6b8f50f92d0$var$Paper = /*#__PURE__*/ $gIfym.forwardRef(function Paper(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 1 : _props$elevation, _props$variant = props.variant, variant = _props$variant === void 0 ? 'elevation' : _props$variant, other = (0, $f6Qba.default)(props, [
        "classes",
        "className",
        "component",
        "square",
        "elevation",
        "variant"
    ]);
    return /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
        ref: ref
    }, other));
});
var $ee13f6b8f50f92d0$export$2e2bcd8739ae039 = (0, $82OGZ.default)($ee13f6b8f50f92d0$export$9dd6ff9ea0189349, {
    name: 'MuiPaper'
})($ee13f6b8f50f92d0$var$Paper);



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");

var $kfLRg = parcelRequire("kfLRg");
var $9c5b9e5aa5c4774c$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            margin: 0
        },
        /* Styles applied to the root element if `variant="body2"`. */ body2: theme.typography.body2,
        /* Styles applied to the root element if `variant="body1"`. */ body1: theme.typography.body1,
        /* Styles applied to the root element if `variant="caption"`. */ caption: theme.typography.caption,
        /* Styles applied to the root element if `variant="button"`. */ button: theme.typography.button,
        /* Styles applied to the root element if `variant="h1"`. */ h1: theme.typography.h1,
        /* Styles applied to the root element if `variant="h2"`. */ h2: theme.typography.h2,
        /* Styles applied to the root element if `variant="h3"`. */ h3: theme.typography.h3,
        /* Styles applied to the root element if `variant="h4"`. */ h4: theme.typography.h4,
        /* Styles applied to the root element if `variant="h5"`. */ h5: theme.typography.h5,
        /* Styles applied to the root element if `variant="h6"`. */ h6: theme.typography.h6,
        /* Styles applied to the root element if `variant="subtitle1"`. */ subtitle1: theme.typography.subtitle1,
        /* Styles applied to the root element if `variant="subtitle2"`. */ subtitle2: theme.typography.subtitle2,
        /* Styles applied to the root element if `variant="overline"`. */ overline: theme.typography.overline,
        /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */ srOnly: {
            position: 'absolute',
            height: 1,
            width: 1,
            overflow: 'hidden'
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: 'left'
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: 'center'
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: 'right'
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: 'justify'
        },
        /* Styles applied to the root element if `nowrap={true}`. */ noWrap: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        /* Styles applied to the root element if `gutterBottom={true}`. */ gutterBottom: {
            marginBottom: '0.35em'
        },
        /* Styles applied to the root element if `paragraph={true}`. */ paragraph: {
            marginBottom: 16
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="textPrimary"`. */ colorTextPrimary: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `color="textSecondary"`. */ colorTextSecondary: {
            color: theme.palette.text.secondary
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `display="inline"`. */ displayInline: {
            display: 'inline'
        },
        /* Styles applied to the root element if `display="block"`. */ displayBlock: {
            display: 'block'
        }
    };
};
var $9c5b9e5aa5c4774c$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p'
};
var $9c5b9e5aa5c4774c$var$Typography = /*#__PURE__*/ $gIfym.forwardRef(function Typography(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? 'inherit' : _props$align, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'initial' : _props$color, component = props.component, _props$display = props.display, display = _props$display === void 0 ? 'initial' : _props$display, _props$gutterBottom = props.gutterBottom, gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom, _props$noWrap = props.noWrap, noWrap = _props$noWrap === void 0 ? false : _props$noWrap, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? false : _props$paragraph, _props$variant = props.variant, variant = _props$variant === void 0 ? 'body1' : _props$variant, _props$variantMapping = props.variantMapping, variantMapping = _props$variantMapping === void 0 ? $9c5b9e5aa5c4774c$var$defaultVariantMapping : _props$variantMapping, other = (0, $f6Qba.default)(props, [
        "align",
        "classes",
        "className",
        "color",
        "component",
        "display",
        "gutterBottom",
        "noWrap",
        "paragraph",
        "variant",
        "variantMapping"
    ]);
    var Component = component || (paragraph ? 'p' : variantMapping[variant] || $9c5b9e5aa5c4774c$var$defaultVariantMapping[variant]) || 'span';
    return /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat((0, $kfLRg.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat((0, $kfLRg.default)(align))], display !== 'initial' && classes["display".concat((0, $kfLRg.default)(display))]),
        ref: ref
    }, other));
});
var $9c5b9e5aa5c4774c$export$2e2bcd8739ae039 = (0, $82OGZ.default)($9c5b9e5aa5c4774c$export$9dd6ff9ea0189349, {
    name: 'MuiTypography'
})($9c5b9e5aa5c4774c$var$Typography);


var $82db5f4ea5a284fb$exports = {};
"use strict";
var $9b6be45f16d1a28c$exports = {};
function $9b6be45f16d1a28c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
$9b6be45f16d1a28c$exports = $9b6be45f16d1a28c$var$_interopRequireDefault, $9b6be45f16d1a28c$exports.__esModule = true, $9b6be45f16d1a28c$exports["default"] = $9b6be45f16d1a28c$exports;


var $2794e01ecb82119c$exports = {};
var $c33c301477c193c0$exports = {};
function $c33c301477c193c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c33c301477c193c0$exports = $c33c301477c193c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c33c301477c193c0$exports.__esModule = true, $c33c301477c193c0$exports["default"] = $c33c301477c193c0$exports, $c33c301477c193c0$var$_typeof(o);
}
$c33c301477c193c0$exports = $c33c301477c193c0$var$_typeof, $c33c301477c193c0$exports.__esModule = true, $c33c301477c193c0$exports["default"] = $c33c301477c193c0$exports;


var $2794e01ecb82119c$var$_typeof = $c33c301477c193c0$exports.default;
function $2794e01ecb82119c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2794e01ecb82119c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2794e01ecb82119c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $2794e01ecb82119c$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $2794e01ecb82119c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
$2794e01ecb82119c$exports = $2794e01ecb82119c$var$_interopRequireWildcard, $2794e01ecb82119c$exports.__esModule = true, $2794e01ecb82119c$exports["default"] = $2794e01ecb82119c$exports;


Object.defineProperty($82db5f4ea5a284fb$exports, "__esModule", {
    value: true
});
$82db5f4ea5a284fb$exports.default = void 0;

var $82db5f4ea5a284fb$var$React = $2794e01ecb82119c$exports((parcelRequire("gIfym")));

var $82db5f4ea5a284fb$var$_createSvgIcon = $9b6be45f16d1a28c$exports((parcelRequire("kKaK5")));
var $82db5f4ea5a284fb$var$_default = (0, $82db5f4ea5a284fb$var$_createSvgIcon.default)(/*#__PURE__*/ $82db5f4ea5a284fb$var$React.createElement("path", {
    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
}), 'Refresh');
$82db5f4ea5a284fb$exports.default = $82db5f4ea5a284fb$var$_default;



var $hQJVM = parcelRequire("hQJVM");

var $6IRuR = parcelRequire("6IRuR");

var $gIfym = parcelRequire("gIfym");




var $gIfym = parcelRequire("gIfym");

var $6IRuR = parcelRequire("6IRuR");

var $hQJVM = parcelRequire("hQJVM");

var $f6Qba = parcelRequire("f6Qba");

var $k2R8s = parcelRequire("k2R8s");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");


var $82OGZ = parcelRequire("82OGZ");

var $gIfym = parcelRequire("gIfym");
/**
 * @ignore - internal component.
 */ var $cd1c2d360ddfb3ad$var$TableContext = $gIfym.createContext();
var $cd1c2d360ddfb3ad$export$2e2bcd8739ae039 = $cd1c2d360ddfb3ad$var$TableContext;


var $9baaa18523ae0079$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'table',
            width: '100%',
            borderCollapse: 'collapse',
            borderSpacing: 0,
            '& caption': (0, $k2R8s.default)({}, theme.typography.body2, {
                padding: theme.spacing(2),
                color: theme.palette.text.secondary,
                textAlign: 'left',
                captionSide: 'bottom'
            })
        },
        /* Styles applied to the root element if `stickyHeader={true}`. */ stickyHeader: {
            borderCollapse: 'separate'
        }
    };
};
var $9baaa18523ae0079$var$defaultComponent = 'table';
var $9baaa18523ae0079$var$Table = /*#__PURE__*/ $gIfym.forwardRef(function Table(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $9baaa18523ae0079$var$defaultComponent : _props$component, _props$padding = props.padding, padding = _props$padding === void 0 ? 'normal' : _props$padding, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, _props$stickyHeader = props.stickyHeader, stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader, other = (0, $f6Qba.default)(props, [
        "classes",
        "className",
        "component",
        "padding",
        "size",
        "stickyHeader"
    ]);
    var table = $gIfym.useMemo(function() {
        return {
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        };
    }, [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ $gIfym.createElement((0, $cd1c2d360ddfb3ad$export$2e2bcd8739ae039).Provider, {
        value: table
    }, /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        role: Component === $9baaa18523ae0079$var$defaultComponent ? null : 'table',
        ref: ref,
        className: (0, $ba4yE.default)(classes.root, className, stickyHeader && classes.stickyHeader)
    }, other)));
});
var $9baaa18523ae0079$export$2e2bcd8739ae039 = (0, $82OGZ.default)($9baaa18523ae0079$export$9dd6ff9ea0189349, {
    name: 'MuiTable'
})($9baaa18523ae0079$var$Table);



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");

var $gIfym = parcelRequire("gIfym");
/**
 * @ignore - internal component.
 */ var $b93432a45511fa87$var$Tablelvl2Context = $gIfym.createContext();
var $b93432a45511fa87$export$2e2bcd8739ae039 = $b93432a45511fa87$var$Tablelvl2Context;


var $b26ae0b21e46ca86$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'table-row-group'
    }
};
var $b26ae0b21e46ca86$var$tablelvl2 = {
    variant: 'body'
};
var $b26ae0b21e46ca86$var$defaultComponent = 'tbody';
var $b26ae0b21e46ca86$var$TableBody = /*#__PURE__*/ $gIfym.forwardRef(function TableBody(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $b26ae0b21e46ca86$var$defaultComponent : _props$component, other = (0, $f6Qba.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $gIfym.createElement((0, $b93432a45511fa87$export$2e2bcd8739ae039).Provider, {
        value: $b26ae0b21e46ca86$var$tablelvl2
    }, /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className),
        ref: ref,
        role: Component === $b26ae0b21e46ca86$var$defaultComponent ? null : 'rowgroup'
    }, other)));
});
var $b26ae0b21e46ca86$export$2e2bcd8739ae039 = (0, $82OGZ.default)($b26ae0b21e46ca86$export$9dd6ff9ea0189349, {
    name: 'MuiTableBody'
})($b26ae0b21e46ca86$var$TableBody);



var $f6Qba = parcelRequire("f6Qba");

var $k2R8s = parcelRequire("k2R8s");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");


var $82OGZ = parcelRequire("82OGZ");

var $kfLRg = parcelRequire("kfLRg");

var $aUprr = parcelRequire("aUprr");


var $911323fee9a96c67$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $k2R8s.default)({}, theme.typography.body2, {
            display: 'table-cell',
            verticalAlign: 'inherit',
            // Workaround for a rendering bug with spanned columns in Chrome 62.0.
            // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
            borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? (0, $aUprr.lighten)((0, $aUprr.alpha)(theme.palette.divider, 1), 0.88) : (0, $aUprr.darken)((0, $aUprr.alpha)(theme.palette.divider, 1), 0.68)),
            textAlign: 'left',
            padding: 16
        }),
        /* Styles applied to the root element if `variant="head"` or `context.table.head`. */ head: {
            color: theme.palette.text.primary,
            lineHeight: theme.typography.pxToRem(24),
            fontWeight: theme.typography.fontWeightMedium
        },
        /* Styles applied to the root element if `variant="body"` or `context.table.body`. */ body: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */ footer: {
            color: theme.palette.text.secondary,
            lineHeight: theme.typography.pxToRem(21),
            fontSize: theme.typography.pxToRem(12)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: '6px 24px 6px 16px',
            '&:last-child': {
                paddingRight: 16
            },
            '&$paddingCheckbox': {
                width: 24,
                // prevent the checkbox column from growing
                padding: '0 12px 0 16px',
                '&:last-child': {
                    paddingLeft: 12,
                    paddingRight: 16
                },
                '& > *': {
                    padding: 0
                }
            }
        },
        /* Styles applied to the root element if `padding="checkbox"`. */ paddingCheckbox: {
            width: 48,
            // prevent the checkbox column from growing
            padding: '0 0 0 4px',
            '&:last-child': {
                paddingLeft: 0,
                paddingRight: 4
            }
        },
        /* Styles applied to the root element if `padding="none"`. */ paddingNone: {
            padding: 0,
            '&:last-child': {
                padding: 0
            }
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: 'left'
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: 'center'
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: 'right',
            flexDirection: 'row-reverse'
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: 'justify'
        },
        /* Styles applied to the root element if `context.table.stickyHeader={true}`. */ stickyHeader: {
            position: 'sticky',
            top: 0,
            left: 0,
            zIndex: 2,
            backgroundColor: theme.palette.background.default
        }
    };
};
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ var $911323fee9a96c67$var$TableCell = /*#__PURE__*/ $gIfym.forwardRef(function TableCell(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? 'inherit' : _props$align, classes = props.classes, className = props.className, component = props.component, paddingProp = props.padding, scopeProp = props.scope, sizeProp = props.size, sortDirection = props.sortDirection, variantProp = props.variant, other = (0, $f6Qba.default)(props, [
        "align",
        "classes",
        "className",
        "component",
        "padding",
        "scope",
        "size",
        "sortDirection",
        "variant"
    ]);
    var table = $gIfym.useContext((0, $cd1c2d360ddfb3ad$export$2e2bcd8739ae039));
    var tablelvl2 = $gIfym.useContext((0, $b93432a45511fa87$export$2e2bcd8739ae039));
    var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    var role;
    var Component;
    if (component) {
        Component = component;
        role = isHeadCell ? 'columnheader' : 'cell';
    } else Component = isHeadCell ? 'th' : 'td';
    var scope = scopeProp;
    if (!scope && isHeadCell) scope = 'col';
    var padding = paddingProp || (table && table.padding ? table.padding : 'normal');
    var size = sizeProp || (table && table.size ? table.size : 'medium');
    var variant = variantProp || tablelvl2 && tablelvl2.variant;
    var ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        ref: ref,
        className: (0, $ba4yE.default)(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat((0, $kfLRg.default)(align))], padding !== 'normal' && classes["padding".concat((0, $kfLRg.default)(padding))], size !== 'medium' && classes["size".concat((0, $kfLRg.default)(size))], variant === 'head' && table && table.stickyHeader && classes.stickyHeader),
        "aria-sort": ariaSort,
        role: role,
        scope: scope
    }, other));
});
var $911323fee9a96c67$export$2e2bcd8739ae039 = (0, $82OGZ.default)($911323fee9a96c67$export$9dd6ff9ea0189349, {
    name: 'MuiTableCell'
})($911323fee9a96c67$var$TableCell);



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");
var $6d7bd70307fdcf46$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        width: '100%',
        overflowX: 'auto'
    }
};
var $6d7bd70307fdcf46$var$TableContainer = /*#__PURE__*/ $gIfym.forwardRef(function TableContainer(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, other = (0, $f6Qba.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        ref: ref,
        className: (0, $ba4yE.default)(classes.root, className)
    }, other));
});
var $6d7bd70307fdcf46$export$2e2bcd8739ae039 = (0, $82OGZ.default)($6d7bd70307fdcf46$export$9dd6ff9ea0189349, {
    name: 'MuiTableContainer'
})($6d7bd70307fdcf46$var$TableContainer);



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");

var $8877b048d1d8501c$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'table-header-group'
    }
};
var $8877b048d1d8501c$var$tablelvl2 = {
    variant: 'head'
};
var $8877b048d1d8501c$var$defaultComponent = 'thead';
var $8877b048d1d8501c$var$TableHead = /*#__PURE__*/ $gIfym.forwardRef(function TableHead(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $8877b048d1d8501c$var$defaultComponent : _props$component, other = (0, $f6Qba.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $gIfym.createElement((0, $b93432a45511fa87$export$2e2bcd8739ae039).Provider, {
        value: $8877b048d1d8501c$var$tablelvl2
    }, /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className),
        ref: ref,
        role: Component === $8877b048d1d8501c$var$defaultComponent ? null : 'rowgroup'
    }, other)));
});
var $8877b048d1d8501c$export$2e2bcd8739ae039 = (0, $82OGZ.default)($8877b048d1d8501c$export$9dd6ff9ea0189349, {
    name: 'MuiTableHead'
})($8877b048d1d8501c$var$TableHead);



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");



var $ba4yE = parcelRequire("ba4yE");


var $82OGZ = parcelRequire("82OGZ");

var $f6Qba = parcelRequire("f6Qba");

var $k2R8s = parcelRequire("k2R8s");

var $gzSPO = parcelRequire("gzSPO");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");
function $a62fb4227558e134$export$2e2bcd8739ae039(_ref) {
    var props = _ref.props, states = _ref.states, muiFormControl = _ref.muiFormControl;
    return states.reduce(function(acc, state) {
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $gIfym = parcelRequire("gIfym");
/**
 * @ignore - internal component.
 */ var $df967b5ae1e94986$var$FormControlContext = $gIfym.createContext();
function $df967b5ae1e94986$export$62ecd8ad1bbe1a18() {
    return $gIfym.useContext($df967b5ae1e94986$var$FormControlContext);
}
var $df967b5ae1e94986$export$2e2bcd8739ae039 = $df967b5ae1e94986$var$FormControlContext;



var $82OGZ = parcelRequire("82OGZ");

var $kfLRg = parcelRequire("kfLRg");


var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $b95683bf1edd1407$export$2e2bcd8739ae039(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
    var timeout;
    function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // eslint-disable-next-line consistent-this
        var that = this;
        var later = function later() {
            func.apply(that, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}




function $b59ff8aee74aba3a$var$getStyleValue(computedStyle, property) {
    return parseInt(computedStyle[property], 10) || 0;
}
var $b59ff8aee74aba3a$var$useEnhancedEffect = typeof window !== 'undefined' ? $gIfym.useLayoutEffect : $gIfym.useEffect;
var $b59ff8aee74aba3a$var$styles = {
    /* Styles applied to the shadow textarea element. */ shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
var $b59ff8aee74aba3a$var$TextareaAutosize = /*#__PURE__*/ $gIfym.forwardRef(function TextareaAutosize(props, ref) {
    var onChange = props.onChange, rows = props.rows, rowsMax = props.rowsMax, rowsMinProp = props.rowsMin, maxRowsProp = props.maxRows, _props$minRows = props.minRows, minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows, style = props.style, value = props.value, other = (0, $f6Qba.default)(props, [
        "onChange",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "style",
        "value"
    ]);
    var maxRows = maxRowsProp || rowsMax;
    var minRows = rows || rowsMinProp || minRowsProp;
    var _React$useRef = $gIfym.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $gIfym.useRef(null);
    var handleRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(ref, inputRef);
    var shadowRef = $gIfym.useRef(null);
    var renders = $gIfym.useRef(0);
    var _React$useState = $gIfym.useState({}), state = _React$useState[0], setState = _React$useState[1];
    var syncHeight = $gIfym.useCallback(function() {
        var input = inputRef.current;
        var computedStyle = window.getComputedStyle(input);
        var inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || 'x';
        if (inputShallow.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += ' ';
        var boxSizing = computedStyle['box-sizing'];
        var padding = $b59ff8aee74aba3a$var$getStyleValue(computedStyle, 'padding-bottom') + $b59ff8aee74aba3a$var$getStyleValue(computedStyle, 'padding-top');
        var border = $b59ff8aee74aba3a$var$getStyleValue(computedStyle, 'border-bottom-width') + $b59ff8aee74aba3a$var$getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content
        var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
        inputShallow.value = 'x';
        var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
        var outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
        var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        var overflow = Math.abs(outerHeight - innerHeight) <= 1;
        setState(function(prevState) {
            // Need a large enough difference to update the height.
            // This prevents infinite rendering loop.
            if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
                renders.current += 1;
                return {
                    overflow: overflow,
                    outerHeightStyle: outerHeightStyle
                };
            }
            return prevState;
        });
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    $gIfym.useEffect(function() {
        var handleResize = (0, $b95683bf1edd1407$export$2e2bcd8739ae039)(function() {
            renders.current = 0;
            syncHeight();
        });
        window.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener('resize', handleResize);
        };
    }, [
        syncHeight
    ]);
    $b59ff8aee74aba3a$var$useEnhancedEffect(function() {
        syncHeight();
    });
    $gIfym.useEffect(function() {
        renders.current = 0;
    }, [
        value
    ]);
    var handleChange = function handleChange(event) {
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ $gIfym.createElement($gIfym.Fragment, null, /*#__PURE__*/ $gIfym.createElement("textarea", (0, $k2R8s.default)({
        value: value,
        onChange: handleChange,
        ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
        ,
        rows: minRows,
        style: (0, $k2R8s.default)({
            height: state.outerHeightStyle,
            // Need a large enough difference to allow scrolling.
            // This prevents infinite rendering loop.
            overflow: state.overflow ? 'hidden' : null
        }, style)
    }, other)), /*#__PURE__*/ $gIfym.createElement("textarea", {
        "aria-hidden": true,
        className: props.className,
        readOnly: true,
        ref: shadowRef,
        tabIndex: -1,
        style: (0, $k2R8s.default)({}, $b59ff8aee74aba3a$var$styles.shadow, style)
    }));
});
var $b59ff8aee74aba3a$export$2e2bcd8739ae039 = $b59ff8aee74aba3a$var$TextareaAutosize;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $8dfa0da0cd720873$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
function $8dfa0da0cd720873$export$d652b828d7fdeff8(obj) {
    var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return obj && ($8dfa0da0cd720873$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $8dfa0da0cd720873$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
function $8dfa0da0cd720873$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}


var $880cf795a892206e$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === 'light';
    var placeholder = {
        color: 'currentColor',
        opacity: light ? 0.42 : 0.5,
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    var placeholderHidden = {
        opacity: '0 !important'
    };
    var placeholderVisible = {
        opacity: light ? 0.42 : 0.5
    };
    return {
        '@global': {
            '@keyframes mui-auto-fill': {},
            '@keyframes mui-auto-fill-cancel': {}
        },
        /* Styles applied to the root element. */ root: (0, $k2R8s.default)({}, theme.typography.body1, {
            color: theme.palette.text.primary,
            lineHeight: '1.1876em',
            // Reset (19px), match the native input line-height
            boxSizing: 'border-box',
            // Prevent padding issue with fullWidth.
            position: 'relative',
            cursor: 'text',
            display: 'inline-flex',
            alignItems: 'center',
            '&$disabled': {
                color: theme.palette.text.disabled,
                cursor: 'default'
            }
        }),
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {},
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {},
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            '&$marginDense': {
                paddingTop: 3
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: '100%'
        },
        /* Styles applied to the `input` element. */ input: {
            font: 'inherit',
            letterSpacing: 'inherit',
            color: 'currentColor',
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            border: 0,
            boxSizing: 'content-box',
            background: 'none',
            height: '1.1876em',
            // Reset (19px), match the native input line-height
            margin: 0,
            // Reset for Safari
            WebkitTapHighlightColor: 'transparent',
            display: 'block',
            // Make the flex item shrink with Firefox
            minWidth: 0,
            width: '100%',
            // Fix IE 11 width issue
            animationName: 'mui-auto-fill-cancel',
            animationDuration: '10ms',
            '&::-webkit-input-placeholder': placeholder,
            '&::-moz-placeholder': placeholder,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholder,
            // IE 11
            '&::-ms-input-placeholder': placeholder,
            // Edge
            '&:focus': {
                outline: 0
            },
            // Reset Firefox invalid required input style
            '&:invalid': {
                boxShadow: 'none'
            },
            '&::-webkit-search-decoration': {
                // Remove the padding when type=search.
                '-webkit-appearance': 'none'
            },
            // Show and hide the placeholder logic
            'label[data-shrink=false] + $formControl &': {
                '&::-webkit-input-placeholder': placeholderHidden,
                '&::-moz-placeholder': placeholderHidden,
                // Firefox 19+
                '&:-ms-input-placeholder': placeholderHidden,
                // IE 11
                '&::-ms-input-placeholder': placeholderHidden,
                // Edge
                '&:focus::-webkit-input-placeholder': placeholderVisible,
                '&:focus::-moz-placeholder': placeholderVisible,
                // Firefox 19+
                '&:focus:-ms-input-placeholder': placeholderVisible,
                // IE 11
                '&:focus::-ms-input-placeholder': placeholderVisible // Edge
            },
            '&$disabled': {
                opacity: 1 // Reset iOS opacity
            },
            '&:-webkit-autofill': {
                animationDuration: '5000s',
                animationName: 'mui-auto-fill'
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 3
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            height: 'auto',
            resize: 'none',
            padding: 0
        },
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {
            // Improve type search style.
            '-moz-appearance': 'textfield',
            '-webkit-appearance': 'textfield'
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {},
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {},
        /* Styles applied to the `input` element if `hiddenLabel={true}`. */ inputHiddenLabel: {}
    };
};
var $880cf795a892206e$var$useEnhancedEffect = typeof window === 'undefined' ? $gIfym.useEffect : $gIfym.useLayoutEffect;
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ var $880cf795a892206e$var$InputBase = /*#__PURE__*/ $gIfym.forwardRef(function InputBase(props, ref) {
    var ariaDescribedby = props['aria-describedby'], autoComplete = props.autoComplete, autoFocus = props.autoFocus, classes = props.classes, className = props.className, color = props.color, defaultValue = props.defaultValue, disabled = props.disabled, endAdornment = props.endAdornment, error = props.error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, id = props.id, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, _props$inputProps = props.inputProps, inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps, inputRefProp = props.inputRef, margin = props.margin, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, placeholder = props.placeholder, readOnly = props.readOnly, renderSuffix = props.renderSuffix, rows = props.rows, rowsMax = props.rowsMax, rowsMin = props.rowsMin, maxRows = props.maxRows, minRows = props.minRows, startAdornment = props.startAdornment, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, valueProp = props.value, other = (0, $f6Qba.default)(props, [
        "aria-describedby",
        "autoComplete",
        "autoFocus",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "endAdornment",
        "error",
        "fullWidth",
        "id",
        "inputComponent",
        "inputProps",
        "inputRef",
        "margin",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onClick",
        "onFocus",
        "onKeyDown",
        "onKeyUp",
        "placeholder",
        "readOnly",
        "renderSuffix",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "startAdornment",
        "type",
        "value"
    ]);
    var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    var _React$useRef = $gIfym.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $gIfym.useRef();
    var handleInputRefWarning = $gIfym.useCallback(function(instance) {}, []);
    var handleInputPropsRefProp = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(inputPropsProp.ref, handleInputRefWarning);
    var handleInputRefProp = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(inputRefProp, handleInputPropsRefProp);
    var handleInputRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(inputRef, handleInputRefProp);
    var _React$useState = $gIfym.useState(false), focused = _React$useState[0], setFocused = _React$useState[1];
    var muiFormControl = (0, $df967b5ae1e94986$export$62ecd8ad1bbe1a18)();
    var fcs = (0, $a62fb4227558e134$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'margin',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $gIfym.useEffect(function() {
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    var onFilled = muiFormControl && muiFormControl.onFilled;
    var onEmpty = muiFormControl && muiFormControl.onEmpty;
    var checkDirty = $gIfym.useCallback(function(obj) {
        if ((0, $8dfa0da0cd720873$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    $880cf795a892206e$var$useEnhancedEffect(function() {
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    var handleFocus = function handleFocus(event) {
        // Fix a bug with IE 11 where the focus/blur events are triggered
        // while the input is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) {
            var element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $gzSPO.default)(1));
            checkDirty({
                value: element.value
            });
        }
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (inputPropsProp.onChange) inputPropsProp.onChange.apply(inputPropsProp, [
            event
        ].concat(args));
         // Perform in the willUpdate
        if (onChange) onChange.apply(void 0, [
            event
        ].concat(args));
    }; // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $gIfym.useEffect(function() {
        checkDirty(inputRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var handleClick = function handleClick(event) {
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    var InputComponent = inputComponent;
    var inputProps = (0, $k2R8s.default)({}, inputPropsProp, {
        ref: handleInputRef
    });
    if (typeof InputComponent !== 'string') inputProps = (0, $k2R8s.default)({
        // Rename ref to inputRef as we don't know the
        // provided `inputComponent` structure.
        inputRef: handleInputRef,
        type: type
    }, inputProps, {
        ref: null
    });
    else if (multiline) {
        if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) InputComponent = 'textarea';
        else {
            inputProps = (0, $k2R8s.default)({
                minRows: rows || minRows,
                rowsMax: rowsMax,
                maxRows: maxRows
            }, inputProps);
            InputComponent = (0, $b59ff8aee74aba3a$export$2e2bcd8739ae039);
        }
    } else inputProps = (0, $k2R8s.default)({
        type: type
    }, inputProps);
    var handleAutoFill = function handleAutoFill(event) {
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $gIfym.useEffect(function() {
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    return /*#__PURE__*/ $gIfym.createElement("div", (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, classes["color".concat((0, $kfLRg.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
        onClick: handleClick,
        ref: ref
    }, other), startAdornment, /*#__PURE__*/ $gIfym.createElement((0, $df967b5ae1e94986$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $gIfym.createElement(InputComponent, (0, $k2R8s.default)({
        "aria-invalid": fcs.error,
        "aria-describedby": ariaDescribedby,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        disabled: fcs.disabled,
        id: id,
        onAnimationStart: handleAutoFill,
        name: name,
        placeholder: placeholder,
        readOnly: readOnly,
        required: fcs.required,
        rows: rows,
        value: value,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    }, inputProps, {
        className: (0, $ba4yE.default)(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus
    }))), endAdornment, renderSuffix ? renderSuffix((0, $k2R8s.default)({}, fcs, {
        startAdornment: startAdornment
    })) : null);
});
var $880cf795a892206e$export$2e2bcd8739ae039 = (0, $82OGZ.default)($880cf795a892206e$export$9dd6ff9ea0189349, {
    name: 'MuiInputBase'
})($880cf795a892206e$var$InputBase);



var $f6Qba = parcelRequire("f6Qba");

var $8k2Uc = parcelRequire("8k2Uc");

var $k2R8s = parcelRequire("k2R8s");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");


var $82OGZ = parcelRequire("82OGZ");


var $gIfym = parcelRequire("gIfym");
function $2d1ff91adb46a3b2$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $gIfym.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}




var $gIfym = parcelRequire("gIfym");
/**
 * @ignore - internal component.
 */ var $ae90a7cb68735098$var$ListContext = $gIfym.createContext({});
var $ae90a7cb68735098$export$2e2bcd8739ae039 = $ae90a7cb68735098$var$ListContext;



var $260b2a0fcf443bd8$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */ root: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            position: 'relative',
            textDecoration: 'none',
            width: '100%',
            boxSizing: 'border-box',
            textAlign: 'left',
            paddingTop: 8,
            paddingBottom: 8,
            '&$focusVisible': {
                backgroundColor: theme.palette.action.selected
            },
            '&$selected, &$selected:hover': {
                backgroundColor: theme.palette.action.selected
            },
            '&$disabled': {
                opacity: 0.5
            }
        },
        /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */ container: {
            position: 'relative'
        },
        /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */ focusVisible: {},
        /* Styles applied to the `component` element if dense. */ dense: {
            paddingTop: 4,
            paddingBottom: 4
        },
        /* Styles applied to the `component` element if `alignItems="flex-start"`. */ alignItemsFlexStart: {
            alignItems: 'flex-start'
        },
        /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the inner `component` element if `divider={true}`. */ divider: {
            borderBottom: "1px solid ".concat(theme.palette.divider),
            backgroundClip: 'padding-box'
        },
        /* Styles applied to the inner `component` element if `disableGutters={false}`. */ gutters: {
            paddingLeft: 16,
            paddingRight: 16
        },
        /* Styles applied to the inner `component` element if `button={true}`. */ button: {
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.shortest
            }),
            '&:hover': {
                textDecoration: 'none',
                backgroundColor: theme.palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */ secondaryAction: {
            // Add some space to avoid collision as `ListItemSecondaryAction`
            // is absolutely positioned.
            paddingRight: 48
        },
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {}
    };
};
var $260b2a0fcf443bd8$var$useEnhancedEffect = typeof window === 'undefined' ? $gIfym.useEffect : $gIfym.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ var $260b2a0fcf443bd8$var$ListItem = /*#__PURE__*/ $gIfym.forwardRef(function ListItem(props, ref) {
    var _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$button = props.button, button = _props$button === void 0 ? false : _props$button, childrenProp = props.children, classes = props.classes, className = props.className, componentProp = props.component, _props$ContainerCompo = props.ContainerComponent, ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo, _props$ContainerProps = props.ContainerProps;
    _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
    var ContainerClassName = _props$ContainerProps.className, ContainerProps = (0, $f6Qba.default)(_props$ContainerProps, [
        "className"
    ]), _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$divider = props.divider, divider = _props$divider === void 0 ? false : _props$divider, focusVisibleClassName = props.focusVisibleClassName, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0, $f6Qba.default)(props, [
        "alignItems",
        "autoFocus",
        "button",
        "children",
        "classes",
        "className",
        "component",
        "ContainerComponent",
        "ContainerProps",
        "dense",
        "disabled",
        "disableGutters",
        "divider",
        "focusVisibleClassName",
        "selected"
    ]);
    var context = $gIfym.useContext((0, $ae90a7cb68735098$export$2e2bcd8739ae039));
    var childContext = {
        dense: dense || context.dense || false,
        alignItems: alignItems
    };
    var listItemRef = $gIfym.useRef(null);
    $260b2a0fcf443bd8$var$useEnhancedEffect(function() {
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    var children = $gIfym.Children.toArray(childrenProp);
    var hasSecondaryAction = children.length && (0, $2d1ff91adb46a3b2$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    var handleOwnRef = $gIfym.useCallback(function(instance) {
        // #StrictMode ready
        listItemRef.current = $c4a08725a78d51bf$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(handleOwnRef, ref);
    var componentProps = (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
        disabled: disabled
    }, other);
    var Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, $ba4yE.default)(classes.focusVisible, focusVisibleClassName);
        Component = (0, $c3be49ff5d39de33$export$2e2bcd8739ae039);
    }
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ $gIfym.createElement((0, $ae90a7cb68735098$export$2e2bcd8739ae039).Provider, {
            value: childContext
        }, /*#__PURE__*/ $gIfym.createElement(ContainerComponent, (0, $k2R8s.default)({
            className: (0, $ba4yE.default)(classes.container, ContainerClassName),
            ref: handleRef
        }, ContainerProps), /*#__PURE__*/ $gIfym.createElement(Component, componentProps, children), children.pop()));
    }
    return /*#__PURE__*/ $gIfym.createElement((0, $ae90a7cb68735098$export$2e2bcd8739ae039).Provider, {
        value: childContext
    }, /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        ref: handleRef
    }, componentProps), children));
});
var $260b2a0fcf443bd8$export$2e2bcd8739ae039 = (0, $82OGZ.default)($260b2a0fcf443bd8$export$9dd6ff9ea0189349, {
    name: 'MuiListItem'
})($260b2a0fcf443bd8$var$ListItem);


var $c027d6b11891bde0$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $k2R8s.default)({}, theme.typography.body1, (0, $8k2Uc.default)({
            minHeight: 48,
            paddingTop: 6,
            paddingBottom: 6,
            boxSizing: 'border-box',
            width: 'auto',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
        }, theme.breakpoints.up('sm'), {
            minHeight: 'auto'
        })),
        // TODO v5: remove
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: {},
        /* Styles applied to the root element if `selected={true}`. */ selected: {},
        /* Styles applied to the root element if dense. */ dense: (0, $k2R8s.default)({}, theme.typography.body2, {
            minHeight: 'auto'
        })
    };
};
var $c027d6b11891bde0$var$MenuItem = /*#__PURE__*/ $gIfym.forwardRef(function MenuItem(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? 'li' : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, ListItemClasses = props.ListItemClasses, _props$role = props.role, role = _props$role === void 0 ? 'menuitem' : _props$role, selected = props.selected, tabIndexProp = props.tabIndex, other = (0, $f6Qba.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "ListItemClasses",
        "role",
        "selected",
        "tabIndex"
    ]);
    var tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ $gIfym.createElement((0, $260b2a0fcf443bd8$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        button: true,
        role: role,
        tabIndex: tabIndex,
        component: component,
        selected: selected,
        disableGutters: disableGutters,
        classes: (0, $k2R8s.default)({
            dense: classes.dense
        }, ListItemClasses),
        className: (0, $ba4yE.default)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $c027d6b11891bde0$export$2e2bcd8739ae039 = (0, $82OGZ.default)($c027d6b11891bde0$export$9dd6ff9ea0189349, {
    name: 'MuiMenuItem'
})($c027d6b11891bde0$var$MenuItem);



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $698pq = parcelRequire("698pq");

var $k2R8s = parcelRequire("k2R8s");

var $3KNdx = parcelRequire("3KNdx");

var $f6Qba = parcelRequire("f6Qba");

var $8ZNRc = parcelRequire("8ZNRc");

var $gzSPO = parcelRequire("gzSPO");

var $gIfym = parcelRequire("gIfym");
var $2d222ef6f692482f$exports = {};
'use strict';

$2d222ef6f692482f$exports = (parcelRequire("95oGi"));




var $ba4yE = parcelRequire("ba4yE");
function $871f26f0a74624ef$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $kfLRg = parcelRequire("kfLRg");

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");



var $ba4yE = parcelRequire("ba4yE");


var $82OGZ = parcelRequire("82OGZ");

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");





var $ba4yE = parcelRequire("ba4yE");


function $799cdcab80d73947$export$2e2bcd8739ae039(node) {
    var doc = (0, $871f26f0a74624ef$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $40014db9871382a1$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.reduce(function(acc, func) {
        if (func == null) return acc;
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, function() {});
}




var $82OGZ = parcelRequire("82OGZ");

var $f6Qba = parcelRequire("f6Qba");

var $k2R8s = parcelRequire("k2R8s");

var $gIfym = parcelRequire("gIfym");



var $f1Esc = parcelRequire("f1Esc");
var $6VBRO = parcelRequire("6VBRO");




var $gIfym = parcelRequire("gIfym");






function $9389c2cc46f3367e$var$getContainer(container) {
    container = typeof container === 'function' ? container() : container; // #StrictMode ready
    return $c4a08725a78d51bf$exports.findDOMNode(container);
}
var $9389c2cc46f3367e$var$useEnhancedEffect = typeof window !== 'undefined' ? $gIfym.useLayoutEffect : $gIfym.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ var $9389c2cc46f3367e$var$Portal = /*#__PURE__*/ $gIfym.forwardRef(function Portal(props, ref) {
    var children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, onRendered = props.onRendered;
    var _React$useState = $gIfym.useState(null), mountNode = _React$useState[0], setMountNode = _React$useState[1];
    var handleRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(/*#__PURE__*/ $gIfym.isValidElement(children) ? children.ref : null, ref);
    $9389c2cc46f3367e$var$useEnhancedEffect(function() {
        if (!disablePortal) setMountNode($9389c2cc46f3367e$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    $9389c2cc46f3367e$var$useEnhancedEffect(function() {
        if (mountNode && !disablePortal) {
            (0, $9c4434890668410f$export$2e2bcd8739ae039)(ref, mountNode);
            return function() {
                (0, $9c4434890668410f$export$2e2bcd8739ae039)(ref, null);
            };
        }
        return undefined;
    }, [
        ref,
        mountNode,
        disablePortal
    ]);
    $9389c2cc46f3367e$var$useEnhancedEffect(function() {
        if (onRendered && (mountNode || disablePortal)) onRendered();
    }, [
        onRendered,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $gIfym.isValidElement(children)) return /*#__PURE__*/ $gIfym.cloneElement(children, {
            ref: handleRef
        });
        return children;
    }
    return mountNode ? /*#__PURE__*/ $c4a08725a78d51bf$exports.createPortal(children, mountNode) : mountNode;
});
var $9389c2cc46f3367e$export$2e2bcd8739ae039 = $9389c2cc46f3367e$var$Portal;






var $3hBRr = parcelRequire("3hBRr");
function $05dd595adecf7ee3$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



var $lU1Um = parcelRequire("lU1Um");

var $9unC2 = parcelRequire("9unC2");
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function $177f73c301d5fc30$export$2e2bcd8739ae039() {
    var scrollDiv = document.createElement('div');
    scrollDiv.style.width = '99px';
    scrollDiv.style.height = '99px';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.overflow = 'scroll';
    document.body.appendChild(scrollDiv);
    var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarSize;
}




function $bc6941c423bf2eb6$var$isOverflowing(container) {
    var doc = (0, $871f26f0a74624ef$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $799cdcab80d73947$export$2e2bcd8739ae039)(doc).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $bc6941c423bf2eb6$export$e1bd0c6150f13d96(node, show) {
    if (show) node.setAttribute('aria-hidden', 'true');
    else node.removeAttribute('aria-hidden');
}
function $bc6941c423bf2eb6$var$getPaddingRight(node) {
    return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
}
function $bc6941c423bf2eb6$var$ariaHiddenSiblings(container, mountNode, currentNode) {
    var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var show = arguments.length > 4 ? arguments[4] : undefined;
    var blacklist = [
        mountNode,
        currentNode
    ].concat((0, $9unC2.default)(nodesToExclude));
    var blacklistTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE'
    ];
    [].forEach.call(container.children, function(node) {
        if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) $bc6941c423bf2eb6$export$e1bd0c6150f13d96(node, show);
    });
}
function $bc6941c423bf2eb6$var$findIndexOf(containerInfo, callback) {
    var idx = -1;
    containerInfo.some(function(item, index) {
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $bc6941c423bf2eb6$var$handleContainer(containerInfo, props) {
    var restoreStyle = [];
    var restorePaddings = [];
    var container = containerInfo.container;
    var fixedNodes;
    if (!props.disableScrollLock) {
        if ($bc6941c423bf2eb6$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            var scrollbarSize = (0, $177f73c301d5fc30$export$2e2bcd8739ae039)();
            restoreStyle.push({
                value: container.style.paddingRight,
                key: 'padding-right',
                el: container
            }); // Use computed style, here to get the real padding to add our scrollbar width.
            container.style['padding-right'] = "".concat($bc6941c423bf2eb6$var$getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
            fixedNodes = (0, $871f26f0a74624ef$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedNodes, function(node) {
                restorePaddings.push(node.style.paddingRight);
                node.style.paddingRight = "".concat($bc6941c423bf2eb6$var$getPaddingRight(node) + scrollbarSize, "px");
            });
        } // Improve Gatsby support
        // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
        var parent = container.parentElement;
        var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            key: 'overflow',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    var restore = function restore() {
        if (fixedNodes) [].forEach.call(fixedNodes, function(node, i) {
            if (restorePaddings[i]) node.style.paddingRight = restorePaddings[i];
            else node.style.removeProperty('padding-right');
        });
        restoreStyle.forEach(function(_ref) {
            var value = _ref.value, el = _ref.el, key = _ref.key;
            if (value) el.style.setProperty(key, value);
            else el.style.removeProperty(key);
        });
    };
    return restore;
}
function $bc6941c423bf2eb6$var$getHiddenSiblings(container) {
    var hiddenSiblings = [];
    [].forEach.call(container.children, function(node) {
        if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(node);
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ var $bc6941c423bf2eb6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ModalManager() {
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, ModalManager);
        // this.modals[modalIndex] = modal
        this.modals = []; // this.containers[containerIndex] = {
        //   modals: [],
        //   container,
        //   restore: null,
        // }
        this.containers = [];
    }
    (0, $lU1Um.default)(ModalManager, [
        {
            key: "add",
            value: function add(modal, container) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex !== -1) return modalIndex;
                modalIndex = this.modals.length;
                this.modals.push(modal); // If the modal we are adding is already in the DOM.
                if (modal.modalRef) $bc6941c423bf2eb6$export$e1bd0c6150f13d96(modal.modalRef, false);
                var hiddenSiblingNodes = $bc6941c423bf2eb6$var$getHiddenSiblings(container);
                $bc6941c423bf2eb6$var$ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
                var containerIndex = $bc6941c423bf2eb6$var$findIndexOf(this.containers, function(item) {
                    return item.container === container;
                });
                if (containerIndex !== -1) {
                    this.containers[containerIndex].modals.push(modal);
                    return modalIndex;
                }
                this.containers.push({
                    modals: [
                        modal
                    ],
                    container: container,
                    restore: null,
                    hiddenSiblingNodes: hiddenSiblingNodes
                });
                return modalIndex;
            }
        },
        {
            key: "mount",
            value: function mount(modal, props) {
                var containerIndex = $bc6941c423bf2eb6$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                if (!containerInfo.restore) containerInfo.restore = $bc6941c423bf2eb6$var$handleContainer(containerInfo, props);
            }
        },
        {
            key: "remove",
            value: function remove(modal) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex === -1) return modalIndex;
                var containerIndex = $bc6941c423bf2eb6$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
                this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
                if (containerInfo.modals.length === 0) {
                    // The modal might be closed before it had the chance to be mounted in the DOM.
                    if (containerInfo.restore) containerInfo.restore();
                    if (modal.modalRef) // In case the modal wasn't in the DOM yet.
                    $bc6941c423bf2eb6$export$e1bd0c6150f13d96(modal.modalRef, true);
                    $bc6941c423bf2eb6$var$ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
                    this.containers.splice(containerIndex, 1);
                } else {
                    // Otherwise make sure the next top modal is visible to a screen reader.
                    var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
                    // aria-hidden because the dom element doesn't exist either
                    // when modal was unmounted before modalRef gets null
                    if (nextTop.modalRef) $bc6941c423bf2eb6$export$e1bd0c6150f13d96(nextTop.modalRef, false);
                }
                return modalIndex;
            }
        },
        {
            key: "isTopModal",
            value: function isTopModal(modal) {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
            }
        }
    ]);
    return ModalManager;
}();


/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */ 
var $gIfym = parcelRequire("gIfym");





/**
 * Utility component that locks focus inside the component.
 */ function $a925938e559a5ebe$var$Unstable_TrapFocus(props) {
    var children = props.children, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, getDoc = props.getDoc, isEnabled = props.isEnabled, open = props.open;
    var ignoreNextEnforceFocus = $gIfym.useRef();
    var sentinelStart = $gIfym.useRef(null);
    var sentinelEnd = $gIfym.useRef(null);
    var nodeToRestore = $gIfym.useRef();
    var rootRef = $gIfym.useRef(null); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $gIfym.useCallback(function(instance) {
        // #StrictMode ready
        rootRef.current = $c4a08725a78d51bf$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(children.ref, handleOwnRef);
    var prevOpenRef = $gIfym.useRef();
    $gIfym.useEffect(function() {
        prevOpenRef.current = open;
    }, [
        open
    ]);
    if (!prevOpenRef.current && open && typeof window !== 'undefined') // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
    $gIfym.useEffect(function() {
        if (!open) return;
        var doc = (0, $871f26f0a74624ef$export$2e2bcd8739ae039)(rootRef.current); // We might render an empty child.
        if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', -1);
            rootRef.current.focus();
        }
        var contain = function contain() {
            var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (rootRef.current && !rootRef.current.contains(doc.activeElement)) rootRef.current.focus();
        };
        var loopFocus = function loopFocus(event) {
            // 9 = Tab
            if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) return;
             // Make sure the next tab starts from the right place.
            if (doc.activeElement === rootRef.current) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (event.shiftKey) sentinelEnd.current.focus();
                else sentinelStart.current.focus();
            }
        };
        doc.addEventListener('focus', contain, true);
        doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        var interval = setInterval(function() {
            contain();
        }, 50);
        return function() {
            clearInterval(interval);
            doc.removeEventListener('focus', contain, true);
            doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE 11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE 11 have a focus method.
                // Once IE 11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) nodeToRestore.current.focus();
                nodeToRestore.current = null;
            }
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open
    ]);
    return /*#__PURE__*/ $gIfym.createElement($gIfym.Fragment, null, /*#__PURE__*/ $gIfym.createElement("div", {
        tabIndex: 0,
        ref: sentinelStart,
        "data-test": "sentinelStart"
    }), /*#__PURE__*/ $gIfym.cloneElement(children, {
        ref: handleRef
    }), /*#__PURE__*/ $gIfym.createElement("div", {
        tabIndex: 0,
        ref: sentinelEnd,
        "data-test": "sentinelEnd"
    }));
}
var $a925938e559a5ebe$export$2e2bcd8739ae039 = $a925938e559a5ebe$var$Unstable_TrapFocus;



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");

var $5e555c4d4da5df7f$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        zIndex: -1,
        position: 'fixed',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: 'transparent'
    }
};
/**
 * @ignore - internal component.
 */ var $5e555c4d4da5df7f$var$SimpleBackdrop = /*#__PURE__*/ $gIfym.forwardRef(function SimpleBackdrop(props, ref) {
    var _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, other = (0, $f6Qba.default)(props, [
        "invisible",
        "open"
    ]);
    return open ? /*#__PURE__*/ $gIfym.createElement("div", (0, $k2R8s.default)({
        "aria-hidden": true,
        ref: ref
    }, other, {
        style: (0, $k2R8s.default)({}, $5e555c4d4da5df7f$export$9dd6ff9ea0189349.root, invisible ? $5e555c4d4da5df7f$export$9dd6ff9ea0189349.invisible : {}, other.style)
    })) : null;
});
var $5e555c4d4da5df7f$export$2e2bcd8739ae039 = $5e555c4d4da5df7f$var$SimpleBackdrop;


function $3ad09d28fe7c5342$var$getContainer(container) {
    container = typeof container === 'function' ? container() : container;
    return $c4a08725a78d51bf$exports.findDOMNode(container);
}
function $3ad09d28fe7c5342$var$getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
var $3ad09d28fe7c5342$var$defaultManager = new (0, $bc6941c423bf2eb6$export$2e2bcd8739ae039)();
var $3ad09d28fe7c5342$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'fixed',
            zIndex: theme.zIndex.modal,
            right: 0,
            bottom: 0,
            top: 0,
            left: 0
        },
        /* Styles applied to the root element if the `Modal` has exited. */ hidden: {
            visibility: 'hidden'
        }
    };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ var $3ad09d28fe7c5342$var$Modal = /*#__PURE__*/ $gIfym.forwardRef(function Modal(inProps, ref) {
    var theme = (0, $6VBRO.default)();
    var props = (0, $f1Esc.default)({
        name: 'MuiModal',
        props: (0, $k2R8s.default)({}, inProps),
        theme: theme
    });
    var _props$BackdropCompon = props.BackdropComponent, BackdropComponent = _props$BackdropCompon === void 0 ? (0, $5e555c4d4da5df7f$export$2e2bcd8739ae039) : _props$BackdropCompon, BackdropProps = props.BackdropProps, children = props.children, _props$closeAfterTran = props.closeAfterTransition, closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran, container = props.container, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, _props$disableScrollL = props.disableScrollLock, disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL, _props$hideBackdrop = props.hideBackdrop, hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, _props$manager = props.manager, manager = _props$manager === void 0 ? $3ad09d28fe7c5342$var$defaultManager : _props$manager, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEscapeKeyDown = props.onEscapeKeyDown, onRendered = props.onRendered, open = props.open, other = (0, $f6Qba.default)(props, [
        "BackdropComponent",
        "BackdropProps",
        "children",
        "closeAfterTransition",
        "container",
        "disableAutoFocus",
        "disableBackdropClick",
        "disableEnforceFocus",
        "disableEscapeKeyDown",
        "disablePortal",
        "disableRestoreFocus",
        "disableScrollLock",
        "hideBackdrop",
        "keepMounted",
        "manager",
        "onBackdropClick",
        "onClose",
        "onEscapeKeyDown",
        "onRendered",
        "open"
    ]);
    var _React$useState = $gIfym.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var modal = $gIfym.useRef({});
    var mountNodeRef = $gIfym.useRef(null);
    var modalRef = $gIfym.useRef(null);
    var handleRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(modalRef, ref);
    var hasTransition = $3ad09d28fe7c5342$var$getHasTransition(props);
    var getDoc = function getDoc() {
        return (0, $871f26f0a74624ef$export$2e2bcd8739ae039)(mountNodeRef.current);
    };
    var getModal = function getModal() {
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    var handleMounted = function handleMounted() {
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        }); // Fix a bug on Chrome where the scroll isn't initially 0.
        modalRef.current.scrollTop = 0;
    };
    var handleOpen = (0, $fa3e36e8e29920e7$export$2e2bcd8739ae039)(function() {
        var resolvedContainer = $3ad09d28fe7c5342$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer); // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    var isTopModal = $gIfym.useCallback(function() {
        return manager.isTopModal(getModal());
    }, [
        manager
    ]);
    var handlePortalRef = (0, $fa3e36e8e29920e7$export$2e2bcd8739ae039)(function(node) {
        mountNodeRef.current = node;
        if (!node) return;
        if (onRendered) onRendered();
        if (open && isTopModal()) handleMounted();
        else (0, $bc6941c423bf2eb6$export$e1bd0c6150f13d96)(modalRef.current, true);
    });
    var handleClose = $gIfym.useCallback(function() {
        manager.remove(getModal());
    }, [
        manager
    ]);
    $gIfym.useEffect(function() {
        return function() {
            handleClose();
        };
    }, [
        handleClose
    ]);
    $gIfym.useEffect(function() {
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleExited = function handleExited() {
        setExited(true);
        if (closeAfterTransition) handleClose();
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, 'backdropClick');
    };
    var handleKeyDown = function handleKeyDown(event) {
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviours like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== 'Escape' || !isTopModal()) return;
        if (onEscapeKeyDown) onEscapeKeyDown(event);
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, 'escapeKeyDown');
        }
    };
    var inlineStyle = $3ad09d28fe7c5342$export$9dd6ff9ea0189349(theme || {
        zIndex: (0, $3hBRr.default)
    });
    var childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = children.props.tabIndex || '-1';
     // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $40014db9871382a1$export$2e2bcd8739ae039)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $40014db9871382a1$export$2e2bcd8739ae039)(handleExited, children.props.onExited);
    }
    return /*#__PURE__*/ $gIfym.createElement((0, $9389c2cc46f3367e$export$2e2bcd8739ae039), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal
    }, /*#__PURE__*/ $gIfym.createElement("div", (0, $k2R8s.default)({
        ref: handleRef,
        onKeyDown: handleKeyDown,
        role: "presentation"
    }, other, {
        style: (0, $k2R8s.default)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
    }), hideBackdrop ? null : /*#__PURE__*/ $gIfym.createElement(BackdropComponent, (0, $k2R8s.default)({
        open: open,
        onClick: handleBackdropClick
    }, BackdropProps)), /*#__PURE__*/ $gIfym.createElement((0, $a925938e559a5ebe$export$2e2bcd8739ae039), {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        getDoc: getDoc,
        isEnabled: isTopModal,
        open: open
    }, /*#__PURE__*/ $gIfym.cloneElement(children, childProps))));
});
var $3ad09d28fe7c5342$export$2e2bcd8739ae039 = $3ad09d28fe7c5342$var$Modal;



var $k2R8s = parcelRequire("k2R8s");

var $3KNdx = parcelRequire("3KNdx");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $8hGk9 = parcelRequire("8hGk9");

var $Ku8r1 = parcelRequire("Ku8r1");


var $gIfym = parcelRequire("gIfym");

var $7600586e28688e32$export$2e2bcd8739ae039 = {
    disabled: false
};




var $0cf5d5f54f72096b$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $19bb90b7fff15f94$export$bb38bb9a1161268 = 'unmounted';
var $19bb90b7fff15f94$export$84cbff306f539230 = 'exited';
var $19bb90b7fff15f94$export$df38205c966be359 = 'entering';
var $19bb90b7fff15f94$export$78e9e6e3e014d60a = 'entered';
var $19bb90b7fff15f94$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $19bb90b7fff15f94$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $Ku8r1.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $19bb90b7fff15f94$export$84cbff306f539230;
                _this.appearStatus = $19bb90b7fff15f94$export$df38205c966be359;
            } else initialStatus = $19bb90b7fff15f94$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $19bb90b7fff15f94$export$bb38bb9a1161268;
        else initialStatus = $19bb90b7fff15f94$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $19bb90b7fff15f94$export$bb38bb9a1161268) return {
            status: $19bb90b7fff15f94$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $19bb90b7fff15f94$export$df38205c966be359 && status !== $19bb90b7fff15f94$export$78e9e6e3e014d60a) nextStatus = $19bb90b7fff15f94$export$df38205c966be359;
            } else if (status === $19bb90b7fff15f94$export$df38205c966be359 || status === $19bb90b7fff15f94$export$78e9e6e3e014d60a) nextStatus = $19bb90b7fff15f94$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $19bb90b7fff15f94$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($c4a08725a78d51bf$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $0cf5d5f54f72096b$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $19bb90b7fff15f94$export$84cbff306f539230) this.setState({
            status: $19bb90b7fff15f94$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($c4a08725a78d51bf$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $7600586e28688e32$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $19bb90b7fff15f94$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $19bb90b7fff15f94$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $19bb90b7fff15f94$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($c4a08725a78d51bf$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $7600586e28688e32$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $19bb90b7fff15f94$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $19bb90b7fff15f94$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $19bb90b7fff15f94$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($c4a08725a78d51bf$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $19bb90b7fff15f94$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $8hGk9.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $62aabe3b0546d049$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$19bb90b7fff15f94$var$Transition.contextType = (0, $62aabe3b0546d049$export$2e2bcd8739ae039);
$19bb90b7fff15f94$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $19bb90b7fff15f94$var$noop() {}
$19bb90b7fff15f94$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $19bb90b7fff15f94$var$noop,
    onEntering: $19bb90b7fff15f94$var$noop,
    onEntered: $19bb90b7fff15f94$var$noop,
    onExit: $19bb90b7fff15f94$var$noop,
    onExiting: $19bb90b7fff15f94$var$noop,
    onExited: $19bb90b7fff15f94$var$noop
};
$19bb90b7fff15f94$var$Transition.UNMOUNTED = $19bb90b7fff15f94$export$bb38bb9a1161268;
$19bb90b7fff15f94$var$Transition.EXITED = $19bb90b7fff15f94$export$84cbff306f539230;
$19bb90b7fff15f94$var$Transition.ENTERING = $19bb90b7fff15f94$export$df38205c966be359;
$19bb90b7fff15f94$var$Transition.ENTERED = $19bb90b7fff15f94$export$78e9e6e3e014d60a;
$19bb90b7fff15f94$var$Transition.EXITING = $19bb90b7fff15f94$export$4aacc83d4d59139f;
var $19bb90b7fff15f94$export$2e2bcd8739ae039 = $19bb90b7fff15f94$var$Transition;



var $6VBRO = parcelRequire("6VBRO");
parcelRequire("gIfym");

var $7nQ0B = parcelRequire("7nQ0B");
function $80d7961be58b720f$export$2e2bcd8739ae039() {
    var theme = (0, $6VBRO.default)() || (0, $7nQ0B.default);
    return theme;
}


var $ff9839da05f19fc0$export$b7a864e1eaef9de5 = function reflow(node) {
    return node.scrollTop;
};
function $ff9839da05f19fc0$export$8cb1e9b404609ae9(props, options) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style;
    return {
        duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        delay: style.transitionDelay
    };
}



function $b7c71614d3a7d73f$var$getScale(value) {
    return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var $b7c71614d3a7d73f$var$styles = {
    entering: {
        opacity: 1,
        transform: $b7c71614d3a7d73f$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $b7c71614d3a7d73f$var$Grow = /*#__PURE__*/ $gIfym.forwardRef(function Grow(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? 'auto' : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $19bb90b7fff15f94$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $f6Qba.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var timer = $gIfym.useRef();
    var autoTimeout = $gIfym.useRef();
    var theme = (0, $80d7961be58b720f$export$2e2bcd8739ae039)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $gIfym.useRef(null);
    var foreignRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(children.ref, ref);
    var handleRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $3KNdx.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $ff9839da05f19fc0$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        var _getTransitionProps = (0, $ff9839da05f19fc0$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: 'enter'
        }), transitionDuration = _getTransitionProps.duration, delay = _getTransitionProps.delay;
        var duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: duration * 0.666,
                delay: delay
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var _getTransitionProps2 = (0, $ff9839da05f19fc0$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: 'exit'
        }), transitionDuration = _getTransitionProps2.duration, delay = _getTransitionProps2.delay;
        var duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: duration * 0.666,
                delay: delay || duration * 0.333
            })
        ].join(',');
        node.style.opacity = '0';
        node.style.transform = $b7c71614d3a7d73f$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === 'auto') timer.current = setTimeout(next, autoTimeout.current || 0);
    };
    $gIfym.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ $gIfym.createElement(TransitionComponent, (0, $k2R8s.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $gIfym.cloneElement(children, (0, $k2R8s.default)({
            style: (0, $k2R8s.default)({
                opacity: 0,
                transform: $b7c71614d3a7d73f$var$getScale(0.75),
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, $b7c71614d3a7d73f$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
$b7c71614d3a7d73f$var$Grow.muiSupportAuto = true;
var $b7c71614d3a7d73f$export$2e2bcd8739ae039 = $b7c71614d3a7d73f$var$Grow;



function $154807aaa727960c$export$6fcff0dc60346367(rect, vertical) {
    var offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $154807aaa727960c$export$a6a488ff68b1bf7b(rect, horizontal) {
    var offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $154807aaa727960c$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map(function(n) {
        return typeof n === 'number' ? "".concat(n, "px") : n;
    }).join(' ');
} // Sum the scrollTop between two elements.
function $154807aaa727960c$var$getScrollParent(parent, child) {
    var element = child;
    var scrollTop = 0;
    while(element && element !== parent){
        element = element.parentElement;
        scrollTop += element.scrollTop;
    }
    return scrollTop;
}
function $154807aaa727960c$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
var $154807aaa727960c$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the `Paper` component. */ paper: {
        position: 'absolute',
        overflowY: 'auto',
        overflowX: 'hidden',
        // So we see the popover when it's empty.
        // It's most likely on issue on userland.
        minWidth: 16,
        minHeight: 16,
        maxWidth: 'calc(100% - 32px)',
        maxHeight: 'calc(100% - 32px)',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $154807aaa727960c$var$Popover = /*#__PURE__*/ $gIfym.forwardRef(function Popover(props, ref) {
    var action = props.action, anchorEl = props.anchorEl, _props$anchorOrigin = props.anchorOrigin, anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: 'top',
        horizontal: 'left'
    } : _props$anchorOrigin, anchorPosition = props.anchorPosition, _props$anchorReferenc = props.anchorReference, anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc, children = props.children, classes = props.classes, className = props.className, containerProp = props.container, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 8 : _props$elevation, getContentAnchorEl = props.getContentAnchorEl, _props$marginThreshol = props.marginThreshold, marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$transformOrigi = props.transformOrigin, transformOrigin = _props$transformOrigi === void 0 ? {
        vertical: 'top',
        horizontal: 'left'
    } : _props$transformOrigi, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $b7c71614d3a7d73f$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura, _props$TransitionProp = props.TransitionProps, TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp, other = (0, $f6Qba.default)(props, [
        "action",
        "anchorEl",
        "anchorOrigin",
        "anchorPosition",
        "anchorReference",
        "children",
        "classes",
        "className",
        "container",
        "elevation",
        "getContentAnchorEl",
        "marginThreshold",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperProps",
        "transformOrigin",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var paperRef = $gIfym.useRef(); // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    var getAnchorOffset = $gIfym.useCallback(function(contentAnchorOffset) {
        if (anchorReference === 'anchorPosition') return anchorPosition;
        var resolvedAnchorEl = $154807aaa727960c$var$getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
        var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $871f26f0a74624ef$export$2e2bcd8739ae039)(paperRef.current).body;
        var anchorRect = anchorElement.getBoundingClientRect();
        var box;
        var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
        return {
            top: anchorRect.top + $154807aaa727960c$export$6fcff0dc60346367(anchorRect, anchorVertical),
            left: anchorRect.left + $154807aaa727960c$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]); // Returns the vertical offset of inner content to anchor the transform on if provided
    var getContentAnchorOffset = $gIfym.useCallback(function(element) {
        var contentAnchorOffset = 0;
        if (getContentAnchorEl && anchorReference === 'anchorEl') {
            var contentAnchorEl = getContentAnchorEl(element);
            if (contentAnchorEl && element.contains(contentAnchorEl)) {
                var scrollTop = $154807aaa727960c$var$getScrollParent(element, contentAnchorEl);
                contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
            } // != the default value
        }
        return contentAnchorOffset;
    }, [
        anchorOrigin.vertical,
        anchorReference,
        getContentAnchorEl
    ]); // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use
    var getTransformOrigin = $gIfym.useCallback(function(elemRect) {
        var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return {
            vertical: $154807aaa727960c$export$6fcff0dc60346367(elemRect, transformOrigin.vertical) + contentAnchorOffset,
            horizontal: $154807aaa727960c$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    var getPositioningStyle = $gIfym.useCallback(function(element) {
        // Check if the parent has requested anchoring on an inner content node
        var contentAnchorOffset = getContentAnchorOffset(element);
        var elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        }; // Get the transform origin point on the element itself
        var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $154807aaa727960c$var$getTransformOriginValue(elemTransformOrigin)
        };
         // Get the offset of of the anchoring element
        var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
        var top = anchorOffset.top - elemTransformOrigin.vertical;
        var left = anchorOffset.left - elemTransformOrigin.horizontal;
        var bottom = top + elemRect.height;
        var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
        var containerWindow = (0, $799cdcab80d73947$export$2e2bcd8739ae039)($154807aaa727960c$var$getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
        var heightThreshold = containerWindow.innerHeight - marginThreshold;
        var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            var diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            var _diff = bottom - heightThreshold;
            top -= _diff;
            elemTransformOrigin.vertical += _diff;
        }
        if (left < marginThreshold) {
            var _diff2 = left - marginThreshold;
            left -= _diff2;
            elemTransformOrigin.horizontal += _diff2;
        } else if (right > widthThreshold) {
            var _diff3 = right - widthThreshold;
            left -= _diff3;
            elemTransformOrigin.horizontal += _diff3;
        }
        return {
            top: "".concat(Math.round(top), "px"),
            left: "".concat(Math.round(left), "px"),
            transformOrigin: $154807aaa727960c$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getContentAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    var setPositioningStyles = $gIfym.useCallback(function() {
        var element = paperRef.current;
        if (!element) return;
        var positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
    }, [
        getPositioningStyle
    ]);
    var handleEntering = function handleEntering(element, isAppearing) {
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    var handlePaperRef = $gIfym.useCallback(function(instance) {
        // #StrictMode ready
        paperRef.current = $c4a08725a78d51bf$exports.findDOMNode(instance);
    }, []);
    $gIfym.useEffect(function() {
        if (open) setPositioningStyles();
    });
    $gIfym.useImperativeHandle(action, function() {
        return open ? {
            updatePosition: function updatePosition() {
                setPositioningStyles();
            }
        } : null;
    }, [
        open,
        setPositioningStyles
    ]);
    $gIfym.useEffect(function() {
        if (!open) return undefined;
        var handleResize = (0, $b95683bf1edd1407$export$2e2bcd8739ae039)(function() {
            setPositioningStyles();
        });
        window.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener('resize', handleResize);
        };
    }, [
        open,
        setPositioningStyles
    ]);
    var transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    var container = containerProp || (anchorEl ? (0, $871f26f0a74624ef$export$2e2bcd8739ae039)($154807aaa727960c$var$getAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ $gIfym.createElement((0, $3ad09d28fe7c5342$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        container: container,
        open: open,
        ref: ref,
        BackdropProps: {
            invisible: true
        },
        className: (0, $ba4yE.default)(classes.root, className)
    }, other), /*#__PURE__*/ $gIfym.createElement(TransitionComponent, (0, $k2R8s.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        timeout: transitionDuration
    }, TransitionProps, {
        onEntering: (0, $40014db9871382a1$export$2e2bcd8739ae039)(handleEntering, TransitionProps.onEntering)
    }), /*#__PURE__*/ $gIfym.createElement((0, $ee13f6b8f50f92d0$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        elevation: elevation,
        ref: handlePaperRef
    }, PaperProps, {
        className: (0, $ba4yE.default)(classes.paper, PaperProps.className)
    }), children)));
});
var $154807aaa727960c$export$2e2bcd8739ae039 = (0, $82OGZ.default)($154807aaa727960c$export$9dd6ff9ea0189349, {
    name: 'MuiPopover'
})($154807aaa727960c$var$Popover);



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");





var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");

var $e58b878dddb079be$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    },
    /* Styles applied to the root element if `disablePadding={false}`. */ padding: {
        paddingTop: 8,
        paddingBottom: 8
    },
    /* Styles applied to the root element if dense. */ dense: {},
    /* Styles applied to the root element if a `subheader` is provided. */ subheader: {
        paddingTop: 0
    }
};
var $e58b878dddb079be$var$List = /*#__PURE__*/ $gIfym.forwardRef(function List(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'ul' : _props$component, _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disablePadding = props.disablePadding, disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding, subheader = props.subheader, other = (0, $f6Qba.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "dense",
        "disablePadding",
        "subheader"
    ]);
    var context = $gIfym.useMemo(function() {
        return {
            dense: dense
        };
    }, [
        dense
    ]);
    return /*#__PURE__*/ $gIfym.createElement((0, $ae90a7cb68735098$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
        ref: ref
    }, other), subheader, children));
});
var $e58b878dddb079be$export$2e2bcd8739ae039 = (0, $82OGZ.default)($e58b878dddb079be$export$9dd6ff9ea0189349, {
    name: 'MuiList'
})($e58b878dddb079be$var$List);




function $40c9d6dc1854e713$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $40c9d6dc1854e713$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $40c9d6dc1854e713$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    var text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $40c9d6dc1854e713$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    var wrappedOnce = false;
    var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        } // Same logic as useAutocomplete.js
        var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$40c9d6dc1854e713$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return;
        }
    }
}
var $40c9d6dc1854e713$var$useEnhancedEffect = typeof window === 'undefined' ? $gIfym.useEffect : $gIfym.useLayoutEffect;
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ var $40c9d6dc1854e713$var$MenuList = /*#__PURE__*/ $gIfym.forwardRef(function MenuList(props, ref) {
    var actions = props.actions, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$autoFocusItem = props.autoFocusItem, autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem, children = props.children, className = props.className, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, onKeyDown = props.onKeyDown, _props$variant = props.variant, variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant, other = (0, $f6Qba.default)(props, [
        "actions",
        "autoFocus",
        "autoFocusItem",
        "children",
        "className",
        "disabledItemsFocusable",
        "disableListWrap",
        "onKeyDown",
        "variant"
    ]);
    var listRef = $gIfym.useRef(null);
    var textCriteriaRef = $gIfym.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    $40c9d6dc1854e713$var$useEnhancedEffect(function() {
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $gIfym.useImperativeHandle(actions, function() {
        return {
            adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                var noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    var scrollbarSize = "".concat((0, $177f73c301d5fc30$export$2e2bcd8739ae039)(true), "px");
                    listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
                }
                return listRef.current;
            }
        };
    }, []);
    var handleKeyDown = function handleKeyDown(event) {
        var list = listRef.current;
        var key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ var currentFocus = (0, $871f26f0a74624ef$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $40c9d6dc1854e713$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $40c9d6dc1854e713$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $40c9d6dc1854e713$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $40c9d6dc1854e713$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $40c9d6dc1854e713$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $40c9d6dc1854e713$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $40c9d6dc1854e713$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $40c9d6dc1854e713$var$previousItem);
        } else if (key.length === 1) {
            var criteria = textCriteriaRef.current;
            var lowerKey = key.toLowerCase();
            var currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            var keepFocusOnCurrent = currentFocus && !criteria.repeating && $40c9d6dc1854e713$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $40c9d6dc1854e713$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $40c9d6dc1854e713$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    var handleOwnRef = $gIfym.useCallback(function(instance) {
        // #StrictMode ready
        listRef.current = $c4a08725a78d51bf$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(handleOwnRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $gIfym.Children.forEach(children, function(child, index) {
        if (!/*#__PURE__*/ $gIfym.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $gIfym.Children.map(children, function(child, index) {
        if (index === activeItemIndex) {
            var newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $gIfym.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ $gIfym.createElement((0, $e58b878dddb079be$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other), items);
});
var $40c9d6dc1854e713$export$2e2bcd8739ae039 = $40c9d6dc1854e713$var$MenuList;






var $c8ffb6149fd0b20e$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
var $c8ffb6149fd0b20e$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
var $c8ffb6149fd0b20e$export$9dd6ff9ea0189349 = {
    /* Styles applied to the `Paper` component. */ paper: {
        // specZ: The maximum height of a simple menu should be one or more rows less than the view
        // height. This ensures a tapable area outside of the simple menu with which to dismiss
        // the menu.
        maxHeight: 'calc(100% - 96px)',
        // Add iOS momentum scrolling.
        WebkitOverflowScrolling: 'touch'
    },
    /* Styles applied to the `List` component via `MenuList`. */ list: {
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $c8ffb6149fd0b20e$var$Menu = /*#__PURE__*/ $gIfym.forwardRef(function Menu(props, ref) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, children = props.children, classes = props.classes, _props$disableAutoFoc = props.disableAutoFocusItem, disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$MenuListProps = props.MenuListProps, MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps, onClose = props.onClose, onEnteringProp = props.onEntering, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, PopoverClasses = props.PopoverClasses, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura, _props$TransitionProp = props.TransitionProps;
    _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;
    var onEntering = _props$TransitionProp.onEntering, TransitionProps = (0, $f6Qba.default)(_props$TransitionProp, [
        "onEntering"
    ]), _props$variant = props.variant, variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant, other = (0, $f6Qba.default)(props, [
        "autoFocus",
        "children",
        "classes",
        "disableAutoFocusItem",
        "MenuListProps",
        "onClose",
        "onEntering",
        "open",
        "PaperProps",
        "PopoverClasses",
        "transitionDuration",
        "TransitionProps",
        "variant"
    ]);
    var theme = (0, $80d7961be58b720f$export$2e2bcd8739ae039)();
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var menuListActionsRef = $gIfym.useRef(null);
    var contentAnchorRef = $gIfym.useRef(null);
    var getContentAnchorEl = function getContentAnchorEl() {
        return contentAnchorRef.current;
    };
    var handleEntering = function handleEntering(element, isAppearing) {
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEnteringProp) onEnteringProp(element, isAppearing);
        if (onEntering) onEntering(element, isAppearing);
    };
    var handleListKeyDown = function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $gIfym.Children.map(children, function(child, index) {
        if (!/*#__PURE__*/ $gIfym.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant !== "menu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $gIfym.Children.map(children, function(child, index) {
        if (index === activeItemIndex) return /*#__PURE__*/ $gIfym.cloneElement(child, {
            ref: function ref(instance) {
                // #StrictMode ready
                contentAnchorRef.current = $c4a08725a78d51bf$exports.findDOMNode(instance);
                (0, $9c4434890668410f$export$2e2bcd8739ae039)(child.ref, instance);
            }
        });
        return child;
    });
    return /*#__PURE__*/ $gIfym.createElement((0, $154807aaa727960c$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        getContentAnchorEl: getContentAnchorEl,
        classes: PopoverClasses,
        onClose: onClose,
        TransitionProps: (0, $k2R8s.default)({
            onEntering: handleEntering
        }, TransitionProps),
        anchorOrigin: theme.direction === 'rtl' ? $c8ffb6149fd0b20e$var$RTL_ORIGIN : $c8ffb6149fd0b20e$var$LTR_ORIGIN,
        transformOrigin: theme.direction === 'rtl' ? $c8ffb6149fd0b20e$var$RTL_ORIGIN : $c8ffb6149fd0b20e$var$LTR_ORIGIN,
        PaperProps: (0, $k2R8s.default)({}, PaperProps, {
            classes: (0, $k2R8s.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        open: open,
        ref: ref,
        transitionDuration: transitionDuration
    }, other), /*#__PURE__*/ $gIfym.createElement((0, $40c9d6dc1854e713$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        onKeyDown: handleListKeyDown,
        actions: menuListActionsRef,
        autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
        autoFocusItem: autoFocusItem,
        variant: variant
    }, MenuListProps, {
        className: (0, $ba4yE.default)(classes.list, MenuListProps.className)
    }), items));
});
var $c8ffb6149fd0b20e$export$2e2bcd8739ae039 = (0, $82OGZ.default)($c8ffb6149fd0b20e$export$9dd6ff9ea0189349, {
    name: 'MuiMenu'
})($c8ffb6149fd0b20e$var$Menu);




/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $gIfym = parcelRequire("gIfym");
function $d1ff3d9162e8e2bb$export$2e2bcd8739ae039(_ref) {
    var controlled = _ref.controlled, defaultProp = _ref.default, name = _ref.name, _ref$state = _ref.state, state = _ref$state === void 0 ? 'value' : _ref$state;
    var _React$useRef = $gIfym.useRef(controlled !== undefined), isControlled = _React$useRef.current;
    var _React$useState = $gIfym.useState(defaultProp), valueState = _React$useState[0], setValue = _React$useState[1];
    var value = isControlled ? controlled : valueState;
    var _React$useRef2, defaultValue;
    var setValueIfUncontrolled = $gIfym.useCallback(function(newValue) {
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


function $c74561f52ba88efa$var$areEqualValues(a, b) {
    if ((0, $8ZNRc.default)(b) === 'object' && b !== null) return a === b;
    return String(a) === String(b);
}
function $c74561f52ba88efa$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
/**
 * @ignore - internal component.
 */ var $c74561f52ba88efa$var$SelectInput = /*#__PURE__*/ $gIfym.forwardRef(function SelectInput(props, ref) {
    var ariaLabel = props['aria-label'], autoFocus = props.autoFocus, autoWidth = props.autoWidth, children = props.children, classes = props.classes, className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, displayEmpty = props.displayEmpty, IconComponent = props.IconComponent, inputRefProp = props.inputRef, labelId = props.labelId, _props$MenuProps = props.MenuProps, MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps, multiple = props.multiple, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClose = props.onClose, onFocus = props.onFocus, onOpen = props.onOpen, openProp = props.open, readOnly = props.readOnly, renderValue = props.renderValue, _props$SelectDisplayP = props.SelectDisplayProps, SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP, tabIndexProp = props.tabIndex, type = props.type, valueProp = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $f6Qba.default)(props, [
        "aria-label",
        "autoFocus",
        "autoWidth",
        "children",
        "classes",
        "className",
        "defaultValue",
        "disabled",
        "displayEmpty",
        "IconComponent",
        "inputRef",
        "labelId",
        "MenuProps",
        "multiple",
        "name",
        "onBlur",
        "onChange",
        "onClose",
        "onFocus",
        "onOpen",
        "open",
        "readOnly",
        "renderValue",
        "SelectDisplayProps",
        "tabIndex",
        "type",
        "value",
        "variant"
    ]);
    var _useControlled = (0, $d1ff3d9162e8e2bb$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    }), _useControlled2 = (0, $3KNdx.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    var inputRef = $gIfym.useRef(null);
    var _React$useState = $gIfym.useState(null), displayNode = _React$useState[0], setDisplayNode = _React$useState[1];
    var _React$useRef = $gIfym.useRef(openProp != null), isOpenControlled = _React$useRef.current;
    var _React$useState2 = $gIfym.useState(), menuMinWidthState = _React$useState2[0], setMenuMinWidthState = _React$useState2[1];
    var _React$useState3 = $gIfym.useState(false), openState = _React$useState3[0], setOpenState = _React$useState3[1];
    var handleRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(ref, inputRefProp);
    $gIfym.useImperativeHandle(handleRef, function() {
        return {
            focus: function focus() {
                displayNode.focus();
            },
            node: inputRef.current,
            value: value
        };
    }, [
        displayNode,
        value
    ]);
    $gIfym.useEffect(function() {
        if (autoFocus && displayNode) displayNode.focus();
    }, [
        autoFocus,
        displayNode
    ]);
    $gIfym.useEffect(function() {
        if (displayNode) {
            var label = (0, $871f26f0a74624ef$export$2e2bcd8739ae039)(displayNode).getElementById(labelId);
            if (label) {
                var handler = function handler() {
                    if (getSelection().isCollapsed) displayNode.focus();
                };
                label.addEventListener('click', handler);
                return function() {
                    label.removeEventListener('click', handler);
                };
            }
        }
        return undefined;
    }, [
        labelId,
        displayNode
    ]);
    var update = function update(open, event) {
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    var handleMouseDown = function handleMouseDown(event) {
        // Ignore everything but left-click
        if (event.button !== 0) return;
         // Hijack the default focus behavior.
        event.preventDefault();
        displayNode.focus();
        update(true, event);
    };
    var handleClose = function handleClose(event) {
        update(false, event);
    };
    var childrenArray = $gIfym.Children.toArray(children); // Support autofill.
    var handleChange = function handleChange(event) {
        var index = childrenArray.map(function(child) {
            return child.props.value;
        }).indexOf(event.target.value);
        if (index === -1) return;
        var child = childrenArray[index];
        setValue(child.props.value);
        if (onChange) onChange(event, child);
    };
    var handleItemClick = function handleItemClick(child) {
        return function(event) {
            if (!multiple) update(false, event);
            var newValue;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                var itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value === newValue) return;
            setValue(newValue);
            if (onChange) {
                event.persist(); // Preact support, target is read only property on a native event.
                Object.defineProperty(event, 'target', {
                    writable: true,
                    value: {
                        value: newValue,
                        name: name
                    }
                });
                onChange(event, child);
            }
        };
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (!readOnly) {
            var validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    var open = displayNode !== null && (isOpenControlled ? openProp : openState);
    var handleBlur = function handleBlur(event) {
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            event.persist(); // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    var display;
    var displaySingle;
    var displayMultiple = [];
    var computeDisplay = false;
    var foundMatch = false; // No need to display any value if the field is empty.
    if ((0, $8dfa0da0cd720873$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    var items = childrenArray.map(function(child) {
        if (!/*#__PURE__*/ $gIfym.isValidElement(child)) return null;
        var selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $gzSPO.default)(2));
            selected = value.some(function(v) {
                return $c74561f52ba88efa$var$areEqualValues(v, child.props.value);
            });
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $c74561f52ba88efa$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $gIfym.cloneElement(child, {
            'aria-selected': selected ? 'true' : undefined,
            onClick: handleItemClick(child),
            onKeyUp: function onKeyUp(event) {
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    if (computeDisplay) display = multiple ? displayMultiple.join(', ') : displaySingle;
     // Avoid performing a layout computation in the render method.
    var menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = displayNode.clientWidth;
    var tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
    return /*#__PURE__*/ $gIfym.createElement($gIfym.Fragment, null, /*#__PURE__*/ $gIfym.createElement("div", (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
        ref: setDisplayNode,
        tabIndex: tabIndex,
        role: "button",
        "aria-disabled": disabled ? 'true' : undefined,
        "aria-expanded": open ? 'true' : undefined,
        "aria-haspopup": "listbox",
        "aria-label": ariaLabel,
        "aria-labelledby": [
            labelId,
            buttonId
        ].filter(Boolean).join(' ') || undefined,
        onKeyDown: handleKeyDown,
        onMouseDown: disabled || readOnly ? null : handleMouseDown,
        onBlur: handleBlur,
        onFocus: onFocus
    }, SelectDisplayProps, {
        // The id is required for proper a11y
        id: buttonId
    }), $c74561f52ba88efa$var$isEmpty(display) ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $gIfym.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    }) : display), /*#__PURE__*/ $gIfym.createElement("input", (0, $k2R8s.default)({
        value: Array.isArray(value) ? value.join(',') : value,
        name: name,
        ref: inputRef,
        "aria-hidden": true,
        onChange: handleChange,
        tabIndex: -1,
        className: classes.nativeInput,
        autoFocus: autoFocus
    }, other)), /*#__PURE__*/ $gIfym.createElement(IconComponent, {
        className: (0, $ba4yE.default)(classes.icon, classes["icon".concat((0, $kfLRg.default)(variant))], open && classes.iconOpen, disabled && classes.disabled)
    }), /*#__PURE__*/ $gIfym.createElement((0, $c8ffb6149fd0b20e$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        id: "menu-".concat(name || ''),
        anchorEl: displayNode,
        open: open,
        onClose: handleClose
    }, MenuProps, {
        MenuListProps: (0, $k2R8s.default)({
            'aria-labelledby': labelId,
            role: 'listbox',
            disableListWrap: true
        }, MenuProps.MenuListProps),
        PaperProps: (0, $k2R8s.default)({}, MenuProps.PaperProps, {
            style: (0, $k2R8s.default)({
                minWidth: menuMinWidth
            }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
    }), items));
});
var $c74561f52ba88efa$export$2e2bcd8739ae039 = $c74561f52ba88efa$var$SelectInput;




var $gIfym = parcelRequire("gIfym");

function $fb91f9a015629c85$export$2e2bcd8739ae039() {
    return $gIfym.useContext((0, $df967b5ae1e94986$export$2e2bcd8739ae039));
}



var $82OGZ = parcelRequire("82OGZ");

var $gIfym = parcelRequire("gIfym");

var $ljC17 = parcelRequire("ljC17");
var /**
 * @ignore - internal component.
 */ $7cae4788b283dec0$export$2e2bcd8739ae039 = (0, $ljC17.default)(/*#__PURE__*/ $gIfym.createElement("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");



var $82OGZ = parcelRequire("82OGZ");
var $f36d5c810dfccd93$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === 'light';
    var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative'
        },
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            'label + &': {
                marginTop: 16
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            '&$underline:after': {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            '&:after': {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: 'absolute',
                right: 0,
                transform: 'scaleX(0)',
                transition: theme.transitions.create('transform', {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&$focused:after': {
                transform: 'scaleX(1)'
            },
            '&$error:after': {
                borderBottomColor: theme.palette.error.main,
                transform: 'scaleX(1)' // error is always underlined in red
            },
            '&:before': {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: 'absolute',
                right: 0,
                transition: theme.transitions.create('border-bottom-color', {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&:hover:not($disabled):before': {
                borderBottom: "2px solid ".concat(theme.palette.text.primary),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    borderBottom: "1px solid ".concat(bottomLineColor)
                }
            },
            '&$disabled:before': {
                borderBottomStyle: 'dotted'
            }
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {},
        /* Styles applied to the `input` element. */ input: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {},
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {},
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {}
    };
};
var $f36d5c810dfccd93$var$Input = /*#__PURE__*/ $gIfym.forwardRef(function Input(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, other = (0, $f6Qba.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $gIfym.createElement((0, $880cf795a892206e$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        classes: (0, $k2R8s.default)({}, classes, {
            root: (0, $ba4yE.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$f36d5c810dfccd93$var$Input.muiName = 'Input';
var $f36d5c810dfccd93$export$2e2bcd8739ae039 = (0, $82OGZ.default)($f36d5c810dfccd93$export$9dd6ff9ea0189349, {
    name: 'MuiInput'
})($f36d5c810dfccd93$var$Input);



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");


var $kfLRg = parcelRequire("kfLRg");
/**
 * @ignore - internal component.
 */ var $eafc8e08075cac0a$var$NativeSelectInput = /*#__PURE__*/ $gIfym.forwardRef(function NativeSelectInput(props, ref) {
    var classes = props.classes, className = props.className, disabled = props.disabled, IconComponent = props.IconComponent, inputRef = props.inputRef, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $f6Qba.default)(props, [
        "classes",
        "className",
        "disabled",
        "IconComponent",
        "inputRef",
        "variant"
    ]);
    return /*#__PURE__*/ $gIfym.createElement($gIfym.Fragment, null, /*#__PURE__*/ $gIfym.createElement("select", (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, classes.select, classes[variant], className, disabled && classes.disabled),
        disabled: disabled,
        ref: inputRef || ref
    }, other)), props.multiple ? null : /*#__PURE__*/ $gIfym.createElement(IconComponent, {
        className: (0, $ba4yE.default)(classes.icon, classes["icon".concat((0, $kfLRg.default)(variant))], disabled && classes.disabled)
    }));
});
var $eafc8e08075cac0a$export$2e2bcd8739ae039 = $eafc8e08075cac0a$var$NativeSelectInput;



var $82OGZ = parcelRequire("82OGZ");




var $f4d4af08807e54ad$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the select component `root` class. */ root: {},
        /* Styles applied to the select component `select` class. */ select: {
            '-moz-appearance': 'none',
            // Reset
            '-webkit-appearance': 'none',
            // Reset
            // When interacting quickly, the text can end up selected.
            // Native select can't be selected either.
            userSelect: 'none',
            borderRadius: 0,
            // Reset
            minWidth: 16,
            // So it doesn't collapse.
            cursor: 'pointer',
            '&:focus': {
                // Show that it's not an text input
                backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
                borderRadius: 0 // Reset Chrome style
            },
            // Remove IE 11 arrow
            '&::-ms-expand': {
                display: 'none'
            },
            '&$disabled': {
                cursor: 'default'
            },
            '&[multiple]': {
                height: 'auto'
            },
            '&:not([multiple]) option, &:not([multiple]) optgroup': {
                backgroundColor: theme.palette.background.paper
            },
            '&&': {
                paddingRight: 24
            }
        },
        /* Styles applied to the select component if `variant="filled"`. */ filled: {
            '&&': {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component if `variant="outlined"`. */ outlined: {
            borderRadius: theme.shape.borderRadius,
            '&&': {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component `selectMenu` class. */ selectMenu: {
            height: 'auto',
            // Resets for multpile select with chips
            minHeight: '1.1876em',
            // Required for select\text-field height consistency
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        /* Pseudo-class applied to the select component `disabled` class. */ disabled: {},
        /* Styles applied to the icon component. */ icon: {
            // We use a position absolute over a flexbox in order to forward the pointer events
            // to the input and to support wrapping tags..
            position: 'absolute',
            right: 0,
            top: 'calc(50% - 12px)',
            // Center vertically
            pointerEvents: 'none',
            // Don't block pointer events on the select under the icon.
            color: theme.palette.action.active,
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the icon component if the popup is open. */ iconOpen: {
            transform: 'rotate(180deg)'
        },
        /* Styles applied to the icon component if `variant="filled"`. */ iconFilled: {
            right: 7
        },
        /* Styles applied to the icon component if `variant="outlined"`. */ iconOutlined: {
            right: 7
        },
        /* Styles applied to the underlying native input component. */ nativeInput: {
            bottom: 0,
            left: 0,
            position: 'absolute',
            opacity: 0,
            pointerEvents: 'none',
            width: '100%'
        }
    };
};
var $f4d4af08807e54ad$var$defaultInput = /*#__PURE__*/ $gIfym.createElement((0, $f36d5c810dfccd93$export$2e2bcd8739ae039), null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */ var $f4d4af08807e54ad$var$NativeSelect = /*#__PURE__*/ $gIfym.forwardRef(function NativeSelect(props, ref) {
    var children = props.children, classes = props.classes, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $7cae4788b283dec0$export$2e2bcd8739ae039) : _props$IconComponent, _props$input = props.input, input = _props$input === void 0 ? $f4d4af08807e54ad$var$defaultInput : _props$input, inputProps = props.inputProps, variant = props.variant, other = (0, $f6Qba.default)(props, [
        "children",
        "classes",
        "IconComponent",
        "input",
        "inputProps",
        "variant"
    ]);
    var muiFormControl = (0, $fb91f9a015629c85$export$2e2bcd8739ae039)();
    var fcs = (0, $a62fb4227558e134$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant'
        ]
    });
    return /*#__PURE__*/ $gIfym.cloneElement(input, (0, $k2R8s.default)({
        // Most of the logic is implemented in `NativeSelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: (0, $eafc8e08075cac0a$export$2e2bcd8739ae039),
        inputProps: (0, $k2R8s.default)({
            children: children,
            classes: classes,
            IconComponent: IconComponent,
            variant: fcs.variant,
            type: undefined
        }, inputProps, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$f4d4af08807e54ad$var$NativeSelect.muiName = 'Select';
var $f4d4af08807e54ad$export$2e2bcd8739ae039 = (0, $82OGZ.default)($f4d4af08807e54ad$export$9dd6ff9ea0189349, {
    name: 'MuiNativeSelect'
})($f4d4af08807e54ad$var$NativeSelect);




var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");



var $82OGZ = parcelRequire("82OGZ");
var $7d9dbf313cf242e7$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === 'light';
    var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            backgroundColor: backgroundColor,
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            '&:hover': {
                backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: backgroundColor
                }
            },
            '&$focused': {
                backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
            },
            '&$disabled': {
                backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
            }
        },
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            '&$underline:after': {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            '&:after': {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: 'absolute',
                right: 0,
                transform: 'scaleX(0)',
                transition: theme.transitions.create('transform', {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&$focused:after': {
                transform: 'scaleX(1)'
            },
            '&$error:after': {
                borderBottomColor: theme.palette.error.main,
                transform: 'scaleX(1)' // error is always underlined in red
            },
            '&:before': {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: 'absolute',
                right: 0,
                transition: theme.transitions.create('border-bottom-color', {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&:hover:before': {
                borderBottom: "1px solid ".concat(theme.palette.text.primary)
            },
            '&$disabled:before': {
                borderBottomStyle: 'dotted'
            }
        },
        /* Pseudo-class applied to the root element if the component is focused. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 12
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 12
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: '27px 12px 10px',
            '&$marginDense': {
                paddingTop: 23,
                paddingBottom: 6
            }
        },
        /* Styles applied to the `input` element. */ input: {
            padding: '27px 12px 10px',
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
                caretColor: theme.palette.type === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 23,
            paddingBottom: 6
        },
        /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */ inputHiddenLabel: {
            paddingTop: 18,
            paddingBottom: 19,
            '&$inputMarginDense': {
                paddingTop: 10,
                paddingBottom: 11
            }
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $7d9dbf313cf242e7$var$FilledInput = /*#__PURE__*/ $gIfym.forwardRef(function FilledInput(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, other = (0, $f6Qba.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $gIfym.createElement((0, $880cf795a892206e$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        classes: (0, $k2R8s.default)({}, classes, {
            root: (0, $ba4yE.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$7d9dbf313cf242e7$var$FilledInput.muiName = 'Input';
var $7d9dbf313cf242e7$export$2e2bcd8739ae039 = (0, $82OGZ.default)($7d9dbf313cf242e7$export$9dd6ff9ea0189349, {
    name: 'MuiFilledInput'
})($7d9dbf313cf242e7$var$FilledInput);



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");



var $8k2Uc = parcelRequire("8k2Uc");

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");


var $kfLRg = parcelRequire("kfLRg");
var $e91aaf2c3c17cce0$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'absolute',
            bottom: 0,
            right: 0,
            top: -5,
            left: 0,
            margin: 0,
            padding: '0 8px',
            pointerEvents: 'none',
            borderRadius: 'inherit',
            borderStyle: 'solid',
            borderWidth: 1,
            overflow: 'hidden'
        },
        /* Styles applied to the legend element when `labelWidth` is provided. */ legend: {
            textAlign: 'left',
            padding: 0,
            lineHeight: '11px',
            // sync with `height` in `legend` styles
            transition: theme.transitions.create('width', {
                duration: 150,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the legend element. */ legendLabelled: {
            display: 'block',
            width: 'auto',
            textAlign: 'left',
            padding: 0,
            height: 11,
            // sync with `lineHeight` in `legend` styles
            fontSize: '0.75em',
            visibility: 'hidden',
            maxWidth: 0.01,
            transition: theme.transitions.create('max-width', {
                duration: 50,
                easing: theme.transitions.easing.easeOut
            }),
            '& > span': {
                paddingLeft: 5,
                paddingRight: 5,
                display: 'inline-block'
            }
        },
        /* Styles applied to the legend element is notched. */ legendNotched: {
            maxWidth: 1000,
            transition: theme.transitions.create('max-width', {
                duration: 100,
                easing: theme.transitions.easing.easeOut,
                delay: 50
            })
        }
    };
};
/**
 * @ignore - internal component.
 */ var $e91aaf2c3c17cce0$var$NotchedOutline = /*#__PURE__*/ $gIfym.forwardRef(function NotchedOutline(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, label = props.label, labelWidthProp = props.labelWidth, notched = props.notched, style = props.style, other = (0, $f6Qba.default)(props, [
        "children",
        "classes",
        "className",
        "label",
        "labelWidth",
        "notched",
        "style"
    ]);
    var theme = (0, $80d7961be58b720f$export$2e2bcd8739ae039)();
    var align = theme.direction === 'rtl' ? 'right' : 'left';
    if (label !== undefined) return /*#__PURE__*/ $gIfym.createElement("fieldset", (0, $k2R8s.default)({
        "aria-hidden": true,
        className: (0, $ba4yE.default)(classes.root, className),
        ref: ref,
        style: style
    }, other), /*#__PURE__*/ $gIfym.createElement("legend", {
        className: (0, $ba4yE.default)(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/ $gIfym.createElement("span", null, label) : /*#__PURE__*/ $gIfym.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    })));
    var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
    return /*#__PURE__*/ $gIfym.createElement("fieldset", (0, $k2R8s.default)({
        "aria-hidden": true,
        style: (0, $k2R8s.default)((0, $8k2Uc.default)({}, "padding".concat((0, $kfLRg.default)(align)), 8), style),
        className: (0, $ba4yE.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $gIfym.createElement("legend", {
        className: classes.legend,
        style: {
            // IE 11: fieldset with legend does not render
            // a border radius. This maintains consistency
            // by always having a legend rendered
            width: notched ? labelWidth : 0.01
        }
    }, /*#__PURE__*/ $gIfym.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    })));
});
var $e91aaf2c3c17cce0$export$2e2bcd8739ae039 = (0, $82OGZ.default)($e91aaf2c3c17cce0$export$9dd6ff9ea0189349, {
    name: 'PrivateNotchedOutline'
})($e91aaf2c3c17cce0$var$NotchedOutline);



var $82OGZ = parcelRequire("82OGZ");
var $56fe5ea54f7e8d74$export$9dd6ff9ea0189349 = function styles(theme) {
    var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            borderRadius: theme.shape.borderRadius,
            '&:hover $notchedOutline': {
                borderColor: theme.palette.text.primary
            },
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                '&:hover $notchedOutline': {
                    borderColor: borderColor
                }
            },
            '&$focused $notchedOutline': {
                borderColor: theme.palette.primary.main,
                borderWidth: 2
            },
            '&$error $notchedOutline': {
                borderColor: theme.palette.error.main
            },
            '&$disabled $notchedOutline': {
                borderColor: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            '&$focused $notchedOutline': {
                borderColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 14
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 14
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: '18.5px 14px',
            '&$marginDense': {
                paddingTop: 10.5,
                paddingBottom: 10.5
            }
        },
        /* Styles applied to the `NotchedOutline` element. */ notchedOutline: {
            borderColor: borderColor
        },
        /* Styles applied to the `input` element. */ input: {
            padding: '18.5px 14px',
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
                caretColor: theme.palette.type === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 10.5,
            paddingBottom: 10.5
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $56fe5ea54f7e8d74$var$OutlinedInput = /*#__PURE__*/ $gIfym.forwardRef(function OutlinedInput(props, ref) {
    var classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, label = props.label, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, notched = props.notched, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, other = (0, $f6Qba.default)(props, [
        "classes",
        "fullWidth",
        "inputComponent",
        "label",
        "labelWidth",
        "multiline",
        "notched",
        "type"
    ]);
    return /*#__PURE__*/ $gIfym.createElement((0, $880cf795a892206e$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        renderSuffix: function renderSuffix(state) {
            return /*#__PURE__*/ $gIfym.createElement((0, $e91aaf2c3c17cce0$export$2e2bcd8739ae039), {
                className: classes.notchedOutline,
                label: label,
                labelWidth: labelWidth,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            });
        },
        classes: (0, $k2R8s.default)({}, classes, {
            root: (0, $ba4yE.default)(classes.root, classes.underline),
            notchedOutline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$56fe5ea54f7e8d74$var$OutlinedInput.muiName = 'Input';
var $56fe5ea54f7e8d74$export$2e2bcd8739ae039 = (0, $82OGZ.default)($56fe5ea54f7e8d74$export$9dd6ff9ea0189349, {
    name: 'MuiOutlinedInput'
})($56fe5ea54f7e8d74$var$OutlinedInput);


var $ea71a0b004fd8af3$export$9dd6ff9ea0189349 = (0, $f4d4af08807e54ad$export$9dd6ff9ea0189349);
var $ea71a0b004fd8af3$var$_ref = /*#__PURE__*/ $gIfym.createElement((0, $f36d5c810dfccd93$export$2e2bcd8739ae039), null);
var $ea71a0b004fd8af3$var$_ref2 = /*#__PURE__*/ $gIfym.createElement((0, $7d9dbf313cf242e7$export$2e2bcd8739ae039), null);
var $ea71a0b004fd8af3$var$Select = /*#__PURE__*/ $gIfym.forwardRef(function Select(props, ref) {
    var _props$autoWidth = props.autoWidth, autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth, children = props.children, classes = props.classes, _props$displayEmpty = props.displayEmpty, displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $7cae4788b283dec0$export$2e2bcd8739ae039) : _props$IconComponent, id = props.id, input = props.input, inputProps = props.inputProps, label = props.label, labelId = props.labelId, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, MenuProps = props.MenuProps, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$native = props.native, native = _props$native === void 0 ? false : _props$native, onClose = props.onClose, onOpen = props.onOpen, open = props.open, renderValue = props.renderValue, SelectDisplayProps = props.SelectDisplayProps, _props$variant = props.variant, variantProps = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $f6Qba.default)(props, [
        "autoWidth",
        "children",
        "classes",
        "displayEmpty",
        "IconComponent",
        "id",
        "input",
        "inputProps",
        "label",
        "labelId",
        "labelWidth",
        "MenuProps",
        "multiple",
        "native",
        "onClose",
        "onOpen",
        "open",
        "renderValue",
        "SelectDisplayProps",
        "variant"
    ]);
    var inputComponent = native ? (0, $eafc8e08075cac0a$export$2e2bcd8739ae039) : (0, $c74561f52ba88efa$export$2e2bcd8739ae039);
    var muiFormControl = (0, $fb91f9a015629c85$export$2e2bcd8739ae039)();
    var fcs = (0, $a62fb4227558e134$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant'
        ]
    });
    var variant = fcs.variant || variantProps;
    var InputComponent = input || ({
        standard: $ea71a0b004fd8af3$var$_ref,
        outlined: /*#__PURE__*/ $gIfym.createElement((0, $56fe5ea54f7e8d74$export$2e2bcd8739ae039), {
            label: label,
            labelWidth: labelWidth
        }),
        filled: $ea71a0b004fd8af3$var$_ref2
    })[variant];
    return /*#__PURE__*/ $gIfym.cloneElement(InputComponent, (0, $k2R8s.default)({
        // Most of the logic is implemented in `SelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: inputComponent,
        inputProps: (0, $k2R8s.default)({
            children: children,
            IconComponent: IconComponent,
            variant: variant,
            type: undefined,
            // We render a select. We can ignore the type provided by the `Input`.
            multiple: multiple
        }, native ? {
            id: id
        } : {
            autoWidth: autoWidth,
            displayEmpty: displayEmpty,
            labelId: labelId,
            MenuProps: MenuProps,
            onClose: onClose,
            onOpen: onOpen,
            open: open,
            renderValue: renderValue,
            SelectDisplayProps: (0, $k2R8s.default)({
                id: id
            }, SelectDisplayProps)
        }, inputProps, {
            classes: inputProps ? (0, $698pq.default)({
                baseClasses: classes,
                newClasses: inputProps.classes,
                Component: Select
            }) : classes
        }, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$ea71a0b004fd8af3$var$Select.muiName = 'Select';
var $ea71a0b004fd8af3$export$2e2bcd8739ae039 = (0, $82OGZ.default)($ea71a0b004fd8af3$export$9dd6ff9ea0189349, {
    name: 'MuiSelect'
})($ea71a0b004fd8af3$var$Select);




var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $8k2Uc = parcelRequire("8k2Uc");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");
var $5f5f251c67055e79$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center'
        },
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: (0, $8k2Uc.default)({
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        }, theme.breakpoints.up('sm'), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }),
        /* Styles applied to the root element if `variant="regular"`. */ regular: theme.mixins.toolbar,
        /* Styles applied to the root element if `variant="dense"`. */ dense: {
            minHeight: 48
        }
    };
};
var $5f5f251c67055e79$var$Toolbar = /*#__PURE__*/ $gIfym.forwardRef(function Toolbar(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$variant = props.variant, variant = _props$variant === void 0 ? 'regular' : _props$variant, other = (0, $f6Qba.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "variant"
    ]);
    return /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, classes[variant], className, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $5f5f251c67055e79$export$2e2bcd8739ae039 = (0, $82OGZ.default)($5f5f251c67055e79$export$9dd6ff9ea0189349, {
    name: 'MuiToolbar'
})($5f5f251c67055e79$var$Toolbar);




var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $gIfym = parcelRequire("gIfym");

var $ljC17 = parcelRequire("ljC17");
var /**
 * @ignore - internal component.
 */ $4b6bd0c1adc3af23$export$2e2bcd8739ae039 = (0, $ljC17.default)(/*#__PURE__*/ $gIfym.createElement("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');



var $gIfym = parcelRequire("gIfym");

var $ljC17 = parcelRequire("ljC17");
var /**
 * @ignore - internal component.
 */ $7a2d54b555f851d8$export$2e2bcd8739ae039 = (0, $ljC17.default)(/*#__PURE__*/ $gIfym.createElement("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');




/**
 * @ignore - internal component.
 */ var $fb7bf7b48e5030d0$var$_ref = /*#__PURE__*/ $gIfym.createElement((0, $7a2d54b555f851d8$export$2e2bcd8739ae039), null);
var $fb7bf7b48e5030d0$var$_ref2 = /*#__PURE__*/ $gIfym.createElement((0, $4b6bd0c1adc3af23$export$2e2bcd8739ae039), null);
var $fb7bf7b48e5030d0$var$_ref3 = /*#__PURE__*/ $gIfym.createElement((0, $4b6bd0c1adc3af23$export$2e2bcd8739ae039), null);
var $fb7bf7b48e5030d0$var$_ref4 = /*#__PURE__*/ $gIfym.createElement((0, $7a2d54b555f851d8$export$2e2bcd8739ae039), null);
var $fb7bf7b48e5030d0$var$TablePaginationActions = /*#__PURE__*/ $gIfym.forwardRef(function TablePaginationActions(props, ref) {
    var backIconButtonProps = props.backIconButtonProps, count = props.count, nextIconButtonProps = props.nextIconButtonProps, _props$onChangePage = props.onChangePage, onChangePage = _props$onChangePage === void 0 ? function() {} : _props$onChangePage, _props$onPageChange = props.onPageChange, onPageChange = _props$onPageChange === void 0 ? function() {} : _props$onPageChange, page = props.page, rowsPerPage = props.rowsPerPage, other = (0, $f6Qba.default)(props, [
        "backIconButtonProps",
        "count",
        "nextIconButtonProps",
        "onChangePage",
        "onPageChange",
        "page",
        "rowsPerPage"
    ]);
    var theme = (0, $80d7961be58b720f$export$2e2bcd8739ae039)();
    var handleBackButtonClick = function handleBackButtonClick(event) {
        onChangePage(event, page - 1);
        onPageChange(event, page - 1);
    };
    var handleNextButtonClick = function handleNextButtonClick(event) {
        onChangePage(event, page + 1);
        onPageChange(event, page + 1);
    };
    return /*#__PURE__*/ $gIfym.createElement("div", (0, $k2R8s.default)({
        ref: ref
    }, other), /*#__PURE__*/ $gIfym.createElement((0, $2ae0a89ca37bbdde$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        onClick: handleBackButtonClick,
        disabled: page === 0,
        color: "inherit"
    }, backIconButtonProps), theme.direction === 'rtl' ? $fb7bf7b48e5030d0$var$_ref : $fb7bf7b48e5030d0$var$_ref2), /*#__PURE__*/ $gIfym.createElement((0, $2ae0a89ca37bbdde$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        onClick: handleNextButtonClick,
        disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
        color: "inherit"
    }, nextIconButtonProps), theme.direction === 'rtl' ? $fb7bf7b48e5030d0$var$_ref3 : $fb7bf7b48e5030d0$var$_ref4));
});
var $fb7bf7b48e5030d0$export$2e2bcd8739ae039 = $fb7bf7b48e5030d0$var$TablePaginationActions;



var $gIfym = parcelRequire("gIfym");
function $5e9db6073b6c20ef$export$2e2bcd8739ae039(idOverride) {
    var _React$useState = $gIfym.useState(idOverride), defaultId = _React$useState[0], setDefaultId = _React$useState[1];
    var id = idOverride || defaultId;
    $gIfym.useEffect(function() {
        if (defaultId == null) // Fallback to this default id when possible.
        // Use the random value for client-side rendering only.
        // We can't use it server-side.
        setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }, [
        defaultId
    ]);
    return id;
}


var $3cba5a2b6a62bd7c$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: theme.palette.text.primary,
            fontSize: theme.typography.pxToRem(14),
            overflow: 'auto',
            // Increase the specificity to override TableCell.
            '&:last-child': {
                padding: 0
            }
        },
        /* Styles applied to the Toolbar component. */ toolbar: {
            minHeight: 52,
            paddingRight: 2
        },
        /* Styles applied to the spacer element. */ spacer: {
            flex: '1 1 100%'
        },
        /* Styles applied to the caption Typography components if `variant="caption"`. */ caption: {
            flexShrink: 0
        },
        // TODO v5: `.selectRoot` should be merged with `.input`
        /* Styles applied to the Select component root element. */ selectRoot: {
            marginRight: 32,
            marginLeft: 8
        },
        /* Styles applied to the Select component `select` class. */ select: {
            paddingLeft: 8,
            paddingRight: 24,
            textAlign: 'right',
            textAlignLast: 'right' // Align <select> on Chrome.
        },
        // TODO v5: remove
        /* Styles applied to the Select component `icon` class. */ selectIcon: {},
        /* Styles applied to the `InputBase` component. */ input: {
            color: 'inherit',
            fontSize: 'inherit',
            flexShrink: 0
        },
        /* Styles applied to the MenuItem component. */ menuItem: {},
        /* Styles applied to the internal `TablePaginationActions` component. */ actions: {
            flexShrink: 0,
            marginLeft: 20
        }
    };
};
var $3cba5a2b6a62bd7c$var$defaultLabelDisplayedRows = function defaultLabelDisplayedRows(_ref) {
    var from = _ref.from, to = _ref.to, count = _ref.count;
    return "".concat(from, "-").concat(to, " of ").concat(count !== -1 ? count : "more than ".concat(to));
};
var $3cba5a2b6a62bd7c$var$defaultRowsPerPageOptions = [
    10,
    25,
    50,
    100
];
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ var $3cba5a2b6a62bd7c$var$TablePagination = /*#__PURE__*/ $gIfym.forwardRef(function TablePagination(props, ref) {
    var _props$ActionsCompone = props.ActionsComponent, ActionsComponent = _props$ActionsCompone === void 0 ? (0, $fb7bf7b48e5030d0$export$2e2bcd8739ae039) : _props$ActionsCompone, backIconButtonProps = props.backIconButtonProps, _props$backIconButton = props.backIconButtonText, backIconButtonText = _props$backIconButton === void 0 ? 'Previous page' : _props$backIconButton, classes = props.classes, className = props.className, colSpanProp = props.colSpan, _props$component = props.component, Component = _props$component === void 0 ? (0, $911323fee9a96c67$export$2e2bcd8739ae039) : _props$component, count = props.count, _props$labelDisplayed = props.labelDisplayedRows, labelDisplayedRows = _props$labelDisplayed === void 0 ? $3cba5a2b6a62bd7c$var$defaultLabelDisplayedRows : _props$labelDisplayed, _props$labelRowsPerPa = props.labelRowsPerPage, labelRowsPerPage = _props$labelRowsPerPa === void 0 ? 'Rows per page:' : _props$labelRowsPerPa, nextIconButtonProps = props.nextIconButtonProps, _props$nextIconButton = props.nextIconButtonText, nextIconButtonText = _props$nextIconButton === void 0 ? 'Next page' : _props$nextIconButton, onChangePage = props.onChangePage, onPageChange = props.onPageChange, onChangeRowsPerPageProp = props.onChangeRowsPerPage, onRowsPerPageChangeProp = props.onRowsPerPageChange, page = props.page, rowsPerPage = props.rowsPerPage, _props$rowsPerPageOpt = props.rowsPerPageOptions, rowsPerPageOptions = _props$rowsPerPageOpt === void 0 ? $3cba5a2b6a62bd7c$var$defaultRowsPerPageOptions : _props$rowsPerPageOpt, _props$SelectProps = props.SelectProps, SelectProps = _props$SelectProps === void 0 ? {} : _props$SelectProps, other = (0, $f6Qba.default)(props, [
        "ActionsComponent",
        "backIconButtonProps",
        "backIconButtonText",
        "classes",
        "className",
        "colSpan",
        "component",
        "count",
        "labelDisplayedRows",
        "labelRowsPerPage",
        "nextIconButtonProps",
        "nextIconButtonText",
        "onChangePage",
        "onPageChange",
        "onChangeRowsPerPage",
        "onRowsPerPageChange",
        "page",
        "rowsPerPage",
        "rowsPerPageOptions",
        "SelectProps"
    ]);
    var onChangeRowsPerPage = onChangeRowsPerPageProp || onRowsPerPageChangeProp;
    var colSpan;
    if (Component === (0, $911323fee9a96c67$export$2e2bcd8739ae039) || Component === 'td') colSpan = colSpanProp || 1000; // col-span over everything
    var selectId = (0, $5e9db6073b6c20ef$export$2e2bcd8739ae039)();
    var labelId = (0, $5e9db6073b6c20ef$export$2e2bcd8739ae039)();
    var MenuItemComponent = SelectProps.native ? 'option' : (0, $c027d6b11891bde0$export$2e2bcd8739ae039);
    return /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className),
        colSpan: colSpan,
        ref: ref
    }, other), /*#__PURE__*/ $gIfym.createElement((0, $5f5f251c67055e79$export$2e2bcd8739ae039), {
        className: classes.toolbar
    }, /*#__PURE__*/ $gIfym.createElement("div", {
        className: classes.spacer
    }), rowsPerPageOptions.length > 1 && /*#__PURE__*/ $gIfym.createElement((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
        color: "inherit",
        variant: "body2",
        className: classes.caption,
        id: labelId
    }, labelRowsPerPage), rowsPerPageOptions.length > 1 && /*#__PURE__*/ $gIfym.createElement((0, $ea71a0b004fd8af3$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        classes: {
            select: classes.select,
            icon: classes.selectIcon
        },
        input: /*#__PURE__*/ $gIfym.createElement((0, $880cf795a892206e$export$2e2bcd8739ae039), {
            className: (0, $ba4yE.default)(classes.input, classes.selectRoot)
        }),
        value: rowsPerPage,
        onChange: onChangeRowsPerPage,
        id: selectId,
        labelId: labelId
    }, SelectProps), rowsPerPageOptions.map(function(rowsPerPageOption) {
        return /*#__PURE__*/ $gIfym.createElement(MenuItemComponent, {
            className: classes.menuItem,
            key: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption,
            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
        }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption);
    })), /*#__PURE__*/ $gIfym.createElement((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
        color: "inherit",
        variant: "body2",
        className: classes.caption
    }, labelDisplayedRows({
        from: count === 0 ? 0 : page * rowsPerPage + 1,
        to: count !== -1 ? Math.min(count, (page + 1) * rowsPerPage) : (page + 1) * rowsPerPage,
        count: count === -1 ? -1 : count,
        page: page
    })), /*#__PURE__*/ $gIfym.createElement(ActionsComponent, {
        className: classes.actions,
        backIconButtonProps: (0, $k2R8s.default)({
            title: backIconButtonText,
            'aria-label': backIconButtonText
        }, backIconButtonProps),
        count: count,
        nextIconButtonProps: (0, $k2R8s.default)({
            title: nextIconButtonText,
            'aria-label': nextIconButtonText
        }, nextIconButtonProps),
        onChangePage: onChangePage,
        onPageChange: onPageChange,
        page: page,
        rowsPerPage: rowsPerPage
    })));
});
var $3cba5a2b6a62bd7c$export$2e2bcd8739ae039 = (0, $82OGZ.default)($3cba5a2b6a62bd7c$export$9dd6ff9ea0189349, {
    name: 'MuiTablePagination'
})($3cba5a2b6a62bd7c$var$TablePagination);



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");


var $aUprr = parcelRequire("aUprr");
var $246e5d89d70fb818$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: 'inherit',
            display: 'table-row',
            verticalAlign: 'middle',
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0,
            '&$hover:hover': {
                backgroundColor: theme.palette.action.hover
            },
            '&$selected, &$selected:hover': {
                backgroundColor: (0, $aUprr.alpha)(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
            }
        },
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {},
        /* Pseudo-class applied to the root element if `hover={true}`. */ hover: {},
        /* Styles applied to the root element if table variant="head". */ head: {},
        /* Styles applied to the root element if table variant="footer". */ footer: {}
    };
};
var $246e5d89d70fb818$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ var $246e5d89d70fb818$var$TableRow = /*#__PURE__*/ $gIfym.forwardRef(function TableRow(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $246e5d89d70fb818$var$defaultComponent : _props$component, _props$hover = props.hover, hover = _props$hover === void 0 ? false : _props$hover, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0, $f6Qba.default)(props, [
        "classes",
        "className",
        "component",
        "hover",
        "selected"
    ]);
    var tablelvl2 = $gIfym.useContext((0, $b93432a45511fa87$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        ref: ref,
        className: (0, $ba4yE.default)(classes.root, className, tablelvl2 && ({
            'head': classes.head,
            'footer': classes.footer
        })[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
        role: Component === $246e5d89d70fb818$var$defaultComponent ? null : 'row'
    }, other));
});
var $246e5d89d70fb818$export$2e2bcd8739ae039 = (0, $82OGZ.default)($246e5d89d70fb818$export$9dd6ff9ea0189349, {
    name: 'MuiTableRow'
})($246e5d89d70fb818$var$TableRow);



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $gIfym = parcelRequire("gIfym");

var $ljC17 = parcelRequire("ljC17");
var /**
 * @ignore - internal component.
 */ $6d1499f9b79b1f2b$export$2e2bcd8739ae039 = (0, $ljC17.default)(/*#__PURE__*/ $gIfym.createElement("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');



var $82OGZ = parcelRequire("82OGZ");


var $kfLRg = parcelRequire("kfLRg");
var $99436b9fec0b22ea$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            cursor: 'pointer',
            display: 'inline-flex',
            justifyContent: 'flex-start',
            flexDirection: 'inherit',
            alignItems: 'center',
            '&:focus': {
                color: theme.palette.text.secondary
            },
            '&:hover': {
                color: theme.palette.text.secondary,
                '& $icon': {
                    opacity: 0.5
                }
            },
            '&$active': {
                color: theme.palette.text.primary,
                // && instead of & is a workaround for https://github.com/cssinjs/jss/issues/1045
                '&& $icon': {
                    opacity: 1,
                    color: theme.palette.text.secondary
                }
            }
        },
        /* Pseudo-class applied to the root element if `active={true}`. */ active: {},
        /* Styles applied to the icon component. */ icon: {
            fontSize: 18,
            marginRight: 4,
            marginLeft: 4,
            opacity: 0,
            transition: theme.transitions.create([
                'opacity',
                'transform'
            ], {
                duration: theme.transitions.duration.shorter
            }),
            userSelect: 'none'
        },
        /* Styles applied to the icon component if `direction="desc"`. */ iconDirectionDesc: {
            transform: 'rotate(0deg)'
        },
        /* Styles applied to the icon component if `direction="asc"`. */ iconDirectionAsc: {
            transform: 'rotate(180deg)'
        }
    };
};
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ var $99436b9fec0b22ea$var$TableSortLabel = /*#__PURE__*/ $gIfym.forwardRef(function TableSortLabel(props, ref) {
    var _props$active = props.active, active = _props$active === void 0 ? false : _props$active, children = props.children, classes = props.classes, className = props.className, _props$direction = props.direction, direction = _props$direction === void 0 ? 'asc' : _props$direction, _props$hideSortIcon = props.hideSortIcon, hideSortIcon = _props$hideSortIcon === void 0 ? false : _props$hideSortIcon, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $6d1499f9b79b1f2b$export$2e2bcd8739ae039) : _props$IconComponent, other = (0, $f6Qba.default)(props, [
        "active",
        "children",
        "classes",
        "className",
        "direction",
        "hideSortIcon",
        "IconComponent"
    ]);
    return /*#__PURE__*/ $gIfym.createElement((0, $c3be49ff5d39de33$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className, active && classes.active),
        component: "span",
        disableRipple: true,
        ref: ref
    }, other), children, hideSortIcon && !active ? null : /*#__PURE__*/ $gIfym.createElement(IconComponent, {
        className: (0, $ba4yE.default)(classes.icon, classes["iconDirection".concat((0, $kfLRg.default)(direction))])
    }));
});
var $99436b9fec0b22ea$export$2e2bcd8739ae039 = (0, $82OGZ.default)($99436b9fec0b22ea$export$9dd6ff9ea0189349, {
    name: 'MuiTableSortLabel'
})($99436b9fec0b22ea$var$TableSortLabel);





var $gIfym = parcelRequire("gIfym");

var $6IRuR = parcelRequire("6IRuR");


parcelRequire("gIfym");

var $6IRuR = parcelRequire("6IRuR");

var $hQJVM = parcelRequire("hQJVM");

var $gIfym = parcelRequire("gIfym");
function $e97bcb9bbe88738a$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $e97bcb9bbe88738a$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $e97bcb9bbe88738a$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $e97bcb9bbe88738a$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $e97bcb9bbe88738a$export$2e2bcd8739ae039 = $e97bcb9bbe88738a$export$4f5d2d50c9deca37;



var $gIfym = parcelRequire("gIfym");

var $h1Rs9 = parcelRequire("h1Rs9");
var $236f70409b994978$exports = {};
(function(global, factory) {
    factory($236f70409b994978$exports);
})($236f70409b994978$exports, function(exports1) {
    'use strict';
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a === b || !a && !b && a !== a && b !== b;
    }
    var PREACT_VNODE = '__v';
    var PREACT_OWNER = '__o';
    var REACT_OWNER = '_owner';
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the errors passed are equal in value.
     */ function areErrorsEqual(a, b) {
        return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
    }
    /**
     * Whether the functions passed are equal in value.
     */ function areFunctionsEqual(a, b) {
        return a === b;
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.entries();
        var aResult;
        var bResult;
        var index = 0;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (matchedIndices[matchIndex]) {
                    matchIndex++;
                    continue;
                }
                var aEntry = aResult.value;
                var bEntry = bResult.value;
                if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the numbers are equal in value.
     */ var areNumbersEqual = sameValueZeroEqual;
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isPropertyEqual(a, b, state, properties[index])) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (!isPropertyEqual(a, b, state, property)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    /**
     * Whether the URL instances are equal in value.
     */ function areUrlsEqual(a, b) {
        return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
    }
    function isPropertyEqual(a, b, state, property) {
        if ((property === REACT_OWNER || property === PREACT_OWNER || property === PREACT_VNODE) && (a.$$typeof || b.$$typeof)) return true;
        return hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var ERROR_TAG = '[object Error]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var REG_EXP_TAG = '[object RegExp]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var URL_TAG = '[object URL]';
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === 'function' && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areErrorsEqual = _a.areErrorsEqual, areFunctionsEqual = _a.areFunctionsEqual, areMapsEqual = _a.areMapsEqual, areNumbersEqual = _a.areNumbersEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual, areUrlsEqual = _a.areUrlsEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If either of the items are nullish and fail the strictly equal check
            // above, then they must be unequal.
            if (a == null || b == null) return false;
            var type = typeof a;
            if (type !== typeof b) return false;
            if (type !== 'object') {
                if (type === 'number') return areNumbersEqual(a, b, state);
                if (type === 'function') return areFunctionsEqual(a, b, state);
                // If a primitive value that is not strictly equal, it must be unequal.
                return false;
            }
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            // For RegExp, the properties are not enumerable, and therefore will give false positives if
            // tested like a standard object.
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state);
            // If a URL tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === URL_TAG) return areUrlsEqual(a, b, state);
            // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === ERROR_TAG) return areErrorsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areErrorsEqual: areErrorsEqual,
            areFunctionsEqual: areFunctionsEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areNumbersEqual: areNumbersEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual,
            areUrlsEqual: areUrlsEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $e190a141e9876731$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(callback);
}
function $e190a141e9876731$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $e190a141e9876731$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $e84070e324d1d87b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e84070e324d1d87b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e84070e324d1d87b$var$_typeof(o);
}
function $e84070e324d1d87b$var$_toArray(arr) {
    return $e84070e324d1d87b$var$_arrayWithHoles(arr) || $e84070e324d1d87b$var$_iterableToArray(arr) || $e84070e324d1d87b$var$_unsupportedIterableToArray(arr) || $e84070e324d1d87b$var$_nonIterableRest();
}
function $e84070e324d1d87b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e84070e324d1d87b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e84070e324d1d87b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e84070e324d1d87b$var$_arrayLikeToArray(o, minLen);
}
function $e84070e324d1d87b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e84070e324d1d87b$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e84070e324d1d87b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e84070e324d1d87b$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $e84070e324d1d87b$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === 'number') {
                (0, $e190a141e9876731$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $e190a141e9876731$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($e84070e324d1d87b$var$_typeof(_style) === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $a8f4b3c841ac3722$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a8f4b3c841ac3722$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a8f4b3c841ac3722$var$_typeof(o);
}
function $a8f4b3c841ac3722$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a8f4b3c841ac3722$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a8f4b3c841ac3722$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a8f4b3c841ac3722$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a8f4b3c841ac3722$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a8f4b3c841ac3722$var$_defineProperty(obj, key, value) {
    key = $a8f4b3c841ac3722$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a8f4b3c841ac3722$var$_toPropertyKey(arg) {
    var key = $a8f4b3c841ac3722$var$_toPrimitive(arg, "string");
    return $a8f4b3c841ac3722$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a8f4b3c841ac3722$var$_toPrimitive(input, hint) {
    if ($a8f4b3c841ac3722$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a8f4b3c841ac3722$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $a8f4b3c841ac3722$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $a8f4b3c841ac3722$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $a8f4b3c841ac3722$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $a8f4b3c841ac3722$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $a8f4b3c841ac3722$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $a8f4b3c841ac3722$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $a8f4b3c841ac3722$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || 'anonymous function';
        var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
        $a8f4b3c841ac3722$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $a8f4b3c841ac3722$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $a8f4b3c841ac3722$var$_objectSpread($a8f4b3c841ac3722$var$_objectSpread({}, res), {}, $a8f4b3c841ac3722$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $a8f4b3c841ac3722$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($a8f4b3c841ac3722$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(',');
};
var $a8f4b3c841ac3722$var$isDev = false;
var $a8f4b3c841ac3722$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($a8f4b3c841ac3722$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $032cacad8f7ca974$var$_slicedToArray(arr, i) {
    return $032cacad8f7ca974$var$_arrayWithHoles(arr) || $032cacad8f7ca974$var$_iterableToArrayLimit(arr, i) || $032cacad8f7ca974$var$_unsupportedIterableToArray(arr, i) || $032cacad8f7ca974$var$_nonIterableRest();
}
function $032cacad8f7ca974$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $032cacad8f7ca974$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $032cacad8f7ca974$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $032cacad8f7ca974$var$_toConsumableArray(arr) {
    return $032cacad8f7ca974$var$_arrayWithoutHoles(arr) || $032cacad8f7ca974$var$_iterableToArray(arr) || $032cacad8f7ca974$var$_unsupportedIterableToArray(arr) || $032cacad8f7ca974$var$_nonIterableSpread();
}
function $032cacad8f7ca974$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $032cacad8f7ca974$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $032cacad8f7ca974$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $032cacad8f7ca974$var$_arrayLikeToArray(o, minLen);
}
function $032cacad8f7ca974$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $032cacad8f7ca974$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $032cacad8f7ca974$var$_arrayLikeToArray(arr);
}
function $032cacad8f7ca974$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $032cacad8f7ca974$var$ACCURACY = 1e-4;
var $032cacad8f7ca974$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $032cacad8f7ca974$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $032cacad8f7ca974$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $032cacad8f7ca974$var$cubicBezierFactor(c1, c2);
        return $032cacad8f7ca974$var$multyTime(params, t);
    };
};
var $032cacad8f7ca974$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $032cacad8f7ca974$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($032cacad8f7ca974$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $032cacad8f7ca974$var$multyTime(newParams, t);
    };
};
var $032cacad8f7ca974$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease':
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case 'ease-in':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease-out':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case 'ease-in-out':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split('(');
            if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
                var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $032cacad8f7ca974$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $a8f4b3c841ac3722$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $a8f4b3c841ac3722$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === 'number' && num >= 0 && num <= 1;
    }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
    var curveX = $032cacad8f7ca974$var$cubicBezier(x1, x2);
    var curveY = $032cacad8f7ca974$var$cubicBezier(y1, y2);
    var derCurveX = $032cacad8f7ca974$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $032cacad8f7ca974$var$ACCURACY || derVal < $032cacad8f7ca974$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $032cacad8f7ca974$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $032cacad8f7ca974$var$ACCURACY && Math.abs(newV) < $032cacad8f7ca974$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $032cacad8f7ca974$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $032cacad8f7ca974$export$56c51296f72f0592(easing);
        case 'spring':
            return $032cacad8f7ca974$export$12fc25daf62b865a();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $032cacad8f7ca974$export$56c51296f72f0592(easing);
            (0, $a8f4b3c841ac3722$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === 'function') return easing;
    (0, $a8f4b3c841ac3722$export$c106dd0671a0fc2d)(false, '[configEasing]: first argument type should be function or string, instead received %s', args);
    return null;
};



function $df65ca6ab0f1e77d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $df65ca6ab0f1e77d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $df65ca6ab0f1e77d$var$_typeof(o);
}
function $df65ca6ab0f1e77d$var$_toConsumableArray(arr) {
    return $df65ca6ab0f1e77d$var$_arrayWithoutHoles(arr) || $df65ca6ab0f1e77d$var$_iterableToArray(arr) || $df65ca6ab0f1e77d$var$_unsupportedIterableToArray(arr) || $df65ca6ab0f1e77d$var$_nonIterableSpread();
}
function $df65ca6ab0f1e77d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $df65ca6ab0f1e77d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $df65ca6ab0f1e77d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $df65ca6ab0f1e77d$var$_arrayLikeToArray(arr);
}
function $df65ca6ab0f1e77d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df65ca6ab0f1e77d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df65ca6ab0f1e77d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $df65ca6ab0f1e77d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df65ca6ab0f1e77d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $df65ca6ab0f1e77d$var$_defineProperty(obj, key, value) {
    key = $df65ca6ab0f1e77d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $df65ca6ab0f1e77d$var$_toPropertyKey(arg) {
    var key = $df65ca6ab0f1e77d$var$_toPrimitive(arg, "string");
    return $df65ca6ab0f1e77d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $df65ca6ab0f1e77d$var$_toPrimitive(input, hint) {
    if ($df65ca6ab0f1e77d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($df65ca6ab0f1e77d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $df65ca6ab0f1e77d$var$_slicedToArray(arr, i) {
    return $df65ca6ab0f1e77d$var$_arrayWithHoles(arr) || $df65ca6ab0f1e77d$var$_iterableToArrayLimit(arr, i) || $df65ca6ab0f1e77d$var$_unsupportedIterableToArray(arr, i) || $df65ca6ab0f1e77d$var$_nonIterableRest();
}
function $df65ca6ab0f1e77d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $df65ca6ab0f1e77d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $df65ca6ab0f1e77d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $df65ca6ab0f1e77d$var$_arrayLikeToArray(o, minLen);
}
function $df65ca6ab0f1e77d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $df65ca6ab0f1e77d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $df65ca6ab0f1e77d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $df65ca6ab0f1e77d$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $df65ca6ab0f1e77d$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $df65ca6ab0f1e77d$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $a8f4b3c841ac3722$export$d6051a0f7a227332)(function(key, val) {
        if ($df65ca6ab0f1e77d$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $df65ca6ab0f1e77d$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $df65ca6ab0f1e77d$var$_objectSpread($df65ca6ab0f1e77d$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $a8f4b3c841ac3722$export$d6051a0f7a227332)(function(key, val) {
        if ($df65ca6ab0f1e77d$var$needContinue(val)) return $df65ca6ab0f1e77d$var$_objectSpread($df65ca6ab0f1e77d$var$_objectSpread({}, val), {}, {
            velocity: $df65ca6ab0f1e77d$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $df65ca6ab0f1e77d$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$df65ca6ab0f1e77d$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $a8f4b3c841ac3722$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $df65ca6ab0f1e77d$var$_objectSpread($df65ca6ab0f1e77d$var$_objectSpread({}, res), {}, $df65ca6ab0f1e77d$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $df65ca6ab0f1e77d$var$_objectSpread($df65ca6ab0f1e77d$var$_objectSpread({}, res), {}, $df65ca6ab0f1e77d$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $a8f4b3c841ac3722$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($df65ca6ab0f1e77d$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $df65ca6ab0f1e77d$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($df65ca6ab0f1e77d$var$_objectSpread($df65ca6ab0f1e77d$var$_objectSpread($df65ca6ab0f1e77d$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $a8f4b3c841ac3722$export$d6051a0f7a227332)(function(key, val) {
            return $df65ca6ab0f1e77d$var$alpha.apply(void 0, $df65ca6ab0f1e77d$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($df65ca6ab0f1e77d$var$_objectSpread($df65ca6ab0f1e77d$var$_objectSpread($df65ca6ab0f1e77d$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $a8f4b3c841ac3722$export$d6051a0f7a227332)(function(key, val) {
                return $df65ca6ab0f1e77d$var$alpha.apply(void 0, $df65ca6ab0f1e77d$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($df65ca6ab0f1e77d$var$_objectSpread($df65ca6ab0f1e77d$var$_objectSpread($df65ca6ab0f1e77d$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $5d1ce52627e4dcd2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5d1ce52627e4dcd2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5d1ce52627e4dcd2$var$_typeof(o);
}
var $5d1ce52627e4dcd2$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $5d1ce52627e4dcd2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5d1ce52627e4dcd2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5d1ce52627e4dcd2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5d1ce52627e4dcd2$var$_toConsumableArray(arr) {
    return $5d1ce52627e4dcd2$var$_arrayWithoutHoles(arr) || $5d1ce52627e4dcd2$var$_iterableToArray(arr) || $5d1ce52627e4dcd2$var$_unsupportedIterableToArray(arr) || $5d1ce52627e4dcd2$var$_nonIterableSpread();
}
function $5d1ce52627e4dcd2$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5d1ce52627e4dcd2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5d1ce52627e4dcd2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5d1ce52627e4dcd2$var$_arrayLikeToArray(o, minLen);
}
function $5d1ce52627e4dcd2$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $5d1ce52627e4dcd2$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5d1ce52627e4dcd2$var$_arrayLikeToArray(arr);
}
function $5d1ce52627e4dcd2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5d1ce52627e4dcd2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d1ce52627e4dcd2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d1ce52627e4dcd2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5d1ce52627e4dcd2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d1ce52627e4dcd2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5d1ce52627e4dcd2$var$_defineProperty(obj, key, value) {
    key = $5d1ce52627e4dcd2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5d1ce52627e4dcd2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5d1ce52627e4dcd2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5d1ce52627e4dcd2$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $5d1ce52627e4dcd2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5d1ce52627e4dcd2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5d1ce52627e4dcd2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5d1ce52627e4dcd2$var$_toPropertyKey(arg) {
    var key = $5d1ce52627e4dcd2$var$_toPrimitive(arg, "string");
    return $5d1ce52627e4dcd2$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5d1ce52627e4dcd2$var$_toPrimitive(input, hint) {
    if ($5d1ce52627e4dcd2$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5d1ce52627e4dcd2$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5d1ce52627e4dcd2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $5d1ce52627e4dcd2$var$_setPrototypeOf(subClass, superClass);
}
function $5d1ce52627e4dcd2$var$_setPrototypeOf(o, p) {
    $5d1ce52627e4dcd2$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5d1ce52627e4dcd2$var$_setPrototypeOf(o, p);
}
function $5d1ce52627e4dcd2$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5d1ce52627e4dcd2$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5d1ce52627e4dcd2$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5d1ce52627e4dcd2$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5d1ce52627e4dcd2$var$_possibleConstructorReturn(this, result);
    };
}
function $5d1ce52627e4dcd2$var$_possibleConstructorReturn(self, call) {
    if (call && ($5d1ce52627e4dcd2$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $5d1ce52627e4dcd2$var$_assertThisInitialized(self);
}
function $5d1ce52627e4dcd2$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5d1ce52627e4dcd2$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5d1ce52627e4dcd2$var$_getPrototypeOf(o) {
    $5d1ce52627e4dcd2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5d1ce52627e4dcd2$var$_getPrototypeOf(o);
}
var $5d1ce52627e4dcd2$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $5d1ce52627e4dcd2$var$_inherits(Animate, _PureComponent);
    var _super = $5d1ce52627e4dcd2$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $5d1ce52627e4dcd2$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($5d1ce52627e4dcd2$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($5d1ce52627e4dcd2$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === 'function') _this.state = {
                style: to
            };
            return $5d1ce52627e4dcd2$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === 'function') {
                _this.state = {
                    style: from
                };
                return $5d1ce52627e4dcd2$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $5d1ce52627e4dcd2$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $5d1ce52627e4dcd2$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $5d1ce52627e4dcd2$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $236f70409b994978$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $5d1ce52627e4dcd2$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && style[attributeName] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($5d1ce52627e4dcd2$var$_objectSpread($5d1ce52627e4dcd2$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $df65ca6ab0f1e77d$export$2e2bcd8739ae039)(from, to, (0, $032cacad8f7ca974$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === 'function' || easing === 'spring') return [].concat($5d1ce52627e4dcd2$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $a8f4b3c841ac3722$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $5d1ce52627e4dcd2$var$_objectSpread($5d1ce52627e4dcd2$var$_objectSpread($5d1ce52627e4dcd2$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($5d1ce52627e4dcd2$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $a8f4b3c841ac3722$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($5d1ce52627e4dcd2$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $e84070e324d1d87b$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $5d1ce52627e4dcd2$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $a8f4b3c841ac3722$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $5d1ce52627e4dcd2$var$_objectSpread($5d1ce52627e4dcd2$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $5d1ce52627e4dcd2$var$_objectWithoutProperties(_this$props4, $5d1ce52627e4dcd2$var$_excluded);
                var count = (0, $gIfym.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = this.state.style;
                if (typeof children === 'function') return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $gIfym.cloneElement)(container, $5d1ce52627e4dcd2$var$_objectSpread($5d1ce52627e4dcd2$var$_objectSpread({}, others), {}, {
                        style: $5d1ce52627e4dcd2$var$_objectSpread($5d1ce52627e4dcd2$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $gIfym.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", null, (0, $gIfym.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $gIfym.PureComponent));
$5d1ce52627e4dcd2$var$Animate.displayName = 'Animate';
$5d1ce52627e4dcd2$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: '',
    to: '',
    attributeName: '',
    easing: 'ease',
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$5d1ce52627e4dcd2$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).oneOf([
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'linear'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).arrayOf('string'),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($h1Rs9))).func
};
var $5d1ce52627e4dcd2$export$2e2bcd8739ae039 = $5d1ce52627e4dcd2$var$Animate;




var $c1c3cea1c393a834$export$2e2bcd8739ae039 = (0, $5d1ce52627e4dcd2$export$2e2bcd8739ae039);


var $f0e839acff22663e$exports = {};
var $a4faac028a5783e9$exports = {};
var $3699f8138e7d0453$exports = {};
var $1d3a246bcaafa134$exports = {};
var $a02d1c89dbac7b27$exports = {};
var $2be39170f19342bb$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $2be39170f19342bb$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$2be39170f19342bb$exports = $2be39170f19342bb$var$listCacheClear;


var $5f02c1eb205ecc0a$exports = {};
var $cbca8567778f9e87$exports = {};
var $ad6123642c190612$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $ad6123642c190612$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$ad6123642c190612$exports = $ad6123642c190612$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $cbca8567778f9e87$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($ad6123642c190612$exports(array[length][0], key)) return length;
    }
    return -1;
}
$cbca8567778f9e87$exports = $cbca8567778f9e87$var$assocIndexOf;


/** Used for built-in method references. */ var $5f02c1eb205ecc0a$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $5f02c1eb205ecc0a$var$splice = $5f02c1eb205ecc0a$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5f02c1eb205ecc0a$var$listCacheDelete(key) {
    var data = this.__data__, index = $cbca8567778f9e87$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $5f02c1eb205ecc0a$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$5f02c1eb205ecc0a$exports = $5f02c1eb205ecc0a$var$listCacheDelete;


var $51984b7cfcfe65b5$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $51984b7cfcfe65b5$var$listCacheGet(key) {
    var data = this.__data__, index = $cbca8567778f9e87$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$51984b7cfcfe65b5$exports = $51984b7cfcfe65b5$var$listCacheGet;


var $bb2e71fe4814cd06$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bb2e71fe4814cd06$var$listCacheHas(key) {
    return $cbca8567778f9e87$exports(this.__data__, key) > -1;
}
$bb2e71fe4814cd06$exports = $bb2e71fe4814cd06$var$listCacheHas;


var $38e16125bd2ef4ec$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $38e16125bd2ef4ec$var$listCacheSet(key, value) {
    var data = this.__data__, index = $cbca8567778f9e87$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$38e16125bd2ef4ec$exports = $38e16125bd2ef4ec$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a02d1c89dbac7b27$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$a02d1c89dbac7b27$var$ListCache.prototype.clear = $2be39170f19342bb$exports;
$a02d1c89dbac7b27$var$ListCache.prototype['delete'] = $5f02c1eb205ecc0a$exports;
$a02d1c89dbac7b27$var$ListCache.prototype.get = $51984b7cfcfe65b5$exports;
$a02d1c89dbac7b27$var$ListCache.prototype.has = $bb2e71fe4814cd06$exports;
$a02d1c89dbac7b27$var$ListCache.prototype.set = $38e16125bd2ef4ec$exports;
$a02d1c89dbac7b27$exports = $a02d1c89dbac7b27$var$ListCache;


var $5c24492811daa200$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $5c24492811daa200$var$stackClear() {
    this.__data__ = new $a02d1c89dbac7b27$exports;
    this.size = 0;
}
$5c24492811daa200$exports = $5c24492811daa200$var$stackClear;


var $888012a5439838a3$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $888012a5439838a3$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$888012a5439838a3$exports = $888012a5439838a3$var$stackDelete;


var $722dd4587f3b0ec4$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $722dd4587f3b0ec4$var$stackGet(key) {
    return this.__data__.get(key);
}
$722dd4587f3b0ec4$exports = $722dd4587f3b0ec4$var$stackGet;


var $ddefa73f6ddd6a42$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ddefa73f6ddd6a42$var$stackHas(key) {
    return this.__data__.has(key);
}
$ddefa73f6ddd6a42$exports = $ddefa73f6ddd6a42$var$stackHas;


var $bef5a4c7cbe15759$exports = {};

var $970ada1afc753add$exports = {};
var $257e3b6443360c50$exports = {};
var $24408f21a9bde9c8$exports = {};
var $521335ecaded1962$exports = {};
var $7795fa4e140e28cd$exports = {};
var $5a48a5ef4eb9b974$exports = {};

var $g1Rml = parcelRequire("g1Rml");
/** Built-in value references. */ var $5a48a5ef4eb9b974$var$Symbol = $g1Rml.Symbol;
$5a48a5ef4eb9b974$exports = $5a48a5ef4eb9b974$var$Symbol;


var $9fb1986808b86528$exports = {};

/** Used for built-in method references. */ var $9fb1986808b86528$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9fb1986808b86528$var$hasOwnProperty = $9fb1986808b86528$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9fb1986808b86528$var$nativeObjectToString = $9fb1986808b86528$var$objectProto.toString;
/** Built-in value references. */ var $9fb1986808b86528$var$symToStringTag = $5a48a5ef4eb9b974$exports ? $5a48a5ef4eb9b974$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $9fb1986808b86528$var$getRawTag(value) {
    var isOwn = $9fb1986808b86528$var$hasOwnProperty.call(value, $9fb1986808b86528$var$symToStringTag), tag = value[$9fb1986808b86528$var$symToStringTag];
    try {
        value[$9fb1986808b86528$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $9fb1986808b86528$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$9fb1986808b86528$var$symToStringTag] = tag;
        else delete value[$9fb1986808b86528$var$symToStringTag];
    }
    return result;
}
$9fb1986808b86528$exports = $9fb1986808b86528$var$getRawTag;


var $16cc02ae46dfbc06$exports = {};
/** Used for built-in method references. */ var $16cc02ae46dfbc06$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $16cc02ae46dfbc06$var$nativeObjectToString = $16cc02ae46dfbc06$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $16cc02ae46dfbc06$var$objectToString(value) {
    return $16cc02ae46dfbc06$var$nativeObjectToString.call(value);
}
$16cc02ae46dfbc06$exports = $16cc02ae46dfbc06$var$objectToString;


/** `Object#toString` result references. */ var $7795fa4e140e28cd$var$nullTag = '[object Null]', $7795fa4e140e28cd$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $7795fa4e140e28cd$var$symToStringTag = $5a48a5ef4eb9b974$exports ? $5a48a5ef4eb9b974$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $7795fa4e140e28cd$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $7795fa4e140e28cd$var$undefinedTag : $7795fa4e140e28cd$var$nullTag;
    return $7795fa4e140e28cd$var$symToStringTag && $7795fa4e140e28cd$var$symToStringTag in Object(value) ? $9fb1986808b86528$exports(value) : $16cc02ae46dfbc06$exports(value);
}
$7795fa4e140e28cd$exports = $7795fa4e140e28cd$var$baseGetTag;


var $6c66affe1256ad5a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $6c66affe1256ad5a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$6c66affe1256ad5a$exports = $6c66affe1256ad5a$var$isObject;


/** `Object#toString` result references. */ var $521335ecaded1962$var$asyncTag = '[object AsyncFunction]', $521335ecaded1962$var$funcTag = '[object Function]', $521335ecaded1962$var$genTag = '[object GeneratorFunction]', $521335ecaded1962$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $521335ecaded1962$var$isFunction(value) {
    if (!$6c66affe1256ad5a$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $7795fa4e140e28cd$exports(value);
    return tag == $521335ecaded1962$var$funcTag || tag == $521335ecaded1962$var$genTag || tag == $521335ecaded1962$var$asyncTag || tag == $521335ecaded1962$var$proxyTag;
}
$521335ecaded1962$exports = $521335ecaded1962$var$isFunction;


var $5d08e60a2047ac7b$exports = {};
var $55c5b37a13c96fdd$exports = {};

var $g1Rml = parcelRequire("g1Rml");
/** Used to detect overreaching core-js shims. */ var $55c5b37a13c96fdd$var$coreJsData = $g1Rml["__core-js_shared__"];
$55c5b37a13c96fdd$exports = $55c5b37a13c96fdd$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $5d08e60a2047ac7b$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($55c5b37a13c96fdd$exports && $55c5b37a13c96fdd$exports.keys && $55c5b37a13c96fdd$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5d08e60a2047ac7b$var$isMasked(func) {
    return !!$5d08e60a2047ac7b$var$maskSrcKey && $5d08e60a2047ac7b$var$maskSrcKey in func;
}
$5d08e60a2047ac7b$exports = $5d08e60a2047ac7b$var$isMasked;



var $1b080b51894661f4$exports = {};
/** Used for built-in method references. */ var $1b080b51894661f4$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $1b080b51894661f4$var$funcToString = $1b080b51894661f4$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $1b080b51894661f4$var$toSource(func) {
    if (func != null) {
        try {
            return $1b080b51894661f4$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$1b080b51894661f4$exports = $1b080b51894661f4$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $24408f21a9bde9c8$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $24408f21a9bde9c8$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $24408f21a9bde9c8$var$funcProto = Function.prototype, $24408f21a9bde9c8$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $24408f21a9bde9c8$var$funcToString = $24408f21a9bde9c8$var$funcProto.toString;
/** Used to check objects for own properties. */ var $24408f21a9bde9c8$var$hasOwnProperty = $24408f21a9bde9c8$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $24408f21a9bde9c8$var$reIsNative = RegExp('^' + $24408f21a9bde9c8$var$funcToString.call($24408f21a9bde9c8$var$hasOwnProperty).replace($24408f21a9bde9c8$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $24408f21a9bde9c8$var$baseIsNative(value) {
    if (!$6c66affe1256ad5a$exports(value) || $5d08e60a2047ac7b$exports(value)) return false;
    var pattern = $521335ecaded1962$exports(value) ? $24408f21a9bde9c8$var$reIsNative : $24408f21a9bde9c8$var$reIsHostCtor;
    return pattern.test($1b080b51894661f4$exports(value));
}
$24408f21a9bde9c8$exports = $24408f21a9bde9c8$var$baseIsNative;


var $ab6c7b2047c48d6d$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $ab6c7b2047c48d6d$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$ab6c7b2047c48d6d$exports = $ab6c7b2047c48d6d$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $257e3b6443360c50$var$getNative(object, key) {
    var value = $ab6c7b2047c48d6d$exports(object, key);
    return $24408f21a9bde9c8$exports(value) ? value : undefined;
}
$257e3b6443360c50$exports = $257e3b6443360c50$var$getNative;



var $g1Rml = parcelRequire("g1Rml");
/* Built-in method references that are verified to be native. */ var $970ada1afc753add$var$Map = $257e3b6443360c50$exports($g1Rml, 'Map');
$970ada1afc753add$exports = $970ada1afc753add$var$Map;


var $b0b756100e13bcb5$exports = {};
var $7b5377b2b6c00f6e$exports = {};
var $bbc529dffa1d6c5e$exports = {};
var $f4cf60f76cb7144b$exports = {};
var $89fcbab7208c2462$exports = {};

/* Built-in method references that are verified to be native. */ var $89fcbab7208c2462$var$nativeCreate = $257e3b6443360c50$exports(Object, 'create');
$89fcbab7208c2462$exports = $89fcbab7208c2462$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $f4cf60f76cb7144b$var$hashClear() {
    this.__data__ = $89fcbab7208c2462$exports ? $89fcbab7208c2462$exports(null) : {};
    this.size = 0;
}
$f4cf60f76cb7144b$exports = $f4cf60f76cb7144b$var$hashClear;


var $6c4e782480edbca2$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6c4e782480edbca2$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$6c4e782480edbca2$exports = $6c4e782480edbca2$var$hashDelete;


var $d65d3bc7711366dd$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $d65d3bc7711366dd$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $d65d3bc7711366dd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d65d3bc7711366dd$var$hasOwnProperty = $d65d3bc7711366dd$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d65d3bc7711366dd$var$hashGet(key) {
    var data = this.__data__;
    if ($89fcbab7208c2462$exports) {
        var result = data[key];
        return result === $d65d3bc7711366dd$var$HASH_UNDEFINED ? undefined : result;
    }
    return $d65d3bc7711366dd$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$d65d3bc7711366dd$exports = $d65d3bc7711366dd$var$hashGet;


var $6069d70972e881be$exports = {};

/** Used for built-in method references. */ var $6069d70972e881be$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6069d70972e881be$var$hasOwnProperty = $6069d70972e881be$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6069d70972e881be$var$hashHas(key) {
    var data = this.__data__;
    return $89fcbab7208c2462$exports ? data[key] !== undefined : $6069d70972e881be$var$hasOwnProperty.call(data, key);
}
$6069d70972e881be$exports = $6069d70972e881be$var$hashHas;


var $eed2fef6856fe40f$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $eed2fef6856fe40f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $eed2fef6856fe40f$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $89fcbab7208c2462$exports && value === undefined ? $eed2fef6856fe40f$var$HASH_UNDEFINED : value;
    return this;
}
$eed2fef6856fe40f$exports = $eed2fef6856fe40f$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbc529dffa1d6c5e$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$bbc529dffa1d6c5e$var$Hash.prototype.clear = $f4cf60f76cb7144b$exports;
$bbc529dffa1d6c5e$var$Hash.prototype['delete'] = $6c4e782480edbca2$exports;
$bbc529dffa1d6c5e$var$Hash.prototype.get = $d65d3bc7711366dd$exports;
$bbc529dffa1d6c5e$var$Hash.prototype.has = $6069d70972e881be$exports;
$bbc529dffa1d6c5e$var$Hash.prototype.set = $eed2fef6856fe40f$exports;
$bbc529dffa1d6c5e$exports = $bbc529dffa1d6c5e$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $7b5377b2b6c00f6e$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $bbc529dffa1d6c5e$exports,
        'map': new ($970ada1afc753add$exports || $a02d1c89dbac7b27$exports),
        'string': new $bbc529dffa1d6c5e$exports
    };
}
$7b5377b2b6c00f6e$exports = $7b5377b2b6c00f6e$var$mapCacheClear;


var $46bec429c3892470$exports = {};
var $221e6031357ae3e3$exports = {};
var $89e49e88967e650f$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $89e49e88967e650f$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$89e49e88967e650f$exports = $89e49e88967e650f$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $221e6031357ae3e3$var$getMapData(map, key) {
    var data = map.__data__;
    return $89e49e88967e650f$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$221e6031357ae3e3$exports = $221e6031357ae3e3$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $46bec429c3892470$var$mapCacheDelete(key) {
    var result = $221e6031357ae3e3$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$46bec429c3892470$exports = $46bec429c3892470$var$mapCacheDelete;


var $0babe1b21bb59b3c$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0babe1b21bb59b3c$var$mapCacheGet(key) {
    return $221e6031357ae3e3$exports(this, key).get(key);
}
$0babe1b21bb59b3c$exports = $0babe1b21bb59b3c$var$mapCacheGet;


var $97bddb6c818a6de8$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $97bddb6c818a6de8$var$mapCacheHas(key) {
    return $221e6031357ae3e3$exports(this, key).has(key);
}
$97bddb6c818a6de8$exports = $97bddb6c818a6de8$var$mapCacheHas;


var $1460d0cdd0584043$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $1460d0cdd0584043$var$mapCacheSet(key, value) {
    var data = $221e6031357ae3e3$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$1460d0cdd0584043$exports = $1460d0cdd0584043$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b0b756100e13bcb5$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$b0b756100e13bcb5$var$MapCache.prototype.clear = $7b5377b2b6c00f6e$exports;
$b0b756100e13bcb5$var$MapCache.prototype['delete'] = $46bec429c3892470$exports;
$b0b756100e13bcb5$var$MapCache.prototype.get = $0babe1b21bb59b3c$exports;
$b0b756100e13bcb5$var$MapCache.prototype.has = $97bddb6c818a6de8$exports;
$b0b756100e13bcb5$var$MapCache.prototype.set = $1460d0cdd0584043$exports;
$b0b756100e13bcb5$exports = $b0b756100e13bcb5$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $bef5a4c7cbe15759$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $bef5a4c7cbe15759$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $a02d1c89dbac7b27$exports) {
        var pairs = data.__data__;
        if (!$970ada1afc753add$exports || pairs.length < $bef5a4c7cbe15759$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $b0b756100e13bcb5$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$bef5a4c7cbe15759$exports = $bef5a4c7cbe15759$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1d3a246bcaafa134$var$Stack(entries) {
    var data = this.__data__ = new $a02d1c89dbac7b27$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$1d3a246bcaafa134$var$Stack.prototype.clear = $5c24492811daa200$exports;
$1d3a246bcaafa134$var$Stack.prototype['delete'] = $888012a5439838a3$exports;
$1d3a246bcaafa134$var$Stack.prototype.get = $722dd4587f3b0ec4$exports;
$1d3a246bcaafa134$var$Stack.prototype.has = $ddefa73f6ddd6a42$exports;
$1d3a246bcaafa134$var$Stack.prototype.set = $bef5a4c7cbe15759$exports;
$1d3a246bcaafa134$exports = $1d3a246bcaafa134$var$Stack;


var $99115c610c7be078$exports = {};
var $2ca059bfc0fc507a$exports = {};

var $050224e02a86d4a1$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $050224e02a86d4a1$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $050224e02a86d4a1$var$setCacheAdd(value) {
    this.__data__.set(value, $050224e02a86d4a1$var$HASH_UNDEFINED);
    return this;
}
$050224e02a86d4a1$exports = $050224e02a86d4a1$var$setCacheAdd;


var $6a5aad2d729a0b26$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $6a5aad2d729a0b26$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$6a5aad2d729a0b26$exports = $6a5aad2d729a0b26$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $2ca059bfc0fc507a$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $b0b756100e13bcb5$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$2ca059bfc0fc507a$var$SetCache.prototype.add = $2ca059bfc0fc507a$var$SetCache.prototype.push = $050224e02a86d4a1$exports;
$2ca059bfc0fc507a$var$SetCache.prototype.has = $6a5aad2d729a0b26$exports;
$2ca059bfc0fc507a$exports = $2ca059bfc0fc507a$var$SetCache;


var $5b91008bcd74ad68$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $5b91008bcd74ad68$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$5b91008bcd74ad68$exports = $5b91008bcd74ad68$var$arraySome;


var $eee8606129ee6d5d$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $eee8606129ee6d5d$var$cacheHas(cache, key) {
    return cache.has(key);
}
$eee8606129ee6d5d$exports = $eee8606129ee6d5d$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $99115c610c7be078$var$COMPARE_PARTIAL_FLAG = 1, $99115c610c7be078$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $99115c610c7be078$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $99115c610c7be078$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $99115c610c7be078$var$COMPARE_UNORDERED_FLAG ? new $2ca059bfc0fc507a$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$5b91008bcd74ad68$exports(other, function(othValue, othIndex) {
                if (!$eee8606129ee6d5d$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$99115c610c7be078$exports = $99115c610c7be078$var$equalArrays;


var $8951d079c66a6fc9$exports = {};

var $a57165bf1119fa28$exports = {};

var $g1Rml = parcelRequire("g1Rml");
/** Built-in value references. */ var $a57165bf1119fa28$var$Uint8Array = $g1Rml.Uint8Array;
$a57165bf1119fa28$exports = $a57165bf1119fa28$var$Uint8Array;




var $2f736df2ae8ab9a2$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $2f736df2ae8ab9a2$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$2f736df2ae8ab9a2$exports = $2f736df2ae8ab9a2$var$mapToArray;


var $fca0d725dad9084d$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $fca0d725dad9084d$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$fca0d725dad9084d$exports = $fca0d725dad9084d$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $8951d079c66a6fc9$var$COMPARE_PARTIAL_FLAG = 1, $8951d079c66a6fc9$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $8951d079c66a6fc9$var$boolTag = '[object Boolean]', $8951d079c66a6fc9$var$dateTag = '[object Date]', $8951d079c66a6fc9$var$errorTag = '[object Error]', $8951d079c66a6fc9$var$mapTag = '[object Map]', $8951d079c66a6fc9$var$numberTag = '[object Number]', $8951d079c66a6fc9$var$regexpTag = '[object RegExp]', $8951d079c66a6fc9$var$setTag = '[object Set]', $8951d079c66a6fc9$var$stringTag = '[object String]', $8951d079c66a6fc9$var$symbolTag = '[object Symbol]';
var $8951d079c66a6fc9$var$arrayBufferTag = '[object ArrayBuffer]', $8951d079c66a6fc9$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $8951d079c66a6fc9$var$symbolProto = $5a48a5ef4eb9b974$exports ? $5a48a5ef4eb9b974$exports.prototype : undefined, $8951d079c66a6fc9$var$symbolValueOf = $8951d079c66a6fc9$var$symbolProto ? $8951d079c66a6fc9$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $8951d079c66a6fc9$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $8951d079c66a6fc9$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $8951d079c66a6fc9$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $a57165bf1119fa28$exports(object), new $a57165bf1119fa28$exports(other))) return false;
            return true;
        case $8951d079c66a6fc9$var$boolTag:
        case $8951d079c66a6fc9$var$dateTag:
        case $8951d079c66a6fc9$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $ad6123642c190612$exports(+object, +other);
        case $8951d079c66a6fc9$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $8951d079c66a6fc9$var$regexpTag:
        case $8951d079c66a6fc9$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $8951d079c66a6fc9$var$mapTag:
            var convert = $2f736df2ae8ab9a2$exports;
        case $8951d079c66a6fc9$var$setTag:
            var isPartial = bitmask & $8951d079c66a6fc9$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $fca0d725dad9084d$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $8951d079c66a6fc9$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $99115c610c7be078$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $8951d079c66a6fc9$var$symbolTag:
            if ($8951d079c66a6fc9$var$symbolValueOf) return $8951d079c66a6fc9$var$symbolValueOf.call(object) == $8951d079c66a6fc9$var$symbolValueOf.call(other);
    }
    return false;
}
$8951d079c66a6fc9$exports = $8951d079c66a6fc9$var$equalByTag;


var $c3bff16084b6cc79$exports = {};
var $73c43f9b0807101b$exports = {};
var $283ccd282479a99f$exports = {};
var $4e75e860d57e3f05$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $4e75e860d57e3f05$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$4e75e860d57e3f05$exports = $4e75e860d57e3f05$var$arrayPush;


var $9ddb8a7a9343d289$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $9ddb8a7a9343d289$var$isArray = Array.isArray;
$9ddb8a7a9343d289$exports = $9ddb8a7a9343d289$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $283ccd282479a99f$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $9ddb8a7a9343d289$exports(object) ? result : $4e75e860d57e3f05$exports(result, symbolsFunc(object));
}
$283ccd282479a99f$exports = $283ccd282479a99f$var$baseGetAllKeys;


var $623cd90fc49d9e78$exports = {};
var $7347f21710fba9e9$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $7347f21710fba9e9$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$7347f21710fba9e9$exports = $7347f21710fba9e9$var$arrayFilter;


var $18b8609685016c34$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $18b8609685016c34$var$stubArray() {
    return [];
}
$18b8609685016c34$exports = $18b8609685016c34$var$stubArray;


/** Used for built-in method references. */ var $623cd90fc49d9e78$var$objectProto = Object.prototype;
/** Built-in value references. */ var $623cd90fc49d9e78$var$propertyIsEnumerable = $623cd90fc49d9e78$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $623cd90fc49d9e78$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $623cd90fc49d9e78$var$getSymbols = !$623cd90fc49d9e78$var$nativeGetSymbols ? $18b8609685016c34$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $7347f21710fba9e9$exports($623cd90fc49d9e78$var$nativeGetSymbols(object), function(symbol) {
        return $623cd90fc49d9e78$var$propertyIsEnumerable.call(object, symbol);
    });
};
$623cd90fc49d9e78$exports = $623cd90fc49d9e78$var$getSymbols;


var $09df402023a7d8be$exports = {};
var $a09bf745dbab9cbb$exports = {};
var $e8ba2fb7e61821d6$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $e8ba2fb7e61821d6$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$e8ba2fb7e61821d6$exports = $e8ba2fb7e61821d6$var$baseTimes;


var $4066d8b81a6799bf$exports = {};
var $7fd58b1e4589a5a5$exports = {};

var $1cb4850252351023$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1cb4850252351023$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$1cb4850252351023$exports = $1cb4850252351023$var$isObjectLike;


/** `Object#toString` result references. */ var $7fd58b1e4589a5a5$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $7fd58b1e4589a5a5$var$baseIsArguments(value) {
    return $1cb4850252351023$exports(value) && $7795fa4e140e28cd$exports(value) == $7fd58b1e4589a5a5$var$argsTag;
}
$7fd58b1e4589a5a5$exports = $7fd58b1e4589a5a5$var$baseIsArguments;



/** Used for built-in method references. */ var $4066d8b81a6799bf$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4066d8b81a6799bf$var$hasOwnProperty = $4066d8b81a6799bf$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $4066d8b81a6799bf$var$propertyIsEnumerable = $4066d8b81a6799bf$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $4066d8b81a6799bf$var$isArguments = $7fd58b1e4589a5a5$exports(function() {
    return arguments;
}()) ? $7fd58b1e4589a5a5$exports : function(value) {
    return $1cb4850252351023$exports(value) && $4066d8b81a6799bf$var$hasOwnProperty.call(value, 'callee') && !$4066d8b81a6799bf$var$propertyIsEnumerable.call(value, 'callee');
};
$4066d8b81a6799bf$exports = $4066d8b81a6799bf$var$isArguments;




var $gi6Ym = parcelRequire("gi6Ym");
var $a2de504b4d43ec68$exports = {};
/** Used as references for various `Number` constants. */ var $a2de504b4d43ec68$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $a2de504b4d43ec68$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $a2de504b4d43ec68$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $a2de504b4d43ec68$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $a2de504b4d43ec68$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$a2de504b4d43ec68$exports = $a2de504b4d43ec68$var$isIndex;


var $c513067efacd5397$exports = {};
var $fdb15df79af1df3e$exports = {};

var $2b3915bf92a501db$exports = {};
/** Used as references for various `Number` constants. */ var $2b3915bf92a501db$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $2b3915bf92a501db$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $2b3915bf92a501db$var$MAX_SAFE_INTEGER;
}
$2b3915bf92a501db$exports = $2b3915bf92a501db$var$isLength;



/** `Object#toString` result references. */ var $fdb15df79af1df3e$var$argsTag = '[object Arguments]', $fdb15df79af1df3e$var$arrayTag = '[object Array]', $fdb15df79af1df3e$var$boolTag = '[object Boolean]', $fdb15df79af1df3e$var$dateTag = '[object Date]', $fdb15df79af1df3e$var$errorTag = '[object Error]', $fdb15df79af1df3e$var$funcTag = '[object Function]', $fdb15df79af1df3e$var$mapTag = '[object Map]', $fdb15df79af1df3e$var$numberTag = '[object Number]', $fdb15df79af1df3e$var$objectTag = '[object Object]', $fdb15df79af1df3e$var$regexpTag = '[object RegExp]', $fdb15df79af1df3e$var$setTag = '[object Set]', $fdb15df79af1df3e$var$stringTag = '[object String]', $fdb15df79af1df3e$var$weakMapTag = '[object WeakMap]';
var $fdb15df79af1df3e$var$arrayBufferTag = '[object ArrayBuffer]', $fdb15df79af1df3e$var$dataViewTag = '[object DataView]', $fdb15df79af1df3e$var$float32Tag = '[object Float32Array]', $fdb15df79af1df3e$var$float64Tag = '[object Float64Array]', $fdb15df79af1df3e$var$int8Tag = '[object Int8Array]', $fdb15df79af1df3e$var$int16Tag = '[object Int16Array]', $fdb15df79af1df3e$var$int32Tag = '[object Int32Array]', $fdb15df79af1df3e$var$uint8Tag = '[object Uint8Array]', $fdb15df79af1df3e$var$uint8ClampedTag = '[object Uint8ClampedArray]', $fdb15df79af1df3e$var$uint16Tag = '[object Uint16Array]', $fdb15df79af1df3e$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $fdb15df79af1df3e$var$typedArrayTags = {};
$fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$float32Tag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$float64Tag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$int8Tag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$int16Tag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$int32Tag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$uint8Tag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$uint8ClampedTag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$uint16Tag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$uint32Tag] = true;
$fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$argsTag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$arrayTag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$arrayBufferTag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$boolTag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$dataViewTag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$dateTag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$errorTag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$funcTag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$mapTag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$numberTag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$objectTag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$regexpTag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$setTag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$stringTag] = $fdb15df79af1df3e$var$typedArrayTags[$fdb15df79af1df3e$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $fdb15df79af1df3e$var$baseIsTypedArray(value) {
    return $1cb4850252351023$exports(value) && $2b3915bf92a501db$exports(value.length) && !!$fdb15df79af1df3e$var$typedArrayTags[$7795fa4e140e28cd$exports(value)];
}
$fdb15df79af1df3e$exports = $fdb15df79af1df3e$var$baseIsTypedArray;


var $d92a75ec01863059$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $d92a75ec01863059$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$d92a75ec01863059$exports = $d92a75ec01863059$var$baseUnary;



var $igBAz = parcelRequire("igBAz");
/* Node.js helper references. */ var $c513067efacd5397$var$nodeIsTypedArray = $igBAz && $igBAz.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $c513067efacd5397$var$isTypedArray = $c513067efacd5397$var$nodeIsTypedArray ? $d92a75ec01863059$exports($c513067efacd5397$var$nodeIsTypedArray) : $fdb15df79af1df3e$exports;
$c513067efacd5397$exports = $c513067efacd5397$var$isTypedArray;


/** Used for built-in method references. */ var $a09bf745dbab9cbb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a09bf745dbab9cbb$var$hasOwnProperty = $a09bf745dbab9cbb$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $a09bf745dbab9cbb$var$arrayLikeKeys(value, inherited) {
    var isArr = $9ddb8a7a9343d289$exports(value), isArg = !isArr && $4066d8b81a6799bf$exports(value), isBuff = !isArr && !isArg && $gi6Ym(value), isType = !isArr && !isArg && !isBuff && $c513067efacd5397$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $e8ba2fb7e61821d6$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $a09bf745dbab9cbb$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $a2de504b4d43ec68$exports(key, length)))) result.push(key);
    return result;
}
$a09bf745dbab9cbb$exports = $a09bf745dbab9cbb$var$arrayLikeKeys;


var $0cbbe936bf577462$exports = {};
var $64856c8eea60b446$exports = {};
/** Used for built-in method references. */ var $64856c8eea60b446$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $64856c8eea60b446$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $64856c8eea60b446$var$objectProto;
    return value === proto;
}
$64856c8eea60b446$exports = $64856c8eea60b446$var$isPrototype;


var $a2a7bc6b122c6d47$exports = {};
var $e1440f89166587cb$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $e1440f89166587cb$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$e1440f89166587cb$exports = $e1440f89166587cb$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $a2a7bc6b122c6d47$var$nativeKeys = $e1440f89166587cb$exports(Object.keys, Object);
$a2a7bc6b122c6d47$exports = $a2a7bc6b122c6d47$var$nativeKeys;


/** Used for built-in method references. */ var $0cbbe936bf577462$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0cbbe936bf577462$var$hasOwnProperty = $0cbbe936bf577462$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $0cbbe936bf577462$var$baseKeys(object) {
    if (!$64856c8eea60b446$exports(object)) return $a2a7bc6b122c6d47$exports(object);
    var result = [];
    for(var key in Object(object))if ($0cbbe936bf577462$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$0cbbe936bf577462$exports = $0cbbe936bf577462$var$baseKeys;


var $27e5d73ea889a418$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $27e5d73ea889a418$var$isArrayLike(value) {
    return value != null && $2b3915bf92a501db$exports(value.length) && !$521335ecaded1962$exports(value);
}
$27e5d73ea889a418$exports = $27e5d73ea889a418$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $09df402023a7d8be$var$keys(object) {
    return $27e5d73ea889a418$exports(object) ? $a09bf745dbab9cbb$exports(object) : $0cbbe936bf577462$exports(object);
}
$09df402023a7d8be$exports = $09df402023a7d8be$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $73c43f9b0807101b$var$getAllKeys(object) {
    return $283ccd282479a99f$exports(object, $09df402023a7d8be$exports, $623cd90fc49d9e78$exports);
}
$73c43f9b0807101b$exports = $73c43f9b0807101b$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $c3bff16084b6cc79$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $c3bff16084b6cc79$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c3bff16084b6cc79$var$hasOwnProperty = $c3bff16084b6cc79$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c3bff16084b6cc79$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $c3bff16084b6cc79$var$COMPARE_PARTIAL_FLAG, objProps = $73c43f9b0807101b$exports(object), objLength = objProps.length, othProps = $73c43f9b0807101b$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $c3bff16084b6cc79$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$c3bff16084b6cc79$exports = $c3bff16084b6cc79$var$equalObjects;


var $c36d32eab908bbc7$exports = {};
var $aca08d8f44a66c0c$exports = {};


var $g1Rml = parcelRequire("g1Rml");
/* Built-in method references that are verified to be native. */ var $aca08d8f44a66c0c$var$DataView = $257e3b6443360c50$exports($g1Rml, 'DataView');
$aca08d8f44a66c0c$exports = $aca08d8f44a66c0c$var$DataView;



var $c0e6c0a79c08420e$exports = {};


var $g1Rml = parcelRequire("g1Rml");
/* Built-in method references that are verified to be native. */ var $c0e6c0a79c08420e$var$Promise = $257e3b6443360c50$exports($g1Rml, 'Promise');
$c0e6c0a79c08420e$exports = $c0e6c0a79c08420e$var$Promise;


var $d29ac6e1c214c2cf$exports = {};


var $g1Rml = parcelRequire("g1Rml");
/* Built-in method references that are verified to be native. */ var $d29ac6e1c214c2cf$var$Set = $257e3b6443360c50$exports($g1Rml, 'Set');
$d29ac6e1c214c2cf$exports = $d29ac6e1c214c2cf$var$Set;


var $4dd3d99576d7c39b$exports = {};


var $g1Rml = parcelRequire("g1Rml");
/* Built-in method references that are verified to be native. */ var $4dd3d99576d7c39b$var$WeakMap = $257e3b6443360c50$exports($g1Rml, 'WeakMap');
$4dd3d99576d7c39b$exports = $4dd3d99576d7c39b$var$WeakMap;




/** `Object#toString` result references. */ var $c36d32eab908bbc7$var$mapTag = '[object Map]', $c36d32eab908bbc7$var$objectTag = '[object Object]', $c36d32eab908bbc7$var$promiseTag = '[object Promise]', $c36d32eab908bbc7$var$setTag = '[object Set]', $c36d32eab908bbc7$var$weakMapTag = '[object WeakMap]';
var $c36d32eab908bbc7$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $c36d32eab908bbc7$var$dataViewCtorString = $1b080b51894661f4$exports($aca08d8f44a66c0c$exports), $c36d32eab908bbc7$var$mapCtorString = $1b080b51894661f4$exports($970ada1afc753add$exports), $c36d32eab908bbc7$var$promiseCtorString = $1b080b51894661f4$exports($c0e6c0a79c08420e$exports), $c36d32eab908bbc7$var$setCtorString = $1b080b51894661f4$exports($d29ac6e1c214c2cf$exports), $c36d32eab908bbc7$var$weakMapCtorString = $1b080b51894661f4$exports($4dd3d99576d7c39b$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $c36d32eab908bbc7$var$getTag = $7795fa4e140e28cd$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($aca08d8f44a66c0c$exports && $c36d32eab908bbc7$var$getTag(new $aca08d8f44a66c0c$exports(new ArrayBuffer(1))) != $c36d32eab908bbc7$var$dataViewTag || $970ada1afc753add$exports && $c36d32eab908bbc7$var$getTag(new $970ada1afc753add$exports) != $c36d32eab908bbc7$var$mapTag || $c0e6c0a79c08420e$exports && $c36d32eab908bbc7$var$getTag($c0e6c0a79c08420e$exports.resolve()) != $c36d32eab908bbc7$var$promiseTag || $d29ac6e1c214c2cf$exports && $c36d32eab908bbc7$var$getTag(new $d29ac6e1c214c2cf$exports) != $c36d32eab908bbc7$var$setTag || $4dd3d99576d7c39b$exports && $c36d32eab908bbc7$var$getTag(new $4dd3d99576d7c39b$exports) != $c36d32eab908bbc7$var$weakMapTag) $c36d32eab908bbc7$var$getTag = function(value) {
    var result = $7795fa4e140e28cd$exports(value), Ctor = result == $c36d32eab908bbc7$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $1b080b51894661f4$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $c36d32eab908bbc7$var$dataViewCtorString:
            return $c36d32eab908bbc7$var$dataViewTag;
        case $c36d32eab908bbc7$var$mapCtorString:
            return $c36d32eab908bbc7$var$mapTag;
        case $c36d32eab908bbc7$var$promiseCtorString:
            return $c36d32eab908bbc7$var$promiseTag;
        case $c36d32eab908bbc7$var$setCtorString:
            return $c36d32eab908bbc7$var$setTag;
        case $c36d32eab908bbc7$var$weakMapCtorString:
            return $c36d32eab908bbc7$var$weakMapTag;
    }
    return result;
};
$c36d32eab908bbc7$exports = $c36d32eab908bbc7$var$getTag;




var $gi6Ym = parcelRequire("gi6Ym");

/** Used to compose bitmasks for value comparisons. */ var $3699f8138e7d0453$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $3699f8138e7d0453$var$argsTag = '[object Arguments]', $3699f8138e7d0453$var$arrayTag = '[object Array]', $3699f8138e7d0453$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $3699f8138e7d0453$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3699f8138e7d0453$var$hasOwnProperty = $3699f8138e7d0453$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $3699f8138e7d0453$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $9ddb8a7a9343d289$exports(object), othIsArr = $9ddb8a7a9343d289$exports(other), objTag = objIsArr ? $3699f8138e7d0453$var$arrayTag : $c36d32eab908bbc7$exports(object), othTag = othIsArr ? $3699f8138e7d0453$var$arrayTag : $c36d32eab908bbc7$exports(other);
    objTag = objTag == $3699f8138e7d0453$var$argsTag ? $3699f8138e7d0453$var$objectTag : objTag;
    othTag = othTag == $3699f8138e7d0453$var$argsTag ? $3699f8138e7d0453$var$objectTag : othTag;
    var objIsObj = objTag == $3699f8138e7d0453$var$objectTag, othIsObj = othTag == $3699f8138e7d0453$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $gi6Ym(object)) {
        if (!$gi6Ym(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $1d3a246bcaafa134$exports);
        return objIsArr || $c513067efacd5397$exports(object) ? $99115c610c7be078$exports(object, other, bitmask, customizer, equalFunc, stack) : $8951d079c66a6fc9$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $3699f8138e7d0453$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $3699f8138e7d0453$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $3699f8138e7d0453$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $1d3a246bcaafa134$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $1d3a246bcaafa134$exports);
    return $c3bff16084b6cc79$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$3699f8138e7d0453$exports = $3699f8138e7d0453$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $a4faac028a5783e9$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$1cb4850252351023$exports(value) && !$1cb4850252351023$exports(other)) return value !== value && other !== other;
    return $3699f8138e7d0453$exports(value, other, bitmask, customizer, $a4faac028a5783e9$var$baseIsEqual, stack);
}
$a4faac028a5783e9$exports = $a4faac028a5783e9$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $f0e839acff22663e$var$isEqual(value, other) {
    return $a4faac028a5783e9$exports(value, other);
}
$f0e839acff22663e$exports = $f0e839acff22663e$var$isEqual;


var $b10c0410b70013f3$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $b10c0410b70013f3$var$isNil(value) {
    return value == null;
}
$b10c0410b70013f3$exports = $b10c0410b70013f3$var$isNil;



var $gIfym = parcelRequire("gIfym");

var $acb894cf4c1e4223$exports = {};
var $fb1d6919c9f99e63$exports = {};
var $27a757d2c4a3dc7b$exports = {};

var $6dd64aa6b68d56e5$exports = {};

var $b33d0ca91daaf047$exports = {};


/** `Object#toString` result references. */ var $b33d0ca91daaf047$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b33d0ca91daaf047$var$isSymbol(value) {
    return typeof value == 'symbol' || $1cb4850252351023$exports(value) && $7795fa4e140e28cd$exports(value) == $b33d0ca91daaf047$var$symbolTag;
}
$b33d0ca91daaf047$exports = $b33d0ca91daaf047$var$isSymbol;


/** Used to match property names within property paths. */ var $6dd64aa6b68d56e5$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $6dd64aa6b68d56e5$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $6dd64aa6b68d56e5$var$isKey(value, object) {
    if ($9ddb8a7a9343d289$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $b33d0ca91daaf047$exports(value)) return true;
    return $6dd64aa6b68d56e5$var$reIsPlainProp.test(value) || !$6dd64aa6b68d56e5$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$6dd64aa6b68d56e5$exports = $6dd64aa6b68d56e5$var$isKey;


var $7b394a5d03b306d9$exports = {};
var $1c6e9312894b87cf$exports = {};
var $f201d6f0c7a11898$exports = {};

/** Error message constants. */ var $f201d6f0c7a11898$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $f201d6f0c7a11898$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($f201d6f0c7a11898$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($f201d6f0c7a11898$var$memoize.Cache || $b0b756100e13bcb5$exports);
    return memoized;
}
// Expose `MapCache`.
$f201d6f0c7a11898$var$memoize.Cache = $b0b756100e13bcb5$exports;
$f201d6f0c7a11898$exports = $f201d6f0c7a11898$var$memoize;


/** Used as the maximum memoize cache size. */ var $1c6e9312894b87cf$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $1c6e9312894b87cf$var$memoizeCapped(func) {
    var result = $f201d6f0c7a11898$exports(func, function(key) {
        if (cache.size === $1c6e9312894b87cf$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$1c6e9312894b87cf$exports = $1c6e9312894b87cf$var$memoizeCapped;


/** Used to match property names within property paths. */ var $7b394a5d03b306d9$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $7b394a5d03b306d9$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $7b394a5d03b306d9$var$stringToPath = $1c6e9312894b87cf$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($7b394a5d03b306d9$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($7b394a5d03b306d9$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$7b394a5d03b306d9$exports = $7b394a5d03b306d9$var$stringToPath;


var $327b618d771fa8fb$exports = {};
var $5a66f54f8d64803e$exports = {};

var $a49158a66fd855e6$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $a49158a66fd855e6$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$a49158a66fd855e6$exports = $a49158a66fd855e6$var$arrayMap;




/** Used as references for various `Number` constants. */ var $5a66f54f8d64803e$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $5a66f54f8d64803e$var$symbolProto = $5a48a5ef4eb9b974$exports ? $5a48a5ef4eb9b974$exports.prototype : undefined, $5a66f54f8d64803e$var$symbolToString = $5a66f54f8d64803e$var$symbolProto ? $5a66f54f8d64803e$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $5a66f54f8d64803e$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($9ddb8a7a9343d289$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $a49158a66fd855e6$exports(value, $5a66f54f8d64803e$var$baseToString) + '';
    if ($b33d0ca91daaf047$exports(value)) return $5a66f54f8d64803e$var$symbolToString ? $5a66f54f8d64803e$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$5a66f54f8d64803e$var$INFINITY ? '-0' : result;
}
$5a66f54f8d64803e$exports = $5a66f54f8d64803e$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $327b618d771fa8fb$var$toString(value) {
    return value == null ? '' : $5a66f54f8d64803e$exports(value);
}
$327b618d771fa8fb$exports = $327b618d771fa8fb$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $27a757d2c4a3dc7b$var$castPath(value, object) {
    if ($9ddb8a7a9343d289$exports(value)) return value;
    return $6dd64aa6b68d56e5$exports(value, object) ? [
        value
    ] : $7b394a5d03b306d9$exports($327b618d771fa8fb$exports(value));
}
$27a757d2c4a3dc7b$exports = $27a757d2c4a3dc7b$var$castPath;


var $6647d8289572aa82$exports = {};

/** Used as references for various `Number` constants. */ var $6647d8289572aa82$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $6647d8289572aa82$var$toKey(value) {
    if (typeof value == 'string' || $b33d0ca91daaf047$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$6647d8289572aa82$var$INFINITY ? '-0' : result;
}
$6647d8289572aa82$exports = $6647d8289572aa82$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fb1d6919c9f99e63$var$baseGet(object, path) {
    path = $27a757d2c4a3dc7b$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$6647d8289572aa82$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$fb1d6919c9f99e63$exports = $fb1d6919c9f99e63$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $acb894cf4c1e4223$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $fb1d6919c9f99e63$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$acb894cf4c1e4223$exports = $acb894cf4c1e4223$var$get;



var $fde8137f9fa467a7$exports = {};



/** `Object#toString` result references. */ var $fde8137f9fa467a7$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $fde8137f9fa467a7$var$isString(value) {
    return typeof value == 'string' || !$9ddb8a7a9343d289$exports(value) && $1cb4850252351023$exports(value) && $7795fa4e140e28cd$exports(value) == $fde8137f9fa467a7$var$stringTag;
}
$fde8137f9fa467a7$exports = $fde8137f9fa467a7$var$isString;





var $gIfym = parcelRequire("gIfym");
var $f408f1a00e90b377$exports = {};
'use strict';

$f408f1a00e90b377$exports = (parcelRequire("krok7"));



var $5da66dc27836751e$exports = {};
var $c8f39eba2f8b95d9$exports = {};


/** `Object#toString` result references. */ var $c8f39eba2f8b95d9$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $c8f39eba2f8b95d9$var$isNumber(value) {
    return typeof value == 'number' || $1cb4850252351023$exports(value) && $7795fa4e140e28cd$exports(value) == $c8f39eba2f8b95d9$var$numberTag;
}
$c8f39eba2f8b95d9$exports = $c8f39eba2f8b95d9$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $5da66dc27836751e$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $c8f39eba2f8b95d9$exports(value) && value != +value;
}
$5da66dc27836751e$exports = $5da66dc27836751e$var$isNaN;




var $938aefa455a73c9b$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $938aefa455a73c9b$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fde8137f9fa467a7$exports)))(value) && value.indexOf('%') === value.length - 1;
};
var $938aefa455a73c9b$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($c8f39eba2f8b95d9$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($5da66dc27836751e$exports)))(value);
};
var $938aefa455a73c9b$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $938aefa455a73c9b$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($fde8137f9fa467a7$exports)))(value);
};
var $938aefa455a73c9b$var$idCounter = 0;
var $938aefa455a73c9b$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$938aefa455a73c9b$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $938aefa455a73c9b$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$938aefa455a73c9b$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($fde8137f9fa467a7$exports)))(percent)) return defaultValue;
    var value;
    if ($938aefa455a73c9b$export$e50269385c77c348(percent)) {
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($5da66dc27836751e$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $938aefa455a73c9b$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $938aefa455a73c9b$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $938aefa455a73c9b$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($938aefa455a73c9b$export$7e4aa119212bc614(numberA) && $938aefa455a73c9b$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $938aefa455a73c9b$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($acb894cf4c1e4223$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $938aefa455a73c9b$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};
var $938aefa455a73c9b$export$6ab1df3197f7c641 = function compareValues(a, b) {
    if ($938aefa455a73c9b$export$7e4aa119212bc614(a) && $938aefa455a73c9b$export$7e4aa119212bc614(b)) return a - b;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($fde8137f9fa467a7$exports)))(a) && (0, (/*@__PURE__*/$parcel$interopDefault($fde8137f9fa467a7$exports)))(b)) return a.localeCompare(b);
    if (a instanceof Date && b instanceof Date) return a.getTime() - b.getTime();
    return String(a).localeCompare(String(b));
};


function $5039526b485776da$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}



var $gIfym = parcelRequire("gIfym");

function $e49003a65b792e53$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e49003a65b792e53$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e49003a65b792e53$var$_typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $e49003a65b792e53$var$SVGContainerPropKeys = [
    'viewBox',
    'children'
];
var $e49003a65b792e53$export$190f430946f96110 = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $e49003a65b792e53$var$PolyElementKeys = [
    'points',
    'pathLength'
];
var $e49003a65b792e53$export$2b22758266a6fa48 = {
    svg: $e49003a65b792e53$var$SVGContainerPropKeys,
    polygon: $e49003a65b792e53$var$PolyElementKeys,
    polyline: $e49003a65b792e53$var$PolyElementKeys
};
var $e49003a65b792e53$export$f30789245f2c4d11 = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
var $e49003a65b792e53$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $gIfym.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($6c66affe1256ad5a$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($e49003a65b792e53$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $e49003a65b792e53$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $e49003a65b792e53$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($6c66affe1256ad5a$exports)))(props) || $e49003a65b792e53$var$_typeof(props) !== 'object') return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($e49003a65b792e53$export$f30789245f2c4d11.includes(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $e49003a65b792e53$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $49516a074167c4be$var$_excluded = [
    "children"
], $49516a074167c4be$var$_excluded2 = [
    "children"
];
function $49516a074167c4be$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $49516a074167c4be$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $49516a074167c4be$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $49516a074167c4be$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $49516a074167c4be$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $49516a074167c4be$var$_typeof(o);
}
var $49516a074167c4be$var$REACT_BROWSER_EVENT_MAP = {
    click: 'onClick',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    mouseout: 'onMouseOut',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    touchcancel: 'onTouchCancel',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchstart: 'onTouchStart',
    contextmenu: 'onContextMenu',
    dblclick: 'onDoubleClick'
};
var $49516a074167c4be$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $49516a074167c4be$export$84dbd3b52ff06578 = [
    'plainline',
    'line',
    'square',
    'rect',
    'circle',
    'cross',
    'diamond',
    'star',
    'triangle',
    'wye',
    'none'
];
var $49516a074167c4be$export$59a4d7d024cf1025 = [
    'none'
];
var $49516a074167c4be$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $49516a074167c4be$var$lastChildren = null;
var $49516a074167c4be$var$lastResult = null;
var $49516a074167c4be$export$45b10814cc054894 = function toArray(children) {
    if (children === $49516a074167c4be$var$lastChildren && Array.isArray($49516a074167c4be$var$lastResult)) return $49516a074167c4be$var$lastResult;
    var result = [];
    (0, $gIfym.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(child)) return;
        if ((0, $f408f1a00e90b377$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    $49516a074167c4be$var$lastResult = result;
    $49516a074167c4be$var$lastChildren = children;
    return result;
};
function $49516a074167c4be$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return $49516a074167c4be$export$be63e0664592e141(t);
    });
    else types = [
        $49516a074167c4be$export$be63e0664592e141(type)
    ];
    $49516a074167c4be$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($acb894cf4c1e4223$exports)))(child, 'type.displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($acb894cf4c1e4223$exports)))(child, 'type.name');
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $49516a074167c4be$export$64c61536a2b72e0f(children, type) {
    var result = $49516a074167c4be$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $49516a074167c4be$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return $49516a074167c4be$export$be63e0664592e141(t);
    });
    else types = [
        $49516a074167c4be$export$be63e0664592e141(type)
    ];
    $49516a074167c4be$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($acb894cf4c1e4223$exports)))(child, 'type.displayName');
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $49516a074167c4be$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $938aefa455a73c9b$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $49516a074167c4be$var$SVG_TAGS = [
    'a',
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animate',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'circle',
    'clipPath',
    'color-profile',
    'cursor',
    'defs',
    'desc',
    'ellipse',
    'feBlend',
    'feColormatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'font',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-url',
    'foreignObject',
    'g',
    'glyph',
    'glyphRef',
    'hkern',
    'image',
    'line',
    'lineGradient',
    'marker',
    'mask',
    'metadata',
    'missing-glyph',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'script',
    'set',
    'stop',
    'style',
    'svg',
    'switch',
    'symbol',
    'text',
    'textPath',
    'title',
    'tref',
    'tspan',
    'use',
    'view',
    'vkern'
];
var $49516a074167c4be$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($fde8137f9fa467a7$exports)))(child.type) && $49516a074167c4be$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $49516a074167c4be$export$392f6c9701718a4e = function hasClipDot(dot) {
    return dot && $49516a074167c4be$var$_typeof(dot) === 'object' && 'clipDot' in dot;
};
var $49516a074167c4be$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $e49003a65b792e53$export$2b22758266a6fa48) === null || (0, $e49003a65b792e53$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $e49003a65b792e53$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return key.startsWith('data-') || !(0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $e49003a65b792e53$export$190f430946f96110).includes(key)) || includeEvents && (0, $e49003a65b792e53$export$f30789245f2c4d11).includes(key);
};
var $49516a074167c4be$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $49516a074167c4be$export$45b10814cc054894(children).forEach(function(entry) {
        if ($49516a074167c4be$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $49516a074167c4be$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $gIfym.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($6c66affe1256ad5a$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($49516a074167c4be$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $49516a074167c4be$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $gIfym.Children).count(nextChildren);
    if (count !== (0, $gIfym.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $49516a074167c4be$export$96bceecf65400492(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$49516a074167c4be$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $49516a074167c4be$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $49516a074167c4be$var$_objectWithoutProperties(_ref, $49516a074167c4be$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $49516a074167c4be$var$_objectWithoutProperties(_ref2, $49516a074167c4be$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $5039526b485776da$export$d36bdfa510afb180)(nextProps, prevProps) && $49516a074167c4be$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $5039526b485776da$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $49516a074167c4be$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $49516a074167c4be$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($49516a074167c4be$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $49516a074167c4be$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $49516a074167c4be$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $49516a074167c4be$var$REACT_BROWSER_EVENT_MAP[type]) return $49516a074167c4be$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $49516a074167c4be$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $49516a074167c4be$export$45b10814cc054894(children).indexOf(child);
};


var $f4b5c79812b944a1$var$_excluded = [
    "children",
    "className"
];
function $f4b5c79812b944a1$var$_extends() {
    $f4b5c79812b944a1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f4b5c79812b944a1$var$_extends.apply(this, arguments);
}
function $f4b5c79812b944a1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f4b5c79812b944a1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f4b5c79812b944a1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f4b5c79812b944a1$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $f4b5c79812b944a1$var$_objectWithoutProperties(props, $f4b5c79812b944a1$var$_excluded);
    var layerClass = (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-layer', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("g", $f4b5c79812b944a1$var$_extends({
        className: layerClass
    }, (0, $49516a074167c4be$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});



var $gIfym = parcelRequire("gIfym");



var $d7f00f77e606798b$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $d7f00f77e606798b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d7f00f77e606798b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d7f00f77e606798b$var$_typeof(o);
}
function $d7f00f77e606798b$var$_extends() {
    $d7f00f77e606798b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d7f00f77e606798b$var$_extends.apply(this, arguments);
}
function $d7f00f77e606798b$var$_slicedToArray(arr, i) {
    return $d7f00f77e606798b$var$_arrayWithHoles(arr) || $d7f00f77e606798b$var$_iterableToArrayLimit(arr, i) || $d7f00f77e606798b$var$_unsupportedIterableToArray(arr, i) || $d7f00f77e606798b$var$_nonIterableRest();
}
function $d7f00f77e606798b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d7f00f77e606798b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d7f00f77e606798b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d7f00f77e606798b$var$_arrayLikeToArray(o, minLen);
}
function $d7f00f77e606798b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d7f00f77e606798b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d7f00f77e606798b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d7f00f77e606798b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d7f00f77e606798b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d7f00f77e606798b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d7f00f77e606798b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d7f00f77e606798b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d7f00f77e606798b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d7f00f77e606798b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d7f00f77e606798b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d7f00f77e606798b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d7f00f77e606798b$var$_callSuper(t, o, e) {
    return o = $d7f00f77e606798b$var$_getPrototypeOf(o), $d7f00f77e606798b$var$_possibleConstructorReturn(t, $d7f00f77e606798b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $d7f00f77e606798b$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $d7f00f77e606798b$var$_possibleConstructorReturn(self, call) {
    if (call && ($d7f00f77e606798b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d7f00f77e606798b$var$_assertThisInitialized(self);
}
function $d7f00f77e606798b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d7f00f77e606798b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d7f00f77e606798b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $d7f00f77e606798b$var$_getPrototypeOf(o) {
    $d7f00f77e606798b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d7f00f77e606798b$var$_getPrototypeOf(o);
}
function $d7f00f77e606798b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d7f00f77e606798b$var$_setPrototypeOf(subClass, superClass);
}
function $d7f00f77e606798b$var$_setPrototypeOf(o, p) {
    $d7f00f77e606798b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d7f00f77e606798b$var$_setPrototypeOf(o, p);
}
function $d7f00f77e606798b$var$_defineProperty(obj, key, value) {
    key = $d7f00f77e606798b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d7f00f77e606798b$var$_toPropertyKey(t) {
    var i = $d7f00f77e606798b$var$_toPrimitive(t, "string");
    return "symbol" == $d7f00f77e606798b$var$_typeof(i) ? i : i + "";
}
function $d7f00f77e606798b$var$_toPrimitive(t, r) {
    if ("object" != $d7f00f77e606798b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d7f00f77e606798b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d7f00f77e606798b$export$4f4d7676bdf949e5 = /*#__PURE__*/ function(_React$Component) {
    function ErrorBar() {
        $d7f00f77e606798b$var$_classCallCheck(this, ErrorBar);
        return $d7f00f77e606798b$var$_callSuper(this, ErrorBar, arguments);
    }
    $d7f00f77e606798b$var$_inherits(ErrorBar, _React$Component);
    return $d7f00f77e606798b$var$_createClass(ErrorBar, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, offset = _this$props.offset, layout = _this$props.layout, width = _this$props.width, dataKey = _this$props.dataKey, data = _this$props.data, dataPointFormatter = _this$props.dataPointFormatter, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, others = $d7f00f77e606798b$var$_objectWithoutProperties(_this$props, $d7f00f77e606798b$var$_excluded);
                var svgProps = (0, $49516a074167c4be$export$d697c39a2985a4c)(others, false);
                !!(this.props.direction === 'x' && xAxis.type !== 'number') && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
                var errorBars = data.map(function(entry) {
                    var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
                    if (!errorVal) return null;
                    var lineCoordinates = [];
                    var lowBound, highBound;
                    if (Array.isArray(errorVal)) {
                        var _errorVal = $d7f00f77e606798b$var$_slicedToArray(errorVal, 2);
                        lowBound = _errorVal[0];
                        highBound = _errorVal[1];
                    } else lowBound = highBound = errorVal;
                    if (layout === 'vertical') {
                        // error bar for horizontal charts, the y is fixed, x is a range value
                        var scale = xAxis.scale;
                        var yMid = y + offset;
                        var yMin = yMid + width;
                        var yMax = yMid - width;
                        var xMin = scale(value - lowBound);
                        var xMax = scale(value + highBound);
                        // the right line of |--|
                        lineCoordinates.push({
                            x1: xMax,
                            y1: yMin,
                            x2: xMax,
                            y2: yMax
                        });
                        // the middle line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMid,
                            x2: xMax,
                            y2: yMid
                        });
                        // the left line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMin,
                            x2: xMin,
                            y2: yMax
                        });
                    } else if (layout === 'horizontal') {
                        // error bar for horizontal charts, the x is fixed, y is a range value
                        var _scale = yAxis.scale;
                        var xMid = x + offset;
                        var _xMin = xMid - width;
                        var _xMax = xMid + width;
                        var _yMin = _scale(value - lowBound);
                        var _yMax = _scale(value + highBound);
                        // the top line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMax,
                            x2: _xMax,
                            y2: _yMax
                        });
                        // the middle line
                        lineCoordinates.push({
                            x1: xMid,
                            y1: _yMin,
                            x2: xMid,
                            y2: _yMax
                        });
                        // the bottom line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMin,
                            x2: _xMax,
                            y2: _yMin
                        });
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), $d7f00f77e606798b$var$_extends({
                        className: "recharts-errorBar",
                        key: "bar-".concat(lineCoordinates.map(function(c) {
                            return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
                        }))
                    }, svgProps), lineCoordinates.map(function(coordinates) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("line", $d7f00f77e606798b$var$_extends({}, coordinates, {
                            key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
                        }));
                    }));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
                    className: "recharts-errorBars"
                }, errorBars);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$d7f00f77e606798b$var$_defineProperty($d7f00f77e606798b$export$4f4d7676bdf949e5, "defaultProps", {
    stroke: 'black',
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: 'horizontal'
});
$d7f00f77e606798b$var$_defineProperty($d7f00f77e606798b$export$4f4d7676bdf949e5, "displayName", 'ErrorBar');


/**
 * @fileOverview Cross
 */ var $b7ce6dc70cc786c8$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$b7ce6dc70cc786c8$export$f6f0c3fe4ec306ea.displayName = 'Cell';



var $gIfym = parcelRequire("gIfym");



var $ce55d5d51ec6b2cd$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $ce55d5d51ec6b2cd$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$ce55d5d51ec6b2cd$exports = $ce55d5d51ec6b2cd$var$last;



var $gIfym = parcelRequire("gIfym");





var $gIfym = parcelRequire("gIfym");



var $2a28151593e2b6a4$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var $2a28151593e2b6a4$export$98f03c5d19621d70 = {
    isSsr: $2a28151593e2b6a4$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $2a28151593e2b6a4$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === 'string') $2a28151593e2b6a4$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $2a28151593e2b6a4$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};




function $d9e815357bd46210$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d9e815357bd46210$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d9e815357bd46210$var$_typeof(o);
}
function $d9e815357bd46210$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d9e815357bd46210$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d9e815357bd46210$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d9e815357bd46210$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d9e815357bd46210$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d9e815357bd46210$var$_defineProperty(obj, key, value) {
    key = $d9e815357bd46210$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d9e815357bd46210$var$_toPropertyKey(t) {
    var i = $d9e815357bd46210$var$_toPrimitive(t, "string");
    return "symbol" == $d9e815357bd46210$var$_typeof(i) ? i : i + "";
}
function $d9e815357bd46210$var$_toPrimitive(t, r) {
    if ("object" != $d9e815357bd46210$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d9e815357bd46210$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d9e815357bd46210$var$_toConsumableArray(arr) {
    return $d9e815357bd46210$var$_arrayWithoutHoles(arr) || $d9e815357bd46210$var$_iterableToArray(arr) || $d9e815357bd46210$var$_unsupportedIterableToArray(arr) || $d9e815357bd46210$var$_nonIterableSpread();
}
function $d9e815357bd46210$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d9e815357bd46210$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d9e815357bd46210$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d9e815357bd46210$var$_arrayLikeToArray(o, minLen);
}
function $d9e815357bd46210$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $d9e815357bd46210$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $d9e815357bd46210$var$_arrayLikeToArray(arr);
}
function $d9e815357bd46210$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $d9e815357bd46210$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $d9e815357bd46210$var$MAX_CACHE_NUM = 2000;
var $d9e815357bd46210$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $d9e815357bd46210$var$STYLE_LIST = [
    'minWidth',
    'maxWidth',
    'width',
    'minHeight',
    'maxHeight',
    'height',
    'top',
    'left',
    'fontSize',
    'lineHeight',
    'padding',
    'margin',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
];
var $d9e815357bd46210$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $d9e815357bd46210$var$autoCompleteStyle(name, value) {
    if ($d9e815357bd46210$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $d9e815357bd46210$var$camelToMiddleLine(text) {
    var strs = text.split('');
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($d9e815357bd46210$var$_toConsumableArray(result), [
            '-',
            entry.toLowerCase()
        ]);
        return [].concat($d9e815357bd46210$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join('');
}
var $d9e815357bd46210$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($d9e815357bd46210$var$camelToMiddleLine(s), ":").concat($d9e815357bd46210$var$autoCompleteStyle(s, style[s]), ";");
    }, '');
};
function $d9e815357bd46210$var$removeInvalidKeys(obj) {
    var copyObj = $d9e815357bd46210$var$_objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var $d9e815357bd46210$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $2a28151593e2b6a4$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = $d9e815357bd46210$var$removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if ($d9e815357bd46210$var$stringCache.widthCache[cacheKey]) return $d9e815357bd46210$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($d9e815357bd46210$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $d9e815357bd46210$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $d9e815357bd46210$var$_objectSpread($d9e815357bd46210$var$_objectSpread({}, $d9e815357bd46210$var$SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $d9e815357bd46210$var$stringCache.widthCache[cacheKey] = result;
        if (++$d9e815357bd46210$var$stringCache.cacheCount > $d9e815357bd46210$var$MAX_CACHE_NUM) {
            $d9e815357bd46210$var$stringCache.cacheCount = 0;
            $d9e815357bd46210$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $d9e815357bd46210$export$622cea445a1c5b7d = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};


function $e55ad0185e02474e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e55ad0185e02474e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e55ad0185e02474e$var$_typeof(o);
}
function $e55ad0185e02474e$var$_slicedToArray(arr, i) {
    return $e55ad0185e02474e$var$_arrayWithHoles(arr) || $e55ad0185e02474e$var$_iterableToArrayLimit(arr, i) || $e55ad0185e02474e$var$_unsupportedIterableToArray(arr, i) || $e55ad0185e02474e$var$_nonIterableRest();
}
function $e55ad0185e02474e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e55ad0185e02474e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e55ad0185e02474e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e55ad0185e02474e$var$_arrayLikeToArray(o, minLen);
}
function $e55ad0185e02474e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e55ad0185e02474e$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e55ad0185e02474e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e55ad0185e02474e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e55ad0185e02474e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e55ad0185e02474e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e55ad0185e02474e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e55ad0185e02474e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e55ad0185e02474e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e55ad0185e02474e$var$_toPropertyKey(t) {
    var i = $e55ad0185e02474e$var$_toPrimitive(t, "string");
    return "symbol" == $e55ad0185e02474e$var$_typeof(i) ? i : i + "";
}
function $e55ad0185e02474e$var$_toPrimitive(t, r) {
    if ("object" != $e55ad0185e02474e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e55ad0185e02474e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $e55ad0185e02474e$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $e55ad0185e02474e$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $e55ad0185e02474e$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $e55ad0185e02474e$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $e55ad0185e02474e$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var $e55ad0185e02474e$var$FIXED_CSS_LENGTH_UNITS = Object.keys($e55ad0185e02474e$var$CONVERSION_RATES);
var $e55ad0185e02474e$var$STR_NAN = 'NaN';
function $e55ad0185e02474e$var$convertToPx(value, unit) {
    return value * $e55ad0185e02474e$var$CONVERSION_RATES[unit];
}
var $e55ad0185e02474e$var$DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        $e55ad0185e02474e$var$_classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = '';
        if (unit !== '' && !$e55ad0185e02474e$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if ($e55ad0185e02474e$var$FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = $e55ad0185e02474e$var$convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    return $e55ad0185e02474e$var$_createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = $e55ad0185e02474e$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = $e55ad0185e02474e$var$_slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
            }
        }
    ]);
}();
function $e55ad0185e02474e$var$calculateArithmetic(expr) {
    if (expr.includes($e55ad0185e02474e$var$STR_NAN)) return $e55ad0185e02474e$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = $e55ad0185e02474e$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = $e55ad0185e02474e$var$_slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = $e55ad0185e02474e$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = $e55ad0185e02474e$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $e55ad0185e02474e$var$STR_NAN;
        newExpr = newExpr.replace($e55ad0185e02474e$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = $e55ad0185e02474e$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = $e55ad0185e02474e$var$_slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = $e55ad0185e02474e$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = $e55ad0185e02474e$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $e55ad0185e02474e$var$STR_NAN;
        newExpr = newExpr.replace($e55ad0185e02474e$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $e55ad0185e02474e$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $e55ad0185e02474e$var$calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes('(')){
        var _PARENTHESES_REGEX$ex = $e55ad0185e02474e$var$PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = $e55ad0185e02474e$var$_slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace($e55ad0185e02474e$var$PARENTHESES_REGEX, $e55ad0185e02474e$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $e55ad0185e02474e$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = $e55ad0185e02474e$var$calculateParentheses(newExpr);
    newExpr = $e55ad0185e02474e$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $e55ad0185e02474e$export$c891f73c9c6d00c9(expression) {
    try {
        return $e55ad0185e02474e$var$evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return $e55ad0185e02474e$var$STR_NAN;
    }
}
function $e55ad0185e02474e$export$254eac204f89fd7d(expression) {
    var result = $e55ad0185e02474e$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $e55ad0185e02474e$var$STR_NAN) // notify the user
    return '';
    return result;
}


var $af1dbcbd2651f0c2$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], $af1dbcbd2651f0c2$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $af1dbcbd2651f0c2$var$_extends() {
    $af1dbcbd2651f0c2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $af1dbcbd2651f0c2$var$_extends.apply(this, arguments);
}
function $af1dbcbd2651f0c2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $af1dbcbd2651f0c2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $af1dbcbd2651f0c2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $af1dbcbd2651f0c2$var$_slicedToArray(arr, i) {
    return $af1dbcbd2651f0c2$var$_arrayWithHoles(arr) || $af1dbcbd2651f0c2$var$_iterableToArrayLimit(arr, i) || $af1dbcbd2651f0c2$var$_unsupportedIterableToArray(arr, i) || $af1dbcbd2651f0c2$var$_nonIterableRest();
}
function $af1dbcbd2651f0c2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $af1dbcbd2651f0c2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $af1dbcbd2651f0c2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $af1dbcbd2651f0c2$var$_arrayLikeToArray(o, minLen);
}
function $af1dbcbd2651f0c2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $af1dbcbd2651f0c2$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $af1dbcbd2651f0c2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $af1dbcbd2651f0c2$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $af1dbcbd2651f0c2$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($af1dbcbd2651f0c2$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $d9e815357bd46210$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $d9e815357bd46210$export$e5560531f057ad5d)("\xA0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $af1dbcbd2651f0c2$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $938aefa455a73c9b$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $af1dbcbd2651f0c2$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $af1dbcbd2651f0c2$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $af1dbcbd2651f0c2$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $af1dbcbd2651f0c2$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(children) ? children.toString().split($af1dbcbd2651f0c2$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $af1dbcbd2651f0c2$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $2a28151593e2b6a4$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $af1dbcbd2651f0c2$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $af1dbcbd2651f0c2$var$getWordsWithoutCalculate(children);
        return $af1dbcbd2651f0c2$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $af1dbcbd2651f0c2$var$getWordsWithoutCalculate(children);
};
var $af1dbcbd2651f0c2$var$DEFAULT_FILL = '#808080';
var $af1dbcbd2651f0c2$export$5f1af8db9871e1d6 = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? '1em' : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? '0.71em' : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? 'start' : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? 'end' : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? $af1dbcbd2651f0c2$var$DEFAULT_FILL : _ref5$fill, props = $af1dbcbd2651f0c2$var$_objectWithoutProperties(_ref5, $af1dbcbd2651f0c2$var$_excluded);
    var wordsByLines = (0, $gIfym.useMemo)(function() {
        return $af1dbcbd2651f0c2$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = $af1dbcbd2651f0c2$var$_objectWithoutProperties(props, $af1dbcbd2651f0c2$var$_excluded2);
    if (!(0, $938aefa455a73c9b$export$402a499e1ea44294)(propsX) || !(0, $938aefa455a73c9b$export$402a499e1ea44294)(propsY)) return null;
    var x = propsX + ((0, $938aefa455a73c9b$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = propsY + ((0, $938aefa455a73c9b$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, $e55ad0185e02474e$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, $e55ad0185e02474e$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $e55ad0185e02474e$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $938aefa455a73c9b$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("text", $af1dbcbd2651f0c2$var$_extends({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? $af1dbcbd2651f0c2$var$DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? '' : ' ');
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys
        // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
};






var $gIfym = parcelRequire("gIfym");


var $391ea09682974c37$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$391ea09682974c37$exports = (parcelRequire("7GsXL"));


var $b8df57eaf33776d8$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$b8df57eaf33776d8$exports = (parcelRequire("3H57O"));


var $1ba6bac3ec83ed90$exports = {};
var $c97827481385ceaf$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $c97827481385ceaf$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$b33d0ca91daaf047$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$c97827481385ceaf$exports = $c97827481385ceaf$var$baseExtremum;


var $a6ec50d52b2bc7e1$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $a6ec50d52b2bc7e1$var$baseGt(value, other) {
    return value > other;
}
$a6ec50d52b2bc7e1$exports = $a6ec50d52b2bc7e1$var$baseGt;


var $d07a4b164653b961$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $d07a4b164653b961$var$identity(value) {
    return value;
}
$d07a4b164653b961$exports = $d07a4b164653b961$var$identity;


/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $1ba6bac3ec83ed90$var$max(array) {
    return array && array.length ? $c97827481385ceaf$exports(array, $d07a4b164653b961$exports, $a6ec50d52b2bc7e1$exports) : undefined;
}
$1ba6bac3ec83ed90$exports = $1ba6bac3ec83ed90$var$max;


var $a04633b4899e9c73$exports = {};

var $27e415dfdace9d87$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $27e415dfdace9d87$var$baseLt(value, other) {
    return value < other;
}
$27e415dfdace9d87$exports = $27e415dfdace9d87$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $a04633b4899e9c73$var$min(array) {
    return array && array.length ? $c97827481385ceaf$exports(array, $d07a4b164653b961$exports, $27e415dfdace9d87$exports) : undefined;
}
$a04633b4899e9c73$exports = $a04633b4899e9c73$var$min;






var $d0a106317e83b276$exports = {};
var $8f1c770ea7af275c$exports = {};

var $3700ebdb789952ee$exports = {};



/** Built-in value references. */ var $3700ebdb789952ee$var$spreadableSymbol = $5a48a5ef4eb9b974$exports ? $5a48a5ef4eb9b974$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $3700ebdb789952ee$var$isFlattenable(value) {
    return $9ddb8a7a9343d289$exports(value) || $4066d8b81a6799bf$exports(value) || !!($3700ebdb789952ee$var$spreadableSymbol && value && value[$3700ebdb789952ee$var$spreadableSymbol]);
}
$3700ebdb789952ee$exports = $3700ebdb789952ee$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $8f1c770ea7af275c$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $3700ebdb789952ee$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $8f1c770ea7af275c$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $4e75e860d57e3f05$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$8f1c770ea7af275c$exports = $8f1c770ea7af275c$var$baseFlatten;


var $17d91b41f75dcf73$exports = {};

var $72536eccaddefa03$exports = {};
var $b6bed324c167cdf5$exports = {};
var $23141c6f913a6799$exports = {};


/** Used to compose bitmasks for value comparisons. */ var $23141c6f913a6799$var$COMPARE_PARTIAL_FLAG = 1, $23141c6f913a6799$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $23141c6f913a6799$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $1d3a246bcaafa134$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $a4faac028a5783e9$exports(srcValue, objValue, $23141c6f913a6799$var$COMPARE_PARTIAL_FLAG | $23141c6f913a6799$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$23141c6f913a6799$exports = $23141c6f913a6799$var$baseIsMatch;


var $d3f40bf51717c6dc$exports = {};
var $56e9bec22843848d$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $56e9bec22843848d$var$isStrictComparable(value) {
    return value === value && !$6c66affe1256ad5a$exports(value);
}
$56e9bec22843848d$exports = $56e9bec22843848d$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $d3f40bf51717c6dc$var$getMatchData(object) {
    var result = $09df402023a7d8be$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $56e9bec22843848d$exports(value)
        ];
    }
    return result;
}
$d3f40bf51717c6dc$exports = $d3f40bf51717c6dc$var$getMatchData;


var $7b958b0476e2bf8e$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $7b958b0476e2bf8e$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$7b958b0476e2bf8e$exports = $7b958b0476e2bf8e$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $b6bed324c167cdf5$var$baseMatches(source) {
    var matchData = $d3f40bf51717c6dc$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $7b958b0476e2bf8e$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $23141c6f913a6799$exports(object, source, matchData);
    };
}
$b6bed324c167cdf5$exports = $b6bed324c167cdf5$var$baseMatches;


var $464dab2392f1648f$exports = {};


var $4d77ad37131a198c$exports = {};
var $b3fca2a2a40b465f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $b3fca2a2a40b465f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$b3fca2a2a40b465f$exports = $b3fca2a2a40b465f$var$baseHasIn;


var $b40814723cf0f5a8$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $b40814723cf0f5a8$var$hasPath(object, path, hasFunc) {
    path = $27a757d2c4a3dc7b$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $6647d8289572aa82$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $2b3915bf92a501db$exports(length) && $a2de504b4d43ec68$exports(key, length) && ($9ddb8a7a9343d289$exports(object) || $4066d8b81a6799bf$exports(object));
}
$b40814723cf0f5a8$exports = $b40814723cf0f5a8$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $4d77ad37131a198c$var$hasIn(object, path) {
    return object != null && $b40814723cf0f5a8$exports(object, path, $b3fca2a2a40b465f$exports);
}
$4d77ad37131a198c$exports = $4d77ad37131a198c$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $464dab2392f1648f$var$COMPARE_PARTIAL_FLAG = 1, $464dab2392f1648f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $464dab2392f1648f$var$baseMatchesProperty(path, srcValue) {
    if ($6dd64aa6b68d56e5$exports(path) && $56e9bec22843848d$exports(srcValue)) return $7b958b0476e2bf8e$exports($6647d8289572aa82$exports(path), srcValue);
    return function(object) {
        var objValue = $acb894cf4c1e4223$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $4d77ad37131a198c$exports(object, path) : $a4faac028a5783e9$exports(srcValue, objValue, $464dab2392f1648f$var$COMPARE_PARTIAL_FLAG | $464dab2392f1648f$var$COMPARE_UNORDERED_FLAG);
    };
}
$464dab2392f1648f$exports = $464dab2392f1648f$var$baseMatchesProperty;




var $15e88a7735d71fa7$exports = {};
var $2794d999fef7d4fa$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $2794d999fef7d4fa$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$2794d999fef7d4fa$exports = $2794d999fef7d4fa$var$baseProperty;


var $4dc4c13f6ea356ff$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $4dc4c13f6ea356ff$var$basePropertyDeep(path) {
    return function(object) {
        return $fb1d6919c9f99e63$exports(object, path);
    };
}
$4dc4c13f6ea356ff$exports = $4dc4c13f6ea356ff$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $15e88a7735d71fa7$var$property(path) {
    return $6dd64aa6b68d56e5$exports(path) ? $2794d999fef7d4fa$exports($6647d8289572aa82$exports(path)) : $4dc4c13f6ea356ff$exports(path);
}
$15e88a7735d71fa7$exports = $15e88a7735d71fa7$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $72536eccaddefa03$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $d07a4b164653b961$exports;
    if (typeof value == 'object') return $9ddb8a7a9343d289$exports(value) ? $464dab2392f1648f$exports(value[0], value[1]) : $b6bed324c167cdf5$exports(value);
    return $15e88a7735d71fa7$exports(value);
}
$72536eccaddefa03$exports = $72536eccaddefa03$var$baseIteratee;


var $b17261a3df4175d7$exports = {};
var $4294681764bc38bd$exports = {};
var $dce2671156e34347$exports = {};
var $2d46c6909ad76972$exports = {};
var $ba82ae7e88b73bc5$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $ba82ae7e88b73bc5$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$ba82ae7e88b73bc5$exports = $ba82ae7e88b73bc5$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $2d46c6909ad76972$var$baseFor = $ba82ae7e88b73bc5$exports();
$2d46c6909ad76972$exports = $2d46c6909ad76972$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $dce2671156e34347$var$baseForOwn(object, iteratee) {
    return object && $2d46c6909ad76972$exports(object, iteratee, $09df402023a7d8be$exports);
}
$dce2671156e34347$exports = $dce2671156e34347$var$baseForOwn;


var $102501ccf3737b10$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $102501ccf3737b10$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$27e5d73ea889a418$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$102501ccf3737b10$exports = $102501ccf3737b10$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $4294681764bc38bd$var$baseEach = $102501ccf3737b10$exports($dce2671156e34347$exports);
$4294681764bc38bd$exports = $4294681764bc38bd$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b17261a3df4175d7$var$baseMap(collection, iteratee) {
    var index = -1, result = $27e5d73ea889a418$exports(collection) ? Array(collection.length) : [];
    $4294681764bc38bd$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$b17261a3df4175d7$exports = $b17261a3df4175d7$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $17d91b41f75dcf73$var$map(collection, iteratee) {
    var func = $9ddb8a7a9343d289$exports(collection) ? $a49158a66fd855e6$exports : $b17261a3df4175d7$exports;
    return func(collection, $72536eccaddefa03$exports(iteratee, 3));
}
$17d91b41f75dcf73$exports = $17d91b41f75dcf73$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $d0a106317e83b276$var$flatMap(collection, iteratee) {
    return $8f1c770ea7af275c$exports($17d91b41f75dcf73$exports(collection, iteratee), 1);
}
$d0a106317e83b276$exports = $d0a106317e83b276$var$flatMap;



var $ecdaa70f26552d44$exports = {};
var $52015c7e76a7283e$exports = {};
var $d97989c675d13850$exports = {};
var $190db73a2bb8cf45$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $190db73a2bb8cf45$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$190db73a2bb8cf45$exports = $190db73a2bb8cf45$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $d97989c675d13850$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $190db73a2bb8cf45$exports(array, start, end);
}
$d97989c675d13850$exports = $d97989c675d13850$var$castSlice;


var $701af4dc93490956$exports = {};
/** Used to compose unicode character classes. */ var $701af4dc93490956$var$rsAstralRange = '\\ud800-\\udfff', $701af4dc93490956$var$rsComboMarksRange = '\\u0300-\\u036f', $701af4dc93490956$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $701af4dc93490956$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $701af4dc93490956$var$rsComboRange = $701af4dc93490956$var$rsComboMarksRange + $701af4dc93490956$var$reComboHalfMarksRange + $701af4dc93490956$var$rsComboSymbolsRange, $701af4dc93490956$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $701af4dc93490956$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $701af4dc93490956$var$reHasUnicode = RegExp('[' + $701af4dc93490956$var$rsZWJ + $701af4dc93490956$var$rsAstralRange + $701af4dc93490956$var$rsComboRange + $701af4dc93490956$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $701af4dc93490956$var$hasUnicode(string) {
    return $701af4dc93490956$var$reHasUnicode.test(string);
}
$701af4dc93490956$exports = $701af4dc93490956$var$hasUnicode;


var $24468d8aeca31329$exports = {};
var $becfcd21870edec9$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $becfcd21870edec9$var$asciiToArray(string) {
    return string.split('');
}
$becfcd21870edec9$exports = $becfcd21870edec9$var$asciiToArray;



var $a2742958f50cf1bd$exports = {};
/** Used to compose unicode character classes. */ var $a2742958f50cf1bd$var$rsAstralRange = '\\ud800-\\udfff', $a2742958f50cf1bd$var$rsComboMarksRange = '\\u0300-\\u036f', $a2742958f50cf1bd$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $a2742958f50cf1bd$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $a2742958f50cf1bd$var$rsComboRange = $a2742958f50cf1bd$var$rsComboMarksRange + $a2742958f50cf1bd$var$reComboHalfMarksRange + $a2742958f50cf1bd$var$rsComboSymbolsRange, $a2742958f50cf1bd$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $a2742958f50cf1bd$var$rsAstral = '[' + $a2742958f50cf1bd$var$rsAstralRange + ']', $a2742958f50cf1bd$var$rsCombo = '[' + $a2742958f50cf1bd$var$rsComboRange + ']', $a2742958f50cf1bd$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $a2742958f50cf1bd$var$rsModifier = '(?:' + $a2742958f50cf1bd$var$rsCombo + '|' + $a2742958f50cf1bd$var$rsFitz + ')', $a2742958f50cf1bd$var$rsNonAstral = '[^' + $a2742958f50cf1bd$var$rsAstralRange + ']', $a2742958f50cf1bd$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $a2742958f50cf1bd$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $a2742958f50cf1bd$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $a2742958f50cf1bd$var$reOptMod = $a2742958f50cf1bd$var$rsModifier + '?', $a2742958f50cf1bd$var$rsOptVar = '[' + $a2742958f50cf1bd$var$rsVarRange + ']?', $a2742958f50cf1bd$var$rsOptJoin = '(?:' + $a2742958f50cf1bd$var$rsZWJ + '(?:' + [
    $a2742958f50cf1bd$var$rsNonAstral,
    $a2742958f50cf1bd$var$rsRegional,
    $a2742958f50cf1bd$var$rsSurrPair
].join('|') + ')' + $a2742958f50cf1bd$var$rsOptVar + $a2742958f50cf1bd$var$reOptMod + ')*', $a2742958f50cf1bd$var$rsSeq = $a2742958f50cf1bd$var$rsOptVar + $a2742958f50cf1bd$var$reOptMod + $a2742958f50cf1bd$var$rsOptJoin, $a2742958f50cf1bd$var$rsSymbol = '(?:' + [
    $a2742958f50cf1bd$var$rsNonAstral + $a2742958f50cf1bd$var$rsCombo + '?',
    $a2742958f50cf1bd$var$rsCombo,
    $a2742958f50cf1bd$var$rsRegional,
    $a2742958f50cf1bd$var$rsSurrPair,
    $a2742958f50cf1bd$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $a2742958f50cf1bd$var$reUnicode = RegExp($a2742958f50cf1bd$var$rsFitz + '(?=' + $a2742958f50cf1bd$var$rsFitz + ')|' + $a2742958f50cf1bd$var$rsSymbol + $a2742958f50cf1bd$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $a2742958f50cf1bd$var$unicodeToArray(string) {
    return string.match($a2742958f50cf1bd$var$reUnicode) || [];
}
$a2742958f50cf1bd$exports = $a2742958f50cf1bd$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $24468d8aeca31329$var$stringToArray(string) {
    return $701af4dc93490956$exports(string) ? $a2742958f50cf1bd$exports(string) : $becfcd21870edec9$exports(string);
}
$24468d8aeca31329$exports = $24468d8aeca31329$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $52015c7e76a7283e$var$createCaseFirst(methodName) {
    return function(string) {
        string = $327b618d771fa8fb$exports(string);
        var strSymbols = $701af4dc93490956$exports(string) ? $24468d8aeca31329$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $d97989c675d13850$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$52015c7e76a7283e$exports = $52015c7e76a7283e$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $ecdaa70f26552d44$var$upperFirst = $52015c7e76a7283e$exports('toUpperCase');
$ecdaa70f26552d44$exports = $ecdaa70f26552d44$var$upperFirst;



var $74190bf599267a83$exports = {};

var $ed1ff1aa3924564c$exports = {};




var $fb6a6d013e57bf85$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $fb6a6d013e57bf85$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$fb6a6d013e57bf85$exports = $fb6a6d013e57bf85$var$baseSortBy;



var $1c17691a09b7ae13$exports = {};
var $570d8648a5afb883$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $570d8648a5afb883$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $b33d0ca91daaf047$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $b33d0ca91daaf047$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$570d8648a5afb883$exports = $570d8648a5afb883$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $1c17691a09b7ae13$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $570d8648a5afb883$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$1c17691a09b7ae13$exports = $1c17691a09b7ae13$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $ed1ff1aa3924564c$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $a49158a66fd855e6$exports(iteratees, function(iteratee) {
        if ($9ddb8a7a9343d289$exports(iteratee)) return function(value) {
            return $fb1d6919c9f99e63$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $d07a4b164653b961$exports
    ];
    var index = -1;
    iteratees = $a49158a66fd855e6$exports(iteratees, $d92a75ec01863059$exports($72536eccaddefa03$exports));
    var result = $b17261a3df4175d7$exports(collection, function(value, key, collection) {
        var criteria = $a49158a66fd855e6$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $fb6a6d013e57bf85$exports(result, function(object, other) {
        return $1c17691a09b7ae13$exports(object, other, orders);
    });
}
$ed1ff1aa3924564c$exports = $ed1ff1aa3924564c$var$baseOrderBy;


var $10dad2a6bce84ca4$exports = {};

var $0f3b232175b3f27b$exports = {};
var $e9d0a8ee65289976$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e9d0a8ee65289976$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$e9d0a8ee65289976$exports = $e9d0a8ee65289976$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $0f3b232175b3f27b$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $0f3b232175b3f27b$var$overRest(func, start, transform) {
    start = $0f3b232175b3f27b$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $0f3b232175b3f27b$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $e9d0a8ee65289976$exports(func, this, otherArgs);
    };
}
$0f3b232175b3f27b$exports = $0f3b232175b3f27b$var$overRest;


var $6190b1cb08ba9984$exports = {};
var $68e2ec20b0e4106a$exports = {};
var $0ebd54fab0f18371$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $0ebd54fab0f18371$var$constant(value) {
    return function() {
        return value;
    };
}
$0ebd54fab0f18371$exports = $0ebd54fab0f18371$var$constant;


var $72343bff8b826eca$exports = {};

var $72343bff8b826eca$var$defineProperty = function() {
    try {
        var func = $257e3b6443360c50$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$72343bff8b826eca$exports = $72343bff8b826eca$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $68e2ec20b0e4106a$var$baseSetToString = !$72343bff8b826eca$exports ? $d07a4b164653b961$exports : function(func, string) {
    return $72343bff8b826eca$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $0ebd54fab0f18371$exports(string),
        'writable': true
    });
};
$68e2ec20b0e4106a$exports = $68e2ec20b0e4106a$var$baseSetToString;


var $bdd573fbfd660c96$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $bdd573fbfd660c96$var$HOT_COUNT = 800, $bdd573fbfd660c96$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $bdd573fbfd660c96$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $bdd573fbfd660c96$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $bdd573fbfd660c96$var$nativeNow(), remaining = $bdd573fbfd660c96$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $bdd573fbfd660c96$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$bdd573fbfd660c96$exports = $bdd573fbfd660c96$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $6190b1cb08ba9984$var$setToString = $bdd573fbfd660c96$exports($68e2ec20b0e4106a$exports);
$6190b1cb08ba9984$exports = $6190b1cb08ba9984$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $10dad2a6bce84ca4$var$baseRest(func, start) {
    return $6190b1cb08ba9984$exports($0f3b232175b3f27b$exports(func, start, $d07a4b164653b961$exports), func + '');
}
$10dad2a6bce84ca4$exports = $10dad2a6bce84ca4$var$baseRest;


var $3c6bc6c2e4316f7b$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $3c6bc6c2e4316f7b$var$isIterateeCall(value, index, object) {
    if (!$6c66affe1256ad5a$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $27e5d73ea889a418$exports(object) && $a2de504b4d43ec68$exports(index, object.length) : type == 'string' && index in object) return $ad6123642c190612$exports(object[index], value);
    return false;
}
$3c6bc6c2e4316f7b$exports = $3c6bc6c2e4316f7b$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $74190bf599267a83$var$sortBy = $10dad2a6bce84ca4$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $3c6bc6c2e4316f7b$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $3c6bc6c2e4316f7b$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $ed1ff1aa3924564c$exports(collection, $8f1c770ea7af275c$exports(iteratees, 1), []);
});
$74190bf599267a83$exports = $74190bf599267a83$var$sortBy;


var $954a150ac6ea0fbd$exports = {};
(function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $954a150ac6ea0fbd$exports) $954a150ac6ea0fbd$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})($954a150ac6ea0fbd$exports);


function $d24b49ddfba28634$var$_toConsumableArray(arr) {
    return $d24b49ddfba28634$var$_arrayWithoutHoles(arr) || $d24b49ddfba28634$var$_iterableToArray(arr) || $d24b49ddfba28634$var$_unsupportedIterableToArray(arr) || $d24b49ddfba28634$var$_nonIterableSpread();
}
function $d24b49ddfba28634$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d24b49ddfba28634$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d24b49ddfba28634$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d24b49ddfba28634$var$_arrayLikeToArray(o, minLen);
}
function $d24b49ddfba28634$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $d24b49ddfba28634$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $d24b49ddfba28634$var$_arrayLikeToArray(arr);
}
function $d24b49ddfba28634$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $d24b49ddfba28634$var$identity = function identity(i) {
    return i;
};
var $d24b49ddfba28634$export$ca73b6d700d0505 = {
    '@@functional/placeholder': true
};
var $d24b49ddfba28634$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $d24b49ddfba28634$export$ca73b6d700d0505;
};
var $d24b49ddfba28634$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $d24b49ddfba28634$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $d24b49ddfba28634$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $d24b49ddfba28634$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $d24b49ddfba28634$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $d24b49ddfba28634$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $d24b49ddfba28634$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $d24b49ddfba28634$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $d24b49ddfba28634$export$c3095a23b368d1f2 = function curry(fn) {
    return $d24b49ddfba28634$var$curryN(fn.length, fn);
};
var $d24b49ddfba28634$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $d24b49ddfba28634$export$871de8747c9eaa88 = $d24b49ddfba28634$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $d24b49ddfba28634$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $d24b49ddfba28634$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $d24b49ddfba28634$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split('').reverse.join('');
};
var $d24b49ddfba28634$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $bd93ad4b40d0c77a$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $bd93ad4b40d0c77a$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $bd93ad4b40d0c77a$var$interpolateNumber = (0, $d24b49ddfba28634$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $bd93ad4b40d0c77a$var$uninterpolateNumber = (0, $d24b49ddfba28634$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $bd93ad4b40d0c77a$var$uninterpolateTruncation = (0, $d24b49ddfba28634$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $bd93ad4b40d0c77a$export$2e2bcd8739ae039 = {
    rangeStep: $bd93ad4b40d0c77a$var$rangeStep,
    getDigitCount: $bd93ad4b40d0c77a$var$getDigitCount,
    interpolateNumber: $bd93ad4b40d0c77a$var$interpolateNumber,
    uninterpolateNumber: $bd93ad4b40d0c77a$var$uninterpolateNumber,
    uninterpolateTruncation: $bd93ad4b40d0c77a$var$uninterpolateTruncation
};


function $b32144b87431814d$var$_toConsumableArray(arr) {
    return $b32144b87431814d$var$_arrayWithoutHoles(arr) || $b32144b87431814d$var$_iterableToArray(arr) || $b32144b87431814d$var$_unsupportedIterableToArray(arr) || $b32144b87431814d$var$_nonIterableSpread();
}
function $b32144b87431814d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b32144b87431814d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $b32144b87431814d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b32144b87431814d$var$_arrayLikeToArray(arr);
}
function $b32144b87431814d$var$_slicedToArray(arr, i) {
    return $b32144b87431814d$var$_arrayWithHoles(arr) || $b32144b87431814d$var$_iterableToArrayLimit(arr, i) || $b32144b87431814d$var$_unsupportedIterableToArray(arr, i) || $b32144b87431814d$var$_nonIterableRest();
}
function $b32144b87431814d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b32144b87431814d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b32144b87431814d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b32144b87431814d$var$_arrayLikeToArray(o, minLen);
}
function $b32144b87431814d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b32144b87431814d$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b32144b87431814d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $b32144b87431814d$var$getValidInterval(_ref) {
    var _ref2 = $b32144b87431814d$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $b32144b87431814d$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(0);
    var digitCount = (0, $bd93ad4b40d0c77a$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $b32144b87431814d$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(10).pow((0, $bd93ad4b40d0c77a$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $d24b49ddfba28634$export$f672e0b6f7222cd7)((0, $d24b49ddfba28634$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $d24b49ddfba28634$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $b32144b87431814d$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $b32144b87431814d$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $b32144b87431814d$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $b32144b87431814d$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $b32144b87431814d$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $b32144b87431814d$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $b32144b87431814d$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($b32144b87431814d$var$_toConsumableArray((0, $d24b49ddfba28634$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($b32144b87431814d$var$_toConsumableArray((0, $d24b49ddfba28634$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $d24b49ddfba28634$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $b32144b87431814d$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $b32144b87431814d$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $bd93ad4b40d0c77a$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $d24b49ddfba28634$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $b32144b87431814d$var$getTickValuesFn(_ref5) {
    var _ref6 = $b32144b87431814d$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $b32144b87431814d$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $b32144b87431814d$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $b32144b87431814d$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $b32144b87431814d$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $d24b49ddfba28634$export$f672e0b6f7222cd7)((0, $d24b49ddfba28634$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(n).mul(step)).toNumber();
    }), (0, $d24b49ddfba28634$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $d24b49ddfba28634$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $b32144b87431814d$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $b32144b87431814d$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $b32144b87431814d$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $b32144b87431814d$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $b32144b87431814d$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($b32144b87431814d$var$_toConsumableArray((0, $bd93ad4b40d0c77a$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($954a150ac6ea0fbd$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $d24b49ddfba28634$export$66c1ae025e96b4bc)(values) : values;
}
var $b32144b87431814d$export$b84e75ccbfe6a612 = (0, $d24b49ddfba28634$export$fc10aeed3a532e2a)($b32144b87431814d$var$getNiceTickValuesFn);
var $b32144b87431814d$export$4cc7a216492b1f53 = (0, $d24b49ddfba28634$export$fc10aeed3a532e2a)($b32144b87431814d$var$getTickValuesFn);
var $b32144b87431814d$export$e9d28da780436e98 = (0, $d24b49ddfba28634$export$fc10aeed3a532e2a)($b32144b87431814d$var$getTickValuesFixedDomainFn);








var $gIfym = parcelRequire("gIfym");

var $gIfym = parcelRequire("gIfym");


/* eslint no-console: 0 */ var $0eb6b0656d09fb9a$var$isDev = false;
var $0eb6b0656d09fb9a$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($0eb6b0656d09fb9a$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



var $gIfym = parcelRequire("gIfym");


var $6e8d54bdf0351ed1$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $6e8d54bdf0351ed1$var$_extends() {
    $6e8d54bdf0351ed1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6e8d54bdf0351ed1$var$_extends.apply(this, arguments);
}
function $6e8d54bdf0351ed1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6e8d54bdf0351ed1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6e8d54bdf0351ed1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6e8d54bdf0351ed1$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = $6e8d54bdf0351ed1$var$_objectWithoutProperties(props, $6e8d54bdf0351ed1$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-surface', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("svg", $6e8d54bdf0351ed1$var$_extends({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(others, true, 'svg'), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("desc", null, desc), children);
}



var $gIfym = parcelRequire("gIfym");




function $2c7308af7c49eae7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2c7308af7c49eae7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2c7308af7c49eae7$var$_typeof(o);
}
var $2c7308af7c49eae7$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $2c7308af7c49eae7$var$_extends() {
    $2c7308af7c49eae7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2c7308af7c49eae7$var$_extends.apply(this, arguments);
}
function $2c7308af7c49eae7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2c7308af7c49eae7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2c7308af7c49eae7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2c7308af7c49eae7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2c7308af7c49eae7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2c7308af7c49eae7$var$_defineProperty(obj, key, value) {
    key = $2c7308af7c49eae7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2c7308af7c49eae7$var$_toPropertyKey(t) {
    var i = $2c7308af7c49eae7$var$_toPrimitive(t, "string");
    return "symbol" == $2c7308af7c49eae7$var$_typeof(i) ? i : i + "";
}
function $2c7308af7c49eae7$var$_toPrimitive(t, r) {
    if ("object" != $2c7308af7c49eae7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2c7308af7c49eae7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2c7308af7c49eae7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2c7308af7c49eae7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2c7308af7c49eae7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2c7308af7c49eae7$var$symbolFactories = {
    symbolCircle: (0, $b8df57eaf33776d8$exports.symbolCircle),
    symbolCross: (0, $b8df57eaf33776d8$exports.symbolCross),
    symbolDiamond: (0, $b8df57eaf33776d8$exports.symbolDiamond),
    symbolSquare: (0, $b8df57eaf33776d8$exports.symbolSquare),
    symbolStar: (0, $b8df57eaf33776d8$exports.symbolStar),
    symbolTriangle: (0, $b8df57eaf33776d8$exports.symbolTriangle),
    symbolWye: (0, $b8df57eaf33776d8$exports.symbolWye)
};
var $2c7308af7c49eae7$var$RADIAN = Math.PI / 180;
var $2c7308af7c49eae7$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($ecdaa70f26552d44$exports)))(type));
    return $2c7308af7c49eae7$var$symbolFactories[name] || (0, $b8df57eaf33776d8$exports.symbolCircle);
};
var $2c7308af7c49eae7$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * $2c7308af7c49eae7$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $2c7308af7c49eae7$var$registerSymbol = function registerSymbol(key, factory) {
    $2c7308af7c49eae7$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($ecdaa70f26552d44$exports)))(key))] = factory;
};
var $2c7308af7c49eae7$export$fa456266707bf4e4 = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'circle' : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? 'area' : _ref$sizeType, rest = $2c7308af7c49eae7$var$_objectWithoutProperties(_ref, $2c7308af7c49eae7$var$_excluded);
    var props = $2c7308af7c49eae7$var$_objectSpread($2c7308af7c49eae7$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = $2c7308af7c49eae7$var$getSymbolFactory(type);
        var symbol = (0, $b8df57eaf33776d8$exports.symbol)().type(symbolFactory).size($2c7308af7c49eae7$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, $49516a074167c4be$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", $2c7308af7c49eae7$var$_extends({}, filteredProps, {
        className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$2c7308af7c49eae7$export$fa456266707bf4e4.registerSymbol = $2c7308af7c49eae7$var$registerSymbol;



function $783c5e1b345d303c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $783c5e1b345d303c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $783c5e1b345d303c$var$_typeof(o);
}
function $783c5e1b345d303c$var$_extends() {
    $783c5e1b345d303c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $783c5e1b345d303c$var$_extends.apply(this, arguments);
}
function $783c5e1b345d303c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $783c5e1b345d303c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $783c5e1b345d303c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $783c5e1b345d303c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $783c5e1b345d303c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $783c5e1b345d303c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $783c5e1b345d303c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $783c5e1b345d303c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $783c5e1b345d303c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $783c5e1b345d303c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $783c5e1b345d303c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $783c5e1b345d303c$var$_callSuper(t, o, e) {
    return o = $783c5e1b345d303c$var$_getPrototypeOf(o), $783c5e1b345d303c$var$_possibleConstructorReturn(t, $783c5e1b345d303c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $783c5e1b345d303c$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $783c5e1b345d303c$var$_possibleConstructorReturn(self, call) {
    if (call && ($783c5e1b345d303c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $783c5e1b345d303c$var$_assertThisInitialized(self);
}
function $783c5e1b345d303c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $783c5e1b345d303c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($783c5e1b345d303c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $783c5e1b345d303c$var$_getPrototypeOf(o) {
    $783c5e1b345d303c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $783c5e1b345d303c$var$_getPrototypeOf(o);
}
function $783c5e1b345d303c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $783c5e1b345d303c$var$_setPrototypeOf(subClass, superClass);
}
function $783c5e1b345d303c$var$_setPrototypeOf(o, p) {
    $783c5e1b345d303c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $783c5e1b345d303c$var$_setPrototypeOf(o, p);
}
function $783c5e1b345d303c$var$_defineProperty(obj, key, value) {
    key = $783c5e1b345d303c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $783c5e1b345d303c$var$_toPropertyKey(t) {
    var i = $783c5e1b345d303c$var$_toPrimitive(t, "string");
    return "symbol" == $783c5e1b345d303c$var$_typeof(i) ? i : i + "";
}
function $783c5e1b345d303c$var$_toPrimitive(t, r) {
    if ("object" != $783c5e1b345d303c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $783c5e1b345d303c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $783c5e1b345d303c$var$SIZE = 32;
var $783c5e1b345d303c$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    function DefaultLegendContent() {
        $783c5e1b345d303c$var$_classCallCheck(this, DefaultLegendContent);
        return $783c5e1b345d303c$var$_callSuper(this, DefaultLegendContent, arguments);
    }
    $783c5e1b345d303c$var$_inherits(DefaultLegendContent, _PureComponent);
    return $783c5e1b345d303c$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $783c5e1b345d303c$var$SIZE / 2;
                var sixthSize = $783c5e1b345d303c$var$SIZE / 6;
                var thirdSize = $783c5e1b345d303c$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === 'plainline') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $783c5e1b345d303c$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === 'line') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($783c5e1b345d303c$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === 'rect') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($783c5e1b345d303c$var$SIZE / 8, "h").concat($783c5e1b345d303c$var$SIZE, "v").concat($783c5e1b345d303c$var$SIZE * 3 / 4, "h").concat(-$783c5e1b345d303c$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(data.legendIcon)) {
                    var iconProps = $783c5e1b345d303c$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $2c7308af7c49eae7$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $783c5e1b345d303c$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $783c5e1b345d303c$var$SIZE,
                    height: $783c5e1b345d303c$var$SIZE
                };
                var itemStyle = {
                    display: layout === 'horizontal' ? 'inline-block' : 'block',
                    marginRight: 10
                };
                var svgStyle = {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)($783c5e1b345d303c$var$_defineProperty($783c5e1b345d303c$var$_defineProperty({
                        'recharts-legend-item': true
                    }, "legend-item-".concat(i), true), "inactive", entry.inactive));
                    if (entry.type === 'none') return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(entry.value) ? entry.value : null;
                    (0, $0eb6b0656d09fb9a$export$c106dd0671a0fc2d)(!(0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(entry.value), "The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name=\"Name of my Data\"/>" // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("li", $783c5e1b345d303c$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, $e49003a65b792e53$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $6e8d54bdf0351ed1$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === 'horizontal' ? align : 'left'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
}((0, $gIfym.PureComponent));
$783c5e1b345d303c$var$_defineProperty($783c5e1b345d303c$export$99f8d96ed0cededa, "displayName", 'Legend');
$783c5e1b345d303c$var$_defineProperty($783c5e1b345d303c$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'middle',
    inactiveColor: '#ccc'
});



var $cdd9b4fb8ce2e23b$exports = {};

var $f54ad29b7c5f49f4$exports = {};

var $e265fe8cc912e0cc$exports = {};
var $c3d238890cf58b86$exports = {};
var $473b8469d73623c0$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $473b8469d73623c0$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$473b8469d73623c0$exports = $473b8469d73623c0$var$baseFindIndex;


var $6514f2a8838c805c$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $6514f2a8838c805c$var$baseIsNaN(value) {
    return value !== value;
}
$6514f2a8838c805c$exports = $6514f2a8838c805c$var$baseIsNaN;


var $a376ad1a10771591$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a376ad1a10771591$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$a376ad1a10771591$exports = $a376ad1a10771591$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $c3d238890cf58b86$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $a376ad1a10771591$exports(array, value, fromIndex) : $473b8469d73623c0$exports(array, $6514f2a8838c805c$exports, fromIndex);
}
$c3d238890cf58b86$exports = $c3d238890cf58b86$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $e265fe8cc912e0cc$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $c3d238890cf58b86$exports(array, value, 0) > -1;
}
$e265fe8cc912e0cc$exports = $e265fe8cc912e0cc$var$arrayIncludes;


var $531a7e3e529791b1$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $531a7e3e529791b1$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$531a7e3e529791b1$exports = $531a7e3e529791b1$var$arrayIncludesWith;



var $769a7f9dccd217f4$exports = {};

var $f3c3ea86d3a2a8da$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $f3c3ea86d3a2a8da$var$noop() {
// No operation performed.
}
$f3c3ea86d3a2a8da$exports = $f3c3ea86d3a2a8da$var$noop;



/** Used as references for various `Number` constants. */ var $769a7f9dccd217f4$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $769a7f9dccd217f4$var$createSet = !($d29ac6e1c214c2cf$exports && 1 / $fca0d725dad9084d$exports(new $d29ac6e1c214c2cf$exports([
    ,
    -0
]))[1] == $769a7f9dccd217f4$var$INFINITY) ? $f3c3ea86d3a2a8da$exports : function(values) {
    return new $d29ac6e1c214c2cf$exports(values);
};
$769a7f9dccd217f4$exports = $769a7f9dccd217f4$var$createSet;



/** Used as the size to enable large array optimizations. */ var $f54ad29b7c5f49f4$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $f54ad29b7c5f49f4$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $e265fe8cc912e0cc$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $531a7e3e529791b1$exports;
    } else if (length >= $f54ad29b7c5f49f4$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $769a7f9dccd217f4$exports(array);
        if (set) return $fca0d725dad9084d$exports(set);
        isCommon = false;
        includes = $eee8606129ee6d5d$exports;
        seen = new $2ca059bfc0fc507a$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$f54ad29b7c5f49f4$exports = $f54ad29b7c5f49f4$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $cdd9b4fb8ce2e23b$var$uniqBy(array, iteratee) {
    return array && array.length ? $f54ad29b7c5f49f4$exports(array, $72536eccaddefa03$exports(iteratee, 2)) : [];
}
$cdd9b4fb8ce2e23b$exports = $cdd9b4fb8ce2e23b$var$uniqBy;



function $8aec891402d43cc9$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($cdd9b4fb8ce2e23b$exports)))(payload, defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($cdd9b4fb8ce2e23b$exports)))(payload, option);
    return payload;
}


function $61f751c849868bc2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $61f751c849868bc2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $61f751c849868bc2$var$_typeof(o);
}
var $61f751c849868bc2$var$_excluded = [
    "ref"
];
function $61f751c849868bc2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $61f751c849868bc2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $61f751c849868bc2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $61f751c849868bc2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $61f751c849868bc2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $61f751c849868bc2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $61f751c849868bc2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $61f751c849868bc2$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $61f751c849868bc2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $61f751c849868bc2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $61f751c849868bc2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $61f751c849868bc2$var$_callSuper(t, o, e) {
    return o = $61f751c849868bc2$var$_getPrototypeOf(o), $61f751c849868bc2$var$_possibleConstructorReturn(t, $61f751c849868bc2$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $61f751c849868bc2$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $61f751c849868bc2$var$_possibleConstructorReturn(self, call) {
    if (call && ($61f751c849868bc2$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $61f751c849868bc2$var$_assertThisInitialized(self);
}
function $61f751c849868bc2$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $61f751c849868bc2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($61f751c849868bc2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $61f751c849868bc2$var$_getPrototypeOf(o) {
    $61f751c849868bc2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $61f751c849868bc2$var$_getPrototypeOf(o);
}
function $61f751c849868bc2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $61f751c849868bc2$var$_setPrototypeOf(subClass, superClass);
}
function $61f751c849868bc2$var$_setPrototypeOf(o, p) {
    $61f751c849868bc2$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $61f751c849868bc2$var$_setPrototypeOf(o, p);
}
function $61f751c849868bc2$var$_defineProperty(obj, key, value) {
    key = $61f751c849868bc2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $61f751c849868bc2$var$_toPropertyKey(t) {
    var i = $61f751c849868bc2$var$_toPrimitive(t, "string");
    return "symbol" == $61f751c849868bc2$var$_typeof(i) ? i : i + "";
}
function $61f751c849868bc2$var$_toPrimitive(t, r) {
    if ("object" != $61f751c849868bc2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $61f751c849868bc2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $61f751c849868bc2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $61f751c849868bc2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $61f751c849868bc2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $61f751c849868bc2$var$defaultUniqBy(entry) {
    return entry.value;
}
function $61f751c849868bc2$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(content, props);
    var ref = props.ref, otherProps = $61f751c849868bc2$var$_objectWithoutProperties(props, $61f751c849868bc2$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $783c5e1b345d303c$export$99f8d96ed0cededa), otherProps);
}
var $61f751c849868bc2$var$EPS = 1;
var $61f751c849868bc2$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    function Legend() {
        var _this;
        $61f751c849868bc2$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $61f751c849868bc2$var$_callSuper(this, Legend, [].concat(args));
        $61f751c849868bc2$var$_defineProperty(_this, "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    $61f751c849868bc2$var$_inherits(Legend, _PureComponent);
    return $61f751c849868bc2$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    box.height = this.wrapperNode.offsetHeight;
                    box.width = this.wrapperNode.offsetWidth;
                    return box;
                }
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                var box = this.getBBox();
                if (box) {
                    if (Math.abs(box.width - this.lastBoundingBox.width) > $61f751c849868bc2$var$EPS || Math.abs(box.height - this.lastBoundingBox.height) > $61f751c849868bc2$var$EPS) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                        if (onBBoxUpdate) onBBoxUpdate(box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return $61f751c849868bc2$var$_objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === 'center' && layout === 'vertical') {
                        var box = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - box.width) / 2
                        };
                    } else hPos = align === 'right' ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === 'middle') {
                        var _box = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box.height) / 2
                        };
                    } else vPos = verticalAlign === 'bottom' ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $61f751c849868bc2$var$_objectSpread($61f751c849868bc2$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $61f751c849868bc2$var$_objectSpread($61f751c849868bc2$var$_objectSpread({
                    position: 'absolute',
                    width: width || 'auto',
                    height: height || 'auto'
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $61f751c849868bc2$var$renderContent(content, $61f751c849868bc2$var$_objectSpread($61f751c849868bc2$var$_objectSpread({}, this.props), {}, {
                    payload: (0, $8aec891402d43cc9$export$b67e33c2fb1535fa)(payload, payloadUniqBy, $61f751c849868bc2$var$defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var _this$defaultProps$it = $61f751c849868bc2$var$_objectSpread($61f751c849868bc2$var$_objectSpread({}, this.defaultProps), item.props), layout = _this$defaultProps$it.layout;
                if (layout === 'vertical' && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === 'horizontal') return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
}((0, $gIfym.PureComponent));
$61f751c849868bc2$var$_defineProperty($61f751c849868bc2$export$ed247974535929c7, "displayName", 'Legend');
$61f751c849868bc2$var$_defineProperty($61f751c849868bc2$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom'
});




function $d7115b802e1208ae$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d7115b802e1208ae$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d7115b802e1208ae$var$_typeof(o);
}
function $d7115b802e1208ae$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d7115b802e1208ae$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d7115b802e1208ae$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d7115b802e1208ae$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d7115b802e1208ae$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d7115b802e1208ae$var$_defineProperty(obj, key, value) {
    key = $d7115b802e1208ae$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d7115b802e1208ae$var$_toPropertyKey(t) {
    var i = $d7115b802e1208ae$var$_toPrimitive(t, "string");
    return "symbol" == $d7115b802e1208ae$var$_typeof(i) ? i : i + "";
}
function $d7115b802e1208ae$var$_toPrimitive(t, r) {
    if ("object" != $d7115b802e1208ae$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d7115b802e1208ae$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d7115b802e1208ae$export$8f9424d123c36aa = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, $49516a074167c4be$export$64c61536a2b72e0f)(children, (0, $61f751c849868bc2$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendDefaultProps = (0, $61f751c849868bc2$export$ed247974535929c7).defaultProps;
    var legendProps = legendDefaultProps !== undefined ? $d7115b802e1208ae$var$_objectSpread($d7115b802e1208ae$var$_objectSpread({}, legendDefaultProps), legendItem.props) : {};
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === 'children') legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var itemDefaultProps = item.type.defaultProps;
        var itemProps = itemDefaultProps !== undefined ? $d7115b802e1208ae$var$_objectSpread($d7115b802e1208ae$var$_objectSpread({}, itemDefaultProps), item.props) : {};
        var dataKey = itemProps.dataKey, name = itemProps.name, legendType = itemProps.legendType, hide = itemProps.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendProps.iconType || legendType || 'square',
            color: (0, $2cf058a100d782d5$export$ec6cab5a7a3b93bf)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: itemProps
        };
    });
    return $d7115b802e1208ae$var$_objectSpread($d7115b802e1208ae$var$_objectSpread($d7115b802e1208ae$var$_objectSpread({}, legendProps), (0, $61f751c849868bc2$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};


function $2cf058a100d782d5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2cf058a100d782d5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2cf058a100d782d5$var$_typeof(o);
}
function $2cf058a100d782d5$var$_toConsumableArray(arr) {
    return $2cf058a100d782d5$var$_arrayWithoutHoles(arr) || $2cf058a100d782d5$var$_iterableToArray(arr) || $2cf058a100d782d5$var$_unsupportedIterableToArray(arr) || $2cf058a100d782d5$var$_nonIterableSpread();
}
function $2cf058a100d782d5$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2cf058a100d782d5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2cf058a100d782d5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2cf058a100d782d5$var$_arrayLikeToArray(o, minLen);
}
function $2cf058a100d782d5$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $2cf058a100d782d5$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $2cf058a100d782d5$var$_arrayLikeToArray(arr);
}
function $2cf058a100d782d5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2cf058a100d782d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2cf058a100d782d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2cf058a100d782d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2cf058a100d782d5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2cf058a100d782d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2cf058a100d782d5$var$_defineProperty(obj, key, value) {
    key = $2cf058a100d782d5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2cf058a100d782d5$var$_toPropertyKey(t) {
    var i = $2cf058a100d782d5$var$_toPrimitive(t, "string");
    return "symbol" == $2cf058a100d782d5$var$_typeof(i) ? i : i + "";
}
function $2cf058a100d782d5$var$_toPrimitive(t, r) {
    if ("object" != $2cf058a100d782d5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2cf058a100d782d5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2cf058a100d782d5$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(dataKey)) return defaultValue;
    if ((0, $938aefa455a73c9b$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($acb894cf4c1e4223$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $2cf058a100d782d5$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($d0a106317e83b276$exports)))(data, function(entry) {
        return $2cf058a100d782d5$export$f97fc4a450f29a(entry, key);
    });
    if (type === 'number') {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, $938aefa455a73c9b$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($a04633b4899e9c73$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($1ba6bac3ec83ed90$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, $938aefa455a73c9b$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : '';
    });
}
var $2cf058a100d782d5$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $938aefa455a73c9b$export$9d334328eb75e624)(cur - before) !== (0, $938aefa455a73c9b$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $938aefa455a73c9b$export$9d334328eb75e624)(after - cur) === (0, $938aefa455a73c9b$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $2cf058a100d782d5$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _item$type;
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var defaultedProps = (_item$type = item.type) !== null && _item$type !== void 0 && _item$type.defaultProps ? $2cf058a100d782d5$var$_objectSpread($2cf058a100d782d5$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stroke = defaultedProps.stroke, fill = defaultedProps.fill;
    var result;
    switch(displayName){
        case 'Line':
            result = stroke;
            break;
        case 'Area':
        case 'Radar':
            result = stroke && stroke !== 'none' ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $2cf058a100d782d5$export$570d306bee26c748 = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $49516a074167c4be$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            });
            if (barItems && barItems.length) {
                var barItemDefaultProps = barItems[0].type.defaultProps;
                var barItemProps = barItemDefaultProps !== undefined ? $2cf058a100d782d5$var$_objectSpread($2cf058a100d782d5$var$_objectSpread({}, barItemDefaultProps), barItems[0].props) : barItems[0].props;
                var selfSize = barItemProps.barSize;
                var cateId = barItemProps[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                var barSize = (0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(selfSize) ? globalSize : selfSize;
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(barSize) ? undefined : (0, $938aefa455a73c9b$export$476354dbf49bdff6)(barSize, totalSize, 0)
                });
            }
        }
    }
    return result;
};
var $2cf058a100d782d5$export$d36834ecd87f906b = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $938aefa455a73c9b$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat($2cf058a100d782d5$var$_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $938aefa455a73c9b$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($2cf058a100d782d5$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var $2cf058a100d782d5$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, $d7115b802e1208ae$export$8f9424d123c36aa)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(offset[align])) return $2cf058a100d782d5$var$_objectSpread($2cf058a100d782d5$var$_objectSpread({}, offset), {}, $2cf058a100d782d5$var$_defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(offset[verticalAlign])) return $2cf058a100d782d5$var$_objectSpread($2cf058a100d782d5$var$_objectSpread({}, offset), {}, $2cf058a100d782d5$var$_defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var $2cf058a100d782d5$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(axisType)) return true;
    if (layout === 'horizontal') return axisType === 'yAxis';
    if (layout === 'vertical') return axisType === 'xAxis';
    if (direction === 'x') return axisType === 'xAxis';
    if (direction === 'y') return axisType === 'yAxis';
    return true;
};
var $2cf058a100d782d5$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $49516a074167c4be$export$fdd5e64c0e8495bb)(children, (0, $d7f00f77e606798b$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $2cf058a100d782d5$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $2cf058a100d782d5$export$f97fc4a450f29a(entry, dataKey);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(entryValue)) return result;
            var mainValue = Array.isArray(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($a04633b4899e9c73$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($1ba6bac3ec83ed90$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $2cf058a100d782d5$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $2cf058a100d782d5$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $2cf058a100d782d5$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $2cf058a100d782d5$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === 'number' && dataKey) return $2cf058a100d782d5$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $2cf058a100d782d5$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $2cf058a100d782d5$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === 'number') // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $2cf058a100d782d5$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
var $2cf058a100d782d5$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $2cf058a100d782d5$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $938aefa455a73c9b$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($5da66dc27836751e$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var $2cf058a100d782d5$var$handlerWeakMap = new WeakMap();
var $2cf058a100d782d5$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== 'function') return defaultHandler;
    if (!$2cf058a100d782d5$var$handlerWeakMap.has(defaultHandler)) $2cf058a100d782d5$var$handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = $2cf058a100d782d5$var$handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var $2cf058a100d782d5$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return {
            scale: $391ea09682974c37$exports.scaleBand(),
            realScaleType: 'band'
        };
        if (layout === 'radial' && axisType === 'angleAxis') return {
            scale: $391ea09682974c37$exports.scaleLinear(),
            realScaleType: 'linear'
        };
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return {
            scale: $391ea09682974c37$exports.scalePoint(),
            realScaleType: 'point'
        };
        if (type === 'category') return {
            scale: $391ea09682974c37$exports.scaleBand(),
            realScaleType: 'band'
        };
        return {
            scale: $391ea09682974c37$exports.scaleLinear(),
            realScaleType: 'linear'
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($fde8137f9fa467a7$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($ecdaa70f26552d44$exports)))(scale));
        return {
            scale: ($391ea09682974c37$exports[name] || $391ea09682974c37$exports.scalePoint)(),
            realScaleType: $391ea09682974c37$exports[name] ? name : 'point'
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $391ea09682974c37$exports.scalePoint(),
        realScaleType: 'point'
    };
};
var $2cf058a100d782d5$var$EPS = 1e-4;
var $2cf058a100d782d5$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $2cf058a100d782d5$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $2cf058a100d782d5$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $2cf058a100d782d5$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $2cf058a100d782d5$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(domain[0]) || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $938aefa455a73c9b$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $938aefa455a73c9b$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $2cf058a100d782d5$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($5da66dc27836751e$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var $2cf058a100d782d5$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($5da66dc27836751e$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $2cf058a100d782d5$var$STACK_OFFSET_MAP = {
    sign: $2cf058a100d782d5$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $b8df57eaf33776d8$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $b8df57eaf33776d8$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $b8df57eaf33776d8$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $b8df57eaf33776d8$exports.stackOffsetWiggle),
    positive: $2cf058a100d782d5$export$9f2c6ead70935022
};
var $2cf058a100d782d5$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = $2cf058a100d782d5$var$STACK_OFFSET_MAP[offsetType];
    var stack = (0, $b8df57eaf33776d8$exports.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +$2cf058a100d782d5$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $b8df57eaf33776d8$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var $2cf058a100d782d5$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$type2;
        var defaultedProps = (_item$type2 = item.type) !== null && _item$type2 !== void 0 && _item$type2.defaultProps ? $2cf058a100d782d5$var$_objectSpread($2cf058a100d782d5$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
        var stackId = defaultedProps.stackId, hide = defaultedProps.hide;
        if (hide) return result;
        var axisId = defaultedProps[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $938aefa455a73c9b$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $938aefa455a73c9b$export$8b15d37bc3f197d4)('_stackId_')] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $2cf058a100d782d5$var$_objectSpread($2cf058a100d782d5$var$_objectSpread({}, result), {}, $2cf058a100d782d5$var$_defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return $2cf058a100d782d5$var$_objectSpread($2cf058a100d782d5$var$_objectSpread({}, res), {}, $2cf058a100d782d5$var$_defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: $2cf058a100d782d5$export$c2170542cfc0177c(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return $2cf058a100d782d5$var$_objectSpread($2cf058a100d782d5$var$_objectSpread({}, result), {}, $2cf058a100d782d5$var$_defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var $2cf058a100d782d5$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== 'auto' && scaleType !== 'linear') return null;
    if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $b32144b87431814d$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($a04633b4899e9c73$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($1ba6bac3ec83ed90$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === 'number') {
        var _domain = scale.domain();
        var _tickValues = (0, $b32144b87431814d$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
function $2cf058a100d782d5$export$6e87f3defb83c3f(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, $938aefa455a73c9b$export$66950d3869f5cc67)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $2cf058a100d782d5$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(value) ? axis.scale(value) : null;
}
var $2cf058a100d782d5$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $2cf058a100d782d5$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $2cf058a100d782d5$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $2cf058a100d782d5$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var _item$type3;
    var defaultedProps = (_item$type3 = item.type) !== null && _item$type3 !== void 0 && _item$type3.defaultProps ? $2cf058a100d782d5$var$_objectSpread($2cf058a100d782d5$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stackId = defaultedProps.stackId;
    if ((0, $938aefa455a73c9b$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $2cf058a100d782d5$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($a04633b4899e9c73$exports)))(entry.concat([
                result[0]
            ]).filter((0, $938aefa455a73c9b$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($1ba6bac3ec83ed90$exports)))(entry.concat([
                result[1]
            ]).filter((0, $938aefa455a73c9b$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $2cf058a100d782d5$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $2cf058a100d782d5$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $2cf058a100d782d5$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $2cf058a100d782d5$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $2cf058a100d782d5$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $938aefa455a73c9b$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($2cf058a100d782d5$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$2cf058a100d782d5$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $938aefa455a73c9b$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($2cf058a100d782d5$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$2cf058a100d782d5$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $2cf058a100d782d5$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($74190bf599267a83$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $2cf058a100d782d5$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f0e839acff22663e$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($acb894cf4c1e4223$exports)))(axisChild, 'type.defaultProps.domain'))) return calculatedDomain;
    return specifiedDomain;
};
var $2cf058a100d782d5$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var defaultedProps = graphicalItem.type.defaultProps ? $2cf058a100d782d5$var$_objectSpread($2cf058a100d782d5$var$_objectSpread({}, graphicalItem.type.defaultProps), graphicalItem.props) : graphicalItem.props;
    var dataKey = defaultedProps.dataKey, name = defaultedProps.name, unit = defaultedProps.unit, formatter = defaultedProps.formatter, tooltipType = defaultedProps.tooltipType, chartType = defaultedProps.chartType, hide = defaultedProps.hide;
    return $2cf058a100d782d5$var$_objectSpread($2cf058a100d782d5$var$_objectSpread({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(graphicalItem, false)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $2cf058a100d782d5$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $2cf058a100d782d5$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType,
        hide: hide
    });
};


function $b592c97d860421c4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b592c97d860421c4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b592c97d860421c4$var$_typeof(o);
}
function $b592c97d860421c4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b592c97d860421c4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b592c97d860421c4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b592c97d860421c4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b592c97d860421c4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b592c97d860421c4$var$_defineProperty(obj, key, value) {
    key = $b592c97d860421c4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b592c97d860421c4$var$_toPropertyKey(t) {
    var i = $b592c97d860421c4$var$_toPrimitive(t, "string");
    return "symbol" == $b592c97d860421c4$var$_typeof(i) ? i : i + "";
}
function $b592c97d860421c4$var$_toPrimitive(t, r) {
    if ("object" != $b592c97d860421c4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b592c97d860421c4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b592c97d860421c4$var$_slicedToArray(arr, i) {
    return $b592c97d860421c4$var$_arrayWithHoles(arr) || $b592c97d860421c4$var$_iterableToArrayLimit(arr, i) || $b592c97d860421c4$var$_unsupportedIterableToArray(arr, i) || $b592c97d860421c4$var$_nonIterableRest();
}
function $b592c97d860421c4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b592c97d860421c4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b592c97d860421c4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b592c97d860421c4$var$_arrayLikeToArray(o, minLen);
}
function $b592c97d860421c4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b592c97d860421c4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b592c97d860421c4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $b592c97d860421c4$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $b592c97d860421c4$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $b592c97d860421c4$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $b592c97d860421c4$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$b592c97d860421c4$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$b592c97d860421c4$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $b592c97d860421c4$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $b592c97d860421c4$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $938aefa455a73c9b$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $938aefa455a73c9b$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $b592c97d860421c4$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $938aefa455a73c9b$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $938aefa455a73c9b$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(axis.range)) {
            if (axisType === 'angleAxis') range = [
                startAngle,
                endAngle
            ];
            else if (axisType === 'radiusAxis') range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $b592c97d860421c4$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $2cf058a100d782d5$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $2cf058a100d782d5$export$9d80152e23bae434)(scale);
        var ticks = (0, $2cf058a100d782d5$export$ac086aaa4358d590)(scale, $b592c97d860421c4$var$_objectSpread($b592c97d860421c4$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $b592c97d860421c4$var$_objectSpread($b592c97d860421c4$var$_objectSpread($b592c97d860421c4$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $b592c97d860421c4$var$_objectSpread($b592c97d860421c4$var$_objectSpread({}, result), {}, $b592c97d860421c4$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $b592c97d860421c4$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $b592c97d860421c4$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $b592c97d860421c4$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $b592c97d860421c4$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $b592c97d860421c4$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $b592c97d860421c4$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $b592c97d860421c4$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $b592c97d860421c4$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $b592c97d860421c4$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $b592c97d860421c4$var$_objectSpread($b592c97d860421c4$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $b592c97d860421c4$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};
var $b592c97d860421c4$export$88d525dabc04abcd = function getTickClassName(tick) {
    return !/*#__PURE__*/ (0, $gIfym.isValidElement)(tick) && !(0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(tick) && typeof tick !== 'boolean' ? tick.className : '';
};


function $0e68a54aec8ebf8f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0e68a54aec8ebf8f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0e68a54aec8ebf8f$var$_typeof(o);
}
var $0e68a54aec8ebf8f$var$_excluded = [
    "offset"
];
function $0e68a54aec8ebf8f$var$_toConsumableArray(arr) {
    return $0e68a54aec8ebf8f$var$_arrayWithoutHoles(arr) || $0e68a54aec8ebf8f$var$_iterableToArray(arr) || $0e68a54aec8ebf8f$var$_unsupportedIterableToArray(arr) || $0e68a54aec8ebf8f$var$_nonIterableSpread();
}
function $0e68a54aec8ebf8f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0e68a54aec8ebf8f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0e68a54aec8ebf8f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0e68a54aec8ebf8f$var$_arrayLikeToArray(o, minLen);
}
function $0e68a54aec8ebf8f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $0e68a54aec8ebf8f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $0e68a54aec8ebf8f$var$_arrayLikeToArray(arr);
}
function $0e68a54aec8ebf8f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0e68a54aec8ebf8f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0e68a54aec8ebf8f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0e68a54aec8ebf8f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0e68a54aec8ebf8f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0e68a54aec8ebf8f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0e68a54aec8ebf8f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0e68a54aec8ebf8f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0e68a54aec8ebf8f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0e68a54aec8ebf8f$var$_defineProperty(obj, key, value) {
    key = $0e68a54aec8ebf8f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0e68a54aec8ebf8f$var$_toPropertyKey(t) {
    var i = $0e68a54aec8ebf8f$var$_toPrimitive(t, "string");
    return "symbol" == $0e68a54aec8ebf8f$var$_typeof(i) ? i : i + "";
}
function $0e68a54aec8ebf8f$var$_toPrimitive(t, r) {
    if ("object" != $0e68a54aec8ebf8f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0e68a54aec8ebf8f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0e68a54aec8ebf8f$var$_extends() {
    $0e68a54aec8ebf8f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0e68a54aec8ebf8f$var$_extends.apply(this, arguments);
}
var $0e68a54aec8ebf8f$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(formatter)) return formatter(label);
    return label;
};
var $0e68a54aec8ebf8f$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $938aefa455a73c9b$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $0e68a54aec8ebf8f$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $0e68a54aec8ebf8f$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === 'insideStart') {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === 'insideEnd') {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === 'end') {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(labelProps.id) ? (0, $938aefa455a73c9b$export$8b15d37bc3f197d4)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("text", $0e68a54aec8ebf8f$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $0e68a54aec8ebf8f$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var _polarToCartesian = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $0e68a54aec8ebf8f$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return $0e68a54aec8ebf8f$var$_objectSpread($0e68a54aec8ebf8f$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return $0e68a54aec8ebf8f$var$_objectSpread($0e68a54aec8ebf8f$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return $0e68a54aec8ebf8f$var$_objectSpread($0e68a54aec8ebf8f$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return $0e68a54aec8ebf8f$var$_objectSpread($0e68a54aec8ebf8f$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === 'insideLeft') return $0e68a54aec8ebf8f$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $0e68a54aec8ebf8f$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $0e68a54aec8ebf8f$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $0e68a54aec8ebf8f$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $0e68a54aec8ebf8f$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $0e68a54aec8ebf8f$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $0e68a54aec8ebf8f$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $0e68a54aec8ebf8f$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6c66affe1256ad5a$exports)))(position) && ((0, $938aefa455a73c9b$export$7e4aa119212bc614)(position.x) || (0, $938aefa455a73c9b$export$e50269385c77c348)(position.x)) && ((0, $938aefa455a73c9b$export$7e4aa119212bc614)(position.y) || (0, $938aefa455a73c9b$export$e50269385c77c348)(position.y))) return $0e68a54aec8ebf8f$var$_objectSpread({
        x: x + (0, $938aefa455a73c9b$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $938aefa455a73c9b$export$476354dbf49bdff6)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $0e68a54aec8ebf8f$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var $0e68a54aec8ebf8f$var$isPolar = function isPolar(viewBox) {
    return 'cx' in viewBox && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(viewBox.cx);
};
function $0e68a54aec8ebf8f$export$b04be29aa201d4f5(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = $0e68a54aec8ebf8f$var$_objectWithoutProperties(_ref4, $0e68a54aec8ebf8f$var$_excluded);
    var props = $0e68a54aec8ebf8f$var$_objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(children) && !/*#__PURE__*/ (0, $gIfym.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $gIfym.isValidElement)(content)) return /*#__PURE__*/ (0, $gIfym.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(content)) {
        label = /*#__PURE__*/ (0, $gIfym.createElement)(content, props);
        if (/*#__PURE__*/ (0, $gIfym.isValidElement)(label)) return label;
    } else label = $0e68a54aec8ebf8f$var$getLabel(props);
    var isPolarLabel = $0e68a54aec8ebf8f$var$isPolar(viewBox);
    var attrs = (0, $49516a074167c4be$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) return $0e68a54aec8ebf8f$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $0e68a54aec8ebf8f$var$getAttrsOfPolarLabel(props) : $0e68a54aec8ebf8f$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $af1dbcbd2651f0c2$export$5f1af8db9871e1d6), $0e68a54aec8ebf8f$var$_extends({
        className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-label', className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$0e68a54aec8ebf8f$export$b04be29aa201d4f5.displayName = 'Label';
var $0e68a54aec8ebf8f$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $938aefa455a73c9b$export$7e4aa119212bc614)(width) && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(height)) {
        if ((0, $938aefa455a73c9b$export$7e4aa119212bc614)(x) && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $938aefa455a73c9b$export$7e4aa119212bc614)(top) && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $938aefa455a73c9b$export$7e4aa119212bc614)(x) && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $938aefa455a73c9b$export$7e4aa119212bc614)(cx) && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $0e68a54aec8ebf8f$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($0e68a54aec8ebf8f$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $938aefa455a73c9b$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($0e68a54aec8ebf8f$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $gIfym.isValidElement)(label)) {
        if (label.type === $0e68a54aec8ebf8f$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $gIfym.cloneElement)(label, {
            key: 'label-implicit',
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($0e68a54aec8ebf8f$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($0e68a54aec8ebf8f$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6c66affe1256ad5a$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($0e68a54aec8ebf8f$export$b04be29aa201d4f5, $0e68a54aec8ebf8f$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $0e68a54aec8ebf8f$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $0e68a54aec8ebf8f$var$parseViewBox(parentProps);
    var explicitChildren = (0, $49516a074167c4be$export$fdd5e64c0e8495bb)(children, $0e68a54aec8ebf8f$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $gIfym.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $0e68a54aec8ebf8f$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($0e68a54aec8ebf8f$var$_toConsumableArray(explicitChildren));
};
$0e68a54aec8ebf8f$export$b04be29aa201d4f5.parseViewBox = $0e68a54aec8ebf8f$var$parseViewBox;
$0e68a54aec8ebf8f$export$b04be29aa201d4f5.renderCallByParent = $0e68a54aec8ebf8f$var$renderCallByParent;





function $e706762aa5cf4680$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e706762aa5cf4680$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e706762aa5cf4680$var$_typeof(o);
}
var $e706762aa5cf4680$var$_excluded = [
    "valueAccessor"
], $e706762aa5cf4680$var$_excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $e706762aa5cf4680$var$_toConsumableArray(arr) {
    return $e706762aa5cf4680$var$_arrayWithoutHoles(arr) || $e706762aa5cf4680$var$_iterableToArray(arr) || $e706762aa5cf4680$var$_unsupportedIterableToArray(arr) || $e706762aa5cf4680$var$_nonIterableSpread();
}
function $e706762aa5cf4680$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e706762aa5cf4680$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e706762aa5cf4680$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e706762aa5cf4680$var$_arrayLikeToArray(o, minLen);
}
function $e706762aa5cf4680$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e706762aa5cf4680$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e706762aa5cf4680$var$_arrayLikeToArray(arr);
}
function $e706762aa5cf4680$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e706762aa5cf4680$var$_extends() {
    $e706762aa5cf4680$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e706762aa5cf4680$var$_extends.apply(this, arguments);
}
function $e706762aa5cf4680$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e706762aa5cf4680$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e706762aa5cf4680$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e706762aa5cf4680$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e706762aa5cf4680$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e706762aa5cf4680$var$_defineProperty(obj, key, value) {
    key = $e706762aa5cf4680$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e706762aa5cf4680$var$_toPropertyKey(t) {
    var i = $e706762aa5cf4680$var$_toPrimitive(t, "string");
    return "symbol" == $e706762aa5cf4680$var$_typeof(i) ? i : i + "";
}
function $e706762aa5cf4680$var$_toPrimitive(t, r) {
    if ("object" != $e706762aa5cf4680$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e706762aa5cf4680$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e706762aa5cf4680$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e706762aa5cf4680$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e706762aa5cf4680$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e706762aa5cf4680$var$defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($ce55d5d51ec6b2cd$exports)))(entry.value) : entry.value;
};
function $e706762aa5cf4680$export$835fcf23ab7bf88(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? $e706762aa5cf4680$var$defaultAccessor : _ref$valueAccessor, restProps = $e706762aa5cf4680$var$_objectWithoutProperties(_ref, $e706762aa5cf4680$var$_excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = $e706762aa5cf4680$var$_objectWithoutProperties(restProps, $e706762aa5cf4680$var$_excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $2cf058a100d782d5$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $0e68a54aec8ebf8f$export$b04be29aa201d4f5), $e706762aa5cf4680$var$_extends({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $0e68a54aec8ebf8f$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(clockWise) ? entry : $e706762aa5cf4680$var$_objectSpread($e706762aa5cf4680$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
$e706762aa5cf4680$export$835fcf23ab7bf88.displayName = 'LabelList';
function $e706762aa5cf4680$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($e706762aa5cf4680$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($e706762aa5cf4680$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6c66affe1256ad5a$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($e706762aa5cf4680$export$835fcf23ab7bf88, $e706762aa5cf4680$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $e706762aa5cf4680$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $49516a074167c4be$export$fdd5e64c0e8495bb)(children, $e706762aa5cf4680$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $gIfym.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $e706762aa5cf4680$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($e706762aa5cf4680$var$_toConsumableArray(explicitChildren));
}
$e706762aa5cf4680$export$835fcf23ab7bf88.renderCallByParent = $e706762aa5cf4680$var$renderCallByParent;








var $gIfym = parcelRequire("gIfym");


var $gIfym = parcelRequire("gIfym");

var $14409efa7651a6aa$exports = {};

var $fd02ba7728f512b1$exports = {};

/** Built-in value references. */ var $fd02ba7728f512b1$var$getPrototype = $e1440f89166587cb$exports(Object.getPrototypeOf, Object);
$fd02ba7728f512b1$exports = $fd02ba7728f512b1$var$getPrototype;



/** `Object#toString` result references. */ var $14409efa7651a6aa$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $14409efa7651a6aa$var$funcProto = Function.prototype, $14409efa7651a6aa$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $14409efa7651a6aa$var$funcToString = $14409efa7651a6aa$var$funcProto.toString;
/** Used to check objects for own properties. */ var $14409efa7651a6aa$var$hasOwnProperty = $14409efa7651a6aa$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $14409efa7651a6aa$var$objectCtorString = $14409efa7651a6aa$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $14409efa7651a6aa$var$isPlainObject(value) {
    if (!$1cb4850252351023$exports(value) || $7795fa4e140e28cd$exports(value) != $14409efa7651a6aa$var$objectTag) return false;
    var proto = $fd02ba7728f512b1$exports(value);
    if (proto === null) return true;
    var Ctor = $14409efa7651a6aa$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $14409efa7651a6aa$var$funcToString.call(Ctor) == $14409efa7651a6aa$var$objectCtorString;
}
$14409efa7651a6aa$exports = $14409efa7651a6aa$var$isPlainObject;


var $e6d5a0894a5599f1$exports = {};


/** `Object#toString` result references. */ var $e6d5a0894a5599f1$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $e6d5a0894a5599f1$var$isBoolean(value) {
    return value === true || value === false || $1cb4850252351023$exports(value) && $7795fa4e140e28cd$exports(value) == $e6d5a0894a5599f1$var$boolTag;
}
$e6d5a0894a5599f1$exports = $e6d5a0894a5599f1$var$isBoolean;




var $gIfym = parcelRequire("gIfym");



function $25b2a5d5dc6ab71a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $25b2a5d5dc6ab71a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $25b2a5d5dc6ab71a$var$_typeof(o);
}
function $25b2a5d5dc6ab71a$var$_extends() {
    $25b2a5d5dc6ab71a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $25b2a5d5dc6ab71a$var$_extends.apply(this, arguments);
}
function $25b2a5d5dc6ab71a$var$_slicedToArray(arr, i) {
    return $25b2a5d5dc6ab71a$var$_arrayWithHoles(arr) || $25b2a5d5dc6ab71a$var$_iterableToArrayLimit(arr, i) || $25b2a5d5dc6ab71a$var$_unsupportedIterableToArray(arr, i) || $25b2a5d5dc6ab71a$var$_nonIterableRest();
}
function $25b2a5d5dc6ab71a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $25b2a5d5dc6ab71a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $25b2a5d5dc6ab71a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $25b2a5d5dc6ab71a$var$_arrayLikeToArray(o, minLen);
}
function $25b2a5d5dc6ab71a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $25b2a5d5dc6ab71a$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $25b2a5d5dc6ab71a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $25b2a5d5dc6ab71a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $25b2a5d5dc6ab71a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $25b2a5d5dc6ab71a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $25b2a5d5dc6ab71a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $25b2a5d5dc6ab71a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $25b2a5d5dc6ab71a$var$_defineProperty(obj, key, value) {
    key = $25b2a5d5dc6ab71a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $25b2a5d5dc6ab71a$var$_toPropertyKey(t) {
    var i = $25b2a5d5dc6ab71a$var$_toPrimitive(t, "string");
    return "symbol" == $25b2a5d5dc6ab71a$var$_typeof(i) ? i : i + "";
}
function $25b2a5d5dc6ab71a$var$_toPrimitive(t, r) {
    if ("object" != $25b2a5d5dc6ab71a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $25b2a5d5dc6ab71a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $25b2a5d5dc6ab71a$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $25b2a5d5dc6ab71a$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $25b2a5d5dc6ab71a$var$defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $25b2a5d5dc6ab71a$export$4617fb02663045ef = function Rectangle(rectangleProps) {
    var props = $25b2a5d5dc6ab71a$var$_objectSpread($25b2a5d5dc6ab71a$var$_objectSpread({}, $25b2a5d5dc6ab71a$var$defaultProps), rectangleProps);
    var pathRef = (0, $gIfym.useRef)();
    var _useState = (0, $gIfym.useState)(-1), _useState2 = $25b2a5d5dc6ab71a$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $gIfym.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", $25b2a5d5dc6ab71a$var$_extends({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $25b2a5d5dc6ab71a$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $c1c3cea1c393a834$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $c1c3cea1c393a834$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", $25b2a5d5dc6ab71a$var$_extends({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $25b2a5d5dc6ab71a$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};



var $gIfym = parcelRequire("gIfym");



function $7a15f38761b9af18$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7a15f38761b9af18$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7a15f38761b9af18$var$_typeof(o);
}
function $7a15f38761b9af18$var$_extends() {
    $7a15f38761b9af18$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7a15f38761b9af18$var$_extends.apply(this, arguments);
}
function $7a15f38761b9af18$var$_slicedToArray(arr, i) {
    return $7a15f38761b9af18$var$_arrayWithHoles(arr) || $7a15f38761b9af18$var$_iterableToArrayLimit(arr, i) || $7a15f38761b9af18$var$_unsupportedIterableToArray(arr, i) || $7a15f38761b9af18$var$_nonIterableRest();
}
function $7a15f38761b9af18$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7a15f38761b9af18$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7a15f38761b9af18$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7a15f38761b9af18$var$_arrayLikeToArray(o, minLen);
}
function $7a15f38761b9af18$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7a15f38761b9af18$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $7a15f38761b9af18$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $7a15f38761b9af18$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7a15f38761b9af18$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7a15f38761b9af18$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7a15f38761b9af18$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7a15f38761b9af18$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7a15f38761b9af18$var$_defineProperty(obj, key, value) {
    key = $7a15f38761b9af18$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7a15f38761b9af18$var$_toPropertyKey(t) {
    var i = $7a15f38761b9af18$var$_toPrimitive(t, "string");
    return "symbol" == $7a15f38761b9af18$var$_typeof(i) ? i : i + "";
}
function $7a15f38761b9af18$var$_toPrimitive(t, r) {
    if ("object" != $7a15f38761b9af18$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7a15f38761b9af18$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7a15f38761b9af18$var$getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var $7a15f38761b9af18$var$defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $7a15f38761b9af18$export$d1ed33dc592f5337 = function Trapezoid(props) {
    var trapezoidProps = $7a15f38761b9af18$var$_objectSpread($7a15f38761b9af18$var$_objectSpread({}, $7a15f38761b9af18$var$defaultProps), props);
    var pathRef = (0, $gIfym.useRef)();
    var _useState = (0, $gIfym.useState)(-1), _useState2 = $7a15f38761b9af18$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $gIfym.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", $7a15f38761b9af18$var$_extends({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(trapezoidProps, true), {
        className: layerClass,
        d: $7a15f38761b9af18$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $c1c3cea1c393a834$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $c1c3cea1c393a834$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", $7a15f38761b9af18$var$_extends({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(trapezoidProps, true), {
            className: layerClass,
            d: $7a15f38761b9af18$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};



var $gIfym = parcelRequire("gIfym");




function $403dd5713dcc2a00$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $403dd5713dcc2a00$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $403dd5713dcc2a00$var$_typeof(o);
}
function $403dd5713dcc2a00$var$_extends() {
    $403dd5713dcc2a00$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $403dd5713dcc2a00$var$_extends.apply(this, arguments);
}
function $403dd5713dcc2a00$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $403dd5713dcc2a00$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $403dd5713dcc2a00$var$ownKeys(Object(t), !0).forEach(function(r) {
            $403dd5713dcc2a00$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $403dd5713dcc2a00$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $403dd5713dcc2a00$var$_defineProperty(obj, key, value) {
    key = $403dd5713dcc2a00$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $403dd5713dcc2a00$var$_toPropertyKey(t) {
    var i = $403dd5713dcc2a00$var$_toPrimitive(t, "string");
    return "symbol" == $403dd5713dcc2a00$var$_typeof(i) ? i : i + "";
}
function $403dd5713dcc2a00$var$_toPrimitive(t, r) {
    if ("object" != $403dd5713dcc2a00$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $403dd5713dcc2a00$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $403dd5713dcc2a00$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $938aefa455a73c9b$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $403dd5713dcc2a00$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $b592c97d860421c4$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $b592c97d860421c4$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $403dd5713dcc2a00$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $403dd5713dcc2a00$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $403dd5713dcc2a00$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $938aefa455a73c9b$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $403dd5713dcc2a00$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $403dd5713dcc2a00$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $403dd5713dcc2a00$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $403dd5713dcc2a00$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $403dd5713dcc2a00$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $403dd5713dcc2a00$var$defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $403dd5713dcc2a00$export$e98c2c7eb2b14f45 = function Sector(sectorProps) {
    var props = $403dd5713dcc2a00$var$_objectSpread($403dd5713dcc2a00$var$_objectSpread({}, $403dd5713dcc2a00$var$defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $938aefa455a73c9b$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $403dd5713dcc2a00$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $403dd5713dcc2a00$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", $403dd5713dcc2a00$var$_extends({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};




var $cf9db1230888ca89$var$_excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function $cf9db1230888ca89$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cf9db1230888ca89$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cf9db1230888ca89$var$_typeof(o);
}
function $cf9db1230888ca89$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cf9db1230888ca89$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cf9db1230888ca89$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $cf9db1230888ca89$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cf9db1230888ca89$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cf9db1230888ca89$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cf9db1230888ca89$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cf9db1230888ca89$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cf9db1230888ca89$var$_defineProperty(obj, key, value) {
    key = $cf9db1230888ca89$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cf9db1230888ca89$var$_toPropertyKey(t) {
    var i = $cf9db1230888ca89$var$_toPrimitive(t, "string");
    return "symbol" == $cf9db1230888ca89$var$_typeof(i) ? i : i + "";
}
function $cf9db1230888ca89$var$_toPrimitive(t, r) {
    if ("object" != $cf9db1230888ca89$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cf9db1230888ca89$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $cf9db1230888ca89$var$defaultPropTransformer(option, props) {
    return $cf9db1230888ca89$var$_objectSpread($cf9db1230888ca89$var$_objectSpread({}, props), option);
}
function $cf9db1230888ca89$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function $cf9db1230888ca89$var$ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $25b2a5d5dc6ab71a$export$4617fb02663045ef), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $7a15f38761b9af18$export$d1ed33dc592f5337), elementProps);
        case 'sector':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $403dd5713dcc2a00$export$e98c2c7eb2b14f45), elementProps);
        case 'symbols':
            if ($cf9db1230888ca89$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $2c7308af7c49eae7$export$fa456266707bf4e4), elementProps);
            break;
        default:
            return null;
    }
}
function $cf9db1230888ca89$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $gIfym.isValidElement)(option)) return option.props;
    return option;
}
function $cf9db1230888ca89$export$6428a7f2611ef1fa(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? $cf9db1230888ca89$var$defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? 'recharts-active-shape' : _ref2$activeClassName, isActive = _ref2.isActive, props = $cf9db1230888ca89$var$_objectWithoutProperties(_ref2, $cf9db1230888ca89$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $gIfym.isValidElement)(option)) shape = /*#__PURE__*/ (0, $gIfym.cloneElement)(option, $cf9db1230888ca89$var$_objectSpread($cf9db1230888ca89$var$_objectSpread({}, props), $cf9db1230888ca89$export$33c4f706a443da24(option)));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(option)) shape = option(props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($14409efa7651a6aa$exports)))(option) && !(0, (/*@__PURE__*/$parcel$interopDefault($e6d5a0894a5599f1$exports)))(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($cf9db1230888ca89$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($cf9db1230888ca89$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}
function $cf9db1230888ca89$export$4b83e8415af38a18(graphicalItem, _item) {
    return _item != null && 'trapezoids' in graphicalItem.props;
}
function $cf9db1230888ca89$export$f722d7e63cc07b(graphicalItem, _item) {
    return _item != null && 'sectors' in graphicalItem.props;
}
function $cf9db1230888ca89$export$f62b21bcfd1a733e(graphicalItem, _item) {
    return _item != null && 'points' in graphicalItem.props;
}
function $cf9db1230888ca89$export$7c9a98b3f068686f(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function $cf9db1230888ca89$export$b356b51e8337a02f(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function $cf9db1230888ca89$export$559c3a78b4889350(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function $cf9db1230888ca89$var$getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if ($cf9db1230888ca89$export$4b83e8415af38a18(graphicalItem, activeItem)) comparison = $cf9db1230888ca89$export$7c9a98b3f068686f;
    else if ($cf9db1230888ca89$export$f722d7e63cc07b(graphicalItem, activeItem)) comparison = $cf9db1230888ca89$export$b356b51e8337a02f;
    else if ($cf9db1230888ca89$export$f62b21bcfd1a733e(graphicalItem, activeItem)) comparison = $cf9db1230888ca89$export$559c3a78b4889350;
    return comparison;
}
function $cf9db1230888ca89$var$getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if ($cf9db1230888ca89$export$4b83e8415af38a18(graphicalItem, activeItem)) shapeKey = 'trapezoids';
    else if ($cf9db1230888ca89$export$f722d7e63cc07b(graphicalItem, activeItem)) shapeKey = 'sectors';
    else if ($cf9db1230888ca89$export$f62b21bcfd1a733e(graphicalItem, activeItem)) shapeKey = 'points';
    return shapeKey;
}
function $cf9db1230888ca89$var$getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if ($cf9db1230888ca89$export$4b83e8415af38a18(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if ($cf9db1230888ca89$export$f722d7e63cc07b(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if ($cf9db1230888ca89$export$f62b21bcfd1a733e(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function $cf9db1230888ca89$export$bd5d63c57ca4468(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = $cf9db1230888ca89$var$getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = $cf9db1230888ca89$var$getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, (/*@__PURE__*/$parcel$interopDefault($f0e839acff22663e$exports)))(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = $cf9db1230888ca89$var$getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}


var $a749ac67359c481d$var$_excluded = [
    "x",
    "y"
];
function $a749ac67359c481d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a749ac67359c481d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a749ac67359c481d$var$_typeof(o);
}
function $a749ac67359c481d$var$_extends() {
    $a749ac67359c481d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a749ac67359c481d$var$_extends.apply(this, arguments);
}
function $a749ac67359c481d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a749ac67359c481d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a749ac67359c481d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a749ac67359c481d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a749ac67359c481d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a749ac67359c481d$var$_defineProperty(obj, key, value) {
    key = $a749ac67359c481d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a749ac67359c481d$var$_toPropertyKey(t) {
    var i = $a749ac67359c481d$var$_toPrimitive(t, "string");
    return "symbol" == $a749ac67359c481d$var$_typeof(i) ? i : i + "";
}
function $a749ac67359c481d$var$_toPrimitive(t, r) {
    if ("object" != $a749ac67359c481d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a749ac67359c481d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a749ac67359c481d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a749ac67359c481d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a749ac67359c481d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, number, number, number]
function $a749ac67359c481d$var$typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = $a749ac67359c481d$var$_objectWithoutProperties(_ref, $a749ac67359c481d$var$_excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return $a749ac67359c481d$var$_objectSpread($a749ac67359c481d$var$_objectSpread($a749ac67359c481d$var$_objectSpread($a749ac67359c481d$var$_objectSpread($a749ac67359c481d$var$_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function $a749ac67359c481d$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $cf9db1230888ca89$export$6428a7f2611ef1fa), $a749ac67359c481d$var$_extends({
        shapeType: "rectangle",
        propTransformer: $a749ac67359c481d$var$typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}
var $a749ac67359c481d$export$c20d73790de171f0 = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function(value, index) {
        if (typeof minPointSize === 'number') return minPointSize;
        var isValueNumber = typeof value === 'number';
        if (isValueNumber) return minPointSize(value, index);
        !isValueNumber && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
        return defaultValue;
    };
};


var $7f0f02843a7c30b4$var$_excluded = [
    "value",
    "background"
];
var $7f0f02843a7c30b4$var$_Bar;
function $7f0f02843a7c30b4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7f0f02843a7c30b4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7f0f02843a7c30b4$var$_typeof(o);
}
function $7f0f02843a7c30b4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7f0f02843a7c30b4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7f0f02843a7c30b4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7f0f02843a7c30b4$var$_extends() {
    $7f0f02843a7c30b4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7f0f02843a7c30b4$var$_extends.apply(this, arguments);
}
function $7f0f02843a7c30b4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7f0f02843a7c30b4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7f0f02843a7c30b4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7f0f02843a7c30b4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7f0f02843a7c30b4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7f0f02843a7c30b4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7f0f02843a7c30b4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7f0f02843a7c30b4$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7f0f02843a7c30b4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7f0f02843a7c30b4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7f0f02843a7c30b4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7f0f02843a7c30b4$var$_callSuper(t, o, e) {
    return o = $7f0f02843a7c30b4$var$_getPrototypeOf(o), $7f0f02843a7c30b4$var$_possibleConstructorReturn(t, $7f0f02843a7c30b4$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $7f0f02843a7c30b4$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $7f0f02843a7c30b4$var$_possibleConstructorReturn(self, call) {
    if (call && ($7f0f02843a7c30b4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7f0f02843a7c30b4$var$_assertThisInitialized(self);
}
function $7f0f02843a7c30b4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7f0f02843a7c30b4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7f0f02843a7c30b4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $7f0f02843a7c30b4$var$_getPrototypeOf(o) {
    $7f0f02843a7c30b4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7f0f02843a7c30b4$var$_getPrototypeOf(o);
}
function $7f0f02843a7c30b4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7f0f02843a7c30b4$var$_setPrototypeOf(subClass, superClass);
}
function $7f0f02843a7c30b4$var$_setPrototypeOf(o, p) {
    $7f0f02843a7c30b4$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7f0f02843a7c30b4$var$_setPrototypeOf(o, p);
}
function $7f0f02843a7c30b4$var$_defineProperty(obj, key, value) {
    key = $7f0f02843a7c30b4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7f0f02843a7c30b4$var$_toPropertyKey(t) {
    var i = $7f0f02843a7c30b4$var$_toPrimitive(t, "string");
    return "symbol" == $7f0f02843a7c30b4$var$_typeof(i) ? i : i + "";
}
function $7f0f02843a7c30b4$var$_toPrimitive(t, r) {
    if ("object" != $7f0f02843a7c30b4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7f0f02843a7c30b4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7f0f02843a7c30b4$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    function Bar() {
        var _this;
        $7f0f02843a7c30b4$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $7f0f02843a7c30b4$var$_callSuper(this, Bar, [].concat(args));
        $7f0f02843a7c30b4$var$_defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        $7f0f02843a7c30b4$var$_defineProperty(_this, "id", (0, $938aefa455a73c9b$export$8b15d37bc3f197d4)('recharts-bar-'));
        $7f0f02843a7c30b4$var$_defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $7f0f02843a7c30b4$var$_defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $7f0f02843a7c30b4$var$_inherits(Bar, _PureComponent);
    return $7f0f02843a7c30b4$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, $49516a074167c4be$export$d697c39a2985a4c)(this.props, false);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = $7f0f02843a7c30b4$var$_objectSpread($7f0f02843a7c30b4$var$_objectSpread($7f0f02843a7c30b4$var$_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), $7f0f02843a7c30b4$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $e49003a65b792e53$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        // https://github.com/recharts/recharts/issues/5415
                        // eslint-disable-next-line react/no-array-index-key
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value, "-").concat(i)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $a749ac67359c481d$export$f19074a6842f9217), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $c1c3cea1c393a834$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $938aefa455a73c9b$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $938aefa455a73c9b$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $938aefa455a73c9b$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $938aefa455a73c9b$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $7f0f02843a7c30b4$var$_objectSpread($7f0f02843a7c30b4$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === 'horizontal') {
                            var _interpolatorHeight = (0, $938aefa455a73c9b$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $7f0f02843a7c30b4$var$_objectSpread($7f0f02843a7c30b4$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $938aefa455a73c9b$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $7f0f02843a7c30b4$var$_objectSpread($7f0f02843a7c30b4$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($f0e839acff22663e$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, $49516a074167c4be$export$d697c39a2985a4c)(this.props.background, false);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $7f0f02843a7c30b4$var$_objectWithoutProperties(entry, $7f0f02843a7c30b4$var$_excluded);
                    if (!background) return null;
                    var props = $7f0f02843a7c30b4$var$_objectSpread($7f0f02843a7c30b4$var$_objectSpread($7f0f02843a7c30b4$var$_objectSpread($7f0f02843a7c30b4$var$_objectSpread($7f0f02843a7c30b4$var$_objectSpread({}, rest), {}, {
                        fill: '#eee'
                    }, background), backgroundProps), (0, $e49003a65b792e53$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        className: 'recharts-bar-background-rectangle'
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $a749ac67359c481d$export$f19074a6842f9217), $7f0f02843a7c30b4$var$_extends({
                        key: "background-bar-".concat(i),
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, $49516a074167c4be$export$fdd5e64c0e8495bb)(children, (0, $d7f00f77e606798b$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $2cf058a100d782d5$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-bar', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $e706762aa5cf4680$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
}((0, $gIfym.PureComponent));
$7f0f02843a7c30b4$var$_Bar = $7f0f02843a7c30b4$export$bbc6c6369b38e3d1;
$7f0f02843a7c30b4$var$_defineProperty($7f0f02843a7c30b4$export$bbc6c6369b38e3d1, "displayName", 'Bar');
$7f0f02843a7c30b4$var$_defineProperty($7f0f02843a7c30b4$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'rect',
    minPointSize: 0,
    hide: false,
    data: [],
    layout: 'vertical',
    activeBar: false,
    isAnimationActive: !(0, $2a28151593e2b6a4$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease'
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $7f0f02843a7c30b4$var$_defineProperty($7f0f02843a7c30b4$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $2cf058a100d782d5$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var itemDefaultProps = item.type.defaultProps;
    var itemProps = itemDefaultProps !== undefined ? $7f0f02843a7c30b4$var$_objectSpread($7f0f02843a7c30b4$var$_objectSpread({}, itemDefaultProps), item.props) : item.props;
    var dataKey = itemProps.dataKey, children = itemProps.children, minPointSizeProp = itemProps.minPointSize;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $2cf058a100d782d5$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $49516a074167c4be$export$fdd5e64c0e8495bb)(children, (0, $b7ce6dc70cc786c8$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $2cf058a100d782d5$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $2cf058a100d782d5$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, $a749ac67359c481d$export$c20d73790de171f0)(minPointSizeProp, $7f0f02843a7c30b4$var$_Bar.defaultProps.minPointSize)(value[1], index);
        if (layout === 'horizontal') {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $2cf058a100d782d5$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $938aefa455a73c9b$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $2cf058a100d782d5$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $938aefa455a73c9b$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $7f0f02843a7c30b4$var$_objectSpread($7f0f02843a7c30b4$var$_objectSpread($7f0f02843a7c30b4$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $2cf058a100d782d5$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $7f0f02843a7c30b4$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});

/**
 * @fileOverview Bar Chart
 */ 
var $gIfym = parcelRequire("gIfym");


var $fbafef0136c05c9e$exports = {};
var $128eb3e2b529f041$exports = {};
var $6defb1f0edf7e4e9$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6defb1f0edf7e4e9$var$nativeCeil = Math.ceil, $6defb1f0edf7e4e9$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $6defb1f0edf7e4e9$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $6defb1f0edf7e4e9$var$nativeMax($6defb1f0edf7e4e9$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$6defb1f0edf7e4e9$exports = $6defb1f0edf7e4e9$var$baseRange;



var $cc1fa9938b04eaf5$exports = {};
var $0df966900e95bbe3$exports = {};
var $7f82f596bfdfbf04$exports = {};
var $cfc4e5a5b8124629$exports = {};
/** Used to match a single whitespace character. */ var $cfc4e5a5b8124629$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $cfc4e5a5b8124629$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $cfc4e5a5b8124629$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$cfc4e5a5b8124629$exports = $cfc4e5a5b8124629$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $7f82f596bfdfbf04$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $7f82f596bfdfbf04$var$baseTrim(string) {
    return string ? string.slice(0, $cfc4e5a5b8124629$exports(string) + 1).replace($7f82f596bfdfbf04$var$reTrimStart, '') : string;
}
$7f82f596bfdfbf04$exports = $7f82f596bfdfbf04$var$baseTrim;




/** Used as references for various `Number` constants. */ var $0df966900e95bbe3$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $0df966900e95bbe3$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $0df966900e95bbe3$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $0df966900e95bbe3$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $0df966900e95bbe3$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $0df966900e95bbe3$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($b33d0ca91daaf047$exports(value)) return $0df966900e95bbe3$var$NAN;
    if ($6c66affe1256ad5a$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $6c66affe1256ad5a$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $7f82f596bfdfbf04$exports(value);
    var isBinary = $0df966900e95bbe3$var$reIsBinary.test(value);
    return isBinary || $0df966900e95bbe3$var$reIsOctal.test(value) ? $0df966900e95bbe3$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $0df966900e95bbe3$var$reIsBadHex.test(value) ? $0df966900e95bbe3$var$NAN : +value;
}
$0df966900e95bbe3$exports = $0df966900e95bbe3$var$toNumber;


/** Used as references for various `Number` constants. */ var $cc1fa9938b04eaf5$var$INFINITY = 1 / 0, $cc1fa9938b04eaf5$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $cc1fa9938b04eaf5$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $0df966900e95bbe3$exports(value);
    if (value === $cc1fa9938b04eaf5$var$INFINITY || value === -$cc1fa9938b04eaf5$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $cc1fa9938b04eaf5$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$cc1fa9938b04eaf5$exports = $cc1fa9938b04eaf5$var$toFinite;


/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $128eb3e2b529f041$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $3c6bc6c2e4316f7b$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $cc1fa9938b04eaf5$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $cc1fa9938b04eaf5$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $cc1fa9938b04eaf5$exports(step);
        return $6defb1f0edf7e4e9$exports(start, end, step, fromRight);
    };
}
$128eb3e2b529f041$exports = $128eb3e2b529f041$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $fbafef0136c05c9e$var$range = $128eb3e2b529f041$exports();
$fbafef0136c05c9e$exports = $fbafef0136c05c9e$var$range;




var $ebc24d79346e975d$exports = {};
var $1299ba80c0801d08$exports = {};

var $b0b4955f953cd634$exports = {};

var $g1Rml = parcelRequire("g1Rml");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $b0b4955f953cd634$var$now = function() {
    return $g1Rml.Date.now();
};
$b0b4955f953cd634$exports = $b0b4955f953cd634$var$now;



/** Error message constants. */ var $1299ba80c0801d08$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1299ba80c0801d08$var$nativeMax = Math.max, $1299ba80c0801d08$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $1299ba80c0801d08$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($1299ba80c0801d08$var$FUNC_ERROR_TEXT);
    wait = $0df966900e95bbe3$exports(wait) || 0;
    if ($6c66affe1256ad5a$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $1299ba80c0801d08$var$nativeMax($0df966900e95bbe3$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $1299ba80c0801d08$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $b0b4955f953cd634$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($b0b4955f953cd634$exports());
    }
    function debounced() {
        var time = $b0b4955f953cd634$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$1299ba80c0801d08$exports = $1299ba80c0801d08$var$debounce;



/** Error message constants. */ var $ebc24d79346e975d$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $ebc24d79346e975d$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($ebc24d79346e975d$var$FUNC_ERROR_TEXT);
    if ($6c66affe1256ad5a$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $1299ba80c0801d08$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$ebc24d79346e975d$exports = $ebc24d79346e975d$var$throttle;







var $gIfym = parcelRequire("gIfym");

var $gIfym = parcelRequire("gIfym");




function $5ae9151e6322f95b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5ae9151e6322f95b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5ae9151e6322f95b$var$_typeof(o);
}
function $5ae9151e6322f95b$var$_extends() {
    $5ae9151e6322f95b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5ae9151e6322f95b$var$_extends.apply(this, arguments);
}
function $5ae9151e6322f95b$var$_slicedToArray(arr, i) {
    return $5ae9151e6322f95b$var$_arrayWithHoles(arr) || $5ae9151e6322f95b$var$_iterableToArrayLimit(arr, i) || $5ae9151e6322f95b$var$_unsupportedIterableToArray(arr, i) || $5ae9151e6322f95b$var$_nonIterableRest();
}
function $5ae9151e6322f95b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5ae9151e6322f95b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5ae9151e6322f95b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5ae9151e6322f95b$var$_arrayLikeToArray(o, minLen);
}
function $5ae9151e6322f95b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5ae9151e6322f95b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $5ae9151e6322f95b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $5ae9151e6322f95b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5ae9151e6322f95b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5ae9151e6322f95b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5ae9151e6322f95b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5ae9151e6322f95b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5ae9151e6322f95b$var$_defineProperty(obj, key, value) {
    key = $5ae9151e6322f95b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5ae9151e6322f95b$var$_toPropertyKey(t) {
    var i = $5ae9151e6322f95b$var$_toPrimitive(t, "string");
    return "symbol" == $5ae9151e6322f95b$var$_typeof(i) ? i : i + "";
}
function $5ae9151e6322f95b$var$_toPrimitive(t, r) {
    if ("object" != $5ae9151e6322f95b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5ae9151e6322f95b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5ae9151e6322f95b$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $938aefa455a73c9b$export$402a499e1ea44294)(value[0]) && (0, $938aefa455a73c9b$export$402a499e1ea44294)(value[1]) ? value.join(' ~ ') : value;
}
var $5ae9151e6322f95b$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? ' : ' : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($74190bf599267a83$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === 'none') return null;
                var finalItemStyle = $5ae9151e6322f95b$var$_objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $5ae9151e6322f95b$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $5ae9151e6322f95b$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $938aefa455a73c9b$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $938aefa455a73c9b$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || '')));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $5ae9151e6322f95b$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = $5ae9151e6322f95b$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: 'status',
        'aria-live': 'assertive'
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", $5ae9151e6322f95b$var$_extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $gIfym = parcelRequire("gIfym");


function $2cf7fbb11d61b63c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2cf7fbb11d61b63c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2cf7fbb11d61b63c$var$_typeof(o);
}
function $2cf7fbb11d61b63c$var$_defineProperty(obj, key, value) {
    key = $2cf7fbb11d61b63c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2cf7fbb11d61b63c$var$_toPropertyKey(t) {
    var i = $2cf7fbb11d61b63c$var$_toPrimitive(t, "string");
    return "symbol" == $2cf7fbb11d61b63c$var$_typeof(i) ? i : i + "";
}
function $2cf7fbb11d61b63c$var$_toPrimitive(t, r) {
    if ("object" != $2cf7fbb11d61b63c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2cf7fbb11d61b63c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2cf7fbb11d61b63c$var$CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var $2cf7fbb11d61b63c$var$TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function $2cf7fbb11d61b63c$export$46aee7ef09f78756(_ref) {
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)($2cf7fbb11d61b63c$var$CSS_CLASS_PREFIX, $2cf7fbb11d61b63c$var$_defineProperty($2cf7fbb11d61b63c$var$_defineProperty($2cf7fbb11d61b63c$var$_defineProperty($2cf7fbb11d61b63c$var$_defineProperty({}, "".concat($2cf7fbb11d61b63c$var$CSS_CLASS_PREFIX, "-right"), (0, $938aefa455a73c9b$export$7e4aa119212bc614)(translateX) && coordinate && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), "".concat($2cf7fbb11d61b63c$var$CSS_CLASS_PREFIX, "-left"), (0, $938aefa455a73c9b$export$7e4aa119212bc614)(translateX) && coordinate && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), "".concat($2cf7fbb11d61b63c$var$CSS_CLASS_PREFIX, "-bottom"), (0, $938aefa455a73c9b$export$7e4aa119212bc614)(translateY) && coordinate && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), "".concat($2cf7fbb11d61b63c$var$CSS_CLASS_PREFIX, "-top"), (0, $938aefa455a73c9b$export$7e4aa119212bc614)(translateY) && coordinate && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y));
}
function $2cf7fbb11d61b63c$export$4cccba03fe0eccc6(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function $2cf7fbb11d61b63c$export$4fe0982879780f9b(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function $2cf7fbb11d61b63c$export$25e3b0ae21503056(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $2cf7fbb11d61b63c$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $2cf7fbb11d61b63c$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $2cf7fbb11d61b63c$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $2cf7fbb11d61b63c$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $2cf7fbb11d61b63c$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $781694be0f2fd532$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $781694be0f2fd532$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $781694be0f2fd532$var$_typeof(o);
}
function $781694be0f2fd532$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $781694be0f2fd532$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $781694be0f2fd532$var$ownKeys(Object(t), !0).forEach(function(r) {
            $781694be0f2fd532$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $781694be0f2fd532$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $781694be0f2fd532$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $781694be0f2fd532$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $781694be0f2fd532$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $781694be0f2fd532$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $781694be0f2fd532$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $781694be0f2fd532$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $781694be0f2fd532$var$_callSuper(t, o, e) {
    return o = $781694be0f2fd532$var$_getPrototypeOf(o), $781694be0f2fd532$var$_possibleConstructorReturn(t, $781694be0f2fd532$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $781694be0f2fd532$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $781694be0f2fd532$var$_possibleConstructorReturn(self, call) {
    if (call && ($781694be0f2fd532$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $781694be0f2fd532$var$_assertThisInitialized(self);
}
function $781694be0f2fd532$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $781694be0f2fd532$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($781694be0f2fd532$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $781694be0f2fd532$var$_getPrototypeOf(o) {
    $781694be0f2fd532$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $781694be0f2fd532$var$_getPrototypeOf(o);
}
function $781694be0f2fd532$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $781694be0f2fd532$var$_setPrototypeOf(subClass, superClass);
}
function $781694be0f2fd532$var$_setPrototypeOf(o, p) {
    $781694be0f2fd532$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $781694be0f2fd532$var$_setPrototypeOf(o, p);
}
function $781694be0f2fd532$var$_defineProperty(obj, key, value) {
    key = $781694be0f2fd532$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $781694be0f2fd532$var$_toPropertyKey(t) {
    var i = $781694be0f2fd532$var$_toPrimitive(t, "string");
    return "symbol" == $781694be0f2fd532$var$_typeof(i) ? i : i + "";
}
function $781694be0f2fd532$var$_toPrimitive(t, r) {
    if ("object" != $781694be0f2fd532$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $781694be0f2fd532$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $781694be0f2fd532$var$EPSILON = 1;
var $781694be0f2fd532$export$9e6cee7b86551b9c = /*#__PURE__*/ function(_PureComponent) {
    function TooltipBoundingBox() {
        var _this;
        $781694be0f2fd532$var$_classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $781694be0f2fd532$var$_callSuper(this, TooltipBoundingBox, [].concat(args));
        $781694be0f2fd532$var$_defineProperty(_this, "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            },
            lastBoundingBox: {
                width: -1,
                height: -1
            }
        });
        $781694be0f2fd532$var$_defineProperty(_this, "handleKeyDown", function(event) {
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    $781694be0f2fd532$var$_inherits(TooltipBoundingBox, _PureComponent);
    return $781694be0f2fd532$var$_createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.state.lastBoundingBox.width) > $781694be0f2fd532$var$EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > $781694be0f2fd532$var$EPSILON) this.setState({
                        lastBoundingBox: {
                            width: box.width,
                            height: box.height
                        }
                    });
                } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) this.setState({
                    lastBoundingBox: {
                        width: -1,
                        height: -1
                    }
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('keydown', this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, $2cf7fbb11d61b63c$export$25e3b0ae21503056)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: this.state.lastBoundingBox,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = $781694be0f2fd532$var$_objectSpread($781694be0f2fd532$var$_objectSpread({
                    transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
                }, cssProperties), {}, {
                    pointerEvents: 'none',
                    visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
                    position: 'absolute',
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
                    tabIndex: -1,
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
}((0, $gIfym.PureComponent));




function $af95134c6736175e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $af95134c6736175e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $af95134c6736175e$var$_typeof(o);
}
function $af95134c6736175e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $af95134c6736175e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $af95134c6736175e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $af95134c6736175e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $af95134c6736175e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $af95134c6736175e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $af95134c6736175e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $af95134c6736175e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $af95134c6736175e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $af95134c6736175e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $af95134c6736175e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $af95134c6736175e$var$_callSuper(t, o, e) {
    return o = $af95134c6736175e$var$_getPrototypeOf(o), $af95134c6736175e$var$_possibleConstructorReturn(t, $af95134c6736175e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $af95134c6736175e$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $af95134c6736175e$var$_possibleConstructorReturn(self, call) {
    if (call && ($af95134c6736175e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $af95134c6736175e$var$_assertThisInitialized(self);
}
function $af95134c6736175e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $af95134c6736175e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($af95134c6736175e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $af95134c6736175e$var$_getPrototypeOf(o) {
    $af95134c6736175e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $af95134c6736175e$var$_getPrototypeOf(o);
}
function $af95134c6736175e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $af95134c6736175e$var$_setPrototypeOf(subClass, superClass);
}
function $af95134c6736175e$var$_setPrototypeOf(o, p) {
    $af95134c6736175e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $af95134c6736175e$var$_setPrototypeOf(o, p);
}
function $af95134c6736175e$var$_defineProperty(obj, key, value) {
    key = $af95134c6736175e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $af95134c6736175e$var$_toPropertyKey(t) {
    var i = $af95134c6736175e$var$_toPrimitive(t, "string");
    return "symbol" == $af95134c6736175e$var$_typeof(i) ? i : i + "";
}
function $af95134c6736175e$var$_toPrimitive(t, r) {
    if ("object" != $af95134c6736175e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $af95134c6736175e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $af95134c6736175e$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $af95134c6736175e$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $5ae9151e6322f95b$export$6fe33945eebf9ac8), props);
}
var $af95134c6736175e$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    function Tooltip() {
        $af95134c6736175e$var$_classCallCheck(this, Tooltip);
        return $af95134c6736175e$var$_callSuper(this, Tooltip, arguments);
    }
    $af95134c6736175e$var$_inherits(Tooltip, _PureComponent);
    return $af95134c6736175e$var$_createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, $8aec891402d43cc9$export$b67e33c2fb1535fa)(payload.filter(function(entry) {
                    return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
                }), payloadUniqBy, $af95134c6736175e$var$defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $781694be0f2fd532$export$9e6cee7b86551b9c), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, $af95134c6736175e$var$renderContent(content, $af95134c6736175e$var$_objectSpread($af95134c6736175e$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
}((0, $gIfym.PureComponent));
$af95134c6736175e$var$_defineProperty($af95134c6736175e$export$28c660c63b792dea, "displayName", 'Tooltip');
$af95134c6736175e$var$_defineProperty($af95134c6736175e$export$28c660c63b792dea, "defaultProps", {
    accessibilityLayer: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, $2a28151593e2b6a4$export$98f03c5d19621d70).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});




var $gIfym = parcelRequire("gIfym");



function $f9dff8c513e6748d$var$_extends() {
    $f9dff8c513e6748d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f9dff8c513e6748d$var$_extends.apply(this, arguments);
}
var $f9dff8c513e6748d$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-dot', className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("circle", $f9dff8c513e6748d$var$_extends({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(props, false), (0, $e49003a65b792e53$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};





var $gIfym = parcelRequire("gIfym");








function $5d099b735dcff99e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5d099b735dcff99e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5d099b735dcff99e$var$_typeof(o);
}
function $5d099b735dcff99e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d099b735dcff99e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d099b735dcff99e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5d099b735dcff99e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d099b735dcff99e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5d099b735dcff99e$var$_defineProperty(obj, key, value) {
    key = $5d099b735dcff99e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5d099b735dcff99e$var$_toPropertyKey(t) {
    var i = $5d099b735dcff99e$var$_toPrimitive(t, "string");
    return "symbol" == $5d099b735dcff99e$var$_typeof(i) ? i : i + "";
}
function $5d099b735dcff99e$var$_toPrimitive(t, r) {
    if ("object" != $5d099b735dcff99e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5d099b735dcff99e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $5d099b735dcff99e$var$PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var $5d099b735dcff99e$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $5d099b735dcff99e$var$PREFIX_LIST.reduce(function(res, entry) {
        return $5d099b735dcff99e$var$_objectSpread($5d099b735dcff99e$var$_objectSpread({}, res), {}, $5d099b735dcff99e$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $e6da98f498586b22$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e6da98f498586b22$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e6da98f498586b22$var$_typeof(o);
}
function $e6da98f498586b22$var$_extends() {
    $e6da98f498586b22$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e6da98f498586b22$var$_extends.apply(this, arguments);
}
function $e6da98f498586b22$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e6da98f498586b22$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e6da98f498586b22$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e6da98f498586b22$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e6da98f498586b22$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e6da98f498586b22$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e6da98f498586b22$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e6da98f498586b22$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e6da98f498586b22$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e6da98f498586b22$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e6da98f498586b22$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e6da98f498586b22$var$_callSuper(t, o, e) {
    return o = $e6da98f498586b22$var$_getPrototypeOf(o), $e6da98f498586b22$var$_possibleConstructorReturn(t, $e6da98f498586b22$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $e6da98f498586b22$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $e6da98f498586b22$var$_possibleConstructorReturn(self, call) {
    if (call && ($e6da98f498586b22$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e6da98f498586b22$var$_assertThisInitialized(self);
}
function $e6da98f498586b22$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e6da98f498586b22$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e6da98f498586b22$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $e6da98f498586b22$var$_getPrototypeOf(o) {
    $e6da98f498586b22$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e6da98f498586b22$var$_getPrototypeOf(o);
}
function $e6da98f498586b22$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e6da98f498586b22$var$_setPrototypeOf(subClass, superClass);
}
function $e6da98f498586b22$var$_setPrototypeOf(o, p) {
    $e6da98f498586b22$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e6da98f498586b22$var$_setPrototypeOf(o, p);
}
function $e6da98f498586b22$var$_defineProperty(obj, key, value) {
    key = $e6da98f498586b22$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e6da98f498586b22$var$_toPropertyKey(t) {
    var i = $e6da98f498586b22$var$_toPrimitive(t, "string");
    return "symbol" == $e6da98f498586b22$var$_typeof(i) ? i : i + "";
}
function $e6da98f498586b22$var$_toPrimitive(t, r) {
    if ("object" != $e6da98f498586b22$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e6da98f498586b22$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $e6da98f498586b22$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $391ea09682974c37$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($fbafef0136c05c9e$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $e6da98f498586b22$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $e6da98f498586b22$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    function Brush(props) {
        var _this;
        $e6da98f498586b22$var$_classCallCheck(this, Brush);
        _this = $e6da98f498586b22$var$_callSuper(this, Brush, [
            props
        ]);
        $e6da98f498586b22$var$_defineProperty(_this, "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $e6da98f498586b22$var$_defineProperty(_this, "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $e6da98f498586b22$var$_defineProperty(_this, "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        $e6da98f498586b22$var$_defineProperty(_this, "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $e6da98f498586b22$var$_defineProperty(_this, "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $e6da98f498586b22$var$_defineProperty(_this, "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $e6da98f498586b22$var$_defineProperty(_this, "handleSlideDragStart", function(e) {
            var event = $e6da98f498586b22$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
            endX: _this.handleTravellerDragStart.bind(_this, 'endX')
        };
        _this.state = {};
        return _this;
    }
    $e6da98f498586b22$var$_inherits(Brush, _PureComponent);
    return $e6da98f498586b22$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, $2cf058a100d782d5$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener('mouseup', this.handleDragEnd, true);
                window.addEventListener('touchend', this.handleDragEnd, true);
                window.addEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener('mouseup', this.handleDragEnd, true);
                window.removeEventListener('touchend', this.handleDragEnd, true);
                window.removeEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $e6da98f498586b22$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState($e6da98f498586b22$var$_defineProperty($e6da98f498586b22$var$_defineProperty({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e.pageX), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === 'startX' && newScaleValue >= endX || id === 'endX' && newScaleValue <= startX) return;
                this.setState($e6da98f498586b22$var$_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, $gIfym.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _data$startIndex, _data$endIndex, _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $e6da98f498586b22$var$_objectSpread($e6da98f498586b22$var$_objectSpread({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(this.props, false)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat((_data$startIndex = data[startIndex]) === null || _data$startIndex === void 0 ? void 0 : _data$startIndex.name, ", Max value: ").concat((_data$endIndex = data[endIndex]) === null || _data$endIndex === void 0 ? void 0 : _data$endIndex.name);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            'ArrowLeft',
                            'ArrowRight'
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === 'ArrowRight' ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: 'col-resize'
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: 'move'
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: 'none',
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $af1dbcbd2651f0c2$export$5f1af8db9871e1d6), $e6da98f498586b22$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $af1dbcbd2651f0c2$export$5f1af8db9871e1d6), $e6da98f498586b22$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(x) || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(y) || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(width) || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-brush', className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Children.count(children) === 1;
                var style = (0, $5d099b735dcff99e$export$4a9169b65825efee)('userSelect', 'none');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $e6da98f498586b22$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $e6da98f498586b22$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
}((0, $gIfym.PureComponent));
$e6da98f498586b22$var$_defineProperty($e6da98f498586b22$export$59bc2e3533b384a0, "displayName", 'Brush');
$e6da98f498586b22$var$_defineProperty($e6da98f498586b22$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: '#fff',
    stroke: '#666',
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});






var $gIfym = parcelRequire("gIfym");






var $10d35130dcb23818$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = 'extendDomain';
    return ifOverflow === value;
};


var $63f3f97972f1ed9a$exports = {};
var $ed324f8195585aed$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $ed324f8195585aed$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $72343bff8b826eca$exports) $72343bff8b826eca$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$ed324f8195585aed$exports = $ed324f8195585aed$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $63f3f97972f1ed9a$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $72536eccaddefa03$exports(iteratee, 3);
    $dce2671156e34347$exports(object, function(value, key, object) {
        $ed324f8195585aed$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$63f3f97972f1ed9a$exports = $63f3f97972f1ed9a$var$mapValues;


var $02abbc95cc352360$exports = {};
var $2ec1fba37eb01fad$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $2ec1fba37eb01fad$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$2ec1fba37eb01fad$exports = $2ec1fba37eb01fad$var$arrayEvery;


var $1325722f3bace2e7$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $1325722f3bace2e7$var$baseEvery(collection, predicate) {
    var result = true;
    $4294681764bc38bd$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$1325722f3bace2e7$exports = $1325722f3bace2e7$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $02abbc95cc352360$var$every(collection, predicate, guard) {
    var func = $9ddb8a7a9343d289$exports(collection) ? $2ec1fba37eb01fad$exports : $1325722f3bace2e7$exports;
    if (guard && $3c6bc6c2e4316f7b$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $72536eccaddefa03$exports(predicate, 3));
}
$02abbc95cc352360$exports = $02abbc95cc352360$var$every;






function $41567e62448fdc32$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $41567e62448fdc32$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $41567e62448fdc32$var$_typeof(o);
}
function $41567e62448fdc32$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $41567e62448fdc32$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $41567e62448fdc32$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $41567e62448fdc32$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $41567e62448fdc32$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $41567e62448fdc32$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $41567e62448fdc32$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41567e62448fdc32$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41567e62448fdc32$var$ownKeys(Object(t), !0).forEach(function(r) {
            $41567e62448fdc32$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41567e62448fdc32$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $41567e62448fdc32$var$_defineProperty(obj, key, value) {
    key = $41567e62448fdc32$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $41567e62448fdc32$var$_toPropertyKey(t) {
    var i = $41567e62448fdc32$var$_toPrimitive(t, "string");
    return "symbol" == $41567e62448fdc32$var$_typeof(i) ? i : i + "";
}
function $41567e62448fdc32$var$_toPrimitive(t, r) {
    if ("object" != $41567e62448fdc32$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $41567e62448fdc32$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $41567e62448fdc32$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $49516a074167c4be$export$64c61536a2b72e0f)(children, (0, $7f0f02843a7c30b4$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort((0, $938aefa455a73c9b$export$6ab1df3197f7c641));
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            if (Number.isFinite(smallestDistanceBetweenValues)) {
                var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
                var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
                if (axis.padding === 'gap') calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
                if (axis.padding === 'no-gap') {
                    var gap = (0, $938aefa455a73c9b$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                    var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                    calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
                }
            }
        }
        if (axisType === 'xAxis') range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === 'yAxis') range = layout === 'horizontal' ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $2cf058a100d782d5$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $2cf058a100d782d5$export$9d80152e23bae434)(scale);
        var ticks = (0, $2cf058a100d782d5$export$ac086aaa4358d590)(scale, $41567e62448fdc32$var$_objectSpread($41567e62448fdc32$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === 'xAxis') {
            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === 'yAxis') {
            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $41567e62448fdc32$var$_objectSpread($41567e62448fdc32$var$_objectSpread($41567e62448fdc32$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === 'xAxis' ? offset.width : axis.width,
            height: axisType === 'yAxis' ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $2cf058a100d782d5$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === 'xAxis') steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $41567e62448fdc32$var$_objectSpread($41567e62448fdc32$var$_objectSpread({}, result), {}, $41567e62448fdc32$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $41567e62448fdc32$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $41567e62448fdc32$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $41567e62448fdc32$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $41567e62448fdc32$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $41567e62448fdc32$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    return $41567e62448fdc32$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case 'start':
                        return this.scale(value);
                    case 'middle':
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case 'end':
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
}();
$41567e62448fdc32$var$_defineProperty($41567e62448fdc32$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $41567e62448fdc32$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $41567e62448fdc32$var$_objectSpread($41567e62448fdc32$var$_objectSpread({}, res), {}, $41567e62448fdc32$var$_defineProperty({}, key, $41567e62448fdc32$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $41567e62448fdc32$var$_objectSpread($41567e62448fdc32$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($63f3f97972f1ed9a$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($02abbc95cc352360$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $41567e62448fdc32$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $41567e62448fdc32$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $41567e62448fdc32$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};




function $2ed52b2e170ac683$var$_extends() {
    $2ed52b2e170ac683$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2ed52b2e170ac683$var$_extends.apply(this, arguments);
}
function $2ed52b2e170ac683$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ed52b2e170ac683$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ed52b2e170ac683$var$_typeof(o);
}
function $2ed52b2e170ac683$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ed52b2e170ac683$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ed52b2e170ac683$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2ed52b2e170ac683$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ed52b2e170ac683$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2ed52b2e170ac683$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2ed52b2e170ac683$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2ed52b2e170ac683$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $2ed52b2e170ac683$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2ed52b2e170ac683$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2ed52b2e170ac683$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2ed52b2e170ac683$var$_callSuper(t, o, e) {
    return o = $2ed52b2e170ac683$var$_getPrototypeOf(o), $2ed52b2e170ac683$var$_possibleConstructorReturn(t, $2ed52b2e170ac683$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $2ed52b2e170ac683$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $2ed52b2e170ac683$var$_possibleConstructorReturn(self, call) {
    if (call && ($2ed52b2e170ac683$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $2ed52b2e170ac683$var$_assertThisInitialized(self);
}
function $2ed52b2e170ac683$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2ed52b2e170ac683$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2ed52b2e170ac683$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $2ed52b2e170ac683$var$_getPrototypeOf(o) {
    $2ed52b2e170ac683$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2ed52b2e170ac683$var$_getPrototypeOf(o);
}
function $2ed52b2e170ac683$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $2ed52b2e170ac683$var$_setPrototypeOf(subClass, superClass);
}
function $2ed52b2e170ac683$var$_setPrototypeOf(o, p) {
    $2ed52b2e170ac683$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2ed52b2e170ac683$var$_setPrototypeOf(o, p);
}
function $2ed52b2e170ac683$var$_defineProperty(obj, key, value) {
    key = $2ed52b2e170ac683$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2ed52b2e170ac683$var$_toPropertyKey(t) {
    var i = $2ed52b2e170ac683$var$_toPrimitive(t, "string");
    return "symbol" == $2ed52b2e170ac683$var$_typeof(i) ? i : i + "";
}
function $2ed52b2e170ac683$var$_toPrimitive(t, r) {
    if ("object" != $2ed52b2e170ac683$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2ed52b2e170ac683$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2ed52b2e170ac683$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $41567e62448fdc32$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $10d35130dcb23818$export$3fb112445eb31879)(props, 'discard') && !scales.isInRange(result)) return null;
    return result;
};
var $2ed52b2e170ac683$export$aa7f0b0106bff39 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceDot() {
        $2ed52b2e170ac683$var$_classCallCheck(this, ReferenceDot);
        return $2ed52b2e170ac683$var$_callSuper(this, ReferenceDot, arguments);
    }
    $2ed52b2e170ac683$var$_inherits(ReferenceDot, _React$Component);
    return $2ed52b2e170ac683$var$_createClass(ReferenceDot, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, r = _this$props.r, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                var isX = (0, $938aefa455a73c9b$export$402a499e1ea44294)(x);
                var isY = (0, $938aefa455a73c9b$export$402a499e1ea44294)(y);
                (0, $0eb6b0656d09fb9a$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                if (!isX || !isY) return null;
                var coordinate = $2ed52b2e170ac683$var$getCoordinate(this.props);
                if (!coordinate) return null;
                var cx = coordinate.x, cy = coordinate.y;
                var _this$props2 = this.props, shape = _this$props2.shape, className = _this$props2.className;
                var clipPath = (0, $10d35130dcb23818$export$3fb112445eb31879)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                var dotProps = $2ed52b2e170ac683$var$_objectSpread($2ed52b2e170ac683$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $49516a074167c4be$export$d697c39a2985a4c)(this.props, true)), {}, {
                    cx: cx,
                    cy: cy
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
                    className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-reference-dot', className)
                }, ReferenceDot.renderDot(shape, dotProps), (0, $0e68a54aec8ebf8f$export$b04be29aa201d4f5).renderCallByParent(this.props, {
                    x: cx - r,
                    y: cy - r,
                    width: 2 * r,
                    height: 2 * r
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$2ed52b2e170ac683$var$_defineProperty($2ed52b2e170ac683$export$aa7f0b0106bff39, "displayName", 'ReferenceDot');
$2ed52b2e170ac683$var$_defineProperty($2ed52b2e170ac683$export$aa7f0b0106bff39, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#fff',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1
});
$2ed52b2e170ac683$var$_defineProperty($2ed52b2e170ac683$export$aa7f0b0106bff39, "renderDot", function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f9dff8c513e6748d$export$d046b3c4a416f60d), $2ed52b2e170ac683$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
});



var $gIfym = parcelRequire("gIfym");

var $87911b45411f5fdc$exports = {};


var $6baac0141d46637b$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $6baac0141d46637b$var$baseSome(collection, predicate) {
    var result;
    $4294681764bc38bd$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$6baac0141d46637b$exports = $6baac0141d46637b$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $87911b45411f5fdc$var$some(collection, predicate, guard) {
    var func = $9ddb8a7a9343d289$exports(collection) ? $5b91008bcd74ad68$exports : $6baac0141d46637b$exports;
    if (guard && $3c6bc6c2e4316f7b$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $72536eccaddefa03$exports(predicate, 3));
}
$87911b45411f5fdc$exports = $87911b45411f5fdc$var$some;











var $gIfym = parcelRequire("gIfym");

var $d780967e93a545f3$exports = {};
var $0d8f2cf638f1ec00$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $0d8f2cf638f1ec00$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$27e5d73ea889a418$exports(collection)) {
            var iteratee = $72536eccaddefa03$exports(predicate, 3);
            collection = $09df402023a7d8be$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$0d8f2cf638f1ec00$exports = $0d8f2cf638f1ec00$var$createFind;


var $d5c8978dfcfb553b$exports = {};


var $625fb8ecb4384e54$exports = {};

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $625fb8ecb4384e54$var$toInteger(value) {
    var result = $cc1fa9938b04eaf5$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$625fb8ecb4384e54$exports = $625fb8ecb4384e54$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $d5c8978dfcfb553b$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $d5c8978dfcfb553b$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $625fb8ecb4384e54$exports(fromIndex);
    if (index < 0) index = $d5c8978dfcfb553b$var$nativeMax(length + index, 0);
    return $473b8469d73623c0$exports(array, $72536eccaddefa03$exports(predicate, 3), index);
}
$d5c8978dfcfb553b$exports = $d5c8978dfcfb553b$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $d780967e93a545f3$var$find = $0d8f2cf638f1ec00$exports($d5c8978dfcfb553b$exports);
$d780967e93a545f3$exports = $d780967e93a545f3$var$find;




var $797b93dde5a709f3$export$7e29f973febe72ad = (0, (/*@__PURE__*/$parcel$interopDefault($f201d6f0c7a11898$exports)))(function(offset) {
    return {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
}, function(offset) {
    return [
        'l',
        offset.left,
        't',
        offset.top,
        'w',
        offset.width,
        'h',
        offset.height
    ].join('');
});



function $25bdd3424767d42d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $25bdd3424767d42d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $25bdd3424767d42d$var$_typeof(o);
}
var $25bdd3424767d42d$export$92c2a2c8239475bf = /*#__PURE__*/ (0, $gIfym.createContext)(undefined);
var $25bdd3424767d42d$export$40ceabe61e17c4dc = /*#__PURE__*/ (0, $gIfym.createContext)(undefined);
var $25bdd3424767d42d$export$29b7735f8b5653b2 = /*#__PURE__*/ (0, $gIfym.createContext)(undefined);
var $25bdd3424767d42d$export$482c85f2026f212e = /*#__PURE__*/ (0, $gIfym.createContext)({});
var $25bdd3424767d42d$export$e42cfe3f3988c70f = /*#__PURE__*/ (0, $gIfym.createContext)(undefined);
var $25bdd3424767d42d$export$b18854f928720bc8 = /*#__PURE__*/ (0, $gIfym.createContext)(0);
var $25bdd3424767d42d$export$3c3f0c9338cf7530 = /*#__PURE__*/ (0, $gIfym.createContext)(0);
var $25bdd3424767d42d$export$e22c0f72c980af5a = function ChartLayoutContextProvider(props) {
    var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width = props.width, height = props.height;
    /**
   * Perhaps we should compute this property when reading? Let's see what is more often used
   */ var viewBox = (0, $797b93dde5a709f3$export$7e29f973febe72ad)(offset);
    /*
   * This pretends to be a single context but actually is split into multiple smaller ones.
   * Why?
   * Because one React Context only allows to set one value.
   * But we need to set multiple values.
   * If we do that with one context, then we force re-render on components that might not even be interested
   * in the part of the state that has changed.
   *
   * By splitting into smaller contexts, we allow each components to be optimized and only re-render when its dependencies change.
   *
   * To actually achieve the optimal re-render, it is necessary to use React.memo().
   * See the test file for details.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($25bdd3424767d42d$export$92c2a2c8239475bf.Provider, {
        value: xAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($25bdd3424767d42d$export$40ceabe61e17c4dc.Provider, {
        value: yAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($25bdd3424767d42d$export$482c85f2026f212e.Provider, {
        value: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($25bdd3424767d42d$export$29b7735f8b5653b2.Provider, {
        value: viewBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($25bdd3424767d42d$export$e42cfe3f3988c70f.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($25bdd3424767d42d$export$b18854f928720bc8.Provider, {
        value: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($25bdd3424767d42d$export$3c3f0c9338cf7530.Provider, {
        value: width
    }, children)))))));
};
var $25bdd3424767d42d$export$71e825c43eae6ca6 = function useClipPathId() {
    return (0, $gIfym.useContext)($25bdd3424767d42d$export$e42cfe3f3988c70f);
};
function $25bdd3424767d42d$var$getKeysForDebug(object) {
    var keys = Object.keys(object);
    if (keys.length === 0) return 'There are no available ids.';
    return "Available ids are: ".concat(keys, ".");
}
var $25bdd3424767d42d$export$54f54805c81085c5 = function useXAxisOrThrow(xAxisId) {
    var xAxisMap = (0, $gIfym.useContext)($25bdd3424767d42d$export$92c2a2c8239475bf);
    !(xAxisMap != null) && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
    var xAxis = xAxisMap[xAxisId];
    !(xAxis != null) && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
    return xAxis;
};
var $25bdd3424767d42d$export$1d855c2865750a72 = function useArbitraryXAxis() {
    var xAxisMap = (0, $gIfym.useContext)($25bdd3424767d42d$export$92c2a2c8239475bf);
    return (0, $938aefa455a73c9b$export$b88993f0aa0bf776)(xAxisMap);
};
var $25bdd3424767d42d$export$a691147b33d52613 = function useArbitraryYAxis() {
    var yAxisMap = (0, $gIfym.useContext)($25bdd3424767d42d$export$40ceabe61e17c4dc);
    return (0, $938aefa455a73c9b$export$b88993f0aa0bf776)(yAxisMap);
};
var $25bdd3424767d42d$export$631ee617f1052e16 = function useYAxisWithFiniteDomainOrRandom() {
    var yAxisMap = (0, $gIfym.useContext)($25bdd3424767d42d$export$40ceabe61e17c4dc);
    var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($d780967e93a545f3$exports)))(yAxisMap, function(axis) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($02abbc95cc352360$exports)))(axis.domain, Number.isFinite);
    });
    return yAxisWithFiniteDomain || (0, $938aefa455a73c9b$export$b88993f0aa0bf776)(yAxisMap);
};
var $25bdd3424767d42d$export$6f8958021ad81c20 = function useYAxisOrThrow(yAxisId) {
    var yAxisMap = (0, $gIfym.useContext)($25bdd3424767d42d$export$40ceabe61e17c4dc);
    !(yAxisMap != null) && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
    var yAxis = yAxisMap[yAxisId];
    !(yAxis != null) && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
    return yAxis;
};
var $25bdd3424767d42d$export$76b29bb074e0c45a = function useViewBox() {
    var viewBox = (0, $gIfym.useContext)($25bdd3424767d42d$export$29b7735f8b5653b2);
    return viewBox;
};
var $25bdd3424767d42d$export$99e5207fa7e69f17 = function useOffset() {
    return (0, $gIfym.useContext)($25bdd3424767d42d$export$482c85f2026f212e);
};
var $25bdd3424767d42d$export$8854f7ece606854b = function useChartWidth() {
    return (0, $gIfym.useContext)($25bdd3424767d42d$export$3c3f0c9338cf7530);
};
var $25bdd3424767d42d$export$369ae257969c6f9f = function useChartHeight() {
    return (0, $gIfym.useContext)($25bdd3424767d42d$export$b18854f928720bc8);
};


function $67157f46d9407305$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $67157f46d9407305$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $67157f46d9407305$var$_typeof(o);
}
function $67157f46d9407305$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $67157f46d9407305$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $67157f46d9407305$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $67157f46d9407305$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $67157f46d9407305$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $67157f46d9407305$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $67157f46d9407305$var$_callSuper(t, o, e) {
    return o = $67157f46d9407305$var$_getPrototypeOf(o), $67157f46d9407305$var$_possibleConstructorReturn(t, $67157f46d9407305$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $67157f46d9407305$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $67157f46d9407305$var$_possibleConstructorReturn(self, call) {
    if (call && ($67157f46d9407305$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $67157f46d9407305$var$_assertThisInitialized(self);
}
function $67157f46d9407305$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $67157f46d9407305$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($67157f46d9407305$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $67157f46d9407305$var$_getPrototypeOf(o) {
    $67157f46d9407305$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $67157f46d9407305$var$_getPrototypeOf(o);
}
function $67157f46d9407305$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $67157f46d9407305$var$_setPrototypeOf(subClass, superClass);
}
function $67157f46d9407305$var$_setPrototypeOf(o, p) {
    $67157f46d9407305$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $67157f46d9407305$var$_setPrototypeOf(o, p);
}
function $67157f46d9407305$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $67157f46d9407305$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $67157f46d9407305$var$ownKeys(Object(t), !0).forEach(function(r) {
            $67157f46d9407305$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $67157f46d9407305$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $67157f46d9407305$var$_defineProperty(obj, key, value) {
    key = $67157f46d9407305$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $67157f46d9407305$var$_toPropertyKey(t) {
    var i = $67157f46d9407305$var$_toPrimitive(t, "string");
    return "symbol" == $67157f46d9407305$var$_typeof(i) ? i : i + "";
}
function $67157f46d9407305$var$_toPrimitive(t, r) {
    if ("object" != $67157f46d9407305$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $67157f46d9407305$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $67157f46d9407305$var$_slicedToArray(arr, i) {
    return $67157f46d9407305$var$_arrayWithHoles(arr) || $67157f46d9407305$var$_iterableToArrayLimit(arr, i) || $67157f46d9407305$var$_unsupportedIterableToArray(arr, i) || $67157f46d9407305$var$_nonIterableRest();
}
function $67157f46d9407305$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $67157f46d9407305$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $67157f46d9407305$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $67157f46d9407305$var$_arrayLikeToArray(o, minLen);
}
function $67157f46d9407305$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $67157f46d9407305$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $67157f46d9407305$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $67157f46d9407305$var$_extends() {
    $67157f46d9407305$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $67157f46d9407305$var$_extends.apply(this, arguments);
}
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */ var $67157f46d9407305$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("line", $67157f46d9407305$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
var $67157f46d9407305$export$f273d496b213b6da = function getEndPoints(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (isFixedY) {
        var yCoord = props.y;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $10d35130dcb23818$export$3fb112445eb31879)(props, 'discard') && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return yAxisOrientation === 'left' ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $10d35130dcb23818$export$3fb112445eb31879)(props, 'discard') && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return xAxisOrientation === 'top' ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $10d35130dcb23818$export$3fb112445eb31879)(props, 'discard') && (0, (/*@__PURE__*/$parcel$interopDefault($87911b45411f5fdc$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $67157f46d9407305$var$ReferenceLineImpl(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
    var clipPathId = (0, $25bdd3424767d42d$export$71e825c43eae6ca6)();
    var xAxis = (0, $25bdd3424767d42d$export$54f54805c81085c5)(xAxisId);
    var yAxis = (0, $25bdd3424767d42d$export$6f8958021ad81c20)(yAxisId);
    var viewBox = (0, $25bdd3424767d42d$export$76b29bb074e0c45a)();
    if (!clipPathId || !viewBox) return null;
    (0, $0eb6b0656d09fb9a$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $41567e62448fdc32$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $938aefa455a73c9b$export$402a499e1ea44294)(fixedX);
    var isY = (0, $938aefa455a73c9b$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $67157f46d9407305$export$f273d496b213b6da(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
    if (!endPoints) return null;
    var _endPoints = $67157f46d9407305$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $10d35130dcb23818$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $67157f46d9407305$var$_objectSpread($67157f46d9407305$var$_objectSpread({
        clipPath: clipPath
    }, (0, $49516a074167c4be$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
        className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-reference-line', className)
    }, $67157f46d9407305$var$renderLine(shape, lineProps), (0, $0e68a54aec8ebf8f$export$b04be29aa201d4f5).renderCallByParent(props, (0, $41567e62448fdc32$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
var $67157f46d9407305$export$b2f28e248e7838eb = /*#__PURE__*/ function(_React$Component) {
    function ReferenceLine() {
        $67157f46d9407305$var$_classCallCheck(this, ReferenceLine);
        return $67157f46d9407305$var$_callSuper(this, ReferenceLine, arguments);
    }
    $67157f46d9407305$var$_inherits(ReferenceLine, _React$Component);
    return $67157f46d9407305$var$_createClass(ReferenceLine, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($67157f46d9407305$var$ReferenceLineImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$67157f46d9407305$var$_defineProperty($67157f46d9407305$export$b2f28e248e7838eb, "displayName", 'ReferenceLine');
$67157f46d9407305$var$_defineProperty($67157f46d9407305$export$b2f28e248e7838eb, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    fill: 'none',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1,
    position: 'middle'
});



var $gIfym = parcelRequire("gIfym");










function $ff8faf15a9386073$var$_extends() {
    $ff8faf15a9386073$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ff8faf15a9386073$var$_extends.apply(this, arguments);
}
function $ff8faf15a9386073$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ff8faf15a9386073$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ff8faf15a9386073$var$_typeof(o);
}
function $ff8faf15a9386073$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ff8faf15a9386073$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ff8faf15a9386073$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ff8faf15a9386073$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ff8faf15a9386073$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ff8faf15a9386073$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ff8faf15a9386073$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ff8faf15a9386073$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ff8faf15a9386073$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ff8faf15a9386073$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ff8faf15a9386073$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ff8faf15a9386073$var$_callSuper(t, o, e) {
    return o = $ff8faf15a9386073$var$_getPrototypeOf(o), $ff8faf15a9386073$var$_possibleConstructorReturn(t, $ff8faf15a9386073$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $ff8faf15a9386073$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $ff8faf15a9386073$var$_possibleConstructorReturn(self, call) {
    if (call && ($ff8faf15a9386073$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ff8faf15a9386073$var$_assertThisInitialized(self);
}
function $ff8faf15a9386073$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ff8faf15a9386073$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ff8faf15a9386073$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ff8faf15a9386073$var$_getPrototypeOf(o) {
    $ff8faf15a9386073$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ff8faf15a9386073$var$_getPrototypeOf(o);
}
function $ff8faf15a9386073$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ff8faf15a9386073$var$_setPrototypeOf(subClass, superClass);
}
function $ff8faf15a9386073$var$_setPrototypeOf(o, p) {
    $ff8faf15a9386073$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ff8faf15a9386073$var$_setPrototypeOf(o, p);
}
function $ff8faf15a9386073$var$_defineProperty(obj, key, value) {
    key = $ff8faf15a9386073$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ff8faf15a9386073$var$_toPropertyKey(t) {
    var i = $ff8faf15a9386073$var$_toPrimitive(t, "string");
    return "symbol" == $ff8faf15a9386073$var$_typeof(i) ? i : i + "";
}
function $ff8faf15a9386073$var$_toPrimitive(t, r) {
    if ("object" != $ff8faf15a9386073$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ff8faf15a9386073$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ff8faf15a9386073$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $41567e62448fdc32$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: 'start'
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: 'start'
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: 'end'
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: 'end'
        }) : scales.y.rangeMax
    };
    if ((0, $10d35130dcb23818$export$3fb112445eb31879)(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $41567e62448fdc32$export$c7964a5b9439ae62)(p1, p2);
};
var $ff8faf15a9386073$export$b4ec4f050ce240b9 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceArea() {
        $ff8faf15a9386073$var$_classCallCheck(this, ReferenceArea);
        return $ff8faf15a9386073$var$_callSuper(this, ReferenceArea, arguments);
    }
    $ff8faf15a9386073$var$_inherits(ReferenceArea, _React$Component);
    return $ff8faf15a9386073$var$_createClass(ReferenceArea, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x1 = _this$props.x1, x2 = _this$props.x2, y1 = _this$props.y1, y2 = _this$props.y2, className = _this$props.className, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                (0, $0eb6b0656d09fb9a$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                var hasX1 = (0, $938aefa455a73c9b$export$402a499e1ea44294)(x1);
                var hasX2 = (0, $938aefa455a73c9b$export$402a499e1ea44294)(x2);
                var hasY1 = (0, $938aefa455a73c9b$export$402a499e1ea44294)(y1);
                var hasY2 = (0, $938aefa455a73c9b$export$402a499e1ea44294)(y2);
                var shape = this.props.shape;
                if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
                var rect = $ff8faf15a9386073$var$getRect(hasX1, hasX2, hasY1, hasY2, this.props);
                if (!rect && !shape) return null;
                var clipPath = (0, $10d35130dcb23818$export$3fb112445eb31879)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
                    className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-reference-area', className)
                }, ReferenceArea.renderRect(shape, $ff8faf15a9386073$var$_objectSpread($ff8faf15a9386073$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $49516a074167c4be$export$d697c39a2985a4c)(this.props, true)), rect)), (0, $0e68a54aec8ebf8f$export$b04be29aa201d4f5).renderCallByParent(this.props, rect));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$ff8faf15a9386073$var$_defineProperty($ff8faf15a9386073$export$b4ec4f050ce240b9, "displayName", 'ReferenceArea');
$ff8faf15a9386073$var$_defineProperty($ff8faf15a9386073$export$b4ec4f050ce240b9, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#ccc',
    fillOpacity: 0.5,
    stroke: 'none',
    strokeWidth: 1
});
$ff8faf15a9386073$var$_defineProperty($ff8faf15a9386073$export$b4ec4f050ce240b9, "renderRect", function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $25b2a5d5dc6ab71a$export$4617fb02663045ef), $ff8faf15a9386073$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
});





function $4ddd823ae64c4d04$var$_toConsumableArray(arr) {
    return $4ddd823ae64c4d04$var$_arrayWithoutHoles(arr) || $4ddd823ae64c4d04$var$_iterableToArray(arr) || $4ddd823ae64c4d04$var$_unsupportedIterableToArray(arr) || $4ddd823ae64c4d04$var$_nonIterableSpread();
}
function $4ddd823ae64c4d04$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4ddd823ae64c4d04$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4ddd823ae64c4d04$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4ddd823ae64c4d04$var$_arrayLikeToArray(o, minLen);
}
function $4ddd823ae64c4d04$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $4ddd823ae64c4d04$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $4ddd823ae64c4d04$var$_arrayLikeToArray(arr);
}
function $4ddd823ae64c4d04$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $4ddd823ae64c4d04$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $49516a074167c4be$export$fdd5e64c0e8495bb)(children, (0, $67157f46d9407305$export$b2f28e248e7838eb));
    var dots = (0, $49516a074167c4be$export$fdd5e64c0e8495bb)(children, (0, $2ed52b2e170ac683$export$aa7f0b0106bff39));
    var elements = [].concat($4ddd823ae64c4d04$var$_toConsumableArray(lines), $4ddd823ae64c4d04$var$_toConsumableArray(dots));
    var areas = (0, $49516a074167c4be$export$fdd5e64c0e8495bb)(children, (0, $ff8faf15a9386073$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $10d35130dcb23818$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $10d35130dcb23818$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(el.props[key1]) && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $938aefa455a73c9b$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $b8a40edbba25f581$exports = {};
'use strict';
var $b8a40edbba25f581$var$has = Object.prototype.hasOwnProperty, $b8a40edbba25f581$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $b8a40edbba25f581$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $b8a40edbba25f581$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $b8a40edbba25f581$var$Events().__proto__) $b8a40edbba25f581$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $b8a40edbba25f581$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $b8a40edbba25f581$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $b8a40edbba25f581$var$EE(fn, context || emitter, once), evt = $b8a40edbba25f581$var$prefix ? $b8a40edbba25f581$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $b8a40edbba25f581$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $b8a40edbba25f581$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $b8a40edbba25f581$var$EventEmitter() {
    this._events = new $b8a40edbba25f581$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $b8a40edbba25f581$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($b8a40edbba25f581$var$has.call(events, name)) names.push($b8a40edbba25f581$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $b8a40edbba25f581$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $b8a40edbba25f581$var$prefix ? $b8a40edbba25f581$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $b8a40edbba25f581$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $b8a40edbba25f581$var$prefix ? $b8a40edbba25f581$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $b8a40edbba25f581$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $b8a40edbba25f581$var$prefix ? $b8a40edbba25f581$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $b8a40edbba25f581$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $b8a40edbba25f581$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $b8a40edbba25f581$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $b8a40edbba25f581$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $b8a40edbba25f581$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $b8a40edbba25f581$var$prefix ? $b8a40edbba25f581$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $b8a40edbba25f581$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $b8a40edbba25f581$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $b8a40edbba25f581$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $b8a40edbba25f581$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $b8a40edbba25f581$var$prefix ? $b8a40edbba25f581$var$prefix + event : event;
        if (this._events[evt]) $b8a40edbba25f581$var$clearEvent(this, evt);
    } else {
        this._events = new $b8a40edbba25f581$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$b8a40edbba25f581$var$EventEmitter.prototype.off = $b8a40edbba25f581$var$EventEmitter.prototype.removeListener;
$b8a40edbba25f581$var$EventEmitter.prototype.addListener = $b8a40edbba25f581$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$b8a40edbba25f581$var$EventEmitter.prefixed = $b8a40edbba25f581$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$b8a40edbba25f581$var$EventEmitter.EventEmitter = $b8a40edbba25f581$var$EventEmitter;
$b8a40edbba25f581$exports = $b8a40edbba25f581$var$EventEmitter;


var $93eefb1af259cca0$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($b8a40edbba25f581$exports)))();
var $93eefb1af259cca0$export$ff9a08f6d0c38b8f = 'recharts.syncMouseEvents';



function $ae96119a38fb5474$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ae96119a38fb5474$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ae96119a38fb5474$var$_typeof(o);
}
function $ae96119a38fb5474$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ae96119a38fb5474$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ae96119a38fb5474$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ae96119a38fb5474$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ae96119a38fb5474$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ae96119a38fb5474$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ae96119a38fb5474$var$_defineProperty(obj, key, value) {
    key = $ae96119a38fb5474$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ae96119a38fb5474$var$_toPropertyKey(t) {
    var i = $ae96119a38fb5474$var$_toPrimitive(t, "string");
    return "symbol" == $ae96119a38fb5474$var$_typeof(i) ? i : i + "";
}
function $ae96119a38fb5474$var$_toPrimitive(t, r) {
    if ("object" != $ae96119a38fb5474$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ae96119a38fb5474$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ae96119a38fb5474$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $ae96119a38fb5474$var$_classCallCheck(this, AccessibilityManager);
        $ae96119a38fb5474$var$_defineProperty(this, "activeIndex", 0);
        $ae96119a38fb5474$var$_defineProperty(this, "coordinateList", []);
        $ae96119a38fb5474$var$_defineProperty(this, "layout", 'horizontal');
    }
    return $ae96119a38fb5474$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref2;
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case 'ArrowRight':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case 'ArrowLeft':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "setIndex",
            value: function setIndex(newIndex) {
                this.activeIndex = newIndex;
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== 'horizontal') return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
}();



function $dc82afd978f7b76b$export$33279f645a5831b7(domain, allowDataOverflow, axisType) {
    if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(domainStart) && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}




var $gIfym = parcelRequire("gIfym");


var $gIfym = parcelRequire("gIfym");







function $2df235e87c4a83c7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2df235e87c4a83c7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2df235e87c4a83c7$var$_typeof(o);
}
function $2df235e87c4a83c7$var$_extends() {
    $2df235e87c4a83c7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2df235e87c4a83c7$var$_extends.apply(this, arguments);
}
function $2df235e87c4a83c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2df235e87c4a83c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2df235e87c4a83c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2df235e87c4a83c7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2df235e87c4a83c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2df235e87c4a83c7$var$_defineProperty(obj, key, value) {
    key = $2df235e87c4a83c7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2df235e87c4a83c7$var$_toPropertyKey(t) {
    var i = $2df235e87c4a83c7$var$_toPrimitive(t, "string");
    return "symbol" == $2df235e87c4a83c7$var$_typeof(i) ? i : i + "";
}
function $2df235e87c4a83c7$var$_toPrimitive(t, r) {
    if ("object" != $2df235e87c4a83c7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2df235e87c4a83c7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2df235e87c4a83c7$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $b8df57eaf33776d8$exports.curveBasisClosed),
    curveBasisOpen: (0, $b8df57eaf33776d8$exports.curveBasisOpen),
    curveBasis: (0, $b8df57eaf33776d8$exports.curveBasis),
    curveBumpX: (0, $b8df57eaf33776d8$exports.curveBumpX),
    curveBumpY: (0, $b8df57eaf33776d8$exports.curveBumpY),
    curveLinearClosed: (0, $b8df57eaf33776d8$exports.curveLinearClosed),
    curveLinear: (0, $b8df57eaf33776d8$exports.curveLinear),
    curveMonotoneX: (0, $b8df57eaf33776d8$exports.curveMonotoneX),
    curveMonotoneY: (0, $b8df57eaf33776d8$exports.curveMonotoneY),
    curveNatural: (0, $b8df57eaf33776d8$exports.curveNatural),
    curveStep: (0, $b8df57eaf33776d8$exports.curveStep),
    curveStepAfter: (0, $b8df57eaf33776d8$exports.curveStepAfter),
    curveStepBefore: (0, $b8df57eaf33776d8$exports.curveStepBefore)
};
var $2df235e87c4a83c7$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $2df235e87c4a83c7$var$getX = function getX(p) {
    return p.x;
};
var $2df235e87c4a83c7$var$getY = function getY(p) {
    return p.y;
};
var $2df235e87c4a83c7$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($ecdaa70f26552d44$exports)))(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return $2df235e87c4a83c7$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return $2df235e87c4a83c7$var$CURVE_FACTORIES[name] || (0, $b8df57eaf33776d8$exports.curveLinear);
};
var $2df235e87c4a83c7$export$2aa3fd96c49a84a8 = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'linear' : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = $2df235e87c4a83c7$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $2df235e87c4a83c7$var$defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $2df235e87c4a83c7$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $2df235e87c4a83c7$var$_objectSpread($2df235e87c4a83c7$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === 'vertical') lineFunction = (0, $b8df57eaf33776d8$exports.area)().y($2df235e87c4a83c7$var$getY).x1($2df235e87c4a83c7$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $b8df57eaf33776d8$exports.area)().x($2df235e87c4a83c7$var$getX).y1($2df235e87c4a83c7$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($2df235e87c4a83c7$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === 'vertical' && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $b8df57eaf33776d8$exports.area)().y($2df235e87c4a83c7$var$getY).x1($2df235e87c4a83c7$var$getX).x0(baseLine);
    else if ((0, $938aefa455a73c9b$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $b8df57eaf33776d8$exports.area)().x($2df235e87c4a83c7$var$getX).y1($2df235e87c4a83c7$var$getY).y0(baseLine);
    else lineFunction = (0, $b8df57eaf33776d8$exports.line)().x($2df235e87c4a83c7$var$getX).y($2df235e87c4a83c7$var$getY);
    lineFunction.defined($2df235e87c4a83c7$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $2df235e87c4a83c7$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $2df235e87c4a83c7$export$2aa3fd96c49a84a8(props) : path;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", $2df235e87c4a83c7$var$_extends({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(props, false), (0, $e49003a65b792e53$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-curve', className),
        d: realPath,
        ref: pathRef
    }));
};



var $gIfym = parcelRequire("gIfym");



function $e8cb1d2bb5088631$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e8cb1d2bb5088631$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e8cb1d2bb5088631$var$_typeof(o);
}
var $e8cb1d2bb5088631$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $e8cb1d2bb5088631$var$_extends() {
    $e8cb1d2bb5088631$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e8cb1d2bb5088631$var$_extends.apply(this, arguments);
}
function $e8cb1d2bb5088631$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e8cb1d2bb5088631$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e8cb1d2bb5088631$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e8cb1d2bb5088631$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e8cb1d2bb5088631$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e8cb1d2bb5088631$var$_defineProperty(obj, key, value) {
    key = $e8cb1d2bb5088631$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e8cb1d2bb5088631$var$_toPropertyKey(t) {
    var i = $e8cb1d2bb5088631$var$_toPrimitive(t, "string");
    return "symbol" == $e8cb1d2bb5088631$var$_typeof(i) ? i : i + "";
}
function $e8cb1d2bb5088631$var$_toPrimitive(t, r) {
    if ("object" != $e8cb1d2bb5088631$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e8cb1d2bb5088631$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e8cb1d2bb5088631$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e8cb1d2bb5088631$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e8cb1d2bb5088631$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e8cb1d2bb5088631$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $e8cb1d2bb5088631$export$3c877bb842c36952 = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = $e8cb1d2bb5088631$var$_objectWithoutProperties(_ref, $e8cb1d2bb5088631$var$_excluded);
    var props = $e8cb1d2bb5088631$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $938aefa455a73c9b$export$7e4aa119212bc614)(x) || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(y) || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(width) || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(height) || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(top) || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", $e8cb1d2bb5088631$var$_extends({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(props, true), {
        className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-cross', className),
        d: $e8cb1d2bb5088631$var$getPath(x, y, width, height, top, left)
    }));
};


function $a8ed9184ce61558a$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}




function $1ea8dc1bdb84b89e$export$ad661ef85a042a4f(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}





function $53f0fc1bcad6e25f$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === 'horizontal') {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === 'vertical') {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === 'centric') {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, $1ea8dc1bdb84b89e$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}



function $449e45aeb6304d88$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $449e45aeb6304d88$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $449e45aeb6304d88$var$_typeof(o);
}
function $449e45aeb6304d88$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $449e45aeb6304d88$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $449e45aeb6304d88$var$ownKeys(Object(t), !0).forEach(function(r) {
            $449e45aeb6304d88$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $449e45aeb6304d88$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $449e45aeb6304d88$var$_defineProperty(obj, key, value) {
    key = $449e45aeb6304d88$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $449e45aeb6304d88$var$_toPropertyKey(t) {
    var i = $449e45aeb6304d88$var$_toPrimitive(t, "string");
    return "symbol" == $449e45aeb6304d88$var$_typeof(i) ? i : i + "";
}
function $449e45aeb6304d88$var$_toPrimitive(t, r) {
    if ("object" != $449e45aeb6304d88$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $449e45aeb6304d88$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $449e45aeb6304d88$export$b6a79797ad180576(props) {
    var _element$props$cursor, _defaultProps;
    var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
    var elementPropsCursor = (_element$props$cursor = element.props.cursor) !== null && _element$props$cursor !== void 0 ? _element$props$cursor : (_defaultProps = element.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps.cursor;
    if (!element || !elementPropsCursor || !isActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps;
    var cursorComp = (0, $2df235e87c4a83c7$export$b0e83c3ef8d2db1);
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, $e8cb1d2bb5088631$export$3c877bb842c36952);
    } else if (chartName === 'BarChart') {
        restProps = (0, $a8ed9184ce61558a$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $25b2a5d5dc6ab71a$export$4617fb02663045ef);
    } else if (layout === 'radial') {
        var _getRadialCursorPoint = (0, $1ea8dc1bdb84b89e$export$ad661ef85a042a4f)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $403dd5713dcc2a00$export$e98c2c7eb2b14f45);
    } else {
        restProps = {
            points: (0, $53f0fc1bcad6e25f$export$56e1305620ce5745)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $2df235e87c4a83c7$export$b0e83c3ef8d2db1);
    }
    var cursorProps = $449e45aeb6304d88$var$_objectSpread($449e45aeb6304d88$var$_objectSpread($449e45aeb6304d88$var$_objectSpread($449e45aeb6304d88$var$_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, $49516a074167c4be$export$d697c39a2985a4c)(elementPropsCursor, false)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-tooltip-cursor', elementPropsCursor.className)
    });
    return /*#__PURE__*/ (0, $gIfym.isValidElement)(elementPropsCursor) ? /*#__PURE__*/ (0, $gIfym.cloneElement)(elementPropsCursor, cursorProps) : /*#__PURE__*/ (0, $gIfym.createElement)(cursorComp, cursorProps);
}



var $bbcd5dcaccb206b2$var$_excluded = [
    "item"
], $bbcd5dcaccb206b2$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $bbcd5dcaccb206b2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bbcd5dcaccb206b2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bbcd5dcaccb206b2$var$_typeof(o);
}
function $bbcd5dcaccb206b2$var$_extends() {
    $bbcd5dcaccb206b2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bbcd5dcaccb206b2$var$_extends.apply(this, arguments);
}
function $bbcd5dcaccb206b2$var$_slicedToArray(arr, i) {
    return $bbcd5dcaccb206b2$var$_arrayWithHoles(arr) || $bbcd5dcaccb206b2$var$_iterableToArrayLimit(arr, i) || $bbcd5dcaccb206b2$var$_unsupportedIterableToArray(arr, i) || $bbcd5dcaccb206b2$var$_nonIterableRest();
}
function $bbcd5dcaccb206b2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bbcd5dcaccb206b2$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $bbcd5dcaccb206b2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $bbcd5dcaccb206b2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bbcd5dcaccb206b2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bbcd5dcaccb206b2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bbcd5dcaccb206b2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bbcd5dcaccb206b2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $bbcd5dcaccb206b2$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $bbcd5dcaccb206b2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bbcd5dcaccb206b2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bbcd5dcaccb206b2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $bbcd5dcaccb206b2$var$_callSuper(t, o, e) {
    return o = $bbcd5dcaccb206b2$var$_getPrototypeOf(o), $bbcd5dcaccb206b2$var$_possibleConstructorReturn(t, $bbcd5dcaccb206b2$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $bbcd5dcaccb206b2$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $bbcd5dcaccb206b2$var$_possibleConstructorReturn(self, call) {
    if (call && ($bbcd5dcaccb206b2$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $bbcd5dcaccb206b2$var$_assertThisInitialized(self);
}
function $bbcd5dcaccb206b2$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bbcd5dcaccb206b2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($bbcd5dcaccb206b2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $bbcd5dcaccb206b2$var$_getPrototypeOf(o) {
    $bbcd5dcaccb206b2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bbcd5dcaccb206b2$var$_getPrototypeOf(o);
}
function $bbcd5dcaccb206b2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $bbcd5dcaccb206b2$var$_setPrototypeOf(subClass, superClass);
}
function $bbcd5dcaccb206b2$var$_setPrototypeOf(o, p) {
    $bbcd5dcaccb206b2$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bbcd5dcaccb206b2$var$_setPrototypeOf(o, p);
}
function $bbcd5dcaccb206b2$var$_toConsumableArray(arr) {
    return $bbcd5dcaccb206b2$var$_arrayWithoutHoles(arr) || $bbcd5dcaccb206b2$var$_iterableToArray(arr) || $bbcd5dcaccb206b2$var$_unsupportedIterableToArray(arr) || $bbcd5dcaccb206b2$var$_nonIterableSpread();
}
function $bbcd5dcaccb206b2$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bbcd5dcaccb206b2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bbcd5dcaccb206b2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bbcd5dcaccb206b2$var$_arrayLikeToArray(o, minLen);
}
function $bbcd5dcaccb206b2$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $bbcd5dcaccb206b2$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $bbcd5dcaccb206b2$var$_arrayLikeToArray(arr);
}
function $bbcd5dcaccb206b2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bbcd5dcaccb206b2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bbcd5dcaccb206b2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bbcd5dcaccb206b2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bbcd5dcaccb206b2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bbcd5dcaccb206b2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bbcd5dcaccb206b2$var$_defineProperty(obj, key, value) {
    key = $bbcd5dcaccb206b2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bbcd5dcaccb206b2$var$_toPropertyKey(t) {
    var i = $bbcd5dcaccb206b2$var$_toPrimitive(t, "string");
    return "symbol" == $bbcd5dcaccb206b2$var$_typeof(i) ? i : i + "";
}
function $bbcd5dcaccb206b2$var$_toPrimitive(t, r) {
    if ("object" != $bbcd5dcaccb206b2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $bbcd5dcaccb206b2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $bbcd5dcaccb206b2$var$ORIENT_MAP = {
    xAxis: [
        'bottom',
        'top'
    ],
    yAxis: [
        'left',
        'right'
    ]
};
var $bbcd5dcaccb206b2$var$FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%'
};
var $bbcd5dcaccb206b2$var$originCoordinate = {
    x: 0,
    y: 0
};
/**
 * This function exists as a temporary workaround.
 *
 * Why? generateCategoricalChart does not render `{children}` directly;
 * instead it passes them through `renderByOrder` function which reads their handlers.
 *
 * So, this is a handler that does nothing.
 * Once we get rid of `renderByOrder` and switch to JSX only, we can get rid of this handler too.
 *
 * @param {JSX} element as is in JSX
 * @returns {JSX} the same element
 */ function $bbcd5dcaccb206b2$var$renderAsIs(element) {
    return element;
}
var $bbcd5dcaccb206b2$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === 'horizontal') return rangeObj.x;
    if (layout === 'vertical') return rangeObj.y;
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};
var $bbcd5dcaccb206b2$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === 'vertical') return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, rangeObj), (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, rangeObj), (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $bbcd5dcaccb206b2$var$originCoordinate;
};
var $bbcd5dcaccb206b2$var$getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($bbcd5dcaccb206b2$var$_toConsumableArray(result), $bbcd5dcaccb206b2$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(dataStartIndex) && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function $bbcd5dcaccb206b2$var$getDefaultDomainByAxisType(axisType) {
    return axisType === 'number' ? [
        0,
        'auto'
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $bbcd5dcaccb206b2$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $bbcd5dcaccb206b2$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
        // The data is sliced only when the active index is within the start/end index range.
        state.dataEndIndex - state.dataStartIndex >= activeIndex) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $938aefa455a73c9b$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($bbcd5dcaccb206b2$var$_toConsumableArray(result), [
            (0, $2cf058a100d782d5$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $bbcd5dcaccb206b2$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $bbcd5dcaccb206b2$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $2cf058a100d782d5$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $bbcd5dcaccb206b2$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $bbcd5dcaccb206b2$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $bbcd5dcaccb206b2$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $2cf058a100d782d5$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _childProps$domain2;
        var childProps = child.type.defaultProps !== undefined ? $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var type = childProps.type, dataKey = childProps.dataKey, allowDataOverflow = childProps.allowDataOverflow, allowDuplicatedCategory = childProps.allowDuplicatedCategory, scale = childProps.scale, ticks = childProps.ticks, includeHidden = childProps.includeHidden;
        var axisId = childProps[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $bbcd5dcaccb206b2$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                var _defaultProps;
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps = item.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps[axisIdKey];
                return itemAxisId === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, $dc82afd978f7b76b$export$33279f645a5831b7)(childProps.domain, allowDataOverflow, type)) {
            domain = (0, $2cf058a100d782d5$export$a0bc8660980558a0)(childProps.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $2cf058a100d782d5$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $bbcd5dcaccb206b2$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _childProps$domain;
            var childDomain = (_childProps$domain = childProps.domain) !== null && _childProps$domain !== void 0 ? _childProps$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $2cf058a100d782d5$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === 'category' && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $938aefa455a73c9b$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($fbafef0136c05c9e$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $2cf058a100d782d5$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($bbcd5dcaccb206b2$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === 'category') {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $2cf058a100d782d5$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(entry) ? finalDomain : [].concat($bbcd5dcaccb206b2$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== '' && !(0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(entry);
                    });
                } else if (type === 'number') {
                    // the field type is numerical
                    var errorBarsDomain = (0, $2cf058a100d782d5$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        var _defaultProps2, _defaultProps3;
                        var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps2 = item.type.defaultProps) === null || _defaultProps2 === void 0 ? void 0 : _defaultProps2[axisIdKey];
                        var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps3 = item.type.defaultProps) === null || _defaultProps3 === void 0 ? void 0 : _defaultProps3.hide;
                        return itemAxisId === axisId && (includeHidden || !itemHide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $2cf058a100d782d5$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($fbafef0136c05c9e$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === 'expand' ? [
                0,
                1
            ] : (0, $2cf058a100d782d5$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $2cf058a100d782d5$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : item.type.defaultProps[axisIdKey];
                var itemHide = 'hide' in item.props ? item.props.hide : item.type.defaultProps.hide;
                return itemAxisId === axisId && (includeHidden || !itemHide);
            }), type, layout, true);
            if (type === 'number') {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $4ddd823ae64c4d04$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $2cf058a100d782d5$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === 'category' && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, result), {}, $bbcd5dcaccb206b2$var$_defineProperty({}, axisId, $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, childProps), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_childProps$domain2 = childProps.domain) !== null && _childProps$domain2 !== void 0 ? _childProps$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $bbcd5dcaccb206b2$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $bbcd5dcaccb206b2$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $2cf058a100d782d5$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var childProps = child.type.defaultProps !== undefined ? $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var axisId = childProps[axisIdKey];
        var originalDomain = $bbcd5dcaccb206b2$var$getDefaultDomainByAxisType('number');
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($fbafef0136c05c9e$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $2cf058a100d782d5$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $4ddd823ae64c4d04$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $2cf058a100d782d5$export$a0bc8660980558a0)(originalDomain, (0, $2cf058a100d782d5$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    var _defaultProps4, _defaultProps5;
                    var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps4 = item.type.defaultProps) === null || _defaultProps4 === void 0 ? void 0 : _defaultProps4[axisIdKey];
                    var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps5 = item.type.defaultProps) === null || _defaultProps5 === void 0 ? void 0 : _defaultProps5.hide;
                    return itemAxisId === axisId && !itemHide;
                }), 'number', layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $4ddd823ae64c4d04$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, result), {}, $bbcd5dcaccb206b2$var$_defineProperty({}, axisId, $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($acb894cf4c1e4223$exports)))($bbcd5dcaccb206b2$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $bbcd5dcaccb206b2$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $49516a074167c4be$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $bbcd5dcaccb206b2$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $bbcd5dcaccb206b2$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $bbcd5dcaccb206b2$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $938aefa455a73c9b$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $2cf058a100d782d5$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($74190bf599267a83$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $2cf058a100d782d5$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
var $bbcd5dcaccb206b2$export$e5182fb58612e577 = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $49516a074167c4be$export$64c61536a2b72e0f)(children, (0, $e6da98f498586b22$export$59bc2e3533b384a0));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var $bbcd5dcaccb206b2$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $49516a074167c4be$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf('Bar') >= 0;
    });
};
var $bbcd5dcaccb206b2$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === 'horizontal') return {
        numericAxisName: 'yAxis',
        cateAxisName: 'xAxis'
    };
    if (layout === 'vertical') return {
        numericAxisName: 'xAxis',
        cateAxisName: 'yAxis'
    };
    if (layout === 'centric') return {
        numericAxisName: 'radiusAxis',
        cateAxisName: 'angleAxis'
    };
    return {
        numericAxisName: 'angleAxis',
        cateAxisName: 'radiusAxis'
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $bbcd5dcaccb206b2$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $49516a074167c4be$export$64c61536a2b72e0f)(children, (0, $e6da98f498586b22$export$59bc2e3533b384a0));
    var legendItem = (0, $49516a074167c4be$export$64c61536a2b72e0f)(children, (0, $61f751c849868bc2$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, result), {}, $bbcd5dcaccb206b2$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, result), {}, $bbcd5dcaccb206b2$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($acb894cf4c1e4223$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $e6da98f498586b22$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, $2cf058a100d782d5$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
// Determine the size of the axis, used for calculation of relative bar sizes
var $bbcd5dcaccb206b2$var$getCartesianAxisSize = function getCartesianAxisSize(axisObj, axisName) {
    if (axisName === 'xAxis') return axisObj[axisName].width;
    if (axisName === 'yAxis') return axisObj[axisName].height;
    // This is only supported for Bar charts (i.e. charts with cartesian axes), so we should never get here
    return undefined;
};
var $bbcd5dcaccb206b2$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        'axis'
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $bbcd5dcaccb206b2$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $bbcd5dcaccb206b2$var$hasGraphicalBarItem(graphicalItems);
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $bbcd5dcaccb206b2$var$getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var itemProps = item.type.defaultProps !== undefined ? $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
            var dataKey = itemProps.dataKey, childMaxBarSize = itemProps.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = itemProps["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = itemProps["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = itemProps["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === 'zAxis') && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, result), {}, $bbcd5dcaccb206b2$var$_defineProperty($bbcd5dcaccb206b2$var$_defineProperty({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), (0, $2cf058a100d782d5$export$c829ee42daf7f66d)(axis)));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $2cf058a100d782d5$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $49516a074167c4be$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            var bandSize = (0, $2cf058a100d782d5$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            var sizeList = hasBar && (0, $2cf058a100d782d5$export$570d306bee26c748)({
                barSize: barSize,
                stackGroups: stackGroups,
                totalSize: $bbcd5dcaccb206b2$var$getCartesianAxisSize(axisObj, cateAxisName)
            });
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // If it is bar, calculate the position of bar
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $2cf058a100d782d5$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $2cf058a100d782d5$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, pos), {}, {
                        position: $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) formattedItems.push({
                props: $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, composedFn($bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, axisObj), {}, {
                    displayedData: displayedData,
                    props: props,
                    dataKey: dataKey,
                    item: item,
                    bandSize: bandSize,
                    barPosition: barPosition,
                    offset: offset,
                    stackedData: stackedData,
                    layout: layout,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }))), {}, $bbcd5dcaccb206b2$var$_defineProperty($bbcd5dcaccb206b2$var$_defineProperty($bbcd5dcaccb206b2$var$_defineProperty({
                    key: item.key || "item-".concat(index)
                }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
                childIndex: (0, $49516a074167c4be$export$857ca101f741953)(item, props.children),
                item: item
            });
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $49516a074167c4be$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $bbcd5dcaccb206b2$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $49516a074167c4be$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $2cf058a100d782d5$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, result), {}, $bbcd5dcaccb206b2$var$_defineProperty({}, name, $bbcd5dcaccb206b2$var$getAxisMap(props, $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $bbcd5dcaccb206b2$var$calculateOffset($bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $bbcd5dcaccb206b2$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    var CategoricalChartWrapper = /*#__PURE__*/ function(_Component) {
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            $bbcd5dcaccb206b2$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = $bbcd5dcaccb206b2$var$_callSuper(this, CategoricalChartWrapper, [
                _props
            ]);
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "eventEmitterSymbol", Symbol('rechartsEventEmitter'));
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "accessibilityManager", new (0, $ae96119a38fb5474$export$a2c2de1efa8671eb)());
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($bbcd5dcaccb206b2$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== 'function') return;
                    _this.applySyncEvent(data);
                }
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $bbcd5dcaccb206b2$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleMouseLeave", function(e) {
                _this.throttleTriggeredAfterMouseMove.cancel();
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleOuterEvent", function(e) {
                var eventName = (0, $49516a074167c4be$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($acb894cf4c1e4223$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleDoubleClick", function(e) {
                var onDoubleClick = _this.props.onDoubleClick;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(onDoubleClick)) {
                    var _nextState5 = _this.getMouseInfo(e);
                    onDoubleClick(_nextState5, e);
                }
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "handleContextMenu", function(e) {
                var onContextMenu = _this.props.onContextMenu;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(onContextMenu)) {
                    var _nextState6 = _this.getMouseInfo(e);
                    onContextMenu(_nextState6, e);
                }
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, $93eefb1af259cca0$export$9bcdfe5f29bb33).emit((0, $93eefb1af259cca0$export$ff9a08f6d0c38b8f), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState($bbcd5dcaccb206b2$var$_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === 'function') // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === 'value') {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = $bbcd5dcaccb206b2$var$getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : $bbcd5dcaccb206b2$var$originCoordinate;
                    _this.setState($bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                var layout = _this.props.layout;
                var key = element.key || '_recharts-cursor';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $449e45aeb6304d88$export$b6a79797ad180576), {
                    key: key,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                    chartName: chartName,
                    element: element,
                    isActive: isActive,
                    layout: layout,
                    offset: offset,
                    tooltipAxisBandSize: tooltipAxisBandSize,
                    tooltipEventType: tooltipEventType
                });
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($acb894cf4c1e4223$exports)))(element, 'type.axisType');
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($acb894cf4c1e4223$exports)))(_this.state, "".concat(axisType, "Map"));
                var elementDefaultProps = element.type.defaultProps;
                var elementProps = elementDefaultProps !== undefined ? $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, elementDefaultProps), element.props) : element.props;
                var axisOption = axisMap && axisMap[elementProps["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $gIfym.cloneElement)(element, $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, axisOption), {}, {
                    className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)(axisType, axisOption.className),
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $2cf058a100d782d5$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $938aefa455a73c9b$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $938aefa455a73c9b$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $gIfym.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, $2cf058a100d782d5$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, $2cf058a100d782d5$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || 'polar-grid',
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $bbcd5dcaccb206b2$var$_defineProperty(_this, "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $d7115b802e1208ae$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $bbcd5dcaccb206b2$var$_objectWithoutProperties(props, $bbcd5dcaccb206b2$var$_excluded);
                return /*#__PURE__*/ (0, $gIfym.cloneElement)(item, $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $bbcd5dcaccb206b2$var$_defineProperty(_this, "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer;
                var tooltipItem = (0, $49516a074167c4be$export$64c61536a2b72e0f)(children, (0, $af95134c6736175e$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, $gIfym.cloneElement)(tooltipItem, {
                    viewBox: $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate,
                    accessibilityLayer: accessibilityLayer
                });
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $gIfym.cloneElement)(element, {
                    key: element.key || '_recharts-brush',
                    onChange: (0, $2cf058a100d782d5$export$760ec406ba47bace)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, $938aefa455a73c9b$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $938aefa455a73c9b$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $938aefa455a73c9b$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _this2 = _this, clipPathId = _this2.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var elementDefaultProps = element.type.defaultProps || {};
                var _element$props2 = element.props, _element$props2$xAxis = _element$props2.xAxisId, xAxisId = _element$props2$xAxis === void 0 ? elementDefaultProps.xAxisId : _element$props2$xAxis, _element$props2$yAxis = _element$props2.yAxisId, yAxisId = _element$props2$yAxis === void 0 ? elementDefaultProps.yAxisId : _element$props2$yAxis;
                return /*#__PURE__*/ (0, $gIfym.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "renderActivePoints", function(_ref10) {
                var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
                var result = [];
                // item is not a React Element so we don't need to resolve defaultProps.
                var key = item.props.key;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, dataKey = itemItemProps.dataKey;
                var dotProps = $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $2cf058a100d782d5$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: '#fff',
                    payload: activePoint.payload,
                    value: activePoint.value
                }, (0, $49516a074167c4be$export$d697c39a2985a4c)(activeDot, false)), (0, $e49003a65b792e53$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps, "".concat(key, "-activePoint-").concat(childIndex)));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y
                }), "".concat(key, "-basePoint-").concat(childIndex)));
                else if (isRange) result.push(null);
                return result;
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $49516a074167c4be$export$64c61536a2b72e0f)(children, (0, $af95134c6736175e$export$28c660c63b792dea));
                // item is not a React Element so we don't need to resolve defaultProps
                var _item$props = item.props, points = _item$props.points, isRange = _item$props.isRange, baseLine = _item$props.baseLine;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, hide = itemItemProps.hide, activeBar = itemItemProps.activeBar, activeShape = itemItemProps.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') itemEvents = {
                    onClick: (0, $2cf058a100d782d5$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== 'axis') itemEvents = {
                    onMouseLeave: (0, $2cf058a100d782d5$export$760ec406ba47bace)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, $2cf058a100d782d5$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $gIfym.cloneElement)(element, $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, $938aefa455a73c9b$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, $938aefa455a73c9b$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, $gIfym.cloneElement)(element, $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(activePoint)) return [
                            graphicalItem
                        ].concat($bbcd5dcaccb206b2$var$_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
                        var elementProps = $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, $gIfym.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $gIfym.cloneElement)(element, $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            $bbcd5dcaccb206b2$var$_defineProperty(_this, "renderMap", {
                CartesianGrid: {
                    handler: $bbcd5dcaccb206b2$var$renderAsIs,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: $bbcd5dcaccb206b2$var$renderAsIs
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: $bbcd5dcaccb206b2$var$renderAsIs
                },
                YAxis: {
                    handler: $bbcd5dcaccb206b2$var$renderAsIs
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, $938aefa455a73c9b$export$8b15d37bc3f197d4)('recharts'), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($ebc24d79346e975d$exports)))(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        $bbcd5dcaccb206b2$var$_inherits(CategoricalChartWrapper, _Component);
        return $bbcd5dcaccb206b2$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                    this.displayDefaultTooltip();
                }
            },
            {
                key: "displayDefaultTooltip",
                value: function displayDefaultTooltip() {
                    var _this$props5 = this.props, children = _this$props5.children, data = _this$props5.data, height = _this$props5.height, layout = _this$props5.layout;
                    var tooltipElem = (0, $49516a074167c4be$export$64c61536a2b72e0f)(children, (0, $af95134c6736175e$export$28c660c63b792dea));
                    // If the chart doesn't include a <Tooltip /> element, there's no tooltip to display
                    if (!tooltipElem) return;
                    var defaultIndex = tooltipElem.props.defaultIndex;
                    // Protect against runtime errors
                    if (typeof defaultIndex !== 'number' || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length - 1) return;
                    var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
                    var activePayload = $bbcd5dcaccb206b2$var$getTooltipContent(this.state, data, defaultIndex, activeLabel);
                    var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
                    var dependentAxisCoord = (this.state.offset.top + height) / 2;
                    var isHorizontal = layout === 'horizontal';
                    var activeCoordinate = isHorizontal ? {
                        x: independentAxisCoord,
                        y: dependentAxisCoord
                    } : {
                        y: independentAxisCoord,
                        x: dependentAxisCoord
                    };
                    // Unlike other chart types, scatter plot's tooltip positions rely on both X and Y coordinates. Only the scatter plot
                    // element knows its own Y coordinates.
                    // If there's a scatter plot, we'll want to grab that element for an interrogation.
                    var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
                        var item = _ref12.item;
                        return item.type.name === 'Scatter';
                    });
                    if (scatterPlotElement) {
                        activeCoordinate = $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
                        activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
                    }
                    var nextState = {
                        activeTooltipIndex: defaultIndex,
                        isTooltipActive: true,
                        activeLabel: activeLabel,
                        activePayload: activePayload,
                        activeCoordinate: activeCoordinate
                    };
                    this.setState(nextState);
                    this.renderCursor(tooltipElem);
                    // Make sure that anyone who keyboard-only users who tab to the chart will start their
                    // cursors at defaultIndex
                    this.accessibilityManager.setIndex(defaultIndex);
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // Check to see if the Tooltip updated. If so, re-check default tooltip position
                    if (!(0, $49516a074167c4be$export$acdc716e08572f94)([
                        (0, $49516a074167c4be$export$64c61536a2b72e0f)(prevProps.children, (0, $af95134c6736175e$export$28c660c63b792dea))
                    ], [
                        (0, $49516a074167c4be$export$64c61536a2b72e0f)(this.props.children, (0, $af95134c6736175e$export$28c660c63b792dea))
                    ])) this.displayDefaultTooltip();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $49516a074167c4be$export$64c61536a2b72e0f)(this.props.children, (0, $af95134c6736175e$export$28c660c63b792dea));
                    if (tooltipItem && typeof tooltipItem.props.shared === 'boolean') {
                        var eventType = tooltipItem.props.shared ? 'axis' : 'item';
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, $d9e815357bd46210$export$622cea445a1c5b7d)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    var toolTipData = $bbcd5dcaccb206b2$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
                        var xScale = (0, $938aefa455a73c9b$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $938aefa455a73c9b$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        }, toolTipData);
                    }
                    if (toolTipData) return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === 'horizontal' || layout === 'vertical') {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $938aefa455a73c9b$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $b592c97d860421c4$export$e85a2bf8cd31c504)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $49516a074167c4be$export$64c61536a2b72e0f)(children, (0, $af95134c6736175e$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === 'axis') {
                        if (tooltipItem.props.trigger === 'click') tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onDoubleClick: this.handleDoubleClick,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd,
                            onContextMenu: this.handleContextMenu
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, $e49003a65b792e53$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $93eefb1af259cca0$export$9bcdfe5f29bb33).on((0, $93eefb1af259cca0$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $93eefb1af259cca0$export$9bcdfe5f29bb33).removeListener((0, $93eefb1af259cca0$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $49516a074167c4be$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $bbcd5dcaccb206b2$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, res), {}, $bbcd5dcaccb206b2$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $bbcd5dcaccb206b2$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, res), {}, $bbcd5dcaccb206b2$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        // graphicalItem is not a React Element so we don't need to resolve defaultProps
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemProps = item.type.defaultProps !== undefined ? $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
                        var itemDisplayName = (0, $49516a074167c4be$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === 'Bar') {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $25b2a5d5dc6ab71a$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === 'RadialBar') {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $b592c97d860421c4$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, $cf9db1230888ca89$export$4b83e8415af38a18)(graphicalItem, activeItem) || (0, $cf9db1230888ca89$export$f722d7e63cc07b)(graphicalItem, activeItem) || (0, $cf9db1230888ca89$export$f62b21bcfd1a733e)(graphicalItem, activeItem)) {
                            var activeIndex = (0, $cf9db1230888ca89$export$bd5d63c57ca4468)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: itemProps.data
                            });
                            var childIndex = itemProps.activeIndex === undefined ? activeIndex : itemProps.activeIndex;
                            return {
                                graphicalItem: $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, $cf9db1230888ca89$export$f62b21bcfd1a733e)(graphicalItem, activeItem) ? itemProps.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this3 = this;
                    if (!(0, $49516a074167c4be$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $bbcd5dcaccb206b2$var$_objectWithoutProperties(_this$props6, $bbcd5dcaccb206b2$var$_excluded2);
                    var attrs = (0, $49516a074167c4be$export$d697c39a2985a4c)(others, false);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $25bdd3424767d42d$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $6e8d54bdf0351ed1$export$7b92b459e668cb21), $bbcd5dcaccb206b2$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $49516a074167c4be$export$a98d6da55570cb82)(children, this.renderMap)));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : 'application';
                        attrs.onKeyDown = function(e) {
                            _this3.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this3.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $25bdd3424767d42d$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", $bbcd5dcaccb206b2$var$_extends({
                        className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-wrapper', className),
                        style: $bbcd5dcaccb206b2$var$_objectSpread({
                            position: 'relative',
                            cursor: 'default',
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this3.container = node;
                        }
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $6e8d54bdf0351ed1$export$7b92b459e668cb21), $bbcd5dcaccb206b2$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: $bbcd5dcaccb206b2$var$FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, $49516a074167c4be$export$a98d6da55570cb82)(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
                }
            }
        ]);
    }((0, $gIfym.Component));
    $bbcd5dcaccb206b2$var$_defineProperty(CategoricalChartWrapper, "displayName", chartName);
    // todo join specific chart propTypes
    $bbcd5dcaccb206b2$var$_defineProperty(CategoricalChartWrapper, "defaultProps", $bbcd5dcaccb206b2$var$_objectSpread({
        layout: 'horizontal',
        stackOffset: 'none',
        barCategoryGap: '10%',
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: 'index'
    }, defaultProps));
    $bbcd5dcaccb206b2$var$_defineProperty(CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
        if (prevState.updateId === undefined) {
            var defaultState = $bbcd5dcaccb206b2$export$e5182fb58612e577(nextProps);
            return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $5039526b485776da$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $bbcd5dcaccb206b2$export$e5182fb58612e577(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, $bbcd5dcaccb206b2$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($bbcd5dcaccb206b2$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $49516a074167c4be$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
            // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
            var brush = (0, $49516a074167c4be$export$64c61536a2b72e0f)(children, (0, $e6da98f498586b22$export$59bc2e3533b384a0));
            var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
            var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
            var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(data);
            var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
            return $bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($bbcd5dcaccb206b2$var$_objectSpread($bbcd5dcaccb206b2$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            }), prevState)), {}, {
                prevChildren: children,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            });
        }
        return null;
    });
    $bbcd5dcaccb206b2$var$_defineProperty(CategoricalChartWrapper, "renderActiveDot", function(option, props, key) {
        var dot;
        if (/*#__PURE__*/ (0, $gIfym.isValidElement)(option)) dot = /*#__PURE__*/ (0, $gIfym.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f9dff8c513e6748d$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: key
        }, dot);
    });
    var CategoricalChart = /*#__PURE__*/ (0, $gIfym.forwardRef)(function CategoricalChart(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(CategoricalChartWrapper, $bbcd5dcaccb206b2$var$_extends({}, props, {
            ref: ref
        }));
    });
    CategoricalChart.displayName = CategoricalChartWrapper.displayName;
    return CategoricalChart;
};




var $gIfym = parcelRequire("gIfym");



var $gIfym = parcelRequire("gIfym");















/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $7f94d8cb17cdfc80$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}


function $e1054964f88d779b$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $41567e62448fdc32$export$3ee78d51cffc2b68)(size, angle);
}
function $e1054964f88d779b$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $e1054964f88d779b$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $e1054964f88d779b$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $7f94d8cb17cdfc80$export$41514b9f058a6886)(ticks, interval + 1);
}




function $ce06c51b6a042687$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $7f94d8cb17cdfc80$export$41514b9f058a6886)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $e1054964f88d779b$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}


function $a5e19f82436edfe5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a5e19f82436edfe5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a5e19f82436edfe5$var$_typeof(o);
}
function $a5e19f82436edfe5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a5e19f82436edfe5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a5e19f82436edfe5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a5e19f82436edfe5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a5e19f82436edfe5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a5e19f82436edfe5$var$_defineProperty(obj, key, value) {
    key = $a5e19f82436edfe5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a5e19f82436edfe5$var$_toPropertyKey(t) {
    var i = $a5e19f82436edfe5$var$_toPrimitive(t, "string");
    return "symbol" == $a5e19f82436edfe5$var$_typeof(i) ? i : i + "";
}
function $a5e19f82436edfe5$var$_toPrimitive(t, r) {
    if ("object" != $a5e19f82436edfe5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a5e19f82436edfe5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a5e19f82436edfe5$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $a5e19f82436edfe5$var$_objectSpread($a5e19f82436edfe5$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $a5e19f82436edfe5$var$_objectSpread($a5e19f82436edfe5$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $e1054964f88d779b$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = $a5e19f82436edfe5$var$_objectSpread($a5e19f82436edfe5$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $a5e19f82436edfe5$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $a5e19f82436edfe5$var$_objectSpread($a5e19f82436edfe5$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, $e1054964f88d779b$export$795910f5f15a9633)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $a5e19f82436edfe5$var$_objectSpread($a5e19f82436edfe5$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $a5e19f82436edfe5$var$_objectSpread($a5e19f82436edfe5$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $a5e19f82436edfe5$var$_objectSpread($a5e19f82436edfe5$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $e1054964f88d779b$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = $a5e19f82436edfe5$var$_objectSpread($a5e19f82436edfe5$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $a5e19f82436edfe5$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $938aefa455a73c9b$export$7e4aa119212bc614)(interval) || (0, $2a28151593e2b6a4$export$98f03c5d19621d70).isSsr) return (0, $e1054964f88d779b$export$beeebbe3ff1b306b)(ticks, typeof interval === 'number' && (0, $938aefa455a73c9b$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, $d9e815357bd46210$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, $e1054964f88d779b$export$a1966f4ad955c82b)((0, $d9e815357bd46210$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $d9e815357bd46210$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $938aefa455a73c9b$export$9d334328eb75e624)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $e1054964f88d779b$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, $ce06c51b6a042687$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $a5e19f82436edfe5$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = $a5e19f82436edfe5$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}


var $2c62349f10ac5c41$var$_excluded = [
    "viewBox"
], $2c62349f10ac5c41$var$_excluded2 = [
    "viewBox"
], $2c62349f10ac5c41$var$_excluded3 = [
    "ticks"
];
function $2c62349f10ac5c41$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2c62349f10ac5c41$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2c62349f10ac5c41$var$_typeof(o);
}
function $2c62349f10ac5c41$var$_extends() {
    $2c62349f10ac5c41$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2c62349f10ac5c41$var$_extends.apply(this, arguments);
}
function $2c62349f10ac5c41$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2c62349f10ac5c41$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2c62349f10ac5c41$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2c62349f10ac5c41$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2c62349f10ac5c41$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2c62349f10ac5c41$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2c62349f10ac5c41$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2c62349f10ac5c41$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2c62349f10ac5c41$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2c62349f10ac5c41$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2c62349f10ac5c41$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $2c62349f10ac5c41$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2c62349f10ac5c41$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2c62349f10ac5c41$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2c62349f10ac5c41$var$_callSuper(t, o, e) {
    return o = $2c62349f10ac5c41$var$_getPrototypeOf(o), $2c62349f10ac5c41$var$_possibleConstructorReturn(t, $2c62349f10ac5c41$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $2c62349f10ac5c41$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $2c62349f10ac5c41$var$_possibleConstructorReturn(self, call) {
    if (call && ($2c62349f10ac5c41$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $2c62349f10ac5c41$var$_assertThisInitialized(self);
}
function $2c62349f10ac5c41$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2c62349f10ac5c41$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2c62349f10ac5c41$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $2c62349f10ac5c41$var$_getPrototypeOf(o) {
    $2c62349f10ac5c41$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2c62349f10ac5c41$var$_getPrototypeOf(o);
}
function $2c62349f10ac5c41$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $2c62349f10ac5c41$var$_setPrototypeOf(subClass, superClass);
}
function $2c62349f10ac5c41$var$_setPrototypeOf(o, p) {
    $2c62349f10ac5c41$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2c62349f10ac5c41$var$_setPrototypeOf(o, p);
}
function $2c62349f10ac5c41$var$_defineProperty(obj, key, value) {
    key = $2c62349f10ac5c41$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2c62349f10ac5c41$var$_toPropertyKey(t) {
    var i = $2c62349f10ac5c41$var$_toPrimitive(t, "string");
    return "symbol" == $2c62349f10ac5c41$var$_typeof(i) ? i : i + "";
}
function $2c62349f10ac5c41$var$_toPrimitive(t, r) {
    if ("object" != $2c62349f10ac5c41$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2c62349f10ac5c41$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2c62349f10ac5c41$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    function CartesianAxis(props) {
        var _this;
        $2c62349f10ac5c41$var$_classCallCheck(this, CartesianAxis);
        _this = $2c62349f10ac5c41$var$_callSuper(this, CartesianAxis, [
            props
        ]);
        _this.state = {
            fontSize: '',
            letterSpacing: ''
        };
        return _this;
    }
    $2c62349f10ac5c41$var$_inherits(CartesianAxis, _Component);
    return $2c62349f10ac5c41$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $2c62349f10ac5c41$var$_objectWithoutProperties(_ref, $2c62349f10ac5c41$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $2c62349f10ac5c41$var$_objectWithoutProperties(_this$props, $2c62349f10ac5c41$var$_excluded2);
                return !(0, $5039526b485776da$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $5039526b485776da$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $5039526b485776da$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $938aefa455a73c9b$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case 'top':
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case 'left':
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case 'right':
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = mirror ? 'start' : 'end';
                        break;
                    case 'right':
                        textAnchor = mirror ? 'end' : 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = 'end';
                switch(orientation){
                    case 'left':
                    case 'right':
                        verticalAnchor = 'middle';
                        break;
                    case 'top':
                        verticalAnchor = mirror ? 'start' : 'end';
                        break;
                    default:
                        verticalAnchor = mirror ? 'end' : 'start';
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $2c62349f10ac5c41$var$_objectSpread($2c62349f10ac5c41$var$_objectSpread($2c62349f10ac5c41$var$_objectSpread({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(this.props, false)), (0, $49516a074167c4be$export$d697c39a2985a4c)(axisLine, false)), {}, {
                    fill: 'none'
                });
                if (orientation === 'top' || orientation === 'bottom') {
                    var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
                    props = $2c62349f10ac5c41$var$_objectSpread($2c62349f10ac5c41$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
                    props = $2c62349f10ac5c41$var$_objectSpread($2c62349f10ac5c41$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("line", $2c62349f10ac5c41$var$_extends({}, props, {
                    className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-cartesian-axis-line', (0, (/*@__PURE__*/$parcel$interopDefault($acb894cf4c1e4223$exports)))(axisLine, 'className'))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $a5e19f82436edfe5$export$3d27d42b1034de5c)($2c62349f10ac5c41$var$_objectSpread($2c62349f10ac5c41$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $49516a074167c4be$export$d697c39a2985a4c)(this.props, false);
                var customTickProps = (0, $49516a074167c4be$export$d697c39a2985a4c)(tick, false);
                var tickLineProps = $2c62349f10ac5c41$var$_objectSpread($2c62349f10ac5c41$var$_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, $49516a074167c4be$export$d697c39a2985a4c)(tickLine, false));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $2c62349f10ac5c41$var$_objectSpread($2c62349f10ac5c41$var$_objectSpread($2c62349f10ac5c41$var$_objectSpread($2c62349f10ac5c41$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), $2c62349f10ac5c41$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, $e49003a65b792e53$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("line", $2c62349f10ac5c41$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-cartesian-axis-tick-line', (0, (/*@__PURE__*/$parcel$interopDefault($acb894cf4c1e4223$exports)))(tickLine, 'className'))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $2c62349f10ac5c41$var$_objectWithoutProperties(_this$props8, $2c62349f10ac5c41$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
                    className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-cartesian-axis', className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $0e68a54aec8ebf8f$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $af1dbcbd2651f0c2$export$5f1af8db9871e1d6), $2c62349f10ac5c41$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, $gIfym.Component));
$2c62349f10ac5c41$var$_defineProperty($2c62349f10ac5c41$export$bdd99f2cdf352bae, "displayName", 'CartesianAxis');
$2c62349f10ac5c41$var$_defineProperty($2c62349f10ac5c41$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd'
});



function $4599bbc635684a39$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4599bbc635684a39$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4599bbc635684a39$var$_typeof(o);
}
function $4599bbc635684a39$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4599bbc635684a39$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4599bbc635684a39$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4599bbc635684a39$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4599bbc635684a39$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4599bbc635684a39$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4599bbc635684a39$var$_callSuper(t, o, e) {
    return o = $4599bbc635684a39$var$_getPrototypeOf(o), $4599bbc635684a39$var$_possibleConstructorReturn(t, $4599bbc635684a39$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $4599bbc635684a39$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $4599bbc635684a39$var$_possibleConstructorReturn(self, call) {
    if (call && ($4599bbc635684a39$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4599bbc635684a39$var$_assertThisInitialized(self);
}
function $4599bbc635684a39$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4599bbc635684a39$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4599bbc635684a39$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $4599bbc635684a39$var$_getPrototypeOf(o) {
    $4599bbc635684a39$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4599bbc635684a39$var$_getPrototypeOf(o);
}
function $4599bbc635684a39$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $4599bbc635684a39$var$_setPrototypeOf(subClass, superClass);
}
function $4599bbc635684a39$var$_setPrototypeOf(o, p) {
    $4599bbc635684a39$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4599bbc635684a39$var$_setPrototypeOf(o, p);
}
function $4599bbc635684a39$var$_defineProperty(obj, key, value) {
    key = $4599bbc635684a39$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4599bbc635684a39$var$_toPropertyKey(t) {
    var i = $4599bbc635684a39$var$_toPrimitive(t, "string");
    return "symbol" == $4599bbc635684a39$var$_typeof(i) ? i : i + "";
}
function $4599bbc635684a39$var$_toPrimitive(t, r) {
    if ("object" != $4599bbc635684a39$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4599bbc635684a39$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4599bbc635684a39$var$_extends() {
    $4599bbc635684a39$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4599bbc635684a39$var$_extends.apply(this, arguments);
}
/** Define of XAxis props */ function $4599bbc635684a39$var$XAxisImpl(_ref) {
    var xAxisId = _ref.xAxisId;
    var width = (0, $25bdd3424767d42d$export$8854f7ece606854b)();
    var height = (0, $25bdd3424767d42d$export$369ae257969c6f9f)();
    var axisOptions = (0, $25bdd3424767d42d$export$54f54805c81085c5)(xAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $2c62349f10ac5c41$export$bdd99f2cdf352bae), $4599bbc635684a39$var$_extends({}, axisOptions, {
        className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $2cf058a100d782d5$export$c829ee42daf7f66d)(axis, true);
        }
    })));
}
var $4599bbc635684a39$export$ea77231de273b52d = /*#__PURE__*/ function(_React$Component) {
    function XAxis() {
        $4599bbc635684a39$var$_classCallCheck(this, XAxis);
        return $4599bbc635684a39$var$_callSuper(this, XAxis, arguments);
    }
    $4599bbc635684a39$var$_inherits(XAxis, _React$Component);
    return $4599bbc635684a39$var$_createClass(XAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($4599bbc635684a39$var$XAxisImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$4599bbc635684a39$var$_defineProperty($4599bbc635684a39$export$ea77231de273b52d, "displayName", 'XAxis');
$4599bbc635684a39$var$_defineProperty($4599bbc635684a39$export$ea77231de273b52d, "defaultProps", {
    allowDecimals: true,
    hide: false,
    orientation: 'bottom',
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: 'category',
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false,
    allowDuplicatedCategory: true
});



var $gIfym = parcelRequire("gIfym");




function $dc3299e5adf43c53$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dc3299e5adf43c53$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dc3299e5adf43c53$var$_typeof(o);
}
function $dc3299e5adf43c53$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dc3299e5adf43c53$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $dc3299e5adf43c53$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $dc3299e5adf43c53$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $dc3299e5adf43c53$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $dc3299e5adf43c53$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $dc3299e5adf43c53$var$_callSuper(t, o, e) {
    return o = $dc3299e5adf43c53$var$_getPrototypeOf(o), $dc3299e5adf43c53$var$_possibleConstructorReturn(t, $dc3299e5adf43c53$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $dc3299e5adf43c53$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $dc3299e5adf43c53$var$_possibleConstructorReturn(self, call) {
    if (call && ($dc3299e5adf43c53$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $dc3299e5adf43c53$var$_assertThisInitialized(self);
}
function $dc3299e5adf43c53$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $dc3299e5adf43c53$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dc3299e5adf43c53$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $dc3299e5adf43c53$var$_getPrototypeOf(o) {
    $dc3299e5adf43c53$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $dc3299e5adf43c53$var$_getPrototypeOf(o);
}
function $dc3299e5adf43c53$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $dc3299e5adf43c53$var$_setPrototypeOf(subClass, superClass);
}
function $dc3299e5adf43c53$var$_setPrototypeOf(o, p) {
    $dc3299e5adf43c53$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $dc3299e5adf43c53$var$_setPrototypeOf(o, p);
}
function $dc3299e5adf43c53$var$_defineProperty(obj, key, value) {
    key = $dc3299e5adf43c53$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dc3299e5adf43c53$var$_toPropertyKey(t) {
    var i = $dc3299e5adf43c53$var$_toPrimitive(t, "string");
    return "symbol" == $dc3299e5adf43c53$var$_typeof(i) ? i : i + "";
}
function $dc3299e5adf43c53$var$_toPrimitive(t, r) {
    if ("object" != $dc3299e5adf43c53$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dc3299e5adf43c53$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $dc3299e5adf43c53$var$_extends() {
    $dc3299e5adf43c53$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc3299e5adf43c53$var$_extends.apply(this, arguments);
}
var $dc3299e5adf43c53$var$YAxisImpl = function YAxisImpl(_ref) {
    var yAxisId = _ref.yAxisId;
    var width = (0, $25bdd3424767d42d$export$8854f7ece606854b)();
    var height = (0, $25bdd3424767d42d$export$369ae257969c6f9f)();
    var axisOptions = (0, $25bdd3424767d42d$export$6f8958021ad81c20)(yAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $2c62349f10ac5c41$export$bdd99f2cdf352bae), $dc3299e5adf43c53$var$_extends({}, axisOptions, {
        className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $2cf058a100d782d5$export$c829ee42daf7f66d)(axis, true);
        }
    })));
};
var $dc3299e5adf43c53$export$f96c4024c52de8f4 = /*#__PURE__*/ function(_React$Component) {
    function YAxis() {
        $dc3299e5adf43c53$var$_classCallCheck(this, YAxis);
        return $dc3299e5adf43c53$var$_callSuper(this, YAxis, arguments);
    }
    $dc3299e5adf43c53$var$_inherits(YAxis, _React$Component);
    return $dc3299e5adf43c53$var$_createClass(YAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($dc3299e5adf43c53$var$YAxisImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$dc3299e5adf43c53$var$_defineProperty($dc3299e5adf43c53$export$f96c4024c52de8f4, "displayName", 'YAxis');
$dc3299e5adf43c53$var$_defineProperty($dc3299e5adf43c53$export$f96c4024c52de8f4, "defaultProps", {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: 'left',
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: 'number',
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false
});



var $e5f9bccf45a8faa3$export$94aefc399ef206a9 = (0, $bbcd5dcaccb206b2$export$77871aede60e6838)({
    chartName: 'BarChart',
    GraphicalChild: (0, $7f0f02843a7c30b4$export$bbc6c6369b38e3d1),
    defaultTooltipEventType: 'axis',
    validateTooltipEventTypes: [
        'axis',
        'item'
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $4599bbc635684a39$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $dc3299e5adf43c53$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $41567e62448fdc32$export$ece7de1383db5ac)
});


var $gIfym = parcelRequire("gIfym");








var $1e8a496f1b0dc2f3$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $1e8a496f1b0dc2f3$var$_excluded2 = [
    "offset"
];
function $1e8a496f1b0dc2f3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1e8a496f1b0dc2f3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1e8a496f1b0dc2f3$var$_typeof(o);
}
function $1e8a496f1b0dc2f3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1e8a496f1b0dc2f3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1e8a496f1b0dc2f3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1e8a496f1b0dc2f3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1e8a496f1b0dc2f3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1e8a496f1b0dc2f3$var$_defineProperty(obj, key, value) {
    key = $1e8a496f1b0dc2f3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1e8a496f1b0dc2f3$var$_toPropertyKey(t) {
    var i = $1e8a496f1b0dc2f3$var$_toPrimitive(t, "string");
    return "symbol" == $1e8a496f1b0dc2f3$var$_typeof(i) ? i : i + "";
}
function $1e8a496f1b0dc2f3$var$_toPrimitive(t, r) {
    if ("object" != $1e8a496f1b0dc2f3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1e8a496f1b0dc2f3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1e8a496f1b0dc2f3$var$_extends() {
    $1e8a496f1b0dc2f3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1e8a496f1b0dc2f3$var$_extends.apply(this, arguments);
}
function $1e8a496f1b0dc2f3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1e8a496f1b0dc2f3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1e8a496f1b0dc2f3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * The <CartesianGrid horizontal
 */ var $1e8a496f1b0dc2f3$var$Background = function Background(props) {
    var fill = props.fill;
    if (!fill || fill === 'none') return null;
    var fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, ry = props.ry;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $1e8a496f1b0dc2f3$var$renderLineItem(option, props) {
    var lineItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(option)) lineItem = option(props);
    else {
        var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $1e8a496f1b0dc2f3$var$_objectWithoutProperties(props, $1e8a496f1b0dc2f3$var$_excluded);
        var _filterProps = (0, $49516a074167c4be$export$d697c39a2985a4c)(others, false), __ = _filterProps.offset, restOfFilteredProps = $1e8a496f1b0dc2f3$var$_objectWithoutProperties(_filterProps, $1e8a496f1b0dc2f3$var$_excluded2);
        lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("line", $1e8a496f1b0dc2f3$var$_extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $1e8a496f1b0dc2f3$var$HorizontalGridLines(props) {
    var x = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var items = horizontalPoints.map(function(entry, i) {
        var lineItemProps = $1e8a496f1b0dc2f3$var$_objectSpread($1e8a496f1b0dc2f3$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return $1e8a496f1b0dc2f3$var$renderLineItem(horizontal, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $1e8a496f1b0dc2f3$var$VerticalGridLines(props) {
    var y = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var items = verticalPoints.map(function(entry, i) {
        var lineItemProps = $1e8a496f1b0dc2f3$var$_objectSpread($1e8a496f1b0dc2f3$var$_objectSpread({}, props), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return $1e8a496f1b0dc2f3$var$renderLineItem(vertical, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $1e8a496f1b0dc2f3$var$HorizontalStripes(props) {
    var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
    if (!horizontal || !horizontalFill || !horizontalFill.length) return null;
    // Why =y -y? I was trying to find any difference that this makes, with floating point numbers and edge cases but ... nothing.
    var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
        return Math.round(e + y - y);
    }).sort(function(a, b) {
        return a - b;
    });
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map(function(entry, i) {
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $1e8a496f1b0dc2f3$var$VerticalStripes(props) {
    var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
        return Math.round(e + x - x);
    }).sort(function(a, b) {
        return a - b;
    });
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map(function(entry, i) {
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $1e8a496f1b0dc2f3$var$defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator(_ref, syncWithTicks) {
    var xAxis = _ref.xAxis, width = _ref.width, height = _ref.height, offset = _ref.offset;
    return (0, $2cf058a100d782d5$export$846dc5ac5fecff74)((0, $a5e19f82436edfe5$export$3d27d42b1034de5c)($1e8a496f1b0dc2f3$var$_objectSpread($1e8a496f1b0dc2f3$var$_objectSpread($1e8a496f1b0dc2f3$var$_objectSpread({}, (0, $2c62349f10ac5c41$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
        ticks: (0, $2cf058a100d782d5$export$c829ee42daf7f66d)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $1e8a496f1b0dc2f3$var$defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator(_ref2, syncWithTicks) {
    var yAxis = _ref2.yAxis, width = _ref2.width, height = _ref2.height, offset = _ref2.offset;
    return (0, $2cf058a100d782d5$export$846dc5ac5fecff74)((0, $a5e19f82436edfe5$export$3d27d42b1034de5c)($1e8a496f1b0dc2f3$var$_objectSpread($1e8a496f1b0dc2f3$var$_objectSpread($1e8a496f1b0dc2f3$var$_objectSpread({}, (0, $2c62349f10ac5c41$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
        ticks: (0, $2cf058a100d782d5$export$c829ee42daf7f66d)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $1e8a496f1b0dc2f3$var$defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};
function $1e8a496f1b0dc2f3$export$6440e27b9f186856(props) {
    var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
    var chartWidth = (0, $25bdd3424767d42d$export$8854f7ece606854b)();
    var chartHeight = (0, $25bdd3424767d42d$export$369ae257969c6f9f)();
    var offset = (0, $25bdd3424767d42d$export$99e5207fa7e69f17)();
    var propsIncludingDefaults = $1e8a496f1b0dc2f3$var$_objectSpread($1e8a496f1b0dc2f3$var$_objectSpread({}, props), {}, {
        stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : $1e8a496f1b0dc2f3$var$defaultProps.stroke,
        fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : $1e8a496f1b0dc2f3$var$defaultProps.fill,
        horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : $1e8a496f1b0dc2f3$var$defaultProps.horizontal,
        horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : $1e8a496f1b0dc2f3$var$defaultProps.horizontalFill,
        vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : $1e8a496f1b0dc2f3$var$defaultProps.vertical,
        verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : $1e8a496f1b0dc2f3$var$defaultProps.verticalFill,
        x: (0, $938aefa455a73c9b$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
        y: (0, $938aefa455a73c9b$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
        width: (0, $938aefa455a73c9b$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
        height: (0, $938aefa455a73c9b$export$7e4aa119212bc614)(props.height) ? props.height : offset.height
    });
    var x = propsIncludingDefaults.x, y = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var xAxis = (0, $25bdd3424767d42d$export$1d855c2865750a72)();
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var yAxis = (0, $25bdd3424767d42d$export$631ee617f1052e16)();
    if (!(0, $938aefa455a73c9b$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(x) || x !== +x || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(y) || y !== +y) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside of the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $1e8a496f1b0dc2f3$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $1e8a496f1b0dc2f3$var$defaultHorizontalCoordinatesGenerator;
    var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(horizontalCoordinatesGenerator)) {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $1e8a496f1b0dc2f3$var$_objectSpread($1e8a496f1b0dc2f3$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $0eb6b0656d09fb9a$export$c106dd0671a0fc2d)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat($1e8a496f1b0dc2f3$var$_typeof(generatorResult), "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(verticalCoordinatesGenerator)) {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $1e8a496f1b0dc2f3$var$_objectSpread($1e8a496f1b0dc2f3$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $0eb6b0656d09fb9a$export$c106dd0671a0fc2d)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat($1e8a496f1b0dc2f3$var$_typeof(_generatorResult), "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($1e8a496f1b0dc2f3$var$Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($1e8a496f1b0dc2f3$var$HorizontalGridLines, $1e8a496f1b0dc2f3$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($1e8a496f1b0dc2f3$var$VerticalGridLines, $1e8a496f1b0dc2f3$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($1e8a496f1b0dc2f3$var$HorizontalStripes, $1e8a496f1b0dc2f3$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($1e8a496f1b0dc2f3$var$VerticalStripes, $1e8a496f1b0dc2f3$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })));
}
$1e8a496f1b0dc2f3$export$6440e27b9f186856.displayName = 'CartesianGrid';



var $gIfym = parcelRequire("gIfym");




function $d7b42fa8a2c2a4be$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d7b42fa8a2c2a4be$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d7b42fa8a2c2a4be$var$_typeof(o);
}
function $d7b42fa8a2c2a4be$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d7b42fa8a2c2a4be$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d7b42fa8a2c2a4be$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d7b42fa8a2c2a4be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d7b42fa8a2c2a4be$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d7b42fa8a2c2a4be$var$_defineProperty(obj, key, value) {
    key = $d7b42fa8a2c2a4be$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d7b42fa8a2c2a4be$var$_toPropertyKey(t) {
    var i = $d7b42fa8a2c2a4be$var$_toPrimitive(t, "string");
    return "symbol" == $d7b42fa8a2c2a4be$var$_typeof(i) ? i : i + "";
}
function $d7b42fa8a2c2a4be$var$_toPrimitive(t, r) {
    if ("object" != $d7b42fa8a2c2a4be$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d7b42fa8a2c2a4be$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d7b42fa8a2c2a4be$var$_slicedToArray(arr, i) {
    return $d7b42fa8a2c2a4be$var$_arrayWithHoles(arr) || $d7b42fa8a2c2a4be$var$_iterableToArrayLimit(arr, i) || $d7b42fa8a2c2a4be$var$_unsupportedIterableToArray(arr, i) || $d7b42fa8a2c2a4be$var$_nonIterableRest();
}
function $d7b42fa8a2c2a4be$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d7b42fa8a2c2a4be$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d7b42fa8a2c2a4be$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d7b42fa8a2c2a4be$var$_arrayLikeToArray(o, minLen);
}
function $d7b42fa8a2c2a4be$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d7b42fa8a2c2a4be$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d7b42fa8a2c2a4be$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $d7b42fa8a2c2a4be$export$e60a4704009a0009 = /*#__PURE__*/ (0, $gIfym.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? '100%' : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? '100%' : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, $gIfym.useRef)(null);
    var onResizeRef = (0, $gIfym.useRef)();
    onResizeRef.current = onResize;
    (0, $gIfym.useImperativeHandle)(ref, function() {
        return Object.defineProperty(containerRef.current, 'current', {
            get: function get() {
                // eslint-disable-next-line no-console
                console.warn('The usage of ref.current.current is deprecated and will no longer be supported.');
                return containerRef.current;
            },
            configurable: true
        });
    });
    var _useState = (0, $gIfym.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $d7b42fa8a2c2a4be$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, $gIfym.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $gIfym.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($ebc24d79346e975d$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, $gIfym.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $0eb6b0656d09fb9a$export$c106dd0671a0fc2d)((0, $938aefa455a73c9b$export$e50269385c77c348)(width) || (0, $938aefa455a73c9b$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $0eb6b0656d09fb9a$export$c106dd0671a0fc2d)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
        var calculatedWidth = (0, $938aefa455a73c9b$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $938aefa455a73c9b$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $0eb6b0656d09fb9a$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, $49516a074167c4be$export$be63e0664592e141)(children.type).endsWith('Chart');
        return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Children.map(children, function(child) {
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(child)) return /*#__PURE__*/ (0, $gIfym.cloneElement)(child, $d7b42fa8a2c2a4be$var$_objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: $d7b42fa8a2c2a4be$var$_objectSpread({
                    height: '100%',
                    width: '100%',
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-responsive-container', className),
        style: $d7b42fa8a2c2a4be$var$_objectSpread($d7b42fa8a2c2a4be$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});


var $9ab48ceec76c3abe$exports = {};
"use strict";
Object.defineProperty($9ab48ceec76c3abe$exports, "__esModule", {
    value: true
});
$9ab48ceec76c3abe$exports.default = void 0;
var $9ab48ceec76c3abe$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $9ab48ceec76c3abe$var$_default = $9ab48ceec76c3abe$var$blue;
$9ab48ceec76c3abe$exports.default = $9ab48ceec76c3abe$var$_default;


var $f86af20846cb37e6$exports = {};
"use strict";
Object.defineProperty($f86af20846cb37e6$exports, "__esModule", {
    value: true
});
$f86af20846cb37e6$exports.default = void 0;
var $f86af20846cb37e6$var$brown = {
    50: '#efebe9',
    100: '#d7ccc8',
    200: '#bcaaa4',
    300: '#a1887f',
    400: '#8d6e63',
    500: '#795548',
    600: '#6d4c41',
    700: '#5d4037',
    800: '#4e342e',
    900: '#3e2723',
    A100: '#d7ccc8',
    A200: '#bcaaa4',
    A400: '#8d6e63',
    A700: '#5d4037'
};
var $f86af20846cb37e6$var$_default = $f86af20846cb37e6$var$brown;
$f86af20846cb37e6$exports.default = $f86af20846cb37e6$var$_default;


var $26fe8914417e9386$exports = {};
"use strict";
Object.defineProperty($26fe8914417e9386$exports, "__esModule", {
    value: true
});
$26fe8914417e9386$exports.default = void 0;
var $26fe8914417e9386$var$cyan = {
    50: '#e0f7fa',
    100: '#b2ebf2',
    200: '#80deea',
    300: '#4dd0e1',
    400: '#26c6da',
    500: '#00bcd4',
    600: '#00acc1',
    700: '#0097a7',
    800: '#00838f',
    900: '#006064',
    A100: '#84ffff',
    A200: '#18ffff',
    A400: '#00e5ff',
    A700: '#00b8d4'
};
var $26fe8914417e9386$var$_default = $26fe8914417e9386$var$cyan;
$26fe8914417e9386$exports.default = $26fe8914417e9386$var$_default;


var $405eaf374adbf14a$exports = {};
"use strict";
Object.defineProperty($405eaf374adbf14a$exports, "__esModule", {
    value: true
});
$405eaf374adbf14a$exports.default = void 0;
var $405eaf374adbf14a$var$deepOrange = {
    50: '#fbe9e7',
    100: '#ffccbc',
    200: '#ffab91',
    300: '#ff8a65',
    400: '#ff7043',
    500: '#ff5722',
    600: '#f4511e',
    700: '#e64a19',
    800: '#d84315',
    900: '#bf360c',
    A100: '#ff9e80',
    A200: '#ff6e40',
    A400: '#ff3d00',
    A700: '#dd2c00'
};
var $405eaf374adbf14a$var$_default = $405eaf374adbf14a$var$deepOrange;
$405eaf374adbf14a$exports.default = $405eaf374adbf14a$var$_default;


var $69ff0d593aff65ba$exports = {};
"use strict";
Object.defineProperty($69ff0d593aff65ba$exports, "__esModule", {
    value: true
});
$69ff0d593aff65ba$exports.default = void 0;
var $69ff0d593aff65ba$var$deepPurple = {
    50: '#ede7f6',
    100: '#d1c4e9',
    200: '#b39ddb',
    300: '#9575cd',
    400: '#7e57c2',
    500: '#673ab7',
    600: '#5e35b1',
    700: '#512da8',
    800: '#4527a0',
    900: '#311b92',
    A100: '#b388ff',
    A200: '#7c4dff',
    A400: '#651fff',
    A700: '#6200ea'
};
var $69ff0d593aff65ba$var$_default = $69ff0d593aff65ba$var$deepPurple;
$69ff0d593aff65ba$exports.default = $69ff0d593aff65ba$var$_default;


var $40a8ce25cc803fd2$exports = {};
"use strict";
Object.defineProperty($40a8ce25cc803fd2$exports, "__esModule", {
    value: true
});
$40a8ce25cc803fd2$exports.default = void 0;
var $40a8ce25cc803fd2$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $40a8ce25cc803fd2$var$_default = $40a8ce25cc803fd2$var$green;
$40a8ce25cc803fd2$exports.default = $40a8ce25cc803fd2$var$_default;


var $0e95a667be2070c3$exports = {};
"use strict";
Object.defineProperty($0e95a667be2070c3$exports, "__esModule", {
    value: true
});
$0e95a667be2070c3$exports.default = void 0;
var $0e95a667be2070c3$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161'
};
var $0e95a667be2070c3$var$_default = $0e95a667be2070c3$var$grey;
$0e95a667be2070c3$exports.default = $0e95a667be2070c3$var$_default;


var $ce4a8fb4445df6e0$exports = {};
"use strict";
Object.defineProperty($ce4a8fb4445df6e0$exports, "__esModule", {
    value: true
});
$ce4a8fb4445df6e0$exports.default = void 0;
var $ce4a8fb4445df6e0$var$indigo = {
    50: '#e8eaf6',
    100: '#c5cae9',
    200: '#9fa8da',
    300: '#7986cb',
    400: '#5c6bc0',
    500: '#3f51b5',
    600: '#3949ab',
    700: '#303f9f',
    800: '#283593',
    900: '#1a237e',
    A100: '#8c9eff',
    A200: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe'
};
var $ce4a8fb4445df6e0$var$_default = $ce4a8fb4445df6e0$var$indigo;
$ce4a8fb4445df6e0$exports.default = $ce4a8fb4445df6e0$var$_default;


var $d7beb7893440f1ae$exports = {};
"use strict";
Object.defineProperty($d7beb7893440f1ae$exports, "__esModule", {
    value: true
});
$d7beb7893440f1ae$exports.default = void 0;
var $d7beb7893440f1ae$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $d7beb7893440f1ae$var$_default = $d7beb7893440f1ae$var$orange;
$d7beb7893440f1ae$exports.default = $d7beb7893440f1ae$var$_default;


var $371a9e24bdb95312$exports = {};
"use strict";
Object.defineProperty($371a9e24bdb95312$exports, "__esModule", {
    value: true
});
$371a9e24bdb95312$exports.default = void 0;
var $371a9e24bdb95312$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $371a9e24bdb95312$var$_default = $371a9e24bdb95312$var$red;
$371a9e24bdb95312$exports.default = $371a9e24bdb95312$var$_default;


var $2febbd80a08de7ea$exports = {};
"use strict";
Object.defineProperty($2febbd80a08de7ea$exports, "__esModule", {
    value: true
});
$2febbd80a08de7ea$exports.default = void 0;
var $2febbd80a08de7ea$var$teal = {
    50: '#e0f2f1',
    100: '#b2dfdb',
    200: '#80cbc4',
    300: '#4db6ac',
    400: '#26a69a',
    500: '#009688',
    600: '#00897b',
    700: '#00796b',
    800: '#00695c',
    900: '#004d40',
    A100: '#a7ffeb',
    A200: '#64ffda',
    A400: '#1de9b6',
    A700: '#00bfa5'
};
var $2febbd80a08de7ea$var$_default = $2febbd80a08de7ea$var$teal;
$2febbd80a08de7ea$exports.default = $2febbd80a08de7ea$var$_default;


var $7fd84a775464cfef$exports = {};
"use strict";
Object.defineProperty($7fd84a775464cfef$exports, "__esModule", {
    value: true
});
$7fd84a775464cfef$exports.default = void 0;
var $7fd84a775464cfef$var$yellow = {
    50: '#fffde7',
    100: '#fff9c4',
    200: '#fff59d',
    300: '#fff176',
    400: '#ffee58',
    500: '#ffeb3b',
    600: '#fdd835',
    700: '#fbc02d',
    800: '#f9a825',
    900: '#f57f17',
    A100: '#ffff8d',
    A200: '#ffff00',
    A400: '#ffea00',
    A700: '#ffd600'
};
var $7fd84a775464cfef$var$_default = $7fd84a775464cfef$var$yellow;
$7fd84a775464cfef$exports.default = $7fd84a775464cfef$var$_default;


const $e95a10c0d7b6a200$export$9ad721cf3b3debe0 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($9ab48ceec76c3abe$exports)))[500],
    (0, (/*@__PURE__*/$parcel$interopDefault($371a9e24bdb95312$exports)))[500],
    (0, (/*@__PURE__*/$parcel$interopDefault($40a8ce25cc803fd2$exports)))[500],
    (0, (/*@__PURE__*/$parcel$interopDefault($7fd84a775464cfef$exports)))[500],
    (0, (/*@__PURE__*/$parcel$interopDefault($26fe8914417e9386$exports)))[500],
    (0, (/*@__PURE__*/$parcel$interopDefault($d7beb7893440f1ae$exports)))[500],
    (0, (/*@__PURE__*/$parcel$interopDefault($2febbd80a08de7ea$exports)))[500],
    (0, (/*@__PURE__*/$parcel$interopDefault($ce4a8fb4445df6e0$exports)))[500],
    (0, (/*@__PURE__*/$parcel$interopDefault($405eaf374adbf14a$exports)))[500],
    (0, (/*@__PURE__*/$parcel$interopDefault($69ff0d593aff65ba$exports)))[500]
];
const $e95a10c0d7b6a200$export$88f5aeecbc5784c1 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($0e95a667be2070c3$exports)))[300],
    (0, (/*@__PURE__*/$parcel$interopDefault($0e95a667be2070c3$exports)))[400],
    (0, (/*@__PURE__*/$parcel$interopDefault($0e95a667be2070c3$exports)))[200],
    (0, (/*@__PURE__*/$parcel$interopDefault($0e95a667be2070c3$exports)))[500],
    (0, (/*@__PURE__*/$parcel$interopDefault($0e95a667be2070c3$exports)))[100],
    (0, (/*@__PURE__*/$parcel$interopDefault($0e95a667be2070c3$exports)))[600]
];
const $e95a10c0d7b6a200$export$bcdff0aad5ea3623 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($f86af20846cb37e6$exports)))[500]
];



var $6IRuR = parcelRequire("6IRuR");
const $f5a389928d825682$export$59d6215c1fd3d225 = [
    {
        name: "Today",
        value: "today"
    },
    {
        name: "Yesterday",
        value: "yesterday"
    },
    {
        name: "Last 24h",
        value: "24h"
    },
    {
        name: "Last 48h",
        value: "48h"
    },
    {
        name: "Week-to-date",
        value: "week"
    },
    {
        name: "Last week",
        value: "lastweek"
    },
    {
        name: "Last 7 days",
        value: "7d"
    },
    {
        name: "Last 14 days",
        value: "14d"
    }
];
const $f5a389928d825682$export$b03894030256da6c = [
    {
        name: "Account",
        value: "accountID"
    },
    {
        name: "Invoice Entity",
        value: "invoiceEntityID"
    },
    {
        name: "Provider",
        value: "provider"
    },
    {
        name: "Service ",
        value: "service"
    },
    {
        name: "Category",
        value: "category"
    },
    {
        name: "Item",
        value: "item"
    }
];
const $f5a389928d825682$export$38808721902aaeb5 = [
    {
        name: "Amortized Net Cost",
        value: "AmortizedNetCost"
    },
    {
        name: "List Cost",
        value: "ListCost"
    },
    {
        name: "Invoiced Cost",
        value: "InvoicedCost"
    },
    {
        name: "Amortized Cost",
        value: "AmortizedCost"
    }
];
const $f5a389928d825682$export$95c5080e14eb34f6 = {
    invoiceEntityID: "Invoice Entity",
    provider: "Provider",
    service: "Service",
    accountID: "Account"
};
const $f5a389928d825682$export$b4f68472a7299187 = {
    AmortizedNetCost: "amortizedNetCost",
    AmortizedCost: "amortizedCost",
    ListCost: "listCost",
    NetCost: "netCost",
    InvoicedCost: "invoicedCost"
};


function $4ab43b5ac1a299dc$export$ec4dc9faeed50c1d(allocationSetRange, aggregateBy) {
    if (allocationSetRange.length === 0) return null;
    const result = {};
    (0, $6IRuR.forEach)(allocationSetRange, (allocSet)=>{
        (0, $6IRuR.forEach)(allocSet, (alloc)=>{
            if (result[alloc.name] === undefined) {
                const hrs = (0, $6IRuR.get)(alloc, "minutes", 0) / 60.0;
                result[alloc.name] = {
                    name: alloc.name,
                    [aggregateBy]: alloc.name,
                    cpuCost: (0, $6IRuR.get)(alloc, "cpuCost", 0),
                    gpuCost: (0, $6IRuR.get)(alloc, "gpuCost", 0),
                    ramCost: (0, $6IRuR.get)(alloc, "ramCost", 0),
                    pvCost: (0, $6IRuR.get)(alloc, "pvCost", 0),
                    networkCost: (0, $6IRuR.get)(alloc, "networkCost", 0),
                    sharedCost: (0, $6IRuR.get)(alloc, "sharedCost", 0),
                    externalCost: (0, $6IRuR.get)(alloc, "externalCost", 0),
                    totalCost: (0, $6IRuR.get)(alloc, "totalCost", 0),
                    cpuUseCoreHrs: (0, $6IRuR.get)(alloc, "cpuCoreUsageAverage", 0) * hrs,
                    cpuReqCoreHrs: (0, $6IRuR.get)(alloc, "cpuCoreRequestAverage", 0) * hrs,
                    ramUseByteHrs: (0, $6IRuR.get)(alloc, "ramByteUsageAverage", 0) * hrs,
                    ramReqByteHrs: (0, $6IRuR.get)(alloc, "ramByteRequestAverage", 0) * hrs,
                    cpuEfficiency: (0, $6IRuR.get)(alloc, "cpuEfficiency", 0),
                    ramEfficiency: (0, $6IRuR.get)(alloc, "ramEfficiency", 0),
                    totalEfficiency: (0, $6IRuR.get)(alloc, "totalEfficiency", 0)
                };
            } else {
                const hrs = (0, $6IRuR.get)(alloc, "minutes", 0) / 60.0;
                result[alloc.name].cpuCost += (0, $6IRuR.get)(alloc, "cpuCost", 0);
                result[alloc.name].gpuCost += (0, $6IRuR.get)(alloc, "gpuCost", 0);
                result[alloc.name].ramCost += (0, $6IRuR.get)(alloc, "ramCost", 0);
                result[alloc.name].pvCost += (0, $6IRuR.get)(alloc, "pvCost", 0);
                result[alloc.name].networkCost += (0, $6IRuR.get)(alloc, "networkCost", 0);
                result[alloc.name].sharedCost += (0, $6IRuR.get)(alloc, "sharedCost", 0);
                result[alloc.name].externalCost += (0, $6IRuR.get)(alloc, "externalCost", 0);
                result[alloc.name].totalCost += (0, $6IRuR.get)(alloc, "totalCost", 0);
                result[alloc.name].cpuUseCoreHrs += (0, $6IRuR.get)(alloc, "cpuCoreUsageAverage", 0) * hrs;
                result[alloc.name].cpuReqCoreHrs += (0, $6IRuR.get)(alloc, "cpuCoreRequestAverage", 0) * hrs;
                result[alloc.name].ramUseByteHrs += (0, $6IRuR.get)(alloc, "ramByteUsageAverage", 0) * hrs;
                result[alloc.name].ramReqByteHrs += (0, $6IRuR.get)(alloc, "ramByteRequestAverage", 0) * hrs;
            }
        });
    });
    // If the range is of length > 1 (i.e. it is not just a single set) then
    // compute efficiency for each result after accumulating.
    if (allocationSetRange.length > 1) (0, $6IRuR.forEach)(result, (alloc, name)=>{
        // If we can't compute total efficiency, it defaults to 0.0
        let totalEfficiency = 0.0;
        // CPU efficiency is defined as (usage/request). If request == 0.0 but
        // usage > 0, then efficiency gets set to 1.0.
        let cpuEfficiency = 0.0;
        if (alloc.cpuReqCoreHrs > 0) cpuEfficiency = alloc.cpuUseCoreHrs / alloc.cpuReqCoreHrs;
        else if (alloc.cpuUseCoreHrs > 0) cpuEfficiency = 1.0;
        // RAM efficiency is defined as (usage/request). If request == 0.0 but
        // usage > 0, then efficiency gets set to 1.0.
        let ramEfficiency = 0.0;
        if (alloc.ramReqByteHrs > 0) ramEfficiency = alloc.ramUseByteHrs / alloc.ramReqByteHrs;
        else if (alloc.ramUseByteHrs > 0) ramEfficiency = 1.0;
        // Compute efficiency as the cost-weighted average of CPU and RAM
        // efficiency
        if (alloc.cpuCost + alloc.ramCost > 0.0) totalEfficiency = (alloc.cpuCost * cpuEfficiency + alloc.ramCost * ramEfficiency) / (alloc.cpuCost + alloc.ramCost);
        result[name].cpuEfficiency = cpuEfficiency;
        result[name].ramEfficiency = ramEfficiency;
        result[name].totalEfficiency = totalEfficiency;
    });
    return result;
}
function $4ab43b5ac1a299dc$export$9a53f1556c71494a(allocationSet) {
    let totals = {
        name: "Totals",
        cpuCost: 0,
        gpuCost: 0,
        ramCost: 0,
        pvCost: 0,
        networkCost: 0,
        sharedCost: 0,
        externalCost: 0,
        totalCost: 0,
        cpuEfficiency: 0,
        ramEfficiency: 0,
        totalEfficiency: 0
    };
    // Use these for computing efficiency. As such, idle will not factor into
    // these numbers, including CPU and RAM cost.
    let cpuReqCoreHrs = 0;
    let cpuUseCoreHrs = 0;
    let ramReqByteHrs = 0;
    let ramUseByteHrs = 0;
    let cpuCost = 0;
    let ramCost = 0;
    (0, $6IRuR.forEach)(allocationSet, (alloc, name)=>{
        // Accumulate efficiency-related fields
        if (name !== "__idle__") {
            cpuReqCoreHrs += (0, $6IRuR.get)(alloc, "cpuReqCoreHrs", 0.0);
            cpuUseCoreHrs += (0, $6IRuR.get)(alloc, "cpuUseCoreHrs", 0.0);
            ramReqByteHrs += (0, $6IRuR.get)(alloc, "ramReqByteHrs", 0.0);
            ramUseByteHrs += (0, $6IRuR.get)(alloc, "ramUseByteHrs", 0.0);
            cpuCost += (0, $6IRuR.get)(alloc, "cpuCost", 0.0);
            ramCost += (0, $6IRuR.get)(alloc, "ramCost", 0.0);
        }
        // Sum cumulative fields
        totals.cpuCost += (0, $6IRuR.get)(alloc, "cpuCost", 0);
        totals.gpuCost += (0, $6IRuR.get)(alloc, "gpuCost", 0);
        totals.ramCost += (0, $6IRuR.get)(alloc, "ramCost", 0);
        totals.pvCost += (0, $6IRuR.get)(alloc, "pvCost", 0);
        totals.networkCost += (0, $6IRuR.get)(alloc, "networkCost", 0);
        totals.sharedCost += (0, $6IRuR.get)(alloc, "sharedCost", 0);
        totals.externalCost += (0, $6IRuR.get)(alloc, "externalCost", 0);
        totals.totalCost += (0, $6IRuR.get)(alloc, "totalCost", 0);
    });
    // Compute efficiency
    if (cpuReqCoreHrs > 0) totals.cpuEfficiency = cpuUseCoreHrs / cpuReqCoreHrs;
    else if (cpuUseCoreHrs > 0) totals.cpuEfficiency = 1.0;
    if (ramReqByteHrs > 0) totals.ramEfficiency = ramUseByteHrs / ramReqByteHrs;
    else if (ramUseByteHrs > 0) totals.ramEfficiency = 1.0;
    if (cpuCost + ramCost > 0) totals.totalEfficiency = (cpuCost * totals.cpuEfficiency + ramCost * totals.ramEfficiency) / (cpuCost + ramCost);
    totals.cpuReqCoreHrs = cpuReqCoreHrs;
    totals.cpuUseCoreHrs = cpuUseCoreHrs;
    totals.ramReqByteHrs = ramReqByteHrs;
    totals.ramUseByteHrs = ramUseByteHrs;
    return totals;
}
function $4ab43b5ac1a299dc$export$2e6bf8a055fccba2(window) {
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    const start = new Date();
    start.setUTCHours(0, 0, 0, 0);
    const end = new Date();
    end.setUTCHours(0, 0, 0, 0);
    switch(window){
        case "today":
            return `${start.getUTCDate()} ${months[start.getUTCMonth()]} ${start.getUTCFullYear()}`;
        case "yesterday":
            start.setUTCDate(start.getUTCDate() - 1);
            return `${start.getUTCDate()} ${months[start.getUTCMonth()]} ${start.getUTCFullYear()}`;
        case "week":
            start.setUTCDate(start.getUTCDate() - start.getUTCDay());
            return `${start.getUTCDate()} ${months[start.getUTCMonth()]} ${start.getUTCFullYear()} until now`;
        case "month":
            start.setUTCDate(1);
            return `${start.getUTCDate()} ${months[start.getUTCMonth()]} ${start.getUTCFullYear()} until now`;
        case "lastweek":
            start.setUTCDate(start.getUTCDate() - (start.getUTCDay() + 7));
            end.setUTCDate(end.getUTCDate() - (end.getUTCDay() + 1));
            return `${start.getUTCDate()} ${months[start.getUTCMonth()]} ${start.getUTCFullYear()} through ${end.getUTCDate()} ${months[end.getUTCMonth()]} ${end.getUTCFullYear()}`;
        case "lastmonth":
            end.setUTCDate(1);
            end.setUTCDate(end.getUTCDate() - 1);
            start.setUTCDate(1);
            start.setUTCDate(start.getUTCDate() - 1);
            start.setUTCDate(1);
            return `${start.getUTCDate()} ${months[start.getUTCMonth()]} ${start.getUTCFullYear()} through ${end.getUTCDate()} ${months[end.getUTCMonth()]} ${end.getUTCFullYear()}`;
        case "6d":
            start.setUTCDate(start.getUTCDate() - 6);
            return `${start.getUTCDate()} ${months[start.getUTCMonth()]} ${start.getUTCFullYear()} through now`;
        case "29d":
            start.setUTCDate(start.getUTCDate() - 29);
            return `${start.getUTCDate()} ${months[start.getUTCMonth()]} ${start.getUTCFullYear()} through now`;
        case "59d":
            start.setUTCDate(start.getUTCDate() - 59);
            return `${start.getUTCDate()} ${months[start.getUTCMonth()]} ${start.getUTCFullYear()} through now`;
        case "89d":
            start.setUTCDate(start.getUTCDate() - 89);
            return `${start.getUTCDate()} ${months[start.getUTCMonth()]} ${start.getUTCFullYear()} through now`;
    }
    const splitDates = window.split(",");
    if ($4ab43b5ac1a299dc$export$8764230b0d460478(window) && splitDates.length > 1) {
        let s = splitDates[0].split(/\D+/).slice(0, 3);
        let e = splitDates[1].split(/\D+/).slice(0, 3);
        if (s.length === 3 && e.length === 3) {
            start.setUTCFullYear(s[0], s[1] - 1, s[2]);
            end.setUTCFullYear(e[0], e[1] - 1, e[2]);
            if (start === end) return `${start.getUTCDate()} ${months[start.getUTCMonth()]} ${start.getUTCFullYear()}`;
            else return `${start.getUTCDate()} ${months[start.getUTCMonth()]} ${start.getUTCFullYear()} through ${end.getUTCDate()} ${months[end.getUTCMonth()]} ${end.getUTCFullYear()}`;
        }
    }
    return null;
}
function $4ab43b5ac1a299dc$export$7c746b75f47c9c7d(bytes) {
    const ei = Math.pow(1024, 6);
    if (bytes >= ei) return `${(0, $6IRuR.round)(bytes / ei, 1)} EiB`;
    const pi = Math.pow(1024, 5);
    if (bytes >= pi) return `${(0, $6IRuR.round)(bytes / pi, 1)} PiB`;
    const ti = Math.pow(1024, 4);
    if (bytes >= ti) return `${(0, $6IRuR.round)(bytes / ti, 1)} TiB`;
    const gi = Math.pow(1024, 3);
    if (bytes >= gi) return `${(0, $6IRuR.round)(bytes / gi, 1)} GiB`;
    const mi = Math.pow(1024, 2);
    if (bytes >= mi) return `${(0, $6IRuR.round)(bytes / mi, 1)} MiB`;
    const ki = Math.pow(1024, 1);
    if (bytes >= ki) return `${(0, $6IRuR.round)(bytes / ki, 1)} KiB`;
    return `${(0, $6IRuR.round)(bytes, 1)} B`;
}
const $4ab43b5ac1a299dc$var$currencyLocale = "en-US";
function $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f(amount, currency, precision) {
    if (typeof amount !== "number") {
        console.warn(`Tried to convert "${amount}" to currency, but it is not a number`);
        return "";
    }
    if (currency === undefined || currency === "") currency = "USD";
    const opts = {
        style: "currency",
        currency: currency
    };
    if (typeof precision === "number") {
        opts.minimumFractionDigits = precision;
        opts.maximumFractionDigits = precision;
    }
    return amount.toLocaleString($4ab43b5ac1a299dc$var$currencyLocale, opts);
}
function $4ab43b5ac1a299dc$export$8764230b0d460478(window) {
    // Example ISO interval string: 2020-12-02T00:00:00Z,2020-12-03T23:59:59Z
    const customDateRegex = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z,\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/;
    return customDateRegex.test(window);
}
function $4ab43b5ac1a299dc$export$a51d156d37e37a34({ data: data, costMetric: costMetric }) {
    const costMetricPropName = costMetric ? (0, $f5a389928d825682$export$b4f68472a7299187)[costMetric] : "amortizedNetCost";
    const graphData = data.sets.map(({ cloudCosts: cloudCosts, window: { end: end, start: start } })=>{
        return {
            end: end,
            items: Object.entries(cloudCosts).map(([name, item])=>({
                    name: name,
                    value: item.netCost.cost
                })),
            start: start
        };
    });
    const accumulator = {};
    data.sets.forEach(({ cloudCosts: cloudCosts, window: window })=>{
        Object.entries(cloudCosts).forEach(([name, cloudCostItem])=>{
            const { properties: properties } = cloudCostItem;
            accumulator[name] ||= {
                cost: 0,
                start: "",
                end: "",
                providerID: "",
                labelName: "",
                kubernetesCost: 0,
                kubernetesPercent: 0
            };
            accumulator[name].cost += cloudCostItem[costMetricPropName].cost;
            accumulator[name].kubernetesCost += cloudCostItem[costMetricPropName].cost * cloudCostItem[costMetricPropName].kubernetesPercent;
            accumulator[name].start = window.start;
            accumulator[name].end = window.end;
            accumulator[name].providerID = properties.providerID;
            accumulator[name].labelName = properties.labels?.name;
            accumulator[name].kubernetesPercent = cloudCostItem[costMetricPropName].kubernetesPercent;
        });
    });
    const tableRows = Object.entries(accumulator).map(([name, { cost: cost, start: start, end: end, providerID: providerID, kubernetesCost: kubernetesCost, kubernetesPercent: kubernetesPercent, labelName: labelName }])=>({
            cost: cost,
            name: name,
            kubernetesCost: kubernetesCost,
            kubernetesPercent: kubernetesPercent,
            start: start,
            end: end,
            providerID: providerID,
            labelName: labelName
        })).sort((a, b)=>a.cost > b.cost ? -1 : 1);
    const tableTotal = tableRows.reduce((tr1, tr2)=>({
            ...tr1,
            cost: tr1.cost + tr2.cost,
            kubernetesCost: tr1.kubernetesCost + tr2.kubernetesCost
        }), {
        cost: 0,
        name: "",
        kubernetesCost: 0,
        kubernetesPercent: 0,
        end: "",
        start: "",
        labelName: "",
        providerID: ""
    });
    return {
        graphData: graphData,
        tableRows: tableRows,
        tableTotal: tableTotal
    };
}
function $4ab43b5ac1a299dc$export$2f387f690230eab4(filters) {
    if (typeof filters === "string") return filters;
    // remove dups (via context ) and format
    return [
        ...new Set(filters.map((f)=>`${f.property}:"${f.value}"`))
    ].join(encodeURIComponent("+")) || "";
}
var $4ab43b5ac1a299dc$export$2e2bcd8739ae039 = {
    rangeToCumulative: $4ab43b5ac1a299dc$export$ec4dc9faeed50c1d,
    cumulativeToTotals: $4ab43b5ac1a299dc$export$9a53f1556c71494a,
    toVerboseTimeRange: $4ab43b5ac1a299dc$export$2e6bf8a055fccba2,
    bytesToString: $4ab43b5ac1a299dc$export$7c746b75f47c9c7d,
    toCurrency: $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f,
    checkCustomWindow: $4ab43b5ac1a299dc$export$8764230b0d460478
};


const $7bdc138bb0995da0$var$useStyles = (0, $hQJVM.default)({
    tooltip: {
        borderRadius: 2,
        background: 'rgba(255, 255, 255, 0.95)',
        padding: 12
    },
    tooltipLineItem: {
        fontSize: '1rem',
        margin: 0,
        marginBottom: 4,
        padding: 0
    }
});
function $7bdc138bb0995da0$var$toBarLabels(allocationRange) {
    let keyToFill = {};
    let p = 0;
    let g = 0;
    let b = 0;
    for (const { idle: idle } of allocationRange)for (const allocation of idle){
        const key = allocation.name;
        if (keyToFill[key] === undefined) {
            // idle allocations are assigned grey
            keyToFill[key] = (0, $e95a10c0d7b6a200$export$88f5aeecbc5784c1)[g];
            g = (g + 1) % (0, $e95a10c0d7b6a200$export$88f5aeecbc5784c1).length;
        }
    }
    for (const { top: top } of allocationRange)for (const allocation of top){
        const key = allocation.name;
        if (keyToFill[key] === undefined) {
            if (key === "__unallocated__") // unallocated gets black (clean up)
            keyToFill[key] = "#212121";
            else {
                // non-idle allocations get the next available color
                keyToFill[key] = (0, $e95a10c0d7b6a200$export$9ad721cf3b3debe0)[p];
                p = (p + 1) % (0, $e95a10c0d7b6a200$export$9ad721cf3b3debe0).length;
            }
        }
    }
    for (const { other: other } of allocationRange)for (const allocation of other){
        const key = allocation.name;
        if (keyToFill[key] === undefined) {
            // idle allocations are assigned grey
            keyToFill[key] = (0, $e95a10c0d7b6a200$export$bcdff0aad5ea3623)[b];
            b = (b + 1) % (0, $e95a10c0d7b6a200$export$bcdff0aad5ea3623).length;
        }
    }
    let labels = [];
    for(const key in keyToFill)labels.push({
        dataKey: key,
        fill: keyToFill[key]
    });
    return (0, $6IRuR.reverse)(labels);
}
function $7bdc138bb0995da0$var$toBar(datum) {
    const { top: top, other: other, idle: idle } = datum;
    const bar = {};
    for(const key in top){
        const allocation = top[key];
        const start = new Date(allocation.start);
        bar.start = `${start.getUTCFullYear()}-${start.getUTCMonth() + 1}-${start.getUTCDate()}`;
        bar[allocation.name] = allocation.totalCost;
    }
    for(const key in other){
        const allocation = other[key];
        const start = new Date(allocation.start);
        bar.start = `${start.getUTCFullYear()}-${start.getUTCMonth() + 1}-${start.getUTCDate()}`;
        bar[allocation.name] = allocation.totalCost;
    }
    for(const key in idle){
        const allocation = idle[key];
        const start = new Date(allocation.start);
        bar.start = `${start.getUTCFullYear()}-${start.getUTCMonth() + 1}-${start.getUTCDate()}`;
        bar[allocation.name] = allocation.totalCost;
    }
    return bar;
}
const $7bdc138bb0995da0$var$RangeChart = ({ data: data, currency: currency, height: height })=>{
    const classes = $7bdc138bb0995da0$var$useStyles();
    const barData = data.map($7bdc138bb0995da0$var$toBar);
    const barLabels = $7bdc138bb0995da0$var$toBarLabels(data);
    const CustomTooltip = (params)=>{
        const { active: active, payload: payload } = params;
        if (!payload || payload.length == 0) return null;
        const total = payload.reduce((sum, item)=>sum + item.value, 0.0);
        if (active) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: classes.tooltip,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                    className: classes.tooltipLineItem,
                    style: {
                        color: '#000000'
                    },
                    children: `Total: ${(0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(total, currency)}`
                }),
                (0, $6IRuR.reverse)(payload).map((item, i)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                        className: classes.tooltipLineItem,
                        style: {
                            color: item.fill
                        },
                        children: `${item.name}: ${(0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(item.value, currency)}`
                    }, i))
            ]
        });
        return null;
    };
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d7b42fa8a2c2a4be$export$e60a4704009a0009), {
        width: "100%",
        height: height,
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $e5f9bccf45a8faa3$export$94aefc399ef206a9), {
            data: barData,
            margin: {
                top: 30,
                right: 30,
                left: 30,
                bottom: 12
            },
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $1e8a496f1b0dc2f3$export$6440e27b9f186856), {
                    strokeDasharray: "3 3"
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $4599bbc635684a39$export$ea77231de273b52d), {
                    dataKey: "start"
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $dc3299e5adf43c53$export$f96c4024c52de8f4), {}),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $af95134c6736175e$export$28c660c63b792dea), {
                    content: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)(CustomTooltip, {})
                }),
                barLabels.map((barLabel, i)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $7f0f02843a7c30b4$export$bbc6c6369b38e3d1), {
                        dataKey: barLabel.dataKey,
                        stackId: "a",
                        fill: barLabel.fill
                    }, i))
            ]
        })
    });
};
var $7bdc138bb0995da0$export$2e2bcd8739ae039 = $7bdc138bb0995da0$var$RangeChart;



parcelRequire("gIfym");

var $gIfym = parcelRequire("gIfym");




















var $a9eb26465817775c$var$_Pie;
function $a9eb26465817775c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a9eb26465817775c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a9eb26465817775c$var$_typeof(o);
}
function $a9eb26465817775c$var$_extends() {
    $a9eb26465817775c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a9eb26465817775c$var$_extends.apply(this, arguments);
}
function $a9eb26465817775c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a9eb26465817775c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a9eb26465817775c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a9eb26465817775c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a9eb26465817775c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a9eb26465817775c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a9eb26465817775c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a9eb26465817775c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a9eb26465817775c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a9eb26465817775c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a9eb26465817775c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a9eb26465817775c$var$_callSuper(t, o, e) {
    return o = $a9eb26465817775c$var$_getPrototypeOf(o), $a9eb26465817775c$var$_possibleConstructorReturn(t, $a9eb26465817775c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $a9eb26465817775c$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $a9eb26465817775c$var$_possibleConstructorReturn(self, call) {
    if (call && ($a9eb26465817775c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $a9eb26465817775c$var$_assertThisInitialized(self);
}
function $a9eb26465817775c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a9eb26465817775c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a9eb26465817775c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a9eb26465817775c$var$_getPrototypeOf(o) {
    $a9eb26465817775c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a9eb26465817775c$var$_getPrototypeOf(o);
}
function $a9eb26465817775c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a9eb26465817775c$var$_setPrototypeOf(subClass, superClass);
}
function $a9eb26465817775c$var$_setPrototypeOf(o, p) {
    $a9eb26465817775c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a9eb26465817775c$var$_setPrototypeOf(o, p);
}
function $a9eb26465817775c$var$_defineProperty(obj, key, value) {
    key = $a9eb26465817775c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a9eb26465817775c$var$_toPropertyKey(t) {
    var i = $a9eb26465817775c$var$_toPrimitive(t, "string");
    return "symbol" == $a9eb26465817775c$var$_typeof(i) ? i : i + "";
}
function $a9eb26465817775c$var$_toPrimitive(t, r) {
    if ("object" != $a9eb26465817775c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a9eb26465817775c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $a9eb26465817775c$export$2ae8800cf67c848c = /*#__PURE__*/ function(_PureComponent) {
    function Pie(props) {
        var _this;
        $a9eb26465817775c$var$_classCallCheck(this, Pie);
        _this = $a9eb26465817775c$var$_callSuper(this, Pie, [
            props
        ]);
        $a9eb26465817775c$var$_defineProperty(_this, "pieRef", null);
        $a9eb26465817775c$var$_defineProperty(_this, "sectorRefs", []);
        $a9eb26465817775c$var$_defineProperty(_this, "id", (0, $938aefa455a73c9b$export$8b15d37bc3f197d4)('recharts-pie-'));
        $a9eb26465817775c$var$_defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(onAnimationEnd)) onAnimationEnd();
        });
        $a9eb26465817775c$var$_defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(onAnimationStart)) onAnimationStart();
        });
        _this.state = {
            isAnimationFinished: !props.isAnimationActive,
            prevIsAnimationActive: props.isAnimationActive,
            prevAnimationId: props.animationId,
            sectorToFocus: 0
        };
        return _this;
    }
    $a9eb26465817775c$var$_inherits(Pie, _PureComponent);
    return $a9eb26465817775c$var$_createClass(Pie, [
        {
            key: "isActiveIndex",
            value: function isActiveIndex(i) {
                var activeIndex = this.props.activeIndex;
                if (Array.isArray(activeIndex)) return activeIndex.indexOf(i) !== -1;
                return i === activeIndex;
            }
        },
        {
            key: "hasActiveIndex",
            value: function hasActiveIndex() {
                var activeIndex = this.props.activeIndex;
                return Array.isArray(activeIndex) ? activeIndex.length !== 0 : activeIndex || activeIndex === 0;
            }
        },
        {
            key: "renderLabels",
            value: function renderLabels(sectors) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, label = _this$props.label, labelLine = _this$props.labelLine, dataKey = _this$props.dataKey, valueKey = _this$props.valueKey;
                var pieProps = (0, $49516a074167c4be$export$d697c39a2985a4c)(this.props, false);
                var customLabelProps = (0, $49516a074167c4be$export$d697c39a2985a4c)(label, false);
                var customLabelLineProps = (0, $49516a074167c4be$export$d697c39a2985a4c)(labelLine, false);
                var offsetRadius = label && label.offsetRadius || 20;
                var labels = sectors.map(function(entry, i) {
                    var midAngle = (entry.startAngle + entry.endAngle) / 2;
                    var endPoint = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
                    var labelProps = $a9eb26465817775c$var$_objectSpread($a9eb26465817775c$var$_objectSpread($a9eb26465817775c$var$_objectSpread($a9eb26465817775c$var$_objectSpread({}, pieProps), entry), {}, {
                        stroke: 'none'
                    }, customLabelProps), {}, {
                        index: i,
                        textAnchor: Pie.getTextAnchor(endPoint.x, entry.cx)
                    }, endPoint);
                    var lineProps = $a9eb26465817775c$var$_objectSpread($a9eb26465817775c$var$_objectSpread($a9eb26465817775c$var$_objectSpread($a9eb26465817775c$var$_objectSpread({}, pieProps), entry), {}, {
                        fill: 'none',
                        stroke: entry.fill
                    }, customLabelLineProps), {}, {
                        index: i,
                        points: [
                            (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(entry.cx, entry.cy, entry.outerRadius, midAngle),
                            endPoint
                        ]
                    });
                    var realDataKey = dataKey;
                    // TODO: compatible to lower versions
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(dataKey) && (0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(valueKey)) realDataKey = 'value';
                    else if ((0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(dataKey)) realDataKey = valueKey;
                    return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                    (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
                        key: "label-".concat(entry.startAngle, "-").concat(entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
                    }, labelLine && Pie.renderLabelLineItem(labelLine, lineProps, 'line'), Pie.renderLabelItem(label, labelProps, (0, $2cf058a100d782d5$export$f97fc4a450f29a)(entry, realDataKey))));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
                    className: "recharts-pie-labels"
                }, labels);
            }
        },
        {
            key: "renderSectorsStatically",
            value: function renderSectorsStatically(sectors) {
                var _this2 = this;
                var _this$props2 = this.props, activeShape = _this$props2.activeShape, blendStroke = _this$props2.blendStroke, inactiveShapeProp = _this$props2.inactiveShape;
                return sectors.map(function(entry, i) {
                    if ((entry === null || entry === void 0 ? void 0 : entry.startAngle) === 0 && (entry === null || entry === void 0 ? void 0 : entry.endAngle) === 0 && sectors.length !== 1) return null;
                    var isActive = _this2.isActiveIndex(i);
                    var inactiveShape = inactiveShapeProp && _this2.hasActiveIndex() ? inactiveShapeProp : null;
                    var sectorOptions = isActive ? activeShape : inactiveShape;
                    var sectorProps = $a9eb26465817775c$var$_objectSpread($a9eb26465817775c$var$_objectSpread({}, entry), {}, {
                        stroke: blendStroke ? entry.fill : entry.stroke,
                        tabIndex: -1
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), $a9eb26465817775c$var$_extends({
                        ref: function ref(_ref) {
                            if (_ref && !_this2.sectorRefs.includes(_ref)) _this2.sectorRefs.push(_ref);
                        },
                        tabIndex: -1,
                        className: "recharts-pie-sector"
                    }, (0, $e49003a65b792e53$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        // eslint-disable-next-line react/no-array-index-key
                        key: "sector-".concat(entry === null || entry === void 0 ? void 0 : entry.startAngle, "-").concat(entry === null || entry === void 0 ? void 0 : entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $cf9db1230888ca89$export$6428a7f2611ef1fa), $a9eb26465817775c$var$_extends({
                        option: sectorOptions,
                        isActive: isActive,
                        shapeType: "sector"
                    }, sectorProps)));
                });
            }
        },
        {
            key: "renderSectorsWithAnimation",
            value: function renderSectorsWithAnimation() {
                var _this3 = this;
                var _this$props3 = this.props, sectors = _this$props3.sectors, isAnimationActive = _this$props3.isAnimationActive, animationBegin = _this$props3.animationBegin, animationDuration = _this$props3.animationDuration, animationEasing = _this$props3.animationEasing, animationId = _this$props3.animationId;
                var _this$state = this.state, prevSectors = _this$state.prevSectors, prevIsAnimationActive = _this$state.prevIsAnimationActive;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $c1c3cea1c393a834$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId, "-").concat(prevIsAnimationActive),
                    onAnimationStart: this.handleAnimationStart,
                    onAnimationEnd: this.handleAnimationEnd
                }, function(_ref2) {
                    var t = _ref2.t;
                    var stepData = [];
                    var first = sectors && sectors[0];
                    var curAngle = first.startAngle;
                    sectors.forEach(function(entry, index) {
                        var prev = prevSectors && prevSectors[index];
                        var paddingAngle = index > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($acb894cf4c1e4223$exports)))(entry, 'paddingAngle', 0) : 0;
                        if (prev) {
                            var angleIp = (0, $938aefa455a73c9b$export$d871d53bd7eeb390)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
                            var latest = $a9eb26465817775c$var$_objectSpread($a9eb26465817775c$var$_objectSpread({}, entry), {}, {
                                startAngle: curAngle + paddingAngle,
                                endAngle: curAngle + angleIp(t) + paddingAngle
                            });
                            stepData.push(latest);
                            curAngle = latest.endAngle;
                        } else {
                            var endAngle = entry.endAngle, startAngle = entry.startAngle;
                            var interpolatorAngle = (0, $938aefa455a73c9b$export$d871d53bd7eeb390)(0, endAngle - startAngle);
                            var deltaAngle = interpolatorAngle(t);
                            var _latest = $a9eb26465817775c$var$_objectSpread($a9eb26465817775c$var$_objectSpread({}, entry), {}, {
                                startAngle: curAngle + paddingAngle,
                                endAngle: curAngle + deltaAngle + paddingAngle
                            });
                            stepData.push(_latest);
                            curAngle = _latest.endAngle;
                        }
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), null, _this3.renderSectorsStatically(stepData));
                });
            }
        },
        {
            key: "attachKeyboardHandlers",
            value: function attachKeyboardHandlers(pieRef) {
                var _this4 = this;
                // eslint-disable-next-line no-param-reassign
                pieRef.onkeydown = function(e) {
                    if (!e.altKey) switch(e.key){
                        case 'ArrowLeft':
                            var next = ++_this4.state.sectorToFocus % _this4.sectorRefs.length;
                            _this4.sectorRefs[next].focus();
                            _this4.setState({
                                sectorToFocus: next
                            });
                            break;
                        case 'ArrowRight':
                            var _next = --_this4.state.sectorToFocus < 0 ? _this4.sectorRefs.length - 1 : _this4.state.sectorToFocus % _this4.sectorRefs.length;
                            _this4.sectorRefs[_next].focus();
                            _this4.setState({
                                sectorToFocus: _next
                            });
                            break;
                        case 'Escape':
                            _this4.sectorRefs[_this4.state.sectorToFocus].blur();
                            _this4.setState({
                                sectorToFocus: 0
                            });
                            break;
                        default:
                    }
                };
            }
        },
        {
            key: "renderSectors",
            value: function renderSectors() {
                var _this$props4 = this.props, sectors = _this$props4.sectors, isAnimationActive = _this$props4.isAnimationActive;
                var prevSectors = this.state.prevSectors;
                if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, (/*@__PURE__*/$parcel$interopDefault($f0e839acff22663e$exports)))(prevSectors, sectors))) return this.renderSectorsWithAnimation();
                return this.renderSectorsStatically(sectors);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.pieRef) this.attachKeyboardHandlers(this.pieRef);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                var _this$props5 = this.props, hide = _this$props5.hide, sectors = _this$props5.sectors, className = _this$props5.className, label = _this$props5.label, cx = _this$props5.cx, cy = _this$props5.cy, innerRadius = _this$props5.innerRadius, outerRadius = _this$props5.outerRadius, isAnimationActive = _this$props5.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (hide || !sectors || !sectors.length || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(cx) || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(cy) || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(innerRadius) || !(0, $938aefa455a73c9b$export$7e4aa119212bc614)(outerRadius)) return null;
                var layerClass = (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-pie', className);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
                    tabIndex: this.props.rootTabIndex,
                    className: layerClass,
                    ref: function ref(_ref3) {
                        _this5.pieRef = _ref3;
                    }
                }, this.renderSectors(), label && this.renderLabels(sectors), (0, $0e68a54aec8ebf8f$export$b04be29aa201d4f5).renderCallByParent(this.props, null, false), (!isAnimationActive || isAnimationFinished) && (0, $e706762aa5cf4680$export$835fcf23ab7bf88).renderCallByParent(this.props, sectors, false));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (prevState.prevIsAnimationActive !== nextProps.isAnimationActive) return {
                    prevIsAnimationActive: nextProps.isAnimationActive,
                    prevAnimationId: nextProps.animationId,
                    curSectors: nextProps.sectors,
                    prevSectors: [],
                    isAnimationFinished: true
                };
                if (nextProps.isAnimationActive && nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curSectors: nextProps.sectors,
                    prevSectors: prevState.curSectors,
                    isAnimationFinished: true
                };
                if (nextProps.sectors !== prevState.curSectors) return {
                    curSectors: nextProps.sectors,
                    isAnimationFinished: true
                };
                return null;
            }
        },
        {
            key: "getTextAnchor",
            value: function getTextAnchor(x, cx) {
                if (x > cx) return 'start';
                if (x < cx) return 'end';
                return 'middle';
            }
        },
        {
            key: "renderLabelLineItem",
            value: function renderLabelLineItem(option, props, key) {
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(option, props);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(option)) return option(props);
                var className = (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-pie-label-line', typeof option !== 'boolean' ? option.className : '');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $2df235e87c4a83c7$export$b0e83c3ef8d2db1), $a9eb26465817775c$var$_extends({}, props, {
                    key: key,
                    type: "linear",
                    className: className
                }));
            }
        },
        {
            key: "renderLabelItem",
            value: function renderLabelItem(option, props, value) {
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(option, props);
                var label = value;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(option)) {
                    label = option(props);
                    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(label)) return label;
                }
                var className = (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-pie-label-text', typeof option !== 'boolean' && !(0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(option) ? option.className : '');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $af1dbcbd2651f0c2$export$5f1af8db9871e1d6), $a9eb26465817775c$var$_extends({}, props, {
                    alignmentBaseline: "middle",
                    className: className
                }), label);
            }
        }
    ]);
}((0, $gIfym.PureComponent));
$a9eb26465817775c$var$_Pie = $a9eb26465817775c$export$2ae8800cf67c848c;
$a9eb26465817775c$var$_defineProperty($a9eb26465817775c$export$2ae8800cf67c848c, "displayName", 'Pie');
$a9eb26465817775c$var$_defineProperty($a9eb26465817775c$export$2ae8800cf67c848c, "defaultProps", {
    stroke: '#fff',
    fill: '#808080',
    legendType: 'rect',
    cx: '50%',
    cy: '50%',
    startAngle: 0,
    endAngle: 360,
    innerRadius: 0,
    outerRadius: '80%',
    paddingAngle: 0,
    labelLine: true,
    hide: false,
    minAngle: 0,
    isAnimationActive: !(0, $2a28151593e2b6a4$export$98f03c5d19621d70).isSsr,
    animationBegin: 400,
    animationDuration: 1500,
    animationEasing: 'ease',
    nameKey: 'name',
    blendStroke: false,
    rootTabIndex: 0
});
$a9eb26465817775c$var$_defineProperty($a9eb26465817775c$export$2ae8800cf67c848c, "parseDeltaAngle", function(startAngle, endAngle) {
    var sign = (0, $938aefa455a73c9b$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
});
$a9eb26465817775c$var$_defineProperty($a9eb26465817775c$export$2ae8800cf67c848c, "getRealPieData", function(itemProps) {
    var data = itemProps.data, children = itemProps.children;
    var presentationProps = (0, $49516a074167c4be$export$d697c39a2985a4c)(itemProps, false);
    var cells = (0, $49516a074167c4be$export$fdd5e64c0e8495bb)(children, (0, $b7ce6dc70cc786c8$export$f6f0c3fe4ec306ea));
    if (data && data.length) return data.map(function(entry, index) {
        return $a9eb26465817775c$var$_objectSpread($a9eb26465817775c$var$_objectSpread($a9eb26465817775c$var$_objectSpread({
            payload: entry
        }, presentationProps), entry), cells && cells[index] && cells[index].props);
    });
    if (cells && cells.length) return cells.map(function(cell) {
        return $a9eb26465817775c$var$_objectSpread($a9eb26465817775c$var$_objectSpread({}, presentationProps), cell.props);
    });
    return [];
});
$a9eb26465817775c$var$_defineProperty($a9eb26465817775c$export$2ae8800cf67c848c, "parseCoordinateOfPie", function(itemProps, offset) {
    var top = offset.top, left = offset.left, width = offset.width, height = offset.height;
    var maxPieRadius = (0, $b592c97d860421c4$export$ad5c48602371adfa)(width, height);
    var cx = left + (0, $938aefa455a73c9b$export$476354dbf49bdff6)(itemProps.cx, width, width / 2);
    var cy = top + (0, $938aefa455a73c9b$export$476354dbf49bdff6)(itemProps.cy, height, height / 2);
    var innerRadius = (0, $938aefa455a73c9b$export$476354dbf49bdff6)(itemProps.innerRadius, maxPieRadius, 0);
    var outerRadius = (0, $938aefa455a73c9b$export$476354dbf49bdff6)(itemProps.outerRadius, maxPieRadius, maxPieRadius * 0.8);
    var maxRadius = itemProps.maxRadius || Math.sqrt(width * width + height * height) / 2;
    return {
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        maxRadius: maxRadius
    };
});
$a9eb26465817775c$var$_defineProperty($a9eb26465817775c$export$2ae8800cf67c848c, "getComposedData", function(_ref4) {
    var item = _ref4.item, offset = _ref4.offset;
    var itemProps = item.type.defaultProps !== undefined ? $a9eb26465817775c$var$_objectSpread($a9eb26465817775c$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var pieData = $a9eb26465817775c$var$_Pie.getRealPieData(itemProps);
    if (!pieData || !pieData.length) return null;
    var cornerRadius = itemProps.cornerRadius, startAngle = itemProps.startAngle, endAngle = itemProps.endAngle, paddingAngle = itemProps.paddingAngle, dataKey = itemProps.dataKey, nameKey = itemProps.nameKey, valueKey = itemProps.valueKey, tooltipType = itemProps.tooltipType;
    var minAngle = Math.abs(itemProps.minAngle);
    var coordinate = $a9eb26465817775c$var$_Pie.parseCoordinateOfPie(itemProps, offset);
    var deltaAngle = $a9eb26465817775c$var$_Pie.parseDeltaAngle(startAngle, endAngle);
    var absDeltaAngle = Math.abs(deltaAngle);
    var realDataKey = dataKey;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(dataKey) && (0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(valueKey)) {
        (0, $0eb6b0656d09fb9a$export$c106dd0671a0fc2d)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
        realDataKey = 'value';
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($b10c0410b70013f3$exports)))(dataKey)) {
        (0, $0eb6b0656d09fb9a$export$c106dd0671a0fc2d)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
        realDataKey = valueKey;
    }
    var notZeroItemCount = pieData.filter(function(entry) {
        return (0, $2cf058a100d782d5$export$f97fc4a450f29a)(entry, realDataKey, 0) !== 0;
    }).length;
    var totalPadingAngle = (absDeltaAngle >= 360 ? notZeroItemCount : notZeroItemCount - 1) * paddingAngle;
    var realTotalAngle = absDeltaAngle - notZeroItemCount * minAngle - totalPadingAngle;
    var sum = pieData.reduce(function(result, entry) {
        var val = (0, $2cf058a100d782d5$export$f97fc4a450f29a)(entry, realDataKey, 0);
        return result + ((0, $938aefa455a73c9b$export$7e4aa119212bc614)(val) ? val : 0);
    }, 0);
    var sectors;
    if (sum > 0) {
        var prev;
        sectors = pieData.map(function(entry, i) {
            var val = (0, $2cf058a100d782d5$export$f97fc4a450f29a)(entry, realDataKey, 0);
            var name = (0, $2cf058a100d782d5$export$f97fc4a450f29a)(entry, nameKey, i);
            var percent = ((0, $938aefa455a73c9b$export$7e4aa119212bc614)(val) ? val : 0) / sum;
            var tempStartAngle;
            if (i) tempStartAngle = prev.endAngle + (0, $938aefa455a73c9b$export$9d334328eb75e624)(deltaAngle) * paddingAngle * (val !== 0 ? 1 : 0);
            else tempStartAngle = startAngle;
            var tempEndAngle = tempStartAngle + (0, $938aefa455a73c9b$export$9d334328eb75e624)(deltaAngle) * ((val !== 0 ? minAngle : 0) + percent * realTotalAngle);
            var midAngle = (tempStartAngle + tempEndAngle) / 2;
            var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
            var tooltipPayload = [
                {
                    name: name,
                    value: val,
                    payload: entry,
                    dataKey: realDataKey,
                    type: tooltipType
                }
            ];
            var tooltipPosition = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
            prev = $a9eb26465817775c$var$_objectSpread($a9eb26465817775c$var$_objectSpread($a9eb26465817775c$var$_objectSpread({
                percent: percent,
                cornerRadius: cornerRadius,
                name: name,
                tooltipPayload: tooltipPayload,
                midAngle: midAngle,
                middleRadius: middleRadius,
                tooltipPosition: tooltipPosition
            }, entry), coordinate), {}, {
                value: (0, $2cf058a100d782d5$export$f97fc4a450f29a)(entry, realDataKey),
                startAngle: tempStartAngle,
                endAngle: tempEndAngle,
                payload: entry,
                paddingAngle: (0, $938aefa455a73c9b$export$9d334328eb75e624)(deltaAngle) * paddingAngle
            });
            return prev;
        });
    }
    return $a9eb26465817775c$var$_objectSpread($a9eb26465817775c$var$_objectSpread({}, coordinate), {}, {
        sectors: sectors,
        data: pieData
    });
});

/**
 * @fileOverview Pie Chart
 */ 

var $gIfym = parcelRequire("gIfym");





var $gIfym = parcelRequire("gIfym");


var $cf039945a658027e$var$_excluded = [
    "points",
    "className",
    "baseLinePoints",
    "connectNulls"
];
function $cf039945a658027e$var$_extends() {
    $cf039945a658027e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cf039945a658027e$var$_extends.apply(this, arguments);
}
function $cf039945a658027e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cf039945a658027e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cf039945a658027e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $cf039945a658027e$var$_toConsumableArray(arr) {
    return $cf039945a658027e$var$_arrayWithoutHoles(arr) || $cf039945a658027e$var$_iterableToArray(arr) || $cf039945a658027e$var$_unsupportedIterableToArray(arr) || $cf039945a658027e$var$_nonIterableSpread();
}
function $cf039945a658027e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cf039945a658027e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cf039945a658027e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cf039945a658027e$var$_arrayLikeToArray(o, minLen);
}
function $cf039945a658027e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $cf039945a658027e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cf039945a658027e$var$_arrayLikeToArray(arr);
}
function $cf039945a658027e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $cf039945a658027e$var$isValidatePoint = function isValidatePoint(point) {
    return point && point.x === +point.x && point.y === +point.y;
};
var $cf039945a658027e$var$getParsedPoints = function getParsedPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var segmentPoints = [
        []
    ];
    points.forEach(function(entry) {
        if ($cf039945a658027e$var$isValidatePoint(entry)) segmentPoints[segmentPoints.length - 1].push(entry);
        else if (segmentPoints[segmentPoints.length - 1].length > 0) // add another path
        segmentPoints.push([]);
    });
    if ($cf039945a658027e$var$isValidatePoint(points[0])) segmentPoints[segmentPoints.length - 1].push(points[0]);
    if (segmentPoints[segmentPoints.length - 1].length <= 0) segmentPoints = segmentPoints.slice(0, -1);
    return segmentPoints;
};
var $cf039945a658027e$var$getSinglePolygonPath = function getSinglePolygonPath(points, connectNulls) {
    var segmentPoints = $cf039945a658027e$var$getParsedPoints(points);
    if (connectNulls) segmentPoints = [
        segmentPoints.reduce(function(res, segPoints) {
            return [].concat($cf039945a658027e$var$_toConsumableArray(res), $cf039945a658027e$var$_toConsumableArray(segPoints));
        }, [])
    ];
    var polygonPath = segmentPoints.map(function(segPoints) {
        return segPoints.reduce(function(path, point, index) {
            return "".concat(path).concat(index === 0 ? 'M' : 'L').concat(point.x, ",").concat(point.y);
        }, '');
    }).join('');
    return segmentPoints.length === 1 ? "".concat(polygonPath, "Z") : polygonPath;
};
var $cf039945a658027e$var$getRanglePath = function getRanglePath(points, baseLinePoints, connectNulls) {
    var outerPath = $cf039945a658027e$var$getSinglePolygonPath(points, connectNulls);
    return "".concat(outerPath.slice(-1) === 'Z' ? outerPath.slice(0, -1) : outerPath, "L").concat($cf039945a658027e$var$getSinglePolygonPath(baseLinePoints.reverse(), connectNulls).slice(1));
};
var $cf039945a658027e$export$7d31b617c820d435 = function Polygon(props) {
    var points = props.points, className = props.className, baseLinePoints = props.baseLinePoints, connectNulls = props.connectNulls, others = $cf039945a658027e$var$_objectWithoutProperties(props, $cf039945a658027e$var$_excluded);
    if (!points || !points.length) return null;
    var layerClass = (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-polygon', className);
    if (baseLinePoints && baseLinePoints.length) {
        var hasStroke = others.stroke && others.stroke !== 'none';
        var rangePath = $cf039945a658027e$var$getRanglePath(points, baseLinePoints, connectNulls);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("g", {
            className: layerClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", $cf039945a658027e$var$_extends({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(others, true), {
            fill: rangePath.slice(-1) === 'Z' ? others.fill : 'none',
            stroke: "none",
            d: rangePath
        })), hasStroke ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", $cf039945a658027e$var$_extends({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(others, true), {
            fill: "none",
            d: $cf039945a658027e$var$getSinglePolygonPath(points, connectNulls)
        })) : null, hasStroke ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", $cf039945a658027e$var$_extends({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(others, true), {
            fill: "none",
            d: $cf039945a658027e$var$getSinglePolygonPath(baseLinePoints, connectNulls)
        })) : null);
    }
    var singlePath = $cf039945a658027e$var$getSinglePolygonPath(points, connectNulls);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", $cf039945a658027e$var$_extends({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(others, true), {
        fill: singlePath.slice(-1) === 'Z' ? others.fill : 'none',
        className: layerClass,
        d: singlePath
    }));
};






function $f384443f29c20230$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f384443f29c20230$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f384443f29c20230$var$_typeof(o);
}
function $f384443f29c20230$var$_extends() {
    $f384443f29c20230$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f384443f29c20230$var$_extends.apply(this, arguments);
}
function $f384443f29c20230$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f384443f29c20230$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f384443f29c20230$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f384443f29c20230$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f384443f29c20230$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f384443f29c20230$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f384443f29c20230$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f384443f29c20230$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f384443f29c20230$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f384443f29c20230$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f384443f29c20230$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f384443f29c20230$var$_callSuper(t, o, e) {
    return o = $f384443f29c20230$var$_getPrototypeOf(o), $f384443f29c20230$var$_possibleConstructorReturn(t, $f384443f29c20230$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $f384443f29c20230$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $f384443f29c20230$var$_possibleConstructorReturn(self, call) {
    if (call && ($f384443f29c20230$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f384443f29c20230$var$_assertThisInitialized(self);
}
function $f384443f29c20230$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f384443f29c20230$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f384443f29c20230$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f384443f29c20230$var$_getPrototypeOf(o) {
    $f384443f29c20230$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f384443f29c20230$var$_getPrototypeOf(o);
}
function $f384443f29c20230$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f384443f29c20230$var$_setPrototypeOf(subClass, superClass);
}
function $f384443f29c20230$var$_setPrototypeOf(o, p) {
    $f384443f29c20230$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f384443f29c20230$var$_setPrototypeOf(o, p);
}
function $f384443f29c20230$var$_defineProperty(obj, key, value) {
    key = $f384443f29c20230$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f384443f29c20230$var$_toPropertyKey(t) {
    var i = $f384443f29c20230$var$_toPrimitive(t, "string");
    return "symbol" == $f384443f29c20230$var$_typeof(i) ? i : i + "";
}
function $f384443f29c20230$var$_toPrimitive(t, r) {
    if ("object" != $f384443f29c20230$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f384443f29c20230$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f384443f29c20230$var$RADIAN = Math.PI / 180;
var $f384443f29c20230$var$eps = 1e-5;
var $f384443f29c20230$export$67d930e793705898 = /*#__PURE__*/ function(_PureComponent) {
    function PolarAngleAxis() {
        $f384443f29c20230$var$_classCallCheck(this, PolarAngleAxis);
        return $f384443f29c20230$var$_callSuper(this, PolarAngleAxis, arguments);
    }
    $f384443f29c20230$var$_inherits(PolarAngleAxis, _PureComponent);
    return $f384443f29c20230$var$_createClass(PolarAngleAxis, [
        {
            key: "getTickLineCoord",
            value: /**
     * Calculate the coordinate of line endpoint
     * @param  {Object} data The Data if ticks
     * @return {Object} (x0, y0): The start point of text,
     *                  (x1, y1): The end point close to text,
     *                  (x2, y2): The end point close to axis
     */ function getTickLineCoord(data) {
                var _this$props = this.props, cx = _this$props.cx, cy = _this$props.cy, radius = _this$props.radius, orientation = _this$props.orientation, tickSize = _this$props.tickSize;
                var tickLineSize = tickSize || 8;
                var p1 = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, radius, data.coordinate);
                var p2 = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
                return {
                    x1: p1.x,
                    y1: p1.y,
                    x2: p2.x,
                    y2: p2.y
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor(data) {
                var orientation = this.props.orientation;
                var cos = Math.cos(-data.coordinate * $f384443f29c20230$var$RADIAN);
                var textAnchor;
                if (cos > $f384443f29c20230$var$eps) textAnchor = orientation === 'outer' ? 'start' : 'end';
                else if (cos < -$f384443f29c20230$var$eps) textAnchor = orientation === 'outer' ? 'end' : 'start';
                else textAnchor = 'middle';
                return textAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, radius = _this$props2.radius, axisLine = _this$props2.axisLine, axisLineType = _this$props2.axisLineType;
                var props = $f384443f29c20230$var$_objectSpread($f384443f29c20230$var$_objectSpread({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(this.props, false)), {}, {
                    fill: 'none'
                }, (0, $49516a074167c4be$export$d697c39a2985a4c)(axisLine, false));
                if (axisLineType === 'circle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f9dff8c513e6748d$export$d046b3c4a416f60d), $f384443f29c20230$var$_extends({
                    className: "recharts-polar-angle-axis-line"
                }, props, {
                    cx: cx,
                    cy: cy,
                    r: radius
                }));
                var ticks = this.props.ticks;
                var points = ticks.map(function(entry) {
                    return (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, radius, entry.coordinate);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $cf039945a658027e$export$7d31b617c820d435), $f384443f29c20230$var$_extends({
                    className: "recharts-polar-angle-axis-line"
                }, props, {
                    points: points
                }));
            }
        },
        {
            key: "renderTicks",
            value: function renderTicks() {
                var _this = this;
                var _this$props3 = this.props, ticks = _this$props3.ticks, tick = _this$props3.tick, tickLine = _this$props3.tickLine, tickFormatter = _this$props3.tickFormatter, stroke = _this$props3.stroke;
                var axisProps = (0, $49516a074167c4be$export$d697c39a2985a4c)(this.props, false);
                var customTickProps = (0, $49516a074167c4be$export$d697c39a2985a4c)(tick, false);
                var tickLineProps = $f384443f29c20230$var$_objectSpread($f384443f29c20230$var$_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, $49516a074167c4be$export$d697c39a2985a4c)(tickLine, false));
                var items = ticks.map(function(entry, i) {
                    var lineCoord = _this.getTickLineCoord(entry);
                    var textAnchor = _this.getTickTextAnchor(entry);
                    var tickProps = $f384443f29c20230$var$_objectSpread($f384443f29c20230$var$_objectSpread($f384443f29c20230$var$_objectSpread({
                        textAnchor: textAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), {}, {
                        index: i,
                        payload: entry,
                        x: lineCoord.x2,
                        y: lineCoord.y2
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), $f384443f29c20230$var$_extends({
                        className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-polar-angle-axis-tick', (0, $b592c97d860421c4$export$88d525dabc04abcd)(tick)),
                        key: "tick-".concat(entry.coordinate)
                    }, (0, $e49003a65b792e53$export$ca62be0d67a3158c)(_this.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("line", $f384443f29c20230$var$_extends({
                        className: "recharts-polar-angle-axis-tick-line"
                    }, tickLineProps, lineCoord)), tick && PolarAngleAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
                    className: "recharts-polar-angle-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, ticks = _this$props4.ticks, radius = _this$props4.radius, axisLine = _this$props4.axisLine;
                if (radius <= 0 || !ticks || !ticks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
                    className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-polar-angle-axis', this.props.className)
                }, axisLine && this.renderAxisLine(), this.renderTicks());
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $af1dbcbd2651f0c2$export$5f1af8db9871e1d6), $f384443f29c20230$var$_extends({}, props, {
                    className: "recharts-polar-angle-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, $gIfym.PureComponent));
$f384443f29c20230$var$_defineProperty($f384443f29c20230$export$67d930e793705898, "displayName", 'PolarAngleAxis');
$f384443f29c20230$var$_defineProperty($f384443f29c20230$export$67d930e793705898, "axisType", 'angleAxis');
$f384443f29c20230$var$_defineProperty($f384443f29c20230$export$67d930e793705898, "defaultProps", {
    type: 'category',
    angleAxisId: 0,
    scale: 'auto',
    cx: 0,
    cy: 0,
    orientation: 'outer',
    axisLine: true,
    tickLine: true,
    tickSize: 8,
    tick: true,
    hide: false,
    allowDuplicatedCategory: true
});



var $gIfym = parcelRequire("gIfym");
var $ef1e1f2896a32786$exports = {};



/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */ function $ef1e1f2896a32786$var$maxBy(array, iteratee) {
    return array && array.length ? $c97827481385ceaf$exports(array, $72536eccaddefa03$exports(iteratee, 2), $a6ec50d52b2bc7e1$exports) : undefined;
}
$ef1e1f2896a32786$exports = $ef1e1f2896a32786$var$maxBy;


var $a8af0bc1834d8c6f$exports = {};



/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */ function $a8af0bc1834d8c6f$var$minBy(array, iteratee) {
    return array && array.length ? $c97827481385ceaf$exports(array, $72536eccaddefa03$exports(iteratee, 2), $27e415dfdace9d87$exports) : undefined;
}
$a8af0bc1834d8c6f$exports = $a8af0bc1834d8c6f$var$minBy;










var $bbb5f22718654af7$var$_excluded = [
    "cx",
    "cy",
    "angle",
    "ticks",
    "axisLine"
], $bbb5f22718654af7$var$_excluded2 = [
    "ticks",
    "tick",
    "angle",
    "tickFormatter",
    "stroke"
];
function $bbb5f22718654af7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bbb5f22718654af7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bbb5f22718654af7$var$_typeof(o);
}
function $bbb5f22718654af7$var$_extends() {
    $bbb5f22718654af7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bbb5f22718654af7$var$_extends.apply(this, arguments);
}
function $bbb5f22718654af7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bbb5f22718654af7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bbb5f22718654af7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bbb5f22718654af7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bbb5f22718654af7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bbb5f22718654af7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bbb5f22718654af7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bbb5f22718654af7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bbb5f22718654af7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bbb5f22718654af7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $bbb5f22718654af7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $bbb5f22718654af7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bbb5f22718654af7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bbb5f22718654af7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $bbb5f22718654af7$var$_callSuper(t, o, e) {
    return o = $bbb5f22718654af7$var$_getPrototypeOf(o), $bbb5f22718654af7$var$_possibleConstructorReturn(t, $bbb5f22718654af7$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $bbb5f22718654af7$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $bbb5f22718654af7$var$_possibleConstructorReturn(self, call) {
    if (call && ($bbb5f22718654af7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $bbb5f22718654af7$var$_assertThisInitialized(self);
}
function $bbb5f22718654af7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bbb5f22718654af7$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($bbb5f22718654af7$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $bbb5f22718654af7$var$_getPrototypeOf(o) {
    $bbb5f22718654af7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bbb5f22718654af7$var$_getPrototypeOf(o);
}
function $bbb5f22718654af7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $bbb5f22718654af7$var$_setPrototypeOf(subClass, superClass);
}
function $bbb5f22718654af7$var$_setPrototypeOf(o, p) {
    $bbb5f22718654af7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bbb5f22718654af7$var$_setPrototypeOf(o, p);
}
function $bbb5f22718654af7$var$_defineProperty(obj, key, value) {
    key = $bbb5f22718654af7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bbb5f22718654af7$var$_toPropertyKey(t) {
    var i = $bbb5f22718654af7$var$_toPrimitive(t, "string");
    return "symbol" == $bbb5f22718654af7$var$_typeof(i) ? i : i + "";
}
function $bbb5f22718654af7$var$_toPrimitive(t, r) {
    if ("object" != $bbb5f22718654af7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $bbb5f22718654af7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $bbb5f22718654af7$export$d2607afddf4df58d = /*#__PURE__*/ function(_PureComponent) {
    function PolarRadiusAxis() {
        $bbb5f22718654af7$var$_classCallCheck(this, PolarRadiusAxis);
        return $bbb5f22718654af7$var$_callSuper(this, PolarRadiusAxis, arguments);
    }
    $bbb5f22718654af7$var$_inherits(PolarRadiusAxis, _PureComponent);
    return $bbb5f22718654af7$var$_createClass(PolarRadiusAxis, [
        {
            key: "getTickValueCoord",
            value: /**
     * Calculate the coordinate of tick
     * @param  {Number} coordinate The radius of tick
     * @return {Object} (x, y)
     */ function getTickValueCoord(_ref) {
                var coordinate = _ref.coordinate;
                var _this$props = this.props, angle = _this$props.angle, cx = _this$props.cx, cy = _this$props.cy;
                return (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, coordinate, angle);
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var orientation = this.props.orientation;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = 'end';
                        break;
                    case 'right':
                        textAnchor = 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getViewBox",
            value: function getViewBox() {
                var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, angle = _this$props2.angle, ticks = _this$props2.ticks;
                var maxRadiusTick = (0, (/*@__PURE__*/$parcel$interopDefault($ef1e1f2896a32786$exports)))(ticks, function(entry) {
                    return entry.coordinate || 0;
                });
                var minRadiusTick = (0, (/*@__PURE__*/$parcel$interopDefault($a8af0bc1834d8c6f$exports)))(ticks, function(entry) {
                    return entry.coordinate || 0;
                });
                return {
                    cx: cx,
                    cy: cy,
                    startAngle: angle,
                    endAngle: angle,
                    innerRadius: minRadiusTick.coordinate || 0,
                    outerRadius: maxRadiusTick.coordinate || 0
                };
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props3 = this.props, cx = _this$props3.cx, cy = _this$props3.cy, angle = _this$props3.angle, ticks = _this$props3.ticks, axisLine = _this$props3.axisLine, others = $bbb5f22718654af7$var$_objectWithoutProperties(_this$props3, $bbb5f22718654af7$var$_excluded);
                var extent = ticks.reduce(function(result, entry) {
                    return [
                        Math.min(result[0], entry.coordinate),
                        Math.max(result[1], entry.coordinate)
                    ];
                }, [
                    Infinity,
                    -Infinity
                ]);
                var point0 = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, extent[0], angle);
                var point1 = (0, $b592c97d860421c4$export$5c9a959bb3fc7749)(cx, cy, extent[1], angle);
                var props = $bbb5f22718654af7$var$_objectSpread($bbb5f22718654af7$var$_objectSpread($bbb5f22718654af7$var$_objectSpread({}, (0, $49516a074167c4be$export$d697c39a2985a4c)(others, false)), {}, {
                    fill: 'none'
                }, (0, $49516a074167c4be$export$d697c39a2985a4c)(axisLine, false)), {}, {
                    x1: point0.x,
                    y1: point0.y,
                    x2: point1.x,
                    y2: point1.y
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("line", $bbb5f22718654af7$var$_extends({
                    className: "recharts-polar-radius-axis-line"
                }, props));
            }
        },
        {
            key: "renderTicks",
            value: function renderTicks() {
                var _this = this;
                var _this$props4 = this.props, ticks = _this$props4.ticks, tick = _this$props4.tick, angle = _this$props4.angle, tickFormatter = _this$props4.tickFormatter, stroke = _this$props4.stroke, others = $bbb5f22718654af7$var$_objectWithoutProperties(_this$props4, $bbb5f22718654af7$var$_excluded2);
                var textAnchor = this.getTickTextAnchor();
                var axisProps = (0, $49516a074167c4be$export$d697c39a2985a4c)(others, false);
                var customTickProps = (0, $49516a074167c4be$export$d697c39a2985a4c)(tick, false);
                var items = ticks.map(function(entry, i) {
                    var coord = _this.getTickValueCoord(entry);
                    var tickProps = $bbb5f22718654af7$var$_objectSpread($bbb5f22718654af7$var$_objectSpread($bbb5f22718654af7$var$_objectSpread($bbb5f22718654af7$var$_objectSpread({
                        textAnchor: textAnchor,
                        transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), {}, {
                        index: i
                    }, coord), {}, {
                        payload: entry
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), $bbb5f22718654af7$var$_extends({
                        className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-polar-radius-axis-tick', (0, $b592c97d860421c4$export$88d525dabc04abcd)(tick)),
                        key: "tick-".concat(entry.coordinate)
                    }, (0, $e49003a65b792e53$export$ca62be0d67a3158c)(_this.props, entry, i)), PolarRadiusAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
                    className: "recharts-polar-radius-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, ticks = _this$props5.ticks, axisLine = _this$props5.axisLine, tick = _this$props5.tick;
                if (!ticks || !ticks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $f4b5c79812b944a1$export$936d0764594b6eb3), {
                    className: (0, $e97bcb9bbe88738a$export$2e2bcd8739ae039)('recharts-polar-radius-axis', this.props.className)
                }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), (0, $0e68a54aec8ebf8f$export$b04be29aa201d4f5).renderCallByParent(this.props, this.getViewBox()));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($521335ecaded1962$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $af1dbcbd2651f0c2$export$5f1af8db9871e1d6), $bbb5f22718654af7$var$_extends({}, props, {
                    className: "recharts-polar-radius-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, $gIfym.PureComponent));
$bbb5f22718654af7$var$_defineProperty($bbb5f22718654af7$export$d2607afddf4df58d, "displayName", 'PolarRadiusAxis');
$bbb5f22718654af7$var$_defineProperty($bbb5f22718654af7$export$d2607afddf4df58d, "axisType", 'radiusAxis');
$bbb5f22718654af7$var$_defineProperty($bbb5f22718654af7$export$d2607afddf4df58d, "defaultProps", {
    type: 'number',
    radiusAxisId: 0,
    cx: 0,
    cy: 0,
    angle: 0,
    orientation: 'right',
    stroke: '#ccc',
    axisLine: true,
    tick: true,
    tickCount: 5,
    allowDataOverflow: false,
    scale: 'auto',
    allowDuplicatedCategory: true
});




var $fbbac04d365e8488$export$b99d3348f709c998 = (0, $bbcd5dcaccb206b2$export$77871aede60e6838)({
    chartName: 'PieChart',
    GraphicalChild: (0, $a9eb26465817775c$export$2ae8800cf67c848c),
    validateTooltipEventTypes: [
        'item'
    ],
    defaultTooltipEventType: 'item',
    legendContent: 'children',
    axisComponents: [
        {
            axisType: 'angleAxis',
            AxisComp: (0, $f384443f29c20230$export$67d930e793705898)
        },
        {
            axisType: 'radiusAxis',
            AxisComp: (0, $bbb5f22718654af7$export$d2607afddf4df58d)
        }
    ],
    formatAxisMap: (0, $b592c97d860421c4$export$ece7de1383db5ac),
    defaultProps: {
        layout: 'centric',
        startAngle: 0,
        endAngle: 360,
        cx: '50%',
        cy: '50%',
        innerRadius: 0,
        outerRadius: '80%'
    }
});




function $d8c7e492480fe29d$var$toPieData(top, other, idle) {
    let slices = [];
    for(const i in top){
        const allocation = top[i];
        const fill = allocation.name === "__unallocated__" ? "#212121" : (0, $e95a10c0d7b6a200$export$9ad721cf3b3debe0)[i % (0, $e95a10c0d7b6a200$export$9ad721cf3b3debe0).length];
        slices.push({
            name: allocation.name,
            value: allocation.totalCost,
            fill: fill
        });
    }
    for(const i in other){
        const allocation = other[i];
        const fill = (0, $e95a10c0d7b6a200$export$bcdff0aad5ea3623)[i % (0, $e95a10c0d7b6a200$export$bcdff0aad5ea3623).length];
        slices.push({
            name: allocation.name,
            value: allocation.totalCost,
            fill: fill
        });
    }
    for(const i in idle){
        const allocation = idle[i];
        const fill = (0, $e95a10c0d7b6a200$export$88f5aeecbc5784c1)[i % (0, $e95a10c0d7b6a200$export$88f5aeecbc5784c1).length];
        slices.push({
            name: allocation.name,
            value: allocation.totalCost,
            fill: fill
        });
    }
    return slices;
}
const $d8c7e492480fe29d$var$SummaryChart = ({ top: top, other: other, idle: idle, currency: currency, height: height })=>{
    const pieData = $d8c7e492480fe29d$var$toPieData(top, other, idle);
    const renderLabel = (params)=>{
        const { cx: cx, cy: cy, midAngle: midAngle, outerRadius: outerRadius, percent: percent, name: name, fill: fill, value: value } = params;
        const RADIAN = Math.PI / 180;
        const radius = outerRadius * 1.1;
        let x = cx + radius * Math.cos(-midAngle * RADIAN);
        x += x > cx ? 2 : -2;
        let y = cy + radius * Math.sin(-midAngle * RADIAN);
        // y -= Math.min(Math.abs(2 / Math.cos(-midAngle * RADIAN)), 8)
        if (percent < 0.02) return;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("text", {
            x: x,
            y: y,
            fill: fill,
            textAnchor: x > cx ? 'start' : 'end',
            dominantBaseline: "central",
            children: `${name}: ${(0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(value, currency)} (${(percent * 100).toFixed(1)}%)`
        });
    };
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d7b42fa8a2c2a4be$export$e60a4704009a0009), {
        width: "100%",
        height: height,
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $fbbac04d365e8488$export$b99d3348f709c998), {
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $a9eb26465817775c$export$2ae8800cf67c848c), {
                data: pieData,
                dataKey: "value",
                nameKey: "name",
                label: renderLabel,
                labelLine: true,
                // niko: if tooltips error, try disabling animation
                // isAnimationActive={false}
                animationDuration: 400,
                cy: "90%",
                outerRadius: "140%",
                innerRadius: "60%",
                startAngle: 180,
                endAngle: 0,
                children: pieData.map((datum, i)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b7ce6dc70cc786c8$export$f6f0c3fe4ec306ea), {
                        fill: datum.fill
                    }, i))
            })
        })
    });
};
var $d8c7e492480fe29d$export$2e2bcd8739ae039 = $d8c7e492480fe29d$var$SummaryChart;


// TODO niko/etl
// sum allocationSet to single allocation
function $dcd5b05c68247e71$var$agg(allocationSet, name) {
    if (allocationSet.length === 0) return null;
    return (0, $6IRuR.reduce)(allocationSet, (agg, cur)=>({
            name: agg.name,
            aggregatedBy: cur.aggregatedBy,
            properties: agg.properties,
            start: cur.start,
            end: cur.end,
            cpuCost: agg.cpuCost + cur.cpuCost,
            gpuCost: agg.gpuCost + cur.gpuCost,
            ramCost: agg.ramCost + cur.ramCost,
            pvCost: agg.pvCost + cur.pvCost,
            totalCost: agg.totalCost + cur.totalCost,
            count: agg.count + 1
        }), {
        name: name,
        properties: null,
        cpuCost: 0.0,
        gpuCost: 0.0,
        ramCost: 0.0,
        pvCost: 0.0,
        totalCost: 0.0,
        count: 0
    });
}
function $dcd5b05c68247e71$var$isIdle(allocation) {
    return allocation.name.indexOf('__idle__') >= 0;
}
function $dcd5b05c68247e71$var$top(n, by) {
    return (allocations)=>{
        if ((0, $6IRuR.isArray)(allocations[0])) return (0, $6IRuR.map)(allocations, $dcd5b05c68247e71$var$top(n, by));
        const sorted = (0, $6IRuR.reverse)((0, $6IRuR.sortBy)(allocations, by));
        const active = (0, $6IRuR.filter)(sorted, (a)=>!$dcd5b05c68247e71$var$isIdle(a));
        const idle = (0, $6IRuR.filter)(sorted, (a)=>$dcd5b05c68247e71$var$isIdle(a));
        const topn = active.slice(0, n);
        const other = [];
        if (active.length > n) other.push($dcd5b05c68247e71$var$agg(active.slice(n), 'other'));
        return {
            top: topn,
            other: other,
            idle: idle
        };
    };
}
const $dcd5b05c68247e71$var$AllocationChart = ({ allocationRange: allocationRange, currency: currency, n: n, height: height })=>{
    if (allocationRange.length === 0) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
        variant: "body2",
        children: "No data"
    });
    if (allocationRange.length === 1) {
        const datum = $dcd5b05c68247e71$var$top(n, (alloc)=>alloc.totalCost)(allocationRange[0]);
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d8c7e492480fe29d$export$2e2bcd8739ae039), {
            top: datum.top,
            other: datum.other,
            idle: datum.idle,
            currency: currency,
            height: height
        });
    }
    const data = $dcd5b05c68247e71$var$top(n, (alloc)=>alloc.totalCost)(allocationRange);
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $7bdc138bb0995da0$export$2e2bcd8739ae039), {
        data: data,
        currency: currency,
        height: height
    });
};
var $dcd5b05c68247e71$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).memo($dcd5b05c68247e71$var$AllocationChart);



const $c2f4f7c799313e3f$var$useStyles = (0, $hQJVM.default)({
    noResults: {
        padding: 24
    }
});
function $c2f4f7c799313e3f$var$descendingComparator(a, b, orderBy) {
    if ((0, $6IRuR.get)(b, orderBy) < (0, $6IRuR.get)(a, orderBy)) return -1;
    if ((0, $6IRuR.get)(b, orderBy) > (0, $6IRuR.get)(a, orderBy)) return 1;
    return 0;
}
function $c2f4f7c799313e3f$var$getComparator(order, orderBy) {
    return order === "desc" ? (a, b)=>$c2f4f7c799313e3f$var$descendingComparator(a, b, orderBy) : (a, b)=>-$c2f4f7c799313e3f$var$descendingComparator(a, b, orderBy);
}
function $c2f4f7c799313e3f$var$stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index)=>[
            el,
            index
        ]);
    stabilizedThis.sort((a, b)=>{
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el)=>el[0]);
}
const $c2f4f7c799313e3f$var$headCells = [
    {
        id: "name",
        numeric: false,
        label: "Name",
        width: "auto"
    },
    {
        id: "cpuCost",
        numeric: true,
        label: "CPU",
        width: 90
    },
    {
        id: "gpuCost",
        numeric: true,
        label: "GPU",
        width: 90
    },
    {
        id: "ramCost",
        numeric: true,
        label: "RAM",
        width: 90
    },
    {
        id: "pvCost",
        numeric: true,
        label: "PV",
        width: 90
    },
    {
        id: "totalEfficiency",
        numeric: true,
        label: "Efficiency",
        width: 90
    },
    {
        id: "totalCost",
        numeric: true,
        label: "Total cost",
        width: 90
    }
];
const $c2f4f7c799313e3f$var$AllocationReport = ({ allocationData: allocationData, cumulativeData: cumulativeData, totalData: totalData, currency: currency })=>{
    const classes = $c2f4f7c799313e3f$var$useStyles();
    if (allocationData.length === 0) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
        variant: "body2",
        className: classes.noResults,
        children: "No results"
    });
    const [order, setOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useState("desc");
    const [orderBy, setOrderBy] = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useState("totalCost");
    const [page, setPage] = (0, $gIfym.useState)(0);
    const [rowsPerPage, setRowsPerPage] = (0, $gIfym.useState)(25);
    const numData = cumulativeData.length;
    (0, $gIfym.useEffect)(()=>{
        setPage(0);
    }, [
        numData
    ]);
    const lastPage = Math.floor(numData / rowsPerPage);
    const handleChangePage = (event, newPage)=>setPage(newPage);
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const createSortHandler = (property)=>(event)=>handleRequestSort(event, property);
    const handleRequestSort = (event, property)=>{
        const isDesc = orderBy === property && order === "desc";
        setOrder(isDesc ? "asc" : "desc");
        setOrderBy(property);
    };
    const orderedRows = $c2f4f7c799313e3f$var$stableSort(cumulativeData, $c2f4f7c799313e3f$var$getComparator(order, orderBy));
    const pageRows = orderedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        id: "report",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $dcd5b05c68247e71$export$2e2bcd8739ae039), {
                allocationRange: allocationData,
                currency: currency,
                n: 10,
                height: 300
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $6d7bd70307fdcf46$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $9baaa18523ae0079$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8877b048d1d8501c$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                children: $c2f4f7c799313e3f$var$headCells.map((cell)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                        colSpan: cell.colspan,
                                        align: cell.numeric ? "right" : "left",
                                        sortDirection: orderBy === cell.id ? order : false,
                                        style: {
                                            width: cell.width
                                        },
                                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $99436b9fec0b22ea$export$2e2bcd8739ae039), {
                                            active: orderBy === cell.id,
                                            direction: orderBy === cell.id ? order : "asc",
                                            onClick: createSortHandler(cell.id),
                                            children: cell.label
                                        })
                                    }, cell.id))
                            })
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $b26ae0b21e46ca86$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: $c2f4f7c799313e3f$var$headCells.map((cell)=>{
                                        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            colSpan: cell.colspan,
                                            align: cell.numeric ? "right" : "left",
                                            style: {
                                                fontWeight: 500
                                            },
                                            children: cell.numeric ? cell.label === "Efficiency" ? totalData.totalEfficiency == 1.0 && totalData.cpuReqCoreHrs == 0 && totalData.ramReqByteHrs == 0 ? "Inf%" : `${(0, $6IRuR.round)(totalData.totalEfficiency * 100, 1)}%` : (0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(totalData[cell.id], currency) : totalData[cell.id]
                                        }, cell.id);
                                    })
                                }),
                                pageRows.map((row, key)=>{
                                    if (row.name === "__unmounted__") row.name = "Unmounted PVs";
                                    let isIdle = row.name.indexOf("__idle__") >= 0;
                                    let isUnallocated = row.name.indexOf("__unallocated__") >= 0;
                                    let isUnmounted = row.name.indexOf("Unmounted PVs") >= 0;
                                    // Replace "efficiency" with Inf if there is usage w/o request
                                    let efficiency = (0, $6IRuR.round)(row.totalEfficiency * 100, 1);
                                    if (row.totalEfficiency == 1.0 && row.cpuReqCoreHrs == 0 && row.ramReqByteHrs == 0) efficiency = "Inf";
                                    // Do not allow drill-down for idle and unallocated rows
                                    if (isIdle || isUnallocated || isUnmounted) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                align: "left",
                                                children: row.name
                                            }),
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                align: "right",
                                                children: (0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(row.cpuCost, currency)
                                            }),
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                align: "right",
                                                children: (0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(row.gpuCost, currency)
                                            }),
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                align: "right",
                                                children: (0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(row.ramCost, currency)
                                            }),
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                align: "right",
                                                children: (0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(row.pvCost, currency)
                                            }),
                                            isIdle ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                align: "right",
                                                children: "\u2014"
                                            }) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                align: "right",
                                                children: [
                                                    efficiency,
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                align: "right",
                                                children: (0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(row.totalCost, currency)
                                            })
                                        ]
                                    }, key);
                                    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                align: "left",
                                                children: row.name
                                            }),
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                align: "right",
                                                children: (0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(row.cpuCost, currency)
                                            }),
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                align: "right",
                                                children: (0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(row.gpuCost, currency)
                                            }),
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                align: "right",
                                                children: (0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(row.ramCost, currency)
                                            }),
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                align: "right",
                                                children: (0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(row.pvCost, currency)
                                            }),
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                align: "right",
                                                children: [
                                                    efficiency,
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                align: "right",
                                                children: (0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(row.totalCost, currency)
                                            })
                                        ]
                                    }, key);
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $3cba5a2b6a62bd7c$export$2e2bcd8739ae039), {
                component: "div",
                count: numData,
                rowsPerPage: rowsPerPage,
                rowsPerPageOptions: [
                    10,
                    25,
                    50
                ],
                page: Math.min(page, lastPage),
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage
            })
        ]
    });
};
var $c2f4f7c799313e3f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).memo($c2f4f7c799313e3f$var$AllocationReport);




var $gIfym = parcelRequire("gIfym");



var $hQJVM = parcelRequire("hQJVM");

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");


var $82OGZ = parcelRequire("82OGZ");

var $kfLRg = parcelRequire("kfLRg");


var $1f3c3d6fcb879aaf$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top' // Fix alignment issue on Safari.
    },
    /* Styles applied to the root element if `margin="normal"`. */ marginNormal: {
        marginTop: 16,
        marginBottom: 8
    },
    /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
        marginTop: 8,
        marginBottom: 4
    },
    /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
        width: '100%'
    }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */ var $1f3c3d6fcb879aaf$var$FormControl = /*#__PURE__*/ $gIfym.forwardRef(function FormControl(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, visuallyFocused = props.focused, _props$hiddenLabel = props.hiddenLabel, hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel, _props$margin = props.margin, margin = _props$margin === void 0 ? 'none' : _props$margin, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, size = props.size, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $f6Qba.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "fullWidth",
        "focused",
        "hiddenLabel",
        "margin",
        "required",
        "size",
        "variant"
    ]);
    var _React$useState = $gIfym.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialAdornedStart = false;
        if (children) $gIfym.Children.forEach(children, function(child) {
            if (!(0, $2d1ff91adb46a3b2$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            var input = (0, $2d1ff91adb46a3b2$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $8dfa0da0cd720873$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    }), adornedStart = _React$useState[0], setAdornedStart = _React$useState[1];
    var _React$useState2 = $gIfym.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialFilled = false;
        if (children) $gIfym.Children.forEach(children, function(child) {
            if (!(0, $2d1ff91adb46a3b2$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $8dfa0da0cd720873$export$d652b828d7fdeff8)(child.props, true)) initialFilled = true;
        });
        return initialFilled;
    }), filled = _React$useState2[0], setFilled = _React$useState2[1];
    var _React$useState3 = $gIfym.useState(false), _focused = _React$useState3[0], setFocused = _React$useState3[1];
    var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;
    if (disabled && focused) setFocused(false);
    var registerEffect;
    var registeredInput;
    var onFilled = $gIfym.useCallback(function() {
        setFilled(true);
    }, []);
    var onEmpty = $gIfym.useCallback(function() {
        setFilled(false);
    }, []);
    var childContext = {
        adornedStart: adornedStart,
        setAdornedStart: setAdornedStart,
        color: color,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: (size === 'small' ? 'dense' : undefined) || margin,
        onBlur: function onBlur() {
            setFocused(false);
        },
        onEmpty: onEmpty,
        onFilled: onFilled,
        onFocus: function onFocus() {
            setFocused(true);
        },
        registerEffect: registerEffect,
        required: required,
        variant: variant
    };
    return /*#__PURE__*/ $gIfym.createElement((0, $df967b5ae1e94986$export$2e2bcd8739ae039).Provider, {
        value: childContext
    }, /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className, margin !== 'none' && classes["margin".concat((0, $kfLRg.default)(margin))], fullWidth && classes.fullWidth),
        ref: ref
    }, other), children));
});
var $1f3c3d6fcb879aaf$export$2e2bcd8739ae039 = (0, $82OGZ.default)($1f3c3d6fcb879aaf$export$9dd6ff9ea0189349, {
    name: 'MuiFormControl'
})($1f3c3d6fcb879aaf$var$FormControl);



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");



var $82OGZ = parcelRequire("82OGZ");

var $f6Qba = parcelRequire("f6Qba");

var $k2R8s = parcelRequire("k2R8s");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");



var $kfLRg = parcelRequire("kfLRg");

var $82OGZ = parcelRequire("82OGZ");
var $ceb5fb181cba72e5$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $k2R8s.default)({
            color: theme.palette.text.secondary
        }, theme.typography.body1, {
            lineHeight: 1,
            padding: 0,
            '&$focused': {
                color: theme.palette.primary.main
            },
            '&$disabled': {
                color: theme.palette.text.disabled
            },
            '&$error': {
                color: theme.palette.error.main
            }
        }),
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            '&$focused': {
                color: theme.palette.secondary.main
            }
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Styles applied to the asterisk element. */ asterisk: {
            '&$error': {
                color: theme.palette.error.main
            }
        }
    };
};
var $ceb5fb181cba72e5$var$FormLabel = /*#__PURE__*/ $gIfym.forwardRef(function FormLabel(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, color = props.color, _props$component = props.component, Component = _props$component === void 0 ? 'label' : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, required = props.required, other = (0, $f6Qba.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "required"
    ]);
    var muiFormControl = (0, $fb91f9a015629c85$export$2e2bcd8739ae039)();
    var fcs = (0, $a62fb4227558e134$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    return /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, classes["color".concat((0, $kfLRg.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
        ref: ref
    }, other), children, fcs.required && /*#__PURE__*/ $gIfym.createElement("span", {
        "aria-hidden": true,
        className: (0, $ba4yE.default)(classes.asterisk, fcs.error && classes.error)
    }, "\u2009", '*'));
});
var $ceb5fb181cba72e5$export$2e2bcd8739ae039 = (0, $82OGZ.default)($ceb5fb181cba72e5$export$9dd6ff9ea0189349, {
    name: 'MuiFormLabel'
})($ceb5fb181cba72e5$var$FormLabel);


var $83d8148cf52783d5$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'block',
            transformOrigin: 'top left'
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Pseudo-class applied to the asterisk element. */ asterisk: {},
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            position: 'absolute',
            left: 0,
            top: 0,
            // slight alteration to spec spacing to match visual spec result
            transform: 'translate(0, 24px) scale(1)'
        },
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            // Compensation for the `Input.inputDense` style.
            transform: 'translate(0, 21px) scale(1)'
        },
        /* Styles applied to the `input` element if `shrink={true}`. */ shrink: {
            transform: 'translate(0, 1.5px) scale(0.75)',
            transformOrigin: 'top left'
        },
        /* Styles applied to the `input` element if `disableAnimation={false}`. */ animated: {
            transition: theme.transitions.create([
                'color',
                'transform'
            ], {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the root element if `variant="filled"`. */ filled: {
            // Chrome's autofill feature gives the input field a yellow background.
            // Since the input field is behind the label in the HTML tree,
            // the input field is drawn last and hides the label with an opaque background color.
            // zIndex: 1 will raise the label above opaque background-colors of input.
            zIndex: 1,
            pointerEvents: 'none',
            transform: 'translate(12px, 20px) scale(1)',
            '&$marginDense': {
                transform: 'translate(12px, 17px) scale(1)'
            },
            '&$shrink': {
                transform: 'translate(12px, 10px) scale(0.75)',
                '&$marginDense': {
                    transform: 'translate(12px, 7px) scale(0.75)'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            // see comment above on filled.zIndex
            zIndex: 1,
            pointerEvents: 'none',
            transform: 'translate(14px, 20px) scale(1)',
            '&$marginDense': {
                transform: 'translate(14px, 12px) scale(1)'
            },
            '&$shrink': {
                transform: 'translate(14px, -6px) scale(0.75)'
            }
        }
    };
};
var $83d8148cf52783d5$var$InputLabel = /*#__PURE__*/ $gIfym.forwardRef(function InputLabel(props, ref) {
    var classes = props.classes, className = props.className, _props$disableAnimati = props.disableAnimation, disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati, margin = props.margin, shrinkProp = props.shrink, variant = props.variant, other = (0, $f6Qba.default)(props, [
        "classes",
        "className",
        "disableAnimation",
        "margin",
        "shrink",
        "variant"
    ]);
    var muiFormControl = (0, $fb91f9a015629c85$export$2e2bcd8739ae039)();
    var shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    var fcs = (0, $a62fb4227558e134$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'margin',
            'variant'
        ]
    });
    return /*#__PURE__*/ $gIfym.createElement((0, $ceb5fb181cba72e5$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        "data-shrink": shrink,
        className: (0, $ba4yE.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
            'filled': classes.filled,
            'outlined': classes.outlined
        }[fcs.variant]),
        classes: {
            focused: classes.focused,
            disabled: classes.disabled,
            error: classes.error,
            required: classes.required,
            asterisk: classes.asterisk
        },
        ref: ref
    }, other));
});
var $83d8148cf52783d5$export$2e2bcd8739ae039 = (0, $82OGZ.default)($83d8148cf52783d5$export$9dd6ff9ea0189349, {
    name: 'MuiInputLabel'
})($83d8148cf52783d5$var$InputLabel);





var $gIfym = parcelRequire("gIfym");


var $gIfym = parcelRequire("gIfym");

var $hQJVM = parcelRequire("hQJVM");

var $8ZNRc = parcelRequire("8ZNRc");
function $31b002675a35c784$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}


function $10aa39cd648f2fb9$export$2e2bcd8739ae039(argument) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $8ZNRc.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $992736cad2b87886$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}


var $8ZNRc = parcelRequire("8ZNRc");

function $8b850696baf7d48a$export$2e2bcd8739ae039(value) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $8ZNRc.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}




function $fd484e33268961be$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $8b850696baf7d48a$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}



function $fd3041540393caa2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $8k2Uc = parcelRequire("8k2Uc");

var $gIfym = parcelRequire("gIfym");


var $gIfym = parcelRequire("gIfym");

var $30b5b3be1499928f$export$407448d2b89b1813 = (0, $gIfym.createContext)(null);
var $30b5b3be1499928f$export$3a1a48c8f6ef640e = function MuiPickersUtilsProvider(_ref) {
    var Utils = _ref.utils, children = _ref.children, locale = _ref.locale, libInstance = _ref.libInstance;
    var utils = (0, $gIfym.useMemo)(function() {
        return new Utils({
            locale: locale,
            instance: libInstance
        });
    }, [
        Utils,
        libInstance,
        locale
    ]);
    return (0, $gIfym.createElement)($30b5b3be1499928f$export$407448d2b89b1813.Provider, {
        value: utils,
        children: children
    });
};
var $30b5b3be1499928f$var$checkUtils = function checkUtils(utils) {
    if (!utils) // tslint:disable-next-line
    throw new Error('Can not find utils in context. You either a) forgot to wrap your component tree in MuiPickersUtilsProvider; or b) mixed named and direct file imports.  Recommendation: use named imports from the module index.');
};
function $30b5b3be1499928f$export$3b14a55fb2447963() {
    var utils = (0, $gIfym.useContext)($30b5b3be1499928f$export$407448d2b89b1813);
    $30b5b3be1499928f$var$checkUtils(utils);
    return utils;
}



var $ba4yE = parcelRequire("ba4yE");
parcelRequire("k2R8s");
parcelRequire("f6Qba");


var $k2R8s = parcelRequire("k2R8s");

var $hQJVM = parcelRequire("hQJVM");

var $7nQ0B = parcelRequire("7nQ0B");
function $c67a157fd78dc604$var$makeStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, $hQJVM.default)(stylesOrCreator, (0, $k2R8s.default)({
        defaultTheme: (0, $7nQ0B.default)
    }, options));
}
var $c67a157fd78dc604$export$2e2bcd8739ae039 = $c67a157fd78dc604$var$makeStyles;



var $8k2Uc = parcelRequire("8k2Uc");

var $gIfym = parcelRequire("gIfym");



var $ba4yE = parcelRequire("ba4yE");

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

function $8bd5e50abde2e2d6$export$2e2bcd8739ae039(styles) {
    return styles;
}


function $c72980417caacb7d$export$2e2bcd8739ae039(styles) {
    // warning(
    //   warnOnce,
    //   [
    //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
    //     'Please use @material-ui/styles/createStyles',
    //   ].join('\n'),
    // );
    // warnOnce = true;
    return (0, $8bd5e50abde2e2d6$export$2e2bcd8739ae039)(styles);
}


var $aUprr = parcelRequire("aUprr");
var $82OGZ = parcelRequire("82OGZ");

var $f6Qba = parcelRequire("f6Qba");

var $k2R8s = parcelRequire("k2R8s");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");

var $aUprr = parcelRequire("aUprr");


var $kfLRg = parcelRequire("kfLRg");
var $b6f198a9b7d0786c$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $k2R8s.default)({}, theme.typography.button, {
            boxSizing: 'border-box',
            minWidth: 64,
            padding: '6px 16px',
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            transition: theme.transitions.create([
                'background-color',
                'box-shadow',
                'border'
            ], {
                duration: theme.transitions.duration.short
            }),
            '&:hover': {
                textDecoration: 'none',
                backgroundColor: (0, $aUprr.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                },
                '&$disabled': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        }),
        /* Styles applied to the span element that wraps the children. */ label: {
            width: '100%',
            // Ensure the correct width for iOS Safari
            display: 'inherit',
            alignItems: 'inherit',
            justifyContent: 'inherit'
        },
        /* Styles applied to the root element if `variant="text"`. */ text: {
            padding: '6px 8px'
        },
        /* Styles applied to the root element if `variant="text"` and `color="primary"`. */ textPrimary: {
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: (0, $aUprr.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */ textSecondary: {
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: (0, $aUprr.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            padding: '5px 15px',
            border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
            '&$disabled': {
                border: "1px solid ".concat(theme.palette.action.disabledBackground)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat((0, $aUprr.alpha)(theme.palette.primary.main, 0.5)),
            '&:hover': {
                border: "1px solid ".concat(theme.palette.primary.main),
                backgroundColor: (0, $aUprr.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat((0, $aUprr.alpha)(theme.palette.secondary.main, 0.5)),
            '&:hover': {
                border: "1px solid ".concat(theme.palette.secondary.main),
                backgroundColor: (0, $aUprr.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                border: "1px solid ".concat(theme.palette.action.disabled)
            }
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            backgroundColor: theme.palette.grey[300],
            boxShadow: theme.shadows[2],
            '&:hover': {
                backgroundColor: theme.palette.grey.A100,
                boxShadow: theme.shadows[4],
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    boxShadow: theme.shadows[2],
                    backgroundColor: theme.palette.grey[300]
                },
                '&$disabled': {
                    backgroundColor: theme.palette.action.disabledBackground
                }
            },
            '&$focusVisible': {
                boxShadow: theme.shadows[6]
            },
            '&:active': {
                boxShadow: theme.shadows[8]
            },
            '&$disabled': {
                color: theme.palette.action.disabled,
                boxShadow: theme.shadows[0],
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */ containedPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.palette.primary.main
                }
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */ containedSecondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: theme.palette.secondary.dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.palette.secondary.main
                }
            }
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: 'none',
            '&:hover': {
                boxShadow: 'none'
            },
            '&$focusVisible': {
                boxShadow: 'none'
            },
            '&:active': {
                boxShadow: 'none'
            },
            '&$disabled': {
                boxShadow: 'none'
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit',
            borderColor: 'currentColor'
        },
        /* Styles applied to the root element if `size="small"` and `variant="text"`. */ textSizeSmall: {
            padding: '4px 5px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="text"`. */ textSizeLarge: {
            padding: '8px 11px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */ outlinedSizeSmall: {
            padding: '3px 9px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */ outlinedSizeLarge: {
            padding: '7px 21px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="contained"`. */ containedSizeSmall: {
            padding: '4px 10px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="contained"`. */ containedSizeLarge: {
            padding: '8px 22px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {},
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: '100%'
        },
        /* Styles applied to the startIcon element if supplied. */ startIcon: {
            display: 'inherit',
            marginRight: 8,
            marginLeft: -4,
            '&$iconSizeSmall': {
                marginLeft: -2
            }
        },
        /* Styles applied to the endIcon element if supplied. */ endIcon: {
            display: 'inherit',
            marginRight: -4,
            marginLeft: 8,
            '&$iconSizeSmall': {
                marginRight: -2
            }
        },
        /* Styles applied to the icon element if supplied and `size="small"`. */ iconSizeSmall: {
            '& > *:first-child': {
                fontSize: 18
            }
        },
        /* Styles applied to the icon element if supplied and `size="medium"`. */ iconSizeMedium: {
            '& > *:first-child': {
                fontSize: 20
            }
        },
        /* Styles applied to the icon element if supplied and `size="large"`. */ iconSizeLarge: {
            '& > *:first-child': {
                fontSize: 22
            }
        }
    };
};
var $b6f198a9b7d0786c$var$Button = /*#__PURE__*/ $gIfym.forwardRef(function Button(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$component = props.component, component = _props$component === void 0 ? 'button' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, startIconProp = props.startIcon, _props$type = props.type, type = _props$type === void 0 ? 'button' : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? 'text' : _props$variant, other = (0, $f6Qba.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    var startIcon = startIconProp && /*#__PURE__*/ $gIfym.createElement("span", {
        className: (0, $ba4yE.default)(classes.startIcon, classes["iconSize".concat((0, $kfLRg.default)(size))])
    }, startIconProp);
    var endIcon = endIconProp && /*#__PURE__*/ $gIfym.createElement("span", {
        className: (0, $ba4yE.default)(classes.endIcon, classes["iconSize".concat((0, $kfLRg.default)(size))])
    }, endIconProp);
    return /*#__PURE__*/ $gIfym.createElement((0, $c3be49ff5d39de33$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat((0, $kfLRg.default)(color))], size !== 'medium' && [
            classes["".concat(variant, "Size").concat((0, $kfLRg.default)(size))],
            classes["size".concat((0, $kfLRg.default)(size))]
        ], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $ba4yE.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other), /*#__PURE__*/ $gIfym.createElement("span", {
        className: classes.label
    }, startIcon, children, endIcon));
});
var $b6f198a9b7d0786c$export$2e2bcd8739ae039 = (0, $82OGZ.default)($b6f198a9b7d0786c$export$9dd6ff9ea0189349, {
    name: 'MuiButton'
})($b6f198a9b7d0786c$var$Button);




var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $82OGZ = parcelRequire("82OGZ");


var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");
var $66c2657ec70527fb$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    },
    /* Styles applied to the root element if `disableSpacing={false}`. */ spacing: {
        '& > :not(:first-child)': {
            marginLeft: 8
        }
    }
};
var $66c2657ec70527fb$var$DialogActions = /*#__PURE__*/ $gIfym.forwardRef(function DialogActions(props, ref) {
    var _props$disableSpacing = props.disableSpacing, disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing, classes = props.classes, className = props.className, other = (0, $f6Qba.default)(props, [
        "disableSpacing",
        "classes",
        "className"
    ]);
    return /*#__PURE__*/ $gIfym.createElement("div", (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className, !disableSpacing && classes.spacing),
        ref: ref
    }, other));
});
var $66c2657ec70527fb$export$2e2bcd8739ae039 = (0, $82OGZ.default)($66c2657ec70527fb$export$9dd6ff9ea0189349, {
    name: 'MuiDialogActions'
})($66c2657ec70527fb$var$DialogActions);



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");
var $8460cbfc2c095d8f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            flex: '1 1 auto',
            WebkitOverflowScrolling: 'touch',
            // Add iOS momentum scrolling.
            overflowY: 'auto',
            padding: '8px 24px',
            '&:first-child': {
                // dialog without title
                paddingTop: 20
            }
        },
        /* Styles applied to the root element if `dividers={true}`. */ dividers: {
            padding: '16px 24px',
            borderTop: "1px solid ".concat(theme.palette.divider),
            borderBottom: "1px solid ".concat(theme.palette.divider)
        }
    };
};
var $8460cbfc2c095d8f$var$DialogContent = /*#__PURE__*/ $gIfym.forwardRef(function DialogContent(props, ref) {
    var classes = props.classes, className = props.className, _props$dividers = props.dividers, dividers = _props$dividers === void 0 ? false : _props$dividers, other = (0, $f6Qba.default)(props, [
        "classes",
        "className",
        "dividers"
    ]);
    return /*#__PURE__*/ $gIfym.createElement("div", (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className, dividers && classes.dividers),
        ref: ref
    }, other));
});
var $8460cbfc2c095d8f$export$2e2bcd8739ae039 = (0, $82OGZ.default)($8460cbfc2c095d8f$export$9dd6ff9ea0189349, {
    name: 'MuiDialogContent'
})($8460cbfc2c095d8f$var$DialogContent);



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $8k2Uc = parcelRequire("8k2Uc");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");

var $kfLRg = parcelRequire("kfLRg");



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");

var $k2R8s = parcelRequire("k2R8s");

var $3KNdx = parcelRequire("3KNdx");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");



var $dJPr8 = parcelRequire("dJPr8");



var $818c7fa2a90af3c0$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
var $818c7fa2a90af3c0$var$defaultTimeout = {
    enter: (0, $dJPr8.duration).enteringScreen,
    exit: (0, $dJPr8.duration).leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $818c7fa2a90af3c0$var$Fade = /*#__PURE__*/ $gIfym.forwardRef(function Fade(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $19bb90b7fff15f94$export$2e2bcd8739ae039) : _props$TransitionComp, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? $818c7fa2a90af3c0$var$defaultTimeout : _props$timeout, other = (0, $f6Qba.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "TransitionComponent",
        "timeout"
    ]);
    var theme = (0, $80d7961be58b720f$export$2e2bcd8739ae039)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $gIfym.useRef(null);
    var foreignRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(children.ref, ref);
    var handleRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $3KNdx.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $ff9839da05f19fc0$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        var transitionProps = (0, $ff9839da05f19fc0$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var transitionProps = (0, $ff9839da05f19fc0$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    return /*#__PURE__*/ $gIfym.createElement(TransitionComponent, (0, $k2R8s.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        timeout: timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $gIfym.cloneElement(children, (0, $k2R8s.default)({
            style: (0, $k2R8s.default)({
                opacity: 0,
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, $818c7fa2a90af3c0$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
var $818c7fa2a90af3c0$export$2e2bcd8739ae039 = $818c7fa2a90af3c0$var$Fade;


var $9b8aae97883f7e8f$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        // Improve scrollable dialog support.
        zIndex: -1,
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: 'transparent'
    }
};
var $9b8aae97883f7e8f$var$Backdrop = /*#__PURE__*/ $gIfym.forwardRef(function Backdrop(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, transitionDuration = props.transitionDuration, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $818c7fa2a90af3c0$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $f6Qba.default)(props, [
        "children",
        "classes",
        "className",
        "invisible",
        "open",
        "transitionDuration",
        "TransitionComponent"
    ]);
    return /*#__PURE__*/ $gIfym.createElement(TransitionComponent, (0, $k2R8s.default)({
        in: open,
        timeout: transitionDuration
    }, other), /*#__PURE__*/ $gIfym.createElement("div", {
        className: (0, $ba4yE.default)(classes.root, className, invisible && classes.invisible),
        "aria-hidden": true,
        ref: ref
    }, children));
});
var $9b8aae97883f7e8f$export$2e2bcd8739ae039 = (0, $82OGZ.default)($9b8aae97883f7e8f$export$9dd6ff9ea0189349, {
    name: 'MuiBackdrop'
})($9b8aae97883f7e8f$var$Backdrop);




var $dJPr8 = parcelRequire("dJPr8");

var $01f6090aa9d28763$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            '@media print': {
                // Use !important to override the Modal inline-style.
                position: 'absolute !important'
            }
        },
        /* Styles applied to the container element if `scroll="paper"`. */ scrollPaper: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        /* Styles applied to the container element if `scroll="body"`. */ scrollBody: {
            overflowY: 'auto',
            overflowX: 'hidden',
            textAlign: 'center',
            '&:after': {
                content: '""',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0'
            }
        },
        /* Styles applied to the container element. */ container: {
            height: '100%',
            '@media print': {
                height: 'auto'
            },
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0
        },
        /* Styles applied to the `Paper` component. */ paper: {
            margin: 32,
            position: 'relative',
            overflowY: 'auto',
            // Fix IE 11 issue, to remove at some point.
            '@media print': {
                overflowY: 'visible',
                boxShadow: 'none'
            }
        },
        /* Styles applied to the `Paper` component if `scroll="paper"`. */ paperScrollPaper: {
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'calc(100% - 64px)'
        },
        /* Styles applied to the `Paper` component if `scroll="body"`. */ paperScrollBody: {
            display: 'inline-block',
            verticalAlign: 'middle',
            textAlign: 'left' // 'initial' doesn't work on IE 11
        },
        /* Styles applied to the `Paper` component if `maxWidth=false`. */ paperWidthFalse: {
            maxWidth: 'calc(100% - 64px)'
        },
        /* Styles applied to the `Paper` component if `maxWidth="xs"`. */ paperWidthXs: {
            maxWidth: Math.max(theme.breakpoints.values.xs, 444),
            '&$paperScrollBody': (0, $8k2Uc.default)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="sm"`. */ paperWidthSm: {
            maxWidth: theme.breakpoints.values.sm,
            '&$paperScrollBody': (0, $8k2Uc.default)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="md"`. */ paperWidthMd: {
            maxWidth: theme.breakpoints.values.md,
            '&$paperScrollBody': (0, $8k2Uc.default)({}, theme.breakpoints.down(theme.breakpoints.values.md + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="lg"`. */ paperWidthLg: {
            maxWidth: theme.breakpoints.values.lg,
            '&$paperScrollBody': (0, $8k2Uc.default)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="xl"`. */ paperWidthXl: {
            maxWidth: theme.breakpoints.values.xl,
            '&$paperScrollBody': (0, $8k2Uc.default)({}, theme.breakpoints.down(theme.breakpoints.values.xl + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `fullWidth={true}`. */ paperFullWidth: {
            width: 'calc(100% - 64px)'
        },
        /* Styles applied to the `Paper` component if `fullScreen={true}`. */ paperFullScreen: {
            margin: 0,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: 'none',
            borderRadius: 0,
            '&$paperScrollBody': {
                margin: 0,
                maxWidth: '100%'
            }
        }
    };
};
var $01f6090aa9d28763$var$defaultTransitionDuration = {
    enter: (0, $dJPr8.duration).enteringScreen,
    exit: (0, $dJPr8.duration).leavingScreen
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ var $01f6090aa9d28763$var$Dialog = /*#__PURE__*/ $gIfym.forwardRef(function Dialog(props, ref) {
    var BackdropProps = props.BackdropProps, children = props.children, classes = props.classes, className = props.className, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$fullScreen = props.fullScreen, fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$maxWidth = props.maxWidth, maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onEscapeKeyDown = props.onEscapeKeyDown, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperComponent = props.PaperComponent, PaperComponent = _props$PaperComponent === void 0 ? (0, $ee13f6b8f50f92d0$export$2e2bcd8739ae039) : _props$PaperComponent, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$scroll = props.scroll, scroll = _props$scroll === void 0 ? 'paper' : _props$scroll, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $818c7fa2a90af3c0$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? $01f6090aa9d28763$var$defaultTransitionDuration : _props$transitionDura, TransitionProps = props.TransitionProps, ariaDescribedby = props['aria-describedby'], ariaLabelledby = props['aria-labelledby'], other = (0, $f6Qba.default)(props, [
        "BackdropProps",
        "children",
        "classes",
        "className",
        "disableBackdropClick",
        "disableEscapeKeyDown",
        "fullScreen",
        "fullWidth",
        "maxWidth",
        "onBackdropClick",
        "onClose",
        "onEnter",
        "onEntered",
        "onEntering",
        "onEscapeKeyDown",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperComponent",
        "PaperProps",
        "scroll",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps",
        "aria-describedby",
        "aria-labelledby"
    ]);
    var mouseDownTarget = $gIfym.useRef();
    var handleMouseDown = function handleMouseDown(event) {
        mouseDownTarget.current = event.target;
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        // Ignore the events not coming from the "backdrop"
        // We don't want to close the dialog when clicking the dialog content.
        if (event.target !== event.currentTarget) return;
         // Make sure the event starts and ends on the same DOM element.
        if (event.target !== mouseDownTarget.current) return;
        mouseDownTarget.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, 'backdropClick');
    };
    return /*#__PURE__*/ $gIfym.createElement((0, $3ad09d28fe7c5342$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className),
        BackdropComponent: (0, $9b8aae97883f7e8f$export$2e2bcd8739ae039),
        BackdropProps: (0, $k2R8s.default)({
            transitionDuration: transitionDuration
        }, BackdropProps),
        closeAfterTransition: true
    }, disableBackdropClick ? {
        disableBackdropClick: disableBackdropClick
    } : {}, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        onEscapeKeyDown: onEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref
    }, other), /*#__PURE__*/ $gIfym.createElement(TransitionComponent, (0, $k2R8s.default)({
        appear: true,
        in: open,
        timeout: transitionDuration,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        role: "none presentation"
    }, TransitionProps), /*#__PURE__*/ $gIfym.createElement("div", {
        className: (0, $ba4yE.default)(classes.container, classes["scroll".concat((0, $kfLRg.default)(scroll))]),
        onMouseUp: handleBackdropClick,
        onMouseDown: handleMouseDown
    }, /*#__PURE__*/ $gIfym.createElement(PaperComponent, (0, $k2R8s.default)({
        elevation: 24,
        role: "dialog",
        "aria-describedby": ariaDescribedby,
        "aria-labelledby": ariaLabelledby
    }, PaperProps, {
        className: (0, $ba4yE.default)(classes.paper, classes["paperScroll".concat((0, $kfLRg.default)(scroll))], classes["paperWidth".concat((0, $kfLRg.default)(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
    }), children))));
});
var $01f6090aa9d28763$export$2e2bcd8739ae039 = (0, $82OGZ.default)($01f6090aa9d28763$export$9dd6ff9ea0189349, {
    name: 'MuiDialog'
})($01f6090aa9d28763$var$Dialog);



/** Use it instead of .includes method for IE support */ function $e5df3b21da25e895$export$407448d2b89b1813(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every(function(item) {
        return array.indexOf(item) !== -1;
    });
    return array.indexOf(itemOrItems) !== -1;
}
var $e5df3b21da25e895$export$96f57966bedc81b4 = 310;
var $e5df3b21da25e895$export$db3b6bfb95261072 = 325;
var $e5df3b21da25e895$export$8b22cf2602fb60ce = 305;
var $e5df3b21da25e895$var$useStyles = (0, $c67a157fd78dc604$export$2e2bcd8739ae039)(function(theme) {
    return {
        staticWrapperRoot: {
            overflow: 'hidden',
            minWidth: $e5df3b21da25e895$export$96f57966bedc81b4,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: theme.palette.background.paper
        }
    };
}, {
    name: 'MuiPickersStaticWrapper'
});
var $e5df3b21da25e895$var$StaticWrapper = function StaticWrapper(_ref) {
    var children = _ref.children;
    var classes = $e5df3b21da25e895$var$useStyles();
    return (0, $gIfym.createElement)("div", {
        className: classes.staticWrapperRoot,
        children: children
    });
};
var $e5df3b21da25e895$var$ModalDialog = function ModalDialog(_ref) {
    var children = _ref.children, classes = _ref.classes, onAccept = _ref.onAccept, onDismiss = _ref.onDismiss, onClear = _ref.onClear, onSetToday = _ref.onSetToday, okLabel = _ref.okLabel, cancelLabel = _ref.cancelLabel, clearLabel = _ref.clearLabel, todayLabel = _ref.todayLabel, clearable = _ref.clearable, showTodayButton = _ref.showTodayButton, showTabs = _ref.showTabs, wider = _ref.wider, other = (0, $f6Qba.default)(_ref, [
        "children",
        "classes",
        "onAccept",
        "onDismiss",
        "onClear",
        "onSetToday",
        "okLabel",
        "cancelLabel",
        "clearLabel",
        "todayLabel",
        "clearable",
        "showTodayButton",
        "showTabs",
        "wider"
    ]);
    return (0, $gIfym.createElement)((0, $01f6090aa9d28763$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        role: "dialog",
        onClose: onDismiss,
        classes: {
            paper: (0, $ba4yE.default)(classes.dialogRoot, wider && classes.dialogRootWider)
        }
    }, other), (0, $gIfym.createElement)((0, $8460cbfc2c095d8f$export$2e2bcd8739ae039), {
        children: children,
        className: classes.dialog
    }), (0, $gIfym.createElement)((0, $66c2657ec70527fb$export$2e2bcd8739ae039), {
        classes: {
            root: (0, $ba4yE.default)((clearable || showTodayButton) && classes.withAdditionalAction)
        }
    }, clearable && (0, $gIfym.createElement)((0, $b6f198a9b7d0786c$export$2e2bcd8739ae039), {
        color: "primary",
        onClick: onClear
    }, clearLabel), showTodayButton && (0, $gIfym.createElement)((0, $b6f198a9b7d0786c$export$2e2bcd8739ae039), {
        color: "primary",
        onClick: onSetToday
    }, todayLabel), cancelLabel && (0, $gIfym.createElement)((0, $b6f198a9b7d0786c$export$2e2bcd8739ae039), {
        color: "primary",
        onClick: onDismiss
    }, cancelLabel), okLabel && (0, $gIfym.createElement)((0, $b6f198a9b7d0786c$export$2e2bcd8739ae039), {
        color: "primary",
        onClick: onAccept
    }, okLabel)));
};
$e5df3b21da25e895$var$ModalDialog.displayName = 'ModalDialog';
var $e5df3b21da25e895$var$styles = (0, $c72980417caacb7d$export$2e2bcd8739ae039)({
    dialogRoot: {
        minWidth: $e5df3b21da25e895$export$96f57966bedc81b4
    },
    dialogRootWider: {
        minWidth: $e5df3b21da25e895$export$db3b6bfb95261072
    },
    dialog: {
        '&:first-child': {
            padding: 0
        }
    },
    withAdditionalAction: {
        // set justifyContent to default value to fix IE11 layout bug
        // see https://github.com/dmtrKovalenko/material-ui-pickers/pull/267
        justifyContent: 'flex-start',
        '& > *:first-child': {
            marginRight: 'auto'
        }
    }
});
var $e5df3b21da25e895$var$ModalDialog$1 = (0, $82OGZ.default)($e5df3b21da25e895$var$styles, {
    name: 'MuiPickersModal'
})($e5df3b21da25e895$var$ModalDialog);
var $e5df3b21da25e895$export$3b14a55fb2447963 = typeof window === 'undefined' ? (0, $gIfym.useEffect) : (0, $gIfym.useLayoutEffect);
function $e5df3b21da25e895$export$43caf9889c228507(e, keyHandlers) {
    var handler = keyHandlers[e.key];
    if (handler) {
        handler(); // if event was handled prevent other side effects (e.g. page scroll)
        e.preventDefault();
    }
}
function $e5df3b21da25e895$var$useKeyDown(active, keyHandlers) {
    var keyHandlersRef = (0, $gIfym.useRef)(keyHandlers);
    keyHandlersRef.current = keyHandlers;
    $e5df3b21da25e895$export$3b14a55fb2447963(function() {
        if (active) {
            var handleKeyDown = function handleKeyDown(event) {
                $e5df3b21da25e895$export$43caf9889c228507(event, keyHandlersRef.current);
            };
            window.addEventListener('keydown', handleKeyDown);
            return function() {
                window.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [
        active
    ]);
}
var $e5df3b21da25e895$var$ModalWrapper = function ModalWrapper(_ref) {
    var open = _ref.open, children = _ref.children, okLabel = _ref.okLabel, cancelLabel = _ref.cancelLabel, clearLabel = _ref.clearLabel, todayLabel = _ref.todayLabel, showTodayButton = _ref.showTodayButton, clearable = _ref.clearable, DialogProps = _ref.DialogProps, showTabs = _ref.showTabs, wider = _ref.wider, InputComponent = _ref.InputComponent, DateInputProps = _ref.DateInputProps, onClear = _ref.onClear, onAccept = _ref.onAccept, onDismiss = _ref.onDismiss, onSetToday = _ref.onSetToday, other = (0, $f6Qba.default)(_ref, [
        "open",
        "children",
        "okLabel",
        "cancelLabel",
        "clearLabel",
        "todayLabel",
        "showTodayButton",
        "clearable",
        "DialogProps",
        "showTabs",
        "wider",
        "InputComponent",
        "DateInputProps",
        "onClear",
        "onAccept",
        "onDismiss",
        "onSetToday"
    ]);
    $e5df3b21da25e895$var$useKeyDown(open, {
        Enter: onAccept
    });
    return (0, $gIfym.createElement)((0, $gIfym.Fragment), null, (0, $gIfym.createElement)(InputComponent, (0, $k2R8s.default)({}, other, DateInputProps)), (0, $gIfym.createElement)($e5df3b21da25e895$var$ModalDialog$1, (0, $k2R8s.default)({
        wider: wider,
        showTabs: showTabs,
        open: open,
        onClear: onClear,
        onAccept: onAccept,
        onDismiss: onDismiss,
        onSetToday: onSetToday,
        clearLabel: clearLabel,
        todayLabel: todayLabel,
        okLabel: okLabel,
        cancelLabel: cancelLabel,
        clearable: clearable,
        showTodayButton: showTodayButton,
        children: children
    }, DialogProps)));
};
$e5df3b21da25e895$var$ModalWrapper.defaultProps = {
    okLabel: 'OK',
    cancelLabel: 'Cancel',
    clearLabel: 'Clear',
    todayLabel: 'Today',
    clearable: false,
    showTodayButton: false
};
var $e5df3b21da25e895$var$InlineWrapper = function InlineWrapper(_ref) {
    var open = _ref.open, wider = _ref.wider, children = _ref.children, PopoverProps = _ref.PopoverProps, onClear = _ref.onClear, onDismiss = _ref.onDismiss, onSetToday = _ref.onSetToday, onAccept = _ref.onAccept, showTabs = _ref.showTabs, DateInputProps = _ref.DateInputProps, InputComponent = _ref.InputComponent, other = (0, $f6Qba.default)(_ref, [
        "open",
        "wider",
        "children",
        "PopoverProps",
        "onClear",
        "onDismiss",
        "onSetToday",
        "onAccept",
        "showTabs",
        "DateInputProps",
        "InputComponent"
    ]);
    var ref = (0, $gIfym.useRef)();
    $e5df3b21da25e895$var$useKeyDown(open, {
        Enter: onAccept
    });
    return (0, $gIfym.createElement)((0, $gIfym.Fragment), null, (0, $gIfym.createElement)(InputComponent, (0, $k2R8s.default)({}, other, DateInputProps, {
        inputRef: ref
    })), (0, $gIfym.createElement)((0, $154807aaa727960c$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        open: open,
        onClose: onDismiss,
        anchorEl: ref.current,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        },
        children: children
    }, PopoverProps)));
};
function $e5df3b21da25e895$var$getWrapperFromVariant(variant) {
    switch(variant){
        case 'inline':
            return $e5df3b21da25e895$var$InlineWrapper;
        case 'static':
            return $e5df3b21da25e895$var$StaticWrapper;
        default:
            return $e5df3b21da25e895$var$ModalWrapper;
    }
}
var $e5df3b21da25e895$export$e7c866399fa523f5 = (0, $gIfym.createContext)(null);
var $e5df3b21da25e895$export$71cec2538cb2c617 = function Wrapper(_ref) {
    var variant = _ref.variant, props = (0, $f6Qba.default)(_ref, [
        "variant"
    ]);
    var Component = $e5df3b21da25e895$var$getWrapperFromVariant(variant);
    return (0, $gIfym.createElement)($e5df3b21da25e895$export$e7c866399fa523f5.Provider, {
        value: variant || 'dialog'
    }, (0, $gIfym.createElement)(Component, props));
};



var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");








var $f6Qba = parcelRequire("f6Qba");

var $k2R8s = parcelRequire("k2R8s");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");



var $82OGZ = parcelRequire("82OGZ");
var $8866b77cebec2e94$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $k2R8s.default)({
            color: theme.palette.text.secondary
        }, theme.typography.caption, {
            textAlign: 'left',
            marginTop: 3,
            margin: 0,
            '&$disabled': {
                color: theme.palette.text.disabled
            },
            '&$error': {
                color: theme.palette.error.main
            }
        }),
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            marginTop: 4
        },
        /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */ contained: {
            marginLeft: 14,
            marginRight: 14
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {}
    };
};
var $8866b77cebec2e94$var$FormHelperText = /*#__PURE__*/ $gIfym.forwardRef(function FormHelperText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'p' : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, margin = props.margin, required = props.required, variant = props.variant, other = (0, $f6Qba.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "margin",
        "required",
        "variant"
    ]);
    var muiFormControl = (0, $fb91f9a015629c85$export$2e2bcd8739ae039)();
    var fcs = (0, $a62fb4227558e134$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'margin',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    return /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
        ref: ref
    }, other), children === ' ' ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $gIfym.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    }) : children);
});
var $8866b77cebec2e94$export$2e2bcd8739ae039 = (0, $82OGZ.default)($8866b77cebec2e94$export$9dd6ff9ea0189349, {
    name: 'MuiFormHelperText'
})($8866b77cebec2e94$var$FormHelperText);




var $82OGZ = parcelRequire("82OGZ");
var $27b2411b49a9a0ff$var$variantComponent = {
    standard: (0, $f36d5c810dfccd93$export$2e2bcd8739ae039),
    filled: (0, $7d9dbf313cf242e7$export$2e2bcd8739ae039),
    outlined: (0, $56fe5ea54f7e8d74$export$2e2bcd8739ae039)
};
var $27b2411b49a9a0ff$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ var $27b2411b49a9a0ff$var$TextField = /*#__PURE__*/ $gIfym.forwardRef(function TextField(props, ref) {
    var autoComplete = props.autoComplete, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, FormHelperTextProps = props.FormHelperTextProps, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, helperText = props.helperText, hiddenLabel = props.hiddenLabel, id = props.id, InputLabelProps = props.InputLabelProps, inputProps = props.inputProps, InputProps = props.InputProps, inputRef = props.inputRef, label = props.label, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, rows = props.rows, rowsMax = props.rowsMax, maxRows = props.maxRows, minRows = props.minRows, _props$select = props.select, select = _props$select === void 0 ? false : _props$select, SelectProps = props.SelectProps, type = props.type, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $f6Qba.default)(props, [
        "autoComplete",
        "autoFocus",
        "children",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "error",
        "FormHelperTextProps",
        "fullWidth",
        "helperText",
        "hiddenLabel",
        "id",
        "InputLabelProps",
        "inputProps",
        "InputProps",
        "inputRef",
        "label",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "placeholder",
        "required",
        "rows",
        "rowsMax",
        "maxRows",
        "minRows",
        "select",
        "SelectProps",
        "type",
        "value",
        "variant"
    ]);
    var InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        if (label) {
            var _InputLabelProps$requ;
            var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
            InputMore.label = /*#__PURE__*/ $gIfym.createElement($gIfym.Fragment, null, label, displayRequired && "\xA0*");
        }
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
    var InputComponent = $27b2411b49a9a0ff$var$variantComponent[variant];
    var InputElement = /*#__PURE__*/ $gIfym.createElement(InputComponent, (0, $k2R8s.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        rowsMax: rowsMax,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ $gIfym.createElement((0, $1f3c3d6fcb879aaf$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        ref: ref,
        required: required,
        color: color,
        variant: variant
    }, other), label && /*#__PURE__*/ $gIfym.createElement((0, $83d8148cf52783d5$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        htmlFor: id,
        id: inputLabelId
    }, InputLabelProps), label), select ? /*#__PURE__*/ $gIfym.createElement((0, $ea71a0b004fd8af3$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        "aria-describedby": helperTextId,
        id: id,
        labelId: inputLabelId,
        value: value,
        input: InputElement
    }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/ $gIfym.createElement((0, $8866b77cebec2e94$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        id: helperTextId
    }, FormHelperTextProps), helperText));
});
var $27b2411b49a9a0ff$export$2e2bcd8739ae039 = (0, $82OGZ.default)($27b2411b49a9a0ff$export$9dd6ff9ea0189349, {
    name: 'MuiTextField'
})($27b2411b49a9a0ff$var$TextField);




var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");


var $82OGZ = parcelRequire("82OGZ");

var $65bddc40606992a6$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'flex',
        height: '0.01em',
        // Fix IE 11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap'
    },
    /* Styles applied to the root element if `variant="filled"`. */ filled: {
        '&$positionStart:not($hiddenLabel)': {
            marginTop: 16
        }
    },
    /* Styles applied to the root element if `position="start"`. */ positionStart: {
        marginRight: 8
    },
    /* Styles applied to the root element if `position="end"`. */ positionEnd: {
        marginLeft: 8
    },
    /* Styles applied to the root element if `disablePointerEvents=true`. */ disablePointerEvents: {
        pointerEvents: 'none'
    },
    /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */ hiddenLabel: {},
    /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */ marginDense: {}
};
var $65bddc40606992a6$var$InputAdornment = /*#__PURE__*/ $gIfym.forwardRef(function InputAdornment(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disablePointer = props.disablePointerEvents, disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, position = props.position, variantProp = props.variant, other = (0, $f6Qba.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disablePointerEvents",
        "disableTypography",
        "position",
        "variant"
    ]);
    var muiFormControl = (0, $df967b5ae1e94986$export$62ecd8ad1bbe1a18)() || {};
    var variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    return /*#__PURE__*/ $gIfym.createElement((0, $df967b5ae1e94986$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $gIfym.createElement(Component, (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className, position === 'end' ? classes.positionEnd : classes.positionStart, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === 'filled' && classes.filled, muiFormControl.margin === 'dense' && classes.marginDense),
        ref: ref
    }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/ $gIfym.createElement((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
        color: "textSecondary"
    }, children) : children));
});
var $65bddc40606992a6$export$2e2bcd8739ae039 = (0, $82OGZ.default)($65bddc40606992a6$export$9dd6ff9ea0189349, {
    name: 'MuiInputAdornment'
})($65bddc40606992a6$var$InputAdornment);



var $Ku8r1 = parcelRequire("Ku8r1");

var $gIfym = parcelRequire("gIfym");
var $49655f911c6b554c$export$5519909ee832c7c = /*#__PURE__*/ function(_React$Component) {
    (0, $Ku8r1.default)(Rifm, _React$Component);
    function Rifm(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this._state = null;
        _this._del = false;
        _this._handleChange = function(evt) {
            var stateValue = _this.state.value;
            var value = evt.target.value;
            var input = evt.target;
            var op = value.length > stateValue.length;
            var del = _this._del;
            var noOp = stateValue === _this.props.format(value);
            _this.setState({
                value: value,
                local: true
            }, function() {
                var selectionStart = input.selectionStart;
                var refuse = _this.props.refuse || /[^\d]+/g;
                var before = value.substr(0, selectionStart).replace(refuse, '');
                _this._state = {
                    input: input,
                    before: before,
                    op: op,
                    di: del && noOp,
                    del: del
                };
                if (_this.props.replace && _this.props.replace(stateValue) && op && !noOp) {
                    var start = -1;
                    for(var i = 0; i !== before.length; ++i)start = Math.max(start, value.toLowerCase().indexOf(before[i].toLowerCase(), start + 1));
                    var c = value.substr(start + 1).replace(refuse, '')[0];
                    start = value.indexOf(c, start + 1);
                    value = "" + value.substr(0, start) + value.substr(start + 1);
                }
                var fv = _this.props.format(value);
                if (stateValue === fv) _this.setState({
                    value: value
                });
                else _this.props.onChange(fv);
            });
        };
        _this._hKD = function(evt) {
            if (evt.code === 'Delete') _this._del = true;
        };
        _this._hKU = function(evt) {
            if (evt.code === 'Delete') _this._del = false;
        };
        _this.state = {
            value: props.value,
            local: true
        };
        return _this;
    }
    Rifm.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        return {
            value: state.local ? state.value : props.value,
            local: false
        };
    };
    var _proto = Rifm.prototype;
    _proto.render = function render() {
        var _handleChange = this._handleChange, value = this.state.value, children = this.props.children;
        return children({
            value: value,
            onChange: _handleChange
        });
    } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
    ;
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener('keydown', this._hKD);
        document.removeEventListener('keyup', this._hKU);
    } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
    ;
    _proto.componentDidMount = function componentDidMount() {
        document.addEventListener('keydown', this._hKD);
        document.addEventListener('keyup', this._hKU);
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        var _state = this._state;
        if (_state) {
            var value = this.state.value;
            var start = -1;
            for(var i = 0; i !== _state.before.length; ++i)start = Math.max(start, value.toLowerCase().indexOf(_state.before[i].toLowerCase(), start + 1));
             // format usually looks better without this
            if (this.props.replace && (_state.op || _state.del && !_state.di)) while(value[start + 1] && (this.props.refuse || /[^\d]+/).test(value[start + 1]))start += 1;
            _state.input.selectionStart = _state.input.selectionEnd = start + 1 + (_state.di ? 1 : 0);
        }
        this._state = null;
    };
    return Rifm;
}((0, $gIfym.Component));



var $8QfUv = parcelRequire("8QfUv");

var $3KNdx = parcelRequire("3KNdx");

var $8k2Uc = parcelRequire("8k2Uc");

var $gIfym = parcelRequire("gIfym");

var $h1Rs9 = parcelRequire("h1Rs9");


var $ba4yE = parcelRequire("ba4yE");

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");




var $gIfym = parcelRequire("gIfym");



var $ba4yE = parcelRequire("ba4yE");

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");


var $82OGZ = parcelRequire("82OGZ");



var $8QfUv = parcelRequire("8QfUv");


var $lU1Um = parcelRequire("lU1Um");

var $8ZNRc = parcelRequire("8ZNRc");

var $6o8oQ = parcelRequire("6o8oQ");
function $f2568f2b7932cb22$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $8ZNRc.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $6o8oQ.default)(t);
}


function $ff55a031e82added$export$2e2bcd8739ae039(t) {
    return $ff55a031e82added$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $ff55a031e82added$export$2e2bcd8739ae039(t);
}



var $dtYFN = parcelRequire("dtYFN");
function $556cd23fac47f479$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $dtYFN.default)(t, e);
}



var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");



var $1233fb0a07ebc3f8$export$28e6b9b82ee883c = (0, $c67a157fd78dc604$export$2e2bcd8739ae039)(function(theme) {
    return {
        day: {
            width: 36,
            height: 36,
            fontSize: theme.typography.caption.fontSize,
            margin: '0 2px',
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightMedium,
            padding: 0
        },
        hidden: {
            opacity: 0,
            pointerEvents: 'none'
        },
        current: {
            color: theme.palette.primary.main,
            fontWeight: 600
        },
        daySelected: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                backgroundColor: theme.palette.primary.main
            }
        },
        dayDisabled: {
            pointerEvents: 'none',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersDay'
});
var $1233fb0a07ebc3f8$export$7a9a31a911eb9a20 = function Day(_ref) {
    var children = _ref.children, disabled = _ref.disabled, hidden = _ref.hidden, current = _ref.current, selected = _ref.selected, other = (0, $f6Qba.default)(_ref, [
        "children",
        "disabled",
        "hidden",
        "current",
        "selected"
    ]);
    var classes = $1233fb0a07ebc3f8$export$28e6b9b82ee883c();
    var className = (0, $ba4yE.default)(classes.day, hidden && classes.hidden, current && classes.current, selected && classes.daySelected, disabled && classes.dayDisabled);
    return (0, $gIfym.createElement)((0, $2ae0a89ca37bbdde$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        className: className,
        tabIndex: hidden || disabled ? -1 : 0
    }, other), (0, $gIfym.createElement)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
        variant: "body2",
        color: "inherit"
    }, children));
};
$1233fb0a07ebc3f8$export$7a9a31a911eb9a20.displayName = 'Day';
$1233fb0a07ebc3f8$export$7a9a31a911eb9a20.defaultProps = {
    disabled: false,
    hidden: false,
    current: false,
    selected: false
};
var $1233fb0a07ebc3f8$export$2e2bcd8739ae039 = $1233fb0a07ebc3f8$export$7a9a31a911eb9a20;



var $k2R8s = parcelRequire("k2R8s");

var $8hGk9 = parcelRequire("8hGk9");

var $Ku8r1 = parcelRequire("Ku8r1");

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $dca0dd7d0fc909d9$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $5eb3f9a936237142$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $dca0dd7d0fc909d9$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $883a28a3079d74fd$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $883a28a3079d74fd$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $883a28a3079d74fd$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $883a28a3079d74fd$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $gIfym = parcelRequire("gIfym");



var $8a71f0ffeeb4040b$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $5eb3f9a936237142$export$2e2bcd8739ae039)(node, c);
    });
};
var $8a71f0ffeeb4040b$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $883a28a3079d74fd$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $8a71f0ffeeb4040b$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $Ku8r1.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $0cf5d5f54f72096b$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $8a71f0ffeeb4040b$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $8a71f0ffeeb4040b$var$removeClass(node, baseClassName);
        if (activeClassName) $8a71f0ffeeb4040b$var$removeClass(node, activeClassName);
        if (doneClassName) $8a71f0ffeeb4040b$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $8hGk9.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $19bb90b7fff15f94$export$2e2bcd8739ae039), (0, $k2R8s.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$8a71f0ffeeb4040b$var$CSSTransition.defaultProps = {
    classNames: ''
};
$8a71f0ffeeb4040b$var$CSSTransition.propTypes = {};
var $8a71f0ffeeb4040b$export$2e2bcd8739ae039 = $8a71f0ffeeb4040b$var$CSSTransition;



var $df47366baeb07e2a$var$findClosestEnabledDate = function findClosestEnabledDate(_ref) {
    var date = _ref.date, utils = _ref.utils, minDate = _ref.minDate, maxDate = _ref.maxDate, disableFuture = _ref.disableFuture, disablePast = _ref.disablePast, shouldDisableDate = _ref.shouldDisableDate;
    var today = utils.startOfDay(utils.date());
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    var forward = date;
    var backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = utils.date(minDate);
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = utils.date(maxDate);
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!shouldDisableDate(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!shouldDisableDate(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    } // fallback to today if no enabled days
    return utils.date();
};
var $df47366baeb07e2a$export$23f2a1d2818174ef = function isYearOnlyView(views) {
    return views.length === 1 && views[0] === 'year';
};
var $df47366baeb07e2a$export$8b22cf2602fb60ce = function isYearAndMonthViews(views) {
    return views.length === 2 && (0, $e5df3b21da25e895$export$407448d2b89b1813)(views, 'month') && (0, $e5df3b21da25e895$export$407448d2b89b1813)(views, 'year');
};
var $df47366baeb07e2a$export$39b482c5e57630a8 = function getFormatByViews(views, utils) {
    if ($df47366baeb07e2a$export$23f2a1d2818174ef(views)) return utils.yearFormat;
    if ($df47366baeb07e2a$export$8b22cf2602fb60ce(views)) return utils.yearMonthFormat;
    return utils.dateFormat;
};
var $df47366baeb07e2a$var$DayWrapper = function DayWrapper(_ref) {
    var children = _ref.children, value = _ref.value, disabled = _ref.disabled, onSelect = _ref.onSelect, dayInCurrentMonth = _ref.dayInCurrentMonth, other = (0, $f6Qba.default)(_ref, [
        "children",
        "value",
        "disabled",
        "onSelect",
        "dayInCurrentMonth"
    ]);
    var handleClick = (0, $gIfym.useCallback)(function() {
        return onSelect(value);
    }, [
        onSelect,
        value
    ]);
    return (0, $gIfym.createElement)("div", (0, $k2R8s.default)({
        role: "presentation",
        onClick: dayInCurrentMonth && !disabled ? handleClick : undefined,
        onKeyPress: dayInCurrentMonth && !disabled ? handleClick : undefined
    }, other), children);
};
var $df47366baeb07e2a$var$animationDuration = 350;
var $df47366baeb07e2a$var$useStyles = (0, $c67a157fd78dc604$export$2e2bcd8739ae039)(function(theme) {
    var slideTransition = theme.transitions.create('transform', {
        duration: $df47366baeb07e2a$var$animationDuration,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        transitionContainer: {
            display: 'block',
            position: 'relative',
            '& > *': {
                position: 'absolute',
                top: 0,
                right: 0,
                left: 0
            }
        },
        'slideEnter-left': {
            willChange: 'transform',
            transform: 'translate(100%)'
        },
        'slideEnter-right': {
            willChange: 'transform',
            transform: 'translate(-100%)'
        },
        slideEnterActive: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        slideExit: {
            transform: 'translate(0%)'
        },
        'slideExitActiveLeft-left': {
            willChange: 'transform',
            transform: 'translate(-200%)',
            transition: slideTransition
        },
        'slideExitActiveLeft-right': {
            willChange: 'transform',
            transform: 'translate(200%)',
            transition: slideTransition
        }
    };
}, {
    name: 'MuiPickersSlideTransition'
});
var $df47366baeb07e2a$var$SlideTransition = function SlideTransition(_ref) {
    var children = _ref.children, transKey = _ref.transKey, slideDirection = _ref.slideDirection, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className;
    var classes = $df47366baeb07e2a$var$useStyles();
    var transitionClasses = {
        exit: classes.slideExit,
        enterActive: classes.slideEnterActive,
        // @ts-ignore
        enter: classes['slideEnter-' + slideDirection],
        // @ts-ignore
        exitActive: classes['slideExitActiveLeft-' + slideDirection]
    };
    return (0, $gIfym.createElement)((0, $c8a94535b2e16cf8$export$2e2bcd8739ae039), {
        className: (0, $ba4yE.default)(classes.transitionContainer, className),
        childFactory: function childFactory(element) {
            return (0, $gIfym.cloneElement)(element, {
                classNames: transitionClasses
            });
        }
    }, (0, $gIfym.createElement)((0, $8a71f0ffeeb4040b$export$2e2bcd8739ae039), {
        mountOnEnter: true,
        unmountOnExit: true,
        key: transKey + slideDirection,
        timeout: $df47366baeb07e2a$var$animationDuration,
        classNames: transitionClasses,
        children: children
    }));
};
var $df47366baeb07e2a$var$ArrowLeftIcon = function ArrowLeftIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $8QfUv.default), props, (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
        d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0V0z"
    }));
};
var $df47366baeb07e2a$var$ArrowRightIcon = function ArrowRightIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $8QfUv.default), props, (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
        d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0V0z"
    }));
};
var $df47366baeb07e2a$var$useStyles$1 = (0, $c67a157fd78dc604$export$2e2bcd8739ae039)(function(theme) {
    return {
        switchHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: theme.spacing(0.5),
            marginBottom: theme.spacing(1)
        },
        transitionContainer: {
            width: '100%',
            overflow: 'hidden',
            height: 23
        },
        iconButton: {
            zIndex: 1,
            backgroundColor: theme.palette.background.paper
        },
        daysHeader: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: 16
        },
        dayLabel: {
            width: 36,
            margin: '0 2px',
            textAlign: 'center',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersCalendarHeader'
});
var $df47366baeb07e2a$var$CalendarHeader = function CalendarHeader(_ref) {
    var currentMonth = _ref.currentMonth, onMonthChange = _ref.onMonthChange, leftArrowIcon = _ref.leftArrowIcon, rightArrowIcon = _ref.rightArrowIcon, leftArrowButtonProps = _ref.leftArrowButtonProps, rightArrowButtonProps = _ref.rightArrowButtonProps, disablePrevMonth = _ref.disablePrevMonth, disableNextMonth = _ref.disableNextMonth, slideDirection = _ref.slideDirection;
    var utils = (0, $30b5b3be1499928f$export$3b14a55fb2447963)();
    var classes = $df47366baeb07e2a$var$useStyles$1();
    var theme = (0, $80d7961be58b720f$export$2e2bcd8739ae039)();
    var rtl = theme.direction === 'rtl';
    var selectNextMonth = function selectNextMonth() {
        return onMonthChange(utils.getNextMonth(currentMonth), 'left');
    };
    var selectPreviousMonth = function selectPreviousMonth() {
        return onMonthChange(utils.getPreviousMonth(currentMonth), 'right');
    };
    return (0, $gIfym.createElement)("div", null, (0, $gIfym.createElement)("div", {
        className: classes.switchHeader
    }, (0, $gIfym.createElement)((0, $2ae0a89ca37bbdde$export$2e2bcd8739ae039), (0, $k2R8s.default)({}, leftArrowButtonProps, {
        disabled: disablePrevMonth,
        onClick: selectPreviousMonth,
        className: classes.iconButton
    }), rtl ? rightArrowIcon : leftArrowIcon), (0, $gIfym.createElement)($df47366baeb07e2a$var$SlideTransition, {
        slideDirection: slideDirection,
        transKey: currentMonth.toString(),
        className: classes.transitionContainer
    }, (0, $gIfym.createElement)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
        align: "center",
        variant: "body1"
    }, utils.getCalendarHeaderText(currentMonth))), (0, $gIfym.createElement)((0, $2ae0a89ca37bbdde$export$2e2bcd8739ae039), (0, $k2R8s.default)({}, rightArrowButtonProps, {
        disabled: disableNextMonth,
        onClick: selectNextMonth,
        className: classes.iconButton
    }), rtl ? leftArrowIcon : rightArrowIcon)), (0, $gIfym.createElement)("div", {
        className: classes.daysHeader
    }, utils.getWeekdays().map(function(day, index) {
        return (0, $gIfym.createElement)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
            key: index // eslint-disable-line react/no-array-index-key
            ,
            variant: "caption",
            className: classes.dayLabel
        }, day);
    })));
};
$df47366baeb07e2a$var$CalendarHeader.displayName = 'CalendarHeader';
$df47366baeb07e2a$var$CalendarHeader.defaultProps = {
    leftArrowIcon: (0, $gIfym.createElement)($df47366baeb07e2a$var$ArrowLeftIcon, null),
    rightArrowIcon: (0, $gIfym.createElement)($df47366baeb07e2a$var$ArrowRightIcon, null),
    disablePrevMonth: false,
    disableNextMonth: false
};
var $df47366baeb07e2a$var$withUtils = function withUtils() {
    return function(Component) {
        var WithUtils = function WithUtils(props) {
            var utils = (0, $30b5b3be1499928f$export$3b14a55fb2447963)();
            return (0, $gIfym.createElement)(Component, (0, $k2R8s.default)({
                utils: utils
            }, props));
        };
        WithUtils.displayName = "WithUtils(".concat(Component.displayName || Component.name, ")");
        return WithUtils;
    };
};
var $df47366baeb07e2a$var$KeyDownListener = function KeyDownListener(_ref) {
    var onKeyDown = _ref.onKeyDown;
    (0, $gIfym.useEffect)(function() {
        window.addEventListener('keydown', onKeyDown);
        return function() {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [
        onKeyDown
    ]);
    return null;
};
var $df47366baeb07e2a$export$e7094788287c5e9b = /*#__PURE__*/ function(_React$Component) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(Calendar, _React$Component);
    function Calendar() {
        var _getPrototypeOf2;
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, Calendar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $f2568f2b7932cb22$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $ff55a031e82added$export$2e2bcd8739ae039)(Calendar)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.state = {
            slideDirection: 'left',
            currentMonth: _this.props.utils.startOfMonth(_this.props.date),
            loadingQueue: 0
        };
        _this.pushToLoadingQueue = function() {
            var loadingQueue = _this.state.loadingQueue + 1;
            _this.setState({
                loadingQueue: loadingQueue
            });
        };
        _this.popFromLoadingQueue = function() {
            var loadingQueue = _this.state.loadingQueue;
            loadingQueue = loadingQueue <= 0 ? 0 : loadingQueue - 1;
            _this.setState({
                loadingQueue: loadingQueue
            });
        };
        _this.handleChangeMonth = function(newMonth, slideDirection) {
            _this.setState({
                currentMonth: newMonth,
                slideDirection: slideDirection
            });
            if (_this.props.onMonthChange) {
                var returnVal = _this.props.onMonthChange(newMonth);
                if (returnVal) {
                    _this.pushToLoadingQueue();
                    returnVal.then(function() {
                        _this.popFromLoadingQueue();
                    });
                }
            }
        };
        _this.validateMinMaxDate = function(day) {
            var _this$props = _this.props, minDate = _this$props.minDate, maxDate = _this$props.maxDate, utils = _this$props.utils, disableFuture = _this$props.disableFuture, disablePast = _this$props.disablePast;
            var now = utils.date();
            return Boolean(disableFuture && utils.isAfterDay(day, now) || disablePast && utils.isBeforeDay(day, now) || minDate && utils.isBeforeDay(day, utils.date(minDate)) || maxDate && utils.isAfterDay(day, utils.date(maxDate)));
        };
        _this.shouldDisablePrevMonth = function() {
            var _this$props2 = _this.props, utils = _this$props2.utils, disablePast = _this$props2.disablePast, minDate = _this$props2.minDate;
            var now = utils.date();
            var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utils.date(minDate)) ? now : utils.date(minDate));
            return !utils.isBefore(firstEnabledMonth, _this.state.currentMonth);
        };
        _this.shouldDisableNextMonth = function() {
            var _this$props3 = _this.props, utils = _this$props3.utils, disableFuture = _this$props3.disableFuture, maxDate = _this$props3.maxDate;
            var now = utils.date();
            var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utils.date(maxDate)) ? now : utils.date(maxDate));
            return !utils.isAfter(lastEnabledMonth, _this.state.currentMonth);
        };
        _this.shouldDisableDate = function(day) {
            var shouldDisableDate = _this.props.shouldDisableDate;
            return _this.validateMinMaxDate(day) || Boolean(shouldDisableDate && shouldDisableDate(day));
        };
        _this.handleDaySelect = function(day) {
            var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var _this$props4 = _this.props, date = _this$props4.date, utils = _this$props4.utils;
            _this.props.onChange(utils.mergeDateAndTime(day, date), isFinish);
        };
        _this.moveToDay = function(day) {
            var utils = _this.props.utils;
            if (day && !_this.shouldDisableDate(day)) {
                if (utils.getMonth(day) !== utils.getMonth(_this.state.currentMonth)) _this.handleChangeMonth(utils.startOfMonth(day), 'left');
                _this.handleDaySelect(day, false);
            }
        };
        _this.handleKeyDown = function(event) {
            var _this$props5 = _this.props, theme = _this$props5.theme, date = _this$props5.date, utils = _this$props5.utils;
            (0, $e5df3b21da25e895$export$43caf9889c228507)(event, {
                ArrowUp: function ArrowUp() {
                    return _this.moveToDay(utils.addDays(date, -7));
                },
                ArrowDown: function ArrowDown() {
                    return _this.moveToDay(utils.addDays(date, 7));
                },
                ArrowLeft: function ArrowLeft() {
                    return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? -1 : 1));
                },
                ArrowRight: function ArrowRight() {
                    return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? 1 : -1));
                }
            });
        };
        _this.renderWeeks = function() {
            var _this$props6 = _this.props, utils = _this$props6.utils, classes = _this$props6.classes;
            var weeks = utils.getWeekArray(_this.state.currentMonth);
            return weeks.map(function(week) {
                return (0, $gIfym.createElement)("div", {
                    key: "week-".concat(week[0].toString()),
                    className: classes.week
                }, _this.renderDays(week));
            });
        };
        _this.renderDays = function(week) {
            var _this$props7 = _this.props, date = _this$props7.date, renderDay = _this$props7.renderDay, utils = _this$props7.utils;
            var now = utils.date();
            var selectedDate = utils.startOfDay(date);
            var currentMonthNumber = utils.getMonth(_this.state.currentMonth);
            return week.map(function(day) {
                var disabled = _this.shouldDisableDate(day);
                var isDayInCurrentMonth = utils.getMonth(day) === currentMonthNumber;
                var dayComponent = (0, $gIfym.createElement)((0, $1233fb0a07ebc3f8$export$2e2bcd8739ae039), {
                    disabled: disabled,
                    current: utils.isSameDay(day, now),
                    hidden: !isDayInCurrentMonth,
                    selected: utils.isSameDay(selectedDate, day)
                }, utils.getDayText(day));
                if (renderDay) dayComponent = renderDay(day, selectedDate, isDayInCurrentMonth, dayComponent);
                return (0, $gIfym.createElement)($df47366baeb07e2a$var$DayWrapper, {
                    value: day,
                    key: day.toString(),
                    disabled: disabled,
                    dayInCurrentMonth: isDayInCurrentMonth,
                    onSelect: _this.handleDaySelect
                }, dayComponent);
            });
        };
        return _this;
    }
    (0, $lU1Um.default)(Calendar, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props8 = this.props, date = _this$props8.date, minDate = _this$props8.minDate, maxDate = _this$props8.maxDate, utils = _this$props8.utils, disablePast = _this$props8.disablePast, disableFuture = _this$props8.disableFuture;
                if (this.shouldDisableDate(date)) {
                    var closestEnabledDate = $df47366baeb07e2a$var$findClosestEnabledDate({
                        date: date,
                        utils: utils,
                        minDate: utils.date(minDate),
                        maxDate: utils.date(maxDate),
                        disablePast: Boolean(disablePast),
                        disableFuture: Boolean(disableFuture),
                        shouldDisableDate: this.shouldDisableDate
                    });
                    this.handleDaySelect(closestEnabledDate, false);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$state = this.state, currentMonth = _this$state.currentMonth, slideDirection = _this$state.slideDirection;
                var _this$props9 = this.props, classes = _this$props9.classes, allowKeyboardControl = _this$props9.allowKeyboardControl, leftArrowButtonProps = _this$props9.leftArrowButtonProps, leftArrowIcon = _this$props9.leftArrowIcon, rightArrowButtonProps = _this$props9.rightArrowButtonProps, rightArrowIcon = _this$props9.rightArrowIcon, loadingIndicator = _this$props9.loadingIndicator;
                var loadingElement = loadingIndicator ? loadingIndicator : (0, $gIfym.createElement)((0, $ff3a7ab0b65b1eb6$export$2e2bcd8739ae039), null);
                return (0, $gIfym.createElement)((0, $gIfym.Fragment), null, allowKeyboardControl && this.context !== 'static' && (0, $gIfym.createElement)($df47366baeb07e2a$var$KeyDownListener, {
                    onKeyDown: this.handleKeyDown
                }), (0, $gIfym.createElement)($df47366baeb07e2a$var$CalendarHeader, {
                    currentMonth: currentMonth,
                    slideDirection: slideDirection,
                    onMonthChange: this.handleChangeMonth,
                    leftArrowIcon: leftArrowIcon,
                    leftArrowButtonProps: leftArrowButtonProps,
                    rightArrowIcon: rightArrowIcon,
                    rightArrowButtonProps: rightArrowButtonProps,
                    disablePrevMonth: this.shouldDisablePrevMonth(),
                    disableNextMonth: this.shouldDisableNextMonth()
                }), (0, $gIfym.createElement)($df47366baeb07e2a$var$SlideTransition, {
                    slideDirection: slideDirection,
                    transKey: currentMonth.toString(),
                    className: classes.transitionContainer
                }, (0, $gIfym.createElement)((0, $gIfym.Fragment), null, this.state.loadingQueue > 0 && (0, $gIfym.createElement)("div", {
                    className: classes.progressContainer
                }, loadingElement) || (0, $gIfym.createElement)("div", null, this.renderWeeks()))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, state) {
                var utils = nextProps.utils, nextDate = nextProps.date;
                if (!utils.isEqual(nextDate, state.lastDate)) {
                    var nextMonth = utils.getMonth(nextDate);
                    var lastDate = state.lastDate || nextDate;
                    var lastMonth = utils.getMonth(lastDate);
                    return {
                        lastDate: nextDate,
                        currentMonth: nextProps.utils.startOfMonth(nextDate),
                        // prettier-ignore
                        slideDirection: nextMonth === lastMonth ? state.slideDirection : utils.isAfterDay(nextDate, lastDate) ? 'left' : 'right'
                    };
                }
                return null;
            }
        }
    ]);
    return Calendar;
}((0, $gIfym.Component));
$df47366baeb07e2a$export$e7094788287c5e9b.contextType = (0, $e5df3b21da25e895$export$e7c866399fa523f5);
$df47366baeb07e2a$export$e7094788287c5e9b.defaultProps = {
    minDate: new Date('1900-01-01'),
    maxDate: new Date('2100-01-01'),
    disablePast: false,
    disableFuture: false,
    allowKeyboardControl: true
};
var $df47366baeb07e2a$export$2408f22a0fab9ae5 = function styles(theme) {
    return {
        transitionContainer: {
            minHeight: 216,
            marginTop: theme.spacing(1.5)
        },
        progressContainer: {
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        week: {
            display: 'flex',
            justifyContent: 'center'
        }
    };
};
var $df47366baeb07e2a$export$407448d2b89b1813 = (0, $82OGZ.default)($df47366baeb07e2a$export$2408f22a0fab9ae5, {
    name: 'MuiPickersCalendar',
    withTheme: true
})($df47366baeb07e2a$var$withUtils()($df47366baeb07e2a$export$e7094788287c5e9b));



var $3KNdx = parcelRequire("3KNdx");

var $gIfym = parcelRequire("gIfym");



var $ba4yE = parcelRequire("ba4yE");

var $k2R8s = parcelRequire("k2R8s");



parcelRequire("lU1Um");




var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");


var $lU1Um = parcelRequire("lU1Um");



var $4ccc4bfaf9c5eb4b$var$ClockType;
(function(ClockType) {
    ClockType["HOURS"] = "hours";
    ClockType["MINUTES"] = "minutes";
    ClockType["SECONDS"] = "seconds";
})($4ccc4bfaf9c5eb4b$var$ClockType || ($4ccc4bfaf9c5eb4b$var$ClockType = {}));
var $4ccc4bfaf9c5eb4b$export$8b22cf2602fb60ce = $4ccc4bfaf9c5eb4b$var$ClockType;
var $4ccc4bfaf9c5eb4b$var$ClockPointer = /*#__PURE__*/ function(_React$Component) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(ClockPointer, _React$Component);
    function ClockPointer() {
        var _getPrototypeOf2;
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, ClockPointer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $f2568f2b7932cb22$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $ff55a031e82added$export$2e2bcd8739ae039)(ClockPointer)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.state = {
            toAnimateTransform: false,
            previousType: undefined
        };
        _this.getAngleStyle = function() {
            var _this$props = _this.props, value = _this$props.value, isInner = _this$props.isInner, type = _this$props.type;
            var max = type === $4ccc4bfaf9c5eb4b$export$8b22cf2602fb60ce.HOURS ? 12 : 60;
            var angle = 360 / max * value;
            if (type === $4ccc4bfaf9c5eb4b$export$8b22cf2602fb60ce.HOURS && value > 12) angle -= 360; // round up angle to max 360 degrees
            return {
                height: isInner ? '26%' : '40%',
                transform: "rotateZ(".concat(angle, "deg)")
            };
        };
        return _this;
    }
    (0, $lU1Um.default)(ClockPointer, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, classes = _this$props2.classes, hasSelected = _this$props2.hasSelected;
                return (0, $gIfym.createElement)("div", {
                    style: this.getAngleStyle(),
                    className: (0, $ba4yE.default)(classes.pointer, this.state.toAnimateTransform && classes.animateTransform)
                }, (0, $gIfym.createElement)("div", {
                    className: (0, $ba4yE.default)(classes.thumb, hasSelected && classes.noPoint)
                }));
            }
        }
    ]);
    return ClockPointer;
}((0, $gIfym.Component));
$4ccc4bfaf9c5eb4b$var$ClockPointer.getDerivedStateFromProps = function(nextProps, state) {
    if (nextProps.type !== state.previousType) return {
        toAnimateTransform: true,
        previousType: nextProps.type
    };
    return {
        toAnimateTransform: false,
        previousType: nextProps.type
    };
};
var $4ccc4bfaf9c5eb4b$var$styles = function styles(theme) {
    return (0, $c72980417caacb7d$export$2e2bcd8739ae039)({
        pointer: {
            width: 2,
            backgroundColor: theme.palette.primary.main,
            position: 'absolute',
            left: 'calc(50% - 1px)',
            bottom: '50%',
            transformOrigin: 'center bottom 0px'
        },
        animateTransform: {
            transition: theme.transitions.create([
                'transform',
                'height'
            ])
        },
        thumb: {
            width: 4,
            height: 4,
            backgroundColor: theme.palette.primary.contrastText,
            borderRadius: '100%',
            position: 'absolute',
            top: -21,
            left: -15,
            border: "14px solid ".concat(theme.palette.primary.main),
            boxSizing: 'content-box'
        },
        noPoint: {
            backgroundColor: theme.palette.primary.main
        }
    });
};
var $4ccc4bfaf9c5eb4b$var$ClockPointer$1 = (0, $82OGZ.default)($4ccc4bfaf9c5eb4b$var$styles, {
    name: 'MuiPickersClockPointer'
})($4ccc4bfaf9c5eb4b$var$ClockPointer);
var $4ccc4bfaf9c5eb4b$var$center = {
    x: 130,
    y: 130
};
var $4ccc4bfaf9c5eb4b$var$basePoint = {
    x: $4ccc4bfaf9c5eb4b$var$center.x,
    y: 0
};
var $4ccc4bfaf9c5eb4b$var$cx = $4ccc4bfaf9c5eb4b$var$basePoint.x - $4ccc4bfaf9c5eb4b$var$center.x;
var $4ccc4bfaf9c5eb4b$var$cy = $4ccc4bfaf9c5eb4b$var$basePoint.y - $4ccc4bfaf9c5eb4b$var$center.y;
var $4ccc4bfaf9c5eb4b$var$rad2deg = function rad2deg(rad) {
    return rad * 57.29577951308232;
};
var $4ccc4bfaf9c5eb4b$var$getAngleValue = function getAngleValue(step, offsetX, offsetY) {
    var x = offsetX - $4ccc4bfaf9c5eb4b$var$center.x;
    var y = offsetY - $4ccc4bfaf9c5eb4b$var$center.y;
    var atan = Math.atan2($4ccc4bfaf9c5eb4b$var$cx, $4ccc4bfaf9c5eb4b$var$cy) - Math.atan2(x, y);
    var deg = $4ccc4bfaf9c5eb4b$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    var value = Math.floor(deg / step) || 0;
    var delta = Math.pow(x, 2) + Math.pow(y, 2);
    var distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
var $4ccc4bfaf9c5eb4b$var$getHours = function getHours(offsetX, offsetY, ampm) {
    var _getAngleValue = $4ccc4bfaf9c5eb4b$var$getAngleValue(30, offsetX, offsetY), value = _getAngleValue.value, distance = _getAngleValue.distance;
    value = value || 12;
    if (!ampm) {
        if (distance < 90) {
            value += 12;
            value %= 24;
        }
    } else value %= 12;
    return value;
};
var $4ccc4bfaf9c5eb4b$var$getMinutes = function getMinutes(offsetX, offsetY) {
    var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var angleStep = step * 6;
    var _getAngleValue2 = $4ccc4bfaf9c5eb4b$var$getAngleValue(angleStep, offsetX, offsetY), value = _getAngleValue2.value;
    value = value * step % 60;
    return value;
};
var $4ccc4bfaf9c5eb4b$export$39b482c5e57630a8 = function getMeridiem(date, utils) {
    return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
var $4ccc4bfaf9c5eb4b$export$db3b6bfb95261072 = function convertToMeridiem(time, meridiem, ampm, utils) {
    if (ampm) {
        var currentMeridiem = utils.getHours(time) >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) {
            var hours = meridiem === 'am' ? utils.getHours(time) - 12 : utils.getHours(time) + 12;
            return utils.setHours(time, hours);
        }
    }
    return time;
};
var $4ccc4bfaf9c5eb4b$export$e7094788287c5e9b = /*#__PURE__*/ function(_React$Component) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(Clock, _React$Component);
    function Clock() {
        var _getPrototypeOf2;
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, Clock);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $f2568f2b7932cb22$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $ff55a031e82added$export$2e2bcd8739ae039)(Clock)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.isMoving = false;
        _this.handleTouchMove = function(e) {
            _this.isMoving = true;
            _this.setTime(e);
        };
        _this.handleTouchEnd = function(e) {
            if (_this.isMoving) {
                _this.setTime(e, true);
                _this.isMoving = false;
            }
        };
        _this.handleMove = function(e) {
            e.preventDefault();
            e.stopPropagation(); // MouseEvent.which is deprecated, but MouseEvent.buttons is not supported in Safari
            var isButtonPressed = typeof e.buttons === 'undefined' ? e.nativeEvent.which === 1 : e.buttons === 1;
            if (isButtonPressed) _this.setTime(e.nativeEvent, false);
        };
        _this.handleMouseUp = function(e) {
            if (_this.isMoving) _this.isMoving = false;
            _this.setTime(e.nativeEvent, true);
        };
        _this.hasSelected = function() {
            var _this$props = _this.props, type = _this$props.type, value = _this$props.value;
            if (type === $4ccc4bfaf9c5eb4b$export$8b22cf2602fb60ce.HOURS) return true;
            return value % 5 === 0;
        };
        return _this;
    }
    (0, $lU1Um.default)(Clock, [
        {
            key: "setTime",
            value: function setTime(e) {
                var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var offsetX = e.offsetX, offsetY = e.offsetY;
                if (typeof offsetX === 'undefined') {
                    var rect = e.target.getBoundingClientRect();
                    offsetX = e.changedTouches[0].clientX - rect.left;
                    offsetY = e.changedTouches[0].clientY - rect.top;
                }
                var value = this.props.type === $4ccc4bfaf9c5eb4b$export$8b22cf2602fb60ce.SECONDS || this.props.type === $4ccc4bfaf9c5eb4b$export$8b22cf2602fb60ce.MINUTES ? $4ccc4bfaf9c5eb4b$var$getMinutes(offsetX, offsetY, this.props.minutesStep) : $4ccc4bfaf9c5eb4b$var$getHours(offsetX, offsetY, Boolean(this.props.ampm));
                this.props.onChange(value, isFinish);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, classes = _this$props2.classes, value = _this$props2.value, children = _this$props2.children, type = _this$props2.type, ampm = _this$props2.ampm;
                var isPointerInner = !ampm && type === $4ccc4bfaf9c5eb4b$export$8b22cf2602fb60ce.HOURS && (value < 1 || value > 12);
                return (0, $gIfym.createElement)("div", {
                    className: classes.container
                }, (0, $gIfym.createElement)("div", {
                    className: classes.clock
                }, (0, $gIfym.createElement)("div", {
                    role: "menu",
                    tabIndex: -1,
                    className: classes.squareMask,
                    onTouchMove: this.handleTouchMove,
                    onTouchEnd: this.handleTouchEnd,
                    onMouseUp: this.handleMouseUp,
                    onMouseMove: this.handleMove
                }), (0, $gIfym.createElement)("div", {
                    className: classes.pin
                }), (0, $gIfym.createElement)($4ccc4bfaf9c5eb4b$var$ClockPointer$1, {
                    type: type,
                    value: value,
                    isInner: isPointerInner,
                    hasSelected: this.hasSelected()
                }), children));
            }
        }
    ]);
    return Clock;
}((0, $gIfym.Component));
$4ccc4bfaf9c5eb4b$export$e7094788287c5e9b.defaultProps = {
    ampm: false,
    minutesStep: 1
};
var $4ccc4bfaf9c5eb4b$export$2408f22a0fab9ae5 = function styles(theme) {
    return (0, $c72980417caacb7d$export$2e2bcd8739ae039)({
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end',
            margin: "".concat(theme.spacing(2), "px 0 ").concat(theme.spacing(1), "px")
        },
        clock: {
            backgroundColor: 'rgba(0,0,0,.07)',
            borderRadius: '50%',
            height: 260,
            width: 260,
            position: 'relative',
            pointerEvents: 'none'
        },
        squareMask: {
            width: '100%',
            height: '100%',
            position: 'absolute',
            pointerEvents: 'auto',
            outline: 'none',
            touchActions: 'none',
            userSelect: 'none',
            '&:active': {
                cursor: 'move'
            }
        },
        pin: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.main,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        }
    });
};
var $4ccc4bfaf9c5eb4b$export$407448d2b89b1813 = (0, $82OGZ.default)($4ccc4bfaf9c5eb4b$export$2408f22a0fab9ae5, {
    name: 'MuiPickersClock'
})($4ccc4bfaf9c5eb4b$export$e7094788287c5e9b);


var $e6d2ac9b37bf5092$var$positions = {
    0: [
        0,
        40
    ],
    1: [
        55,
        19.6
    ],
    2: [
        94.4,
        59.5
    ],
    3: [
        109,
        114
    ],
    4: [
        94.4,
        168.5
    ],
    5: [
        54.5,
        208.4
    ],
    6: [
        0,
        223
    ],
    7: [
        -54.5,
        208.4
    ],
    8: [
        -94.4,
        168.5
    ],
    9: [
        -109,
        114
    ],
    10: [
        -94.4,
        59.5
    ],
    11: [
        -54.5,
        19.6
    ],
    12: [
        0,
        5
    ],
    13: [
        36.9,
        49.9
    ],
    14: [
        64,
        77
    ],
    15: [
        74,
        114
    ],
    16: [
        64,
        151
    ],
    17: [
        37,
        178
    ],
    18: [
        0,
        188
    ],
    19: [
        -37,
        178
    ],
    20: [
        -64,
        151
    ],
    21: [
        -74,
        114
    ],
    22: [
        -64,
        77
    ],
    23: [
        -37,
        50
    ]
};
var $e6d2ac9b37bf5092$var$useStyles = (0, $c67a157fd78dc604$export$2e2bcd8739ae039)(function(theme) {
    var size = theme.spacing(4);
    return {
        clockNumber: {
            width: size,
            height: 32,
            userSelect: 'none',
            position: 'absolute',
            left: "calc((100% - ".concat(typeof size === 'number' ? "".concat(size, "px") : size, ") / 2)"),
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '50%',
            color: theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.text.hint
        },
        clockNumberSelected: {
            color: theme.palette.primary.contrastText
        }
    };
}, {
    name: 'MuiPickersClockNumber'
});
var $e6d2ac9b37bf5092$var$ClockNumber = function ClockNumber(_ref) {
    var selected = _ref.selected, label = _ref.label, index = _ref.index, isInner = _ref.isInner;
    var classes = $e6d2ac9b37bf5092$var$useStyles();
    var className = (0, $ba4yE.default)(classes.clockNumber, selected && classes.clockNumberSelected);
    var transformStyle = (0, $gIfym.useMemo)(function() {
        var position = $e6d2ac9b37bf5092$var$positions[index];
        return {
            transform: "translate(".concat(position[0], "px, ").concat(position[1], "px")
        };
    }, [
        index
    ]);
    return (0, $gIfym.createElement)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
        component: "span",
        className: className,
        variant: isInner ? 'body2' : 'body1',
        style: transformStyle,
        children: label
    });
};
var $e6d2ac9b37bf5092$var$getHourNumbers = function getHourNumbers(_ref) {
    var ampm = _ref.ampm, utils = _ref.utils, date = _ref.date;
    var currentHours = utils.getHours(date);
    var hourNumbers = [];
    var startHour = ampm ? 1 : 0;
    var endHour = ampm ? 12 : 23;
    var isSelected = function isSelected(hour) {
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(var hour = startHour; hour <= endHour; hour += 1){
        var label = hour.toString();
        if (hour === 0) label = '00';
        var props = {
            index: hour,
            label: utils.formatNumber(label),
            selected: isSelected(hour),
            isInner: !ampm && (hour === 0 || hour > 12)
        };
        hourNumbers.push((0, $gIfym.createElement)($e6d2ac9b37bf5092$var$ClockNumber, (0, $k2R8s.default)({
            key: hour
        }, props)));
    }
    return hourNumbers;
};
var $e6d2ac9b37bf5092$var$getMinutesNumbers = function getMinutesNumbers(_ref2) {
    var value = _ref2.value, utils = _ref2.utils;
    var f = utils.formatNumber;
    return [
        (0, $gIfym.createElement)($e6d2ac9b37bf5092$var$ClockNumber, {
            label: f('00'),
            selected: value === 0,
            index: 12,
            key: 12
        }),
        (0, $gIfym.createElement)($e6d2ac9b37bf5092$var$ClockNumber, {
            label: f('05'),
            selected: value === 5,
            index: 1,
            key: 1
        }),
        (0, $gIfym.createElement)($e6d2ac9b37bf5092$var$ClockNumber, {
            label: f('10'),
            selected: value === 10,
            index: 2,
            key: 2
        }),
        (0, $gIfym.createElement)($e6d2ac9b37bf5092$var$ClockNumber, {
            label: f('15'),
            selected: value === 15,
            index: 3,
            key: 3
        }),
        (0, $gIfym.createElement)($e6d2ac9b37bf5092$var$ClockNumber, {
            label: f('20'),
            selected: value === 20,
            index: 4,
            key: 4
        }),
        (0, $gIfym.createElement)($e6d2ac9b37bf5092$var$ClockNumber, {
            label: f('25'),
            selected: value === 25,
            index: 5,
            key: 5
        }),
        (0, $gIfym.createElement)($e6d2ac9b37bf5092$var$ClockNumber, {
            label: f('30'),
            selected: value === 30,
            index: 6,
            key: 6
        }),
        (0, $gIfym.createElement)($e6d2ac9b37bf5092$var$ClockNumber, {
            label: f('35'),
            selected: value === 35,
            index: 7,
            key: 7
        }),
        (0, $gIfym.createElement)($e6d2ac9b37bf5092$var$ClockNumber, {
            label: f('40'),
            selected: value === 40,
            index: 8,
            key: 8
        }),
        (0, $gIfym.createElement)($e6d2ac9b37bf5092$var$ClockNumber, {
            label: f('45'),
            selected: value === 45,
            index: 9,
            key: 9
        }),
        (0, $gIfym.createElement)($e6d2ac9b37bf5092$var$ClockNumber, {
            label: f('50'),
            selected: value === 50,
            index: 10,
            key: 10
        }),
        (0, $gIfym.createElement)($e6d2ac9b37bf5092$var$ClockNumber, {
            label: f('55'),
            selected: value === 55,
            index: 11,
            key: 11
        })
    ];
};
var $e6d2ac9b37bf5092$export$e6ca67116c8adcad = function ClockView(_ref) {
    var type = _ref.type, onHourChange = _ref.onHourChange, onMinutesChange = _ref.onMinutesChange, onSecondsChange = _ref.onSecondsChange, ampm = _ref.ampm, date = _ref.date, minutesStep = _ref.minutesStep;
    var utils = (0, $30b5b3be1499928f$export$3b14a55fb2447963)();
    var viewProps = (0, $gIfym.useMemo)(function() {
        switch(type){
            case (0, $4ccc4bfaf9c5eb4b$export$8b22cf2602fb60ce).HOURS:
                return {
                    value: utils.getHours(date),
                    children: $e6d2ac9b37bf5092$var$getHourNumbers({
                        date: date,
                        utils: utils,
                        ampm: Boolean(ampm)
                    }),
                    onChange: function onChange(value, isFinish) {
                        var currentMeridiem = (0, $4ccc4bfaf9c5eb4b$export$39b482c5e57630a8)(date, utils);
                        var updatedTimeWithMeridiem = (0, $4ccc4bfaf9c5eb4b$export$db3b6bfb95261072)(utils.setHours(date, value), currentMeridiem, Boolean(ampm), utils);
                        onHourChange(updatedTimeWithMeridiem, isFinish);
                    }
                };
            case (0, $4ccc4bfaf9c5eb4b$export$8b22cf2602fb60ce).MINUTES:
                var minutesValue = utils.getMinutes(date);
                return {
                    value: minutesValue,
                    children: $e6d2ac9b37bf5092$var$getMinutesNumbers({
                        value: minutesValue,
                        utils: utils
                    }),
                    onChange: function onChange(value, isFinish) {
                        var updatedTime = utils.setMinutes(date, value);
                        onMinutesChange(updatedTime, isFinish);
                    }
                };
            case (0, $4ccc4bfaf9c5eb4b$export$8b22cf2602fb60ce).SECONDS:
                var secondsValue = utils.getSeconds(date);
                return {
                    value: secondsValue,
                    children: $e6d2ac9b37bf5092$var$getMinutesNumbers({
                        value: secondsValue,
                        utils: utils
                    }),
                    onChange: function onChange(value, isFinish) {
                        var updatedTime = utils.setSeconds(date, value);
                        onSecondsChange(updatedTime, isFinish);
                    }
                };
            default:
                throw new Error('You must provide the type for TimePickerView');
        }
    }, [
        ampm,
        date,
        onHourChange,
        onMinutesChange,
        onSecondsChange,
        type,
        utils
    ]);
    return (0, $gIfym.createElement)((0, $4ccc4bfaf9c5eb4b$export$407448d2b89b1813), (0, $k2R8s.default)({
        type: type,
        ampm: ampm,
        minutesStep: minutesStep
    }, viewProps));
};
$e6d2ac9b37bf5092$export$e6ca67116c8adcad.displayName = 'TimePickerView';
$e6d2ac9b37bf5092$export$e6ca67116c8adcad.defaultProps = {
    ampm: true,
    minutesStep: 1
};
var $e6d2ac9b37bf5092$var$ClockView$1 = (0, $gIfym.memo)($e6d2ac9b37bf5092$export$e6ca67116c8adcad);
var $e6d2ac9b37bf5092$export$2e2bcd8739ae039 = $e6d2ac9b37bf5092$var$ClockView$1;


function $d4a721711d8d679d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d4a721711d8d679d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d4a721711d8d679d$var$ownKeys(source, true).forEach(function(key) {
            (0, $8k2Uc.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d4a721711d8d679d$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $d4a721711d8d679d$var$date = (0, $h1Rs9.oneOfType)([
    (0, $h1Rs9.object),
    (0, $h1Rs9.string),
    (0, $h1Rs9.number),
    (0, $h1Rs9.instanceOf)(Date)
]);
var $d4a721711d8d679d$var$datePickerView = (0, $h1Rs9.oneOf)([
    'year',
    'month',
    'day'
]);
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */ var $d4a721711d8d679d$export$625550452a3fa3ec = {
    ampm: true,
    invalidDateMessage: 'Invalid Time Format'
};
var $d4a721711d8d679d$export$4368d992c4eafac0 = {
    minDate: new Date('1900-01-01'),
    maxDate: new Date('2100-01-01'),
    invalidDateMessage: 'Invalid Date Format',
    minDateMessage: 'Date should not be before minimal date',
    maxDateMessage: 'Date should not be after maximal date',
    allowKeyboardControl: true
};
var $d4a721711d8d679d$export$407448d2b89b1813 = $d4a721711d8d679d$var$_objectSpread({}, $d4a721711d8d679d$export$625550452a3fa3ec, {}, $d4a721711d8d679d$export$4368d992c4eafac0, {
    showTabs: true
});
function $d4a721711d8d679d$var$useViews(views, openTo, onChange) {
    var _React$useState = (0, $gIfym.useState)(openTo && (0, $e5df3b21da25e895$export$407448d2b89b1813)(views, openTo) ? openTo : views[0]), _React$useState2 = (0, $3KNdx.default)(_React$useState, 2), openView = _React$useState2[0], setOpenView = _React$useState2[1];
    var handleChangeAndOpenNext = (0, $gIfym.useCallback)(function(date, isFinish) {
        var nextViewToOpen = views[views.indexOf(openView) + 1];
        if (isFinish && nextViewToOpen) {
            // do not close picker if needs to show next view
            onChange(date, false);
            setOpenView(nextViewToOpen);
            return;
        }
        onChange(date, Boolean(isFinish));
    }, [
        onChange,
        openView,
        views
    ]);
    return {
        handleChangeAndOpenNext: handleChangeAndOpenNext,
        openView: openView,
        setOpenView: setOpenView
    };
}
var $d4a721711d8d679d$var$useStyles = (0, $c67a157fd78dc604$export$2e2bcd8739ae039)(function(theme) {
    return {
        root: {
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            outline: 'none',
            '&:focus': {
                color: theme.palette.primary.main,
                fontWeight: theme.typography.fontWeightMedium
            }
        },
        yearSelected: {
            margin: '10px 0',
            fontWeight: theme.typography.fontWeightMedium
        },
        yearDisabled: {
            pointerEvents: 'none',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersYear'
});
var $d4a721711d8d679d$var$Year = function Year(_ref) {
    var onSelect = _ref.onSelect, forwardedRef = _ref.forwardedRef, value = _ref.value, selected = _ref.selected, disabled = _ref.disabled, children = _ref.children, other = (0, $f6Qba.default)(_ref, [
        "onSelect",
        "forwardedRef",
        "value",
        "selected",
        "disabled",
        "children"
    ]);
    var classes = $d4a721711d8d679d$var$useStyles();
    var handleClick = (0, $gIfym.useCallback)(function() {
        return onSelect(value);
    }, [
        onSelect,
        value
    ]);
    return (0, $gIfym.createElement)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        role: "button",
        component: "div",
        tabIndex: disabled ? -1 : 0,
        onClick: handleClick,
        onKeyPress: handleClick,
        color: selected ? 'primary' : undefined,
        variant: selected ? 'h5' : 'subtitle1',
        children: children,
        ref: forwardedRef,
        className: (0, $ba4yE.default)(classes.root, selected && classes.yearSelected, disabled && classes.yearDisabled)
    }, other));
};
$d4a721711d8d679d$var$Year.displayName = 'Year';
var $d4a721711d8d679d$var$Year$1 = (0, $gIfym.forwardRef)(function(props, ref) {
    return (0, $gIfym.createElement)($d4a721711d8d679d$var$Year, (0, $k2R8s.default)({}, props, {
        forwardedRef: ref
    }));
});
var $d4a721711d8d679d$var$useStyles$1 = (0, $c67a157fd78dc604$export$2e2bcd8739ae039)({
    container: {
        height: 300,
        overflowY: 'auto'
    }
}, {
    name: 'MuiPickersYearSelection'
});
var $d4a721711d8d679d$var$YearSelection = function YearSelection(_ref) {
    var date = _ref.date, onChange = _ref.onChange, onYearChange = _ref.onYearChange, minDate = _ref.minDate, maxDate = _ref.maxDate, disablePast = _ref.disablePast, disableFuture = _ref.disableFuture, animateYearScrolling = _ref.animateYearScrolling;
    var utils = (0, $30b5b3be1499928f$export$3b14a55fb2447963)();
    var classes = $d4a721711d8d679d$var$useStyles$1();
    var currentVariant = (0, $gIfym.useContext)((0, $e5df3b21da25e895$export$e7c866399fa523f5));
    var selectedYearRef = (0, $gIfym.useRef)(null);
    (0, $gIfym.useEffect)(function() {
        if (selectedYearRef.current && selectedYearRef.current.scrollIntoView) try {
            selectedYearRef.current.scrollIntoView({
                block: currentVariant === 'static' ? 'nearest' : 'center',
                behavior: animateYearScrolling ? 'smooth' : 'auto'
            });
        } catch (e) {
            // call without arguments in case when scrollIntoView works improperly (e.g. Firefox 52-57)
            selectedYearRef.current.scrollIntoView();
        }
    }, []); // eslint-disable-line
    var currentYear = utils.getYear(date);
    var onYearSelect = (0, $gIfym.useCallback)(function(year) {
        var newDate = utils.setYear(date, year);
        if (onYearChange) onYearChange(newDate);
        onChange(newDate, true);
    }, [
        date,
        onChange,
        onYearChange,
        utils
    ]);
    return (0, $gIfym.createElement)("div", {
        className: classes.container
    }, utils.getYearRange(minDate, maxDate).map(function(year) {
        var yearNumber = utils.getYear(year);
        var selected = yearNumber === currentYear;
        return (0, $gIfym.createElement)($d4a721711d8d679d$var$Year$1, {
            key: utils.getYearText(year),
            selected: selected,
            value: yearNumber,
            onSelect: onYearSelect,
            ref: selected ? selectedYearRef : undefined,
            disabled: Boolean(disablePast && utils.isBeforeYear(year, utils.date()) || disableFuture && utils.isAfterYear(year, utils.date()))
        }, utils.getYearText(year));
    }));
};
var $d4a721711d8d679d$var$useStyles$2 = (0, $c67a157fd78dc604$export$2e2bcd8739ae039)(function(theme) {
    return {
        root: {
            flex: '1 0 33.33%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            outline: 'none',
            height: 75,
            transition: theme.transitions.create('font-size', {
                duration: '100ms'
            }),
            '&:focus': {
                color: theme.palette.primary.main,
                fontWeight: theme.typography.fontWeightMedium
            }
        },
        monthSelected: {
            color: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium
        },
        monthDisabled: {
            pointerEvents: 'none',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersMonth'
});
var $d4a721711d8d679d$var$Month = function Month(_ref) {
    var selected = _ref.selected, onSelect = _ref.onSelect, disabled = _ref.disabled, value = _ref.value, children = _ref.children, other = (0, $f6Qba.default)(_ref, [
        "selected",
        "onSelect",
        "disabled",
        "value",
        "children"
    ]);
    var classes = $d4a721711d8d679d$var$useStyles$2();
    var handleSelection = (0, $gIfym.useCallback)(function() {
        onSelect(value);
    }, [
        onSelect,
        value
    ]);
    return (0, $gIfym.createElement)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        role: "button",
        component: "div",
        className: (0, $ba4yE.default)(classes.root, selected && classes.monthSelected, disabled && classes.monthDisabled),
        tabIndex: disabled ? -1 : 0,
        onClick: handleSelection,
        onKeyPress: handleSelection,
        color: selected ? 'primary' : undefined,
        variant: selected ? 'h5' : 'subtitle1',
        children: children
    }, other));
};
$d4a721711d8d679d$var$Month.displayName = 'Month';
var $d4a721711d8d679d$var$useStyles$3 = (0, $c67a157fd78dc604$export$2e2bcd8739ae039)({
    container: {
        width: 310,
        display: 'flex',
        flexWrap: 'wrap',
        alignContent: 'stretch'
    }
}, {
    name: 'MuiPickersMonthSelection'
});
var $d4a721711d8d679d$var$MonthSelection = function MonthSelection(_ref) {
    var disablePast = _ref.disablePast, disableFuture = _ref.disableFuture, minDate = _ref.minDate, maxDate = _ref.maxDate, date = _ref.date, onMonthChange = _ref.onMonthChange, onChange = _ref.onChange;
    var utils = (0, $30b5b3be1499928f$export$3b14a55fb2447963)();
    var classes = $d4a721711d8d679d$var$useStyles$3();
    var currentMonth = utils.getMonth(date);
    var shouldDisableMonth = function shouldDisableMonth(month) {
        var now = utils.date();
        var utilMinDate = utils.date(minDate);
        var utilMaxDate = utils.date(maxDate);
        var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utilMinDate) ? now : utilMinDate);
        var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utilMaxDate) ? now : utilMaxDate);
        var isBeforeFirstEnabled = utils.isBefore(month, firstEnabledMonth);
        var isAfterLastEnabled = utils.isAfter(month, lastEnabledMonth);
        return isBeforeFirstEnabled || isAfterLastEnabled;
    };
    var onMonthSelect = (0, $gIfym.useCallback)(function(month) {
        var newDate = utils.setMonth(date, month);
        onChange(newDate, true);
        if (onMonthChange) onMonthChange(newDate);
    }, [
        date,
        onChange,
        onMonthChange,
        utils
    ]);
    return (0, $gIfym.createElement)("div", {
        className: classes.container
    }, utils.getMonthArray(date).map(function(month) {
        var monthNumber = utils.getMonth(month);
        var monthText = utils.format(month, 'MMM');
        return (0, $gIfym.createElement)($d4a721711d8d679d$var$Month, {
            key: monthText,
            value: monthNumber,
            selected: monthNumber === currentMonth,
            onSelect: onMonthSelect,
            disabled: shouldDisableMonth(month)
        }, monthText);
    }));
};
var $d4a721711d8d679d$var$getOrientation = function getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
     // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
};
function $d4a721711d8d679d$var$useIsLandscape(customOrientation) {
    var _React$useState = (0, $gIfym.useState)($d4a721711d8d679d$var$getOrientation()), _React$useState2 = (0, $3KNdx.default)(_React$useState, 2), orientation = _React$useState2[0], setOrientation = _React$useState2[1];
    var eventHandler = (0, $gIfym.useCallback)(function() {
        return setOrientation($d4a721711d8d679d$var$getOrientation());
    }, []);
    (0, $e5df3b21da25e895$export$3b14a55fb2447963)(function() {
        window.addEventListener('orientationchange', eventHandler);
        return function() {
            return window.removeEventListener('orientationchange', eventHandler);
        };
    }, [
        eventHandler
    ]);
    var orientationToUse = customOrientation || orientation;
    return orientationToUse === 'landscape';
}
function $d4a721711d8d679d$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d4a721711d8d679d$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d4a721711d8d679d$var$ownKeys$1(source, true).forEach(function(key) {
            (0, $8k2Uc.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d4a721711d8d679d$var$ownKeys$1(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $d4a721711d8d679d$var$viewsMap = {
    year: $d4a721711d8d679d$var$YearSelection,
    month: $d4a721711d8d679d$var$MonthSelection,
    date: (0, $df47366baeb07e2a$export$407448d2b89b1813),
    hours: (0, $e6d2ac9b37bf5092$export$e6ca67116c8adcad),
    minutes: (0, $e6d2ac9b37bf5092$export$e6ca67116c8adcad),
    seconds: (0, $e6d2ac9b37bf5092$export$e6ca67116c8adcad)
};
var $d4a721711d8d679d$var$useStyles$4 = (0, $c67a157fd78dc604$export$2e2bcd8739ae039)({
    container: {
        display: 'flex',
        flexDirection: 'column'
    },
    containerLandscape: {
        flexDirection: 'row'
    },
    pickerView: {
        overflowX: 'hidden',
        minHeight: (0, $e5df3b21da25e895$export$8b22cf2602fb60ce),
        minWidth: (0, $e5df3b21da25e895$export$96f57966bedc81b4),
        maxWidth: (0, $e5df3b21da25e895$export$db3b6bfb95261072),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    pickerViewLandscape: {
        padding: '0 8px'
    }
}, {
    name: 'MuiPickersBasePicker'
});
var $d4a721711d8d679d$export$56c0d5a1e737357d = function Picker(_ref) {
    var date = _ref.date, views = _ref.views, disableToolbar = _ref.disableToolbar, onChange = _ref.onChange, openTo = _ref.openTo, unparsedMinDate = _ref.minDate, unparsedMaxDate = _ref.maxDate, ToolbarComponent = _ref.ToolbarComponent, orientation = _ref.orientation, rest = (0, $f6Qba.default)(_ref, [
        "date",
        "views",
        "disableToolbar",
        "onChange",
        "openTo",
        "minDate",
        "maxDate",
        "ToolbarComponent",
        "orientation"
    ]);
    var utils = (0, $30b5b3be1499928f$export$3b14a55fb2447963)();
    var classes = $d4a721711d8d679d$var$useStyles$4();
    var isLandscape = $d4a721711d8d679d$var$useIsLandscape(orientation);
    var _useViews = $d4a721711d8d679d$var$useViews(views, openTo, onChange), openView = _useViews.openView, setOpenView = _useViews.setOpenView, handleChangeAndOpenNext = _useViews.handleChangeAndOpenNext;
    var minDate = (0, $gIfym.useMemo)(function() {
        return utils.date(unparsedMinDate);
    }, [
        unparsedMinDate,
        utils
    ]);
    var maxDate = (0, $gIfym.useMemo)(function() {
        return utils.date(unparsedMaxDate);
    }, [
        unparsedMaxDate,
        utils
    ]);
    return (0, $gIfym.createElement)("div", {
        className: (0, $ba4yE.default)(classes.container, isLandscape && classes.containerLandscape)
    }, !disableToolbar && (0, $gIfym.createElement)(ToolbarComponent, (0, $k2R8s.default)({}, rest, {
        views: views,
        isLandscape: isLandscape,
        date: date,
        onChange: onChange,
        setOpenView: setOpenView,
        openView: openView
    })), (0, $gIfym.createElement)("div", {
        className: (0, $ba4yE.default)(classes.pickerView, isLandscape && classes.pickerViewLandscape)
    }, openView === 'year' && (0, $gIfym.createElement)($d4a721711d8d679d$var$YearSelection, (0, $k2R8s.default)({}, rest, {
        date: date,
        onChange: handleChangeAndOpenNext,
        minDate: minDate,
        maxDate: maxDate
    })), openView === 'month' && (0, $gIfym.createElement)($d4a721711d8d679d$var$MonthSelection, (0, $k2R8s.default)({}, rest, {
        date: date,
        onChange: handleChangeAndOpenNext,
        minDate: minDate,
        maxDate: maxDate
    })), openView === 'date' && (0, $gIfym.createElement)((0, $df47366baeb07e2a$export$407448d2b89b1813), (0, $k2R8s.default)({}, rest, {
        date: date,
        onChange: handleChangeAndOpenNext,
        minDate: minDate,
        maxDate: maxDate
    })), (openView === 'hours' || openView === 'minutes' || openView === 'seconds') && (0, $gIfym.createElement)((0, $e6d2ac9b37bf5092$export$e6ca67116c8adcad), (0, $k2R8s.default)({}, rest, {
        date: date,
        type: openView,
        onHourChange: handleChangeAndOpenNext,
        onMinutesChange: handleChangeAndOpenNext,
        onSecondsChange: handleChangeAndOpenNext
    }))));
};
$d4a721711d8d679d$export$56c0d5a1e737357d.defaultProps = $d4a721711d8d679d$var$_objectSpread$1({}, $d4a721711d8d679d$export$4368d992c4eafac0, {
    views: Object.keys($d4a721711d8d679d$var$viewsMap)
});


var $7275714cbe4684cd$var$useStyles = (0, $c67a157fd78dc604$export$2e2bcd8739ae039)(function(theme) {
    var textColor = theme.palette.type === 'light' ? theme.palette.primary.contrastText : theme.palette.getContrastText(theme.palette.background["default"]);
    return {
        toolbarTxt: {
            color: (0, $aUprr.fade)(textColor, 0.54)
        },
        toolbarBtnSelected: {
            color: textColor
        }
    };
}, {
    name: 'MuiPickersToolbarText'
});
var $7275714cbe4684cd$export$db3b6bfb95261072 = function ToolbarText(_ref) {
    var selected = _ref.selected, label = _ref.label, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, other = (0, $f6Qba.default)(_ref, [
        "selected",
        "label",
        "className"
    ]);
    var classes = $7275714cbe4684cd$var$useStyles();
    return (0, $gIfym.createElement)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        children: label,
        className: (0, $ba4yE.default)(classes.toolbarTxt, className, selected && classes.toolbarBtnSelected)
    }, other));
};
var $7275714cbe4684cd$var$ToolbarButton = function ToolbarButton(_ref) {
    var classes = _ref.classes, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, label = _ref.label, selected = _ref.selected, variant = _ref.variant, align = _ref.align, typographyClassName = _ref.typographyClassName, other = (0, $f6Qba.default)(_ref, [
        "classes",
        "className",
        "label",
        "selected",
        "variant",
        "align",
        "typographyClassName"
    ]);
    return (0, $gIfym.createElement)((0, $b6f198a9b7d0786c$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        variant: "text",
        className: (0, $ba4yE.default)(classes.toolbarBtn, className)
    }, other), (0, $gIfym.createElement)($7275714cbe4684cd$export$db3b6bfb95261072, {
        align: align,
        className: typographyClassName,
        variant: variant,
        label: label,
        selected: selected
    }));
};
$7275714cbe4684cd$var$ToolbarButton.defaultProps = {
    className: ''
};
var $7275714cbe4684cd$var$styles = (0, $c72980417caacb7d$export$2e2bcd8739ae039)({
    toolbarBtn: {
        padding: 0,
        minWidth: '16px',
        textTransform: 'none'
    }
});
var $7275714cbe4684cd$export$971d5caa766a69d7 = (0, $82OGZ.default)($7275714cbe4684cd$var$styles, {
    name: 'MuiPickersToolbarButton'
})($7275714cbe4684cd$var$ToolbarButton);
var $7275714cbe4684cd$var$useStyles$1 = (0, $c67a157fd78dc604$export$2e2bcd8739ae039)(function(theme) {
    return {
        toolbar: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            height: 100,
            backgroundColor: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.background["default"]
        },
        toolbarLandscape: {
            height: 'auto',
            maxWidth: 150,
            padding: 8,
            justifyContent: 'flex-start'
        }
    };
}, {
    name: 'MuiPickersToolbar'
});
var $7275714cbe4684cd$export$56c0d5a1e737357d = function PickerToolbar(_ref) {
    var children = _ref.children, isLandscape = _ref.isLandscape, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, other = (0, $f6Qba.default)(_ref, [
        "children",
        "isLandscape",
        "className"
    ]);
    var classes = $7275714cbe4684cd$var$useStyles$1();
    return (0, $gIfym.createElement)((0, $5f5f251c67055e79$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.toolbar, className, isLandscape && classes.toolbarLandscape)
    }, other), children);
};
function $7275714cbe4684cd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7275714cbe4684cd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7275714cbe4684cd$var$ownKeys(source, true).forEach(function(key) {
            (0, $8k2Uc.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7275714cbe4684cd$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $7275714cbe4684cd$export$407448d2b89b1813 = function PureDateInput(_ref) {
    var inputValue = _ref.inputValue, inputVariant = _ref.inputVariant, validationError = _ref.validationError, InputProps = _ref.InputProps, onOpen = _ref.openPicker, _ref$TextFieldCompone = _ref.TextFieldComponent, TextFieldComponent = _ref$TextFieldCompone === void 0 ? (0, $27b2411b49a9a0ff$export$2e2bcd8739ae039) : _ref$TextFieldCompone, other = (0, $f6Qba.default)(_ref, [
        "inputValue",
        "inputVariant",
        "validationError",
        "InputProps",
        "openPicker",
        "TextFieldComponent"
    ]);
    var PureDateInputProps = (0, $gIfym.useMemo)(function() {
        return $7275714cbe4684cd$var$_objectSpread({}, InputProps, {
            readOnly: true
        });
    }, [
        InputProps
    ]);
    return (0, $gIfym.createElement)(TextFieldComponent, (0, $k2R8s.default)({
        error: Boolean(validationError),
        helperText: validationError
    }, other, {
        // do not overridable
        onClick: onOpen,
        value: inputValue,
        variant: inputVariant,
        InputProps: PureDateInputProps,
        onKeyDown: function onKeyDown(e) {
            // space
            if (e.keyCode === 32) {
                e.stopPropagation();
                onOpen();
            }
        }
    }));
};
$7275714cbe4684cd$export$407448d2b89b1813.displayName = 'PureDateInput';
var $7275714cbe4684cd$var$KeyboardIcon = function KeyboardIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $8QfUv.default), props, (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
        d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
    }));
};
var $7275714cbe4684cd$var$getDisplayDate = function getDisplayDate(value, format, utils, isEmpty, _ref) {
    var invalidLabel = _ref.invalidLabel, emptyLabel = _ref.emptyLabel, labelFunc = _ref.labelFunc;
    var date = utils.date(value);
    if (labelFunc) return labelFunc(isEmpty ? null : date, invalidLabel);
    if (isEmpty) return emptyLabel || '';
    return utils.isValid(date) ? utils.format(date, format) : invalidLabel;
};
var $7275714cbe4684cd$var$getComparisonMaxDate = function getComparisonMaxDate(utils, strictCompareDates, date) {
    if (strictCompareDates) return date;
    return utils.endOfDay(date);
};
var $7275714cbe4684cd$var$getComparisonMinDate = function getComparisonMinDate(utils, strictCompareDates, date) {
    if (strictCompareDates) return date;
    return utils.startOfDay(date);
};
var $7275714cbe4684cd$export$90a7f3efeed30595 = function validate(value, utils, _ref2) {
    var maxDate = _ref2.maxDate, minDate = _ref2.minDate, disablePast = _ref2.disablePast, disableFuture = _ref2.disableFuture, maxDateMessage = _ref2.maxDateMessage, minDateMessage = _ref2.minDateMessage, invalidDateMessage = _ref2.invalidDateMessage, strictCompareDates = _ref2.strictCompareDates;
    var parsedValue = utils.date(value); // if null - do not show error
    if (value === null) return '';
    if (!utils.isValid(value)) return invalidDateMessage;
    if (maxDate && utils.isAfter(parsedValue, $7275714cbe4684cd$var$getComparisonMaxDate(utils, !!strictCompareDates, utils.date(maxDate)))) return maxDateMessage;
    if (disableFuture && utils.isAfter(parsedValue, $7275714cbe4684cd$var$getComparisonMaxDate(utils, !!strictCompareDates, utils.date()))) return maxDateMessage;
    if (minDate && utils.isBefore(parsedValue, $7275714cbe4684cd$var$getComparisonMinDate(utils, !!strictCompareDates, utils.date(minDate)))) return minDateMessage;
    if (disablePast && utils.isBefore(parsedValue, $7275714cbe4684cd$var$getComparisonMinDate(utils, !!strictCompareDates, utils.date()))) return minDateMessage;
    return '';
};
function $7275714cbe4684cd$export$ffb5f4729a158638(userFormat) {
    var ampm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var formats = arguments.length > 2 ? arguments[2] : undefined;
    if (userFormat) return userFormat;
    return ampm ? formats['12h'] : formats['24h'];
}
function $7275714cbe4684cd$var$makeMaskFromFormat(format, numberMaskChar) {
    return format.replace(/[a-z]/gi, numberMaskChar);
}
var $7275714cbe4684cd$var$maskedDateFormatter = function maskedDateFormatter(mask, numberMaskChar, refuse) {
    return function(value) {
        var result = '';
        var parsed = value.replace(refuse, '');
        if (parsed === '') return parsed;
        var i = 0;
        var n = 0;
        while(i < mask.length){
            var maskChar = mask[i];
            if (maskChar === numberMaskChar && n < parsed.length) {
                var parsedChar = parsed[n];
                result += parsedChar;
                n += 1;
            } else result += maskChar;
            i += 1;
        }
        return result;
    };
};
function $7275714cbe4684cd$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7275714cbe4684cd$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7275714cbe4684cd$var$ownKeys$1(source, true).forEach(function(key) {
            (0, $8k2Uc.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7275714cbe4684cd$var$ownKeys$1(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $7275714cbe4684cd$export$3466f893ebf79586 = function KeyboardDateInput(_ref) {
    var inputValue = _ref.inputValue, inputVariant = _ref.inputVariant, validationError = _ref.validationError, KeyboardButtonProps = _ref.KeyboardButtonProps, InputAdornmentProps = _ref.InputAdornmentProps, onOpen = _ref.openPicker, onChange = _ref.onChange, InputProps = _ref.InputProps, mask = _ref.mask, _ref$maskChar = _ref.maskChar, maskChar = _ref$maskChar === void 0 ? '_' : _ref$maskChar, _ref$refuse = _ref.refuse, refuse = _ref$refuse === void 0 ? /[^\d]+/gi : _ref$refuse, format = _ref.format, keyboardIcon = _ref.keyboardIcon, disabled = _ref.disabled, rifmFormatter = _ref.rifmFormatter, _ref$TextFieldCompone = _ref.TextFieldComponent, TextFieldComponent = _ref$TextFieldCompone === void 0 ? (0, $27b2411b49a9a0ff$export$2e2bcd8739ae039) : _ref$TextFieldCompone, other = (0, $f6Qba.default)(_ref, [
        "inputValue",
        "inputVariant",
        "validationError",
        "KeyboardButtonProps",
        "InputAdornmentProps",
        "openPicker",
        "onChange",
        "InputProps",
        "mask",
        "maskChar",
        "refuse",
        "format",
        "keyboardIcon",
        "disabled",
        "rifmFormatter",
        "TextFieldComponent"
    ]);
    var inputMask = mask || $7275714cbe4684cd$var$makeMaskFromFormat(format, maskChar); // prettier-ignore
    var formatter = (0, $gIfym.useMemo)(function() {
        return $7275714cbe4684cd$var$maskedDateFormatter(inputMask, maskChar, refuse);
    }, [
        inputMask,
        maskChar,
        refuse
    ]);
    var position = InputAdornmentProps && InputAdornmentProps.position ? InputAdornmentProps.position : 'end';
    var handleChange = function handleChange(text) {
        var finalString = text === '' || text === inputMask ? null : text;
        onChange(finalString);
    };
    return (0, $gIfym.createElement)((0, $49655f911c6b554c$export$5519909ee832c7c), {
        key: inputMask,
        value: inputValue,
        onChange: handleChange,
        refuse: refuse,
        format: rifmFormatter || formatter
    }, function(_ref2) {
        var onChange = _ref2.onChange, value = _ref2.value;
        return (0, $gIfym.createElement)(TextFieldComponent, (0, $k2R8s.default)({
            disabled: disabled,
            error: Boolean(validationError),
            helperText: validationError
        }, other, {
            value: value,
            onChange: onChange,
            variant: inputVariant,
            InputProps: $7275714cbe4684cd$var$_objectSpread$1({}, InputProps, (0, $8k2Uc.default)({}, "".concat(position, "Adornment"), (0, $gIfym.createElement)((0, $65bddc40606992a6$export$2e2bcd8739ae039), (0, $k2R8s.default)({
                position: position
            }, InputAdornmentProps), (0, $gIfym.createElement)((0, $2ae0a89ca37bbdde$export$2e2bcd8739ae039), (0, $k2R8s.default)({
                disabled: disabled
            }, KeyboardButtonProps, {
                onClick: onOpen
            }), keyboardIcon))))
        }));
    });
};
$7275714cbe4684cd$export$3466f893ebf79586.defaultProps = {
    keyboardIcon: (0, $gIfym.createElement)($7275714cbe4684cd$var$KeyboardIcon, null)
};
function $7275714cbe4684cd$var$useOpenState(_ref) {
    var open = _ref.open, onOpen = _ref.onOpen, onClose = _ref.onClose;
    var setIsOpenState = null;
    if (open === undefined || open === null) {
        // The component is uncontrolled, so we need to give it its own state.
        var _useState = (0, $gIfym.useState)(false);
        var _useState2 = (0, $3KNdx.default)(_useState, 2);
        open = _useState2[0];
        setIsOpenState = _useState2[1];
    } // prettier-ignore
    var setIsOpen = (0, $gIfym.useCallback)(function(newIsOpen) {
        setIsOpenState && setIsOpenState(newIsOpen);
        return newIsOpen ? onOpen && onOpen() : onClose && onClose();
    }, [
        onOpen,
        onClose,
        setIsOpenState
    ]);
    return {
        isOpen: open,
        setIsOpen: setIsOpen
    };
}
var $7275714cbe4684cd$var$useValueToDate = function useValueToDate(utils, _ref) {
    var value = _ref.value, initialFocusedDate = _ref.initialFocusedDate;
    var nowRef = (0, $gIfym.useRef)(utils.date());
    var date = utils.date(value || initialFocusedDate || nowRef.current);
    return date && utils.isValid(date) ? date : nowRef.current;
};
function $7275714cbe4684cd$var$useDateValues(props, options) {
    var utils = (0, $30b5b3be1499928f$export$3b14a55fb2447963)();
    var date = $7275714cbe4684cd$var$useValueToDate(utils, props);
    var format = props.format || options.getDefaultFormat();
    return {
        date: date,
        format: format
    };
}
function $7275714cbe4684cd$export$3b14a55fb2447963(props, options) {
    var autoOk = props.autoOk, disabled = props.disabled, readOnly = props.readOnly, onAccept = props.onAccept, _onChange = props.onChange, onError = props.onError, value = props.value, variant = props.variant;
    var utils = (0, $30b5b3be1499928f$export$3b14a55fb2447963)();
    var _useOpenState = $7275714cbe4684cd$var$useOpenState(props), isOpen = _useOpenState.isOpen, setIsOpen = _useOpenState.setIsOpen;
    var _useDateValues = $7275714cbe4684cd$var$useDateValues(props, options), date = _useDateValues.date, format = _useDateValues.format;
    var _useState = (0, $gIfym.useState)(date), _useState2 = (0, $3KNdx.default)(_useState, 2), pickerDate = _useState2[0], setPickerDate = _useState2[1];
    (0, $gIfym.useEffect)(function() {
        // if value was changed in closed state - treat it as accepted
        if (!isOpen && !utils.isEqual(pickerDate, date)) setPickerDate(date);
    }, [
        date,
        isOpen,
        pickerDate,
        utils
    ]);
    var acceptDate = (0, $gIfym.useCallback)(function(acceptedDate) {
        _onChange(acceptedDate);
        if (onAccept) onAccept(acceptedDate);
        setIsOpen(false);
    }, [
        onAccept,
        _onChange,
        setIsOpen
    ]);
    var wrapperProps = (0, $gIfym.useMemo)(function() {
        return {
            format: format,
            open: isOpen,
            onClear: function onClear() {
                return acceptDate(null);
            },
            onAccept: function onAccept() {
                return acceptDate(pickerDate);
            },
            onSetToday: function onSetToday() {
                return setPickerDate(utils.date());
            },
            onDismiss: function onDismiss() {
                setIsOpen(false);
            }
        };
    }, [
        acceptDate,
        format,
        isOpen,
        pickerDate,
        setIsOpen,
        utils
    ]);
    var pickerProps = (0, $gIfym.useMemo)(function() {
        return {
            date: pickerDate,
            onChange: function onChange(newDate) {
                var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                setPickerDate(newDate);
                if (isFinish && autoOk) {
                    acceptDate(newDate);
                    return;
                } // simulate autoOk, but do not close the modal
                if (variant === 'inline' || variant === 'static') {
                    _onChange(newDate);
                    onAccept && onAccept(newDate);
                }
            }
        };
    }, [
        acceptDate,
        autoOk,
        onAccept,
        _onChange,
        pickerDate,
        variant
    ]);
    var validationError = $7275714cbe4684cd$export$90a7f3efeed30595(value, utils, props);
    (0, $gIfym.useEffect)(function() {
        if (onError) onError(validationError, value);
    }, [
        onError,
        validationError,
        value
    ]);
    var inputValue = $7275714cbe4684cd$var$getDisplayDate(date, format, utils, value === null, props);
    var inputProps = (0, $gIfym.useMemo)(function() {
        return {
            inputValue: inputValue,
            validationError: validationError,
            openPicker: function openPicker() {
                return !readOnly && !disabled && setIsOpen(true);
            }
        };
    }, [
        disabled,
        inputValue,
        readOnly,
        setIsOpen,
        validationError
    ]);
    var pickerState = {
        pickerProps: pickerProps,
        inputProps: inputProps,
        wrapperProps: wrapperProps
    };
    (0, $gIfym.useDebugValue)(pickerState);
    return pickerState;
}
function $7275714cbe4684cd$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7275714cbe4684cd$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7275714cbe4684cd$var$ownKeys$2(source, true).forEach(function(key) {
            (0, $8k2Uc.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7275714cbe4684cd$var$ownKeys$2(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7275714cbe4684cd$var$parseInputString(value, utils, format) {
    try {
        return utils.parse(value, format);
    } catch (_unused) {
        return null;
    }
}
function $7275714cbe4684cd$export$8b22cf2602fb60ce(props, options) {
    var _props$format = props.format, format = _props$format === void 0 ? options.getDefaultFormat() : _props$format, inputValue = props.inputValue, _onChange = props.onChange, value = props.value;
    var utils = (0, $30b5b3be1499928f$export$3b14a55fb2447963)();
    var displayDate = $7275714cbe4684cd$var$getDisplayDate(value, format, utils, value === null, props);
    var _useState = (0, $gIfym.useState)(displayDate), _useState2 = (0, $3KNdx.default)(_useState, 2), innerInputValue = _useState2[0], setInnerInputValue = _useState2[1];
    var dateValue = inputValue ? $7275714cbe4684cd$var$parseInputString(inputValue, utils, format) : value;
    (0, $gIfym.useEffect)(function() {
        if (value === null || utils.isValid(value)) setInnerInputValue(displayDate);
    }, [
        displayDate,
        setInnerInputValue,
        utils,
        value
    ]);
    var handleKeyboardChange = (0, $gIfym.useCallback)(function(date) {
        _onChange(date, date === null ? null : utils.format(date, format));
    }, [
        format,
        _onChange,
        utils
    ]);
    var _usePickerState = $7275714cbe4684cd$export$3b14a55fb2447963($7275714cbe4684cd$var$_objectSpread$2({}, props, {
        value: dateValue,
        onChange: handleKeyboardChange
    }), options), innerInputProps = _usePickerState.inputProps, wrapperProps = _usePickerState.wrapperProps, pickerProps = _usePickerState.pickerProps;
    var inputProps = (0, $gIfym.useMemo)(function() {
        return $7275714cbe4684cd$var$_objectSpread$2({}, innerInputProps, {
            // reuse validation and open/close logic
            format: wrapperProps.format,
            inputValue: inputValue || innerInputValue,
            onChange: function onChange(value) {
                setInnerInputValue(value || '');
                var date = value === null ? null : utils.parse(value, wrapperProps.format);
                _onChange(date, value);
            }
        });
    }, [
        innerInputProps,
        innerInputValue,
        inputValue,
        _onChange,
        utils,
        wrapperProps.format
    ]);
    return {
        inputProps: inputProps,
        wrapperProps: wrapperProps,
        pickerProps: pickerProps
    };
}
function $7275714cbe4684cd$export$953cecd6e717a553(_ref) {
    var Input = _ref.Input, useState = _ref.useState, useOptions = _ref.useOptions, getCustomProps = _ref.getCustomProps, DefaultToolbarComponent = _ref.DefaultToolbarComponent;
    function PickerWithState(props) {
        var allowKeyboardControl = props.allowKeyboardControl, ampm = props.ampm, animateYearScrolling = props.animateYearScrolling, autoOk = props.autoOk, dateRangeIcon = props.dateRangeIcon, disableFuture = props.disableFuture, disablePast = props.disablePast, disableToolbar = props.disableToolbar, emptyLabel = props.emptyLabel, format = props.format, forwardedRef = props.forwardedRef, hideTabs = props.hideTabs, initialFocusedDate = props.initialFocusedDate, invalidDateMessage = props.invalidDateMessage, invalidLabel = props.invalidLabel, labelFunc = props.labelFunc, leftArrowButtonProps = props.leftArrowButtonProps, leftArrowIcon = props.leftArrowIcon, loadingIndicator = props.loadingIndicator, maxDate = props.maxDate, maxDateMessage = props.maxDateMessage, minDate = props.minDate, minDateMessage = props.minDateMessage, minutesStep = props.minutesStep, onAccept = props.onAccept, onChange = props.onChange, onClose = props.onClose, onMonthChange = props.onMonthChange, onOpen = props.onOpen, onYearChange = props.onYearChange, openTo = props.openTo, orientation = props.orientation, renderDay = props.renderDay, rightArrowButtonProps = props.rightArrowButtonProps, rightArrowIcon = props.rightArrowIcon, shouldDisableDate = props.shouldDisableDate, strictCompareDates = props.strictCompareDates, timeIcon = props.timeIcon, _props$ToolbarCompone = props.ToolbarComponent, ToolbarComponent = _props$ToolbarCompone === void 0 ? DefaultToolbarComponent : _props$ToolbarCompone, value = props.value, variant = props.variant, views = props.views, other = (0, $f6Qba.default)(props, [
            "allowKeyboardControl",
            "ampm",
            "animateYearScrolling",
            "autoOk",
            "dateRangeIcon",
            "disableFuture",
            "disablePast",
            "disableToolbar",
            "emptyLabel",
            "format",
            "forwardedRef",
            "hideTabs",
            "initialFocusedDate",
            "invalidDateMessage",
            "invalidLabel",
            "labelFunc",
            "leftArrowButtonProps",
            "leftArrowIcon",
            "loadingIndicator",
            "maxDate",
            "maxDateMessage",
            "minDate",
            "minDateMessage",
            "minutesStep",
            "onAccept",
            "onChange",
            "onClose",
            "onMonthChange",
            "onOpen",
            "onYearChange",
            "openTo",
            "orientation",
            "renderDay",
            "rightArrowButtonProps",
            "rightArrowIcon",
            "shouldDisableDate",
            "strictCompareDates",
            "timeIcon",
            "ToolbarComponent",
            "value",
            "variant",
            "views"
        ]);
        var injectedProps = getCustomProps ? getCustomProps(props) : {};
        var options = useOptions(props);
        var _useState = useState(props, options), pickerProps = _useState.pickerProps, inputProps = _useState.inputProps, wrapperProps = _useState.wrapperProps;
        return (0, $gIfym.createElement)((0, $e5df3b21da25e895$export$71cec2538cb2c617), (0, $k2R8s.default)({
            variant: variant,
            InputComponent: Input,
            DateInputProps: inputProps
        }, injectedProps, wrapperProps, other), (0, $gIfym.createElement)((0, $d4a721711d8d679d$export$56c0d5a1e737357d), (0, $k2R8s.default)({}, pickerProps, {
            allowKeyboardControl: allowKeyboardControl,
            ampm: ampm,
            animateYearScrolling: animateYearScrolling,
            dateRangeIcon: dateRangeIcon,
            disableFuture: disableFuture,
            disablePast: disablePast,
            disableToolbar: disableToolbar,
            hideTabs: hideTabs,
            leftArrowButtonProps: leftArrowButtonProps,
            leftArrowIcon: leftArrowIcon,
            loadingIndicator: loadingIndicator,
            maxDate: maxDate,
            minDate: minDate,
            minutesStep: minutesStep,
            onMonthChange: onMonthChange,
            onYearChange: onYearChange,
            openTo: openTo,
            orientation: orientation,
            renderDay: renderDay,
            rightArrowButtonProps: rightArrowButtonProps,
            rightArrowIcon: rightArrowIcon,
            shouldDisableDate: shouldDisableDate,
            strictCompareDates: strictCompareDates,
            timeIcon: timeIcon,
            ToolbarComponent: ToolbarComponent,
            views: views
        })));
    }
    return PickerWithState;
}











parcelRequire("3KNdx");


parcelRequire("lU1Um");












var $a8e091f918fea129$var$useStyles = (0, $c67a157fd78dc604$export$2e2bcd8739ae039)({
    toolbar: {
        flexDirection: 'column',
        alignItems: 'flex-start'
    },
    toolbarLandscape: {
        padding: 16
    },
    dateLandscape: {
        marginRight: 16
    }
}, {
    name: 'MuiPickersDatePickerRoot'
});
var $a8e091f918fea129$var$DatePickerToolbar = function DatePickerToolbar(_ref) {
    var date = _ref.date, views = _ref.views, setOpenView = _ref.setOpenView, isLandscape = _ref.isLandscape, openView = _ref.openView;
    var utils = (0, $30b5b3be1499928f$export$3b14a55fb2447963)();
    var classes = $a8e091f918fea129$var$useStyles();
    var isYearOnly = (0, $gIfym.useMemo)(function() {
        return (0, $df47366baeb07e2a$export$23f2a1d2818174ef)(views);
    }, [
        views
    ]);
    var isYearAndMonth = (0, $gIfym.useMemo)(function() {
        return (0, $df47366baeb07e2a$export$8b22cf2602fb60ce)(views);
    }, [
        views
    ]);
    return (0, $gIfym.createElement)((0, $7275714cbe4684cd$export$56c0d5a1e737357d), {
        isLandscape: isLandscape,
        className: (0, $ba4yE.default)(!isYearOnly && classes.toolbar, isLandscape && classes.toolbarLandscape)
    }, (0, $gIfym.createElement)((0, $7275714cbe4684cd$export$971d5caa766a69d7), {
        variant: isYearOnly ? 'h3' : 'subtitle1',
        onClick: function onClick() {
            return setOpenView('year');
        },
        selected: openView === 'year',
        label: utils.getYearText(date)
    }), !isYearOnly && !isYearAndMonth && (0, $gIfym.createElement)((0, $7275714cbe4684cd$export$971d5caa766a69d7), {
        variant: "h4",
        selected: openView === 'date',
        onClick: function onClick() {
            return setOpenView('date');
        },
        align: isLandscape ? 'left' : 'center',
        label: utils.getDatePickerHeaderText(date),
        className: (0, $ba4yE.default)(isLandscape && classes.dateLandscape)
    }), isYearAndMonth && (0, $gIfym.createElement)((0, $7275714cbe4684cd$export$971d5caa766a69d7), {
        variant: "h4",
        onClick: function onClick() {
            return setOpenView('month');
        },
        selected: openView === 'month',
        label: utils.getMonthText(date)
    }));
};
function $a8e091f918fea129$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a8e091f918fea129$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a8e091f918fea129$var$ownKeys(source, true).forEach(function(key) {
            (0, $8k2Uc.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a8e091f918fea129$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $a8e091f918fea129$var$defaultProps = $a8e091f918fea129$var$_objectSpread({}, (0, $d4a721711d8d679d$export$4368d992c4eafac0), {
    openTo: 'date',
    views: [
        'year',
        'date'
    ]
});
function $a8e091f918fea129$var$useOptions(props) {
    var utils = (0, $30b5b3be1499928f$export$3b14a55fb2447963)();
    return {
        getDefaultFormat: function getDefaultFormat() {
            return (0, $df47366baeb07e2a$export$39b482c5e57630a8)(props.views, utils);
        }
    };
}
var $a8e091f918fea129$export$5109c6dd95d8fb00 = (0, $7275714cbe4684cd$export$953cecd6e717a553)({
    useOptions: $a8e091f918fea129$var$useOptions,
    Input: (0, $7275714cbe4684cd$export$407448d2b89b1813),
    useState: (0, $7275714cbe4684cd$export$3b14a55fb2447963),
    DefaultToolbarComponent: $a8e091f918fea129$var$DatePickerToolbar
});
var $a8e091f918fea129$export$d8c44f501031ee7c = (0, $7275714cbe4684cd$export$953cecd6e717a553)({
    useOptions: $a8e091f918fea129$var$useOptions,
    Input: (0, $7275714cbe4684cd$export$3466f893ebf79586),
    useState: (0, $7275714cbe4684cd$export$8b22cf2602fb60ce),
    DefaultToolbarComponent: $a8e091f918fea129$var$DatePickerToolbar
});
$a8e091f918fea129$export$5109c6dd95d8fb00.defaultProps = $a8e091f918fea129$var$defaultProps;
$a8e091f918fea129$export$d8c44f501031ee7c.defaultProps = $a8e091f918fea129$var$defaultProps;



function $ab1ccf67772a828b$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $70733e4e50d2f19f$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}





function $f34a916b38b656d5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}





function $505253a3e23d976d$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $f34a916b38b656d5$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}




function $3770653b55b8c767$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    return (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dateLeft).getTime() - (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dateRight).getTime();
}




function $3c960c2b5187ea9f$export$2e2bcd8739ae039(dirtyInterval, options) {
    var _options$step;
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(interval.start);
    var endDate = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
    while(currentDate.getTime() <= endTime){
        dates.push((0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}



var $4744e1d78c565baf$var$defaultOptions = {};
function $4744e1d78c565baf$export$430a3269e24b912e() {
    return $4744e1d78c565baf$var$defaultOptions;
}
function $4744e1d78c565baf$export$95365be1b0704abc(newOptions) {
    $4744e1d78c565baf$var$defaultOptions = newOptions;
}





function $4a2ac0b1bfa4e974$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $4744e1d78c565baf$export$430a3269e24b912e)();
    var weekStartsOn = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $0c69cb6fa50bee26$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}






function $44b85eead361dbcf$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $1cfb31ec8ccc0e14$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $44b85eead361dbcf$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $a91cba184cb1c74f$var$MILLISECONDS_IN_DAY = 86400000;
function $a91cba184cb1c74f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $a91cba184cb1c74f$var$MILLISECONDS_IN_DAY) + 1;
}





function $743b242f5fe00b8a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $23ac35214174de35$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $743b242f5fe00b8a$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $743b242f5fe00b8a$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $723465b4732bafb3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $23ac35214174de35$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $743b242f5fe00b8a$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $859ad782d7a5a232$var$MILLISECONDS_IN_WEEK = 604800000;
function $859ad782d7a5a232$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $743b242f5fe00b8a$export$2e2bcd8739ae039)(date).getTime() - (0, $723465b4732bafb3$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $859ad782d7a5a232$var$MILLISECONDS_IN_WEEK) + 1;
}








function $9e69a479a3a3ee51$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $4744e1d78c565baf$export$430a3269e24b912e)();
    var weekStartsOn = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $5d7ca251f57b4040$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $4744e1d78c565baf$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $9e69a479a3a3ee51$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $9e69a479a3a3ee51$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $53071bb5401a4a72$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $4744e1d78c565baf$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $5d7ca251f57b4040$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $9e69a479a3a3ee51$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $2ba2f8b55cd02a72$var$MILLISECONDS_IN_WEEK = 604800000;
function $2ba2f8b55cd02a72$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $9e69a479a3a3ee51$export$2e2bcd8739ae039)(date, options).getTime() - (0, $53071bb5401a4a72$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $2ba2f8b55cd02a72$var$MILLISECONDS_IN_WEEK) + 1;
}



function $a92ae4af4f02049e$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $7ceb374bc5936874$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $7ceb374bc5936874$export$2e2bcd8739ae039 = $7ceb374bc5936874$var$formatters;


var $6afa95f285fc2dc6$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $6afa95f285fc2dc6$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $7ceb374bc5936874$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $5d7ca251f57b4040$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $23ac35214174de35$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $7ceb374bc5936874$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $2ba2f8b55cd02a72$export$2e2bcd8739ae039)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $859ad782d7a5a232$export$2e2bcd8739ae039)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $7ceb374bc5936874$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $a91cba184cb1c74f$export$2e2bcd8739ae039)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $6afa95f285fc2dc6$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $6afa95f285fc2dc6$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $6afa95f285fc2dc6$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $6afa95f285fc2dc6$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $6afa95f285fc2dc6$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $6afa95f285fc2dc6$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $7ceb374bc5936874$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $7ceb374bc5936874$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $7ceb374bc5936874$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $7ceb374bc5936874$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $7ceb374bc5936874$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $6afa95f285fc2dc6$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $6afa95f285fc2dc6$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $6afa95f285fc2dc6$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $6afa95f285fc2dc6$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $6afa95f285fc2dc6$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $6afa95f285fc2dc6$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $6afa95f285fc2dc6$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $6afa95f285fc2dc6$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $6afa95f285fc2dc6$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $6afa95f285fc2dc6$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $6afa95f285fc2dc6$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(minutes, 2);
}
function $6afa95f285fc2dc6$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $6afa95f285fc2dc6$var$formatTimezone(offset, dirtyDelimiter);
}
function $6afa95f285fc2dc6$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $a92ae4af4f02049e$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $6afa95f285fc2dc6$export$2e2bcd8739ae039 = $6afa95f285fc2dc6$var$formatters;


var $557c7540f4f0608c$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $557c7540f4f0608c$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $557c7540f4f0608c$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $557c7540f4f0608c$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $557c7540f4f0608c$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $557c7540f4f0608c$var$timeLongFormatter(timePattern, formatLong));
};
var $557c7540f4f0608c$var$longFormatters = {
    p: $557c7540f4f0608c$var$timeLongFormatter,
    P: $557c7540f4f0608c$var$dateTimeLongFormatter
};
var $557c7540f4f0608c$export$2e2bcd8739ae039 = $557c7540f4f0608c$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $b10430f8159ac739$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $69d29ec00526bf03$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $69d29ec00526bf03$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $69d29ec00526bf03$export$c6cc36aa33304772(token) {
    return $69d29ec00526bf03$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $69d29ec00526bf03$export$c6b49d6dceb604a1(token) {
    return $69d29ec00526bf03$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $69d29ec00526bf03$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $b0ba906bbcc4d578$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $b0ba906bbcc4d578$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b0ba906bbcc4d578$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $b0ba906bbcc4d578$export$2e2bcd8739ae039 = $b0ba906bbcc4d578$var$formatDistance;


function $207e666fbed039af$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $d60f903013fb8732$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $d60f903013fb8732$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $d60f903013fb8732$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $d60f903013fb8732$var$formatLong = {
    date: (0, $207e666fbed039af$export$2e2bcd8739ae039)({
        formats: $d60f903013fb8732$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $207e666fbed039af$export$2e2bcd8739ae039)({
        formats: $d60f903013fb8732$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $207e666fbed039af$export$2e2bcd8739ae039)({
        formats: $d60f903013fb8732$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d60f903013fb8732$export$2e2bcd8739ae039 = $d60f903013fb8732$var$formatLong;


var $c82a942e5e4ab994$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $c82a942e5e4ab994$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c82a942e5e4ab994$var$formatRelativeLocale[token];
};
var $c82a942e5e4ab994$export$2e2bcd8739ae039 = $c82a942e5e4ab994$var$formatRelative;


function $dee1ce128f174744$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $f81bd1c4e39c67d1$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $f81bd1c4e39c67d1$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $f81bd1c4e39c67d1$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $f81bd1c4e39c67d1$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $f81bd1c4e39c67d1$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $f81bd1c4e39c67d1$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $f81bd1c4e39c67d1$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $f81bd1c4e39c67d1$var$localize = {
    ordinalNumber: $f81bd1c4e39c67d1$var$ordinalNumber,
    era: (0, $dee1ce128f174744$export$2e2bcd8739ae039)({
        values: $f81bd1c4e39c67d1$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $dee1ce128f174744$export$2e2bcd8739ae039)({
        values: $f81bd1c4e39c67d1$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $dee1ce128f174744$export$2e2bcd8739ae039)({
        values: $f81bd1c4e39c67d1$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $dee1ce128f174744$export$2e2bcd8739ae039)({
        values: $f81bd1c4e39c67d1$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $dee1ce128f174744$export$2e2bcd8739ae039)({
        values: $f81bd1c4e39c67d1$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $f81bd1c4e39c67d1$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $f81bd1c4e39c67d1$export$2e2bcd8739ae039 = $f81bd1c4e39c67d1$var$localize;


function $213e6546ac5dc0e0$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $213e6546ac5dc0e0$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $213e6546ac5dc0e0$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $213e6546ac5dc0e0$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $213e6546ac5dc0e0$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $e6bf6f06a64b60f3$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $91f78933d716e51d$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $91f78933d716e51d$var$parseOrdinalNumberPattern = /\d+/i;
var $91f78933d716e51d$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $91f78933d716e51d$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $91f78933d716e51d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $91f78933d716e51d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $91f78933d716e51d$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $91f78933d716e51d$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $91f78933d716e51d$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $91f78933d716e51d$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $91f78933d716e51d$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $91f78933d716e51d$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $91f78933d716e51d$var$match = {
    ordinalNumber: (0, $e6bf6f06a64b60f3$export$2e2bcd8739ae039)({
        matchPattern: $91f78933d716e51d$var$matchOrdinalNumberPattern,
        parsePattern: $91f78933d716e51d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $213e6546ac5dc0e0$export$2e2bcd8739ae039)({
        matchPatterns: $91f78933d716e51d$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $91f78933d716e51d$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $213e6546ac5dc0e0$export$2e2bcd8739ae039)({
        matchPatterns: $91f78933d716e51d$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $91f78933d716e51d$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $213e6546ac5dc0e0$export$2e2bcd8739ae039)({
        matchPatterns: $91f78933d716e51d$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $91f78933d716e51d$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $213e6546ac5dc0e0$export$2e2bcd8739ae039)({
        matchPatterns: $91f78933d716e51d$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $91f78933d716e51d$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $213e6546ac5dc0e0$export$2e2bcd8739ae039)({
        matchPatterns: $91f78933d716e51d$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $91f78933d716e51d$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $91f78933d716e51d$export$2e2bcd8739ae039 = $91f78933d716e51d$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $03d358bcbb69c50d$var$locale = {
    code: 'en-US',
    formatDistance: (0, $b0ba906bbcc4d578$export$2e2bcd8739ae039),
    formatLong: (0, $d60f903013fb8732$export$2e2bcd8739ae039),
    formatRelative: (0, $c82a942e5e4ab994$export$2e2bcd8739ae039),
    localize: (0, $f81bd1c4e39c67d1$export$2e2bcd8739ae039),
    match: (0, $91f78933d716e51d$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $03d358bcbb69c50d$export$2e2bcd8739ae039 = $03d358bcbb69c50d$var$locale;


var $926a271460757e7d$export$2e2bcd8739ae039 = (0, $03d358bcbb69c50d$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e12159bb4a72b327$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e12159bb4a72b327$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e12159bb4a72b327$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e12159bb4a72b327$var$doubleQuoteRegExp = /''/g;
var $e12159bb4a72b327$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e12159bb4a72b327$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $4744e1d78c565baf$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $926a271460757e7d$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $fd484e33268961be$export$2e2bcd8739ae039)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $b10430f8159ac739$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $1cfb31ec8ccc0e14$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($e12159bb4a72b327$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $557c7540f4f0608c$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($e12159bb4a72b327$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $e12159bb4a72b327$var$cleanEscapedString(substring);
        var formatter = (0, $6afa95f285fc2dc6$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $69d29ec00526bf03$export$c6b49d6dceb604a1)(substring)) (0, $69d29ec00526bf03$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $69d29ec00526bf03$export$c6cc36aa33304772)(substring)) (0, $69d29ec00526bf03$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($e12159bb4a72b327$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $e12159bb4a72b327$var$cleanEscapedString(input) {
    var matched = input.match($e12159bb4a72b327$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($e12159bb4a72b327$var$doubleQuoteRegExp, "'");
}




function $ec0f5df76896d512$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var hours = date.getHours();
    return hours;
}




function $8714c9d014072134$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}




function $1a65a7e3c2d81ff0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    return (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate).getFullYear();
}




function $8c6c51519b18afe3$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}




function $9cc564b438244500$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}




function $20c4b33069c49f10$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyLeftDate);
    var dateRight = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}




function $0ce61fa4b27488b9$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $fd3041540393caa2$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $fd3041540393caa2$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}




function $e70d44be99fd87cb$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}




function $4a5e465c3141389c$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}




function $aafbdc79f47bcd3f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}



function $769c1f6f55afe554$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfHour = (0, $aafbdc79f47bcd3f$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfHour = (0, $aafbdc79f47bcd3f$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}




var $8ZNRc = parcelRequire("8ZNRc");

var $biFy3 = parcelRequire("biFy3");
function $75d0b34c22ad1d7e$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $biFy3.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}





function $8188f9a897f4ea0b$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}








var $6o8oQ = parcelRequire("6o8oQ");


function $143c4a7111520f74$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($143c4a7111520f74$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $9a0d8175c92b6fe5$export$2e2bcd8739ae039(t) {
    var r = (0, $143c4a7111520f74$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $ff55a031e82added$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $ff55a031e82added$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $f2568f2b7932cb22$export$2e2bcd8739ae039)(this, e);
    };
}




var $lU1Um = parcelRequire("lU1Um");

var $8k2Uc = parcelRequire("8k2Uc");
var $412d0f55e7475408$var$TIMEZONE_UNIT_PRIORITY = 10;
var $412d0f55e7475408$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, Setter);
        (0, $8k2Uc.default)(this, "priority", void 0);
        (0, $8k2Uc.default)(this, "subPriority", 0);
    }
    (0, $lU1Um.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $412d0f55e7475408$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(ValueSetter, _Setter);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $lU1Um.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($412d0f55e7475408$export$81d53e3678089a6);
var $412d0f55e7475408$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this2), "priority", $412d0f55e7475408$var$TIMEZONE_UNIT_PRIORITY);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $lU1Um.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($412d0f55e7475408$export$81d53e3678089a6);




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");


var $lU1Um = parcelRequire("lU1Um");

var $8k2Uc = parcelRequire("8k2Uc");

var $c2444e20e68ca576$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, Parser);
        (0, $8k2Uc.default)(this, "incompatibleTokens", void 0);
        (0, $8k2Uc.default)(this, "priority", void 0);
        (0, $8k2Uc.default)(this, "subPriority", void 0);
    }
    (0, $lU1Um.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $412d0f55e7475408$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $318829e874cc878f$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(EraParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(EraParser);
    function EraParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 140);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $ae7dfe20ce1438ed$export$dfd9b671c89acc8e = 7;
var $ae7dfe20ce1438ed$export$3913210603d8e9ae = 365.2425;
var $ae7dfe20ce1438ed$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $ae7dfe20ce1438ed$export$91246f0b9bd9beff = 60000;
var $ae7dfe20ce1438ed$export$7f72910d6dfd237a = 3600000;
var $ae7dfe20ce1438ed$export$397c2d5776aa9055 = 1000;
var $ae7dfe20ce1438ed$export$4dec998e48f9c246 = -$ae7dfe20ce1438ed$export$81caae6e1cc7a622;
var $ae7dfe20ce1438ed$export$f2f5ae5a8e2d8f9f = 60;
var $ae7dfe20ce1438ed$export$3c58128db900d44e = 3;
var $ae7dfe20ce1438ed$export$80d7e435f744f319 = 12;
var $ae7dfe20ce1438ed$export$4db7641526e3241f = 4;
var $ae7dfe20ce1438ed$export$698aec755e92c695 = 3600;
var $ae7dfe20ce1438ed$export$a77c1a7ebebe2a5a = 60;
var $ae7dfe20ce1438ed$export$815a9362476d2fe3 = $ae7dfe20ce1438ed$export$698aec755e92c695 * 24;
var $ae7dfe20ce1438ed$export$34804a017b31e2fe = $ae7dfe20ce1438ed$export$815a9362476d2fe3 * 7;
var $ae7dfe20ce1438ed$export$7271e9e3478110d1 = $ae7dfe20ce1438ed$export$815a9362476d2fe3 * $ae7dfe20ce1438ed$export$3913210603d8e9ae;
var $ae7dfe20ce1438ed$export$8e6600bbdee7dabb = $ae7dfe20ce1438ed$export$7271e9e3478110d1 / 12;
var $ae7dfe20ce1438ed$export$be1dccf2de902d31 = $ae7dfe20ce1438ed$export$8e6600bbdee7dabb * 3;


var $051177df0aca266b$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $051177df0aca266b$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $b6459ccd5f620218$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $b6459ccd5f620218$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $b6459ccd5f620218$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $ae7dfe20ce1438ed$export$7f72910d6dfd237a) + minutes * (0, $ae7dfe20ce1438ed$export$91246f0b9bd9beff) + seconds * (0, $ae7dfe20ce1438ed$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $b6459ccd5f620218$export$d931c43c4608a164(dateString) {
    return $b6459ccd5f620218$export$cc7cc9e2a3ff9388((0, $051177df0aca266b$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $b6459ccd5f620218$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $b6459ccd5f620218$export$cc7cc9e2a3ff9388((0, $051177df0aca266b$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $b6459ccd5f620218$export$cc7cc9e2a3ff9388((0, $051177df0aca266b$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $b6459ccd5f620218$export$cc7cc9e2a3ff9388((0, $051177df0aca266b$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $b6459ccd5f620218$export$cc7cc9e2a3ff9388((0, $051177df0aca266b$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $b6459ccd5f620218$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $b6459ccd5f620218$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $b6459ccd5f620218$export$cc7cc9e2a3ff9388((0, $051177df0aca266b$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $b6459ccd5f620218$export$cc7cc9e2a3ff9388((0, $051177df0aca266b$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $b6459ccd5f620218$export$cc7cc9e2a3ff9388((0, $051177df0aca266b$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $b6459ccd5f620218$export$cc7cc9e2a3ff9388((0, $051177df0aca266b$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $b6459ccd5f620218$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $b6459ccd5f620218$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $b6459ccd5f620218$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $b6459ccd5f620218$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $0596f5afc4a4b16c$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(YearParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(YearParser);
    function YearParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 130);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)((0, $b6459ccd5f620218$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)((0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $b6459ccd5f620218$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");




var $eef9463b66019c97$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(LocalWeekYearParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 130);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)((0, $b6459ccd5f620218$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)((0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $5d7ca251f57b4040$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $b6459ccd5f620218$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $9e69a479a3a3ee51$export$2e2bcd8739ae039)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $9e69a479a3a3ee51$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");



var $baeee7633347bf0d$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(ISOWeekYearParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 130);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $b6459ccd5f620218$export$2c9307b2e29c533c)(4, dateString);
                return (0, $b6459ccd5f620218$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $743b242f5fe00b8a$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");


var $abe1ecb31ba528e1$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(ExtendedYearParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 130);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $b6459ccd5f620218$export$2c9307b2e29c533c)(4, dateString);
                return (0, $b6459ccd5f620218$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");


var $76fad13316b8a028$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(QuarterParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 120);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");


var $ae3702fcafb04fc0$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(StandAloneQuarterParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 120);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");



var $add8dbe52231df4e$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(MonthParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 110);
        return _this;
    }
    (0, $lU1Um.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)((0, $b6459ccd5f620218$export$cc7cc9e2a3ff9388)((0, $051177df0aca266b$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)((0, $b6459ccd5f620218$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");



var $e6520c2469c82330$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(StandAloneMonthParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 110);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)((0, $b6459ccd5f620218$export$cc7cc9e2a3ff9388)((0, $051177df0aca266b$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)((0, $b6459ccd5f620218$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");







function $c6d99a8802518d99$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $2ba2f8b55cd02a72$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $dcc1b052f0d79807$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(LocalWeekParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 100);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $b6459ccd5f620218$export$cc7cc9e2a3ff9388)((0, $051177df0aca266b$export$c123ee06d9da8480).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $9e69a479a3a3ee51$export$2e2bcd8739ae039)((0, $c6d99a8802518d99$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");







function $3832cdbf6fbcc1c1$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $859ad782d7a5a232$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $86b2d476541bbc93$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(ISOWeekParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 100);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $b6459ccd5f620218$export$cc7cc9e2a3ff9388)((0, $051177df0aca266b$export$c123ee06d9da8480).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $743b242f5fe00b8a$export$2e2bcd8739ae039)((0, $3832cdbf6fbcc1c1$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");



var $d9b05360d01a56c5$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $d9b05360d01a56c5$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $d9b05360d01a56c5$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(DateParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(DateParser);
    function DateParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 90);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "subPriority", 1);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $b6459ccd5f620218$export$cc7cc9e2a3ff9388)((0, $051177df0aca266b$export$c123ee06d9da8480).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $b6459ccd5f620218$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $d9b05360d01a56c5$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $d9b05360d01a56c5$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");



var $05a97b4a3077c4e6$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(DayOfYearParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 90);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "subpriority", 1);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $b6459ccd5f620218$export$cc7cc9e2a3ff9388)((0, $051177df0aca266b$export$c123ee06d9da8480).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $b6459ccd5f620218$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");





function $21fe757a96e7db39$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $4744e1d78c565baf$export$430a3269e24b912e)();
    var weekStartsOn = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $7419cd47b07154a5$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(DayParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(DayParser);
    function DayParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 90);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $21fe757a96e7db39$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");



var $6861ce268f866bc5$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(LocalDayParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 90);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)((0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $21fe757a96e7db39$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");



var $484e531d8aee2455$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 90);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)((0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $21fe757a96e7db39$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");





function $3fa88e3e6d939faa$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $811f0ca42fbac91f$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(ISODayParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 90);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $3fa88e3e6d939faa$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");


var $18ce478397a76661$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(AMPMParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 80);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $b6459ccd5f620218$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");


var $15c191cd633e89cd$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(AMPMMidnightParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 80);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $b6459ccd5f620218$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");


var $8aa5c95c4bf3d570$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(DayPeriodParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 80);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $b6459ccd5f620218$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");



var $e51f91737bbaea68$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(Hour1to12Parser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 70);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $b6459ccd5f620218$export$cc7cc9e2a3ff9388)((0, $051177df0aca266b$export$c123ee06d9da8480).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");



var $f85882a2f6e58f7b$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(Hour0to23Parser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 70);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $b6459ccd5f620218$export$cc7cc9e2a3ff9388)((0, $051177df0aca266b$export$c123ee06d9da8480).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");



var $7b582eb7d2dcecbd$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(Hour0To11Parser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 70);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $b6459ccd5f620218$export$cc7cc9e2a3ff9388)((0, $051177df0aca266b$export$c123ee06d9da8480).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");



var $225f8e2c69bdea19$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(Hour1To24Parser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 70);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $b6459ccd5f620218$export$cc7cc9e2a3ff9388)((0, $051177df0aca266b$export$c123ee06d9da8480).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");



var $e9a86c53cb8942bc$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(MinuteParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 60);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $b6459ccd5f620218$export$cc7cc9e2a3ff9388)((0, $051177df0aca266b$export$c123ee06d9da8480).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");



var $a04bb908e6e983e5$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(SecondParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 50);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $b6459ccd5f620218$export$cc7cc9e2a3ff9388)((0, $051177df0aca266b$export$c123ee06d9da8480).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");


var $e57775ad30d330d0$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(FractionOfSecondParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 30);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $b6459ccd5f620218$export$4f84e3a82c7b538)((0, $b6459ccd5f620218$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");



var $0f64a49f96cd07a5$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 10);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $b6459ccd5f620218$export$6497f4c0ecdfba8e)((0, $051177df0aca266b$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $b6459ccd5f620218$export$6497f4c0ecdfba8e)((0, $051177df0aca266b$export$a7ee192b982af9c1).basic, dateString);
                    case 'XXXX':
                        return (0, $b6459ccd5f620218$export$6497f4c0ecdfba8e)((0, $051177df0aca266b$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $b6459ccd5f620218$export$6497f4c0ecdfba8e)((0, $051177df0aca266b$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $b6459ccd5f620218$export$6497f4c0ecdfba8e)((0, $051177df0aca266b$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");



var $064a5e8880082c64$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(ISOTimezoneParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 10);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $lU1Um.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $b6459ccd5f620218$export$6497f4c0ecdfba8e)((0, $051177df0aca266b$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $b6459ccd5f620218$export$6497f4c0ecdfba8e)((0, $051177df0aca266b$export$a7ee192b982af9c1).basic, dateString);
                    case 'xxxx':
                        return (0, $b6459ccd5f620218$export$6497f4c0ecdfba8e)((0, $051177df0aca266b$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $b6459ccd5f620218$export$6497f4c0ecdfba8e)((0, $051177df0aca266b$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $b6459ccd5f620218$export$6497f4c0ecdfba8e)((0, $051177df0aca266b$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");


var $a7da77187fed58bc$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(TimestampSecondsParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 40);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $lU1Um.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $b6459ccd5f620218$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));




var $lU1Um = parcelRequire("lU1Um");

var $6o8oQ = parcelRequire("6o8oQ");



var $8k2Uc = parcelRequire("8k2Uc");


var $a1ef8dbd11b8f1cc$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $556cd23fac47f479$export$2e2bcd8739ae039)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $9a0d8175c92b6fe5$export$2e2bcd8739ae039)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $05dd595adecf7ee3$export$2e2bcd8739ae039)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "priority", 20);
        (0, $8k2Uc.default)((0, $6o8oQ.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $lU1Um.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $b6459ccd5f620218$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $c2444e20e68ca576$export$7acfa6ed01010e37));


var $9d59b30f3847eaac$export$19131010e7fd8373 = {
    G: new (0, $318829e874cc878f$export$8e5a1d3f85a9688)(),
    y: new (0, $0596f5afc4a4b16c$export$48d352de7cd4a988)(),
    Y: new (0, $eef9463b66019c97$export$b8ef38dfcf05d5db)(),
    R: new (0, $baeee7633347bf0d$export$951d1df011fde06f)(),
    u: new (0, $abe1ecb31ba528e1$export$bad9d2ea38e8f1a)(),
    Q: new (0, $76fad13316b8a028$export$5cb0f701186dde1d)(),
    q: new (0, $ae3702fcafb04fc0$export$300c0c2990e20e6d)(),
    M: new (0, $add8dbe52231df4e$export$400dd8b40ef138a3)(),
    L: new (0, $e6520c2469c82330$export$1d7eaa53eaa5deba)(),
    w: new (0, $dcc1b052f0d79807$export$c4005ffc174e07c0)(),
    I: new (0, $86b2d476541bbc93$export$6fc8dbedd560a6af)(),
    d: new (0, $d9b05360d01a56c5$export$e8d4b28a20981dd2)(),
    D: new (0, $05a97b4a3077c4e6$export$6cfe0d613455f615)(),
    E: new (0, $7419cd47b07154a5$export$1b03c8b76262f7bd)(),
    e: new (0, $6861ce268f866bc5$export$44d1c127ab42c480)(),
    c: new (0, $484e531d8aee2455$export$e447a647caaaec1d)(),
    i: new (0, $811f0ca42fbac91f$export$693fb1e525095b2a)(),
    a: new (0, $18ce478397a76661$export$8d1e08492351df91)(),
    b: new (0, $15c191cd633e89cd$export$73ca2bd0a17d273)(),
    B: new (0, $8aa5c95c4bf3d570$export$bb9212adf05373db)(),
    h: new (0, $e51f91737bbaea68$export$8a04050a727a1756)(),
    H: new (0, $f85882a2f6e58f7b$export$e56f4dea2c3e56dd)(),
    K: new (0, $7b582eb7d2dcecbd$export$cbbe855312f87d77)(),
    k: new (0, $225f8e2c69bdea19$export$6008046d2b34b6a5)(),
    m: new (0, $e9a86c53cb8942bc$export$2b52670d9e2be53)(),
    s: new (0, $a04bb908e6e983e5$export$94d46d540cf1366a)(),
    S: new (0, $e57775ad30d330d0$export$b8e6f8b2d70893b1)(),
    X: new (0, $0f64a49f96cd07a5$export$104d901d49fea29b)(),
    x: new (0, $064a5e8880082c64$export$12910e5204b52b9)(),
    t: new (0, $a7da77187fed58bc$export$2cd8bf877a05e96)(),
    T: new (0, $a1ef8dbd11b8f1cc$export$6d8f69c6906d6368)()
};



// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $3584b89e801f0f21$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $3584b89e801f0f21$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $3584b89e801f0f21$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $3584b89e801f0f21$var$doubleQuoteRegExp = /''/g;
var $3584b89e801f0f21$var$notWhitespaceRegExp = /\S/;
var $3584b89e801f0f21$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $3584b89e801f0f21$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $4744e1d78c565baf$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $926a271460757e7d$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $412d0f55e7475408$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($3584b89e801f0f21$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $557c7540f4f0608c$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $557c7540f4f0608c$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($3584b89e801f0f21$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $75d0b34c22ad1d7e$export$2e2bcd8739ae039)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $69d29ec00526bf03$export$c6b49d6dceb604a1)(token)) (0, $69d29ec00526bf03$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $69d29ec00526bf03$export$c6cc36aa33304772)(token)) (0, $69d29ec00526bf03$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $9d59b30f3847eaac$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($3584b89e801f0f21$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $3584b89e801f0f21$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $8ZNRc.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $3584b89e801f0f21$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $1cfb31ec8ccc0e14$export$2e2bcd8739ae039)(date, (0, $b10430f8159ac739$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = (0, $75d0b34c22ad1d7e$export$2e2bcd8739ae039)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $8188f9a897f4ea0b$export$2e2bcd8739ae039)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $3584b89e801f0f21$var$cleanEscapedString(input) {
    return input.match($3584b89e801f0f21$var$escapedStringRegExp)[1].replace($3584b89e801f0f21$var$doubleQuoteRegExp, "'");
}





function $14b5a61b311d2441$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var hours = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)(dirtyHours);
    date.setHours(hours);
    return date;
}





function $c2e67db21573b4f9$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}






function $6e6e8360fe9023c5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}



function $d019c4656b2d7f28$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var month = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $6e6e8360fe9023c5$export$2e2bcd8739ae039)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}





function $ecf86fffbfd8701a$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}





function $c494e831a158654b$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var year = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}





function $22331f9a0b7afd9d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $e4f06dd1a1662e9b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}






function $08d09cbda036f4f4$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $4744e1d78c565baf$export$430a3269e24b912e)();
    var weekStartsOn = (0, $ab1ccf67772a828b$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $253bcceb10005ffe$export$2e2bcd8739ae039(dirtyDate) {
    (0, $31b002675a35c784$export$2e2bcd8739ae039)(1, arguments);
    var cleanDate = (0, $10aa39cd648f2fb9$export$2e2bcd8739ae039)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


var $8be8116271836576$var$DateFnsUtils = /** @class */ function() {
    function DateFnsUtils(_a) {
        var locale = (_a === void 0 ? {} : _a).locale;
        this.yearFormat = "yyyy";
        this.yearMonthFormat = "MMMM yyyy";
        this.dateTime12hFormat = "MMMM do hh:mm aaaa";
        this.dateTime24hFormat = "MMMM do HH:mm";
        this.time12hFormat = "hh:mm a";
        this.time24hFormat = "HH:mm";
        this.dateFormat = "MMMM do";
        this.locale = locale;
    }
    // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
    // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
    DateFnsUtils.prototype.addDays = function(value, count) {
        return (0, $70733e4e50d2f19f$export$2e2bcd8739ae039)(value, count);
    };
    DateFnsUtils.prototype.isValid = function(value) {
        return (0, $fd484e33268961be$export$2e2bcd8739ae039)(this.date(value));
    };
    DateFnsUtils.prototype.getDiff = function(value, comparing) {
        return (0, $3770653b55b8c767$export$2e2bcd8739ae039)(value, this.date(comparing));
    };
    DateFnsUtils.prototype.isAfter = function(value, comparing) {
        return (0, $8c6c51519b18afe3$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.isBefore = function(value, comparing) {
        return (0, $9cc564b438244500$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.startOfDay = function(value) {
        return (0, $fd3041540393caa2$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.endOfDay = function(value) {
        return (0, $992736cad2b87886$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.getHours = function(value) {
        return (0, $ec0f5df76896d512$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.setHours = function(value, count) {
        return (0, $14b5a61b311d2441$export$2e2bcd8739ae039)(value, count);
    };
    DateFnsUtils.prototype.setMinutes = function(value, count) {
        return (0, $c2e67db21573b4f9$export$2e2bcd8739ae039)(value, count);
    };
    DateFnsUtils.prototype.getSeconds = function(value) {
        return (0, $8714c9d014072134$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.setSeconds = function(value, count) {
        return (0, $ecf86fffbfd8701a$export$2e2bcd8739ae039)(value, count);
    };
    DateFnsUtils.prototype.isSameDay = function(value, comparing) {
        return (0, $0ce61fa4b27488b9$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.isSameMonth = function(value, comparing) {
        return (0, $4a5e465c3141389c$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.isSameYear = function(value, comparing) {
        return (0, $e70d44be99fd87cb$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.isSameHour = function(value, comparing) {
        return (0, $769c1f6f55afe554$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.startOfMonth = function(value) {
        return (0, $22331f9a0b7afd9d$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.endOfMonth = function(value) {
        return (0, $e4f06dd1a1662e9b$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.getYear = function(value) {
        return (0, $1a65a7e3c2d81ff0$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.setYear = function(value, count) {
        return (0, $c494e831a158654b$export$2e2bcd8739ae039)(value, count);
    };
    DateFnsUtils.prototype.date = function(value) {
        if (typeof value === "undefined") return new Date();
        if (value === null) return null;
        return new Date(value);
    };
    DateFnsUtils.prototype.parse = function(value, formatString) {
        if (value === "") return null;
        return (0, $3584b89e801f0f21$export$2e2bcd8739ae039)(value, formatString, new Date(), {
            locale: this.locale
        });
    };
    DateFnsUtils.prototype.format = function(date, formatString) {
        return (0, $e12159bb4a72b327$export$2e2bcd8739ae039)(date, formatString, {
            locale: this.locale
        });
    };
    DateFnsUtils.prototype.isEqual = function(date, comparing) {
        if (date === null && comparing === null) return true;
        return (0, $20c4b33069c49f10$export$2e2bcd8739ae039)(date, comparing);
    };
    DateFnsUtils.prototype.isNull = function(date) {
        return date === null;
    };
    DateFnsUtils.prototype.isAfterDay = function(date, value) {
        return (0, $8c6c51519b18afe3$export$2e2bcd8739ae039)(date, (0, $992736cad2b87886$export$2e2bcd8739ae039)(value));
    };
    DateFnsUtils.prototype.isBeforeDay = function(date, value) {
        return (0, $9cc564b438244500$export$2e2bcd8739ae039)(date, (0, $fd3041540393caa2$export$2e2bcd8739ae039)(value));
    };
    DateFnsUtils.prototype.isBeforeYear = function(date, value) {
        return (0, $9cc564b438244500$export$2e2bcd8739ae039)(date, (0, $253bcceb10005ffe$export$2e2bcd8739ae039)(value));
    };
    DateFnsUtils.prototype.isAfterYear = function(date, value) {
        return (0, $8c6c51519b18afe3$export$2e2bcd8739ae039)(date, (0, $0c69cb6fa50bee26$export$2e2bcd8739ae039)(value));
    };
    DateFnsUtils.prototype.formatNumber = function(numberToFormat) {
        return numberToFormat;
    };
    DateFnsUtils.prototype.getMinutes = function(date) {
        return date.getMinutes();
    };
    DateFnsUtils.prototype.getMonth = function(date) {
        return date.getMonth();
    };
    DateFnsUtils.prototype.setMonth = function(date, count) {
        return (0, $d019c4656b2d7f28$export$2e2bcd8739ae039)(date, count);
    };
    DateFnsUtils.prototype.getMeridiemText = function(ampm) {
        return ampm === "am" ? "AM" : "PM";
    };
    DateFnsUtils.prototype.getNextMonth = function(date) {
        return (0, $f34a916b38b656d5$export$2e2bcd8739ae039)(date, 1);
    };
    DateFnsUtils.prototype.getPreviousMonth = function(date) {
        return (0, $f34a916b38b656d5$export$2e2bcd8739ae039)(date, -1);
    };
    DateFnsUtils.prototype.getMonthArray = function(date) {
        var firstMonth = (0, $253bcceb10005ffe$export$2e2bcd8739ae039)(date);
        var monthArray = [
            firstMonth
        ];
        while(monthArray.length < 12){
            var prevMonth = monthArray[monthArray.length - 1];
            monthArray.push(this.getNextMonth(prevMonth));
        }
        return monthArray;
    };
    DateFnsUtils.prototype.mergeDateAndTime = function(date, time) {
        return this.setMinutes(this.setHours(date, this.getHours(time)), this.getMinutes(time));
    };
    DateFnsUtils.prototype.getWeekdays = function() {
        var _this = this;
        var now = new Date();
        return (0, $3c960c2b5187ea9f$export$2e2bcd8739ae039)({
            start: (0, $08d09cbda036f4f4$export$2e2bcd8739ae039)(now, {
                locale: this.locale
            }),
            end: (0, $4a2ac0b1bfa4e974$export$2e2bcd8739ae039)(now, {
                locale: this.locale
            })
        }).map(function(day) {
            return _this.format(day, "EEEEEE");
        });
    };
    DateFnsUtils.prototype.getWeekArray = function(date) {
        var start = (0, $08d09cbda036f4f4$export$2e2bcd8739ae039)((0, $22331f9a0b7afd9d$export$2e2bcd8739ae039)(date), {
            locale: this.locale
        });
        var end = (0, $4a2ac0b1bfa4e974$export$2e2bcd8739ae039)((0, $e4f06dd1a1662e9b$export$2e2bcd8739ae039)(date), {
            locale: this.locale
        });
        var count = 0;
        var current = start;
        var nestedWeeks = [];
        while((0, $9cc564b438244500$export$2e2bcd8739ae039)(current, end)){
            var weekNumber = Math.floor(count / 7);
            nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
            nestedWeeks[weekNumber].push(current);
            current = (0, $70733e4e50d2f19f$export$2e2bcd8739ae039)(current, 1);
            count += 1;
        }
        return nestedWeeks;
    };
    DateFnsUtils.prototype.getYearRange = function(start, end) {
        var startDate = (0, $253bcceb10005ffe$export$2e2bcd8739ae039)(start);
        var endDate = (0, $0c69cb6fa50bee26$export$2e2bcd8739ae039)(end);
        var years = [];
        var current = startDate;
        while((0, $9cc564b438244500$export$2e2bcd8739ae039)(current, endDate)){
            years.push(current);
            current = (0, $505253a3e23d976d$export$2e2bcd8739ae039)(current, 1);
        }
        return years;
    };
    // displaying methpds
    DateFnsUtils.prototype.getCalendarHeaderText = function(date) {
        return this.format(date, this.yearMonthFormat);
    };
    DateFnsUtils.prototype.getYearText = function(date) {
        return this.format(date, "yyyy");
    };
    DateFnsUtils.prototype.getDatePickerHeaderText = function(date) {
        return this.format(date, "EEE, MMM d");
    };
    DateFnsUtils.prototype.getDateTimePickerHeaderText = function(date) {
        return this.format(date, "MMM d");
    };
    DateFnsUtils.prototype.getMonthText = function(date) {
        return this.format(date, "MMMM");
    };
    DateFnsUtils.prototype.getDayText = function(date) {
        return this.format(date, "d");
    };
    DateFnsUtils.prototype.getHourText = function(date, ampm) {
        return this.format(date, ampm ? "hh" : "HH");
    };
    DateFnsUtils.prototype.getMinuteText = function(date) {
        return this.format(date, "mm");
    };
    DateFnsUtils.prototype.getSecondText = function(date) {
        return this.format(date, "ss");
    };
    return DateFnsUtils;
}();
var $8be8116271836576$export$2e2bcd8739ae039 = $8be8116271836576$var$DateFnsUtils;




var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $kfLRg = parcelRequire("kfLRg");

var $82OGZ = parcelRequire("82OGZ");




var $1d96cd50cde517a6$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the root element if `underline="none"`. */ underlineNone: {
        textDecoration: 'none'
    },
    /* Styles applied to the root element if `underline="hover"`. */ underlineHover: {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    },
    /* Styles applied to the root element if `underline="always"`. */ underlineAlways: {
        textDecoration: 'underline'
    },
    // Same reset as ButtonBase.root
    /* Styles applied to the root element if `component="button"`. */ button: {
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        '-moz-appearance': 'none',
        // Reset
        '-webkit-appearance': 'none',
        // Reset
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        '&$focusVisible': {
            outline: 'auto'
        }
    },
    /* Pseudo-class applied to the root element if the link is keyboard focused. */ focusVisible: {}
};
var $1d96cd50cde517a6$var$Link = /*#__PURE__*/ $gIfym.forwardRef(function Link(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$component = props.component, component = _props$component === void 0 ? 'a' : _props$component, onBlur = props.onBlur, onFocus = props.onFocus, TypographyClasses = props.TypographyClasses, _props$underline = props.underline, underline = _props$underline === void 0 ? 'hover' : _props$underline, _props$variant = props.variant, variant = _props$variant === void 0 ? 'inherit' : _props$variant, other = (0, $f6Qba.default)(props, [
        "classes",
        "className",
        "color",
        "component",
        "onBlur",
        "onFocus",
        "TypographyClasses",
        "underline",
        "variant"
    ]);
    var _useIsFocusVisible = (0, $c26c53624e49625a$export$2e2bcd8739ae039)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState = $gIfym.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    var handlerRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    var handleBlur = function handleBlur(event) {
        if (focusVisible) {
            onBlurVisible();
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    };
    var handleFocus = function handleFocus(event) {
        if (isFocusVisible(event)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ $gIfym.createElement((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, classes["underline".concat((0, $kfLRg.default)(underline))], className, focusVisible && classes.focusVisible, component === 'button' && classes.button),
        classes: TypographyClasses,
        color: color,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        variant: variant
    }, other));
});
var $1d96cd50cde517a6$export$2e2bcd8739ae039 = (0, $82OGZ.default)($1d96cd50cde517a6$export$9dd6ff9ea0189349, {
    name: 'MuiLink'
})($1d96cd50cde517a6$var$Link);






var $6IRuR = parcelRequire("6IRuR");
const $bedcb082e4938fab$var$useStyles = (0, $hQJVM.default)({
    dateContainer: {
        paddingLeft: 18,
        paddingRight: 18,
        paddingTop: 6,
        paddingBottom: 18,
        display: 'flex',
        flexFlow: 'row'
    },
    dateContainerColumn: {
        display: 'flex',
        flexFlow: 'column'
    },
    formControl: {
        margin: 8,
        width: 120
    }
});
const $bedcb082e4938fab$var$SelectWindow = ({ windowOptions: windowOptions, window: window, setWindow: setWindow })=>{
    const classes = $bedcb082e4938fab$var$useStyles();
    const [anchorEl, setAnchorEl] = (0, $gIfym.useState)(null);
    const [startDate, setStartDate] = (0, $gIfym.useState)(null);
    const [endDate, setEndDate] = (0, $gIfym.useState)(null);
    const [intervalString, setIntervalString] = (0, $gIfym.useState)(null);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const handleStartDateChange = (date)=>{
        if ((0, $fd484e33268961be$export$2e2bcd8739ae039)(date)) setStartDate((0, $fd3041540393caa2$export$2e2bcd8739ae039)(date));
    };
    const handleEndDateChange = (date)=>{
        if ((0, $fd484e33268961be$export$2e2bcd8739ae039)(date)) setEndDate((0, $992736cad2b87886$export$2e2bcd8739ae039)(date));
    };
    const handleSubmitPresetDates = (dateString)=>{
        setWindow(dateString);
        setStartDate(null);
        setEndDate(null);
        handleClose();
    };
    const handleSubmitCustomDates = ()=>{
        if (intervalString !== null) {
            setWindow(intervalString);
            handleClose();
        }
    };
    (0, $gIfym.useEffect)(()=>{
        if (startDate !== null && endDate !== null) {
            // Note: getTimezoneOffset() is calculated based on current system locale, NOT date object
            let adjustedStartDate = new Date(startDate - startDate.getTimezoneOffset() * 60000);
            let adjustedEndDate = new Date(endDate - endDate.getTimezoneOffset() * 60000);
            setIntervalString(adjustedStartDate.toISOString().split('.')[0] + "Z" + "," + adjustedEndDate.toISOString().split('.')[0] + "Z");
        }
    }, [
        startDate,
        endDate
    ]);
    const open = Boolean(anchorEl);
    const id = open ? 'date-range-popover' : undefined;
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $1f3c3d6fcb879aaf$export$2e2bcd8739ae039), {
                className: classes.formControl,
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $27b2411b49a9a0ff$export$2e2bcd8739ae039), {
                    id: "filled-read-only-input",
                    label: "Date Range",
                    value: (0, $6IRuR.get)((0, $6IRuR.find)(windowOptions, {
                        value: window
                    }), "name", "Custom"),
                    onClick: (e)=>handleClick(e),
                    inputProps: {
                        readOnly: true,
                        style: {
                            cursor: 'pointer'
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $154807aaa727960c$export$2e2bcd8739ae039), {
                id: id,
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    className: classes.dateContainer,
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                            className: classes.dateContainerColumn,
                            children: [
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $30b5b3be1499928f$export$3a1a48c8f6ef640e), {
                                    utils: (0, $8be8116271836576$export$2e2bcd8739ae039),
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $a8e091f918fea129$export$d8c44f501031ee7c), {
                                            style: {
                                                width: '144px'
                                            },
                                            autoOk: true,
                                            disableToolbar: true,
                                            variant: "inline",
                                            format: "MM/dd/yyyy",
                                            margin: "normal",
                                            id: "date-picker-start",
                                            label: "Start Date",
                                            value: startDate,
                                            maxDate: new Date(),
                                            maxDateMessage: "Date should not be after today.",
                                            onChange: handleStartDateChange,
                                            KeyboardButtonProps: {
                                                'aria-label': 'change date'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $a8e091f918fea129$export$d8c44f501031ee7c), {
                                            style: {
                                                width: '144px'
                                            },
                                            autoOk: true,
                                            disableToolbar: true,
                                            variant: "inline",
                                            format: "MM/dd/yyyy",
                                            margin: "normal",
                                            id: "date-picker-end",
                                            label: "End Date",
                                            value: endDate,
                                            maxDate: new Date(),
                                            maxDateMessage: "Date should not be after today.",
                                            onChange: handleEndDateChange,
                                            KeyboardButtonProps: {
                                                'aria-label': 'change date'
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b6f198a9b7d0786c$export$2e2bcd8739ae039), {
                                        style: {
                                            marginTop: 16
                                        },
                                        variant: "contained",
                                        color: "default",
                                        onClick: handleSubmitCustomDates,
                                        children: "Apply"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                            className: classes.dateContainerColumn,
                            style: {
                                paddingTop: 12,
                                marginLeft: 18
                            },
                            children: windowOptions.map((opt)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $1d96cd50cde517a6$export$2e2bcd8739ae039), {
                                        style: {
                                            cursor: "pointer"
                                        },
                                        value: opt.value,
                                        onClick: ()=>handleSubmitPresetDates(opt.value),
                                        children: opt.name
                                    }, opt.value)
                                }, opt.value))
                        })
                    ]
                })
            })
        ]
    });
};
var $bedcb082e4938fab$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).memo($bedcb082e4938fab$var$SelectWindow);


const $b9c347917b2583aa$var$useStyles = (0, $hQJVM.default)({
    wrapper: {
        display: 'inline-flex'
    },
    formControl: {
        margin: 8,
        minWidth: 120
    }
});
function $b9c347917b2583aa$var$EditControl({ windowOptions: windowOptions, window: window, setWindow: setWindow, aggregationOptions: aggregationOptions, aggregateBy: aggregateBy, setAggregateBy: setAggregateBy, accumulateOptions: accumulateOptions, accumulate: accumulate, setAccumulate: setAccumulate, currencyOptions: currencyOptions, currency: currency, setCurrency: setCurrency }) {
    const classes = $b9c347917b2583aa$var$useStyles();
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: classes.wrapper,
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bedcb082e4938fab$export$2e2bcd8739ae039), {
                windowOptions: windowOptions,
                window: window,
                setWindow: setWindow
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $1f3c3d6fcb879aaf$export$2e2bcd8739ae039), {
                className: classes.formControl,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $83d8148cf52783d5$export$2e2bcd8739ae039), {
                        id: "aggregation-select-label",
                        children: "Breakdown"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ea71a0b004fd8af3$export$2e2bcd8739ae039), {
                        id: "aggregation-select",
                        value: aggregateBy,
                        onChange: (e)=>{
                            setAggregateBy(e.target.value);
                        },
                        children: aggregationOptions.map((opt)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c027d6b11891bde0$export$2e2bcd8739ae039), {
                                value: opt.value,
                                children: opt.name
                            }, opt.value))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $1f3c3d6fcb879aaf$export$2e2bcd8739ae039), {
                className: classes.formControl,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $83d8148cf52783d5$export$2e2bcd8739ae039), {
                        id: "accumulate-label",
                        children: "Resolution"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ea71a0b004fd8af3$export$2e2bcd8739ae039), {
                        id: "accumulate",
                        value: accumulate,
                        onChange: (e)=>setAccumulate(e.target.value),
                        children: accumulateOptions.map((opt)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c027d6b11891bde0$export$2e2bcd8739ae039), {
                                value: opt.value,
                                children: opt.name
                            }, opt.value))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $1f3c3d6fcb879aaf$export$2e2bcd8739ae039), {
                className: classes.formControl,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $83d8148cf52783d5$export$2e2bcd8739ae039), {
                        id: "currency-label",
                        children: "Currency"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ea71a0b004fd8af3$export$2e2bcd8739ae039), {
                        id: "currency",
                        value: currency,
                        onChange: (e)=>setCurrency(e.target.value),
                        children: currencyOptions?.map((currency)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c027d6b11891bde0$export$2e2bcd8739ae039), {
                                value: currency,
                                children: currency
                            }, currency))
                    })
                ]
            })
        ]
    });
}
var $b9c347917b2583aa$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).memo($b9c347917b2583aa$var$EditControl);




var $gIfym = parcelRequire("gIfym");

var $6IRuR = parcelRequire("6IRuR");
var $127ca2d9c2803d70$exports = {};
"use strict";


Object.defineProperty($127ca2d9c2803d70$exports, "__esModule", {
    value: true
});
$127ca2d9c2803d70$exports.default = void 0;

var $127ca2d9c2803d70$var$React = $2794e01ecb82119c$exports((parcelRequire("gIfym")));

var $127ca2d9c2803d70$var$_createSvgIcon = $9b6be45f16d1a28c$exports((parcelRequire("kKaK5")));
var $127ca2d9c2803d70$var$_default = (0, $127ca2d9c2803d70$var$_createSvgIcon.default)(/*#__PURE__*/ $127ca2d9c2803d70$var$React.createElement("path", {
    d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
}), 'GetApp');
$127ca2d9c2803d70$exports.default = $127ca2d9c2803d70$var$_default;




var $k2R8s = parcelRequire("k2R8s");

var $3KNdx = parcelRequire("3KNdx");

var $f6Qba = parcelRequire("f6Qba");

var $8k2Uc = parcelRequire("8k2Uc");

var $gIfym = parcelRequire("gIfym");



var $ba4yE = parcelRequire("ba4yE");

var $14Uvj = parcelRequire("14Uvj");

var $aUprr = parcelRequire("aUprr");

var $82OGZ = parcelRequire("82OGZ");

var $kfLRg = parcelRequire("kfLRg");


var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $1316b03565a42898$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
var $1316b03565a42898$var$timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        'Edge',
        'Trident',
        'Firefox'
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if ($1316b03565a42898$var$isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function $1316b03565a42898$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $1316b03565a42898$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $1316b03565a42898$var$timeoutDuration);
        }
    };
}
var $1316b03565a42898$var$supportsMicroTasks = $1316b03565a42898$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $1316b03565a42898$var$debounce = $1316b03565a42898$var$supportsMicroTasks ? $1316b03565a42898$var$microtaskDebounce : $1316b03565a42898$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $1316b03565a42898$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $1316b03565a42898$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $1316b03565a42898$var$getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $1316b03565a42898$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $1316b03565a42898$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $1316b03565a42898$var$getScrollParent($1316b03565a42898$var$getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function $1316b03565a42898$var$getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var $1316b03565a42898$var$isIE11 = $1316b03565a42898$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $1316b03565a42898$var$isIE10 = $1316b03565a42898$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $1316b03565a42898$var$isIE(version) {
    if (version === 11) return $1316b03565a42898$var$isIE11;
    if (version === 10) return $1316b03565a42898$var$isIE10;
    return $1316b03565a42898$var$isIE11 || $1316b03565a42898$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $1316b03565a42898$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $1316b03565a42898$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && $1316b03565a42898$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $1316b03565a42898$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $1316b03565a42898$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || $1316b03565a42898$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $1316b03565a42898$var$getRoot(node) {
    if (node.parentNode !== null) return $1316b03565a42898$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $1316b03565a42898$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($1316b03565a42898$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $1316b03565a42898$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $1316b03565a42898$var$getRoot(element1);
    if (element1root.host) return $1316b03565a42898$var$findCommonOffsetParent(element1root.host, element2);
    else return $1316b03565a42898$var$findCommonOffsetParent(element1, $1316b03565a42898$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $1316b03565a42898$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $1316b03565a42898$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $1316b03565a42898$var$getScroll(element, 'top');
    var scrollLeft = $1316b03565a42898$var$getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $1316b03565a42898$var$getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}
function $1316b03565a42898$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $1316b03565a42898$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function $1316b03565a42898$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $1316b03565a42898$var$isIE(10) && getComputedStyle(html);
    return {
        height: $1316b03565a42898$var$getSize('Height', body, html, computedStyle),
        width: $1316b03565a42898$var$getSize('Width', body, html, computedStyle)
    };
}
var $1316b03565a42898$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $1316b03565a42898$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $1316b03565a42898$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $1316b03565a42898$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $1316b03565a42898$var$getClientRect(offsets) {
    return $1316b03565a42898$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $1316b03565a42898$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($1316b03565a42898$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $1316b03565a42898$var$getScroll(element, 'top');
            var scrollLeft = $1316b03565a42898$var$getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? $1316b03565a42898$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $1316b03565a42898$var$getStyleComputedProperty(element);
        horizScrollbar -= $1316b03565a42898$var$getBordersSize(styles, 'x');
        vertScrollbar -= $1316b03565a42898$var$getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $1316b03565a42898$var$getClientRect(result);
}
function $1316b03565a42898$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $1316b03565a42898$var$isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = $1316b03565a42898$var$getBoundingClientRect(children);
    var parentRect = $1316b03565a42898$var$getBoundingClientRect(parent);
    var scrollParent = $1316b03565a42898$var$getScrollParent(children);
    var styles = $1316b03565a42898$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $1316b03565a42898$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $1316b03565a42898$var$includeScroll(offsets, parent);
    return offsets;
}
function $1316b03565a42898$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $1316b03565a42898$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $1316b03565a42898$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $1316b03565a42898$var$getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $1316b03565a42898$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $1316b03565a42898$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if ($1316b03565a42898$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = $1316b03565a42898$var$getParentNode(element);
    if (!parentNode) return false;
    return $1316b03565a42898$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $1316b03565a42898$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $1316b03565a42898$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $1316b03565a42898$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $1316b03565a42898$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $1316b03565a42898$var$getFixedPositionOffsetParent(popper) : $1316b03565a42898$var$findCommonOffsetParent(popper, $1316b03565a42898$var$getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = $1316b03565a42898$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = $1316b03565a42898$var$getScrollParent($1316b03565a42898$var$getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $1316b03565a42898$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !$1316b03565a42898$var$isFixed(offsetParent)) {
            var _getWindowSizes = $1316b03565a42898$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $1316b03565a42898$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1316b03565a42898$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = $1316b03565a42898$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $1316b03565a42898$var$_extends({
            key: key
        }, rects[key], {
            area: $1316b03565a42898$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $1316b03565a42898$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $1316b03565a42898$var$getFixedPositionOffsetParent(popper) : $1316b03565a42898$var$findCommonOffsetParent(popper, $1316b03565a42898$var$getReferenceNode(reference));
    return $1316b03565a42898$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $1316b03565a42898$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $1316b03565a42898$var$getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $1316b03565a42898$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = $1316b03565a42898$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$1316b03565a42898$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $1316b03565a42898$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $1316b03565a42898$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $1316b03565a42898$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $1316b03565a42898$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $1316b03565a42898$var$findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $1316b03565a42898$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $1316b03565a42898$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $1316b03565a42898$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $1316b03565a42898$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $1316b03565a42898$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $1316b03565a42898$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $1316b03565a42898$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = $1316b03565a42898$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $1316b03565a42898$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $1316b03565a42898$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $1316b03565a42898$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($1316b03565a42898$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[$1316b03565a42898$var$getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $1316b03565a42898$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $1316b03565a42898$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $1316b03565a42898$var$attachToScrollParents($1316b03565a42898$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $1316b03565a42898$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $1316b03565a42898$var$getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $1316b03565a42898$var$getScrollParent(reference);
    $1316b03565a42898$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $1316b03565a42898$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $1316b03565a42898$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $1316b03565a42898$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $1316b03565a42898$var$getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $1316b03565a42898$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $1316b03565a42898$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $1316b03565a42898$var$isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $1316b03565a42898$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && $1316b03565a42898$var$isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $1316b03565a42898$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $1316b03565a42898$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $1316b03565a42898$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $1316b03565a42898$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $1316b03565a42898$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $1316b03565a42898$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $1316b03565a42898$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $1316b03565a42898$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $1316b03565a42898$var$setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $1316b03565a42898$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $1316b03565a42898$var$isFirefox = $1316b03565a42898$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1316b03565a42898$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $1316b03565a42898$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $1316b03565a42898$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $1316b03565a42898$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $1316b03565a42898$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$1316b03565a42898$var$isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $1316b03565a42898$var$getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $1316b03565a42898$var$_extends({}, attributes, data.attributes);
    data.styles = $1316b03565a42898$var$_extends({}, styles, data.styles);
    data.arrowStyles = $1316b03565a42898$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $1316b03565a42898$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $1316b03565a42898$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1316b03565a42898$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$1316b03565a42898$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = $1316b03565a42898$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $1316b03565a42898$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $1316b03565a42898$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $1316b03565a42898$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $1316b03565a42898$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $1316b03565a42898$var$getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $1316b03565a42898$var$placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var $1316b03565a42898$var$validPlacements = $1316b03565a42898$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $1316b03565a42898$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $1316b03565a42898$var$validPlacements.indexOf(placement);
    var arr = $1316b03565a42898$var$validPlacements.slice(index + 1).concat($1316b03565a42898$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $1316b03565a42898$var$BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1316b03565a42898$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($1316b03565a42898$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $1316b03565a42898$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = $1316b03565a42898$var$getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case $1316b03565a42898$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $1316b03565a42898$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $1316b03565a42898$var$clockwise(placement);
            break;
        case $1316b03565a42898$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $1316b03565a42898$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = $1316b03565a42898$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $1316b03565a42898$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $1316b03565a42898$var$_extends({}, data.offsets.popper, $1316b03565a42898$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $1316b03565a42898$var$runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1316b03565a42898$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $1316b03565a42898$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = $1316b03565a42898$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $1316b03565a42898$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($1316b03565a42898$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $1316b03565a42898$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($1316b03565a42898$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $1316b03565a42898$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if ($1316b03565a42898$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $1316b03565a42898$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1316b03565a42898$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $1316b03565a42898$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $1316b03565a42898$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $1316b03565a42898$var$getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = $1316b03565a42898$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $1316b03565a42898$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return $1316b03565a42898$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = $1316b03565a42898$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1316b03565a42898$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: $1316b03565a42898$var$defineProperty({}, side, reference[side]),
            end: $1316b03565a42898$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $1316b03565a42898$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1316b03565a42898$var$hide(data) {
    if (!$1316b03565a42898$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = $1316b03565a42898$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $1316b03565a42898$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = $1316b03565a42898$var$getOppositePlacement(placement);
    data.offsets.popper = $1316b03565a42898$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $1316b03565a42898$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1316b03565a42898$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1316b03565a42898$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1316b03565a42898$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1316b03565a42898$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1316b03565a42898$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1316b03565a42898$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $1316b03565a42898$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1316b03565a42898$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1316b03565a42898$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $1316b03565a42898$var$applyStyle,
        /** @prop {Function} */ onLoad: $1316b03565a42898$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $1316b03565a42898$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $1316b03565a42898$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $1316b03565a42898$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $1316b03565a42898$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $1316b03565a42898$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $1316b03565a42898$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($1316b03565a42898$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $1316b03565a42898$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $1316b03565a42898$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $1316b03565a42898$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $1316b03565a42898$var$createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return $1316b03565a42898$var$update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return $1316b03565a42898$var$destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return $1316b03565a42898$var$enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return $1316b03565a42898$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $1316b03565a42898$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
$1316b03565a42898$var$Popper.placements = $1316b03565a42898$var$placements;
$1316b03565a42898$var$Popper.Defaults = $1316b03565a42898$var$Defaults;
var $1316b03565a42898$export$2e2bcd8739ae039 = $1316b03565a42898$var$Popper;




var $6VBRO = parcelRequire("6VBRO");




function $ac340bf9f5305593$var$flipPlacement(placement, theme) {
    var direction = theme && theme.direction || 'ltr';
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $ac340bf9f5305593$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
var $ac340bf9f5305593$var$useEnhancedEffect = typeof window !== 'undefined' ? $gIfym.useLayoutEffect : $gIfym.useEffect;
var $ac340bf9f5305593$var$defaultPopperOptions = {};
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
 */ var $ac340bf9f5305593$var$Popper = /*#__PURE__*/ $gIfym.forwardRef(function Popper(props, ref) {
    var anchorEl = props.anchorEl, children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, modifiers = props.modifiers, open = props.open, _props$placement = props.placement, initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement, _props$popperOptions = props.popperOptions, popperOptions = _props$popperOptions === void 0 ? $ac340bf9f5305593$var$defaultPopperOptions : _props$popperOptions, popperRefProp = props.popperRef, style = props.style, _props$transition = props.transition, transition = _props$transition === void 0 ? false : _props$transition, other = (0, $f6Qba.default)(props, [
        "anchorEl",
        "children",
        "container",
        "disablePortal",
        "keepMounted",
        "modifiers",
        "open",
        "placement",
        "popperOptions",
        "popperRef",
        "style",
        "transition"
    ]);
    var tooltipRef = $gIfym.useRef(null);
    var ownRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(tooltipRef, ref);
    var popperRef = $gIfym.useRef(null);
    var handlePopperRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    var handlePopperRefRef = $gIfym.useRef(handlePopperRef);
    $ac340bf9f5305593$var$useEnhancedEffect(function() {
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $gIfym.useImperativeHandle(popperRefProp, function() {
        return popperRef.current;
    }, []);
    var _React$useState = $gIfym.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var theme = (0, $6VBRO.default)();
    var rtlPlacement = $ac340bf9f5305593$var$flipPlacement(initialPlacement, theme);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ var _React$useState2 = $gIfym.useState(rtlPlacement), placement = _React$useState2[0], setPlacement = _React$useState2[1];
    $gIfym.useEffect(function() {
        if (popperRef.current) popperRef.current.update();
    });
    var handleOpen = $gIfym.useCallback(function() {
        if (!tooltipRef.current || !anchorEl || !open) return;
        if (popperRef.current) {
            popperRef.current.destroy();
            handlePopperRefRef.current(null);
        }
        var handlePopperUpdate = function handlePopperUpdate(data) {
            setPlacement(data.placement);
        };
        var resolvedAnchorEl = $ac340bf9f5305593$var$getAnchorEl(anchorEl);
        var box;
        var popper = new (0, $1316b03565a42898$export$2e2bcd8739ae039)($ac340bf9f5305593$var$getAnchorEl(anchorEl), tooltipRef.current, (0, $k2R8s.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: (0, $k2R8s.default)({}, disablePortal ? {} : {
                // It's using scrollParent by default, we can use the viewport when using a portal.
                preventOverflow: {
                    boundariesElement: 'window'
                }
            }, modifiers, popperOptions.modifiers),
            // We could have been using a custom modifier like react-popper is doing.
            // But it seems this is the best public API for this use case.
            onCreate: (0, $40014db9871382a1$export$2e2bcd8739ae039)(handlePopperUpdate, popperOptions.onCreate),
            onUpdate: (0, $40014db9871382a1$export$2e2bcd8739ae039)(handlePopperUpdate, popperOptions.onUpdate)
        }));
        handlePopperRefRef.current(popper);
    }, [
        anchorEl,
        disablePortal,
        modifiers,
        open,
        rtlPlacement,
        popperOptions
    ]);
    var handleRef = $gIfym.useCallback(function(node) {
        (0, $9c4434890668410f$export$2e2bcd8739ae039)(ownRef, node);
        handleOpen();
    }, [
        ownRef,
        handleOpen
    ]);
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleClose = function handleClose() {
        if (!popperRef.current) return;
        popperRef.current.destroy();
        handlePopperRefRef.current(null);
    };
    var handleExited = function handleExited() {
        setExited(true);
        handleClose();
    };
    $gIfym.useEffect(function() {
        return function() {
            handleClose();
        };
    }, []);
    $gIfym.useEffect(function() {
        if (!open && !transition) // Otherwise handleExited will call this.
        handleClose();
    }, [
        open,
        transition
    ]);
    if (!keepMounted && !open && (!transition || exited)) return null;
    var childProps = {
        placement: placement
    };
    if (transition) childProps.TransitionProps = {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    };
    return /*#__PURE__*/ $gIfym.createElement((0, $9389c2cc46f3367e$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container
    }, /*#__PURE__*/ $gIfym.createElement("div", (0, $k2R8s.default)({
        ref: handleRef,
        role: "tooltip"
    }, other, {
        style: (0, $k2R8s.default)({
            // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
            position: 'fixed',
            // Fix Popper.js display issue
            top: 0,
            left: 0,
            display: !open && keepMounted && !transition ? 'none' : null
        }, style)
    }), typeof children === 'function' ? children(childProps) : children));
});
var $ac340bf9f5305593$export$2e2bcd8739ae039 = $ac340bf9f5305593$var$Popper;








function $b8939a8fa6ee4bc7$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
function $b8939a8fa6ee4bc7$var$arrowGenerator() {
    return {
        '&[x-placement*="bottom"] $arrow': {
            top: 0,
            left: 0,
            marginTop: '-0.71em',
            marginLeft: 4,
            marginRight: 4,
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        '&[x-placement*="top"] $arrow': {
            bottom: 0,
            left: 0,
            marginBottom: '-0.71em',
            marginLeft: 4,
            marginRight: 4,
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        '&[x-placement*="right"] $arrow': {
            left: 0,
            marginLeft: '-0.71em',
            height: '1em',
            width: '0.71em',
            marginTop: 4,
            marginBottom: 4,
            '&::before': {
                transformOrigin: '100% 100%'
            }
        },
        '&[x-placement*="left"] $arrow': {
            right: 0,
            marginRight: '-0.71em',
            height: '1em',
            width: '0.71em',
            marginTop: 4,
            marginBottom: 4,
            '&::before': {
                transformOrigin: '0 0'
            }
        }
    };
}
var $b8939a8fa6ee4bc7$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the Popper component. */ popper: {
            zIndex: theme.zIndex.tooltip,
            pointerEvents: 'none' // disable jss-rtl plugin
        },
        /* Styles applied to the Popper component if `interactive={true}`. */ popperInteractive: {
            pointerEvents: 'auto'
        },
        /* Styles applied to the Popper component if `arrow={true}`. */ popperArrow: $b8939a8fa6ee4bc7$var$arrowGenerator(),
        /* Styles applied to the tooltip (label wrapper) element. */ tooltip: {
            backgroundColor: (0, $aUprr.alpha)(theme.palette.grey[700], 0.9),
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.common.white,
            fontFamily: theme.typography.fontFamily,
            padding: '4px 8px',
            fontSize: theme.typography.pxToRem(10),
            lineHeight: "".concat($b8939a8fa6ee4bc7$var$round(1.4), "em"),
            maxWidth: 300,
            wordWrap: 'break-word',
            fontWeight: theme.typography.fontWeightMedium
        },
        /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */ tooltipArrow: {
            position: 'relative',
            margin: '0'
        },
        /* Styles applied to the arrow element. */ arrow: {
            overflow: 'hidden',
            position: 'absolute',
            width: '1em',
            height: '0.71em',
            boxSizing: 'border-box',
            color: (0, $aUprr.alpha)(theme.palette.grey[700], 0.9),
            '&::before': {
                content: '""',
                margin: 'auto',
                display: 'block',
                width: '100%',
                height: '100%',
                backgroundColor: 'currentColor',
                transform: 'rotate(45deg)'
            }
        },
        /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */ touch: {
            padding: '8px 16px',
            fontSize: theme.typography.pxToRem(14),
            lineHeight: "".concat($b8939a8fa6ee4bc7$var$round(16 / 14), "em"),
            fontWeight: theme.typography.fontWeightRegular
        },
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */ tooltipPlacementLeft: (0, $8k2Uc.default)({
            transformOrigin: 'right center',
            margin: '0 24px '
        }, theme.breakpoints.up('sm'), {
            margin: '0 14px'
        }),
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */ tooltipPlacementRight: (0, $8k2Uc.default)({
            transformOrigin: 'left center',
            margin: '0 24px'
        }, theme.breakpoints.up('sm'), {
            margin: '0 14px'
        }),
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */ tooltipPlacementTop: (0, $8k2Uc.default)({
            transformOrigin: 'center bottom',
            margin: '24px 0'
        }, theme.breakpoints.up('sm'), {
            margin: '14px 0'
        }),
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */ tooltipPlacementBottom: (0, $8k2Uc.default)({
            transformOrigin: 'center top',
            margin: '24px 0'
        }, theme.breakpoints.up('sm'), {
            margin: '14px 0'
        })
    };
};
var $b8939a8fa6ee4bc7$var$hystersisOpen = false;
var $b8939a8fa6ee4bc7$var$hystersisTimer = null;
function $b8939a8fa6ee4bc7$export$b9ee5a7ace0541f8() {
    $b8939a8fa6ee4bc7$var$hystersisOpen = false;
    clearTimeout($b8939a8fa6ee4bc7$var$hystersisTimer);
}
var $b8939a8fa6ee4bc7$var$Tooltip = /*#__PURE__*/ $gIfym.forwardRef(function Tooltip(props, ref) {
    var _props$arrow = props.arrow, arrow = _props$arrow === void 0 ? false : _props$arrow, children = props.children, classes = props.classes, _props$disableFocusLi = props.disableFocusListener, disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi, _props$disableHoverLi = props.disableHoverListener, disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi, _props$disableTouchLi = props.disableTouchListener, disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi, _props$enterDelay = props.enterDelay, enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay, _props$enterNextDelay = props.enterNextDelay, enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay, _props$enterTouchDela = props.enterTouchDelay, enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela, idProp = props.id, _props$interactive = props.interactive, interactive = _props$interactive === void 0 ? false : _props$interactive, _props$leaveDelay = props.leaveDelay, leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay, _props$leaveTouchDela = props.leaveTouchDelay, leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela, onClose = props.onClose, onOpen = props.onOpen, openProp = props.open, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, _props$PopperComponen = props.PopperComponent, PopperComponent = _props$PopperComponen === void 0 ? (0, $ac340bf9f5305593$export$2e2bcd8739ae039) : _props$PopperComponen, PopperProps = props.PopperProps, title = props.title, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $b7c71614d3a7d73f$export$2e2bcd8739ae039) : _props$TransitionComp, TransitionProps = props.TransitionProps, other = (0, $f6Qba.default)(props, [
        "arrow",
        "children",
        "classes",
        "disableFocusListener",
        "disableHoverListener",
        "disableTouchListener",
        "enterDelay",
        "enterNextDelay",
        "enterTouchDelay",
        "id",
        "interactive",
        "leaveDelay",
        "leaveTouchDelay",
        "onClose",
        "onOpen",
        "open",
        "placement",
        "PopperComponent",
        "PopperProps",
        "title",
        "TransitionComponent",
        "TransitionProps"
    ]);
    var theme = (0, $80d7961be58b720f$export$2e2bcd8739ae039)();
    var _React$useState = $gIfym.useState(), childNode = _React$useState[0], setChildNode = _React$useState[1];
    var _React$useState2 = $gIfym.useState(null), arrowRef = _React$useState2[0], setArrowRef = _React$useState2[1];
    var ignoreNonTouchEvents = $gIfym.useRef(false);
    var closeTimer = $gIfym.useRef();
    var enterTimer = $gIfym.useRef();
    var leaveTimer = $gIfym.useRef();
    var touchTimer = $gIfym.useRef();
    var _useControlled = (0, $d1ff3d9162e8e2bb$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    }), _useControlled2 = (0, $3KNdx.default)(_useControlled, 2), openState = _useControlled2[0], setOpenState = _useControlled2[1];
    var open = openState;
    var _React$useRef, isControlled;
    var id = (0, $5e9db6073b6c20ef$export$2e2bcd8739ae039)(idProp);
    $gIfym.useEffect(function() {
        return function() {
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            clearTimeout(touchTimer.current);
        };
    }, []);
    var handleOpen = function handleOpen(event) {
        clearTimeout($b8939a8fa6ee4bc7$var$hystersisTimer);
        $b8939a8fa6ee4bc7$var$hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen) onOpen(event);
    };
    var handleEnter = function handleEnter() {
        var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return function(event) {
            var childrenProps = children.props;
            if (event.type === 'mouseover' && childrenProps.onMouseOver && forward) childrenProps.onMouseOver(event);
            if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
             // Remove the title ahead of time.
            // We don't want to wait for the next render commit.
            // We would risk displaying two tooltips at the same time (native + this one).
            if (childNode) childNode.removeAttribute('title');
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            if (enterDelay || $b8939a8fa6ee4bc7$var$hystersisOpen && enterNextDelay) {
                event.persist();
                enterTimer.current = setTimeout(function() {
                    handleOpen(event);
                }, $b8939a8fa6ee4bc7$var$hystersisOpen ? enterNextDelay : enterDelay);
            } else handleOpen(event);
        };
    };
    var _useIsFocusVisible = (0, $c26c53624e49625a$export$2e2bcd8739ae039)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState3 = $gIfym.useState(false), childIsFocusVisible = _React$useState3[0], setChildIsFocusVisible = _React$useState3[1];
    var handleBlur = function handleBlur() {
        if (childIsFocusVisible) {
            setChildIsFocusVisible(false);
            onBlurVisible();
        }
    };
    var handleFocus = function handleFocus() {
        var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return function(event) {
            // Workaround for https://github.com/facebook/react/issues/7769
            // The autoFocus of React might trigger the event before the componentDidMount.
            // We need to account for this eventuality.
            if (!childNode) setChildNode(event.currentTarget);
            if (isFocusVisible(event)) {
                setChildIsFocusVisible(true);
                handleEnter()(event);
            }
            var childrenProps = children.props;
            if (childrenProps.onFocus && forward) childrenProps.onFocus(event);
        };
    };
    var handleClose = function handleClose(event) {
        clearTimeout($b8939a8fa6ee4bc7$var$hystersisTimer);
        $b8939a8fa6ee4bc7$var$hystersisTimer = setTimeout(function() {
            $b8939a8fa6ee4bc7$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(function() {
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    };
    var handleLeave = function handleLeave() {
        var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return function(event) {
            var childrenProps = children.props;
            if (event.type === 'blur') {
                if (childrenProps.onBlur && forward) childrenProps.onBlur(event);
                handleBlur();
            }
            if (event.type === 'mouseleave' && childrenProps.onMouseLeave && event.currentTarget === childNode) childrenProps.onMouseLeave(event);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            event.persist();
            leaveTimer.current = setTimeout(function() {
                handleClose(event);
            }, leaveDelay);
        };
    };
    var detectTouchStart = function detectTouchStart(event) {
        ignoreNonTouchEvents.current = true;
        var childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    var handleTouchStart = function handleTouchStart(event) {
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        clearTimeout(touchTimer.current);
        event.persist();
        touchTimer.current = setTimeout(function() {
            handleEnter()(event);
        }, enterTouchDelay);
    };
    var handleTouchEnd = function handleTouchEnd(event) {
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        clearTimeout(touchTimer.current);
        clearTimeout(leaveTimer.current);
        event.persist();
        leaveTimer.current = setTimeout(function() {
            handleClose(event);
        }, leaveTouchDelay);
    };
    var handleUseRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(setChildNode, ref);
    var handleFocusRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $gIfym.useCallback(function(instance) {
        // #StrictMode ready
        (0, $9c4434890668410f$export$2e2bcd8739ae039)(handleFocusRef, $c4a08725a78d51bf$exports.findDOMNode(instance));
    }, [
        handleFocusRef
    ]);
    var handleRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(children.ref, handleOwnRef); // There is no point in displaying an empty tooltip.
    if (title === '') open = false;
     // For accessibility and SEO concerns, we render the title to the DOM node when
    // the tooltip is hidden. However, we have made a tradeoff when
    // `disableHoverListener` is set. This title logic is disabled.
    // It's allowing us to keep the implementation size minimal.
    // We are open to change the tradeoff.
    var shouldShowNativeTitle = !open && !disableHoverListener;
    var childrenProps = (0, $k2R8s.default)({
        'aria-describedby': open ? id : null,
        title: shouldShowNativeTitle && typeof title === 'string' ? title : null
    }, other, children.props, {
        className: (0, $ba4yE.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    });
    var interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = handleEnter();
        childrenProps.onMouseLeave = handleLeave();
        if (interactive) {
            interactiveWrapperListeners.onMouseOver = handleEnter(false);
            interactiveWrapperListeners.onMouseLeave = handleLeave(false);
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = handleFocus();
        childrenProps.onBlur = handleLeave();
        if (interactive) {
            interactiveWrapperListeners.onFocus = handleFocus(false);
            interactiveWrapperListeners.onBlur = handleLeave(false);
        }
    }
    var mergedPopperProps = $gIfym.useMemo(function() {
        return (0, $14Uvj.default)({
            popperOptions: {
                modifiers: {
                    arrow: {
                        enabled: Boolean(arrowRef),
                        element: arrowRef
                    }
                }
            }
        }, PopperProps);
    }, [
        arrowRef,
        PopperProps
    ]);
    return /*#__PURE__*/ $gIfym.createElement($gIfym.Fragment, null, /*#__PURE__*/ $gIfym.cloneElement(children, childrenProps), /*#__PURE__*/ $gIfym.createElement(PopperComponent, (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.popper, interactive && classes.popperInteractive, arrow && classes.popperArrow),
        placement: placement,
        anchorEl: childNode,
        open: childNode ? open : false,
        id: childrenProps['aria-describedby'],
        transition: true
    }, interactiveWrapperListeners, mergedPopperProps), function(_ref) {
        var placementInner = _ref.placement, TransitionPropsInner = _ref.TransitionProps;
        return /*#__PURE__*/ $gIfym.createElement(TransitionComponent, (0, $k2R8s.default)({
            timeout: theme.transitions.duration.shorter
        }, TransitionPropsInner, TransitionProps), /*#__PURE__*/ $gIfym.createElement("div", {
            className: (0, $ba4yE.default)(classes.tooltip, classes["tooltipPlacement".concat((0, $kfLRg.default)(placementInner.split('-')[0]))], ignoreNonTouchEvents.current && classes.touch, arrow && classes.tooltipArrow)
        }, title, arrow ? /*#__PURE__*/ $gIfym.createElement("span", {
            className: classes.arrow,
            ref: setArrowRef
        }) : null));
    }));
});
var $b8939a8fa6ee4bc7$export$2e2bcd8739ae039 = (0, $82OGZ.default)($b8939a8fa6ee4bc7$export$9dd6ff9ea0189349, {
    name: 'MuiTooltip',
    flip: false
})($b8939a8fa6ee4bc7$var$Tooltip);


const $e10f00ffccaae862$var$columns = [
    {
        head: "Name",
        prop: "name",
        currency: false
    },
    {
        head: "CPU",
        prop: "cpuCost",
        currency: true
    },
    {
        head: "GPU",
        prop: "gpuCost",
        currency: true
    },
    {
        head: "RAM",
        prop: "ramCost",
        currency: true
    },
    {
        head: "PV",
        prop: "pvCost",
        currency: true
    },
    {
        head: "Network",
        prop: "networkCost",
        currency: true
    },
    {
        head: "Shared",
        prop: "sharedCost",
        currency: true
    },
    {
        head: "Total",
        prop: "totalCost",
        currency: true
    }
];
const $e10f00ffccaae862$var$toCSVLine = (datum)=>{
    let cols = [];
    (0, $6IRuR.forEach)($e10f00ffccaae862$var$columns, (c)=>{
        if (c.currency) cols.push((0, $6IRuR.round)((0, $6IRuR.get)(datum, c.prop, 0.0), 2));
        else cols.push(`"${(0, $6IRuR.get)(datum, c.prop, "")}"`);
    });
    return cols.join(',');
};
const $e10f00ffccaae862$var$DownloadControl = ({ cumulativeData: cumulativeData, title: title })=>{
    // downloadReport downloads a CSV of the cumulative allocation data
    function downloadReport() {
        // Build CSV
        const head = $e10f00ffccaae862$var$columns.map((c)=>c.head).join(',');
        const body = (0, $6IRuR.reverse)((0, $6IRuR.sortBy)(cumulativeData, 'totalCost')).map($e10f00ffccaae862$var$toCSVLine).join('\r\n');
        const csv = `${head}\r\n${body}`;
        // Create download link
        const a = document.createElement("a");
        a.href = URL.createObjectURL(new Blob([
            csv
        ], {
            type: "text/csv"
        }));
        const filename = title.toLowerCase().replace(/\s/gi, '-');
        a.setAttribute("download", `${filename}-${Date.now()}.csv`);
        // Click the link
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b8939a8fa6ee4bc7$export$2e2bcd8739ae039), {
        title: "Download CSV",
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $2ae0a89ca37bbdde$export$2e2bcd8739ae039), {
            onClick: downloadReport,
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($127ca2d9c2803d70$exports))), {})
        })
    });
};
var $e10f00ffccaae862$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).memo($e10f00ffccaae862$var$DownloadControl);


const $0aadca63ce196fea$var$Controls = ({ windowOptions: windowOptions, window: window, setWindow: setWindow, aggregationOptions: aggregationOptions, aggregateBy: aggregateBy, setAggregateBy: setAggregateBy, accumulateOptions: accumulateOptions, accumulate: accumulate, setAccumulate: setAccumulate, title: title, cumulativeData: cumulativeData, currency: currency, currencyOptions: currencyOptions, setCurrency: setCurrency })=>{
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b9c347917b2583aa$export$2e2bcd8739ae039), {
                windowOptions: windowOptions,
                window: window,
                setWindow: setWindow,
                aggregationOptions: aggregationOptions,
                aggregateBy: aggregateBy,
                setAggregateBy: setAggregateBy,
                accumulateOptions: accumulateOptions,
                accumulate: accumulate,
                setAccumulate: setAccumulate,
                currency: currency,
                currencyOptions: currencyOptions,
                setCurrency: setCurrency
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $e10f00ffccaae862$export$2e2bcd8739ae039), {
                cumulativeData: cumulativeData,
                title: title
            })
        ]
    });
};
var $0aadca63ce196fea$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).memo($0aadca63ce196fea$var$Controls);



parcelRequire("gIfym");

var $hQJVM = parcelRequire("hQJVM");

var $k2R8s = parcelRequire("k2R8s");

var $9unC2 = parcelRequire("9unC2");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");



var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");


var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $82OGZ = parcelRequire("82OGZ");

var $aUprr = parcelRequire("aUprr");

var $gIfym = parcelRequire("gIfym");

var $ljC17 = parcelRequire("ljC17");
var /**
 * @ignore - internal component.
 */ $94970ed4d766d3f1$export$2e2bcd8739ae039 = (0, $ljC17.default)(/*#__PURE__*/ $gIfym.createElement("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');



var $75ee7b3f1b78bfd0$var$styles = function styles(theme) {
    return {
        root: {
            display: 'flex',
            marginLeft: theme.spacing(0.5),
            marginRight: theme.spacing(0.5),
            backgroundColor: theme.palette.grey[100],
            color: theme.palette.grey[700],
            borderRadius: 2,
            cursor: 'pointer',
            '&:hover, &:focus': {
                backgroundColor: theme.palette.grey[200]
            },
            '&:active': {
                boxShadow: theme.shadows[0],
                backgroundColor: (0, $aUprr.emphasize)(theme.palette.grey[200], 0.12)
            }
        },
        icon: {
            width: 24,
            height: 16
        }
    };
};
/**
 * @ignore - internal component.
 */ function $75ee7b3f1b78bfd0$var$BreadcrumbCollapsed(props) {
    var classes = props.classes, other = (0, $f6Qba.default)(props, [
        "classes"
    ]);
    return /*#__PURE__*/ $gIfym.createElement((0, $c3be49ff5d39de33$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        component: "li",
        className: classes.root,
        focusRipple: true
    }, other), /*#__PURE__*/ $gIfym.createElement((0, $94970ed4d766d3f1$export$2e2bcd8739ae039), {
        className: classes.icon
    }));
}
var $75ee7b3f1b78bfd0$export$2e2bcd8739ae039 = (0, $82OGZ.default)($75ee7b3f1b78bfd0$var$styles, {
    name: 'PrivateBreadcrumbCollapsed'
})($75ee7b3f1b78bfd0$var$BreadcrumbCollapsed);


var $39efb4eddec95c8d$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the ol element. */ ol: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        padding: 0,
        margin: 0,
        listStyle: 'none'
    },
    /* Styles applied to the li element. */ li: {},
    /* Styles applied to the separator element. */ separator: {
        display: 'flex',
        userSelect: 'none',
        marginLeft: 8,
        marginRight: 8
    }
};
function $39efb4eddec95c8d$var$insertSeparators(items, className, separator) {
    return items.reduce(function(acc, current, index) {
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ $gIfym.createElement("li", {
            "aria-hidden": true,
            key: "separator-".concat(index),
            className: className
        }, separator));
        else acc.push(current);
        return acc;
    }, []);
}
var $39efb4eddec95c8d$var$Breadcrumbs = /*#__PURE__*/ $gIfym.forwardRef(function Breadcrumbs(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'nav' : _props$component, _props$expandText = props.expandText, expandText = _props$expandText === void 0 ? 'Show path' : _props$expandText, _props$itemsAfterColl = props.itemsAfterCollapse, itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl, _props$itemsBeforeCol = props.itemsBeforeCollapse, itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol, _props$maxItems = props.maxItems, maxItems = _props$maxItems === void 0 ? 8 : _props$maxItems, _props$separator = props.separator, separator = _props$separator === void 0 ? '/' : _props$separator, other = (0, $f6Qba.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "expandText",
        "itemsAfterCollapse",
        "itemsBeforeCollapse",
        "maxItems",
        "separator"
    ]);
    var _React$useState = $gIfym.useState(false), expanded = _React$useState[0], setExpanded = _React$useState[1];
    var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter(allItems) {
        var handleClickExpand = function handleClickExpand(event) {
            setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            var focusable = event.currentTarget.parentNode.querySelector('a[href],button,[tabindex]');
            if (focusable) focusable.focus();
        }; // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        return [].concat((0, $9unC2.default)(allItems.slice(0, itemsBeforeCollapse)), [
            /*#__PURE__*/ $gIfym.createElement((0, $75ee7b3f1b78bfd0$export$2e2bcd8739ae039), {
                "aria-label": expandText,
                key: "ellipsis",
                onClick: handleClickExpand
            })
        ], (0, $9unC2.default)(allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)));
    };
    var allItems = $gIfym.Children.toArray(children).filter(function(child) {
        return /*#__PURE__*/ $gIfym.isValidElement(child);
    }).map(function(child, index) {
        return /*#__PURE__*/ $gIfym.createElement("li", {
            className: classes.li,
            key: "child-".concat(index)
        }, child);
    });
    return /*#__PURE__*/ $gIfym.createElement((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        ref: ref,
        component: Component,
        color: "textSecondary",
        className: (0, $ba4yE.default)(classes.root, className)
    }, other), /*#__PURE__*/ $gIfym.createElement("ol", {
        className: classes.ol
    }, $39efb4eddec95c8d$var$insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator)));
});
var $39efb4eddec95c8d$export$2e2bcd8739ae039 = (0, $82OGZ.default)($39efb4eddec95c8d$export$9dd6ff9ea0189349, {
    name: 'MuiBreadcrumbs'
})($39efb4eddec95c8d$var$Breadcrumbs);





const $d5abac16fc0baa87$var$useStyles = (0, $hQJVM.default)({
    root: {
        alignItems: "center",
        display: "flex",
        flexFlow: "row",
        width: "100%",
        marginTop: "10px"
    },
    context: {
        flex: "1 0 auto"
    },
    actions: {
        flex: "0 0 auto"
    }
});
const $d5abac16fc0baa87$var$Header = (props)=>{
    const classes = $d5abac16fc0baa87$var$useStyles();
    const { title: title, breadcrumbs: breadcrumbs, headerTitle: headerTitle } = props;
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
                variant: "h3",
                style: {
                    marginBottom: "10px"
                },
                children: headerTitle
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: classes.context,
                children: [
                    title && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
                        variant: "h4",
                        className: classes.title,
                        children: title
                    }),
                    breadcrumbs && breadcrumbs.length > 0 && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $39efb4eddec95c8d$export$2e2bcd8739ae039), {
                        "aria-label": "breadcrumb",
                        children: [
                            breadcrumbs.slice(0, breadcrumbs.length - 1).map((b)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $1d96cd50cde517a6$export$2e2bcd8739ae039), {
                                    color: "inherit",
                                    href: b.href,
                                    children: b.name
                                }, b.name)),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
                                color: "textPrimary",
                                children: breadcrumbs[breadcrumbs.length - 1].name
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: classes.actions,
                children: props.children
            })
        ]
    });
};
var $d5abac16fc0baa87$export$2e2bcd8739ae039 = $d5abac16fc0baa87$var$Header;




var $hQJVM = parcelRequire("hQJVM");
parcelRequire("gIfym");



var $gIfym = parcelRequire("gIfym");

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");



var $82OGZ = parcelRequire("82OGZ");

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");








var $dJPr8 = parcelRequire("dJPr8");

// Later, we gonna translate back the node to his original location
// with `none`.`
function $31f71cdf1984e84d$var$getTranslateValue(direction, node) {
    var rect = node.getBoundingClientRect();
    var transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        var computedStyle = window.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    var offsetX = 0;
    var offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') return "translateX(".concat(window.innerWidth, "px) translateX(").concat(offsetX - rect.left, "px)");
    if (direction === 'right') return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
    if (direction === 'up') return "translateY(".concat(window.innerHeight, "px) translateY(").concat(offsetY - rect.top, "px)");
     // direction === 'down'
    return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
}
function $31f71cdf1984e84d$export$f820ccdc5b48abdf(direction, node) {
    var transform = $31f71cdf1984e84d$var$getTranslateValue(direction, node);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
var $31f71cdf1984e84d$var$defaultTimeout = {
    enter: (0, $dJPr8.duration).enteringScreen,
    exit: (0, $dJPr8.duration).leavingScreen
};
/**
 * The Slide transition is used by the [Drawer](/components/drawers/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $31f71cdf1984e84d$var$Slide = /*#__PURE__*/ $gIfym.forwardRef(function Slide(props, ref) {
    var children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? 'down' : _props$direction, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? $31f71cdf1984e84d$var$defaultTimeout : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $19bb90b7fff15f94$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $f6Qba.default)(props, [
        "children",
        "direction",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var theme = (0, $80d7961be58b720f$export$2e2bcd8739ae039)();
    var childrenRef = $gIfym.useRef(null);
    /**
   * used in cloneElement(children, { ref: handleRef })
   */ var handleOwnRef = $gIfym.useCallback(function(instance) {
        // #StrictMode ready
        childrenRef.current = $c4a08725a78d51bf$exports.findDOMNode(instance);
    }, []);
    var handleRefIntermediary = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(children.ref, handleOwnRef);
    var handleRef = (0, $9ef4fc3532ca03c1$export$2e2bcd8739ae039)(handleRefIntermediary, ref);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(isAppearing) {
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    };
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        $31f71cdf1984e84d$export$f820ccdc5b48abdf(direction, node);
        (0, $ff9839da05f19fc0$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntering = normalizedTransitionCallback(function(node, isAppearing) {
        var transitionProps = (0, $ff9839da05f19fc0$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $k2R8s.default)({}, transitionProps, {
            easing: theme.transitions.easing.easeOut
        }));
        node.style.transition = theme.transitions.create('transform', (0, $k2R8s.default)({}, transitionProps, {
            easing: theme.transitions.easing.easeOut
        }));
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var transitionProps = (0, $ff9839da05f19fc0$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $k2R8s.default)({}, transitionProps, {
            easing: theme.transitions.easing.sharp
        }));
        node.style.transition = theme.transitions.create('transform', (0, $k2R8s.default)({}, transitionProps, {
            easing: theme.transitions.easing.sharp
        }));
        $31f71cdf1984e84d$export$f820ccdc5b48abdf(direction, node);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(function(node) {
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    var updatePosition = $gIfym.useCallback(function() {
        if (childrenRef.current) $31f71cdf1984e84d$export$f820ccdc5b48abdf(direction, childrenRef.current);
    }, [
        direction
    ]);
    $gIfym.useEffect(function() {
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        var handleResize = (0, $b95683bf1edd1407$export$2e2bcd8739ae039)(function() {
            if (childrenRef.current) $31f71cdf1984e84d$export$f820ccdc5b48abdf(direction, childrenRef.current);
        });
        window.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp
    ]);
    $gIfym.useEffect(function() {
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ $gIfym.createElement(TransitionComponent, (0, $k2R8s.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        appear: true,
        in: inProp,
        timeout: timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $gIfym.cloneElement(children, (0, $k2R8s.default)({
            ref: handleRef,
            style: (0, $k2R8s.default)({
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, style, children.props.style)
        }, childProps));
    });
});
var $31f71cdf1984e84d$export$2e2bcd8739ae039 = $31f71cdf1984e84d$var$Slide;




var $kfLRg = parcelRequire("kfLRg");

var $dJPr8 = parcelRequire("dJPr8");

var $6f9661faa01317fb$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {},
        /* Styles applied to the root element if `variant="permanent or persistent"`. */ docked: {
            flex: '0 0 auto'
        },
        /* Styles applied to the `Paper` component. */ paper: {
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            flex: '1 0 auto',
            zIndex: theme.zIndex.drawer,
            WebkitOverflowScrolling: 'touch',
            // Add iOS momentum scrolling.
            // temporary style
            position: 'fixed',
            top: 0,
            // We disable the focus ring for mouse, touch and keyboard users.
            // At some point, it would be better to keep it for keyboard users.
            // :focus-ring CSS pseudo-class will help.
            outline: 0
        },
        /* Styles applied to the `Paper` component if `anchor="left"`. */ paperAnchorLeft: {
            left: 0,
            right: 'auto'
        },
        /* Styles applied to the `Paper` component if `anchor="right"`. */ paperAnchorRight: {
            left: 'auto',
            right: 0
        },
        /* Styles applied to the `Paper` component if `anchor="top"`. */ paperAnchorTop: {
            top: 0,
            left: 0,
            bottom: 'auto',
            right: 0,
            height: 'auto',
            maxHeight: '100%'
        },
        /* Styles applied to the `Paper` component if `anchor="bottom"`. */ paperAnchorBottom: {
            top: 'auto',
            left: 0,
            bottom: 0,
            right: 0,
            height: 'auto',
            maxHeight: '100%'
        },
        /* Styles applied to the `Paper` component if `anchor="left"` and `variant` is not "temporary". */ paperAnchorDockedLeft: {
            borderRight: "1px solid ".concat(theme.palette.divider)
        },
        /* Styles applied to the `Paper` component if `anchor="top"` and `variant` is not "temporary". */ paperAnchorDockedTop: {
            borderBottom: "1px solid ".concat(theme.palette.divider)
        },
        /* Styles applied to the `Paper` component if `anchor="right"` and `variant` is not "temporary". */ paperAnchorDockedRight: {
            borderLeft: "1px solid ".concat(theme.palette.divider)
        },
        /* Styles applied to the `Paper` component if `anchor="bottom"` and `variant` is not "temporary". */ paperAnchorDockedBottom: {
            borderTop: "1px solid ".concat(theme.palette.divider)
        },
        /* Styles applied to the `Modal` component. */ modal: {}
    };
};
var $6f9661faa01317fb$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $6f9661faa01317fb$export$2a62b49acb270576(anchor) {
    return [
        'left',
        'right'
    ].indexOf(anchor) !== -1;
}
function $6f9661faa01317fb$export$830f4f08342d299e(theme, anchor) {
    return theme.direction === 'rtl' && $6f9661faa01317fb$export$2a62b49acb270576(anchor) ? $6f9661faa01317fb$var$oppositeDirection[anchor] : anchor;
}
var $6f9661faa01317fb$var$defaultTransitionDuration = {
    enter: (0, $dJPr8.duration).enteringScreen,
    exit: (0, $dJPr8.duration).leavingScreen
};
/**
 * The props of the [Modal](/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ var $6f9661faa01317fb$var$Drawer = /*#__PURE__*/ $gIfym.forwardRef(function Drawer(props, ref) {
    var _props$anchor = props.anchor, anchorProp = _props$anchor === void 0 ? 'left' : _props$anchor, BackdropProps = props.BackdropProps, children = props.children, classes = props.classes, className = props.className, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 16 : _props$elevation, _props$ModalProps = props.ModalProps;
    _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
    var BackdropPropsProp = _props$ModalProps.BackdropProps, ModalProps = (0, $f6Qba.default)(_props$ModalProps, [
        "BackdropProps"
    ]), onClose = props.onClose, _props$open = props.open, open = _props$open === void 0 ? false : _props$open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, SlideProps = props.SlideProps, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $31f71cdf1984e84d$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? $6f9661faa01317fb$var$defaultTransitionDuration : _props$transitionDura, _props$variant = props.variant, variant = _props$variant === void 0 ? 'temporary' : _props$variant, other = (0, $f6Qba.default)(props, [
        "anchor",
        "BackdropProps",
        "children",
        "classes",
        "className",
        "elevation",
        "ModalProps",
        "onClose",
        "open",
        "PaperProps",
        "SlideProps",
        "TransitionComponent",
        "transitionDuration",
        "variant"
    ]);
    var theme = (0, $80d7961be58b720f$export$2e2bcd8739ae039)(); // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    var mounted = $gIfym.useRef(false);
    $gIfym.useEffect(function() {
        mounted.current = true;
    }, []);
    var anchor = $6f9661faa01317fb$export$830f4f08342d299e(theme, anchorProp);
    var drawer = /*#__PURE__*/ $gIfym.createElement((0, $ee13f6b8f50f92d0$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        elevation: variant === 'temporary' ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $ba4yE.default)(classes.paper, classes["paperAnchor".concat((0, $kfLRg.default)(anchor))], PaperProps.className, variant !== 'temporary' && classes["paperAnchorDocked".concat((0, $kfLRg.default)(anchor))])
    }), children);
    if (variant === 'permanent') return /*#__PURE__*/ $gIfym.createElement("div", (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, classes.docked, className),
        ref: ref
    }, other), drawer);
    var slidingDrawer = /*#__PURE__*/ $gIfym.createElement(TransitionComponent, (0, $k2R8s.default)({
        in: open,
        direction: $6f9661faa01317fb$var$oppositeDirection[anchor],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps), drawer);
    if (variant === 'persistent') return /*#__PURE__*/ $gIfym.createElement("div", (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, classes.docked, className),
        ref: ref
    }, other), slidingDrawer);
     // variant === temporary
    return /*#__PURE__*/ $gIfym.createElement((0, $3ad09d28fe7c5342$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        BackdropProps: (0, $k2R8s.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        BackdropComponent: (0, $9b8aae97883f7e8f$export$2e2bcd8739ae039),
        className: (0, $ba4yE.default)(classes.root, classes.modal, className),
        open: open,
        onClose: onClose,
        ref: ref
    }, other, ModalProps), slidingDrawer);
});
var $6f9661faa01317fb$export$2e2bcd8739ae039 = (0, $82OGZ.default)($6f9661faa01317fb$export$9dd6ff9ea0189349, {
    name: 'MuiDrawer',
    flip: false
})($6f9661faa01317fb$var$Drawer);



parcelRequire("gIfym");

var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");

var $b8a250a44f304319$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            minWidth: 56,
            color: theme.palette.action.active,
            flexShrink: 0,
            display: 'inline-flex'
        },
        /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */ alignItemsFlexStart: {
            marginTop: 8
        }
    };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ var $b8a250a44f304319$var$ListItemIcon = /*#__PURE__*/ $gIfym.forwardRef(function ListItemIcon(props, ref) {
    var classes = props.classes, className = props.className, other = (0, $f6Qba.default)(props, [
        "classes",
        "className"
    ]);
    var context = $gIfym.useContext((0, $ae90a7cb68735098$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $gIfym.createElement("div", (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
        ref: ref
    }, other));
});
var $b8a250a44f304319$export$2e2bcd8739ae039 = (0, $82OGZ.default)($b8a250a44f304319$export$9dd6ff9ea0189349, {
    name: 'MuiListItemIcon'
})($b8a250a44f304319$var$ListItemIcon);


var $k2R8s = parcelRequire("k2R8s");

var $f6Qba = parcelRequire("f6Qba");

var $gIfym = parcelRequire("gIfym");


var $ba4yE = parcelRequire("ba4yE");

var $82OGZ = parcelRequire("82OGZ");


var $a409dd30f9558cb2$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        flex: '1 1 auto',
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    },
    /* Styles applied to the `Typography` components if primary and secondary are set. */ multiline: {
        marginTop: 6,
        marginBottom: 6
    },
    /* Styles applied to the `Typography` components if dense. */ dense: {},
    /* Styles applied to the root element if `inset={true}`. */ inset: {
        paddingLeft: 56
    },
    /* Styles applied to the primary `Typography` component. */ primary: {},
    /* Styles applied to the secondary `Typography` component. */ secondary: {}
};
var $a409dd30f9558cb2$var$ListItemText = /*#__PURE__*/ $gIfym.forwardRef(function ListItemText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, _props$inset = props.inset, inset = _props$inset === void 0 ? false : _props$inset, primaryProp = props.primary, primaryTypographyProps = props.primaryTypographyProps, secondaryProp = props.secondary, secondaryTypographyProps = props.secondaryTypographyProps, other = (0, $f6Qba.default)(props, [
        "children",
        "classes",
        "className",
        "disableTypography",
        "inset",
        "primary",
        "primaryTypographyProps",
        "secondary",
        "secondaryTypographyProps"
    ]);
    var _React$useContext = $gIfym.useContext((0, $ae90a7cb68735098$export$2e2bcd8739ae039)), dense = _React$useContext.dense;
    var primary = primaryProp != null ? primaryProp : children;
    if (primary != null && primary.type !== (0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ $gIfym.createElement((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        variant: dense ? 'body2' : 'body1',
        className: classes.primary,
        component: "span",
        display: "block"
    }, primaryTypographyProps), primary);
    var secondary = secondaryProp;
    if (secondary != null && secondary.type !== (0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ $gIfym.createElement((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), (0, $k2R8s.default)({
        variant: "body2",
        className: classes.secondary,
        color: "textSecondary",
        display: "block"
    }, secondaryTypographyProps), secondary);
    return /*#__PURE__*/ $gIfym.createElement("div", (0, $k2R8s.default)({
        className: (0, $ba4yE.default)(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
        ref: ref
    }, other), primary, secondary);
});
var $a409dd30f9558cb2$export$2e2bcd8739ae039 = (0, $82OGZ.default)($a409dd30f9558cb2$export$9dd6ff9ea0189349, {
    name: 'MuiListItemText'
})($a409dd30f9558cb2$var$ListItemText);




var $hQJVM = parcelRequire("hQJVM");
const $4d794dde0d9881d1$export$e3925dbaeffcc83f = ({ active: active, href: href, name: name, onClick: onClick, secondary: secondary, title: title, icon: icon })=>{
    const useStyles = (0, $hQJVM.default)({
        root: {
            cursor: "pointer",
            "&:hover": {
                backgroundColor: "#ebebeb"
            },
            "&:selected": {
                backgroundColor: "#e1e1e1"
            }
        },
        text: {
            maxWidth: 200,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        activeIcon: {
            color: "#346ef2",
            minWidth: 36
        },
        activeText: {
            color: "#346ef2"
        },
        icon: {
            color: "#4e4e4e",
            minWidth: 36
        }
    });
    const classes = useStyles();
    const listItemIconClasses = {
        root: classes.icon
    };
    const listItemTextClasses = {
        secondary: classes.text
    };
    if (active) {
        listItemIconClasses.root = classes.activeIcon;
        listItemTextClasses.primary = classes.activeText;
    }
    const renderListItemCore = ()=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $260b2a0fcf443bd8$export$2e2bcd8739ae039), {
            className: active ? "active" : "",
            classes: {
                root: classes.root
            },
            onClick: (e)=>{
                if (onClick) {
                    onClick();
                    e.stopPropagation();
                }
            },
            selected: active,
            title: title,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b8a250a44f304319$export$2e2bcd8739ae039), {
                    classes: listItemIconClasses,
                    children: icon
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $a409dd30f9558cb2$export$2e2bcd8739ae039), {
                    classes: listItemTextClasses,
                    primary: name,
                    secondary: secondary
                })
            ]
        });
    return href && !active ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5f667dc1ae602d9e$export$a6c7ac8248d6e38a), {
        style: {
            textDecoration: "none",
            color: "inherit"
        },
        to: `${href}`,
        children: renderListItemCore()
    }) : renderListItemCore();
};



var $gIfym = parcelRequire("gIfym");

var $ljC17 = parcelRequire("ljC17");
var $37cc92dd9ffdcaa4$export$2e2bcd8739ae039 = (0, $ljC17.default)(/*#__PURE__*/ $gIfym.createElement("path", {
    d: "M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z"
}), 'BarChart');


var $gIfym = parcelRequire("gIfym");

var $ljC17 = parcelRequire("ljC17");
var $3a2162c3d9d1f6a8$export$2e2bcd8739ae039 = (0, $ljC17.default)(/*#__PURE__*/ $gIfym.createElement("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
}), 'Cloud');



var $hQJVM = parcelRequire("hQJVM");
var $61a6872d04f0dbbb$exports = {};
$61a6872d04f0dbbb$exports = $parcel$resolve("1lrMa");


const $4604e351d35bdbb9$var$logo = new URL($61a6872d04f0dbbb$exports).href;
const $4604e351d35bdbb9$var$DRAWER_WIDTH = 200;
const $4604e351d35bdbb9$export$6c4845e528748967 = ({ active: active })=>{
    const useStyles = (0, $hQJVM.default)({
        drawer: {
            width: $4604e351d35bdbb9$var$DRAWER_WIDTH,
            flexShrink: 0
        },
        drawerPaper: {
            backgroundColor: "inherit",
            border: 0,
            width: $4604e351d35bdbb9$var$DRAWER_WIDTH,
            paddingTop: "2.5rem"
        },
        text: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        }
    });
    const classes = useStyles();
    const [init, setInit] = $gIfym.useState(false);
    $gIfym.useEffect(()=>{
        if (!init) setInit(true);
    }, [
        init
    ]);
    const top = [
        {
            name: "Cost Allocation",
            href: "allocation",
            icon: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $37cc92dd9ffdcaa4$export$2e2bcd8739ae039), {})
        },
        {
            name: "Cloud Costs",
            href: "cloud",
            icon: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $3a2162c3d9d1f6a8$export$2e2bcd8739ae039), {})
        },
        {
            name: "External Costs",
            href: "external-costs",
            icon: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $3a2162c3d9d1f6a8$export$2e2bcd8739ae039), {})
        }
    ];
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $6f9661faa01317fb$export$2e2bcd8739ae039), {
        anchor: "left",
        className: classes.drawer,
        classes: {
            paper: classes.drawerPaper
        },
        variant: "permanent",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("img", {
                src: $4604e351d35bdbb9$var$logo,
                alt: "OpenCost",
                style: {
                    flexShrink: 1,
                    padding: "1rem"
                }
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $e58b878dddb079be$export$2e2bcd8739ae039), {
                style: {
                    flexGrow: 1
                },
                children: top.map((l)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $4d794dde0d9881d1$export$e3925dbaeffcc83f), {
                        active: active === `/${l.href}`,
                        ...l
                    }, l.name))
            })
        ]
    });
};


const $8530181efc7ffbd0$var$useStyles = (0, $hQJVM.default)({
    wrapper: {
        position: "relative",
        height: "100vh",
        flexGrow: 1,
        overflowX: "auto",
        paddingLeft: "2rem",
        paddingRight: "rem",
        paddingTop: "2.5rem"
    },
    flexGrow: {
        display: "flex",
        flexFlow: "column",
        flexGrow: 1
    },
    body: {
        display: "flex",
        overflowY: "scroll",
        margin: "0px",
        backgroundColor: "f3f3f3"
    }
});
const $8530181efc7ffbd0$var$Page = (props)=>{
    const classes = $8530181efc7ffbd0$var$useStyles();
    const { pathname: pathname } = (0, $b585d439d92e032d$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: classes.body,
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $4604e351d35bdbb9$export$6c4845e528748967), {
                active: pathname
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: classes.flexGrow,
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: classes.wrapper,
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: classes.flexGrow,
                        children: props.children
                    })
                })
            })
        ]
    });
};
var $8530181efc7ffbd0$export$2e2bcd8739ae039 = $8530181efc7ffbd0$var$Page;


var $81aadd2924ec5f1a$exports = {};
'use strict';
var $59dc37022d7f7468$exports = {};
'use strict';
var $a3d1524f71b9275a$exports = {};
"use strict";
var $a3d1524f71b9275a$var$__createBinding = $a3d1524f71b9275a$exports && $a3d1524f71b9275a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a3d1524f71b9275a$var$__setModuleDefault = $a3d1524f71b9275a$exports && $a3d1524f71b9275a$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a3d1524f71b9275a$var$__importStar = $a3d1524f71b9275a$exports && $a3d1524f71b9275a$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a3d1524f71b9275a$var$__createBinding(result, mod, k);
    }
    $a3d1524f71b9275a$var$__setModuleDefault(result, mod);
    return result;
};
var $a3d1524f71b9275a$var$__importDefault = $a3d1524f71b9275a$exports && $a3d1524f71b9275a$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($a3d1524f71b9275a$exports, "__esModule", {
    value: true
});
$a3d1524f71b9275a$exports.decodeXML = $a3d1524f71b9275a$exports.decodeHTMLStrict = $a3d1524f71b9275a$exports.decodeHTMLAttribute = $a3d1524f71b9275a$exports.decodeHTML = $a3d1524f71b9275a$exports.determineBranch = $a3d1524f71b9275a$exports.EntityDecoder = $a3d1524f71b9275a$exports.DecodingMode = $a3d1524f71b9275a$exports.BinTrieFlags = $a3d1524f71b9275a$exports.fromCodePoint = $a3d1524f71b9275a$exports.replaceCodePoint = $a3d1524f71b9275a$exports.decodeCodePoint = $a3d1524f71b9275a$exports.xmlDecodeTree = $a3d1524f71b9275a$exports.htmlDecodeTree = void 0;

var $a3d1524f71b9275a$var$decode_data_html_js_1 = $a3d1524f71b9275a$var$__importDefault((parcelRequire("4ckAm")));
$a3d1524f71b9275a$exports.htmlDecodeTree = $a3d1524f71b9275a$var$decode_data_html_js_1.default;

var $a3d1524f71b9275a$var$decode_data_xml_js_1 = $a3d1524f71b9275a$var$__importDefault((parcelRequire("apPRO")));
$a3d1524f71b9275a$exports.xmlDecodeTree = $a3d1524f71b9275a$var$decode_data_xml_js_1.default;

var $a3d1524f71b9275a$var$decode_codepoint_js_1 = $a3d1524f71b9275a$var$__importStar((parcelRequire("jCFru")));
$a3d1524f71b9275a$exports.decodeCodePoint = $a3d1524f71b9275a$var$decode_codepoint_js_1.default;

Object.defineProperty($a3d1524f71b9275a$exports, "replaceCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("jCFru")).replaceCodePoint;
    }
});
Object.defineProperty($a3d1524f71b9275a$exports, "fromCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("jCFru")).fromCodePoint;
    }
});
var $a3d1524f71b9275a$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($a3d1524f71b9275a$var$CharCodes || ($a3d1524f71b9275a$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ var $a3d1524f71b9275a$var$TO_LOWER_BIT = 32;
var $a3d1524f71b9275a$var$BinTrieFlags;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($a3d1524f71b9275a$var$BinTrieFlags = $a3d1524f71b9275a$exports.BinTrieFlags || ($a3d1524f71b9275a$exports.BinTrieFlags = {}));
function $a3d1524f71b9275a$var$isNumber(code) {
    return code >= $a3d1524f71b9275a$var$CharCodes.ZERO && code <= $a3d1524f71b9275a$var$CharCodes.NINE;
}
function $a3d1524f71b9275a$var$isHexadecimalCharacter(code) {
    return code >= $a3d1524f71b9275a$var$CharCodes.UPPER_A && code <= $a3d1524f71b9275a$var$CharCodes.UPPER_F || code >= $a3d1524f71b9275a$var$CharCodes.LOWER_A && code <= $a3d1524f71b9275a$var$CharCodes.LOWER_F;
}
function $a3d1524f71b9275a$var$isAsciiAlphaNumeric(code) {
    return code >= $a3d1524f71b9275a$var$CharCodes.UPPER_A && code <= $a3d1524f71b9275a$var$CharCodes.UPPER_Z || code >= $a3d1524f71b9275a$var$CharCodes.LOWER_A && code <= $a3d1524f71b9275a$var$CharCodes.LOWER_Z || $a3d1524f71b9275a$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $a3d1524f71b9275a$var$isEntityInAttributeInvalidEnd(code) {
    return code === $a3d1524f71b9275a$var$CharCodes.EQUALS || $a3d1524f71b9275a$var$isAsciiAlphaNumeric(code);
}
var $a3d1524f71b9275a$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($a3d1524f71b9275a$var$EntityDecoderState || ($a3d1524f71b9275a$var$EntityDecoderState = {}));
var $a3d1524f71b9275a$var$DecodingMode;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($a3d1524f71b9275a$var$DecodingMode = $a3d1524f71b9275a$exports.DecodingMode || ($a3d1524f71b9275a$exports.DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */ var $a3d1524f71b9275a$var$EntityDecoder = /** @class */ function() {
    function EntityDecoder(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors) {
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $a3d1524f71b9275a$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $a3d1524f71b9275a$var$DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */ EntityDecoder.prototype.startEntity = function(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $a3d1524f71b9275a$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    };
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.write = function(str, offset) {
        switch(this.state){
            case $a3d1524f71b9275a$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $a3d1524f71b9275a$var$CharCodes.NUM) {
                    this.state = $a3d1524f71b9275a$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $a3d1524f71b9275a$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $a3d1524f71b9275a$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $a3d1524f71b9275a$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $a3d1524f71b9275a$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $a3d1524f71b9275a$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    };
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericStart = function(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $a3d1524f71b9275a$var$TO_LOWER_BIT) === $a3d1524f71b9275a$var$CharCodes.LOWER_X) {
            this.state = $a3d1524f71b9275a$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $a3d1524f71b9275a$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    };
    EntityDecoder.prototype.addToNumericResult = function(str, start, end, base) {
        if (start !== end) {
            var digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    };
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericHex = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($a3d1524f71b9275a$var$isNumber(char) || $a3d1524f71b9275a$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    };
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericDecimal = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($a3d1524f71b9275a$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    };
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ EntityDecoder.prototype.emitNumericEntity = function(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $a3d1524f71b9275a$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $a3d1524f71b9275a$var$DecodingMode.Strict) return 0;
        this.emitCodePoint((0, $a3d1524f71b9275a$var$decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $a3d1524f71b9275a$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    };
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNamedEntity = function(str, offset) {
        var decodeTree = this.decodeTree;
        var current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        var valueLength = (current & $a3d1524f71b9275a$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            var char = str.charCodeAt(offset);
            this.treeIndex = $a3d1524f71b9275a$var$determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $a3d1524f71b9275a$var$DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $a3d1524f71b9275a$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $a3d1524f71b9275a$var$BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $a3d1524f71b9275a$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $a3d1524f71b9275a$var$DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    };
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNotTerminatedNamedEntity = function() {
        var _a;
        var _b = this, result = _b.result, decodeTree = _b.decodeTree;
        var valueLength = (decodeTree[result] & $a3d1524f71b9275a$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    };
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNamedEntityData = function(result, valueLength, consumed) {
        var decodeTree = this.decodeTree;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$a3d1524f71b9275a$var$BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    };
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.end = function() {
        var _a;
        switch(this.state){
            case $a3d1524f71b9275a$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $a3d1524f71b9275a$var$DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $a3d1524f71b9275a$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $a3d1524f71b9275a$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $a3d1524f71b9275a$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $a3d1524f71b9275a$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    };
    return EntityDecoder;
}();
$a3d1524f71b9275a$exports.EntityDecoder = $a3d1524f71b9275a$var$EntityDecoder;
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $a3d1524f71b9275a$var$getDecoder(decodeTree) {
    var ret = "";
    var decoder = new $a3d1524f71b9275a$var$EntityDecoder(decodeTree, function(str) {
        return ret += (0, $a3d1524f71b9275a$var$decode_codepoint_js_1.fromCodePoint)(str);
    });
    return function decodeWithTrie(str, decodeMode) {
        var lastIndex = 0;
        var offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            var len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        var result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */ function $a3d1524f71b9275a$var$determineBranch(decodeTree, current, nodeIdx, char) {
    var branchCount = (current & $a3d1524f71b9275a$var$BinTrieFlags.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & $a3d1524f71b9275a$var$BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        var value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while(lo <= hi){
        var mid = lo + hi >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
$a3d1524f71b9275a$exports.determineBranch = $a3d1524f71b9275a$var$determineBranch;
var $a3d1524f71b9275a$var$htmlDecoder = $a3d1524f71b9275a$var$getDecoder($a3d1524f71b9275a$var$decode_data_html_js_1.default);
var $a3d1524f71b9275a$var$xmlDecoder = $a3d1524f71b9275a$var$getDecoder($a3d1524f71b9275a$var$decode_data_xml_js_1.default);
/**
 * Decodes an HTML string.
 *
 * @param str The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */ function $a3d1524f71b9275a$var$decodeHTML(str, mode) {
    if (mode === void 0) mode = $a3d1524f71b9275a$var$DecodingMode.Legacy;
    return $a3d1524f71b9275a$var$htmlDecoder(str, mode);
}
$a3d1524f71b9275a$exports.decodeHTML = $a3d1524f71b9275a$var$decodeHTML;
/**
 * Decodes an HTML string in an attribute.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $a3d1524f71b9275a$var$decodeHTMLAttribute(str) {
    return $a3d1524f71b9275a$var$htmlDecoder(str, $a3d1524f71b9275a$var$DecodingMode.Attribute);
}
$a3d1524f71b9275a$exports.decodeHTMLAttribute = $a3d1524f71b9275a$var$decodeHTMLAttribute;
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $a3d1524f71b9275a$var$decodeHTMLStrict(str) {
    return $a3d1524f71b9275a$var$htmlDecoder(str, $a3d1524f71b9275a$var$DecodingMode.Strict);
}
$a3d1524f71b9275a$exports.decodeHTMLStrict = $a3d1524f71b9275a$var$decodeHTMLStrict;
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $a3d1524f71b9275a$var$decodeXML(str) {
    return $a3d1524f71b9275a$var$xmlDecoder(str, $a3d1524f71b9275a$var$DecodingMode.Strict);
}
$a3d1524f71b9275a$exports.decodeXML = $a3d1524f71b9275a$var$decodeXML;


var $079cfa7e3ae6d9a7$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($079cfa7e3ae6d9a7$var$CharCodes || ($079cfa7e3ae6d9a7$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $079cfa7e3ae6d9a7$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["BeforeSpecialT"] = 23] = "BeforeSpecialT";
    State[State["SpecialStartSequence"] = 24] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 25] = "InSpecialTag";
    State[State["InEntity"] = 26] = "InEntity";
})($079cfa7e3ae6d9a7$var$State || ($079cfa7e3ae6d9a7$var$State = {}));
function $079cfa7e3ae6d9a7$var$isWhitespace(c) {
    return c === $079cfa7e3ae6d9a7$var$CharCodes.Space || c === $079cfa7e3ae6d9a7$var$CharCodes.NewLine || c === $079cfa7e3ae6d9a7$var$CharCodes.Tab || c === $079cfa7e3ae6d9a7$var$CharCodes.FormFeed || c === $079cfa7e3ae6d9a7$var$CharCodes.CarriageReturn;
}
function $079cfa7e3ae6d9a7$var$isEndOfTagSection(c) {
    return c === $079cfa7e3ae6d9a7$var$CharCodes.Slash || c === $079cfa7e3ae6d9a7$var$CharCodes.Gt || $079cfa7e3ae6d9a7$var$isWhitespace(c);
}
function $079cfa7e3ae6d9a7$var$isASCIIAlpha(c) {
    return c >= $079cfa7e3ae6d9a7$var$CharCodes.LowerA && c <= $079cfa7e3ae6d9a7$var$CharCodes.LowerZ || c >= $079cfa7e3ae6d9a7$var$CharCodes.UpperA && c <= $079cfa7e3ae6d9a7$var$CharCodes.UpperZ;
}
var $079cfa7e3ae6d9a7$export$cbf5509cea2ad22;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($079cfa7e3ae6d9a7$export$cbf5509cea2ad22 || ($079cfa7e3ae6d9a7$export$cbf5509cea2ad22 = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ const $079cfa7e3ae6d9a7$var$Sequences = {
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x3e
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ]),
    TextareaEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x65,
        0x78,
        0x74,
        0x61,
        0x72,
        0x65,
        0x61
    ])
};
class $079cfa7e3ae6d9a7$export$2e2bcd8739ae039 {
    constructor({ xmlMode: xmlMode = false, decodeEntities: decodeEntities = true }, cbs){
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = $079cfa7e3ae6d9a7$var$State.Text;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** The start of the last entity. */ this.entityStart = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = $079cfa7e3ae6d9a7$var$State.Text;
        /** For special parsing behavior inside of script and style tags. */ this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** The offset of the current buffer. */ this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityDecoder = new (0, $a3d1524f71b9275a$exports.EntityDecoder)(xmlMode ? (0, $a3d1524f71b9275a$exports.xmlDecodeTree) : (0, $a3d1524f71b9275a$exports.htmlDecodeTree), (cp, consumed)=>this.emitCodePoint(cp, consumed));
    }
    reset() {
        this.state = $079cfa7e3ae6d9a7$var$State.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = $079cfa7e3ae6d9a7$var$State.Text;
        this.currentSequence = undefined;
        this.running = true;
        this.offset = 0;
    }
    write(chunk) {
        this.offset += this.buffer.length;
        this.buffer = chunk;
        this.parse();
    }
    end() {
        if (this.running) this.finish();
    }
    pause() {
        this.running = false;
    }
    resume() {
        this.running = true;
        if (this.index < this.buffer.length + this.offset) this.parse();
    }
    stateText(c) {
        if (c === $079cfa7e3ae6d9a7$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($079cfa7e3ae6d9a7$var$CharCodes.Lt)) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = $079cfa7e3ae6d9a7$var$State.BeforeTagName;
            this.sectionStart = this.index;
        } else if (this.decodeEntities && c === $079cfa7e3ae6d9a7$var$CharCodes.Amp) this.startEntity();
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd ? $079cfa7e3ae6d9a7$var$isEndOfTagSection(c) : (c | 0x20) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.isSpecial = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = $079cfa7e3ae6d9a7$var$State.InTagName;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> tags, also decode entities. */ stateInSpecialTag(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === $079cfa7e3ae6d9a7$var$CharCodes.Gt || $079cfa7e3ae6d9a7$var$isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    // Spoof the index so that reported locations match up.
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2; // Skip over the `</`
                this.stateInClosingTagName(c);
                return; // We are done; skip the rest of the function.
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === $079cfa7e3ae6d9a7$var$Sequences.TitleEnd) // We have to parse entities in <title> tags.
            {
                if (this.decodeEntities && c === $079cfa7e3ae6d9a7$var$CharCodes.Amp) this.startEntity();
            } else if (this.fastForwardTo($079cfa7e3ae6d9a7$var$CharCodes.Lt)) // Outside of <title> tags, we can fast-forward.
            this.sequenceIndex = 1;
        } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
        this.sequenceIndex = Number(c === $079cfa7e3ae6d9a7$var$CharCodes.Lt);
    }
    stateCDATASequence(c) {
        if (c === $079cfa7e3ae6d9a7$var$Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === $079cfa7e3ae6d9a7$var$Sequences.Cdata.length) {
                this.state = $079cfa7e3ae6d9a7$var$State.InCommentLike;
                this.currentSequence = $079cfa7e3ae6d9a7$var$Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = $079cfa7e3ae6d9a7$var$State.InDeclaration;
            this.stateInDeclaration(c); // Reconsume the character
        }
    }
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */ fastForwardTo(c) {
        while(++this.index < this.buffer.length + this.offset){
            if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
        }
        /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
        return false;
    }
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */ stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === $079cfa7e3ae6d9a7$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                else this.cbs.oncomment(this.sectionStart, this.index, 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = $079cfa7e3ae6d9a7$var$State.Text;
            }
        } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
        {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
        this.sequenceIndex = 0;
    }
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ isTagStartChar(c) {
        return this.xmlMode ? !$079cfa7e3ae6d9a7$var$isEndOfTagSection(c) : $079cfa7e3ae6d9a7$var$isASCIIAlpha(c);
    }
    startSpecial(sequence, offset) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
        this.state = $079cfa7e3ae6d9a7$var$State.SpecialStartSequence;
    }
    stateBeforeTagName(c) {
        if (c === $079cfa7e3ae6d9a7$var$CharCodes.ExclamationMark) {
            this.state = $079cfa7e3ae6d9a7$var$State.BeforeDeclaration;
            this.sectionStart = this.index + 1;
        } else if (c === $079cfa7e3ae6d9a7$var$CharCodes.Questionmark) {
            this.state = $079cfa7e3ae6d9a7$var$State.InProcessingInstruction;
            this.sectionStart = this.index + 1;
        } else if (this.isTagStartChar(c)) {
            const lower = c | 0x20;
            this.sectionStart = this.index;
            if (this.xmlMode) this.state = $079cfa7e3ae6d9a7$var$State.InTagName;
            else if (lower === $079cfa7e3ae6d9a7$var$Sequences.ScriptEnd[2]) this.state = $079cfa7e3ae6d9a7$var$State.BeforeSpecialS;
            else if (lower === $079cfa7e3ae6d9a7$var$Sequences.TitleEnd[2]) this.state = $079cfa7e3ae6d9a7$var$State.BeforeSpecialT;
            else this.state = $079cfa7e3ae6d9a7$var$State.InTagName;
        } else if (c === $079cfa7e3ae6d9a7$var$CharCodes.Slash) this.state = $079cfa7e3ae6d9a7$var$State.BeforeClosingTagName;
        else {
            this.state = $079cfa7e3ae6d9a7$var$State.Text;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if ($079cfa7e3ae6d9a7$var$isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $079cfa7e3ae6d9a7$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateBeforeClosingTagName(c) {
        if ($079cfa7e3ae6d9a7$var$isWhitespace(c)) ;
        else if (c === $079cfa7e3ae6d9a7$var$CharCodes.Gt) this.state = $079cfa7e3ae6d9a7$var$State.Text;
        else {
            this.state = this.isTagStartChar(c) ? $079cfa7e3ae6d9a7$var$State.InClosingTagName : $079cfa7e3ae6d9a7$var$State.InSpecialComment;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === $079cfa7e3ae6d9a7$var$CharCodes.Gt || $079cfa7e3ae6d9a7$var$isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $079cfa7e3ae6d9a7$var$State.AfterClosingTagName;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        // Skip everything until ">"
        if (c === $079cfa7e3ae6d9a7$var$CharCodes.Gt || this.fastForwardTo($079cfa7e3ae6d9a7$var$CharCodes.Gt)) {
            this.state = $079cfa7e3ae6d9a7$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttributeName(c) {
        if (c === $079cfa7e3ae6d9a7$var$CharCodes.Gt) {
            this.cbs.onopentagend(this.index);
            if (this.isSpecial) {
                this.state = $079cfa7e3ae6d9a7$var$State.InSpecialTag;
                this.sequenceIndex = 0;
            } else this.state = $079cfa7e3ae6d9a7$var$State.Text;
            this.sectionStart = this.index + 1;
        } else if (c === $079cfa7e3ae6d9a7$var$CharCodes.Slash) this.state = $079cfa7e3ae6d9a7$var$State.InSelfClosingTag;
        else if (!$079cfa7e3ae6d9a7$var$isWhitespace(c)) {
            this.state = $079cfa7e3ae6d9a7$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === $079cfa7e3ae6d9a7$var$CharCodes.Gt) {
            this.cbs.onselfclosingtag(this.index);
            this.state = $079cfa7e3ae6d9a7$var$State.Text;
            this.sectionStart = this.index + 1;
            this.isSpecial = false; // Reset special state, in case of self-closing special tags
        } else if (!$079cfa7e3ae6d9a7$var$isWhitespace(c)) {
            this.state = $079cfa7e3ae6d9a7$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateInAttributeName(c) {
        if (c === $079cfa7e3ae6d9a7$var$CharCodes.Eq || $079cfa7e3ae6d9a7$var$isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.sectionStart = this.index;
            this.state = $079cfa7e3ae6d9a7$var$State.AfterAttributeName;
            this.stateAfterAttributeName(c);
        }
    }
    stateAfterAttributeName(c) {
        if (c === $079cfa7e3ae6d9a7$var$CharCodes.Eq) this.state = $079cfa7e3ae6d9a7$var$State.BeforeAttributeValue;
        else if (c === $079cfa7e3ae6d9a7$var$CharCodes.Slash || c === $079cfa7e3ae6d9a7$var$CharCodes.Gt) {
            this.cbs.onattribend($079cfa7e3ae6d9a7$export$cbf5509cea2ad22.NoValue, this.sectionStart);
            this.sectionStart = -1;
            this.state = $079cfa7e3ae6d9a7$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (!$079cfa7e3ae6d9a7$var$isWhitespace(c)) {
            this.cbs.onattribend($079cfa7e3ae6d9a7$export$cbf5509cea2ad22.NoValue, this.sectionStart);
            this.state = $079cfa7e3ae6d9a7$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateBeforeAttributeValue(c) {
        if (c === $079cfa7e3ae6d9a7$var$CharCodes.DoubleQuote) {
            this.state = $079cfa7e3ae6d9a7$var$State.InAttributeValueDq;
            this.sectionStart = this.index + 1;
        } else if (c === $079cfa7e3ae6d9a7$var$CharCodes.SingleQuote) {
            this.state = $079cfa7e3ae6d9a7$var$State.InAttributeValueSq;
            this.sectionStart = this.index + 1;
        } else if (!$079cfa7e3ae6d9a7$var$isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = $079cfa7e3ae6d9a7$var$State.InAttributeValueNq;
            this.stateInAttributeValueNoQuotes(c); // Reconsume token
        }
    }
    handleInAttributeValue(c, quote) {
        if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === $079cfa7e3ae6d9a7$var$CharCodes.DoubleQuote ? $079cfa7e3ae6d9a7$export$cbf5509cea2ad22.Double : $079cfa7e3ae6d9a7$export$cbf5509cea2ad22.Single, this.index + 1);
            this.state = $079cfa7e3ae6d9a7$var$State.BeforeAttributeName;
        } else if (this.decodeEntities && c === $079cfa7e3ae6d9a7$var$CharCodes.Amp) this.startEntity();
    }
    stateInAttributeValueDoubleQuotes(c) {
        this.handleInAttributeValue(c, $079cfa7e3ae6d9a7$var$CharCodes.DoubleQuote);
    }
    stateInAttributeValueSingleQuotes(c) {
        this.handleInAttributeValue(c, $079cfa7e3ae6d9a7$var$CharCodes.SingleQuote);
    }
    stateInAttributeValueNoQuotes(c) {
        if ($079cfa7e3ae6d9a7$var$isWhitespace(c) || c === $079cfa7e3ae6d9a7$var$CharCodes.Gt) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend($079cfa7e3ae6d9a7$export$cbf5509cea2ad22.Unquoted, this.index);
            this.state = $079cfa7e3ae6d9a7$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (this.decodeEntities && c === $079cfa7e3ae6d9a7$var$CharCodes.Amp) this.startEntity();
    }
    stateBeforeDeclaration(c) {
        if (c === $079cfa7e3ae6d9a7$var$CharCodes.OpeningSquareBracket) {
            this.state = $079cfa7e3ae6d9a7$var$State.CDATASequence;
            this.sequenceIndex = 0;
        } else this.state = c === $079cfa7e3ae6d9a7$var$CharCodes.Dash ? $079cfa7e3ae6d9a7$var$State.BeforeComment : $079cfa7e3ae6d9a7$var$State.InDeclaration;
    }
    stateInDeclaration(c) {
        if (c === $079cfa7e3ae6d9a7$var$CharCodes.Gt || this.fastForwardTo($079cfa7e3ae6d9a7$var$CharCodes.Gt)) {
            this.cbs.ondeclaration(this.sectionStart, this.index);
            this.state = $079cfa7e3ae6d9a7$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === $079cfa7e3ae6d9a7$var$CharCodes.Gt || this.fastForwardTo($079cfa7e3ae6d9a7$var$CharCodes.Gt)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = $079cfa7e3ae6d9a7$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === $079cfa7e3ae6d9a7$var$CharCodes.Dash) {
            this.state = $079cfa7e3ae6d9a7$var$State.InCommentLike;
            this.currentSequence = $079cfa7e3ae6d9a7$var$Sequences.CommentEnd;
            // Allow short comments (eg. <!-->)
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = $079cfa7e3ae6d9a7$var$State.InDeclaration;
    }
    stateInSpecialComment(c) {
        if (c === $079cfa7e3ae6d9a7$var$CharCodes.Gt || this.fastForwardTo($079cfa7e3ae6d9a7$var$CharCodes.Gt)) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = $079cfa7e3ae6d9a7$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        const lower = c | 0x20;
        if (lower === $079cfa7e3ae6d9a7$var$Sequences.ScriptEnd[3]) this.startSpecial($079cfa7e3ae6d9a7$var$Sequences.ScriptEnd, 4);
        else if (lower === $079cfa7e3ae6d9a7$var$Sequences.StyleEnd[3]) this.startSpecial($079cfa7e3ae6d9a7$var$Sequences.StyleEnd, 4);
        else {
            this.state = $079cfa7e3ae6d9a7$var$State.InTagName;
            this.stateInTagName(c); // Consume the token again
        }
    }
    stateBeforeSpecialT(c) {
        const lower = c | 0x20;
        if (lower === $079cfa7e3ae6d9a7$var$Sequences.TitleEnd[3]) this.startSpecial($079cfa7e3ae6d9a7$var$Sequences.TitleEnd, 4);
        else if (lower === $079cfa7e3ae6d9a7$var$Sequences.TextareaEnd[3]) this.startSpecial($079cfa7e3ae6d9a7$var$Sequences.TextareaEnd, 4);
        else {
            this.state = $079cfa7e3ae6d9a7$var$State.InTagName;
            this.stateInTagName(c); // Consume the token again
        }
    }
    startEntity() {
        this.baseState = this.state;
        this.state = $079cfa7e3ae6d9a7$var$State.InEntity;
        this.entityStart = this.index;
        this.entityDecoder.startEntity(this.xmlMode ? (0, $a3d1524f71b9275a$exports.DecodingMode).Strict : this.baseState === $079cfa7e3ae6d9a7$var$State.Text || this.baseState === $079cfa7e3ae6d9a7$var$State.InSpecialTag ? (0, $a3d1524f71b9275a$exports.DecodingMode).Legacy : (0, $a3d1524f71b9275a$exports.DecodingMode).Attribute);
    }
    stateInEntity() {
        const length = this.entityDecoder.write(this.buffer, this.index - this.offset);
        // If `length` is positive, we are done with the entity.
        if (length >= 0) {
            this.state = this.baseState;
            if (length === 0) this.index = this.entityStart;
        } else // Mark buffer as consumed.
        this.index = this.offset + this.buffer.length - 1;
    }
    /**
     * Remove data that has already been consumed from the buffer.
     */ cleanup() {
        // If we are inside of text or attributes, emit what we already have.
        if (this.running && this.sectionStart !== this.index) {
            if (this.state === $079cfa7e3ae6d9a7$var$State.Text || this.state === $079cfa7e3ae6d9a7$var$State.InSpecialTag && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === $079cfa7e3ae6d9a7$var$State.InAttributeValueDq || this.state === $079cfa7e3ae6d9a7$var$State.InAttributeValueSq || this.state === $079cfa7e3ae6d9a7$var$State.InAttributeValueNq) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    shouldContinue() {
        return this.index < this.buffer.length + this.offset && this.running;
    }
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ parse() {
        while(this.shouldContinue()){
            const c = this.buffer.charCodeAt(this.index - this.offset);
            switch(this.state){
                case $079cfa7e3ae6d9a7$var$State.Text:
                    this.stateText(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.SpecialStartSequence:
                    this.stateSpecialStartSequence(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.InSpecialTag:
                    this.stateInSpecialTag(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.CDATASequence:
                    this.stateCDATASequence(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.InAttributeValueDq:
                    this.stateInAttributeValueDoubleQuotes(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.InAttributeName:
                    this.stateInAttributeName(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.InCommentLike:
                    this.stateInCommentLike(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.InSpecialComment:
                    this.stateInSpecialComment(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.BeforeAttributeName:
                    this.stateBeforeAttributeName(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.InTagName:
                    this.stateInTagName(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.InClosingTagName:
                    this.stateInClosingTagName(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.BeforeTagName:
                    this.stateBeforeTagName(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.AfterAttributeName:
                    this.stateAfterAttributeName(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.InAttributeValueSq:
                    this.stateInAttributeValueSingleQuotes(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.BeforeAttributeValue:
                    this.stateBeforeAttributeValue(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.BeforeClosingTagName:
                    this.stateBeforeClosingTagName(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.AfterClosingTagName:
                    this.stateAfterClosingTagName(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.BeforeSpecialS:
                    this.stateBeforeSpecialS(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.BeforeSpecialT:
                    this.stateBeforeSpecialT(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.InAttributeValueNq:
                    this.stateInAttributeValueNoQuotes(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.InSelfClosingTag:
                    this.stateInSelfClosingTag(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.InDeclaration:
                    this.stateInDeclaration(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.BeforeDeclaration:
                    this.stateBeforeDeclaration(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.BeforeComment:
                    this.stateBeforeComment(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.InProcessingInstruction:
                    this.stateInProcessingInstruction(c);
                    break;
                case $079cfa7e3ae6d9a7$var$State.InEntity:
                    this.stateInEntity();
                    break;
            }
            this.index++;
        }
        this.cleanup();
    }
    finish() {
        if (this.state === $079cfa7e3ae6d9a7$var$State.InEntity) {
            this.entityDecoder.end();
            this.state = this.baseState;
        }
        this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length + this.offset;
        // If there is no remaining data, we are done.
        if (this.sectionStart >= endIndex) return;
        if (this.state === $079cfa7e3ae6d9a7$var$State.InCommentLike) {
            if (this.currentSequence === $079cfa7e3ae6d9a7$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex, 0);
            else this.cbs.oncomment(this.sectionStart, endIndex, 0);
        } else if (this.state === $079cfa7e3ae6d9a7$var$State.InTagName || this.state === $079cfa7e3ae6d9a7$var$State.BeforeAttributeName || this.state === $079cfa7e3ae6d9a7$var$State.BeforeAttributeValue || this.state === $079cfa7e3ae6d9a7$var$State.AfterAttributeName || this.state === $079cfa7e3ae6d9a7$var$State.InAttributeName || this.state === $079cfa7e3ae6d9a7$var$State.InAttributeValueSq || this.state === $079cfa7e3ae6d9a7$var$State.InAttributeValueDq || this.state === $079cfa7e3ae6d9a7$var$State.InAttributeValueNq || this.state === $079cfa7e3ae6d9a7$var$State.InClosingTagName) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    }
    emitCodePoint(cp, consumed) {
        if (this.baseState !== $079cfa7e3ae6d9a7$var$State.Text && this.baseState !== $079cfa7e3ae6d9a7$var$State.InSpecialTag) {
            if (this.sectionStart < this.entityStart) this.cbs.onattribdata(this.sectionStart, this.entityStart);
            this.sectionStart = this.entityStart + consumed;
            this.index = this.sectionStart - 1;
            this.cbs.onattribentity(cp);
        } else {
            if (this.sectionStart < this.entityStart) this.cbs.ontext(this.sectionStart, this.entityStart);
            this.sectionStart = this.entityStart + consumed;
            this.index = this.sectionStart - 1;
            this.cbs.ontextentity(cp, this.sectionStart);
        }
    }
}



const $113e79e332fd90fd$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
const $113e79e332fd90fd$var$pTag = new Set([
    "p"
]);
const $113e79e332fd90fd$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
const $113e79e332fd90fd$var$ddtTags = new Set([
    "dd",
    "dt"
]);
const $113e79e332fd90fd$var$rtpTags = new Set([
    "rt",
    "rp"
]);
const $113e79e332fd90fd$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "h1",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "h2",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "h3",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "h4",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "h5",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "h6",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "select",
        $113e79e332fd90fd$var$formTags
    ],
    [
        "input",
        $113e79e332fd90fd$var$formTags
    ],
    [
        "output",
        $113e79e332fd90fd$var$formTags
    ],
    [
        "button",
        $113e79e332fd90fd$var$formTags
    ],
    [
        "datalist",
        $113e79e332fd90fd$var$formTags
    ],
    [
        "textarea",
        $113e79e332fd90fd$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $113e79e332fd90fd$var$ddtTags
    ],
    [
        "dt",
        $113e79e332fd90fd$var$ddtTags
    ],
    [
        "address",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "article",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "aside",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "blockquote",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "details",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "div",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "dl",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "fieldset",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "figcaption",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "figure",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "footer",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "form",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "header",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "hr",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "main",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "nav",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "ol",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "pre",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "section",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "table",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "ul",
        $113e79e332fd90fd$var$pTag
    ],
    [
        "rt",
        $113e79e332fd90fd$var$rtpTags
    ],
    [
        "rp",
        $113e79e332fd90fd$var$rtpTags
    ],
    [
        "tbody",
        $113e79e332fd90fd$var$tableSectionTags
    ],
    [
        "tfoot",
        $113e79e332fd90fd$var$tableSectionTags
    ]
]);
const $113e79e332fd90fd$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
const $113e79e332fd90fd$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
const $113e79e332fd90fd$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
]);
const $113e79e332fd90fd$var$reNameEnd = /\s|\//;
class $113e79e332fd90fd$export$7acfa6ed01010e37 {
    constructor(cbs, options = {}){
        var _a, _b, _c, _d, _e, _f;
        this.options = options;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */ this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */ this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.htmlMode = !this.options.xmlMode;
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : this.htmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : this.htmlMode;
        this.recognizeSelfClosing = (_c = options.recognizeSelfClosing) !== null && _c !== void 0 ? _c : !this.htmlMode;
        this.tokenizer = new ((_d = options.Tokenizer) !== null && _d !== void 0 ? _d : (0, $079cfa7e3ae6d9a7$export$2e2bcd8739ae039))(this.options, this);
        this.foreignContext = [
            !this.htmlMode
        ];
        (_f = (_e = this.cbs).onparserinit) === null || _f === void 0 || _f.call(_e, this);
    }
    // Tokenizer event handlers
    /** @internal */ ontext(start, endIndex) {
        var _a, _b;
        const data = this.getSlice(start, endIndex);
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
        this.startIndex = endIndex;
    }
    /** @internal */ ontextentity(cp, endIndex) {
        var _a, _b;
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, (0, $a3d1524f71b9275a$exports.fromCodePoint)(cp));
        this.startIndex = endIndex;
    }
    /**
     * Checks if the current tag is a void element. Override this if you want
     * to specify your own additional void elements.
     */ isVoidElement(name) {
        return this.htmlMode && $113e79e332fd90fd$var$voidElements.has(name);
    }
    /** @internal */ onopentagname(start, endIndex) {
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        this.emitOpenTag(name);
    }
    emitOpenTag(name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        const impliesClose = this.htmlMode && $113e79e332fd90fd$var$openImpliesClose.get(name);
        if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[0])){
            const element = this.stack.shift();
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, true);
        }
        if (!this.isVoidElement(name)) {
            this.stack.unshift(name);
            if (this.htmlMode) {
                if ($113e79e332fd90fd$var$foreignContextElements.has(name)) this.foreignContext.unshift(true);
                else if ($113e79e332fd90fd$var$htmlIntegrationElements.has(name)) this.foreignContext.unshift(false);
            }
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, name);
        if (this.cbs.onopentag) this.attribs = {};
    }
    endOpenTag(isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
        this.tagname = "";
    }
    /** @internal */ onopentagend(endIndex) {
        this.endIndex = endIndex;
        this.endOpenTag(false);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onclosetag(start, endIndex) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        if (this.htmlMode && ($113e79e332fd90fd$var$foreignContextElements.has(name) || $113e79e332fd90fd$var$htmlIntegrationElements.has(name))) this.foreignContext.shift();
        if (!this.isVoidElement(name)) {
            const pos = this.stack.indexOf(name);
            if (pos !== -1) for(let index = 0; index <= pos; index++){
                const element = this.stack.shift();
                // We know the stack has sufficient elements.
                (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, index !== pos);
            }
            else if (this.htmlMode && name === "p") {
                // Implicit open before close
                this.emitOpenTag("p");
                this.closeCurrentTag(true);
            }
        } else if (this.htmlMode && name === "br") {
            // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
            (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, "br");
            (_f = (_e = this.cbs).onopentag) === null || _f === void 0 || _f.call(_e, "br", {}, true);
            (_h = (_g = this.cbs).onclosetag) === null || _h === void 0 || _h.call(_g, "br", false);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onselfclosingtag(endIndex) {
        this.endIndex = endIndex;
        if (this.recognizeSelfClosing || this.foreignContext[0]) {
            this.closeCurrentTag(false);
            // Set `startIndex` for next node
            this.startIndex = endIndex + 1;
        } else // Ignore the fact that the tag is self-closing.
        this.onopentagend(endIndex);
    }
    closeCurrentTag(isOpenImplied) {
        var _a, _b;
        const name = this.tagname;
        this.endOpenTag(isOpenImplied);
        // Self-closing tags will be on the top of the stack
        if (this.stack[0] === name) {
            // If the opening tag isn't implied, the closing tag has to be implied.
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name, !isOpenImplied);
            this.stack.shift();
        }
    }
    /** @internal */ onattribname(start, endIndex) {
        this.startIndex = start;
        const name = this.getSlice(start, endIndex);
        this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
    }
    /** @internal */ onattribdata(start, endIndex) {
        this.attribvalue += this.getSlice(start, endIndex);
    }
    /** @internal */ onattribentity(cp) {
        this.attribvalue += (0, $a3d1524f71b9275a$exports.fromCodePoint)(cp);
    }
    /** @internal */ onattribend(quote, endIndex) {
        var _a, _b;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote === (0, $079cfa7e3ae6d9a7$export$cbf5509cea2ad22).Double ? '"' : quote === (0, $079cfa7e3ae6d9a7$export$cbf5509cea2ad22).Single ? "'" : quote === (0, $079cfa7e3ae6d9a7$export$cbf5509cea2ad22).NoValue ? undefined : null);
        if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
        this.attribvalue = "";
    }
    getInstructionName(value) {
        const index = value.search($113e79e332fd90fd$var$reNameEnd);
        let name = index < 0 ? value : value.substr(0, index);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        return name;
    }
    /** @internal */ ondeclaration(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`!${name}`, `!${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onprocessinginstruction(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`?${name}`, `?${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncomment(start, endIndex, offset) {
        var _a, _b, _c, _d;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, this.getSlice(start, endIndex - offset));
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncdata(start, endIndex, offset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex - offset);
        if (!this.htmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
        } else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 || _h.call(_g, `[CDATA[${value}]]`);
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 || _k.call(_j);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onend() {
        var _a, _b;
        if (this.cbs.onclosetag) {
            // Set the end index for all remaining tags
            this.endIndex = this.startIndex;
            for(let index = 0; index < this.stack.length; index++)this.cbs.onclosetag(this.stack[index], true);
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
    }
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ reset() {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack.length = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
        this.buffers.length = 0;
        this.foreignContext.length = 0;
        this.foreignContext.unshift(!this.htmlMode);
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
    }
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ parseComplete(data) {
        this.reset();
        this.end(data);
    }
    getSlice(start, end) {
        while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
        let slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
        while(end - this.bufferOffset > this.buffers[0].length){
            this.shiftBuffer();
            slice += this.buffers[0].slice(0, end - this.bufferOffset);
        }
        return slice;
    }
    shiftBuffer() {
        this.bufferOffset += this.buffers[0].length;
        this.writeIndex--;
        this.buffers.shift();
    }
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ write(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".write() after done!"));
            return;
        }
        this.buffers.push(chunk);
        if (this.tokenizer.running) {
            this.tokenizer.write(chunk);
            this.writeIndex++;
        }
    }
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ end(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".end() after done!"));
            return;
        }
        if (chunk) this.write(chunk);
        this.ended = true;
        this.tokenizer.end();
    }
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ pause() {
        this.tokenizer.pause();
    }
    /**
     * Resumes parsing after `pause` was called.
     */ resume() {
        this.tokenizer.resume();
        while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
        if (this.ended) this.tokenizer.end();
    }
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ parseChunk(chunk) {
        this.write(chunk);
    }
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ done(chunk) {
        this.end(chunk);
    }
}


/** Types of elements found in htmlparser2's DOM */ var $6692653001d6142c$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($6692653001d6142c$export$b992dc138d950e31 || ($6692653001d6142c$export$b992dc138d950e31 = {}));
function $6692653001d6142c$export$3bf645f08efe3292(elem) {
    return elem.type === $6692653001d6142c$export$b992dc138d950e31.Tag || elem.type === $6692653001d6142c$export$b992dc138d950e31.Script || elem.type === $6692653001d6142c$export$b992dc138d950e31.Style;
}
const $6692653001d6142c$export$be92b6f5f03c0fe9 = $6692653001d6142c$export$b992dc138d950e31.Root;
const $6692653001d6142c$export$5f1af8db9871e1d6 = $6692653001d6142c$export$b992dc138d950e31.Text;
const $6692653001d6142c$export$befdefbdce210f91 = $6692653001d6142c$export$b992dc138d950e31.Directive;
const $6692653001d6142c$export$4d299b491347818a = $6692653001d6142c$export$b992dc138d950e31.Comment;
const $6692653001d6142c$export$2f8b47a141e57afc = $6692653001d6142c$export$b992dc138d950e31.Script;
const $6692653001d6142c$export$d9e45bc13d335801 = $6692653001d6142c$export$b992dc138d950e31.Style;
const $6692653001d6142c$export$3288d34c523a1192 = $6692653001d6142c$export$b992dc138d950e31.Tag;
const $6692653001d6142c$export$1f8b8f7e5c763232 = $6692653001d6142c$export$b992dc138d950e31.CDATA;
const $6692653001d6142c$export$31b44af36ff2c60f = $6692653001d6142c$export$b992dc138d950e31.Doctype;



class $8c39e6151f10fbad$export$85c928794f8d04d4 {
    constructor(){
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get previousSibling() {
        return this.prev;
    }
    set previousSibling(prev) {
        this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ cloneNode(recursive = false) {
        return $8c39e6151f10fbad$export$ae8e35ea29ddac22(this, recursive);
    }
}
class $8c39e6151f10fbad$export$c3569d91cd44d357 extends $8c39e6151f10fbad$export$85c928794f8d04d4 {
    /**
     * @param data The content of the data node
     */ constructor(data){
        super();
        this.data = data;
    }
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
}
class $8c39e6151f10fbad$export$5f1af8db9871e1d6 extends $8c39e6151f10fbad$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $6692653001d6142c$export$b992dc138d950e31).Text;
    }
    get nodeType() {
        return 3;
    }
}
class $8c39e6151f10fbad$export$4d299b491347818a extends $8c39e6151f10fbad$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $6692653001d6142c$export$b992dc138d950e31).Comment;
    }
    get nodeType() {
        return 8;
    }
}
class $8c39e6151f10fbad$export$9269dce19ee35e96 extends $8c39e6151f10fbad$export$c3569d91cd44d357 {
    constructor(name, data){
        super(data);
        this.name = name;
        this.type = (0, $6692653001d6142c$export$b992dc138d950e31).Directive;
    }
    get nodeType() {
        return 1;
    }
}
class $8c39e6151f10fbad$export$62be934f90997196 extends $8c39e6151f10fbad$export$85c928794f8d04d4 {
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ constructor(children){
        super();
        this.children = children;
    }
    // Aliases
    /** First child of the node. */ get firstChild() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */ get lastChild() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
}
class $8c39e6151f10fbad$export$1f8b8f7e5c763232 extends $8c39e6151f10fbad$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $6692653001d6142c$export$b992dc138d950e31).CDATA;
    }
    get nodeType() {
        return 4;
    }
}
class $8c39e6151f10fbad$export$b34a105447964f9f extends $8c39e6151f10fbad$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $6692653001d6142c$export$b992dc138d950e31).Root;
    }
    get nodeType() {
        return 9;
    }
}
class $8c39e6151f10fbad$export$db77ccec0bb4ccac extends $8c39e6151f10fbad$export$62be934f90997196 {
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ constructor(name, attribs, children = [], type = name === "script" ? (0, $6692653001d6142c$export$b992dc138d950e31).Script : name === "style" ? (0, $6692653001d6142c$export$b992dc138d950e31).Style : (0, $6692653001d6142c$export$b992dc138d950e31).Tag){
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name)=>{
            var _a, _b;
            return {
                name: name,
                value: this.attribs[name],
                namespace: (_a = this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
        });
    }
}
function $8c39e6151f10fbad$export$3bf645f08efe3292(node) {
    return (0, $6692653001d6142c$export$3bf645f08efe3292)(node);
}
function $8c39e6151f10fbad$export$c2d65aed98d39b56(node) {
    return node.type === (0, $6692653001d6142c$export$b992dc138d950e31).CDATA;
}
function $8c39e6151f10fbad$export$1879817ac5c922b7(node) {
    return node.type === (0, $6692653001d6142c$export$b992dc138d950e31).Text;
}
function $8c39e6151f10fbad$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $6692653001d6142c$export$b992dc138d950e31).Comment;
}
function $8c39e6151f10fbad$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $6692653001d6142c$export$b992dc138d950e31).Directive;
}
function $8c39e6151f10fbad$export$62858bae88b53fd0(node) {
    return node.type === (0, $6692653001d6142c$export$b992dc138d950e31).Root;
}
function $8c39e6151f10fbad$export$bd5ff50f0e53d41c(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
function $8c39e6151f10fbad$export$ae8e35ea29ddac22(node, recursive = false) {
    let result;
    if ($8c39e6151f10fbad$export$1879817ac5c922b7(node)) result = new $8c39e6151f10fbad$export$5f1af8db9871e1d6(node.data);
    else if ($8c39e6151f10fbad$export$3ab01370f5e64ac8(node)) result = new $8c39e6151f10fbad$export$4d299b491347818a(node.data);
    else if ($8c39e6151f10fbad$export$3bf645f08efe3292(node)) {
        const children = recursive ? $8c39e6151f10fbad$var$cloneChildren(node.children) : [];
        const clone = new $8c39e6151f10fbad$export$db77ccec0bb4ccac(node.name, {
            ...node.attribs
        }, children);
        children.forEach((child)=>child.parent = clone);
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = {
            ...node["x-attribsNamespace"]
        };
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = {
            ...node["x-attribsPrefix"]
        };
        result = clone;
    } else if ($8c39e6151f10fbad$export$c2d65aed98d39b56(node)) {
        const children = recursive ? $8c39e6151f10fbad$var$cloneChildren(node.children) : [];
        const clone = new $8c39e6151f10fbad$export$1f8b8f7e5c763232(children);
        children.forEach((child)=>child.parent = clone);
        result = clone;
    } else if ($8c39e6151f10fbad$export$62858bae88b53fd0(node)) {
        const children = recursive ? $8c39e6151f10fbad$var$cloneChildren(node.children) : [];
        const clone = new $8c39e6151f10fbad$export$b34a105447964f9f(children);
        children.forEach((child)=>child.parent = clone);
        if (node["x-mode"]) clone["x-mode"] = node["x-mode"];
        result = clone;
    } else if ($8c39e6151f10fbad$export$4b5d79f26e0e3ad5(node)) {
        const instruction = new $8c39e6151f10fbad$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error(`Not implemented yet: ${node.type}`);
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function $8c39e6151f10fbad$var$cloneChildren(childs) {
    const children = childs.map((child)=>$8c39e6151f10fbad$export$ae8e35ea29ddac22(child, true));
    for(let i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}


// Default options
const $2bd7da6ebd89dce7$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
class $2bd7da6ebd89dce7$export$ff8ccbac9225de62 {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ constructor(callback, options, elementCB){
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (0, $8c39e6151f10fbad$export$b34a105447964f9f)(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $2bd7da6ebd89dce7$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $2bd7da6ebd89dce7$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    onparserinit(parser) {
        this.parser = parser;
    }
    // Resets the handler back to starting state
    onreset() {
        this.dom = [];
        this.root = new (0, $8c39e6151f10fbad$export$b34a105447964f9f)(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    }
    // Signals the handler that parsing is done
    onend() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    }
    onerror(error) {
        this.handleCallback(error);
    }
    onclosetag() {
        this.lastNode = null;
        const elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    }
    onopentag(name, attribs) {
        const type = this.options.xmlMode ? (0, $6692653001d6142c$export$b992dc138d950e31).Tag : undefined;
        const element = new (0, $8c39e6151f10fbad$export$db77ccec0bb4ccac)(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    }
    ontext(data) {
        const { lastNode: lastNode } = this;
        if (lastNode && lastNode.type === (0, $6692653001d6142c$export$b992dc138d950e31).Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            const node = new (0, $8c39e6151f10fbad$export$5f1af8db9871e1d6)(data);
            this.addNode(node);
            this.lastNode = node;
        }
    }
    oncomment(data) {
        if (this.lastNode && this.lastNode.type === (0, $6692653001d6142c$export$b992dc138d950e31).Comment) {
            this.lastNode.data += data;
            return;
        }
        const node = new (0, $8c39e6151f10fbad$export$4d299b491347818a)(data);
        this.addNode(node);
        this.lastNode = node;
    }
    oncommentend() {
        this.lastNode = null;
    }
    oncdatastart() {
        const text = new (0, $8c39e6151f10fbad$export$5f1af8db9871e1d6)("");
        const node = new (0, $8c39e6151f10fbad$export$1f8b8f7e5c763232)([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    }
    oncdataend() {
        this.lastNode = null;
    }
    onprocessinginstruction(name, data) {
        const node = new (0, $8c39e6151f10fbad$export$9269dce19ee35e96)(name, data);
        this.addNode(node);
    }
    handleCallback(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    }
    addNode(node) {
        const parent = this.tagStack[this.tagStack.length - 1];
        const previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    }
}
var $2bd7da6ebd89dce7$export$2e2bcd8739ae039 = $2bd7da6ebd89dce7$export$ff8ccbac9225de62;





/*
 * Module dependencies
 */ 
// Generated using scripts/write-decode-map.ts
var $042bd405b1e22a22$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map((c)=>c.charCodeAt(0)));


// Generated using scripts/write-decode-map.ts
var $a546d171777a87bd$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));


// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $33255daf70f18021$var$_a;
const $33255daf70f18021$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $33255daf70f18021$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($33255daf70f18021$var$_a = String.fromCodePoint) !== null && $33255daf70f18021$var$_a !== void 0 ? $33255daf70f18021$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $33255daf70f18021$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $33255daf70f18021$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $33255daf70f18021$export$2e2bcd8739ae039(codePoint) {
    return $33255daf70f18021$export$73bfc63873071f74($33255daf70f18021$export$b978ab756102108a(codePoint));
}


var $99539d8aa42bd2c4$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($99539d8aa42bd2c4$var$CharCodes || ($99539d8aa42bd2c4$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $99539d8aa42bd2c4$var$TO_LOWER_BIT = 32;
var $99539d8aa42bd2c4$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($99539d8aa42bd2c4$export$6a4325c613e0faec || ($99539d8aa42bd2c4$export$6a4325c613e0faec = {}));
function $99539d8aa42bd2c4$var$isNumber(code) {
    return code >= $99539d8aa42bd2c4$var$CharCodes.ZERO && code <= $99539d8aa42bd2c4$var$CharCodes.NINE;
}
function $99539d8aa42bd2c4$var$isHexadecimalCharacter(code) {
    return code >= $99539d8aa42bd2c4$var$CharCodes.UPPER_A && code <= $99539d8aa42bd2c4$var$CharCodes.UPPER_F || code >= $99539d8aa42bd2c4$var$CharCodes.LOWER_A && code <= $99539d8aa42bd2c4$var$CharCodes.LOWER_F;
}
function $99539d8aa42bd2c4$var$isAsciiAlphaNumeric(code) {
    return code >= $99539d8aa42bd2c4$var$CharCodes.UPPER_A && code <= $99539d8aa42bd2c4$var$CharCodes.UPPER_Z || code >= $99539d8aa42bd2c4$var$CharCodes.LOWER_A && code <= $99539d8aa42bd2c4$var$CharCodes.LOWER_Z || $99539d8aa42bd2c4$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $99539d8aa42bd2c4$var$isEntityInAttributeInvalidEnd(code) {
    return code === $99539d8aa42bd2c4$var$CharCodes.EQUALS || $99539d8aa42bd2c4$var$isAsciiAlphaNumeric(code);
}
var $99539d8aa42bd2c4$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($99539d8aa42bd2c4$var$EntityDecoderState || ($99539d8aa42bd2c4$var$EntityDecoderState = {}));
var $99539d8aa42bd2c4$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($99539d8aa42bd2c4$export$8c8f129ce60f53c || ($99539d8aa42bd2c4$export$8c8f129ce60f53c = {}));
class $99539d8aa42bd2c4$export$15263a93ff7ec8ba {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $99539d8aa42bd2c4$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $99539d8aa42bd2c4$export$8c8f129ce60f53c.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $99539d8aa42bd2c4$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $99539d8aa42bd2c4$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $99539d8aa42bd2c4$var$CharCodes.NUM) {
                    this.state = $99539d8aa42bd2c4$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $99539d8aa42bd2c4$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $99539d8aa42bd2c4$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $99539d8aa42bd2c4$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $99539d8aa42bd2c4$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $99539d8aa42bd2c4$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $99539d8aa42bd2c4$var$TO_LOWER_BIT) === $99539d8aa42bd2c4$var$CharCodes.LOWER_X) {
            this.state = $99539d8aa42bd2c4$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $99539d8aa42bd2c4$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($99539d8aa42bd2c4$var$isNumber(char) || $99539d8aa42bd2c4$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($99539d8aa42bd2c4$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $99539d8aa42bd2c4$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $99539d8aa42bd2c4$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $33255daf70f18021$export$b978ab756102108a)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $99539d8aa42bd2c4$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $99539d8aa42bd2c4$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $99539d8aa42bd2c4$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $99539d8aa42bd2c4$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $99539d8aa42bd2c4$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $99539d8aa42bd2c4$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $99539d8aa42bd2c4$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $99539d8aa42bd2c4$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $99539d8aa42bd2c4$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$99539d8aa42bd2c4$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $99539d8aa42bd2c4$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $99539d8aa42bd2c4$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $99539d8aa42bd2c4$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $99539d8aa42bd2c4$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $99539d8aa42bd2c4$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $99539d8aa42bd2c4$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $99539d8aa42bd2c4$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $99539d8aa42bd2c4$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $33255daf70f18021$export$73bfc63873071f74)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $99539d8aa42bd2c4$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $99539d8aa42bd2c4$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $99539d8aa42bd2c4$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $99539d8aa42bd2c4$var$htmlDecoder = $99539d8aa42bd2c4$var$getDecoder((0, $042bd405b1e22a22$export$2e2bcd8739ae039));
const $99539d8aa42bd2c4$var$xmlDecoder = $99539d8aa42bd2c4$var$getDecoder((0, $a546d171777a87bd$export$2e2bcd8739ae039));
function $99539d8aa42bd2c4$export$f045cb747ce77a19(str, mode = $99539d8aa42bd2c4$export$8c8f129ce60f53c.Legacy) {
    return $99539d8aa42bd2c4$var$htmlDecoder(str, mode);
}
function $99539d8aa42bd2c4$export$49f5e8089adb006a(str) {
    return $99539d8aa42bd2c4$var$htmlDecoder(str, $99539d8aa42bd2c4$export$8c8f129ce60f53c.Attribute);
}
function $99539d8aa42bd2c4$export$da52f4371b3f37de(str) {
    return $99539d8aa42bd2c4$var$htmlDecoder(str, $99539d8aa42bd2c4$export$8c8f129ce60f53c.Strict);
}
function $99539d8aa42bd2c4$export$88e3b9643a8bd06e(str) {
    return $99539d8aa42bd2c4$var$xmlDecoder(str, $99539d8aa42bd2c4$export$8c8f129ce60f53c.Strict);
}


// Generated using scripts/write-encode-map.ts
function $e89f069dd1266264$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$e89f069dd1266264$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $e89f069dd1266264$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $e89f069dd1266264$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $e89f069dd1266264$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $e89f069dd1266264$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));


const $334b091ca42c7527$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $334b091ca42c7527$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $334b091ca42c7527$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $334b091ca42c7527$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $334b091ca42c7527$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $334b091ca42c7527$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$334b091ca42c7527$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $334b091ca42c7527$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $334b091ca42c7527$export$4e7f196112fea3c5 = $334b091ca42c7527$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $334b091ca42c7527$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $334b091ca42c7527$export$9e081872deefdcb0 = $334b091ca42c7527$var$getEscaper(/[&<>'"]/g, $334b091ca42c7527$var$xmlCodeMap);
const $334b091ca42c7527$export$30330f3d5eb70e11 = $334b091ca42c7527$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $334b091ca42c7527$export$96e6fc3a139b2555 = $334b091ca42c7527$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));


const $0ffc1a4112017940$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $0ffc1a4112017940$export$f9d6449b9af28dc1(data) {
    return $0ffc1a4112017940$var$encodeHTMLTrieRe($0ffc1a4112017940$var$htmlReplacer, data);
}
function $0ffc1a4112017940$export$e6e86c76506f1190(data) {
    return $0ffc1a4112017940$var$encodeHTMLTrieRe((0, $334b091ca42c7527$export$5699810ce3244ab8), data);
}
function $0ffc1a4112017940$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $e89f069dd1266264$export$2e2bcd8739ae039).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $334b091ca42c7527$export$e02688b8085d016b)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}



var $2f10beb0b232e0a6$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($2f10beb0b232e0a6$export$b8c86583d9718b50 || ($2f10beb0b232e0a6$export$b8c86583d9718b50 = {}));
var $2f10beb0b232e0a6$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($2f10beb0b232e0a6$export$1851b20d614eb756 || ($2f10beb0b232e0a6$export$1851b20d614eb756 = {}));
function $2f10beb0b232e0a6$export$2f872c0f2117be69(data, options = $2f10beb0b232e0a6$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $2f10beb0b232e0a6$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $99539d8aa42bd2c4$export$f045cb747ce77a19)(data, mode);
    }
    return (0, $99539d8aa42bd2c4$export$88e3b9643a8bd06e)(data);
}
function $2f10beb0b232e0a6$export$c94669f4c7d36be4(data, options = $2f10beb0b232e0a6$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $99539d8aa42bd2c4$export$8c8f129ce60f53c).Strict;
    return $2f10beb0b232e0a6$export$2f872c0f2117be69(data, opts);
}
function $2f10beb0b232e0a6$export$c564cdbbe6da493(data, options = $2f10beb0b232e0a6$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $2f10beb0b232e0a6$export$1851b20d614eb756.UTF8) return (0, $334b091ca42c7527$export$9e081872deefdcb0)(data);
    if (opts.mode === $2f10beb0b232e0a6$export$1851b20d614eb756.Attribute) return (0, $334b091ca42c7527$export$30330f3d5eb70e11)(data);
    if (opts.mode === $2f10beb0b232e0a6$export$1851b20d614eb756.Text) return (0, $334b091ca42c7527$export$96e6fc3a139b2555)(data);
    if (opts.level === $2f10beb0b232e0a6$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $2f10beb0b232e0a6$export$1851b20d614eb756.ASCII) return (0, $0ffc1a4112017940$export$e6e86c76506f1190)(data);
        return (0, $0ffc1a4112017940$export$f9d6449b9af28dc1)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $334b091ca42c7527$export$18855ec5be97da16)(data);
}


const $089fd6f9cd92cf18$export$82b917442d249e05 = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
].map((val)=>[
        val.toLowerCase(),
        val
    ]));
const $089fd6f9cd92cf18$export$b4cfbfd90280b005 = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
].map((val)=>[
        val.toLowerCase(),
        val
    ]));


const $22eaf83a08605b11$var$unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
]);
function $22eaf83a08605b11$var$replaceQuotes(value) {
    return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */ function $22eaf83a08605b11$var$formatAttributes(attributes, opts) {
    var _a;
    if (!attributes) return;
    const encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? $22eaf83a08605b11$var$replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $334b091ca42c7527$export$18855ec5be97da16) : (0, $334b091ca42c7527$export$30330f3d5eb70e11);
    return Object.keys(attributes).map((key)=>{
        var _a, _b;
        const value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") /* Fix up mixed-case attribute names */ key = (_b = (0, $089fd6f9cd92cf18$export$b4cfbfd90280b005).get(key)) !== null && _b !== void 0 ? _b : key;
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") return key;
        return `${key}="${encode(value)}"`;
    }).join(" ");
}
/**
 * Self-enclosing tags
 */ const $22eaf83a08605b11$var$singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
function $22eaf83a08605b11$export$b3890eb0ae9dca99(node, options = {}) {
    const nodes = "length" in node ? node : [
        node
    ];
    let output = "";
    for(let i = 0; i < nodes.length; i++)output += $22eaf83a08605b11$var$renderNode(nodes[i], options);
    return output;
}
var $22eaf83a08605b11$export$2e2bcd8739ae039 = $22eaf83a08605b11$export$b3890eb0ae9dca99;
function $22eaf83a08605b11$var$renderNode(node, options) {
    switch(node.type){
        case $6692653001d6142c$export$be92b6f5f03c0fe9:
            return $22eaf83a08605b11$export$b3890eb0ae9dca99(node.children, options);
        // @ts-expect-error We don't use `Doctype` yet
        case $6692653001d6142c$export$31b44af36ff2c60f:
        case $6692653001d6142c$export$befdefbdce210f91:
            return $22eaf83a08605b11$var$renderDirective(node);
        case $6692653001d6142c$export$4d299b491347818a:
            return $22eaf83a08605b11$var$renderComment(node);
        case $6692653001d6142c$export$1f8b8f7e5c763232:
            return $22eaf83a08605b11$var$renderCdata(node);
        case $6692653001d6142c$export$2f8b47a141e57afc:
        case $6692653001d6142c$export$d9e45bc13d335801:
        case $6692653001d6142c$export$3288d34c523a1192:
            return $22eaf83a08605b11$var$renderTag(node, options);
        case $6692653001d6142c$export$5f1af8db9871e1d6:
            return $22eaf83a08605b11$var$renderText(node, options);
    }
}
const $22eaf83a08605b11$var$foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
const $22eaf83a08605b11$var$foreignElements = new Set([
    "svg",
    "math"
]);
function $22eaf83a08605b11$var$renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */ elem.name = (_a = (0, $089fd6f9cd92cf18$export$82b917442d249e05).get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */ if (elem.parent && $22eaf83a08605b11$var$foreignModeIntegrationPoints.has(elem.parent.name)) opts = {
            ...opts,
            xmlMode: false
        };
    }
    if (!opts.xmlMode && $22eaf83a08605b11$var$foreignElements.has(elem.name)) opts = {
        ...opts,
        xmlMode: "foreign"
    };
    let tag = `<${elem.name}`;
    const attribs = $22eaf83a08605b11$var$formatAttributes(elem.attribs, opts);
    if (attribs) tag += ` ${attribs}`;
    if (elem.children.length === 0 && (opts.xmlMode ? opts.selfClosingTags !== false : opts.selfClosingTags && $22eaf83a08605b11$var$singleTag.has(elem.name))) {
        if (!opts.xmlMode) tag += " ";
        tag += "/>";
    } else {
        tag += ">";
        if (elem.children.length > 0) tag += $22eaf83a08605b11$export$b3890eb0ae9dca99(elem.children, opts);
        if (opts.xmlMode || !$22eaf83a08605b11$var$singleTag.has(elem.name)) tag += `</${elem.name}>`;
    }
    return tag;
}
function $22eaf83a08605b11$var$renderDirective(elem) {
    return `<${elem.data}>`;
}
function $22eaf83a08605b11$var$renderText(elem, opts) {
    var _a;
    let data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && $22eaf83a08605b11$var$unencodedElements.has(elem.parent.name))) data = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $334b091ca42c7527$export$18855ec5be97da16)(data) : (0, $334b091ca42c7527$export$96e6fc3a139b2555)(data);
    return data;
}
function $22eaf83a08605b11$var$renderCdata(elem) {
    return `<![CDATA[${elem.children[0].data}]]>`;
}
function $22eaf83a08605b11$var$renderComment(elem) {
    return `<!--${elem.data}-->`;
}



function $ced0e4f63c4623b6$export$39484b727cc2f324(node, options) {
    return (0, $22eaf83a08605b11$export$2e2bcd8739ae039)(node, options);
}
function $ced0e4f63c4623b6$export$7ed15b4d2218408(node, options) {
    return (0, $8c39e6151f10fbad$export$bd5ff50f0e53d41c)(node) ? node.children.map((node)=>$ced0e4f63c4623b6$export$39484b727cc2f324(node, options)).join("") : "";
}
function $ced0e4f63c4623b6$export$c72d34660a162238(node) {
    if (Array.isArray(node)) return node.map($ced0e4f63c4623b6$export$c72d34660a162238).join("");
    if ((0, $8c39e6151f10fbad$export$3bf645f08efe3292)(node)) return node.name === "br" ? "\n" : $ced0e4f63c4623b6$export$c72d34660a162238(node.children);
    if ((0, $8c39e6151f10fbad$export$c2d65aed98d39b56)(node)) return $ced0e4f63c4623b6$export$c72d34660a162238(node.children);
    if ((0, $8c39e6151f10fbad$export$1879817ac5c922b7)(node)) return node.data;
    return "";
}
function $ced0e4f63c4623b6$export$e0e0794250e9118f(node) {
    if (Array.isArray(node)) return node.map($ced0e4f63c4623b6$export$e0e0794250e9118f).join("");
    if ((0, $8c39e6151f10fbad$export$bd5ff50f0e53d41c)(node) && !(0, $8c39e6151f10fbad$export$3ab01370f5e64ac8)(node)) return $ced0e4f63c4623b6$export$e0e0794250e9118f(node.children);
    if ((0, $8c39e6151f10fbad$export$1879817ac5c922b7)(node)) return node.data;
    return "";
}
function $ced0e4f63c4623b6$export$5864bc2a45f1eb81(node) {
    if (Array.isArray(node)) return node.map($ced0e4f63c4623b6$export$5864bc2a45f1eb81).join("");
    if ((0, $8c39e6151f10fbad$export$bd5ff50f0e53d41c)(node) && (node.type === (0, $6692653001d6142c$export$b992dc138d950e31).Tag || (0, $8c39e6151f10fbad$export$c2d65aed98d39b56)(node))) return $ced0e4f63c4623b6$export$5864bc2a45f1eb81(node.children);
    if ((0, $8c39e6151f10fbad$export$1879817ac5c922b7)(node)) return node.data;
    return "";
}



function $29ca0f3c29a661d3$export$f8cf48ee793b41be(elem) {
    return (0, $8c39e6151f10fbad$export$bd5ff50f0e53d41c)(elem) ? elem.children : [];
}
function $29ca0f3c29a661d3$export$58081aedf094d85b(elem) {
    return elem.parent || null;
}
function $29ca0f3c29a661d3$export$f312c3733b79ac0d(elem) {
    const parent = $29ca0f3c29a661d3$export$58081aedf094d85b(elem);
    if (parent != null) return $29ca0f3c29a661d3$export$f8cf48ee793b41be(parent);
    const siblings = [
        elem
    ];
    let { prev: prev, next: next } = elem;
    while(prev != null){
        siblings.unshift(prev);
        ({ prev: prev } = prev);
    }
    while(next != null){
        siblings.push(next);
        ({ next: next } = next);
    }
    return siblings;
}
function $29ca0f3c29a661d3$export$1e335898aa11b111(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
function $29ca0f3c29a661d3$export$aa37f90c17957f38(elem, name) {
    return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
function $29ca0f3c29a661d3$export$7d9f7e9c1c02b41e(elem) {
    return elem.name;
}
function $29ca0f3c29a661d3$export$9be3779649ef9cc7(elem) {
    let { next: next } = elem;
    while(next !== null && !(0, $8c39e6151f10fbad$export$3bf645f08efe3292)(next))({ next: next } = next);
    return next;
}
function $29ca0f3c29a661d3$export$c8bafb6e59c0b8e(elem) {
    let { prev: prev } = elem;
    while(prev !== null && !(0, $8c39e6151f10fbad$export$3bf645f08efe3292)(prev))({ prev: prev } = prev);
    return prev;
}


/**
 * Remove an element from the dom
 *
 * @category Manipulation
 * @param elem The element to be removed
 */ function $ea77949acb37efb9$export$f883456a56996078(elem) {
    if (elem.prev) elem.prev.next = elem.next;
    if (elem.next) elem.next.prev = elem.prev;
    if (elem.parent) {
        const childs = elem.parent.children;
        const childsIndex = childs.lastIndexOf(elem);
        if (childsIndex >= 0) childs.splice(childsIndex, 1);
    }
    elem.next = null;
    elem.prev = null;
    elem.parent = null;
}
function $ea77949acb37efb9$export$2dfe578f95754f6a(elem, replacement) {
    const prev = replacement.prev = elem.prev;
    if (prev) prev.next = replacement;
    const next = replacement.next = elem.next;
    if (next) next.prev = replacement;
    const parent = replacement.parent = elem.parent;
    if (parent) {
        const childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
        elem.parent = null;
    }
}
function $ea77949acb37efb9$export$1b8e57c9ea42f1d2(parent, child) {
    $ea77949acb37efb9$export$f883456a56996078(child);
    child.next = null;
    child.parent = parent;
    if (parent.children.push(child) > 1) {
        const sibling = parent.children[parent.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    } else child.prev = null;
}
function $ea77949acb37efb9$export$10d8903dec122b9d(elem, next) {
    $ea77949acb37efb9$export$f883456a56996078(next);
    const { parent: parent } = elem;
    const currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            const childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    } else if (parent) parent.children.push(next);
}
function $ea77949acb37efb9$export$47b51e6d100007bc(parent, child) {
    $ea77949acb37efb9$export$f883456a56996078(child);
    child.parent = parent;
    child.prev = null;
    if (parent.children.unshift(child) !== 1) {
        const sibling = parent.children[1];
        sibling.prev = child;
        child.next = sibling;
    } else child.next = null;
}
function $ea77949acb37efb9$export$68159836694e22c1(elem, prev) {
    $ea77949acb37efb9$export$f883456a56996078(prev);
    const { parent: parent } = elem;
    if (parent) {
        const childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) elem.prev.next = prev;
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}



function $bbf4e7fbf08125f3$export$3dea766d36a8935f(test, node, recurse = true, limit = Infinity) {
    return $bbf4e7fbf08125f3$export$71aa6c912b956294(test, Array.isArray(node) ? node : [
        node
    ], recurse, limit);
}
function $bbf4e7fbf08125f3$export$71aa6c912b956294(test, nodes, recurse, limit) {
    const result = [];
    /** Stack of the arrays we are looking at. */ const nodeStack = [
        Array.isArray(nodes) ? nodes : [
            nodes
        ]
    ];
    /** Stack of the indices within the arrays. */ const indexStack = [
        0
    ];
    for(;;){
        // First, check if the current array has any more elements to look at.
        if (indexStack[0] >= nodeStack[0].length) {
            // If we have no more arrays to look at, we are done.
            if (indexStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0) return result;
        }
        if (recurse && (0, $8c39e6151f10fbad$export$bd5ff50f0e53d41c)(elem) && elem.children.length > 0) {
            /*
             * Add the children to the stack. We are depth-first, so this is
             * the next array we look at.
             */ indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
function $bbf4e7fbf08125f3$export$ac03a862904ce329(test, nodes) {
    return nodes.find(test);
}
function $bbf4e7fbf08125f3$export$a541876d5d7daf90(test, nodes, recurse = true) {
    const searchedNodes = Array.isArray(nodes) ? nodes : [
        nodes
    ];
    for(let i = 0; i < searchedNodes.length; i++){
        const node = searchedNodes[i];
        if ((0, $8c39e6151f10fbad$export$3bf645f08efe3292)(node) && test(node)) return node;
        if (recurse && (0, $8c39e6151f10fbad$export$bd5ff50f0e53d41c)(node) && node.children.length > 0) {
            const found = $bbf4e7fbf08125f3$export$a541876d5d7daf90(test, node.children, true);
            if (found) return found;
        }
    }
    return null;
}
function $bbf4e7fbf08125f3$export$9d99dce58ac4a31b(test, nodes) {
    return (Array.isArray(nodes) ? nodes : [
        nodes
    ]).some((node)=>(0, $8c39e6151f10fbad$export$3bf645f08efe3292)(node) && test(node) || (0, $8c39e6151f10fbad$export$bd5ff50f0e53d41c)(node) && $bbf4e7fbf08125f3$export$9d99dce58ac4a31b(test, node.children));
}
function $bbf4e7fbf08125f3$export$18200ea6c8035394(test, nodes) {
    const result = [];
    const nodeStack = [
        Array.isArray(nodes) ? nodes : [
            nodes
        ]
    ];
    const indexStack = [
        0
    ];
    for(;;){
        if (indexStack[0] >= nodeStack[0].length) {
            if (nodeStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if ((0, $8c39e6151f10fbad$export$3bf645f08efe3292)(elem) && test(elem)) result.push(elem);
        if ((0, $8c39e6151f10fbad$export$bd5ff50f0e53d41c)(elem) && elem.children.length > 0) {
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}




/**
 * A map of functions to check nodes against.
 */ const $337944f82d8fc42d$var$Checks = {
    tag_name (name) {
        if (typeof name === "function") return (elem)=>(0, $8c39e6151f10fbad$export$3bf645f08efe3292)(elem) && name(elem.name);
        else if (name === "*") return 0, $8c39e6151f10fbad$export$3bf645f08efe3292;
        return (elem)=>(0, $8c39e6151f10fbad$export$3bf645f08efe3292)(elem) && elem.name === name;
    },
    tag_type (type) {
        if (typeof type === "function") return (elem)=>type(elem.type);
        return (elem)=>elem.type === type;
    },
    tag_contains (data) {
        if (typeof data === "function") return (elem)=>(0, $8c39e6151f10fbad$export$1879817ac5c922b7)(elem) && data(elem.data);
        return (elem)=>(0, $8c39e6151f10fbad$export$1879817ac5c922b7)(elem) && elem.data === data;
    }
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */ function $337944f82d8fc42d$var$getAttribCheck(attrib, value) {
    if (typeof value === "function") return (elem)=>(0, $8c39e6151f10fbad$export$3bf645f08efe3292)(elem) && value(elem.attribs[attrib]);
    return (elem)=>(0, $8c39e6151f10fbad$export$3bf645f08efe3292)(elem) && elem.attribs[attrib] === value;
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */ function $337944f82d8fc42d$var$combineFuncs(a, b) {
    return (elem)=>a(elem) || b(elem);
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */ function $337944f82d8fc42d$var$compileTest(options) {
    const funcs = Object.keys(options).map((key)=>{
        const value = options[key];
        return Object.prototype.hasOwnProperty.call($337944f82d8fc42d$var$Checks, key) ? $337944f82d8fc42d$var$Checks[key](value) : $337944f82d8fc42d$var$getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce($337944f82d8fc42d$var$combineFuncs);
}
function $337944f82d8fc42d$export$7b31db6b5a0b2f32(options, node) {
    const test = $337944f82d8fc42d$var$compileTest(options);
    return test ? test(node) : true;
}
function $337944f82d8fc42d$export$73eac51a39d6b0eb(options, nodes, recurse, limit = Infinity) {
    const test = $337944f82d8fc42d$var$compileTest(options);
    return test ? (0, $bbf4e7fbf08125f3$export$3dea766d36a8935f)(test, nodes, recurse, limit) : [];
}
function $337944f82d8fc42d$export$83595b84fc78b9b4(id, nodes, recurse = true) {
    if (!Array.isArray(nodes)) nodes = [
        nodes
    ];
    return (0, $bbf4e7fbf08125f3$export$a541876d5d7daf90)($337944f82d8fc42d$var$getAttribCheck("id", id), nodes, recurse);
}
function $337944f82d8fc42d$export$af941c3c7c3b40f5(tagName, nodes, recurse = true, limit = Infinity) {
    return (0, $bbf4e7fbf08125f3$export$3dea766d36a8935f)($337944f82d8fc42d$var$Checks["tag_name"](tagName), nodes, recurse, limit);
}
function $337944f82d8fc42d$export$764e2797d3aa1cff(className, nodes, recurse = true, limit = Infinity) {
    return (0, $bbf4e7fbf08125f3$export$3dea766d36a8935f)($337944f82d8fc42d$var$getAttribCheck("class", className), nodes, recurse, limit);
}
function $337944f82d8fc42d$export$f5d981e30be5545b(type, nodes, recurse = true, limit = Infinity) {
    return (0, $bbf4e7fbf08125f3$export$3dea766d36a8935f)($337944f82d8fc42d$var$Checks["tag_type"](type), nodes, recurse, limit);
}



function $b9842e9daadbeb8c$export$171dc294232ebeef(nodes) {
    let idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */ while(--idx >= 0){
        const node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */ if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for(let ancestor = node.parent; ancestor; ancestor = ancestor.parent)if (nodes.includes(ancestor)) {
            nodes.splice(idx, 1);
            break;
        }
    }
    return nodes;
}
var $b9842e9daadbeb8c$export$406a59d989e8005a;
(function(DocumentPosition) {
    DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})($b9842e9daadbeb8c$export$406a59d989e8005a || ($b9842e9daadbeb8c$export$406a59d989e8005a = {}));
function $b9842e9daadbeb8c$export$17303b8fea718ecc(nodeA, nodeB) {
    const aParents = [];
    const bParents = [];
    if (nodeA === nodeB) return 0;
    let current = (0, $8c39e6151f10fbad$export$bd5ff50f0e53d41c)(nodeA) ? nodeA : nodeA.parent;
    while(current){
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, $8c39e6151f10fbad$export$bd5ff50f0e53d41c)(nodeB) ? nodeB : nodeB.parent;
    while(current){
        bParents.unshift(current);
        current = current.parent;
    }
    const maxIdx = Math.min(aParents.length, bParents.length);
    let idx = 0;
    while(idx < maxIdx && aParents[idx] === bParents[idx])idx++;
    if (idx === 0) return $b9842e9daadbeb8c$export$406a59d989e8005a.DISCONNECTED;
    const sharedParent = aParents[idx - 1];
    const siblings = sharedParent.children;
    const aSibling = aParents[idx];
    const bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) return $b9842e9daadbeb8c$export$406a59d989e8005a.FOLLOWING | $b9842e9daadbeb8c$export$406a59d989e8005a.CONTAINED_BY;
        return $b9842e9daadbeb8c$export$406a59d989e8005a.FOLLOWING;
    }
    if (sharedParent === nodeA) return $b9842e9daadbeb8c$export$406a59d989e8005a.PRECEDING | $b9842e9daadbeb8c$export$406a59d989e8005a.CONTAINS;
    return $b9842e9daadbeb8c$export$406a59d989e8005a.PRECEDING;
}
function $b9842e9daadbeb8c$export$1c267319665a7e7e(nodes) {
    nodes = nodes.filter((node, i, arr)=>!arr.includes(node, i + 1));
    nodes.sort((a, b)=>{
        const relative = $b9842e9daadbeb8c$export$17303b8fea718ecc(a, b);
        if (relative & $b9842e9daadbeb8c$export$406a59d989e8005a.PRECEDING) return -1;
        else if (relative & $b9842e9daadbeb8c$export$406a59d989e8005a.FOLLOWING) return 1;
        return 0;
    });
    return nodes;
}




function $4ae48bb8ee480842$export$ad32138c9e09ad4(doc) {
    const feedRoot = $4ae48bb8ee480842$var$getOneElement($4ae48bb8ee480842$var$isValidFeed, doc);
    return !feedRoot ? null : feedRoot.name === "feed" ? $4ae48bb8ee480842$var$getAtomFeed(feedRoot) : $4ae48bb8ee480842$var$getRssFeed(feedRoot);
}
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $4ae48bb8ee480842$var$getAtomFeed(feedRoot) {
    var _a;
    const childs = feedRoot.children;
    const feed = {
        type: "atom",
        items: (0, $337944f82d8fc42d$export$af941c3c7c3b40f5)("entry", childs).map((item)=>{
            var _a;
            const { children: children } = item;
            const entry = {
                media: $4ae48bb8ee480842$var$getMediaElements(children)
            };
            $4ae48bb8ee480842$var$addConditionally(entry, "id", "id", children);
            $4ae48bb8ee480842$var$addConditionally(entry, "title", "title", children);
            const href = (_a = $4ae48bb8ee480842$var$getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
            if (href) entry.link = href;
            const description = $4ae48bb8ee480842$var$fetch("summary", children) || $4ae48bb8ee480842$var$fetch("content", children);
            if (description) entry.description = description;
            const pubDate = $4ae48bb8ee480842$var$fetch("updated", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $4ae48bb8ee480842$var$addConditionally(feed, "id", "id", childs);
    $4ae48bb8ee480842$var$addConditionally(feed, "title", "title", childs);
    const href = (_a = $4ae48bb8ee480842$var$getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
    if (href) feed.link = href;
    $4ae48bb8ee480842$var$addConditionally(feed, "description", "subtitle", childs);
    const updated = $4ae48bb8ee480842$var$fetch("updated", childs);
    if (updated) feed.updated = new Date(updated);
    $4ae48bb8ee480842$var$addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $4ae48bb8ee480842$var$getRssFeed(feedRoot) {
    var _a, _b;
    const childs = (_b = (_a = $4ae48bb8ee480842$var$getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    const feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, $337944f82d8fc42d$export$af941c3c7c3b40f5)("item", feedRoot.children).map((item)=>{
            const { children: children } = item;
            const entry = {
                media: $4ae48bb8ee480842$var$getMediaElements(children)
            };
            $4ae48bb8ee480842$var$addConditionally(entry, "id", "guid", children);
            $4ae48bb8ee480842$var$addConditionally(entry, "title", "title", children);
            $4ae48bb8ee480842$var$addConditionally(entry, "link", "link", children);
            $4ae48bb8ee480842$var$addConditionally(entry, "description", "description", children);
            const pubDate = $4ae48bb8ee480842$var$fetch("pubDate", children) || $4ae48bb8ee480842$var$fetch("dc:date", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $4ae48bb8ee480842$var$addConditionally(feed, "title", "title", childs);
    $4ae48bb8ee480842$var$addConditionally(feed, "link", "link", childs);
    $4ae48bb8ee480842$var$addConditionally(feed, "description", "description", childs);
    const updated = $4ae48bb8ee480842$var$fetch("lastBuildDate", childs);
    if (updated) feed.updated = new Date(updated);
    $4ae48bb8ee480842$var$addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
const $4ae48bb8ee480842$var$MEDIA_KEYS_STRING = [
    "url",
    "type",
    "lang"
];
const $4ae48bb8ee480842$var$MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */ function $4ae48bb8ee480842$var$getMediaElements(where) {
    return (0, $337944f82d8fc42d$export$af941c3c7c3b40f5)("media:content", where).map((elem)=>{
        const { attribs: attribs } = elem;
        const media = {
            medium: attribs["medium"],
            isDefault: !!attribs["isDefault"]
        };
        for (const attrib of $4ae48bb8ee480842$var$MEDIA_KEYS_STRING)if (attribs[attrib]) media[attrib] = attribs[attrib];
        for (const attrib of $4ae48bb8ee480842$var$MEDIA_KEYS_INT)if (attribs[attrib]) media[attrib] = parseInt(attribs[attrib], 10);
        if (attribs["expression"]) media.expression = attribs["expression"];
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */ function $4ae48bb8ee480842$var$getOneElement(tagName, node) {
    return (0, $337944f82d8fc42d$export$af941c3c7c3b40f5)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */ function $4ae48bb8ee480842$var$fetch(tagName, where, recurse = false) {
    return (0, $ced0e4f63c4623b6$export$e0e0794250e9118f)((0, $337944f82d8fc42d$export$af941c3c7c3b40f5)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */ function $4ae48bb8ee480842$var$addConditionally(obj, prop, tagName, where, recurse = false) {
    const val = $4ae48bb8ee480842$var$fetch(tagName, where, recurse);
    if (val) obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */ function $4ae48bb8ee480842$var$isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}





function $3451baad981580c0$export$b6a9369736b19f4d(data, options) {
    const handler = new (0, $2bd7da6ebd89dce7$export$ff8ccbac9225de62)(undefined, options);
    new (0, $113e79e332fd90fd$export$7acfa6ed01010e37)(handler, options).end(data);
    return handler.root;
}
function $3451baad981580c0$export$d66b332881d9723f(data, options) {
    return $3451baad981580c0$export$b6a9369736b19f4d(data, options).children;
}
function $3451baad981580c0$export$d6f7114fde618113(callback, options, elementCallback) {
    const handler = new (0, $2bd7da6ebd89dce7$export$ff8ccbac9225de62)((error)=>callback(error, handler.root), options, elementCallback);
    return new (0, $113e79e332fd90fd$export$7acfa6ed01010e37)(handler, options);
}
function $3451baad981580c0$export$2bbd0317573b00fc(callback, options, elementCallback) {
    const handler = new (0, $2bd7da6ebd89dce7$export$ff8ccbac9225de62)(callback, options, elementCallback);
    return new (0, $113e79e332fd90fd$export$7acfa6ed01010e37)(handler, options);
}
const $3451baad981580c0$var$parseFeedDefaultOptions = {
    xmlMode: true
};
function $3451baad981580c0$export$5267abf679cd576b(feed, options = $3451baad981580c0$var$parseFeedDefaultOptions) {
    return (0, $4ae48bb8ee480842$export$ad32138c9e09ad4)($3451baad981580c0$export$d66b332881d9723f(feed, options));
}


var $59dc37022d7f7468$require$HtmlParser = $113e79e332fd90fd$export$7acfa6ed01010e37;

var $59dc37022d7f7468$require$DomHandler = $2bd7da6ebd89dce7$export$ff8ccbac9225de62;
var $65b7713b0ee99355$exports = {};
'use strict';
var $436b44ec2838b5a8$exports = {};
'use strict';
function $436b44ec2838b5a8$var$shouldProcessEveryNode(node) {
    return true;
}
$436b44ec2838b5a8$exports = {
    shouldProcessEveryNode: $436b44ec2838b5a8$var$shouldProcessEveryNode
};


var $0d24311b8fc0d310$exports = {};
'use strict';
var $095d501c19bb53d5$exports = {};
'use strict';
var $eadf6b96eb4cb31e$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $eadf6b96eb4cb31e$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $eadf6b96eb4cb31e$var$symbolTag = '[object Symbol]';
/** Used to match words composed of alphanumeric characters. */ var $eadf6b96eb4cb31e$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $eadf6b96eb4cb31e$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $eadf6b96eb4cb31e$var$rsAstralRange = '\\ud800-\\udfff', $eadf6b96eb4cb31e$var$rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23', $eadf6b96eb4cb31e$var$rsComboSymbolsRange = '\\u20d0-\\u20f0', $eadf6b96eb4cb31e$var$rsDingbatRange = '\\u2700-\\u27bf', $eadf6b96eb4cb31e$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $eadf6b96eb4cb31e$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $eadf6b96eb4cb31e$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $eadf6b96eb4cb31e$var$rsPunctuationRange = '\\u2000-\\u206f', $eadf6b96eb4cb31e$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $eadf6b96eb4cb31e$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $eadf6b96eb4cb31e$var$rsVarRange = '\\ufe0e\\ufe0f', $eadf6b96eb4cb31e$var$rsBreakRange = $eadf6b96eb4cb31e$var$rsMathOpRange + $eadf6b96eb4cb31e$var$rsNonCharRange + $eadf6b96eb4cb31e$var$rsPunctuationRange + $eadf6b96eb4cb31e$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $eadf6b96eb4cb31e$var$rsApos = "['\u2019]", $eadf6b96eb4cb31e$var$rsAstral = '[' + $eadf6b96eb4cb31e$var$rsAstralRange + ']', $eadf6b96eb4cb31e$var$rsBreak = '[' + $eadf6b96eb4cb31e$var$rsBreakRange + ']', $eadf6b96eb4cb31e$var$rsCombo = '[' + $eadf6b96eb4cb31e$var$rsComboMarksRange + $eadf6b96eb4cb31e$var$rsComboSymbolsRange + ']', $eadf6b96eb4cb31e$var$rsDigits = '\\d+', $eadf6b96eb4cb31e$var$rsDingbat = '[' + $eadf6b96eb4cb31e$var$rsDingbatRange + ']', $eadf6b96eb4cb31e$var$rsLower = '[' + $eadf6b96eb4cb31e$var$rsLowerRange + ']', $eadf6b96eb4cb31e$var$rsMisc = '[^' + $eadf6b96eb4cb31e$var$rsAstralRange + $eadf6b96eb4cb31e$var$rsBreakRange + $eadf6b96eb4cb31e$var$rsDigits + $eadf6b96eb4cb31e$var$rsDingbatRange + $eadf6b96eb4cb31e$var$rsLowerRange + $eadf6b96eb4cb31e$var$rsUpperRange + ']', $eadf6b96eb4cb31e$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $eadf6b96eb4cb31e$var$rsModifier = '(?:' + $eadf6b96eb4cb31e$var$rsCombo + '|' + $eadf6b96eb4cb31e$var$rsFitz + ')', $eadf6b96eb4cb31e$var$rsNonAstral = '[^' + $eadf6b96eb4cb31e$var$rsAstralRange + ']', $eadf6b96eb4cb31e$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $eadf6b96eb4cb31e$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $eadf6b96eb4cb31e$var$rsUpper = '[' + $eadf6b96eb4cb31e$var$rsUpperRange + ']', $eadf6b96eb4cb31e$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $eadf6b96eb4cb31e$var$rsLowerMisc = '(?:' + $eadf6b96eb4cb31e$var$rsLower + '|' + $eadf6b96eb4cb31e$var$rsMisc + ')', $eadf6b96eb4cb31e$var$rsUpperMisc = '(?:' + $eadf6b96eb4cb31e$var$rsUpper + '|' + $eadf6b96eb4cb31e$var$rsMisc + ')', $eadf6b96eb4cb31e$var$rsOptLowerContr = '(?:' + $eadf6b96eb4cb31e$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $eadf6b96eb4cb31e$var$rsOptUpperContr = '(?:' + $eadf6b96eb4cb31e$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $eadf6b96eb4cb31e$var$reOptMod = $eadf6b96eb4cb31e$var$rsModifier + '?', $eadf6b96eb4cb31e$var$rsOptVar = '[' + $eadf6b96eb4cb31e$var$rsVarRange + ']?', $eadf6b96eb4cb31e$var$rsOptJoin = '(?:' + $eadf6b96eb4cb31e$var$rsZWJ + '(?:' + [
    $eadf6b96eb4cb31e$var$rsNonAstral,
    $eadf6b96eb4cb31e$var$rsRegional,
    $eadf6b96eb4cb31e$var$rsSurrPair
].join('|') + ')' + $eadf6b96eb4cb31e$var$rsOptVar + $eadf6b96eb4cb31e$var$reOptMod + ')*', $eadf6b96eb4cb31e$var$rsSeq = $eadf6b96eb4cb31e$var$rsOptVar + $eadf6b96eb4cb31e$var$reOptMod + $eadf6b96eb4cb31e$var$rsOptJoin, $eadf6b96eb4cb31e$var$rsEmoji = '(?:' + [
    $eadf6b96eb4cb31e$var$rsDingbat,
    $eadf6b96eb4cb31e$var$rsRegional,
    $eadf6b96eb4cb31e$var$rsSurrPair
].join('|') + ')' + $eadf6b96eb4cb31e$var$rsSeq, $eadf6b96eb4cb31e$var$rsSymbol = '(?:' + [
    $eadf6b96eb4cb31e$var$rsNonAstral + $eadf6b96eb4cb31e$var$rsCombo + '?',
    $eadf6b96eb4cb31e$var$rsCombo,
    $eadf6b96eb4cb31e$var$rsRegional,
    $eadf6b96eb4cb31e$var$rsSurrPair,
    $eadf6b96eb4cb31e$var$rsAstral
].join('|') + ')';
/** Used to match apostrophes. */ var $eadf6b96eb4cb31e$var$reApos = RegExp($eadf6b96eb4cb31e$var$rsApos, 'g');
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $eadf6b96eb4cb31e$var$reComboMark = RegExp($eadf6b96eb4cb31e$var$rsCombo, 'g');
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $eadf6b96eb4cb31e$var$reUnicode = RegExp($eadf6b96eb4cb31e$var$rsFitz + '(?=' + $eadf6b96eb4cb31e$var$rsFitz + ')|' + $eadf6b96eb4cb31e$var$rsSymbol + $eadf6b96eb4cb31e$var$rsSeq, 'g');
/** Used to match complex or compound words. */ var $eadf6b96eb4cb31e$var$reUnicodeWord = RegExp([
    $eadf6b96eb4cb31e$var$rsUpper + '?' + $eadf6b96eb4cb31e$var$rsLower + '+' + $eadf6b96eb4cb31e$var$rsOptLowerContr + '(?=' + [
        $eadf6b96eb4cb31e$var$rsBreak,
        $eadf6b96eb4cb31e$var$rsUpper,
        '$'
    ].join('|') + ')',
    $eadf6b96eb4cb31e$var$rsUpperMisc + '+' + $eadf6b96eb4cb31e$var$rsOptUpperContr + '(?=' + [
        $eadf6b96eb4cb31e$var$rsBreak,
        $eadf6b96eb4cb31e$var$rsUpper + $eadf6b96eb4cb31e$var$rsLowerMisc,
        '$'
    ].join('|') + ')',
    $eadf6b96eb4cb31e$var$rsUpper + '?' + $eadf6b96eb4cb31e$var$rsLowerMisc + '+' + $eadf6b96eb4cb31e$var$rsOptLowerContr,
    $eadf6b96eb4cb31e$var$rsUpper + '+' + $eadf6b96eb4cb31e$var$rsOptUpperContr,
    $eadf6b96eb4cb31e$var$rsDigits,
    $eadf6b96eb4cb31e$var$rsEmoji
].join('|'), 'g');
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $eadf6b96eb4cb31e$var$reHasUnicode = RegExp('[' + $eadf6b96eb4cb31e$var$rsZWJ + $eadf6b96eb4cb31e$var$rsAstralRange + $eadf6b96eb4cb31e$var$rsComboMarksRange + $eadf6b96eb4cb31e$var$rsComboSymbolsRange + $eadf6b96eb4cb31e$var$rsVarRange + ']');
/** Used to detect strings that need a more robust regexp to match words. */ var $eadf6b96eb4cb31e$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/** Used to map Latin Unicode letters to basic Latin letters. */ var $eadf6b96eb4cb31e$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 'ss'
};
/** Detect free variable `global` from Node.js. */ var $eadf6b96eb4cb31e$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $eadf6b96eb4cb31e$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $eadf6b96eb4cb31e$var$root = $eadf6b96eb4cb31e$var$freeGlobal || $eadf6b96eb4cb31e$var$freeSelf || Function('return this')();
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $eadf6b96eb4cb31e$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $eadf6b96eb4cb31e$var$asciiToArray(string) {
    return string.split('');
}
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $eadf6b96eb4cb31e$var$asciiWords(string) {
    return string.match($eadf6b96eb4cb31e$var$reAsciiWord) || [];
}
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $eadf6b96eb4cb31e$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $eadf6b96eb4cb31e$var$deburrLetter = $eadf6b96eb4cb31e$var$basePropertyOf($eadf6b96eb4cb31e$var$deburredLetters);
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $eadf6b96eb4cb31e$var$hasUnicode(string) {
    return $eadf6b96eb4cb31e$var$reHasUnicode.test(string);
}
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $eadf6b96eb4cb31e$var$hasUnicodeWord(string) {
    return $eadf6b96eb4cb31e$var$reHasUnicodeWord.test(string);
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $eadf6b96eb4cb31e$var$stringToArray(string) {
    return $eadf6b96eb4cb31e$var$hasUnicode(string) ? $eadf6b96eb4cb31e$var$unicodeToArray(string) : $eadf6b96eb4cb31e$var$asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $eadf6b96eb4cb31e$var$unicodeToArray(string) {
    return string.match($eadf6b96eb4cb31e$var$reUnicode) || [];
}
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $eadf6b96eb4cb31e$var$unicodeWords(string) {
    return string.match($eadf6b96eb4cb31e$var$reUnicodeWord) || [];
}
/** Used for built-in method references. */ var $eadf6b96eb4cb31e$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $eadf6b96eb4cb31e$var$objectToString = $eadf6b96eb4cb31e$var$objectProto.toString;
/** Built-in value references. */ var $eadf6b96eb4cb31e$var$Symbol = $eadf6b96eb4cb31e$var$root.Symbol;
/** Used to convert symbols to primitives and strings. */ var $eadf6b96eb4cb31e$var$symbolProto = $eadf6b96eb4cb31e$var$Symbol ? $eadf6b96eb4cb31e$var$Symbol.prototype : undefined, $eadf6b96eb4cb31e$var$symbolToString = $eadf6b96eb4cb31e$var$symbolProto ? $eadf6b96eb4cb31e$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $eadf6b96eb4cb31e$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $eadf6b96eb4cb31e$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($eadf6b96eb4cb31e$var$isSymbol(value)) return $eadf6b96eb4cb31e$var$symbolToString ? $eadf6b96eb4cb31e$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$eadf6b96eb4cb31e$var$INFINITY ? '-0' : result;
}
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $eadf6b96eb4cb31e$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $eadf6b96eb4cb31e$var$baseSlice(array, start, end);
}
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $eadf6b96eb4cb31e$var$createCaseFirst(methodName) {
    return function(string) {
        string = $eadf6b96eb4cb31e$var$toString(string);
        var strSymbols = $eadf6b96eb4cb31e$var$hasUnicode(string) ? $eadf6b96eb4cb31e$var$stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $eadf6b96eb4cb31e$var$castSlice(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $eadf6b96eb4cb31e$var$createCompounder(callback) {
    return function(string) {
        return $eadf6b96eb4cb31e$var$arrayReduce($eadf6b96eb4cb31e$var$words($eadf6b96eb4cb31e$var$deburr(string).replace($eadf6b96eb4cb31e$var$reApos, '')), callback, '');
    };
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $eadf6b96eb4cb31e$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $eadf6b96eb4cb31e$var$isSymbol(value) {
    return typeof value == 'symbol' || $eadf6b96eb4cb31e$var$isObjectLike(value) && $eadf6b96eb4cb31e$var$objectToString.call(value) == $eadf6b96eb4cb31e$var$symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $eadf6b96eb4cb31e$var$toString(value) {
    return value == null ? '' : $eadf6b96eb4cb31e$var$baseToString(value);
}
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $eadf6b96eb4cb31e$var$camelCase = $eadf6b96eb4cb31e$var$createCompounder(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $eadf6b96eb4cb31e$var$capitalize(word) : word);
});
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $eadf6b96eb4cb31e$var$capitalize(string) {
    return $eadf6b96eb4cb31e$var$upperFirst($eadf6b96eb4cb31e$var$toString(string).toLowerCase());
}
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $eadf6b96eb4cb31e$var$deburr(string) {
    string = $eadf6b96eb4cb31e$var$toString(string);
    return string && string.replace($eadf6b96eb4cb31e$var$reLatin, $eadf6b96eb4cb31e$var$deburrLetter).replace($eadf6b96eb4cb31e$var$reComboMark, '');
}
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $eadf6b96eb4cb31e$var$upperFirst = $eadf6b96eb4cb31e$var$createCaseFirst('toUpperCase');
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $eadf6b96eb4cb31e$var$words(string, pattern, guard) {
    string = $eadf6b96eb4cb31e$var$toString(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $eadf6b96eb4cb31e$var$hasUnicodeWord(string) ? $eadf6b96eb4cb31e$var$unicodeWords(string) : $eadf6b96eb4cb31e$var$asciiWords(string);
    return string.match(pattern) || [];
}
$eadf6b96eb4cb31e$exports = $eadf6b96eb4cb31e$var$camelCase;



var $gIfym = parcelRequire("gIfym");
var $550c6e9de436a9b2$exports = {};
// These are all sourced from https://facebook.github.io/react/docs/tags-and-attributes.html -
// all attributes regardless of whether they have a different case to their HTML equivalents are
// listed to reduce the chance of human error and make it easier to just copy-paste the new list if
// it changes.
'use strict';
const $550c6e9de436a9b2$var$HTML_ATTRIBUTES = [
    'accept',
    'acceptCharset',
    'accessKey',
    'action',
    'allowFullScreen',
    'allowTransparency',
    'alt',
    'async',
    'autoComplete',
    'autoFocus',
    'autoPlay',
    'capture',
    'cellPadding',
    'cellSpacing',
    'challenge',
    'charSet',
    'checked',
    'cite',
    'classID',
    'className',
    'colSpan',
    'cols',
    'content',
    'contentEditable',
    'contextMenu',
    'controls',
    'coords',
    'crossOrigin',
    'data',
    'dateTime',
    'default',
    'defer',
    'dir',
    'disabled',
    'download',
    'draggable',
    'encType',
    'form',
    'formAction',
    'formEncType',
    'formMethod',
    'formNoValidate',
    'formTarget',
    'frameBorder',
    'headers',
    'height',
    'hidden',
    'high',
    'href',
    'hrefLang',
    'htmlFor',
    'httpEquiv',
    'icon',
    'id',
    'inputMode',
    'integrity',
    'is',
    'keyParams',
    'keyType',
    'kind',
    'label',
    'lang',
    'list',
    'loop',
    'low',
    'manifest',
    'marginHeight',
    'marginWidth',
    'max',
    'maxLength',
    'media',
    'mediaGroup',
    'method',
    'min',
    'minLength',
    'multiple',
    'muted',
    'name',
    'noValidate',
    'nonce',
    'open',
    'optimum',
    'pattern',
    'placeholder',
    'poster',
    'preload',
    'profile',
    'radioGroup',
    'readOnly',
    'rel',
    'required',
    'reversed',
    'role',
    'rowSpan',
    'rows',
    'sandbox',
    'scope',
    'scoped',
    'scrolling',
    'seamless',
    'selected',
    'shape',
    'size',
    'sizes',
    'span',
    'spellCheck',
    'src',
    'srcDoc',
    'srcLang',
    'srcSet',
    'start',
    'step',
    'style',
    'summary',
    'tabIndex',
    'target',
    'title',
    'type',
    'useMap',
    'value',
    'width',
    'wmode',
    'wrap',
    'onClick'
];
const $550c6e9de436a9b2$var$NON_STANDARD_ATTRIBUTES = [
    'autoCapitalize',
    'autoCorrect',
    'color',
    'itemProp',
    'itemScope',
    'itemType',
    'itemRef',
    'itemID',
    'security',
    'unselectable',
    'results',
    'autoSave'
];
const $550c6e9de436a9b2$var$SVG_ATTRIBUTES = [
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baseProfile',
    'baselineShift',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'ideographic',
    'imageRendering',
    'in',
    'in2',
    'intercept',
    'k',
    'k1',
    'k2',
    'k3',
    'k4',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'points',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'scale',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'vHanging',
    'vIdeographic',
    'vMathematical',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'viewBox',
    'viewTarget',
    'visibility',
    'widths',
    'wordSpacing',
    'writingMode',
    'x',
    'x1',
    'x2',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlns',
    'xmlnsXlink',
    'xmlBase',
    'xmlLang',
    'xmlSpace',
    'y',
    'y1',
    'y2',
    'yChannelSelector',
    'z',
    'zoomAndPan'
];
const $550c6e9de436a9b2$var$camelCaseMap = $550c6e9de436a9b2$var$HTML_ATTRIBUTES.concat($550c6e9de436a9b2$var$NON_STANDARD_ATTRIBUTES).concat($550c6e9de436a9b2$var$SVG_ATTRIBUTES).reduce(function(soFar, attr) {
    const lower = attr.toLowerCase();
    if (lower !== attr) soFar[lower] = attr;
    return soFar;
}, {});
$550c6e9de436a9b2$exports = $550c6e9de436a9b2$var$camelCaseMap;


function $095d501c19bb53d5$var$createStyleJsonFromString(styleString) {
    styleString = styleString || '';
    const styles = styleString.split(/;(?!base64)/);
    let singleStyle, key, value, jsonStyles = {};
    for(let i = 0; i < styles.length; ++i){
        singleStyle = styles[i].split(':');
        if (singleStyle.length > 2) singleStyle[1] = singleStyle.slice(1).join(':');
        key = singleStyle[0];
        value = singleStyle[1];
        if (typeof value === 'string') value = value.trim();
        if (key != null && value != null && key.length > 0 && value.length > 0) {
            key = key.trim();
            // Don't camelCase CSS custom properties
            if (key.indexOf('--') !== 0) key = $eadf6b96eb4cb31e$exports(key);
            jsonStyles[key] = value;
        }
    }
    return jsonStyles;
}
// Boolean HTML attributes, copied from https://meiert.com/en/blog/boolean-attributes-of-html/,
// on the form React expects.
const $095d501c19bb53d5$var$booleanAttrs = [
    'allowFullScreen',
    'allowpaymentrequest',
    'async',
    'autoFocus',
    'autoPlay',
    'checked',
    'controls',
    'default',
    'disabled',
    'formNoValidate',
    'hidden',
    'ismap',
    'itemScope',
    'loop',
    'multiple',
    'muted',
    'nomodule',
    'noValidate',
    'open',
    'playsinline',
    'readOnly',
    'required',
    'reversed',
    'selected',
    'truespeed'
];
function $095d501c19bb53d5$var$createElement(node, index, data, children) {
    let elementProps = {
        key: index
    };
    // The Custom Elements specification explicitly states that;
    // custom element names must contain a hyphen.
    // src: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    const isCustomElementNode = node.name.includes('-');
    if (node.attribs) elementProps = Object.entries(node.attribs).reduce((result, [key, value])=>{
        // if it's a custom element, we leave its attributes as is
        if (!isCustomElementNode) {
            key = $550c6e9de436a9b2$exports[key.replace(/[-:]/, '')] || key;
            if (key === 'style') value = $095d501c19bb53d5$var$createStyleJsonFromString(value);
            else if (key === 'class') key = 'className';
            else if (key === 'for') key = 'htmlFor';
            else if (key.startsWith('on')) value = Function(value);
            if ($095d501c19bb53d5$var$booleanAttrs.includes(key) && (value || '') === '') value = key;
        }
        result[key] = value;
        return result;
    }, elementProps);
    children = children || [];
    const allChildren = data != null ? [
        data
    ].concat(children) : children;
    return $gIfym.createElement.apply(null, [
        node.name,
        elementProps
    ].concat(allChildren));
}
$095d501c19bb53d5$exports = {
    createElement: $095d501c19bb53d5$var$createElement
};


// eslint-disable-next-line max-len
// https://github.com/facebook/react/blob/15.0-stable/src/renderers/dom/shared/ReactDOMComponent.js#L457
const $0d24311b8fc0d310$var$voidElementTags = [
    'area',
    'base',
    'br',
    'col',
    'embed',
    'hr',
    'img',
    'input',
    'keygen',
    'link',
    'meta',
    'param',
    'source',
    'track',
    'wbr',
    'menuitem',
    'textarea'
];
function $0d24311b8fc0d310$var$ProcessNodeDefinitions() {
    function processDefaultNode(node, children, index) {
        if (node.type === 'text') return node.data;
        else if (node.type === 'comment') // FIXME: The following doesn't work as the generated HTML results in
        // "&lt;!--  This is a comment  --&gt;"
        // return '<!-- ' + node.data + ' -->';
        return false;
        if ($0d24311b8fc0d310$var$voidElementTags.indexOf(node.name) > -1) return $095d501c19bb53d5$exports.createElement(node, index);
        else return $095d501c19bb53d5$exports.createElement(node, index, node.data, children);
    }
    return {
        processDefaultNode: processDefaultNode
    };
}
$0d24311b8fc0d310$exports = $0d24311b8fc0d310$var$ProcessNodeDefinitions;


function $65b7713b0ee99355$var$ProcessingInstructions() {
    const processNodeDefinitions = new $0d24311b8fc0d310$exports();
    return {
        defaultProcessingInstructions: [
            {
                shouldProcessNode: $436b44ec2838b5a8$exports.shouldProcessEveryNode,
                processNode: processNodeDefinitions.processDefaultNode
            }
        ]
    };
}
$65b7713b0ee99355$exports = $65b7713b0ee99355$var$ProcessingInstructions;


var $714ef7f120623a7b$exports = {};
'use strict';
function $714ef7f120623a7b$var$alwaysValid() {
    return true;
}
$714ef7f120623a7b$exports = {
    alwaysValid: $714ef7f120623a7b$var$alwaysValid
};



function $59dc37022d7f7468$var$Html2ReactParser(options) {
    function parseHtmlToTree(html) {
        options = options || {};
        options.decodeEntities = true;
        const handler = new $59dc37022d7f7468$require$DomHandler();
        const parser = new $59dc37022d7f7468$require$HtmlParser(handler, options);
        parser.parseComplete(html);
        return handler.dom.filter(function(element) {
            return element.type !== 'directive';
        });
    }
    function traverseDom(node, isValidNode, processingInstructions, preprocessingInstructions, index) {
        if (isValidNode(node)) {
            (preprocessingInstructions || []).forEach((instruction)=>{
                if (instruction.shouldPreprocessNode(node)) instruction.preprocessNode(node, index);
            });
            const processingInstruction = (processingInstructions || []).find((instruction)=>{
                return instruction.shouldProcessNode(node);
            });
            if (processingInstruction != null) {
                const children = (node.children || []).map((child, i)=>{
                    return traverseDom(child, isValidNode, processingInstructions, preprocessingInstructions, i);
                }).filter((child)=>{
                    return child != null && child !== false;
                });
                if (processingInstruction.replaceChildren) return $095d501c19bb53d5$exports.createElement(node, index, node.data, [
                    processingInstruction.processNode(node, children, index)
                ]);
                else return processingInstruction.processNode(node, children, index);
            } else return false;
        } else return false;
    }
    function parseWithInstructions(html, isValidNode, processingInstructions, preprocessingInstructions) {
        const domTree = parseHtmlToTree(html);
        const list = domTree.map(function(domTreeItem, index) {
            return traverseDom(domTreeItem, isValidNode, processingInstructions, preprocessingInstructions, index);
        });
        return list.length <= 1 ? list[0] : list;
    }
    function parse(html) {
        const processingInstructions = new $65b7713b0ee99355$exports();
        return parseWithInstructions(html, $714ef7f120623a7b$exports.alwaysValid, processingInstructions.defaultProcessingInstructions);
    }
    return {
        parse: parse,
        parseWithInstructions: parseWithInstructions
    };
}
$59dc37022d7f7468$exports = $59dc37022d7f7468$var$Html2ReactParser;





$81aadd2924ec5f1a$exports = {
    Parser: $59dc37022d7f7468$exports,
    ProcessingInstructions: $65b7713b0ee99355$exports,
    IsValidNodeDefinitions: $714ef7f120623a7b$exports,
    ProcessNodeDefinitions: $0d24311b8fc0d310$exports
};


// Footer could be HTML, so we need to parse it.
const $538e5067ae27ebfc$var$Footer = ()=>{
    const content = '<div align="right"><br/>PLACEHOLDER_FOOTER_CONTENT</div>';
    const htmlToReactParser = new (0, $81aadd2924ec5f1a$exports.Parser)();
    const parsedContent = htmlToReactParser.parse(content);
    return parsedContent;
};
var $538e5067ae27ebfc$export$2e2bcd8739ae039 = $538e5067ae27ebfc$var$Footer;




var $gIfym = parcelRequire("gIfym");

var $hQJVM = parcelRequire("hQJVM");

var $6IRuR = parcelRequire("6IRuR");

var $2ae2160a13d672a8$exports = {};
"use strict";


Object.defineProperty($2ae2160a13d672a8$exports, "__esModule", {
    value: true
});
$2ae2160a13d672a8$exports.default = void 0;

var $2ae2160a13d672a8$var$React = $2794e01ecb82119c$exports((parcelRequire("gIfym")));

var $2ae2160a13d672a8$var$_createSvgIcon = $9b6be45f16d1a28c$exports((parcelRequire("kKaK5")));
var $2ae2160a13d672a8$var$_default = (0, $2ae2160a13d672a8$var$_createSvgIcon.default)(/*#__PURE__*/ $2ae2160a13d672a8$var$React.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');
$2ae2160a13d672a8$exports.default = $2ae2160a13d672a8$var$_default;




const $1dc8f044258e228d$var$useStyles = (0, $hQJVM.default)({
    root: {
        "& > * + *": {
            marginTop: 2
        }
    },
    link: {
        cursor: "pointer"
    }
});
const $1dc8f044258e228d$var$Subtitle = ({ report: report, onClick: onClick })=>{
    const classes = $1dc8f044258e228d$var$useStyles();
    const { aggregateBy: aggregateBy, window: window } = report;
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $39efb4eddec95c8d$export$2e2bcd8739ae039), {
            separator: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2ae2160a13d672a8$exports))), {
                fontSize: "small"
            }),
            "aria-label": "breadcrumb",
            onClick: onClick,
            children: aggregateBy && aggregateBy.length > 0 ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
                children: [
                    (0, $4ab43b5ac1a299dc$export$2e6bf8a055fccba2)(window),
                    " by ",
                    (0, $6IRuR.upperFirst)(aggregateBy)
                ]
            }) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
                children: (0, $4ab43b5ac1a299dc$export$2e6bf8a055fccba2)(window)
            })
        })
    });
};
var $1dc8f044258e228d$export$2e2bcd8739ae039 = /*#__PURE__*/ $gIfym.memo($1dc8f044258e228d$var$Subtitle);



parcelRequire("gIfym");

var $hQJVM = parcelRequire("hQJVM");





var $329372a40565750a$exports = {};
"use strict";


Object.defineProperty($329372a40565750a$exports, "__esModule", {
    value: true
});
$329372a40565750a$exports.default = void 0;

var $329372a40565750a$var$React = $2794e01ecb82119c$exports((parcelRequire("gIfym")));

var $329372a40565750a$var$_createSvgIcon = $9b6be45f16d1a28c$exports((parcelRequire("kKaK5")));
var $329372a40565750a$var$_default = (0, $329372a40565750a$var$_createSvgIcon.default)(/*#__PURE__*/ $329372a40565750a$var$React.createElement("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');
$329372a40565750a$exports.default = $329372a40565750a$var$_default;


const $08b36a1d9bca6415$var$useStyles = (0, $hQJVM.default)({
    root: {}
});
const $08b36a1d9bca6415$var$Warnings = ({ warnings: warnings })=>{
    const classes = $08b36a1d9bca6415$var$useStyles();
    if (!warnings || warnings.length === 0) return null;
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ee13f6b8f50f92d0$export$2e2bcd8739ae039), {
        className: classes.root,
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $e58b878dddb079be$export$2e2bcd8739ae039), {
            children: warnings.map((warn, i)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $260b2a0fcf443bd8$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b8a250a44f304319$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($329372a40565750a$exports))), {})
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $a409dd30f9558cb2$export$2e2bcd8739ae039), {
                            primary: warn.primary,
                            secondary: warn.secondary
                        })
                    ]
                }, i))
        })
    });
};
var $08b36a1d9bca6415$export$2e2bcd8739ae039 = $08b36a1d9bca6415$var$Warnings;


var $39363681bdb5f057$exports = {};
var $19f87469c0aa1cc1$exports = {};

var $19f87469c0aa1cc1$var$_typeof = $c33c301477c193c0$exports.default;
var $d09cb406687da39d$exports = {};

var $d09cb406687da39d$var$_typeof = $c33c301477c193c0$exports.default;
function $d09cb406687da39d$var$toPrimitive(t, r) {
    if ("object" != $d09cb406687da39d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d09cb406687da39d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$d09cb406687da39d$exports = $d09cb406687da39d$var$toPrimitive, $d09cb406687da39d$exports.__esModule = true, $d09cb406687da39d$exports["default"] = $d09cb406687da39d$exports;


function $19f87469c0aa1cc1$var$toPropertyKey(t) {
    var i = $d09cb406687da39d$exports(t, "string");
    return "symbol" == $19f87469c0aa1cc1$var$_typeof(i) ? i : i + "";
}
$19f87469c0aa1cc1$exports = $19f87469c0aa1cc1$var$toPropertyKey, $19f87469c0aa1cc1$exports.__esModule = true, $19f87469c0aa1cc1$exports["default"] = $19f87469c0aa1cc1$exports;


function $39363681bdb5f057$var$_defineProperty(e, r, t) {
    return (r = $19f87469c0aa1cc1$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$39363681bdb5f057$exports = $39363681bdb5f057$var$_defineProperty, $39363681bdb5f057$exports.__esModule = true, $39363681bdb5f057$exports["default"] = $39363681bdb5f057$exports;


'use strict';
function $381f9d98ed7dd6c7$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $7dba0ee10f9f7ad9$var$toString } = Object.prototype;
const { getPrototypeOf: $7dba0ee10f9f7ad9$var$getPrototypeOf } = Object;
const $7dba0ee10f9f7ad9$var$kindOf = ((cache)=>(thing)=>{
        const str = $7dba0ee10f9f7ad9$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $7dba0ee10f9f7ad9$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$7dba0ee10f9f7ad9$var$kindOf(thing) === type;
};
const $7dba0ee10f9f7ad9$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $7dba0ee10f9f7ad9$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $7dba0ee10f9f7ad9$var$isUndefined = $7dba0ee10f9f7ad9$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isBuffer(val) {
    return val !== null && !$7dba0ee10f9f7ad9$var$isUndefined(val) && val.constructor !== null && !$7dba0ee10f9f7ad9$var$isUndefined(val.constructor) && $7dba0ee10f9f7ad9$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $7dba0ee10f9f7ad9$var$isArrayBuffer = $7dba0ee10f9f7ad9$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $7dba0ee10f9f7ad9$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $7dba0ee10f9f7ad9$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $7dba0ee10f9f7ad9$var$isString = $7dba0ee10f9f7ad9$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $7dba0ee10f9f7ad9$var$isFunction = $7dba0ee10f9f7ad9$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $7dba0ee10f9f7ad9$var$isNumber = $7dba0ee10f9f7ad9$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $7dba0ee10f9f7ad9$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $7dba0ee10f9f7ad9$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $7dba0ee10f9f7ad9$var$isPlainObject = (val)=>{
    if ($7dba0ee10f9f7ad9$var$kindOf(val) !== 'object') return false;
    const prototype = $7dba0ee10f9f7ad9$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $7dba0ee10f9f7ad9$var$isDate = $7dba0ee10f9f7ad9$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $7dba0ee10f9f7ad9$var$isFile = $7dba0ee10f9f7ad9$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $7dba0ee10f9f7ad9$var$isBlob = $7dba0ee10f9f7ad9$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $7dba0ee10f9f7ad9$var$isFileList = $7dba0ee10f9f7ad9$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $7dba0ee10f9f7ad9$var$isStream = (val)=>$7dba0ee10f9f7ad9$var$isObject(val) && $7dba0ee10f9f7ad9$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $7dba0ee10f9f7ad9$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $7dba0ee10f9f7ad9$var$isFunction(thing.append) && ((kind = $7dba0ee10f9f7ad9$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $7dba0ee10f9f7ad9$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $7dba0ee10f9f7ad9$var$isURLSearchParams = $7dba0ee10f9f7ad9$var$kindOfTest('URLSearchParams');
const [$7dba0ee10f9f7ad9$var$isReadableStream, $7dba0ee10f9f7ad9$var$isRequest, $7dba0ee10f9f7ad9$var$isResponse, $7dba0ee10f9f7ad9$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($7dba0ee10f9f7ad9$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $7dba0ee10f9f7ad9$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $7dba0ee10f9f7ad9$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($7dba0ee10f9f7ad9$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $7dba0ee10f9f7ad9$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $7dba0ee10f9f7ad9$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $7dba0ee10f9f7ad9$var$isContextDefined = (context)=>!$7dba0ee10f9f7ad9$var$isUndefined(context) && context !== $7dba0ee10f9f7ad9$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $7dba0ee10f9f7ad9$var$merge() {
    const { caseless: caseless } = $7dba0ee10f9f7ad9$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $7dba0ee10f9f7ad9$var$findKey(result, key) || key;
        if ($7dba0ee10f9f7ad9$var$isPlainObject(result[targetKey]) && $7dba0ee10f9f7ad9$var$isPlainObject(val)) result[targetKey] = $7dba0ee10f9f7ad9$var$merge(result[targetKey], val);
        else if ($7dba0ee10f9f7ad9$var$isPlainObject(val)) result[targetKey] = $7dba0ee10f9f7ad9$var$merge({}, val);
        else if ($7dba0ee10f9f7ad9$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $7dba0ee10f9f7ad9$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $7dba0ee10f9f7ad9$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $7dba0ee10f9f7ad9$var$forEach(b, (val, key)=>{
        if (thisArg && $7dba0ee10f9f7ad9$var$isFunction(val)) a[key] = (0, $381f9d98ed7dd6c7$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $7dba0ee10f9f7ad9$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $7dba0ee10f9f7ad9$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $7dba0ee10f9f7ad9$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $7dba0ee10f9f7ad9$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $7dba0ee10f9f7ad9$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $7dba0ee10f9f7ad9$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($7dba0ee10f9f7ad9$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$7dba0ee10f9f7ad9$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $7dba0ee10f9f7ad9$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $7dba0ee10f9f7ad9$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $7dba0ee10f9f7ad9$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $7dba0ee10f9f7ad9$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $7dba0ee10f9f7ad9$var$isHTMLForm = $7dba0ee10f9f7ad9$var$kindOfTest('HTMLFormElement');
const $7dba0ee10f9f7ad9$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $7dba0ee10f9f7ad9$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $7dba0ee10f9f7ad9$var$isRegExp = $7dba0ee10f9f7ad9$var$kindOfTest('RegExp');
const $7dba0ee10f9f7ad9$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $7dba0ee10f9f7ad9$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $7dba0ee10f9f7ad9$var$freezeMethods = (obj)=>{
    $7dba0ee10f9f7ad9$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($7dba0ee10f9f7ad9$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$7dba0ee10f9f7ad9$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $7dba0ee10f9f7ad9$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $7dba0ee10f9f7ad9$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $7dba0ee10f9f7ad9$var$noop = ()=>{};
const $7dba0ee10f9f7ad9$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $7dba0ee10f9f7ad9$var$isSpecCompliantForm(thing) {
    return !!(thing && $7dba0ee10f9f7ad9$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $7dba0ee10f9f7ad9$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($7dba0ee10f9f7ad9$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $7dba0ee10f9f7ad9$var$isArray(source) ? [] : {};
                $7dba0ee10f9f7ad9$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$7dba0ee10f9f7ad9$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $7dba0ee10f9f7ad9$var$isAsyncFn = $7dba0ee10f9f7ad9$var$kindOfTest('AsyncFunction');
const $7dba0ee10f9f7ad9$var$isThenable = (thing)=>thing && ($7dba0ee10f9f7ad9$var$isObject(thing) || $7dba0ee10f9f7ad9$var$isFunction(thing)) && $7dba0ee10f9f7ad9$var$isFunction(thing.then) && $7dba0ee10f9f7ad9$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $7dba0ee10f9f7ad9$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $7dba0ee10f9f7ad9$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $7dba0ee10f9f7ad9$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $7dba0ee10f9f7ad9$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $7dba0ee10f9f7ad9$var$isFunction($7dba0ee10f9f7ad9$var$_global.postMessage));
const $7dba0ee10f9f7ad9$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($7dba0ee10f9f7ad9$var$_global) : $7dba0ee10f9f7ad9$var$_setImmediate;
var // *********************
$7dba0ee10f9f7ad9$export$2e2bcd8739ae039 = {
    isArray: $7dba0ee10f9f7ad9$var$isArray,
    isArrayBuffer: $7dba0ee10f9f7ad9$var$isArrayBuffer,
    isBuffer: $7dba0ee10f9f7ad9$var$isBuffer,
    isFormData: $7dba0ee10f9f7ad9$var$isFormData,
    isArrayBufferView: $7dba0ee10f9f7ad9$var$isArrayBufferView,
    isString: $7dba0ee10f9f7ad9$var$isString,
    isNumber: $7dba0ee10f9f7ad9$var$isNumber,
    isBoolean: $7dba0ee10f9f7ad9$var$isBoolean,
    isObject: $7dba0ee10f9f7ad9$var$isObject,
    isPlainObject: $7dba0ee10f9f7ad9$var$isPlainObject,
    isReadableStream: $7dba0ee10f9f7ad9$var$isReadableStream,
    isRequest: $7dba0ee10f9f7ad9$var$isRequest,
    isResponse: $7dba0ee10f9f7ad9$var$isResponse,
    isHeaders: $7dba0ee10f9f7ad9$var$isHeaders,
    isUndefined: $7dba0ee10f9f7ad9$var$isUndefined,
    isDate: $7dba0ee10f9f7ad9$var$isDate,
    isFile: $7dba0ee10f9f7ad9$var$isFile,
    isBlob: $7dba0ee10f9f7ad9$var$isBlob,
    isRegExp: $7dba0ee10f9f7ad9$var$isRegExp,
    isFunction: $7dba0ee10f9f7ad9$var$isFunction,
    isStream: $7dba0ee10f9f7ad9$var$isStream,
    isURLSearchParams: $7dba0ee10f9f7ad9$var$isURLSearchParams,
    isTypedArray: $7dba0ee10f9f7ad9$var$isTypedArray,
    isFileList: $7dba0ee10f9f7ad9$var$isFileList,
    forEach: $7dba0ee10f9f7ad9$var$forEach,
    merge: $7dba0ee10f9f7ad9$var$merge,
    extend: $7dba0ee10f9f7ad9$var$extend,
    trim: $7dba0ee10f9f7ad9$var$trim,
    stripBOM: $7dba0ee10f9f7ad9$var$stripBOM,
    inherits: $7dba0ee10f9f7ad9$var$inherits,
    toFlatObject: $7dba0ee10f9f7ad9$var$toFlatObject,
    kindOf: $7dba0ee10f9f7ad9$var$kindOf,
    kindOfTest: $7dba0ee10f9f7ad9$var$kindOfTest,
    endsWith: $7dba0ee10f9f7ad9$var$endsWith,
    toArray: $7dba0ee10f9f7ad9$var$toArray,
    forEachEntry: $7dba0ee10f9f7ad9$var$forEachEntry,
    matchAll: $7dba0ee10f9f7ad9$var$matchAll,
    isHTMLForm: $7dba0ee10f9f7ad9$var$isHTMLForm,
    hasOwnProperty: $7dba0ee10f9f7ad9$var$hasOwnProperty,
    hasOwnProp: $7dba0ee10f9f7ad9$var$hasOwnProperty,
    reduceDescriptors: $7dba0ee10f9f7ad9$var$reduceDescriptors,
    freezeMethods: $7dba0ee10f9f7ad9$var$freezeMethods,
    toObjectSet: $7dba0ee10f9f7ad9$var$toObjectSet,
    toCamelCase: $7dba0ee10f9f7ad9$var$toCamelCase,
    noop: $7dba0ee10f9f7ad9$var$noop,
    toFiniteNumber: $7dba0ee10f9f7ad9$var$toFiniteNumber,
    findKey: $7dba0ee10f9f7ad9$var$findKey,
    global: $7dba0ee10f9f7ad9$var$_global,
    isContextDefined: $7dba0ee10f9f7ad9$var$isContextDefined,
    isSpecCompliantForm: $7dba0ee10f9f7ad9$var$isSpecCompliantForm,
    toJSONObject: $7dba0ee10f9f7ad9$var$toJSONObject,
    isAsyncFn: $7dba0ee10f9f7ad9$var$isAsyncFn,
    isThenable: $7dba0ee10f9f7ad9$var$isThenable,
    setImmediate: $7dba0ee10f9f7ad9$var$_setImmediate,
    asap: $7dba0ee10f9f7ad9$var$asap
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $2e05ec49c9f7d58f$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).inherits($2e05ec49c9f7d58f$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $2e05ec49c9f7d58f$var$prototype = $2e05ec49c9f7d58f$var$AxiosError.prototype;
const $2e05ec49c9f7d58f$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $2e05ec49c9f7d58f$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($2e05ec49c9f7d58f$var$AxiosError, $2e05ec49c9f7d58f$var$descriptors);
Object.defineProperty($2e05ec49c9f7d58f$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$2e05ec49c9f7d58f$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($2e05ec49c9f7d58f$var$prototype);
    (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $2e05ec49c9f7d58f$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $2e05ec49c9f7d58f$export$2e2bcd8739ae039 = $2e05ec49c9f7d58f$var$AxiosError;


// eslint-disable-next-line strict
var $8abfd70dcc7991e7$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $6a772037c784145c$export$a143d493d941bafc;
var $6a772037c784145c$export$e4cf37d7f6fb9e0a;
var $6a772037c784145c$export$f99ded8fe4b79145;
var $6a772037c784145c$export$599f31c3813fae4d;
'use strict';
var $51c300904a140497$export$a48f0734ac7c2329;
var $51c300904a140497$export$d622b2ad8d90c771;
var $51c300904a140497$export$6100ba28696e12de;
'use strict';
$51c300904a140497$export$a48f0734ac7c2329 = $51c300904a140497$var$byteLength;
$51c300904a140497$export$d622b2ad8d90c771 = $51c300904a140497$var$toByteArray;
$51c300904a140497$export$6100ba28696e12de = $51c300904a140497$var$fromByteArray;
var $51c300904a140497$var$lookup = [];
var $51c300904a140497$var$revLookup = [];
var $51c300904a140497$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $51c300904a140497$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $51c300904a140497$var$i = 0, $51c300904a140497$var$len = $51c300904a140497$var$code.length; $51c300904a140497$var$i < $51c300904a140497$var$len; ++$51c300904a140497$var$i){
    $51c300904a140497$var$lookup[$51c300904a140497$var$i] = $51c300904a140497$var$code[$51c300904a140497$var$i];
    $51c300904a140497$var$revLookup[$51c300904a140497$var$code.charCodeAt($51c300904a140497$var$i)] = $51c300904a140497$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$51c300904a140497$var$revLookup['-'.charCodeAt(0)] = 62;
$51c300904a140497$var$revLookup['_'.charCodeAt(0)] = 63;
function $51c300904a140497$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $51c300904a140497$var$byteLength(b64) {
    var lens = $51c300904a140497$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $51c300904a140497$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $51c300904a140497$var$toByteArray(b64) {
    var tmp;
    var lens = $51c300904a140497$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $51c300904a140497$var$Arr($51c300904a140497$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $51c300904a140497$var$revLookup[b64.charCodeAt(i)] << 18 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $51c300904a140497$var$revLookup[b64.charCodeAt(i)] << 2 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $51c300904a140497$var$revLookup[b64.charCodeAt(i)] << 10 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $51c300904a140497$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $51c300904a140497$var$tripletToBase64(num) {
    return $51c300904a140497$var$lookup[num >> 18 & 0x3F] + $51c300904a140497$var$lookup[num >> 12 & 0x3F] + $51c300904a140497$var$lookup[num >> 6 & 0x3F] + $51c300904a140497$var$lookup[num & 0x3F];
}
function $51c300904a140497$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($51c300904a140497$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $51c300904a140497$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($51c300904a140497$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($51c300904a140497$var$lookup[tmp >> 2] + $51c300904a140497$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($51c300904a140497$var$lookup[tmp >> 10] + $51c300904a140497$var$lookup[tmp >> 4 & 0x3F] + $51c300904a140497$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $5c5047a9af555f4a$export$aafa59e2e03f2942;
var $5c5047a9af555f4a$export$68d8715fc104d294;
$5c5047a9af555f4a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$5c5047a9af555f4a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $6a772037c784145c$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$6a772037c784145c$export$a143d493d941bafc = $6a772037c784145c$var$Buffer;
$6a772037c784145c$export$e4cf37d7f6fb9e0a = $6a772037c784145c$var$SlowBuffer;
$6a772037c784145c$export$f99ded8fe4b79145 = 50;
const $6a772037c784145c$var$K_MAX_LENGTH = 0x7fffffff;
$6a772037c784145c$export$599f31c3813fae4d = $6a772037c784145c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $6a772037c784145c$var$Buffer.TYPED_ARRAY_SUPPORT = $6a772037c784145c$var$typedArraySupport();
if (!$6a772037c784145c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $6a772037c784145c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($6a772037c784145c$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$6a772037c784145c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($6a772037c784145c$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$6a772037c784145c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $6a772037c784145c$var$createBuffer(length) {
    if (length > $6a772037c784145c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $6a772037c784145c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $6a772037c784145c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $6a772037c784145c$var$allocUnsafe(arg);
    }
    return $6a772037c784145c$var$from(arg, encodingOrOffset, length);
}
$6a772037c784145c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $6a772037c784145c$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $6a772037c784145c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $6a772037c784145c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($6a772037c784145c$var$isInstance(value, ArrayBuffer) || value && $6a772037c784145c$var$isInstance(value.buffer, ArrayBuffer)) return $6a772037c784145c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($6a772037c784145c$var$isInstance(value, SharedArrayBuffer) || value && $6a772037c784145c$var$isInstance(value.buffer, SharedArrayBuffer))) return $6a772037c784145c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $6a772037c784145c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $6a772037c784145c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $6a772037c784145c$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $6a772037c784145c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $6a772037c784145c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($6a772037c784145c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($6a772037c784145c$var$Buffer, Uint8Array);
function $6a772037c784145c$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $6a772037c784145c$var$alloc(size, fill, encoding) {
    $6a772037c784145c$var$assertSize(size);
    if (size <= 0) return $6a772037c784145c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $6a772037c784145c$var$createBuffer(size).fill(fill, encoding) : $6a772037c784145c$var$createBuffer(size).fill(fill);
    return $6a772037c784145c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $6a772037c784145c$var$Buffer.alloc = function(size, fill, encoding) {
    return $6a772037c784145c$var$alloc(size, fill, encoding);
};
function $6a772037c784145c$var$allocUnsafe(size) {
    $6a772037c784145c$var$assertSize(size);
    return $6a772037c784145c$var$createBuffer(size < 0 ? 0 : $6a772037c784145c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $6a772037c784145c$var$Buffer.allocUnsafe = function(size) {
    return $6a772037c784145c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $6a772037c784145c$var$Buffer.allocUnsafeSlow = function(size) {
    return $6a772037c784145c$var$allocUnsafe(size);
};
function $6a772037c784145c$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$6a772037c784145c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $6a772037c784145c$var$byteLength(string, encoding) | 0;
    let buf = $6a772037c784145c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $6a772037c784145c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $6a772037c784145c$var$checked(array.length) | 0;
    const buf = $6a772037c784145c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $6a772037c784145c$var$fromArrayView(arrayView) {
    if ($6a772037c784145c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $6a772037c784145c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $6a772037c784145c$var$fromArrayLike(arrayView);
}
function $6a772037c784145c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $6a772037c784145c$var$Buffer.prototype);
    return buf;
}
function $6a772037c784145c$var$fromObject(obj) {
    if ($6a772037c784145c$var$Buffer.isBuffer(obj)) {
        const len = $6a772037c784145c$var$checked(obj.length) | 0;
        const buf = $6a772037c784145c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $6a772037c784145c$var$numberIsNaN(obj.length)) return $6a772037c784145c$var$createBuffer(0);
        return $6a772037c784145c$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $6a772037c784145c$var$fromArrayLike(obj.data);
}
function $6a772037c784145c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $6a772037c784145c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $6a772037c784145c$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $6a772037c784145c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $6a772037c784145c$var$Buffer.alloc(+length);
}
$6a772037c784145c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $6a772037c784145c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$6a772037c784145c$var$Buffer.compare = function compare(a, b) {
    if ($6a772037c784145c$var$isInstance(a, Uint8Array)) a = $6a772037c784145c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($6a772037c784145c$var$isInstance(b, Uint8Array)) b = $6a772037c784145c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$6a772037c784145c$var$Buffer.isBuffer(a) || !$6a772037c784145c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$6a772037c784145c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$6a772037c784145c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $6a772037c784145c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $6a772037c784145c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($6a772037c784145c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$6a772037c784145c$var$Buffer.isBuffer(buf)) buf = $6a772037c784145c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$6a772037c784145c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $6a772037c784145c$var$byteLength(string, encoding) {
    if ($6a772037c784145c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $6a772037c784145c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $6a772037c784145c$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $6a772037c784145c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $6a772037c784145c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$6a772037c784145c$var$Buffer.byteLength = $6a772037c784145c$var$byteLength;
function $6a772037c784145c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $6a772037c784145c$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $6a772037c784145c$var$utf8Slice(this, start, end);
        case 'ascii':
            return $6a772037c784145c$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $6a772037c784145c$var$latin1Slice(this, start, end);
        case 'base64':
            return $6a772037c784145c$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6a772037c784145c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$6a772037c784145c$var$Buffer.prototype._isBuffer = true;
function $6a772037c784145c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$6a772037c784145c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$6a772037c784145c$var$swap(this, i, i + 1);
    return this;
};
$6a772037c784145c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $6a772037c784145c$var$swap(this, i, i + 3);
        $6a772037c784145c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$6a772037c784145c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $6a772037c784145c$var$swap(this, i, i + 7);
        $6a772037c784145c$var$swap(this, i + 1, i + 6);
        $6a772037c784145c$var$swap(this, i + 2, i + 5);
        $6a772037c784145c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$6a772037c784145c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $6a772037c784145c$var$utf8Slice(this, 0, length);
    return $6a772037c784145c$var$slowToString.apply(this, arguments);
};
$6a772037c784145c$var$Buffer.prototype.toLocaleString = $6a772037c784145c$var$Buffer.prototype.toString;
$6a772037c784145c$var$Buffer.prototype.equals = function equals(b) {
    if (!$6a772037c784145c$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $6a772037c784145c$var$Buffer.compare(this, b) === 0;
};
$6a772037c784145c$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $6a772037c784145c$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($6a772037c784145c$var$customInspectSymbol) $6a772037c784145c$var$Buffer.prototype[$6a772037c784145c$var$customInspectSymbol] = $6a772037c784145c$var$Buffer.prototype.inspect;
$6a772037c784145c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($6a772037c784145c$var$isInstance(target, Uint8Array)) target = $6a772037c784145c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$6a772037c784145c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $6a772037c784145c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($6a772037c784145c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $6a772037c784145c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($6a772037c784145c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $6a772037c784145c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $6a772037c784145c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $6a772037c784145c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$6a772037c784145c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$6a772037c784145c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $6a772037c784145c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$6a772037c784145c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $6a772037c784145c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $6a772037c784145c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($6a772037c784145c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $6a772037c784145c$var$utf8Write(buf, string, offset, length) {
    return $6a772037c784145c$var$blitBuffer($6a772037c784145c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $6a772037c784145c$var$asciiWrite(buf, string, offset, length) {
    return $6a772037c784145c$var$blitBuffer($6a772037c784145c$var$asciiToBytes(string), buf, offset, length);
}
function $6a772037c784145c$var$base64Write(buf, string, offset, length) {
    return $6a772037c784145c$var$blitBuffer($6a772037c784145c$var$base64ToBytes(string), buf, offset, length);
}
function $6a772037c784145c$var$ucs2Write(buf, string, offset, length) {
    return $6a772037c784145c$var$blitBuffer($6a772037c784145c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$6a772037c784145c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $6a772037c784145c$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $6a772037c784145c$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $6a772037c784145c$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $6a772037c784145c$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6a772037c784145c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$6a772037c784145c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $6a772037c784145c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $51c300904a140497$export$6100ba28696e12de(buf);
    else return $51c300904a140497$export$6100ba28696e12de(buf.slice(start, end));
}
function $6a772037c784145c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $6a772037c784145c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $6a772037c784145c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $6a772037c784145c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $6a772037c784145c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $6a772037c784145c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $6a772037c784145c$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $6a772037c784145c$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $6a772037c784145c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $6a772037c784145c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $6a772037c784145c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$6a772037c784145c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $6a772037c784145c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $6a772037c784145c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$6a772037c784145c$var$Buffer.prototype.readUintLE = $6a772037c784145c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$6a772037c784145c$var$Buffer.prototype.readUintBE = $6a772037c784145c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$6a772037c784145c$var$Buffer.prototype.readUint8 = $6a772037c784145c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$6a772037c784145c$var$Buffer.prototype.readUint16LE = $6a772037c784145c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$6a772037c784145c$var$Buffer.prototype.readUint16BE = $6a772037c784145c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$6a772037c784145c$var$Buffer.prototype.readUint32LE = $6a772037c784145c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$6a772037c784145c$var$Buffer.prototype.readUint32BE = $6a772037c784145c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$6a772037c784145c$var$Buffer.prototype.readBigUInt64LE = $6a772037c784145c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $6a772037c784145c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6a772037c784145c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$6a772037c784145c$var$Buffer.prototype.readBigUInt64BE = $6a772037c784145c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $6a772037c784145c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6a772037c784145c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$6a772037c784145c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6a772037c784145c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6a772037c784145c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$6a772037c784145c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6a772037c784145c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6a772037c784145c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$6a772037c784145c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$6a772037c784145c$var$Buffer.prototype.readBigInt64LE = $6a772037c784145c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $6a772037c784145c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6a772037c784145c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$6a772037c784145c$var$Buffer.prototype.readBigInt64BE = $6a772037c784145c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $6a772037c784145c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6a772037c784145c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$6a772037c784145c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return $5c5047a9af555f4a$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$6a772037c784145c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 4, this.length);
    return $5c5047a9af555f4a$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$6a772037c784145c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 8, this.length);
    return $5c5047a9af555f4a$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$6a772037c784145c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkOffset(offset, 8, this.length);
    return $5c5047a9af555f4a$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $6a772037c784145c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$6a772037c784145c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$6a772037c784145c$var$Buffer.prototype.writeUintLE = $6a772037c784145c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6a772037c784145c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6a772037c784145c$var$Buffer.prototype.writeUintBE = $6a772037c784145c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6a772037c784145c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6a772037c784145c$var$Buffer.prototype.writeUint8 = $6a772037c784145c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$6a772037c784145c$var$Buffer.prototype.writeUint16LE = $6a772037c784145c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6a772037c784145c$var$Buffer.prototype.writeUint16BE = $6a772037c784145c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6a772037c784145c$var$Buffer.prototype.writeUint32LE = $6a772037c784145c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$6a772037c784145c$var$Buffer.prototype.writeUint32BE = $6a772037c784145c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $6a772037c784145c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $6a772037c784145c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $6a772037c784145c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $6a772037c784145c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$6a772037c784145c$var$Buffer.prototype.writeBigUInt64LE = $6a772037c784145c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $6a772037c784145c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6a772037c784145c$var$Buffer.prototype.writeBigUInt64BE = $6a772037c784145c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $6a772037c784145c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6a772037c784145c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $6a772037c784145c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6a772037c784145c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $6a772037c784145c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6a772037c784145c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$6a772037c784145c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6a772037c784145c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6a772037c784145c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$6a772037c784145c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$6a772037c784145c$var$Buffer.prototype.writeBigInt64LE = $6a772037c784145c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $6a772037c784145c$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$6a772037c784145c$var$Buffer.prototype.writeBigInt64BE = $6a772037c784145c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $6a772037c784145c$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $6a772037c784145c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $6a772037c784145c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5c5047a9af555f4a$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$6a772037c784145c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $6a772037c784145c$var$writeFloat(this, value, offset, true, noAssert);
};
$6a772037c784145c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $6a772037c784145c$var$writeFloat(this, value, offset, false, noAssert);
};
function $6a772037c784145c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6a772037c784145c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5c5047a9af555f4a$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$6a772037c784145c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $6a772037c784145c$var$writeDouble(this, value, offset, true, noAssert);
};
$6a772037c784145c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $6a772037c784145c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$6a772037c784145c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$6a772037c784145c$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$6a772037c784145c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$6a772037c784145c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $6a772037c784145c$var$Buffer.isBuffer(val) ? val : $6a772037c784145c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $6a772037c784145c$var$errors = {};
function $6a772037c784145c$var$E(sym, getMessage, Base) {
    $6a772037c784145c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$6a772037c784145c$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$6a772037c784145c$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$6a772037c784145c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $6a772037c784145c$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $6a772037c784145c$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $6a772037c784145c$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $6a772037c784145c$var$checkBounds(buf, offset, byteLength) {
    $6a772037c784145c$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $6a772037c784145c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $6a772037c784145c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $6a772037c784145c$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $6a772037c784145c$var$checkBounds(buf, offset, byteLength);
}
function $6a772037c784145c$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $6a772037c784145c$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $6a772037c784145c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $6a772037c784145c$var$validateNumber(value, type);
        throw new $6a772037c784145c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $6a772037c784145c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $6a772037c784145c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $6a772037c784145c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $6a772037c784145c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($6a772037c784145c$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $6a772037c784145c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $6a772037c784145c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $6a772037c784145c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $6a772037c784145c$var$base64ToBytes(str) {
    return $51c300904a140497$export$d622b2ad8d90c771($6a772037c784145c$var$base64clean(str));
}
function $6a772037c784145c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $6a772037c784145c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $6a772037c784145c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $6a772037c784145c$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $6a772037c784145c$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $6a772037c784145c$var$BufferBigIntNotDefined : fn;
}
function $6a772037c784145c$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $12550457841e8219$require$Buffer = $6a772037c784145c$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $12550457841e8219$var$isVisitable(thing) {
    return (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $12550457841e8219$var$removeBrackets(key) {
    return (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $12550457841e8219$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $12550457841e8219$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $12550457841e8219$var$isFlatArray(arr) {
    return (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isArray(arr) && !arr.some($12550457841e8219$var$isVisitable);
}
const $12550457841e8219$var$predicates = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).toFlatObject((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $12550457841e8219$var$toFormData(obj, formData, options) {
    if (!(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $8abfd70dcc7991e7$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $12550457841e8219$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isArray(value) && $12550457841e8219$var$isFlatArray(value) || ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isFileList(value) || (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $12550457841e8219$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $12550457841e8219$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($12550457841e8219$var$isVisitable(value)) return true;
        formData.append($12550457841e8219$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($12550457841e8219$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $12550457841e8219$var$isVisitable
    });
    function build(value, path) {
        if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $12550457841e8219$export$2e2bcd8739ae039 = $12550457841e8219$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $7fbca826415d3384$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $7fbca826415d3384$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $12550457841e8219$export$2e2bcd8739ae039)(params, this, options);
}
const $7fbca826415d3384$var$prototype = $7fbca826415d3384$var$AxiosURLSearchParams.prototype;
$7fbca826415d3384$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$7fbca826415d3384$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $7fbca826415d3384$var$encode);
    } : $7fbca826415d3384$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $7fbca826415d3384$export$2e2bcd8739ae039 = $7fbca826415d3384$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $0fa13816d630046e$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $0fa13816d630046e$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $0fa13816d630046e$var$encode;
    if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $7fbca826415d3384$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $961693ee68106526$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $961693ee68106526$export$2e2bcd8739ae039 = $961693ee68106526$var$InterceptorManager;





'use strict';
var $f3761d23331de665$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $62b572db6d613dee$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $7fbca826415d3384$export$2e2bcd8739ae039);


'use strict';
var $7b5c56697628e1fb$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $83174415a3ba91c3$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $f043f18f6751a04a$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $62b572db6d613dee$export$2e2bcd8739ae039,
        FormData: $7b5c56697628e1fb$export$2e2bcd8739ae039,
        Blob: $83174415a3ba91c3$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $55035a4e31e02517$exports = {};

$parcel$export($55035a4e31e02517$exports, "hasBrowserEnv", function () { return $55035a4e31e02517$export$c4996c4b7b93b0bf; });
$parcel$export($55035a4e31e02517$exports, "navigator", function () { return $55035a4e31e02517$export$ec7c8efa7f5790ae; });
$parcel$export($55035a4e31e02517$exports, "hasStandardBrowserEnv", function () { return $55035a4e31e02517$export$c0bcc9250309d66; });
$parcel$export($55035a4e31e02517$exports, "hasStandardBrowserWebWorkerEnv", function () { return $55035a4e31e02517$export$c81692cf5af97dac; });
$parcel$export($55035a4e31e02517$exports, "origin", function () { return $55035a4e31e02517$export$f710a83a91838a36; });
const $55035a4e31e02517$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $55035a4e31e02517$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $55035a4e31e02517$export$c0bcc9250309d66 = $55035a4e31e02517$export$c4996c4b7b93b0bf && (!$55035a4e31e02517$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($55035a4e31e02517$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $55035a4e31e02517$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $55035a4e31e02517$export$f710a83a91838a36 = $55035a4e31e02517$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $75bcbb7b8459ed60$export$2e2bcd8739ae039 = {
    ...$55035a4e31e02517$exports,
    ...(0, $f043f18f6751a04a$export$2e2bcd8739ae039)
};


'use strict';
function $83fbd1843f98b5c3$export$2e2bcd8739ae039(data, options) {
    return (0, $12550457841e8219$export$2e2bcd8739ae039)(data, new (0, $75bcbb7b8459ed60$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $75bcbb7b8459ed60$export$2e2bcd8739ae039).isNode && (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $ccfddbf197a36c6a$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $ccfddbf197a36c6a$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $ccfddbf197a36c6a$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $ccfddbf197a36c6a$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isFormData(formData) && (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($ccfddbf197a36c6a$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $ccfddbf197a36c6a$export$2e2bcd8739ae039 = $ccfddbf197a36c6a$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $f73cd5e375b7624b$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $f73cd5e375b7624b$var$defaults = {
    transitional: (0, $f3761d23331de665$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $ccfddbf197a36c6a$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isBuffer(data) || (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isStream(data) || (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isFile(data) || (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isBlob(data) || (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $83fbd1843f98b5c3$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $12550457841e8219$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $f73cd5e375b7624b$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $f73cd5e375b7624b$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isResponse(data) || (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).from(e, (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $75bcbb7b8459ed60$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $75bcbb7b8459ed60$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $f73cd5e375b7624b$var$defaults.headers[method] = {};
});
var $f73cd5e375b7624b$export$2e2bcd8739ae039 = $f73cd5e375b7624b$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $193106c7feb4405c$var$ignoreDuplicateOf = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $193106c7feb4405c$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $193106c7feb4405c$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $fab181d20943ed8e$var$$internals = Symbol('internals');
function $fab181d20943ed8e$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $fab181d20943ed8e$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isArray(value) ? value.map($fab181d20943ed8e$var$normalizeValue) : String(value);
}
function $fab181d20943ed8e$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $fab181d20943ed8e$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $fab181d20943ed8e$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $fab181d20943ed8e$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $fab181d20943ed8e$var$buildAccessors(obj, header) {
    const accessorName = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $fab181d20943ed8e$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $fab181d20943ed8e$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $fab181d20943ed8e$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$fab181d20943ed8e$var$isValidHeaderName(header)) setHeaders((0, $193106c7feb4405c$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $fab181d20943ed8e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $fab181d20943ed8e$var$parseTokens(value);
                if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $fab181d20943ed8e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $fab181d20943ed8e$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $fab181d20943ed8e$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $fab181d20943ed8e$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $fab181d20943ed8e$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $fab181d20943ed8e$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $fab181d20943ed8e$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $fab181d20943ed8e$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$fab181d20943ed8e$var$$internals] = this[$fab181d20943ed8e$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $fab181d20943ed8e$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $fab181d20943ed8e$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$fab181d20943ed8e$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).reduceDescriptors($fab181d20943ed8e$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).freezeMethods($fab181d20943ed8e$var$AxiosHeaders);
var $fab181d20943ed8e$export$2e2bcd8739ae039 = $fab181d20943ed8e$var$AxiosHeaders;


'use strict';
function $b079068132257f40$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $f73cd5e375b7624b$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $fab181d20943ed8e$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $4e70c984f5d36867$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $017033ffb6fdad8f$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).inherits($017033ffb6fdad8f$var$CanceledError, (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $017033ffb6fdad8f$export$2e2bcd8739ae039 = $017033ffb6fdad8f$var$CanceledError;







'use strict';
function $c048f9d56533304e$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $f36a7658bd5b95a8$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $1e4235cdeef90fa8$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $1e4235cdeef90fa8$export$2e2bcd8739ae039 = $1e4235cdeef90fa8$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $b1bac7ede3da8405$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $b1bac7ede3da8405$export$2e2bcd8739ae039 = $b1bac7ede3da8405$var$throttle;



const $c62848c20f57fb6c$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $1e4235cdeef90fa8$export$2e2bcd8739ae039)(50, 250);
    return (0, $b1bac7ede3da8405$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $c62848c20f57fb6c$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $c62848c20f57fb6c$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $551c1705ae32f466$export$2e2bcd8739ae039 = (0, $75bcbb7b8459ed60$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $75bcbb7b8459ed60$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $75bcbb7b8459ed60$export$2e2bcd8739ae039).origin), (0, $75bcbb7b8459ed60$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $75bcbb7b8459ed60$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $a2ffe0d7f15ee0dc$export$2e2bcd8739ae039 = (0, $75bcbb7b8459ed60$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $07047f5514552a50$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $3f18983db1855d74$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $bd76c06c6555b332$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $07047f5514552a50$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $3f18983db1855d74$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $472ad3b6945fce64$var$headersToObject = (thing)=>thing instanceof (0, $fab181d20943ed8e$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $472ad3b6945fce64$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isPlainObject(target) && (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($472ad3b6945fce64$var$headersToObject(a), $472ad3b6945fce64$var$headersToObject(b), prop, true)
    };
    (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $135103470fc4c4b3$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $472ad3b6945fce64$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $fab181d20943ed8e$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $0fa13816d630046e$export$2e2bcd8739ae039)((0, $bd76c06c6555b332$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $75bcbb7b8459ed60$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $75bcbb7b8459ed60$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $75bcbb7b8459ed60$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $551c1705ae32f466$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $a2ffe0d7f15ee0dc$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $15fb29d3ae239684$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $15fb29d3ae239684$export$2e2bcd8739ae039 = $15fb29d3ae239684$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $135103470fc4c4b3$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $fab181d20943ed8e$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $fab181d20943ed8e$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $c048f9d56533304e$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039)('Request aborted', (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039)('Network Error', (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $f3761d23331de665$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).ETIMEDOUT : (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $c62848c20f57fb6c$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $c62848c20f57fb6c$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $017033ffb6fdad8f$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $f36a7658bd5b95a8$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $75bcbb7b8459ed60$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $3b95ae8bf2a0345d$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039) ? err : new (0, $017033ffb6fdad8f$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $3b95ae8bf2a0345d$export$2e2bcd8739ae039 = $3b95ae8bf2a0345d$var$composeSignals;


const $0b8d6dc2e6593bf6$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $0b8d6dc2e6593bf6$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $0b8d6dc2e6593bf6$var$readStream(iterable))yield* $0b8d6dc2e6593bf6$export$71b051935044bd5d(chunk, chunkSize);
};
const $0b8d6dc2e6593bf6$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $0b8d6dc2e6593bf6$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $0b8d6dc2e6593bf6$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $947208a0a78274df$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $947208a0a78274df$var$isReadableStreamSupported = $947208a0a78274df$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $947208a0a78274df$var$encodeText = $947208a0a78274df$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $947208a0a78274df$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $947208a0a78274df$var$supportsRequestStream = $947208a0a78274df$var$isReadableStreamSupported && $947208a0a78274df$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $75bcbb7b8459ed60$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $947208a0a78274df$var$DEFAULT_CHUNK_SIZE = 65536;
const $947208a0a78274df$var$supportsResponseStream = $947208a0a78274df$var$isReadableStreamSupported && $947208a0a78274df$var$test(()=>(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $947208a0a78274df$var$resolvers = {
    stream: $947208a0a78274df$var$supportsResponseStream && ((res)=>res.body)
};
$947208a0a78274df$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$947208a0a78274df$var$resolvers[type] && ($947208a0a78274df$var$resolvers[type] = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $947208a0a78274df$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $75bcbb7b8459ed60$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isString(body)) return (await $947208a0a78274df$var$encodeText(body)).byteLength;
};
const $947208a0a78274df$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $947208a0a78274df$var$getBodyLength(body) : length;
};
var $947208a0a78274df$export$2e2bcd8739ae039 = $947208a0a78274df$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $135103470fc4c4b3$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $3b95ae8bf2a0345d$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $947208a0a78274df$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $947208a0a78274df$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $c62848c20f57fb6c$export$d9fadd12586c18d6)(requestContentLength, (0, $c62848c20f57fb6c$export$c1b28109d46c3592)((0, $c62848c20f57fb6c$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $0b8d6dc2e6593bf6$export$b0119225647bd83)(_request.body, $947208a0a78274df$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $947208a0a78274df$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($947208a0a78274df$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $c62848c20f57fb6c$export$d9fadd12586c18d6)(responseContentLength, (0, $c62848c20f57fb6c$export$c1b28109d46c3592)((0, $c62848c20f57fb6c$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $0b8d6dc2e6593bf6$export$b0119225647bd83)(response.body, $947208a0a78274df$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $947208a0a78274df$var$resolvers[(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).findKey($947208a0a78274df$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $c048f9d56533304e$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $fab181d20943ed8e$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039)('Network Error', (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $23ff6f14f9c5f60e$var$knownAdapters = {
    http: (0, $8abfd70dcc7991e7$export$2e2bcd8739ae039),
    xhr: (0, $15fb29d3ae239684$export$2e2bcd8739ae039),
    fetch: (0, $947208a0a78274df$export$2e2bcd8739ae039)
};
(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).forEach($23ff6f14f9c5f60e$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $23ff6f14f9c5f60e$var$renderReason = (reason)=>`- ${reason}`;
const $23ff6f14f9c5f60e$var$isResolvedHandle = (adapter)=>(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $23ff6f14f9c5f60e$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$23ff6f14f9c5f60e$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $23ff6f14f9c5f60e$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($23ff6f14f9c5f60e$var$renderReason).join('\n') : ' ' + $23ff6f14f9c5f60e$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $23ff6f14f9c5f60e$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $835241ad82c58ec5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $017033ffb6fdad8f$export$2e2bcd8739ae039)(null, config);
}
function $835241ad82c58ec5$export$2e2bcd8739ae039(config) {
    $835241ad82c58ec5$var$throwIfCancellationRequested(config);
    config.headers = (0, $fab181d20943ed8e$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $b079068132257f40$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $23ff6f14f9c5f60e$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $f73cd5e375b7624b$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $835241ad82c58ec5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $b079068132257f40$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $fab181d20943ed8e$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $4e70c984f5d36867$export$2e2bcd8739ae039)(reason)) {
            $835241ad82c58ec5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $b079068132257f40$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $fab181d20943ed8e$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $5d92d2aee6967ce4$export$a4ad2735b021c132 = "1.8.4";



'use strict';
const $cbd192d8ec56dbf7$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $cbd192d8ec56dbf7$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $cbd192d8ec56dbf7$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $cbd192d8ec56dbf7$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $5d92d2aee6967ce4$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$cbd192d8ec56dbf7$var$deprecatedWarnings[opt]) {
            $cbd192d8ec56dbf7$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$cbd192d8ec56dbf7$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $cbd192d8ec56dbf7$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039)('options must be an object', (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $cbd192d8ec56dbf7$export$2e2bcd8739ae039 = {
    assertOptions: $cbd192d8ec56dbf7$var$assertOptions,
    validators: $cbd192d8ec56dbf7$var$validators
};



'use strict';
const $e870243985b8da51$var$validators = (0, $cbd192d8ec56dbf7$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $e870243985b8da51$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $961693ee68106526$export$2e2bcd8739ae039)(),
            response: new (0, $961693ee68106526$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $472ad3b6945fce64$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $cbd192d8ec56dbf7$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $e870243985b8da51$var$validators.transitional($e870243985b8da51$var$validators.boolean),
            forcedJSONParsing: $e870243985b8da51$var$validators.transitional($e870243985b8da51$var$validators.boolean),
            clarifyTimeoutError: $e870243985b8da51$var$validators.transitional($e870243985b8da51$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $cbd192d8ec56dbf7$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $e870243985b8da51$var$validators.function,
                serialize: $e870243985b8da51$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $cbd192d8ec56dbf7$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $e870243985b8da51$var$validators.spelling('baseURL'),
            withXsrfToken: $e870243985b8da51$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $fab181d20943ed8e$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $835241ad82c58ec5$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $835241ad82c58ec5$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $472ad3b6945fce64$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $bd76c06c6555b332$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $0fa13816d630046e$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $e870243985b8da51$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $472ad3b6945fce64$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $472ad3b6945fce64$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $e870243985b8da51$var$Axios.prototype[method] = generateHTTPMethod();
    $e870243985b8da51$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $e870243985b8da51$export$2e2bcd8739ae039 = $e870243985b8da51$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $ced540a01b7d919c$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $017033ffb6fdad8f$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $ced540a01b7d919c$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $ced540a01b7d919c$export$2e2bcd8739ae039 = $ced540a01b7d919c$var$CancelToken;






'use strict';
function $316028e48ca8469d$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $26bc80e0aa691bba$export$2e2bcd8739ae039(payload) {
    return (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $dd00163f329b6e7d$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($dd00163f329b6e7d$var$HttpStatusCode).forEach(([key, value])=>{
    $dd00163f329b6e7d$var$HttpStatusCode[value] = key;
});
var $dd00163f329b6e7d$export$2e2bcd8739ae039 = $dd00163f329b6e7d$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $e03209fca4c3e620$var$createInstance(defaultConfig) {
    const context = new (0, $e870243985b8da51$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $381f9d98ed7dd6c7$export$2e2bcd8739ae039)((0, $e870243985b8da51$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).extend(instance, (0, $e870243985b8da51$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $e03209fca4c3e620$var$createInstance((0, $472ad3b6945fce64$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $e03209fca4c3e620$var$axios = $e03209fca4c3e620$var$createInstance((0, $f73cd5e375b7624b$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$e03209fca4c3e620$var$axios.Axios = (0, $e870243985b8da51$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$e03209fca4c3e620$var$axios.CanceledError = (0, $017033ffb6fdad8f$export$2e2bcd8739ae039);
$e03209fca4c3e620$var$axios.CancelToken = (0, $ced540a01b7d919c$export$2e2bcd8739ae039);
$e03209fca4c3e620$var$axios.isCancel = (0, $4e70c984f5d36867$export$2e2bcd8739ae039);
$e03209fca4c3e620$var$axios.VERSION = (0, $5d92d2aee6967ce4$export$a4ad2735b021c132);
$e03209fca4c3e620$var$axios.toFormData = (0, $12550457841e8219$export$2e2bcd8739ae039);
// Expose AxiosError class
$e03209fca4c3e620$var$axios.AxiosError = (0, $2e05ec49c9f7d58f$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$e03209fca4c3e620$var$axios.Cancel = $e03209fca4c3e620$var$axios.CanceledError;
// Expose all/spread
$e03209fca4c3e620$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$e03209fca4c3e620$var$axios.spread = (0, $316028e48ca8469d$export$2e2bcd8739ae039);
// Expose isAxiosError
$e03209fca4c3e620$var$axios.isAxiosError = (0, $26bc80e0aa691bba$export$2e2bcd8739ae039);
// Expose mergeConfig
$e03209fca4c3e620$var$axios.mergeConfig = (0, $472ad3b6945fce64$export$2e2bcd8739ae039);
$e03209fca4c3e620$var$axios.AxiosHeaders = (0, $fab181d20943ed8e$export$2e2bcd8739ae039);
$e03209fca4c3e620$var$axios.formToJSON = (thing)=>(0, $ccfddbf197a36c6a$export$2e2bcd8739ae039)((0, $7dba0ee10f9f7ad9$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$e03209fca4c3e620$var$axios.getAdapter = (0, $23ff6f14f9c5f60e$export$2e2bcd8739ae039).getAdapter;
$e03209fca4c3e620$var$axios.HttpStatusCode = (0, $dd00163f329b6e7d$export$2e2bcd8739ae039);
$e03209fca4c3e620$var$axios.default = $e03209fca4c3e620$var$axios;
var // this module should only have a default export
$e03209fca4c3e620$export$2e2bcd8739ae039 = $e03209fca4c3e620$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $211a2c8778873708$export$1c00760e9e5a4e95, AxiosError: $211a2c8778873708$export$c1fbed17c2f6a328, CanceledError: $211a2c8778873708$export$1ab0c6b20d94fa14, isCancel: $211a2c8778873708$export$3b22524397b493c6, CancelToken: $211a2c8778873708$export$fd08e3cb425f0d61, VERSION: $211a2c8778873708$export$a4ad2735b021c132, all: $211a2c8778873708$export$84bf76cd7afc7469, Cancel: $211a2c8778873708$export$848c9b7ead0df967, isAxiosError: $211a2c8778873708$export$fbafdbe06a5b5a9a, spread: $211a2c8778873708$export$3ae0fd4797ed47c8, toFormData: $211a2c8778873708$export$10ae0d317ea97f8b, AxiosHeaders: $211a2c8778873708$export$4e7d6ff0f3e6520, HttpStatusCode: $211a2c8778873708$export$a972f69c851492b3, formToJSON: $211a2c8778873708$export$86d7c59254d6a2c9, getAdapter: $211a2c8778873708$export$17ddc20a97d669e2, mergeConfig: $211a2c8778873708$export$7ec1ebcfa9d8bd6a } = (0, $e03209fca4c3e620$export$2e2bcd8739ae039);


class $e89863c8aef35a59$var$AllocationService {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($39363681bdb5f057$exports)))(this, "BASE_URL", "{PLACEHOLDER_BASE_URL}");
    }
    async fetchAllocation(win, aggregate, options) {
        if (this.BASE_URL.includes("PLACEHOLDER_BASE_URL")) this.BASE_URL = `http://localhost:9090/model`;
        const { accumulate: accumulate, filters: filters } = options;
        const params = {
            window: win,
            aggregate: aggregate,
            includeIdle: true,
            step: "1d"
        };
        if (typeof accumulate === "boolean") params.accumulate = accumulate;
        const result = await (0, $e03209fca4c3e620$export$2e2bcd8739ae039).get(`${this.BASE_URL}/allocation/compute`, {
            params: params
        });
        return result.data;
    }
}
var $e89863c8aef35a59$export$2e2bcd8739ae039 = new $e89863c8aef35a59$var$AllocationService();



const $74b9db456d6885ed$export$a01df35ce0858603 = [
    "AED",
    "AFN",
    "ALL",
    "AMD",
    "ANG",
    "AOA",
    "ARS",
    "AUD",
    "AWG",
    "AZN",
    "BAM",
    "BBD",
    "BDT",
    "BGN",
    "BHD",
    "BIF",
    "BMD",
    "BND",
    "BOB",
    "BOV",
    "BRL",
    "BSD",
    "BTN",
    "BWP",
    "BYR",
    "BZD",
    "CAD",
    "CDF",
    "CHE",
    "CHF",
    "CHW",
    "CLF",
    "CLP",
    "CNY",
    "COP",
    "COU",
    "CRC",
    "CUC",
    "CUP",
    "CVE",
    "CZK",
    "DJF",
    "DKK",
    "DOP",
    "DZD",
    "EGP",
    "ERN",
    "ETB",
    "EUR",
    "FJD",
    "FKP",
    "GBP",
    "GEL",
    "GHS",
    "GIP",
    "GMD",
    "GNF",
    "GTQ",
    "GYD",
    "HKD",
    "HNL",
    "HRK",
    "HTG",
    "HUF",
    "IDR",
    "ILS",
    "INR",
    "IQD",
    "IRR",
    "ISK",
    "JMD",
    "JOD",
    "JPY",
    "KES",
    "KGS",
    "KHR",
    "KMF",
    "KPW",
    "KRW",
    "KWD",
    "KYD",
    "KZT",
    "LAK",
    "LBP",
    "LKR",
    "LRD",
    "LSL",
    "LTL",
    "LVL",
    "LYD",
    "MAD",
    "MDL",
    "MGA",
    "MKD",
    "MMK",
    "MNT",
    "MOP",
    "MRO",
    "MUR",
    "MVR",
    "MWK",
    "MXN",
    "MXV",
    "MYR",
    "MZN",
    "NAD",
    "NGN",
    "NIO",
    "NOK",
    "NPR",
    "NZD",
    "OMR",
    "PAB",
    "PEN",
    "PGK",
    "PHP",
    "PKR",
    "PLN",
    "PYG",
    "QAR",
    "RON",
    "RSD",
    "RUB",
    "RWF",
    "SAR",
    "SBD",
    "SCR",
    "SDG",
    "SEK",
    "SGD",
    "SHP",
    "SLL",
    "SOS",
    "SRD",
    "SSP",
    "STD",
    "SYP",
    "SZL",
    "THB",
    "TJS",
    "TMT",
    "TND",
    "TOP",
    "TRY",
    "TTD",
    "TWD",
    "TZS",
    "UAH",
    "UGX",
    "USD",
    "USN",
    "USS",
    "UYI",
    "UYU",
    "UZS",
    "VEF",
    "VND",
    "VUV",
    "WST",
    "XAF",
    "XAG",
    "XAU",
    "XBA",
    "XBB",
    "XBC",
    "XBD",
    "XCD",
    "XDR",
    "XFU",
    "XOF",
    "XPD",
    "XPF",
    "XPT",
    "XTS",
    "XXX",
    "YER",
    "ZAR",
    "ZMW"
];


const $139bab258972d88b$var$windowOptions = [
    {
        name: "Today",
        value: "today"
    },
    {
        name: "Yesterday",
        value: "yesterday"
    },
    {
        name: "Last 24h",
        value: "24h"
    },
    {
        name: "Last 48h",
        value: "48h"
    },
    {
        name: "Week-to-date",
        value: "week"
    },
    {
        name: "Last week",
        value: "lastweek"
    },
    {
        name: "Last 7 days",
        value: "7d"
    },
    {
        name: "Last 14 days",
        value: "14d"
    }
];
const $139bab258972d88b$var$aggregationOptions = [
    {
        name: "Cluster",
        value: "cluster"
    },
    {
        name: "Node",
        value: "node"
    },
    {
        name: "Namespace",
        value: "namespace"
    },
    {
        name: "Controller Kind",
        value: "controllerKind"
    },
    {
        name: "Controller",
        value: "controller"
    },
    {
        name: "DaemonSet",
        value: "daemonset"
    },
    {
        name: "Deployment",
        value: "deployment"
    },
    {
        name: "Job",
        value: "job"
    },
    {
        name: "Service",
        value: "service"
    },
    {
        name: "StatefulSet",
        value: "statefulset"
    },
    {
        name: "Pod",
        value: "pod"
    },
    {
        name: "Container",
        value: "container"
    }
];
const $139bab258972d88b$var$accumulateOptions = [
    {
        name: "Entire window",
        value: true
    },
    {
        name: "Daily",
        value: false
    }
];
const $139bab258972d88b$var$useStyles = (0, $hQJVM.default)({
    reportHeader: {
        display: "flex",
        flexFlow: "row",
        padding: 24
    },
    titles: {
        flexGrow: 1
    }
});
// generateTitle generates a string title from a report object
function $139bab258972d88b$var$generateTitle({ window: window, aggregateBy: aggregateBy, accumulate: accumulate }) {
    let windowName = (0, $6IRuR.get)((0, $6IRuR.find)($139bab258972d88b$var$windowOptions, {
        value: window
    }), "name", "");
    if (windowName === "") {
        if ((0, $4ab43b5ac1a299dc$export$8764230b0d460478)(window)) windowName = (0, $4ab43b5ac1a299dc$export$2e6bf8a055fccba2)(window);
        else console.warn(`unknown window: ${window}`);
    }
    let aggregationName = (0, $6IRuR.get)((0, $6IRuR.find)($139bab258972d88b$var$aggregationOptions, {
        value: aggregateBy
    }), "name", "").toLowerCase();
    if (aggregationName === "") console.warn(`unknown aggregation: ${aggregateBy}`);
    let str = `${windowName} by ${aggregationName}`;
    if (!accumulate) str = `${str} daily`;
    return str;
}
const $139bab258972d88b$var$ReportsPage = ()=>{
    const classes = $139bab258972d88b$var$useStyles();
    // Allocation data state
    const [allocationData, setAllocationData] = (0, $gIfym.useState)([]);
    const [cumulativeData, setCumulativeData] = (0, $gIfym.useState)({});
    const [totalData, setTotalData] = (0, $gIfym.useState)({});
    // When allocation data changes, create a cumulative version of it
    (0, $gIfym.useEffect)(()=>{
        const cumulative = (0, $4ab43b5ac1a299dc$export$ec4dc9faeed50c1d)(allocationData, aggregateBy);
        setCumulativeData((0, $6IRuR.toArray)(cumulative));
        setTotalData((0, $4ab43b5ac1a299dc$export$9a53f1556c71494a)(cumulative));
    }, [
        allocationData
    ]);
    // Form state, which controls form elements, but not the report itself. On
    // certain actions, the form state may flow into the report state.
    const [window, setWindow] = (0, $gIfym.useState)($139bab258972d88b$var$windowOptions[0].value);
    const [aggregateBy, setAggregateBy] = (0, $gIfym.useState)($139bab258972d88b$var$aggregationOptions[0].value);
    const [accumulate, setAccumulate] = (0, $gIfym.useState)($139bab258972d88b$var$accumulateOptions[0].value);
    const [currency, setCurrency] = (0, $gIfym.useState)("USD");
    // Report state, including current report and saved options
    const [title, setTitle] = (0, $gIfym.useState)("Last 7 days by namespace daily");
    // When parameters changes, fetch data. This should be the
    // only mechanism used to fetch data. Also generate a sensible title from the paramters.
    (0, $gIfym.useEffect)(()=>{
        setFetch(true);
        setTitle($139bab258972d88b$var$generateTitle({
            window: window,
            aggregateBy: aggregateBy,
            accumulate: accumulate
        }));
    }, [
        window,
        aggregateBy,
        accumulate
    ]);
    // page and settings state
    const [init, setInit] = (0, $gIfym.useState)(false);
    const [fetch, setFetch] = (0, $gIfym.useState)(false);
    const [loading, setLoading] = (0, $gIfym.useState)(true);
    const [errors, setErrors] = (0, $gIfym.useState)([]);
    // Initialize once, then fetch report each time setFetch(true) is called
    (0, $gIfym.useEffect)(()=>{
        if (!init) initialize();
        if (init || fetch) fetchData();
    }, [
        init,
        fetch
    ]);
    // parse any context information from the URL
    const routerLocation = (0, $b585d439d92e032d$export$45d76561a5302f2b)();
    const searchParams = new URLSearchParams(routerLocation.search);
    const routerHistory = (0, $b585d439d92e032d$export$3420e1dc2c4a518c)();
    (0, $gIfym.useEffect)(()=>{
        setWindow(searchParams.get("window") || "7d");
        setAggregateBy(searchParams.get("agg") || "namespace");
        setAccumulate(searchParams.get("acc") === "true" || false);
        setCurrency(searchParams.get("currency") || "USD");
    }, [
        routerLocation
    ]);
    async function initialize() {
        setInit(true);
    }
    async function fetchData() {
        setLoading(true);
        setErrors([]);
        try {
            const resp = await (0, $e89863c8aef35a59$export$2e2bcd8739ae039).fetchAllocation(window, aggregateBy, {
                accumulate: accumulate
            });
            if (resp.data && resp.data.length > 0) {
                const allocationRange = resp.data;
                for(const i in allocationRange)// update cluster aggregations to use clusterName/clusterId names
                allocationRange[i] = (0, $6IRuR.sortBy)(allocationRange[i], (a)=>a.totalCost);
                setAllocationData(allocationRange);
            } else {
                if (resp.message && resp.message.indexOf("boundary error") >= 0) {
                    let match = resp.message.match(/(ETL is \d+\.\d+% complete)/);
                    let secondary = "Try again after ETL build is complete";
                    if (match.length > 0) secondary = `${match[1]}. ${secondary}`;
                    setErrors([
                        {
                            primary: "Data unavailable while ETL is building",
                            secondary: secondary
                        }
                    ]);
                }
                setAllocationData([]);
            }
        } catch (err) {
            if (err.message.indexOf("404") === 0) setErrors([
                {
                    primary: "Failed to load report data",
                    secondary: "Please update OpenCost to the latest version, then open an Issue on GitHub if problems persist."
                }
            ]);
            else {
                let secondary = "Please open an Issue on GitHub if problems persist.";
                if (err.message.length > 0) secondary = err.message;
                setErrors([
                    {
                        primary: "Failed to load report data",
                        secondary: secondary
                    }
                ]);
            }
            setAllocationData([]);
        }
        setLoading(false);
        setFetch(false);
    }
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $8530181efc7ffbd0$export$2e2bcd8739ae039), {
        active: "reports.html",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d5abac16fc0baa87$export$2e2bcd8739ae039), {
                headerTitle: "Cost Allocation",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $2ae0a89ca37bbdde$export$2e2bcd8739ae039), {
                    "aria-label": "refresh",
                    onClick: ()=>setFetch(true),
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($82db5f4ea5a284fb$exports))), {})
                })
            }),
            !loading && errors.length > 0 && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                style: {
                    marginBottom: 20
                },
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $08b36a1d9bca6415$export$2e2bcd8739ae039), {
                    warnings: errors
                })
            }),
            init && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $ee13f6b8f50f92d0$export$2e2bcd8739ae039), {
                id: "report",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: classes.reportHeader,
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                                className: classes.titles,
                                children: [
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
                                        variant: "h5",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $1dc8f044258e228d$export$2e2bcd8739ae039), {
                                        report: {
                                            window: window,
                                            aggregateBy: aggregateBy,
                                            accumulate: accumulate
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $0aadca63ce196fea$export$2e2bcd8739ae039), {
                                windowOptions: $139bab258972d88b$var$windowOptions,
                                window: window,
                                setWindow: (win)=>{
                                    searchParams.set("window", win);
                                    routerHistory.push({
                                        search: `?${searchParams.toString()}`
                                    });
                                },
                                aggregationOptions: $139bab258972d88b$var$aggregationOptions,
                                aggregateBy: aggregateBy,
                                setAggregateBy: (agg)=>{
                                    searchParams.set("agg", agg);
                                    routerHistory.push({
                                        search: `?${searchParams.toString()}`
                                    });
                                },
                                accumulateOptions: $139bab258972d88b$var$accumulateOptions,
                                accumulate: accumulate,
                                setAccumulate: (acc)=>{
                                    searchParams.set("acc", acc);
                                    routerHistory.push({
                                        search: `?${searchParams.toString()}`
                                    });
                                },
                                title: title,
                                cumulativeData: cumulativeData,
                                currency: currency,
                                currencyOptions: (0, $74b9db456d6885ed$export$a01df35ce0858603),
                                setCurrency: (curr)=>{
                                    searchParams.set("currency", curr);
                                    routerHistory.push({
                                        search: `?${searchParams.toString()}`
                                    });
                                }
                            })
                        ]
                    }),
                    loading && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                            style: {
                                paddingTop: 100,
                                paddingBottom: 100
                            },
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ff3a7ab0b65b1eb6$export$2e2bcd8739ae039), {})
                        })
                    }),
                    !loading && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c2f4f7c799313e3f$export$2e2bcd8739ae039), {
                        allocationData: allocationData,
                        cumulativeData: cumulativeData,
                        totalData: totalData,
                        currency: currency
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $538e5067ae27ebfc$export$2e2bcd8739ae039), {})
        ]
    });
};
var $139bab258972d88b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).memo($139bab258972d88b$var$ReportsPage);




var $gIfym = parcelRequire("gIfym");






var $hQJVM = parcelRequire("hQJVM");



var $6IRuR = parcelRequire("6IRuR");




var $hQJVM = parcelRequire("hQJVM");





var $gIfym = parcelRequire("gIfym");

const $80752a70656e793c$var$useStyles = (0, $hQJVM.default)({
    wrapper: {
        display: "inline-flex"
    },
    formControl: {
        margin: 8,
        minWidth: 120
    }
});
function $80752a70656e793c$var$EditCloudCostControls({ windowOptions: windowOptions, window: window, setWindow: setWindow, aggregationOptions: aggregationOptions, aggregateBy: aggregateBy, setAggregateBy: setAggregateBy, costMetricOptions: costMetricOptions, costMetric: costMetric, setCostMetric: setCostMetric, currencyOptions: currencyOptions, currency: currency, setCurrency: setCurrency }) {
    const classes = $80752a70656e793c$var$useStyles();
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: classes.wrapper,
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bedcb082e4938fab$export$2e2bcd8739ae039), {
                windowOptions: windowOptions,
                window: window,
                setWindow: setWindow
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $1f3c3d6fcb879aaf$export$2e2bcd8739ae039), {
                className: classes.formControl,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $83d8148cf52783d5$export$2e2bcd8739ae039), {
                        id: "aggregation-select-label",
                        children: "Breakdown"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ea71a0b004fd8af3$export$2e2bcd8739ae039), {
                        id: "aggregation-select",
                        value: aggregateBy,
                        onChange: (e)=>{
                            setAggregateBy(e.target.value);
                        },
                        children: aggregationOptions.map((opt)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c027d6b11891bde0$export$2e2bcd8739ae039), {
                                value: opt.value,
                                children: opt.name
                            }, opt.value))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $1f3c3d6fcb879aaf$export$2e2bcd8739ae039), {
                className: classes.formControl,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $83d8148cf52783d5$export$2e2bcd8739ae039), {
                        id: "costMetric-label",
                        children: "Cost Metric"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ea71a0b004fd8af3$export$2e2bcd8739ae039), {
                        id: "costMetric",
                        value: costMetric,
                        onChange: (e)=>setCostMetric(e.target.value),
                        children: costMetricOptions.map((opt)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c027d6b11891bde0$export$2e2bcd8739ae039), {
                                value: opt.value,
                                children: opt.name
                            }, opt.value))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $1f3c3d6fcb879aaf$export$2e2bcd8739ae039), {
                className: classes.formControl,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $83d8148cf52783d5$export$2e2bcd8739ae039), {
                        id: "currency-label",
                        children: "Currency"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ea71a0b004fd8af3$export$2e2bcd8739ae039), {
                        id: "currency",
                        value: currency,
                        onChange: (e)=>setCurrency(e.target.value),
                        children: currencyOptions?.map((currency)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c027d6b11891bde0$export$2e2bcd8739ae039), {
                                value: currency,
                                children: currency
                            }, currency))
                    })
                ]
            })
        ]
    });
}
var $80752a70656e793c$export$2e2bcd8739ae039 = /*#__PURE__*/ $gIfym.memo($80752a70656e793c$var$EditCloudCostControls);







class $f86010c682ad973b$var$CloudCostTopService {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($39363681bdb5f057$exports)))(this, "BASE_URL", "{PLACEHOLDER_BASE_URL}");
    }
    async fetchCloudCostData(window, aggregate, costMetric, filters) {
        if (this.BASE_URL.includes("PLACEHOLDER_BASE_URL")) this.BASE_URL = `http://localhost:9090/model`;
        const params = {
            window: window,
            aggregate: aggregate,
            costMetric: costMetric,
            filter: (0, $4ab43b5ac1a299dc$export$2f387f690230eab4)(filters ?? []),
            limit: 1000
        };
        if (aggregate.includes("item")) {
            const resp = await (0, $e03209fca4c3e620$export$2e2bcd8739ae039).get(`${this.BASE_URL}/cloudCost?window=${window}&costMetric=${costMetric}&filter=${(0, $4ab43b5ac1a299dc$export$2f387f690230eab4)(filters)}`);
            const result_2 = await resp.data;
            return (0, $4ab43b5ac1a299dc$export$a51d156d37e37a34)(result_2, costMetric);
        }
        const tableView = await (0, $e03209fca4c3e620$export$2e2bcd8739ae039).get(`${this.BASE_URL}/cloudCost/view/table`, {
            params: params
        });
        const totalsView = await (0, $e03209fca4c3e620$export$2e2bcd8739ae039).get(`${this.BASE_URL}/cloudCost/view/totals`, {
            params: params
        });
        const graphView = await (0, $e03209fca4c3e620$export$2e2bcd8739ae039).get(`${this.BASE_URL}/cloudCost/view/graph`, {
            params: params
        });
        const status = await (0, $e03209fca4c3e620$export$2e2bcd8739ae039).get(`${this.BASE_URL}/cloudCost/status`);
        return {
            tableRows: tableView.data.data,
            graphData: graphView.data.data,
            tableTotal: totalsView.data.data.combined,
            cloudCostStatus: status.data.data
        };
    }
}
var $f86010c682ad973b$export$2e2bcd8739ae039 = new $f86010c682ad973b$var$CloudCostTopService();






var $gIfym = parcelRequire("gIfym");

var $6IRuR = parcelRequire("6IRuR");

var $hQJVM = parcelRequire("hQJVM");




var $gIfym = parcelRequire("gIfym");


parcelRequire("gIfym");

var $hQJVM = parcelRequire("hQJVM");



const $1f4137b42a46ad50$var$RangeChart = ({ data: data, currency: currency, height: height })=>{
    const useStyles = (0, $hQJVM.default)({
        tooltip: {
            borderRadius: 2,
            background: "rgba(255, 255, 255, 0.95)",
            padding: 12
        },
        tooltipLineItem: {
            fontSize: "1rem",
            margin: 0,
            marginBottom: 4,
            padding: 0
        }
    });
    const accents = [
        ...(0, $e95a10c0d7b6a200$export$9ad721cf3b3debe0),
        ...(0, $e95a10c0d7b6a200$export$88f5aeecbc5784c1),
        ...(0, $e95a10c0d7b6a200$export$bcdff0aad5ea3623)
    ];
    const _IDLE_ = "__idle__";
    const _OTHER_ = "others";
    const getItemCost = (item)=>{
        return item.value;
    };
    function toBar({ end: end, graph: graph, start: start }) {
        const points = graph.map((item)=>({
                ...item,
                window: {
                    end: end,
                    start: start
                }
            }));
        const dateFormatter = Intl.DateTimeFormat(navigator.language, {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            timeZone: "UTC"
        });
        const timeFormatter = Intl.DateTimeFormat(navigator.language, {
            hour: "numeric",
            minute: "numeric",
            timeZone: "UTC"
        });
        const s = new Date(start);
        const e = new Date(end);
        const interval = (e.valueOf() - s.valueOf()) / 1000 / 60 / 60;
        const bar = {
            end: new Date(end),
            key: interval >= 24 ? dateFormatter.format(s) : timeFormatter.format(s),
            items: {},
            start: new Date(start)
        };
        points.forEach((item)=>{
            const windowStart = new Date(item.window.start);
            const windowEnd = new Date(item.window.end);
            const windowHours = (windowEnd.valueOf() - windowStart.valueOf()) / 1000 / 60 / 60;
            if (windowHours >= 24) bar.key = dateFormatter.format(bar.start);
            else bar.key = timeFormatter.format(bar.start);
            bar.items[item.name] = getItemCost(item);
        });
        return bar;
    }
    const getDataForCloudDay = (dayData)=>{
        const { end: end, start: start } = dayData;
        const copy = [
            ...dayData.items
        ];
        // find items for idle and other
        const idleIndex = copy.findIndex((item)=>item.name === _IDLE_);
        let idle = undefined;
        if (idleIndex > -1) {
            idle = copy[idleIndex];
            copy.splice(idleIndex, 1);
        }
        const otherIndex = copy.findIndex((i)=>i.name === _OTHER_ || i.name === "other");
        let other = undefined;
        if (otherIndex > -1) {
            other = {
                ...copy[otherIndex],
                name: "other"
            };
            copy.splice(otherIndex, 1);
        }
        // sort and remove any items < top 8
        const sortedItems = copy.slice().sort((a, b)=>{
            return a.value > b.value ? -1 : 1;
        });
        const top8 = sortedItems.slice(0, 8);
        // get items that didn't make the cut and shove into other
        const lefovers = sortedItems.slice(8);
        if (lefovers.length > 0) {
            const othersTotal = lefovers.reduce((a, b)=>a.value + b.value);
            if (other) other.value += othersTotal;
            else if (othersTotal) other = {
                name: "other",
                value: othersTotal
            };
        }
        // add in idle and other
        if (idle) top8.unshift(idle);
        if (other) top8.unshift(other);
        return {
            end: end,
            start: start,
            graph: top8
        };
    };
    const getDataForGraph = (dataPoints)=>{
        // for each day, we want top 8 + Idle and Other
        const orderedDataPoints = dataPoints.map(getDataForCloudDay);
        const bars = orderedDataPoints.map(toBar);
        const keyToFill = {};
        // we want to keep track of the order of fill assignment
        const assignmentOrder = [];
        let p = 0;
        orderedDataPoints.forEach(({ graph: graph, start: start, end: end })=>{
            graph.forEach(({ name: name })=>{
                const key = name;
                if (keyToFill[key] === undefined) {
                    assignmentOrder.push(key);
                    if (key === _IDLE_) keyToFill[key] = (0, $e95a10c0d7b6a200$export$bcdff0aad5ea3623);
                    else if (key === _OTHER_ || key === "other") keyToFill[key] = (0, $e95a10c0d7b6a200$export$88f5aeecbc5784c1);
                    else {
                        // non-idle/other allocations get the next available color
                        keyToFill[key] = accents[p];
                        p = (p + 1) % accents.length;
                    }
                }
            });
        });
        // list of dataKeys and fillColors in order of importance (price w/ 'others' last)
        const labels = assignmentOrder.map((dataKey)=>({
                dataKey: dataKey,
                fill: keyToFill[dataKey]
            }));
        return {
            bars: bars,
            labels: labels,
            keyToFill: keyToFill
        };
    };
    const { bars: barData, labels: barLabels, keyToFill: keyToFill } = getDataForGraph(data);
    const classes = useStyles();
    const CustomTooltip = (params)=>{
        const { active: active, payload: payload } = params;
        if (!payload || payload.length == 0) return null;
        const total = payload.reduce((sum, item)=>sum + item.value, 0.0);
        if (active) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: classes.tooltip,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                    className: classes.tooltipLineItem,
                    style: {
                        color: "#000000"
                    },
                    children: `Total: ${(0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(total, currency)}`
                }),
                payload.slice().map((item, i)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        style: {
                            display: "grid",
                            gridTemplateColumns: "20px 1fr",
                            gap: ".5em",
                            margin: ".25em"
                        },
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                    style: {
                                        backgroundColor: keyToFill[item.payload.items[i][0]],
                                        width: 18,
                                        height: 18
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                                    className: classes.tooltipLineItem,
                                    children: `${item.payload.items[i][0]}: ${(0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(item.value, currency)}`
                                })
                            })
                        ]
                    }, item.name)).reverse()
            ]
        });
        return null;
    };
    const orderedBars = barData.map((bar)=>{
        return {
            ...bar,
            items: Object.entries(bar.items).sort((a, b)=>{
                if (a[0] === "other") return -1;
                if (b[0] === "other") return 1;
                return a[1] > b[1] ? -1 : 1;
            })
        };
    });
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d7b42fa8a2c2a4be$export$e60a4704009a0009), {
        height: height,
        width: "100%",
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $e5f9bccf45a8faa3$export$94aefc399ef206a9), {
            data: orderedBars,
            margin: {
                top: 30,
                right: 35,
                left: 30,
                bottom: 45
            },
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $1e8a496f1b0dc2f3$export$6440e27b9f186856), {
                    strokeDasharray: "3 3",
                    vertical: false
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $4599bbc635684a39$export$ea77231de273b52d), {
                    dataKey: "key"
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $dc3299e5adf43c53$export$f96c4024c52de8f4), {
                    tickFormatter: (val)=>(0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(val, currency, 2, true)
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $af95134c6736175e$export$28c660c63b792dea), {
                    content: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)(CustomTooltip, {}),
                    wrapperStyle: {
                        zIndex: 1000
                    }
                }),
                new Array(10).fill(0).map((item, idx)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $7f0f02843a7c30b4$export$bbc6c6369b38e3d1), {
                        dataKey: (entry)=>entry.items[idx] ? entry.items[idx][1] : null,
                        stackId: "x",
                        children: orderedBars.map((bar)=>bar.items[idx] ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b7ce6dc70cc786c8$export$f6f0c3fe4ec306ea), {
                                fill: keyToFill[bar.items[idx][0]]
                            }) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b7ce6dc70cc786c8$export$f6f0c3fe4ec306ea), {}))
                    }))
            ]
        })
    });
};
var $1f4137b42a46ad50$export$2e2bcd8739ae039 = $1f4137b42a46ad50$var$RangeChart;


const $5281c05d1db10778$var$CloudCostChart = ({ graphData: graphData, currency: currency, n: n, height: height })=>{
    if (graphData.length === 0) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
        variant: "body2",
        children: "No data"
    });
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $1f4137b42a46ad50$export$2e2bcd8739ae039), {
        data: graphData,
        currency: currency,
        height: height
    });
};
var $5281c05d1db10778$export$2e2bcd8739ae039 = /*#__PURE__*/ $gIfym.memo($5281c05d1db10778$var$CloudCostChart);



parcelRequire("gIfym");



const $eb94643e876bab03$var$displayCurrencyAsLessThanPenny = (amount, currency)=>amount > 0 && amount < 0.01 ? `<${(0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(0.01, currency)}` : (0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(amount, currency);
const $eb94643e876bab03$export$8d7ed539ab0f1448 = ({ cost: cost, costSuffix: costSuffix, currency: currency, drilldown: drilldown, kubernetesPercent: kubernetesPercent, name: name, row: row, sampleData: sampleData })=>{
    function calculatePercent() {
        const totalPercent = (kubernetesPercent * 100).toFixed();
        return `${totalPercent}%`;
    }
    const whichPercent = sampleData ? `${(kubernetesPercent * 100).toFixed(1)}%` : calculatePercent();
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
        onClick: ()=>drilldown(row),
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                align: "left",
                style: {
                    cursor: "pointer",
                    color: "#346ef2",
                    padding: "1rem"
                },
                children: name
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                align: "right",
                children: whichPercent
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                align: "right",
                style: {
                    paddingRight: "2em"
                },
                children: `${$eb94643e876bab03$var$displayCurrencyAsLessThanPenny(cost, currency)}${costSuffix}`
            })
        ]
    });
};


const $b692744641c7b083$var$CloudCost = ({ cumulativeData: cumulativeData = [], totalData: totalsRow = {}, graphData: graphData = [], currency: currency = "USD", drilldown: drilldown, sampleData: sampleData = false })=>{
    const useStyles = (0, $hQJVM.default)({
        noResults: {
            padding: 24
        }
    });
    const classes = useStyles();
    function descendingComparator(a, b, orderBy) {
        if ((0, $6IRuR.get)(b, orderBy) < (0, $6IRuR.get)(a, orderBy)) return -1;
        if ((0, $6IRuR.get)(b, orderBy) > (0, $6IRuR.get)(a, orderBy)) return 1;
        return 0;
    }
    function getComparator(order, orderBy) {
        return order === "desc" ? (a, b)=>descendingComparator(a, b, orderBy) : (a, b)=>-descendingComparator(a, b, orderBy);
    }
    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index)=>[
                el,
                index
            ]);
        stabilizedThis.sort((a, b)=>{
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el)=>el[0]);
    }
    const headCells = [
        {
            id: "name",
            numeric: false,
            label: "Name",
            width: "auto"
        },
        {
            id: "kubernetesPercent",
            numeric: true,
            label: "K8s Utilization",
            width: 160
        },
        sampleData ? {
            id: "cost",
            numeric: true,
            label: "Sum of Sample Data",
            width: 200
        } : {
            id: "cost",
            numeric: true,
            label: "Total cost",
            width: 155
        }
    ];
    const [order, setOrder] = $gIfym.useState("desc");
    const [orderBy, setOrderBy] = $gIfym.useState("totalCost");
    const [page, setPage] = $gIfym.useState(0);
    const [rowsPerPage, setRowsPerPage] = $gIfym.useState(25);
    const numData = cumulativeData?.length;
    const lastPage = Math.floor(numData / rowsPerPage);
    const handleChangePage = (event, newPage)=>setPage(newPage);
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const orderedRows = stableSort(cumulativeData, getComparator(order, orderBy));
    const pageRows = orderedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    $gIfym.useEffect(()=>{
        setPage(0);
    }, [
        numData
    ]);
    if (cumulativeData.length === 0) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
        variant: "body2",
        className: classes.noResults,
        children: "No results"
    });
    function dataToCloudCostRow(row) {
        const suffix = {
            hourly: "/hr",
            monthly: "/mo",
            daily: "/day"
        }["cumulative"] || "";
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $eb94643e876bab03$export$8d7ed539ab0f1448), {
            costSuffix: suffix,
            cost: row.cost,
            drilldown: drilldown,
            kubernetesPercent: row.kubernetesPercent,
            name: sampleData && row.labelName ? row.labelName ?? "" : row.name ?? "",
            row: row,
            sampleData: sampleData
        }, row.name);
    }
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        id: "cloud-cost",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                id: "cloud-graph-",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5281c05d1db10778$export$2e2bcd8739ae039), {
                    currency: currency,
                    graphData: graphData,
                    height: 300,
                    n: 10
                })
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                id: "cloud-cost-table",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $6d7bd70307fdcf46$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $9baaa18523ae0079$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8877b048d1d8501c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                        children: headCells.map((cell)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                colSpan: cell.colspan,
                                                align: cell.numeric ? "right" : "left",
                                                sortDirection: orderBy === cell.id ? order : false,
                                                style: {
                                                    width: cell.width
                                                },
                                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $99436b9fec0b22ea$export$2e2bcd8739ae039), {
                                                    active: orderBy === cell.id,
                                                    direction: orderBy === cell.id ? order : "asc",
                                                    onClick: ()=>{
                                                        const isDesc = orderBy === cell.id && order === "desc";
                                                        setOrder(isDesc ? "asc" : "desc");
                                                        setOrderBy(cell.id);
                                                    },
                                                    children: cell.label
                                                })
                                            }, cell.id))
                                    })
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $b26ae0b21e46ca86$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                    align: "left",
                                                    style: {
                                                        fontWeight: 500
                                                    },
                                                    children: totalsRow?.name || "Totals"
                                                }),
                                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                    align: "right",
                                                    style: {
                                                        fontWeight: 500
                                                    },
                                                    children: [
                                                        Math.round(totalsRow?.kubernetesPercent * 100),
                                                        "%"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                                    align: "right",
                                                    style: {
                                                        fontWeight: 500,
                                                        paddingRight: "2em"
                                                    },
                                                    children: (0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(totalsRow?.cost || 0, currency)
                                                })
                                            ]
                                        }),
                                        pageRows.map(dataToCloudCostRow)
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $3cba5a2b6a62bd7c$export$2e2bcd8739ae039), {
                        component: "div",
                        count: numData,
                        rowsPerPage: rowsPerPage,
                        rowsPerPageOptions: [
                            10,
                            25,
                            50
                        ],
                        page: Math.min(page, lastPage),
                        onPageChange: handleChangePage,
                        onRowsPerPageChange: handleChangeRowsPerPage
                    })
                ]
            })
        ]
    });
};
var $b692744641c7b083$export$2e2bcd8739ae039 = /*#__PURE__*/ $gIfym.memo($b692744641c7b083$var$CloudCost);




var $gIfym = parcelRequire("gIfym");









function $f51d36aaf012fe7e$var$formatItemsForCost({ data: data, costType: costType }) {
    return data.sets.map(({ cloudCosts: cloudCosts, window: window })=>{
        return {
            date: window.start,
            cost: Object.values(cloudCosts).reduce((acc, costs)=>acc + costs[costType || "amortizedNetCost"].cost, 0)
        };
    });
}
class $f51d36aaf012fe7e$var$CloudCostDayTotalsService {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($39363681bdb5f057$exports)))(this, "BASE_URL", "{PLACEHOLDER_BASE_URL}");
    }
    async fetchCloudCostData(window, aggregate, costMetric, filters) {
        if (this.BASE_URL.includes("PLACEHOLDER_BASE_URL")) this.BASE_URL = `http://localhost:9090/model`;
        if (aggregate.includes("item")) {
            const resp = await (0, $e03209fca4c3e620$export$2e2bcd8739ae039).get(`${this.BASE_URL}/cloudCost?window=${window}&costMetric=${costMetric}&filter=${(0, $4ab43b5ac1a299dc$export$2f387f690230eab4)(filters)}`);
            const costMetricProp = (0, $f5a389928d825682$export$b4f68472a7299187)[costMetric];
            const result_2 = await resp.data;
            return {
                data: $f51d36aaf012fe7e$var$formatItemsForCost(result_2, costMetricProp)
            };
        }
        return [];
    }
}
var $f51d36aaf012fe7e$export$2e2bcd8739ae039 = new $f51d36aaf012fe7e$var$CloudCostDayTotalsService();


const $32f4bde45eb769b4$export$9339d139c9eaab51 = ({ onClose: onClose, selectedProviderId: selectedProviderId, selectedItem: selectedItem, agg: agg, filters: filters, costMetric: costMetric, window: window, currency: currency })=>{
    const [data, setData] = $gIfym.useState([]);
    const [loading, setLoading] = $gIfym.useState(false);
    const [errors, setErrors] = $gIfym.useState([]);
    const [fetch, setFetch] = $gIfym.useState(true);
    const nextFilters = [
        ...filters ?? [],
        {
            property: "providerID",
            value: selectedProviderId
        }
    ];
    async function fetchData() {
        setLoading(true);
        setErrors([]);
        try {
            const resp = await (0, $f51d36aaf012fe7e$export$2e2bcd8739ae039).fetchCloudCostData(window, agg, costMetric, nextFilters);
            if (resp.data) setData(resp.data);
            else {
                if (resp.message && resp.message.indexOf("boundary error") >= 0) {
                    let match = resp.message.match(/(ETL is \d+\.\d+% complete)/);
                    let secondary = "Try again after ETL build is complete";
                    if (match.length > 0) secondary = `${match[1]}. ${secondary}`;
                    setErrors([
                        {
                            primary: "Data unavailable while ETL is building",
                            secondary: secondary
                        }
                    ]);
                }
                setData([]);
            }
        } catch (err) {
            console.log(err);
            if (err.message.indexOf("404") === 0) setErrors([
                {
                    primary: "Failed to load report data",
                    secondary: "Please update OpenCost to the latest version, then open an Issue on GitHub if problems persist."
                }
            ]);
            else {
                let secondary = "Please open an Issue on GitHub if problems persist.";
                if (err.message.length > 0) secondary = err.message;
                setErrors([
                    {
                        primary: "Failed to load report data",
                        secondary: secondary
                    }
                ]);
            }
            setData([]);
        }
        setLoading(false);
        setFetch(false);
    }
    $gIfym.useEffect(()=>{
        if (fetch) fetchData();
    }, [
        fetch
    ]);
    const drilldownData = data.sort((a, b)=>new Date(a.date ?? "").getTime() - new Date(b.date ?? "").getTime());
    const itemData = drilldownData.map((items)=>{
        const dataPoint = {
            time: new Date(items.date),
            cost: items.cost
        };
        return dataPoint;
    });
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $3ad09d28fe7c5342$export$2e2bcd8739ae039), {
            open: true,
            onClose: onClose,
            title: `Costs over the last ${window}`,
            style: {
                margin: "10%"
            },
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $ee13f6b8f50f92d0$export$2e2bcd8739ae039), {
                style: {
                    padding: 20
                },
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
                        style: {
                            marginTop: "1rem"
                        },
                        variant: "body1",
                        children: selectedItem
                    }),
                    loading && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                            style: {
                                paddingTop: 100,
                                paddingBottom: 100
                            },
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ff3a7ab0b65b1eb6$export$2e2bcd8739ae039), {})
                        })
                    }),
                    !loading && errors.length > 0 && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        style: {
                            marginBottom: 20
                        },
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $08b36a1d9bca6415$export$2e2bcd8739ae039), {
                            warnings: errors
                        })
                    }),
                    data && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            marginTop: "2.5rem"
                        },
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d7b42fa8a2c2a4be$export$e60a4704009a0009), {
                            height: 250,
                            id: "cloud-cost-drilldown",
                            width: "100%",
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $e5f9bccf45a8faa3$export$94aefc399ef206a9), {
                                data: itemData,
                                margin: {
                                    top: 0,
                                    bottom: 10,
                                    left: 20,
                                    right: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $1e8a496f1b0dc2f3$export$6440e27b9f186856), {
                                        vertical: false
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $61f751c849868bc2$export$ed247974535929c7), {
                                        verticalAlign: "bottom"
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $4599bbc635684a39$export$ea77231de273b52d), {
                                        dataKey: "time"
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $dc3299e5adf43c53$export$f96c4024c52de8f4), {
                                        tickFormatter: (tick)=>`${(0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(tick)}`
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $7f0f02843a7c30b4$export$bbc6c6369b38e3d1), {
                                        dataKey: "cost",
                                        fill: "#2196f3",
                                        name: "Item Cost"
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $af95134c6736175e$export$28c660c63b792dea), {
                                        formatter: (value)=>`${(0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(value ?? 0, currency, 4, true)}`
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};


const $d7460214e5645b52$var$CloudCosts = ()=>{
    const useStyles = (0, $hQJVM.default)({
        reportHeader: {
            display: "flex",
            flexFlow: "row",
            padding: 24
        },
        titles: {
            flexGrow: 1
        }
    });
    const classes = useStyles();
    // Form state, which controls form elements, but not the report itself. On
    // certain actions, the form state may flow into the report state.
    const [title, setTitle] = $gIfym.useState("Cumulative cost for last 7 days by account");
    const [window, setWindow] = $gIfym.useState((0, $f5a389928d825682$export$59d6215c1fd3d225)[0].value);
    const [aggregateBy, setAggregateBy] = $gIfym.useState((0, $f5a389928d825682$export$b03894030256da6c)[0].value);
    const [costMetric, setCostMetric] = $gIfym.useState((0, $f5a389928d825682$export$38808721902aaeb5)[0].value);
    const [filters, setFilters] = $gIfym.useState([]);
    const [currency, setCurrency] = $gIfym.useState("USD");
    const [selectedProviderId, setSelectedProviderId] = $gIfym.useState("");
    const [selectedItemName, setselectedItemName] = $gIfym.useState("");
    const sampleData = aggregateBy.includes("item");
    // page and settings state
    const [init, setInit] = $gIfym.useState(false);
    const [fetch, setFetch] = $gIfym.useState(false);
    const [loading, setLoading] = $gIfym.useState(true);
    const [errors, setErrors] = $gIfym.useState([]);
    // data
    const [cloudCostData, setCloudCostData] = $gIfym.useState([]);
    function generateTitle({ window: window, aggregateBy: aggregateBy, costMetric: costMetric }) {
        let windowName = (0, $6IRuR.get)((0, $6IRuR.find)((0, $f5a389928d825682$export$59d6215c1fd3d225), {
            value: window
        }), "name", "");
        if (windowName === "") {
            if ((0, $4ab43b5ac1a299dc$export$8764230b0d460478)(window)) windowName = (0, $4ab43b5ac1a299dc$export$2e6bf8a055fccba2)(window);
            else console.warn(`unknown window: ${window}`);
        }
        let aggregationName = (0, $6IRuR.get)((0, $6IRuR.find)((0, $f5a389928d825682$export$b03894030256da6c), {
            value: aggregateBy
        }), "name", "").toLowerCase();
        if (aggregationName === "") console.warn(`unknown aggregation: ${aggregateBy}`);
        let str = `Cumulative cost for ${windowName} by ${aggregationName}`;
        if (!costMetric) str = `${str} amoritizedNetCost`;
        return str;
    }
    // parse any context information from the URL
    const routerLocation = (0, $b585d439d92e032d$export$45d76561a5302f2b)();
    const searchParams = new URLSearchParams(routerLocation.search);
    const routerHistory = (0, $b585d439d92e032d$export$3420e1dc2c4a518c)();
    async function initialize() {
        setInit(true);
    }
    async function fetchData() {
        setLoading(true);
        setErrors([]);
        try {
            const resp = await (0, $f86010c682ad973b$export$2e2bcd8739ae039).fetchCloudCostData(window, aggregateBy, costMetric, filters);
            if (resp) setCloudCostData(resp);
            else {
                if (resp.message && resp.message.indexOf("boundary error") >= 0) {
                    let match = resp.message.match(/(ETL is \d+\.\d+% complete)/);
                    let secondary = "Try again after ETL build is complete";
                    if (match.length > 0) secondary = `${match[1]}. ${secondary}`;
                    setErrors([
                        {
                            primary: "Data unavailable while ETL is building",
                            secondary: secondary
                        }
                    ]);
                }
                setCloudCostData([]);
            }
        } catch (err) {
            if (err.message.indexOf("404") === 0) setErrors([
                {
                    primary: "Failed to load report data",
                    secondary: "Please update OpenCost to the latest version, and open an Issue if problems persist."
                }
            ]);
            else {
                let secondary = "Please open an Issue with OpenCost if problems persist.";
                if (err.message.length > 0) secondary = err.message;
                setErrors([
                    {
                        primary: "Failed to load report data",
                        secondary: secondary
                    }
                ]);
            }
            setCloudCostData([]);
        }
        setLoading(false);
    }
    function drilldown(row) {
        if (aggregateBy.includes("item")) {
            try {
                setSelectedProviderId(row.providerID);
                setselectedItemName(row.labelName ?? row.name);
            } catch (e) {
                logger.error(e);
            }
            return;
        }
        const nameParts = row.name.split("/");
        const nextAgg = aggregateBy.includes("service") ? "item" : "service";
        const aggToString = [
            aggregateBy
        ];
        const newFilters = aggToString.map((property, i)=>{
            const value = nameParts[i];
            return {
                property: property,
                value: value
            };
        });
        setFilters(newFilters);
        setAggregateBy(nextAgg);
    }
    $gIfym.useEffect(()=>{
        setWindow(searchParams.get("window") || "7d");
        setAggregateBy(searchParams.get("agg") || "provider");
        setCostMetric(searchParams.get("costMetric") || "AmortizedNetCost");
        setCurrency(searchParams.get("currency") || "USD");
    }, [
        routerLocation
    ]);
    // Initialize once, then fetch report each time setFetch(true) is called
    $gIfym.useEffect(()=>{
        if (!init) initialize();
        if (init || fetch) fetchData();
    }, [
        init,
        fetch
    ]);
    $gIfym.useEffect(()=>{
        setFetch(!fetch);
        setTitle(generateTitle({
            window: window,
            aggregateBy: aggregateBy,
            costMetric: costMetric
        }));
    }, [
        window,
        aggregateBy,
        costMetric,
        filters
    ]);
    const hasCloudCostEnabled = aggregateBy.includes("item") ? true // this is kind of hacky but something weird is happening
     : // when drilling down will address in a later PR - @jjarrett21
    !!cloudCostData.cloudCostStatus?.length;
    const enabledWarnings = [
        {
            primary: "There are no Cloud Cost integrations currently configured.",
            secondary: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
                children: [
                    "Learn more about setting up Cloud Costs",
                    " ",
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $1d96cd50cde517a6$export$2e2bcd8739ae039), {
                        href: "https://www.opencost.io/docs/configuration/#cloud-costs",
                        target: "_blank",
                        children: "here"
                    })
                ]
            })
        }
    ];
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $8530181efc7ffbd0$export$2e2bcd8739ae039), {
        active: "cloud.html",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d5abac16fc0baa87$export$2e2bcd8739ae039), {
                headerTitle: "Cloud Costs",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $2ae0a89ca37bbdde$export$2e2bcd8739ae039), {
                    "aria-label": "refresh",
                    onClick: ()=>setFetch(true),
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($82db5f4ea5a284fb$exports))), {})
                })
            }),
            !loading && !hasCloudCostEnabled && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                style: {
                    marginBottom: 20
                },
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $08b36a1d9bca6415$export$2e2bcd8739ae039), {
                    warnings: enabledWarnings
                })
            }),
            !loading && errors.length > 0 && hasCloudCostEnabled && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                style: {
                    marginBottom: 20
                },
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $08b36a1d9bca6415$export$2e2bcd8739ae039), {
                    warnings: errors
                })
            }),
            init && hasCloudCostEnabled && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $ee13f6b8f50f92d0$export$2e2bcd8739ae039), {
                id: "cloud-cost",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: classes.reportHeader,
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                                className: classes.titles,
                                children: [
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
                                        variant: "h5",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $1dc8f044258e228d$export$2e2bcd8739ae039), {
                                        report: {
                                            window: window,
                                            aggregateBy: aggregateBy
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $80752a70656e793c$export$2e2bcd8739ae039), {
                                windowOptions: (0, $f5a389928d825682$export$59d6215c1fd3d225),
                                window: window,
                                setWindow: (win)=>{
                                    searchParams.set("window", win);
                                    routerHistory.push({
                                        search: `?${searchParams.toString()}`
                                    });
                                },
                                aggregationOptions: (0, $f5a389928d825682$export$b03894030256da6c),
                                aggregateBy: aggregateBy,
                                setAggregateBy: (agg)=>{
                                    setFilters([]);
                                    searchParams.set("agg", agg);
                                    routerHistory.push({
                                        search: `?${searchParams.toString()}`
                                    });
                                },
                                costMetricOptions: (0, $f5a389928d825682$export$38808721902aaeb5),
                                costMetric: costMetric,
                                setCostMetric: (c)=>{
                                    searchParams.set("costMetric", c);
                                    routerHistory.push({
                                        search: `?${searchParams.toString()}`
                                    });
                                },
                                title: title,
                                // cumulativeData={cumulativeData}
                                currency: currency,
                                currencyOptions: (0, $74b9db456d6885ed$export$a01df35ce0858603),
                                setCurrency: (curr)=>{
                                    searchParams.set("currency", curr);
                                    routerHistory.push({
                                        search: `?${searchParams.toString()}`
                                    });
                                }
                            })
                        ]
                    }),
                    loading && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                            style: {
                                paddingTop: 100,
                                paddingBottom: 100
                            },
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ff3a7ab0b65b1eb6$export$2e2bcd8739ae039), {})
                        })
                    }),
                    !loading && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b692744641c7b083$export$2e2bcd8739ae039), {
                        cumulativeData: cloudCostData.tableRows,
                        currency: currency,
                        graphData: cloudCostData.graphData,
                        totalData: cloudCostData.tableTotal,
                        drilldown: drilldown,
                        sampleData: sampleData
                    }),
                    selectedProviderId && selectedItemName && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $32f4bde45eb769b4$export$9339d139c9eaab51), {
                        onClose: ()=>{
                            setSelectedProviderId("");
                            setselectedItemName("");
                        },
                        selectedProviderId: selectedProviderId,
                        selectedItem: selectedItemName,
                        agg: aggregateBy,
                        filters: filters,
                        costMetric: costMetric,
                        window: window,
                        currency: currency
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $538e5067ae27ebfc$export$2e2bcd8739ae039), {})
        ]
    });
};
var $d7460214e5645b52$export$2e2bcd8739ae039 = /*#__PURE__*/ $gIfym.memo($d7460214e5645b52$var$CloudCosts);




var $gIfym = parcelRequire("gIfym");






var $hQJVM = parcelRequire("hQJVM");






function $4740bba3cf466922$export$23d7163c178dd8b5(filters) {
    if (typeof filters === "string") return filters;
    return [
        ...new Set(filters.map((f)=>`${f.property}:"${f.value}"`))
    ].join('+') || "";
}
class $4740bba3cf466922$var$ExternalCostsService {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($39363681bdb5f057$exports)))(this, "BASE_URL", "{PLACEHOLDER_BASE_URL}");
    }
    async fetchExternalGraphCosts(win, aggregate, filters, costType, sortBy, sortDirection) {
        if (this.BASE_URL.includes("PLACEHOLDER_BASE_URL")) this.BASE_URL = `http://localhost:9090/model`;
        const params = {
            window: win,
            aggregate: aggregate,
            costType: costType,
            filter: $4740bba3cf466922$export$23d7163c178dd8b5(filters),
            sortBy: sortBy,
            sortDirection: sortDirection
        };
        const result = await (0, $e03209fca4c3e620$export$2e2bcd8739ae039).get(`${this.BASE_URL}/customCost/timeseries`, {
            params: params
        });
        return result.data.data;
    }
    async fetchExternalTableCosts(win, aggregate, filters, costType, sortBy, sortDirection) {
        if (this.BASE_URL.includes("PLACEHOLDER_BASE_URL")) this.BASE_URL = `http://localhost:9090/model`;
        const params = {
            window: win,
            aggregate: aggregate,
            costType: costType,
            filter: $4740bba3cf466922$export$23d7163c178dd8b5(filters),
            sortBy: sortBy,
            sortDirection: sortDirection
        };
        const result = await (0, $e03209fca4c3e620$export$2e2bcd8739ae039).get(`${this.BASE_URL}/customCost/total`, {
            params: params
        });
        return result.data.data;
    }
}
var $4740bba3cf466922$export$2e2bcd8739ae039 = new $4740bba3cf466922$var$ExternalCostsService();


const $1e3010fdb6d92f5c$export$d6689cc0b89790a7 = [
    {
        name: "Blended",
        value: "blended"
    },
    {
        name: "Billed",
        value: "billed"
    },
    {
        name: "List",
        value: "list"
    }
];
const $1e3010fdb6d92f5c$export$59d6215c1fd3d225 = [
    {
        name: "Today",
        value: "today"
    },
    {
        name: "Yesterday",
        value: "yesterday"
    },
    {
        name: "Last 24h",
        value: "24h"
    },
    {
        name: "Last 48h",
        value: "48h"
    },
    {
        name: "Week-to-date",
        value: "week"
    },
    {
        name: "Last week",
        value: "lastweek"
    },
    {
        name: "Last 7 days",
        value: "7d"
    },
    {
        name: "Last 14 days",
        value: "14d"
    }
];
const $1e3010fdb6d92f5c$export$b03894030256da6c = [
    {
        name: "Domain",
        value: "domain"
    },
    {
        name: "Account Name",
        value: "accountName"
    },
    {
        name: "Resource Name",
        value: "resourceName"
    },
    {
        name: "Resource Type",
        value: "resourceType"
    },
    {
        name: "Zone",
        value: "zone"
    },
    {
        name: "Charge Category",
        value: "chargeCategory"
    },
    {
        name: "Provider ID",
        value: "providerId"
    },
    {
        name: "Usage Unit",
        value: "usageUnit"
    }
];
const $1e3010fdb6d92f5c$export$2307f5dee391b05d = {
    zone: "zone",
    accountName: "account_name",
    chargeCategory: "charge_category",
    resourceName: "resource_name",
    resourceType: "resource_type",
    providerId: "provider_id",
    usageUnit: "usage_unit",
    domain: "domain"
};




var $hQJVM = parcelRequire("hQJVM");





var $gIfym = parcelRequire("gIfym");


const $177352e08b6a4135$var$useStyles = (0, $hQJVM.default)({
    wrapper: {
        display: "inline-flex"
    },
    formControl: {
        margin: 8,
        minWidth: 120
    }
});
function $177352e08b6a4135$var$ExternalCostsControls({ window: window, setWindow: setWindow, aggregateBy: aggregateBy, setAggregateBy: setAggregateBy, costType: costType, setCostType: setCostType }) {
    const classes = $177352e08b6a4135$var$useStyles();
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: classes.wrapper,
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $bedcb082e4938fab$export$2e2bcd8739ae039), {
                windowOptions: (0, $1e3010fdb6d92f5c$export$59d6215c1fd3d225),
                window: window,
                setWindow: setWindow
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $1f3c3d6fcb879aaf$export$2e2bcd8739ae039), {
                className: classes.formControl,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $83d8148cf52783d5$export$2e2bcd8739ae039), {
                        id: "aggregation-select-label",
                        children: "Breakdown"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ea71a0b004fd8af3$export$2e2bcd8739ae039), {
                        id: "aggregation-select",
                        value: aggregateBy,
                        onChange: (e)=>{
                            setAggregateBy(e.target.value);
                        },
                        children: (0, $1e3010fdb6d92f5c$export$b03894030256da6c).map((opt)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c027d6b11891bde0$export$2e2bcd8739ae039), {
                                value: opt.value,
                                children: opt.name
                            }, opt.value))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $1f3c3d6fcb879aaf$export$2e2bcd8739ae039), {
                className: classes.formControl,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $83d8148cf52783d5$export$2e2bcd8739ae039), {
                        id: "aggregation-select-label",
                        children: "Cost Type"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ea71a0b004fd8af3$export$2e2bcd8739ae039), {
                        id: "cost-type-select",
                        value: costType,
                        onChange: (e)=>{
                            setCostType(e.target.value);
                        },
                        children: (0, $1e3010fdb6d92f5c$export$d6689cc0b89790a7).map((opt)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c027d6b11891bde0$export$2e2bcd8739ae039), {
                                value: opt.value,
                                children: opt.name
                            }, opt.value))
                    })
                ]
            })
        ]
    });
}
var $177352e08b6a4135$export$2e2bcd8739ae039 = /*#__PURE__*/ $gIfym.memo($177352e08b6a4135$var$ExternalCostsControls);




var $gIfym = parcelRequire("gIfym");


parcelRequire("gIfym");

var $hQJVM = parcelRequire("hQJVM");




const $15c6d836ed6132ba$var$RangeChart = ({ data: data, currency: currency, height: height, aggregateBy: aggregateBy })=>{
    const useStyles = (0, $hQJVM.default)({
        tooltip: {
            borderRadius: 2,
            background: "rgba(255, 255, 255, 0.95)",
            padding: 12
        },
        tooltipLineItem: {
            fontSize: "1rem",
            margin: 0,
            marginBottom: 4,
            padding: 0
        }
    });
    const accents = [
        ...(0, $e95a10c0d7b6a200$export$9ad721cf3b3debe0),
        ...(0, $e95a10c0d7b6a200$export$88f5aeecbc5784c1),
        ...(0, $e95a10c0d7b6a200$export$bcdff0aad5ea3623)
    ];
    const getItemCost = (item)=>{
        return item.cost;
    };
    function toBar({ end: end, graph: graph, start: start }) {
        const points = graph.map((item)=>({
                ...item,
                window: {
                    end: end,
                    start: start
                }
            }));
        const dateFormatter = Intl.DateTimeFormat(navigator.language, {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            timeZone: "UTC"
        });
        const timeFormatter = Intl.DateTimeFormat(navigator.language, {
            hour: "numeric",
            minute: "numeric",
            timeZone: "UTC"
        });
        const s = new Date(start);
        const e = new Date(end);
        const interval = (e.valueOf() - s.valueOf()) / 1000 / 60 / 60;
        const bar = {
            end: new Date(end),
            key: interval >= 24 ? dateFormatter.format(s) : timeFormatter.format(s),
            items: {},
            start: new Date(start)
        };
        points.forEach((item)=>{
            const windowStart = new Date(item.window.start);
            const windowEnd = new Date(item.window.end);
            const windowHours = (windowEnd.valueOf() - windowStart.valueOf()) / 1000 / 60 / 60;
            if (windowHours >= 24) bar.key = dateFormatter.format(bar.start);
            else bar.key = timeFormatter.format(bar.start);
            bar.items[item[(0, $1e3010fdb6d92f5c$export$2307f5dee391b05d)[aggregateBy]] || 'Unallocated'] = getItemCost(item);
        });
        return bar;
    }
    const getDataForDay = (dayData)=>{
        const { end: end, start: start } = dayData.window;
        const copy = [
            ...dayData.customCosts
        ];
        const sortedItems = copy.slice().sort((a, b)=>{
            return a.cost > b.cost ? -1 : 1;
        });
        const top8 = sortedItems.slice(0, 8);
        return {
            end: end,
            start: start,
            graph: top8
        };
    };
    const getDataForGraph = (dataPoints)=>{
        const orderedDataPoints = dataPoints.map(getDataForDay);
        const bars = orderedDataPoints.map(toBar);
        const keyToFill = {};
        // we want to keep track of the order of fill assignment
        const assignmentOrder = [];
        let p = 0;
        orderedDataPoints.forEach(({ graph: graph, start: start, end: end })=>{
            graph.forEach((item)=>{
                const key = item[(0, $1e3010fdb6d92f5c$export$2307f5dee391b05d)[aggregateBy]] || 'Unallocated';
                if (keyToFill[key] === undefined) {
                    assignmentOrder.push(key);
                    keyToFill[key] = accents[p];
                    p = (p + 1) % accents.length;
                }
            });
        });
        const labels = assignmentOrder.map((dataKey)=>({
                dataKey: dataKey,
                fill: keyToFill[dataKey]
            }));
        return {
            bars: bars,
            labels: labels,
            keyToFill: keyToFill
        };
    };
    const { bars: barData, labels: barLabels, keyToFill: keyToFill } = getDataForGraph(data.timeseries);
    const classes = useStyles();
    const CustomTooltip = (params)=>{
        const { active: active, payload: payload } = params;
        if (!payload || payload.length == 0) return null;
        // come back and address issue with non-unique key names
        const total = payload.reduce((sum, item)=>sum + item.value, 0.0);
        if (active) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: classes.tooltip,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                    className: classes.tooltipLineItem,
                    style: {
                        color: "#000000"
                    },
                    children: `Total: ${(0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(total, currency)}`
                }),
                payload.slice().map((item, i)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        style: {
                            display: "grid",
                            gridTemplateColumns: "20px 1fr",
                            gap: ".5em",
                            margin: ".25em"
                        },
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                    style: {
                                        backgroundColor: keyToFill[item.payload.items[i][0]],
                                        width: 18,
                                        height: 18
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                                    className: classes.tooltipLineItem,
                                    children: `${item.payload.items[i][0]}: ${(0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(item.value, currency)}`
                                })
                            })
                        ]
                    }, i)).reverse()
            ]
        });
        return null;
    };
    const orderedBars = barData.map((bar)=>{
        return {
            ...bar,
            items: Object.entries(bar.items).sort((a, b)=>a[1] > b[1] ? -1 : 1)
        };
    });
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d7b42fa8a2c2a4be$export$e60a4704009a0009), {
        height: height,
        width: "100%",
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $e5f9bccf45a8faa3$export$94aefc399ef206a9), {
            data: orderedBars,
            margin: {
                top: 30,
                right: 35,
                left: 30,
                bottom: 45
            },
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $1e8a496f1b0dc2f3$export$6440e27b9f186856), {
                    strokeDasharray: "3 3",
                    vertical: false
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $4599bbc635684a39$export$ea77231de273b52d), {
                    dataKey: "key"
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $dc3299e5adf43c53$export$f96c4024c52de8f4), {
                    tickFormatter: (val)=>(0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(val, currency, 2, true)
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $af95134c6736175e$export$28c660c63b792dea), {
                    content: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)(CustomTooltip, {}),
                    wrapperStyle: {
                        zIndex: 1000
                    }
                }),
                new Array(10).fill(0).map((item, idx)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $7f0f02843a7c30b4$export$bbc6c6369b38e3d1), {
                        dataKey: (entry)=>entry.items[idx] ? entry.items[idx][1] : null,
                        stackId: "x",
                        children: orderedBars.map((bar)=>bar.items[idx] ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b7ce6dc70cc786c8$export$f6f0c3fe4ec306ea), {
                                fill: keyToFill[bar.items[idx][0]]
                            }) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b7ce6dc70cc786c8$export$f6f0c3fe4ec306ea), {}))
                    }))
            ]
        })
    });
};
var $15c6d836ed6132ba$export$2e2bcd8739ae039 = $15c6d836ed6132ba$var$RangeChart;


const $e52478e1eadbde64$var$ExternalCostsChart = ({ graphData: graphData, currency: currency, n: n, height: height, aggregateBy: aggregateBy })=>{
    if (graphData.length === 0) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
        variant: "body2",
        style: {
            padding: "4em"
        },
        children: "No data"
    });
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $15c6d836ed6132ba$export$2e2bcd8739ae039), {
        data: graphData,
        currency: currency,
        height: height,
        aggregateBy: aggregateBy
    });
};
var $e52478e1eadbde64$export$2e2bcd8739ae039 = /*#__PURE__*/ $gIfym.memo($e52478e1eadbde64$var$ExternalCostsChart);




var $gIfym = parcelRequire("gIfym");

var $hQJVM = parcelRequire("hQJVM");




parcelRequire("gIfym");



const $361d0f429a7930a1$var$displayCurrencyAsLessThanPenny = (amount, currency)=>amount > 0 && amount < 0.01 ? `<${(0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(0.01, currency)}` : (0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(amount, currency);
function $361d0f429a7930a1$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
const $361d0f429a7930a1$export$882ea1f148a9a0c1 = ({ cost: cost, currency: currency, onClick: onClick, name: name, costType: costType })=>{
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                align: "left",
                style: {
                    cursor: "pointer",
                    color: "#346ef2",
                    padding: "1rem"
                },
                children: name
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                align: "right",
                style: {
                    paddingRight: "2em"
                },
                children: $361d0f429a7930a1$var$capitalizeFirstLetter(costType)
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                align: "right",
                style: {
                    paddingRight: "2em"
                },
                children: `${$361d0f429a7930a1$var$displayCurrencyAsLessThanPenny(cost, currency)}`
            })
        ]
    });
};



const $dcdeeeadd68fc930$var$ExternalCostsTable = ({ tableData: tableData, currency: currency = "USD", aggregateBy: aggregateBy = "usageUnit", drilldown: drilldown })=>{
    const useStyles = (0, $hQJVM.default)({
        noResults: {
            padding: 24
        }
    });
    const classes = useStyles();
    const headCells = [
        {
            id: "aggregate",
            numeric: false,
            label: "Name",
            width: "auto"
        },
        {
            id: "costType",
            numeric: false,
            label: "Cost Type",
            width: 160
        },
        {
            id: "cost",
            numeric: true,
            label: "Cost",
            width: 160
        }
    ];
    const routerLocation = (0, $b585d439d92e032d$export$45d76561a5302f2b)();
    const searchParams = new URLSearchParams(routerLocation.search);
    const routerHistory = (0, $b585d439d92e032d$export$3420e1dc2c4a518c)();
    const [page, setPage] = $gIfym.useState(0);
    const [rowsPerPage, setRowsPerPage] = $gIfym.useState(25);
    const numData = tableData.customCosts?.length ?? 0;
    const lastPage = Math.floor(numData / rowsPerPage);
    const handleChangePage = (event, newPage)=>setPage(newPage);
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    let pageRows = [];
    if (tableData && 'customCosts' in tableData) pageRows = tableData.customCosts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    $gIfym.useEffect(()=>{
        setPage(0);
    }, [
        numData
    ]);
    if ('customCosts' in tableData && tableData.customCosts.length === 0) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9c5b9e5aa5c4774c$export$2e2bcd8739ae039), {
        variant: "body2",
        className: classes.noResults,
        children: "No results"
    });
    function dataToExternalCostRow(row) {
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $361d0f429a7930a1$export$882ea1f148a9a0c1), {
            cost: row.cost,
            costType: row.cost_type,
            onClick: ()=>// we don't want to allow drilldown on item without an empty name
                row[(0, $1e3010fdb6d92f5c$export$2307f5dee391b05d)[aggregateBy]] ? drilldown(row) : {},
            name: row[(0, $1e3010fdb6d92f5c$export$2307f5dee391b05d)[aggregateBy]] || "Unallocated"
        }, row.usage_unit);
    }
    const currentSortBy = searchParams.get("sortBy");
    const currentSortDirection = searchParams.get("sortDirection");
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        id: "cloud-cost-table",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $6d7bd70307fdcf46$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $9baaa18523ae0079$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8877b048d1d8501c$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                children: headCells.map((cell)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                        colSpan: cell.colspan,
                                        align: cell.numeric ? "right" : "left",
                                        style: {
                                            width: cell.width
                                        },
                                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $99436b9fec0b22ea$export$2e2bcd8739ae039), {
                                            active: currentSortBy === cell.id,
                                            direction: currentSortBy === cell.id ? currentSortDirection : 'desc',
                                            onClick: ()=>{
                                                if (currentSortBy === cell.id) // then we simply need to update direction
                                                searchParams.set("sortDirection", currentSortDirection === "desc" ? "asc" : "desc");
                                                else {
                                                    searchParams.set("sortBy", cell.id);
                                                    searchParams.set("sortDirection", "desc");
                                                }
                                                routerHistory.push({
                                                    search: `?${searchParams.toString()}`
                                                });
                                            },
                                            children: cell.label
                                        })
                                    }, cell.id))
                            })
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $b26ae0b21e46ca86$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            align: "left",
                                            style: {
                                                fontWeight: 500
                                            },
                                            children: "Total Cost"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            align: "right",
                                            style: {
                                                fontWeight: 500,
                                                paddingRight: "2em"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            align: "right",
                                            style: {
                                                fontWeight: 500,
                                                paddingRight: "2em"
                                            },
                                            children: (0, $4ab43b5ac1a299dc$export$5b32fe2adc96cb7f)(tableData.totalCost || 0, currency)
                                        })
                                    ]
                                }),
                                pageRows.map(dataToExternalCostRow)
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $3cba5a2b6a62bd7c$export$2e2bcd8739ae039), {
                component: "div",
                count: numData,
                rowsPerPage: rowsPerPage,
                rowsPerPageOptions: [
                    10,
                    25,
                    50
                ],
                page: Math.min(page, lastPage),
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage
            })
        ]
    });
};
var $dcdeeeadd68fc930$export$2e2bcd8739ae039 = /*#__PURE__*/ $gIfym.memo($dcdeeeadd68fc930$var$ExternalCostsTable);




const $cc29835c238bdf5c$export$2906d059637be3a7 = ({ row: row, onClose: onClose })=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $3ad09d28fe7c5342$export$2e2bcd8739ae039), {
            open: true,
            onClose: onClose,
            title: row.resource_type,
            style: {
                margin: "10%"
            },
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ee13f6b8f50f92d0$export$2e2bcd8739ae039), {
                style: {
                    padding: 20
                },
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $6d7bd70307fdcf46$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $9baaa18523ae0079$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $b26ae0b21e46ca86$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: "account_name"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: row.account_name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: "aggregate"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: row.aggregate
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: "charge_category"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: row.charge_category
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: "cost"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: row.cost
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: "cost_source"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: row.cost_source
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: "cost_type"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: row.cost_type
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: "description"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: row.description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: "domain"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: row.domain
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: "id"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: row.id
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: "list_unit_price"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: row.list_unit_price
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: "provider_id"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: row.provider_id
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: "resource_name"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: row.resource_name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: "resource_type"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: row.resource_type
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: "usage_quantity"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: row.usage_quantity
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: "usage_unit"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: row.usage_unit
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $246e5d89d70fb818$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: "zone"
                                        }),
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $911323fee9a96c67$export$2e2bcd8739ae039), {
                                            children: row.zone
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });


const $c6366b90b448fa16$var$ExternalCosts = ()=>{
    const useStyles = (0, $hQJVM.default)({
        reportHeader: {
            display: "flex",
            flexFlow: "row",
            padding: 24
        },
        titles: {
            flexGrow: 1
        }
    });
    const classes = useStyles();
    const [window, setWindow] = $gIfym.useState((0, $1e3010fdb6d92f5c$export$59d6215c1fd3d225)[0].value);
    const [costType, setCostType] = $gIfym.useState((0, $1e3010fdb6d92f5c$export$d6689cc0b89790a7)[0].value);
    const [sortBy, setSortBy] = $gIfym.useState("cost");
    const [sortDirection, setSortDirection] = $gIfym.useState("desc");
    const [aggregateBy, setAggregateBy] = $gIfym.useState((0, $1e3010fdb6d92f5c$export$b03894030256da6c)[0].value);
    const [filters, setFilters] = $gIfym.useState([]);
    const [currency, setCurrency] = $gIfym.useState("USD");
    // page and settings state
    const [init, setInit] = $gIfym.useState(false);
    const [fetch, setFetch] = $gIfym.useState(false);
    const [loading, setLoading] = $gIfym.useState(true);
    const [errors, setErrors] = $gIfym.useState([]);
    const [showModal, setShowModal] = $gIfym.useState(false);
    // data
    const [externalCostData, setExternalCostData] = $gIfym.useState([]);
    const [externalCostTableData, setExternalCostTableData] = $gIfym.useState([]);
    // parse any context information from the URL
    const routerLocation = (0, $b585d439d92e032d$export$45d76561a5302f2b)();
    const searchParams = new URLSearchParams(routerLocation.search);
    const routerHistory = (0, $b585d439d92e032d$export$3420e1dc2c4a518c)();
    async function initialize() {
        setInit(true);
    }
    async function fetchChartData() {
        try {
            const resp = await (0, $4740bba3cf466922$export$2e2bcd8739ae039).fetchExternalGraphCosts(window, aggregateBy, filters, costType, sortBy, sortDirection);
            if (resp) setExternalCostData(resp);
            else {
                if (resp.message && resp.message.indexOf("boundary error") >= 0) {
                    let match = resp.message.match(/(ETL is \d+\.\d+% complete)/);
                    let secondary = "Try again after ETL build is complete";
                    if (match.length > 0) secondary = `${match[1]}. ${secondary}`;
                    setErrors([
                        {
                            primary: "Data unavailable while ETL is building",
                            secondary: secondary
                        }
                    ]);
                }
                setExternalCostData([]);
            }
        } catch (err) {
            console.log(err);
            if (err.message.indexOf("404") === 0) setErrors([
                {
                    primary: "Failed to load report data",
                    secondary: "Please update OpenCost to the latest version, and open an Issue if problems persist."
                }
            ]);
            else {
                let secondary = "Please open an Issue with OpenCost if problems persist.";
                if (err.message.length > 0) secondary = err.message;
                setErrors([
                    {
                        primary: "Failed to load report data",
                        secondary: secondary
                    }
                ]);
            }
            setExternalCostData([]);
        }
    }
    async function fetchTableData() {
        try {
            const resp = await (0, $4740bba3cf466922$export$2e2bcd8739ae039).fetchExternalTableCosts(window, aggregateBy, filters, costType, sortBy, sortDirection);
            if (resp) setExternalCostTableData(resp);
            else {
                if (resp.message && resp.message.indexOf("boundary error") >= 0) {
                    let match = resp.message.match(/(ETL is \d+\.\d+% complete)/);
                    let secondary = "Try again after ETL build is complete";
                    if (match.length > 0) secondary = `${match[1]}. ${secondary}`;
                    setErrors([
                        {
                            primary: "Data unavailable while ETL is building",
                            secondary: secondary
                        }
                    ]);
                }
                setExternalCostTableData([]);
            }
        } catch (err) {
            console.log(err);
            if (err.message.indexOf("404") === 0) setErrors([
                {
                    primary: "Failed to load report data",
                    secondary: "Please update OpenCost to the latest version, and open an Issue if problems persist."
                }
            ]);
            else {
                let secondary = "Please open an Issue with OpenCost if problems persist.";
                if (err.message.length > 0) secondary = err.message;
                setErrors([
                    {
                        primary: "Failed to load report data",
                        secondary: secondary
                    }
                ]);
            }
            setExternalCostTableData([]);
        }
    }
    async function fetchData() {
        setLoading(true);
        setErrors([]);
        // todo: come back and have inidividual loading
        await fetchChartData();
        await fetchTableData();
        setLoading(false);
    }
    function drilldown(row) {
        // Drilldown order: domain > account Name > resource type > resource name
        // We only want drilldown functionality on these items
        if ([
            "domain",
            "accountName",
            "resourceType",
            "resourceName"
        ].includes(aggregateBy)) {
            setFilters([
                ...filters,
                {
                    property: aggregateBy,
                    value: row[(0, $1e3010fdb6d92f5c$export$2307f5dee391b05d)[aggregateBy]]
                }
            ]);
            if (aggregateBy === "domain") setAggregateBy("accountName");
            else if (aggregateBy === "accountName") setAggregateBy("resourceType");
            else if (aggregateBy === "resourceType") setAggregateBy("resourceName");
            else setShowModal(row);
        }
    }
    $gIfym.useEffect(()=>{
        setWindow(searchParams.get("window") || "7d");
        setAggregateBy(searchParams.get("agg") || "domain");
        setCurrency(searchParams.get("currency") || "USD");
        setCostType(searchParams.get("costType") || "blended");
        setSortBy(searchParams.get("sortBy") || "cost");
        setSortDirection(searchParams.get("sortDirection") || "desc");
    }, [
        routerLocation
    ]);
    // Initialize once, then fetch report each time setFetch(true) is called
    $gIfym.useEffect(()=>{
        if (!init) initialize();
        if (init || fetch) fetchData();
    }, [
        init,
        fetch
    ]);
    $gIfym.useEffect(()=>{
        setFetch(!fetch);
    }, [
        window,
        aggregateBy,
        filters,
        costType,
        sortBy,
        sortDirection
    ]);
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $8530181efc7ffbd0$export$2e2bcd8739ae039), {
        active: "cloud.html",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d5abac16fc0baa87$export$2e2bcd8739ae039), {
                headerTitle: "External Costs",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $2ae0a89ca37bbdde$export$2e2bcd8739ae039), {
                    "aria-label": "refresh",
                    onClick: ()=>setFetch(true),
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($82db5f4ea5a284fb$exports))), {})
                })
            }),
            !loading && errors.length > 0 && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                style: {
                    marginBottom: 20
                },
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $08b36a1d9bca6415$export$2e2bcd8739ae039), {
                    warnings: errors
                })
            }),
            init && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $ee13f6b8f50f92d0$export$2e2bcd8739ae039), {
                id: "cloud-cost",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: classes.reportHeader,
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $177352e08b6a4135$export$2e2bcd8739ae039), {
                            costType: costType,
                            setCostType: (type)=>{
                                searchParams.set("costType", type);
                                routerHistory.push({
                                    search: `?${searchParams.toString()}`
                                });
                            },
                            window: window,
                            setWindow: (win)=>{
                                searchParams.set("window", win);
                                routerHistory.push({
                                    search: `?${searchParams.toString()}`
                                });
                            },
                            aggregateBy: aggregateBy,
                            setAggregateBy: (agg)=>{
                                setFilters([]);
                                searchParams.set("agg", agg);
                                routerHistory.push({
                                    search: `?${searchParams.toString()}`
                                });
                            }
                        })
                    }),
                    loading && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                            style: {
                                paddingTop: 100,
                                paddingBottom: 100
                            },
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ff3a7ab0b65b1eb6$export$2e2bcd8739ae039), {})
                        })
                    }),
                    !loading && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $14fc2f3a09df08ae$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $e52478e1eadbde64$export$2e2bcd8739ae039), {
                            graphData: externalCostData,
                            currency: "USD",
                            height: 300,
                            aggregateBy: aggregateBy
                        })
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b6f198a9b7d0786c$export$2e2bcd8739ae039), {
                        style: {
                            margin: ".5em"
                        },
                        variant: "outlined",
                        onClick: ()=>setFilters([]),
                        children: "Clear Filters"
                    }),
                    !loading && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $14fc2f3a09df08ae$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $dcdeeeadd68fc930$export$2e2bcd8739ae039), {
                            tableData: externalCostTableData,
                            aggregateBy: aggregateBy,
                            drilldown: drilldown
                        })
                    }),
                    showModal && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $cc29835c238bdf5c$export$2906d059637be3a7), {
                        row: showModal,
                        onClose: ()=>setShowModal(null)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $538e5067ae27ebfc$export$2e2bcd8739ae039), {})
        ]
    });
};
var $c6366b90b448fa16$export$2e2bcd8739ae039 = /*#__PURE__*/ $gIfym.memo($c6366b90b448fa16$var$ExternalCosts);


const $0d50df9cef64cfe7$var$basename = "".replace(/\/+$/, "");
const $0d50df9cef64cfe7$var$Routes = ()=>{
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $5f667dc1ae602d9e$export$9ba4e89fdfa1fc54), {
        basename: $0d50df9cef64cfe7$var$basename,
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $b585d439d92e032d$export$b5d5cf8927ab7262), {
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b585d439d92e032d$export$e7b0ac011bb776c6), {
                    exact: true,
                    path: "/",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $139bab258972d88b$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b585d439d92e032d$export$e7b0ac011bb776c6), {
                    exact: true,
                    path: "/allocation",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $139bab258972d88b$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b585d439d92e032d$export$e7b0ac011bb776c6), {
                    exact: true,
                    path: "/cloud",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $d7460214e5645b52$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b585d439d92e032d$export$e7b0ac011bb776c6), {
                    exact: true,
                    path: "/external-costs",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c6366b90b448fa16$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
};
var $0d50df9cef64cfe7$export$2e2bcd8739ae039 = $0d50df9cef64cfe7$var$Routes;


(0, (/*@__PURE__*/$parcel$interopDefault($c4a08725a78d51bf$exports))).render(/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $0d50df9cef64cfe7$export$2e2bcd8739ae039), {}), document.getElementById("app"));


//# sourceMappingURL=opencost-ui.5f027c83.js.map
